'use strict';
/**
 * @ngdoc decorator
 * @name loopUiApp.decorator:modelDialog
 * @description
 * # modelDialog
 */
angular.module('satellizer')
    .decorator('SatellizerOAuth2', function ($delegate) {
        var proto = Object.getPrototypeOf($delegate);
        
        /**
         * @param {any} baseUrl 
         * @param {any} url 
         * @returns 
         */
        function joinUrl(baseUrl, url) {
            if (/^(?:[a-z]+:)?\/\//i.test(url)) {
                return url;
            }
            var joined = [baseUrl, url].join('/');
            var normalize = function (str) {
                return str
                    .replace(/[\/]+/g, '/')
                    .replace(/\/\?/g, '?')
                    .replace(/\/\#/g, '#')
                    .replace(/\:\//g, '://');
            };
            return normalize(joined);
        }

        proto.exchangeForToken = function (oauthData, userData) {
            var _this = this;
            var payload = angular.extend({}, userData);
            angular.forEach(this.defaults.responseParams, function (value, key) {
                switch (key) {
                case 'code':
                    payload[value] = oauthData.code;
                    break;
                case 'clientId':
                    payload[value] = _this.defaults.clientId;
                    break;
                case 'redirectUri':
                    payload[value] = _this.defaults.redirectUri;
                    break;
                default:
                    payload[value] = userData[key];
                }
            });
            if (oauthData.state) {
                payload.state = oauthData.state;
            }
            var exchangeForTokenUrl = this.SatellizerConfig.baseUrl ?
                joinUrl(this.SatellizerConfig.baseUrl, this.defaults.url) :
                this.defaults.url;
            return this.$http.post(exchangeForTokenUrl, payload, { withCredentials: this.SatellizerConfig.withCredentials });
        };


        return $delegate;

    });
'use strict';
/**
 * @ngdoc overview
 * @name loopUiApp
 * @description
 * # loopUiApp
 *
 * Main module of the application.
 */
var module = angular
    .module('loopUiApp', [
        'ngMessages',
        'ngResource',
        'ngSanitize',
        'ngAnimate',
        'ngCookies',
        'ui.router',
        'ngMaterial',
        'md.data.table',
        'nvd3',
        'angular-loading-bar',
        'loopUiApp.service',
        'loopUiApp.serviceMPCS',
        'loopUiApp.serviceLicense',
        'loopUiApp.serviceAsyncTask',
        'loopUiApp.serviceFeatures',
        'loopUiApp.serviceEventsMQTT',
        'loopUiApp.serviceBillingAgent',
        'loopUiApp.serviceEdgePolling',
        'loopUiApp.interceptor',
        'ngFileSaver',
        'satellizer',
        'gettext',
        'LocalStorageModule',
        'md.time.picker',
        'ui.ace',
        'ui.tree',
        'json-tree'
    ])
    .constant('appConfig', {
        __env: window.__env,
        baseUrl: window.__env.baseUrl || '/',
        apiUrl: window.__env.apiUrl || '/',
        apiVersion: window.__env.apiVersion || 1,
        documentationBaseUrl: window.__env.documentationBaseUrl,
        insightsProductName: window.__env.insightsProductName || 'LoopInsights',
        logoTopName: window.__env.logoTopName || 'litmus_logo.svg',
        logoBottomName: window.__env.logoBottomName || 'logo.svg',
        companyName: window.__env.companyName || 'Litmus Automation',
        preloadedModelName: window.__env.preloadedModelName || 'LoopEdge',
        preloadedModelParamsSets: window.__env.preloadedModelParamsSets || ['LWM2M_DTLS_PSK', 'MQTT_TLS_SSL'],
        productName: window.__env.productName || 'Edge Manager',
        supportDeviceName: window.__env.supportDeviceName || 'Litmus Edge',
        disabledMenuItems: window.__env.disabledMenuItems || []
    })

    .config(function ($templateRequestProvider, $mdThemingProvider, appConfig, $httpProvider, $authProvider,
        cfpLoadingBarProvider, localStorageServiceProvider, versionControlProvider, userIdleProvider, licenseCheckProvider,
        billingAgentCheckProvider, featuresCheckProvider) {

        // Sets default prefix for storage
        localStorageServiceProvider.setPrefix('loopUi');

        // Configure optional version checking intervals
        versionControlProvider.setDelay(300000);
        versionControlProvider.setPostproneDelay(3600000);

        // Configure optional user session idle
        userIdleProvider.setIdleTime(3600000);
        userIdleProvider.setWarningTime(600000);

        //Configure license check interval
        licenseCheckProvider.setDelay(60000);

        // Configure billing agent check interval
        billingAgentCheckProvider.setDelay(600000);

        // Configure features check interval
        featuresCheckProvider.setDelay(60000);

        //Not intecept templates flag
        //https://github.com/angular/angular.js/issues/10257
        $templateRequestProvider.httpOptions({ _isTemplate: true });

        $mdThemingProvider.theme('default')
            .primaryPalette('litmusPrimary', {
                'default': '500', // by default use shade 500 from the pink palette for primary intentions
                'hue-1': 'A700',  //black
                'hue-2': '800',   //custom black
                'hue-3': '900'    //side black
            })
            .accentPalette('litmusAccent')
            .warnPalette('litmusWarn');

        $httpProvider.interceptors.push('AuthInterceptor');
        $httpProvider.interceptors.push('templateCacheInterceptor');

        //Intercom settings
        if (appConfig.__env.enableIntercom) {
            (function () {
                var w = window;
                var ic = w.Intercom;
                if (typeof ic === 'function') {
                    ic('reattach_activator');
                    ic('update', intercomSettings);
                } else {
                    var d = document;
                    var i = function () {
                        i.c(arguments);
                    };
                    i.q = [];
                    i.c = function (args) {
                        i.q.push(args);
                    };
                    w.Intercom = i;
                    var l = function () {
                        var s = d.createElement('script');
                        s.type = 'text/javascript';
                        s.async = true;
                        s.src = 'https://widget.intercom.io/widget/' + appConfig.__env.intercomKey;
                        var x = d.getElementsByTagName('script')[0];
                        x.parentNode.insertBefore(s, x);
                    };
                    l();
                }
            })();
        }

        //Check Heap Analytics Settings enable
        if (appConfig.__env.enableHeapAnalytics) {
            //Snippet from https://docs.heapanalytics.com/docs/installation#section-web
            window.heap = window.heap || [];
            window.heap.load = function (e, t) {
                window.heap.appid = e;
                window.heap.config = t = t || {};
                var r = t.forceSSL || 'https:' === document.location.protocol,
                    a = document.createElement('script');
                a.type = 'text/javascript';
                a.async = !0;
                a.src = (r ? 'https:' : 'http:') + '//cdn.heapanalytics.com/js/heap-' + e + '.js';
                var n = document.getElementsByTagName('script')[0];
                n.parentNode.insertBefore(a, n);
                for (var o = function (e) {
                    return function () {
                        window.heap.push([e].concat(Array.prototype.slice.call(arguments, 0)));
                    };
                },
                    p = ['addEventProperties', 'addUserProperties', 'clearEventProperties', 'identify',
                        'removeEventProperty', 'setEventProperties', 'track', 'unsetEventProperty'],
                    c = 0; c < p.length; c++) {
                    window.heap[p[c]] = o(p[c]);
                }
            };
            window.heap.load(appConfig.__env.heapAppId);
        }

        //bar config
        cfpLoadingBarProvider.includeSpinner = false;
        cfpLoadingBarProvider.latencyThreshold = 500;

        $authProvider.oauth2({
            name: 'generic',
            oauthType: '2.0',
            popupOptions: { width: 500, height: 530 }
        });

    })
    .run(function ($rootScope, $q, $state, $stateParams, $location, $interval, appConfig, Auth, Service, Commons,
        gettextCatalog, Languages, versionControl, userIdle, billingMetrics, ping, licenseCheck, featuresCheck, 
        $transitions, ServiceZenDesk, billingAgentCheck) {

        // Html page title
        $rootScope.pageTitle = appConfig.__env.productName;
        // Setup current language, if strings is missing in translations.js, then fallback to default locale
        // gettextCatalog.setCurrentLanguage('ru');
        gettextCatalog.setCurrentLanguage(Languages.applicationLanguage());

        //Start connectivity check
        //ping.startPing();

        // Start version checking
        versionControl.startVersionCheck();

        // Start checking user idle
        userIdle.startIdleCheck();

        //Start checking billing metrics
        //billingMetrics.startBillingStatusCheck(); TODO: Disabled for OEM company

        //Start license check
        licenseCheck.startCheck();

        //Start features list check
        featuresCheck.startCheck();

        //Start billing agent check
        billingAgentCheck.startCheck();

        // Call for Intercom update
        if (appConfig.__env.enableIntercom) {
            $transitions.onStart({}, function () {
                window.Intercom('update');
            });
        }


        //For confirmation and invite url return from chain
        if ($location.$$path &&
            ($location.$$path.lastIndexOf('/confirm/', 0) === 0 ||
                $location.$$path.lastIndexOf('/invite/', 0) === 0)
        ) {
            return;
        }

        // Check Admin role if role name specified in config
        Commons.isAdminRole = true;
        if (appConfig.__env.adminRoleName &&
            !Auth.hasRealmRole(appConfig.__env.adminRoleName)) {
            Commons.isAdminRole = false;
        }

        /**
         * Check if GTM feature is available
         * Run GTM script
         */
        var checkConnectedFeatures = function () {
            if (!appConfig.__env.gtmId) { return; }

            var _gtmId = appConfig.__env.gtmId;
            var _gtmFeatureName = appConfig.__env.gtmFeatureName;
            var _gtmFeatureStatusTimeName = appConfig.__env.gtmFeatureStatusTimeName;

            Service.api.userAttributesGet({
                action: Auth.tokenParsed.preferred_username
            }).$promise
                .then(function (data) {
                    if (data[_gtmFeatureName]) {
                        (function (w, d, s, l, i) {
                            w[l] = w[l] || []; w[l].push({
                                'gtm.start':
                                    new Date().getTime(), event: 'gtm.js'
                            }); var f = d.getElementsByTagName(s)[0],
                                j = d.createElement(s), ts = '&custom_ts=' + data[_gtmFeatureStatusTimeName], dl = l !== 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src =
                                    'https://www.googletagmanager.com/gtm.js?id=' + i + dl + ts; f.parentNode.insertBefore(j, f);
                        })(window, document, 'script', 'dataLayer', _gtmId);
                        // Check if Zendesk script is loaded
                        ServiceZenDesk.delayedInitialization();
                    }
                })
                .catch(function (reason) {
                    console.log('Error userAttributesGet:' + JSON.stringify(reason));
                });
        };

        /**
         * Check URL. Take company name from URL
         * @return {Promise} - company name promise
         */
        var getBaseUrl = function () {
            var path = $location.path().split('/');

            if (path.length > 2) {
                // Try to get company name from path
                return path[1];
            }
            return null;
        };

        /**
         * Find project by id
         * @param {Array} companyList - list of project of projects
         * @param {string} name - selected project id
         * @returns {Object} - company with @name
         */
        var findCompany = function (companyList, name) {
            if (!name || !angular.isArray(companyList)) {
                return null;
            }
            var result = companyList.filter(function (company) {
                return company.name === name;
            });
            return result.length === 0 ? null : result[0];
        };

        /**
         * Check company available to current user
         * @param {Sting} companyName - company name to check
         * @returns {Promise} - select company promise
         */
        var checkCompanyName = function (companyName) {
            if (!companyName) {
                $state.go('companyList');
                return $q.reject('Company was not specified');
            }
            return Service.api.companyList().$promise
                .then(function (companyList) {
                    var deferred = $q.defer();
                    if (companyList.length > 0) {
                        var company = findCompany(companyList, companyName);
                        // If company found
                        if (company) {
                            Commons.setCompanyData(company);
                            deferred.resolve(company);
                        }
                        else {
                            deferred.reject('company_not_found');
                        }
                    }
                    else {
                        deferred.reject('company_not_available');
                    }
                    return deferred.promise;
                })
                .catch(function (reason) {
                    var message = '';
                    if (reason === 'company_not_available') {
                        message = 'Company \'' + companyName + '\' not available for current user.';
                        $state.go('companyNotAvailable');
                    } else {
                        message = 'Company \'' + companyName + '\' not found.';
                        $state.go('companyList');
                    }
                    return $q.reject(message);
                });
        };

        /**
         * Find project by id
         * @param {Array} projectList - list of project of projects
         * @param {int} id - selected project id
         * @returns {Object} - project with @id
         */
        var findProjectById = function (projectList, id) {
            if (!angular.isArray(projectList)) {
                return {};
            }
            for (var i = 0; i < projectList.length; i++) {
                if (projectList[i].id === id) {
                    return projectList[i];
                }
            }
            return {};
        };

        /**
         * Select project to go
         *
         * @param {Promise<*>} company - Company data promise
         * @returns {Promise} - Promise for project list
         */
        var checkProject = function (company) {
            // Store company profile in service
            Commons.isProjectListLoading = true;
            return Service.api.projectList({ companyName: company.name }).$promise
                .then(function (projectList) {
                    Commons.projectList = projectList;
                    var state = $state.$current.name || 'dashboard';
                    if ($stateParams.projectId) {
                        var project = findProjectById(projectList, $stateParams.projectId);
                        //Load project billing plan //TODO: Disabled for OEM companies
                        //Commons.refreshBillingPlan($stateParams.projectId);
                        if (project && project.id) {
                            Commons.setCurrentProject(project);
                            $state.go(state, { projectId: project.id, companyName: company.name });
                        } else {
                            Commons.setCurrentProject(null);
                            $state.go('projectList', { companyName: company.name });
                        }
                    }
                })
                .finally(function () {
                    Commons.isProjectListLoading = false;
                });
        };

        /**
         * Detect view scope to change layout
         */
        var checkScope = function () {
            Commons.viewScope = $stateParams.viewScope;
            return;
        };

        /**
         * Promise chain error handler
         * @param {string} error - reject error message
         * @returns {void}
         */
        var handleReject = function (error) {
            console.log(error);
        };

        /**
         * Bootstrap chain:
         * 1) Check url. Try to get company name from URL
         * 2) Check company. If not available then move to company list
         * 3) Check project. Move to first project from list
         * @returns {void}
         */
        var init = function () {
            $q.when()
                .then(checkConnectedFeatures)
                .then(getBaseUrl)
                .then(checkCompanyName)
                .then(checkProject)
                .then(checkScope)
                .catch(handleReject);
        };

        //Check token, try to refresh, then it close to expired
        $interval(function () {
            // refresh token if it's valid for less then 5 minutes
            Auth.updateToken(5);
        }, 60000);

        // Init application
        init();
    });

angular.element(document).ready(function () {
    var keycloak = new Keycloak('keycloak.json'),
        keycloakInitConfig = {
            onLoad: 'login-required',
            checkLoginIframe: false
        };

    keycloak.init(keycloakInitConfig)
        .then(function () {
            module.factory('Auth', function () {
                if (window.Intercom) {
                    window.intercomSettings = {
                        app_id: 'y9psoknj',
                        alignment: 'right',
                        horizontal_padding: 20,
                        vertical_padding: 60
                    };
                    window.Intercom('boot', {
                        app_id: 'y9psoknj',
                        email: keycloak.tokenParsed.email,
                        name: keycloak.tokenParsed.name,
                        created_at: Math.ceil(new Date().getTime() / 1000)
                    });
                }
                if (window.heap) {
                    window.heap.identify(keycloak.tokenParsed.email);
                }
                return keycloak;
            });

            angular.bootstrap(document, ['loopUiApp']);
        })
        .catch(function (err) {
            //window.location.reload();
            console.log('Keycloak init error: ' + err);
        });

});

'use strict';

/**
 * @ngdoc overview
 * @name route
 * @description
 * # route module
 *
 * Main route file for the application.
 */
angular
    .module('loopUiApp')
    .config(function ($stateProvider, $urlRouterProvider) {
        //States list
        var states = [
            {
                name: 'projectList',
                url: '/{companyName}/project-list',
                component: 'projectList',
                params: {
                    viewScope: { value: 'company' }
                }
            },
            {
                name: 'companyTemplateList',
                url: '/{companyName}/template-list',
                component: 'templateList',
                params: {
                    viewScope: { value: 'company' }
                }
            },
            {
                name: 'dashboard',
                url: '/{companyName}/{projectId}/dashboard',
                component: 'dashboard',
                params: {
                    viewScope: { value: 'project' }
                }
            },
            {
                name: 'tagConsumptionDetails',
                url: '/{companyName}/{projectId}/dashboard/tag-consumption-details',
                component: 'tagConsumptionDetails',
                params: {
                    viewScope: { value: 'project' }
                }
            },
            {
                name: 'licenseManagement',
                url: '/{companyName}/{projectId}/license-management',
                component: 'licenseManagement',
                params: {
                    viewScope: { value: 'project' }
                }
            },
            {
                name: 'licenseListUnused',
                url: '/{companyName}/{projectId}/license-list',
                component: 'licenseListUnused',
                params: {
                    viewScope: { value: 'project' }
                }
            },
            {
                name: 'devices',
                url: '/{companyName}/{projectId}/devices',
                component: 'devices',
                params: {
                    viewScope: { value: 'project' }
                }
            },
            {
                name: 'devicesOld', // Add this route for backward compatibility (EM-1510)
                url: '/{companyName}/{projectId}/devices/{selectedTab}',
                component: 'devices',
                params: {
                    viewScope: { value: 'project' }
                }
            },
            {
                name: 'deviceView',
                url: '/{companyName}/{projectId}/device/{deviceId}/{selectedTab}/{selectedSubtab}',
                component: 'deviceView',
                params: {
                    selectedTab: { dynamic: true, value: 'info' },
                    selectedSubtab: { dynamic: true, value: null },
                    viewScope: { value: 'project' }
                },
                resolve: {
                    device: ['Service', '$stateParams', function (Service, $stateParams) {
                        return Service.api.deviceGet({
                            action: $stateParams.projectId,
                            actionExt: $stateParams.deviceId
                        }).$promise;
                    }]
                }
            },
            {
                name: 'templateList',
                url: '/{companyName}/{projectId}/template-list',
                component: 'templateList',
                params: {
                    viewScope: { value: 'project' }
                }
            },
            {
                name: 'templateImport',
                url: '/{companyName}/{projectId}/template-import',
                component: 'templateImport',
                params: {
                    viewScope: { value: 'project' }
                }
            },
            {
                name: 'templateParameterized',
                url: '/{companyName}/{projectId}/template-parameterized/{templateName}',
                component: 'templateParameterized',
                params: {
                    viewScope: { value: 'project' }
                }
            },
            {
                name: 'templateParameterizedCompany',
                url: '/{companyName}/template-parameterized/{templateName}',
                component: 'templateParameterized',
                params: {
                    viewScope: { value: 'company' }
                }
            },
            {
                name: 'sites',
                url: '/{companyName}/{projectId}/sites',
                component: 'sitesList',
                params: {
                    viewScope: { value: 'project' }
                }
            },
            {
                name: 'assets',
                url: '/{companyName}/{projectId}/assets',
                component: 'assetList',
                params: {
                    viewScope: { value: 'project' }
                }
            },
            {
                name: 'siteMap',
                url: '/{companyName}/{projectId}/sites/{siteId}',
                component: 'siteMap',
                params: {
                    viewScope: { value: 'project' }
                }
            },
            {
                name: 'network',
                url: '/{companyName}/{projectId}/network',
                component: 'network',
                params: {
                    viewScope: { value: 'project' }
                }
            },
            {
                name: 'firmwareJobs',
                url: '/{companyName}/{projectId}/firmware-jobs',
                component: 'firmwareJobs',
                params: {
                    viewScope: { value: 'project' }
                }
            },
            {
                name: 'settings',
                url: '/{companyName}/{projectId}/settings/{selectedTab}',
                component: 'projectSettings',
                params: {
                    /*
                    * Sets selectedTab dynamic parameter and its default value,
                    * so when we open settings for the first time we go straight to the Teams tab
                    */
                    selectedTab: { dynamic: true, value: 'settings' },
                    viewScope: { value: 'project' }
                }
            },
            {
                name: 'applicationsList',
                url: '/{companyName}/{projectId}/applications-list',
                component: 'applicationsList',
                params: {
                    viewScope: { value: 'project' }
                }
            },
            {
                name: 'certificatesList',
                url: '/{companyName}/{projectId}/certificates-list',
                component: 'certificatesList',
                params: {
                    viewScope: { value: 'project' }
                }
            },
            {
                name: 'mlEdgeDeviceModels',
                url: '/{companyName}/{projectId}/edge-device-models',
                component: 'mlEdgeDeviceModels',
                params: {
                    viewScope: { value: 'project' }
                }
            },
            {
                name: 'alerts',
                url: '/{companyName}/{projectId}/alerts/{selectedTab}',
                component: 'alertSettings',
                params: {
                    selectedTab: { dynamic: true, value: 'incidents' },
                    viewScope: { value: 'project' }
                }
            },
            {
                name: 'triggerDetails',
                url: '/{companyName}/{projectId}/trigger-details/{triggerId}',
                component: 'triggerDetails',
                params: {
                    viewScope: { value: 'project' }
                }
            },
            {
                name: 'events',
                url: '/{companyName}/{projectId}/events/{selectedType}',
                component: 'eventsView',
                params: {
                    selectedType: { dynamic: true, value: 'SYSTEM_EVENTS' },
                    viewScope: { value: 'project' }
                }
            },
            {
                name: 'edgeApplicationList',
                url: '/{companyName}/{projectId}/edge-applications',
                component: 'edgeApplicationContainer',
                params: {
                    viewScope: { value: 'project' }
                }
            },
            {
                name: 'edgeApplicationDetails',
                url: '/{companyName}/{projectId}/edge-applications/{catalogId}/{applicationId}',
                component: 'edgeApplicationDetails',
                params: {
                    viewScope: { value: 'project' }
                }
            },
            {
                name: 'companyEvents',
                url: '/{companyName}/events',
                component: 'events',
                params: {
                    viewScope: { value: 'company' }
                }
            },
            {
                name: 'companySettings',
                url: '/{companyName}/settings/{selectedTab}',
                component: 'companySettings',
                params: {
                    /*
                    * Sets selectedTab dynamic parameter and its default value,
                    * so when we open settings for the first time we go straight to the Company tab
                    */
                    selectedTab: { dynamic: true, value: 'company' },
                    viewScope: { value: 'company' }
                }
            },
            {
                name: 'companyNotAvailable',
                url: '/company-not-available',
                component: 'companyNotAvailable'
            },
            {
                name: 'confirm',
                url: '/confirm/{token}',
                component: 'confirm',
            },
            {
                name: 'invite',
                url: '/invite/{companyName}',
                component: 'invite',
            },
            {
                name: 'companyList',
                url: '/company-list',
                component: 'companyList'
            },
            {
                name: 'companyRemoved',
                url: '/company-removed'
            },
            {
                name: 'instanceList',
                url: '/{companyName}/instance-list',
                component: 'instanceList',
                params: {
                    viewScope: { value: 'company' }
                }
            },
            {
                name: 'sensorModelList',
                url: '/{companyName}/company-model/sensor',
                component: 'sensorModelList',
                params: {
                    viewScope: { value: 'company' }
                }
            },
            {
                name: 'deviceModelList',
                url: '/{companyName}/company-model/device',
                component: 'deviceModelList',
                params: {
                    viewScope: { value: 'company' }
                }
            },
            {
                name: 'assetModelList',
                url: '/{companyName}/company-model/asset',
                component: 'assetModelList',
                params: {
                    viewScope: { value: 'company' }
                }
            },
            {
                name: 'dtModelList',
                url: '/{companyName}/company-model/model-list',
                component: 'dtModelList',
                params: {
                    viewScope: { value: 'assets' }
                }
            },
            {
                name: 'dtInstanceList',
                url: '/{companyName}/company-model/instance-list',
                component: 'dtInstanceList',
                params: {
                    viewScope: { value: 'assets' }
                }
            },
            {
                name: 'dtModelView',
                url: '/{companyName}/company-model/{modelId}/{selectedTab}',
                component: 'dtModelView',
                params: {
                    /*
                    * Sets selectedTab dynamic parameter and its default value,
                    * so when we open settings for the first time we go straight to the Company tab
                    */
                    selectedTab: { dynamic: true, value: 'static' },
                    viewScope: { value: 'assets' }
                }
            },
            {
                name: 'dtInstanceView',
                url: '/{companyName}/company-instance/{instanceId}/{selectedTab}',
                component: 'dtModelView',
                params: {
                    /*
                    * Sets selectedTab dynamic parameter and its default value,
                    * so when we open settings for the first time we go straight to the Company tab
                    */
                    selectedTab: { dynamic: true, value: 'static' },
                    viewScope: { value: 'assets' }
                }
            },
            {
                name: 'dtEvents',
                url: '/{companyName}/company-model/events',
                component: 'events',
                params: {
                    context: { value: 'digital-twins'},
                    viewScope: { value: 'assets' }
                }
            },
            {
                name: 'projectWizard',
                url: '/{companyName}/project-wizard/{projectId}',
                component: 'projectWizard',
                params: {
                    viewScope: { value: 'company' }
                }
            },
            {
                name: 'activationView',
                url: '/{companyName}/activation-view/{projectId}',
                component: 'activationView',
                params: {
                    viewScope: { value: 'project' }
                }
            },
            {
                name: 'activationConfigList',
                url: '/{companyName}/activation-config/{projectId}',
                component: 'activationConfigList',
                params: {
                    viewScope: { value: 'project' }
                }
            },
            {
                name: 'activationConfigDetails',
                url: '/{companyName}/activation-config/{projectId}/{code}',
                component: 'activationConfigDetails',
                params: {
                    viewScope: { value: 'project' }
                }
            },
            {
                name: 'activationRequestList',
                url: '/{companyName}/activation-request/{projectId}',
                component: 'activationRequestList',
                params: {
                    viewScope: { value: 'project' },
                    code: { dynamic: true, value: null },
                }
            },
            {
                name: 'activationRequestListByCode',
                url: '/{companyName}/activation-request/{projectId}/{code}',
                component: 'activationRequestList',
                params: {
                    code: { dynamic: true, value: null },
                    viewScope: { value: 'project' }
                }
            },
            {
                name: 'ztConfigList',
                url: '/{companyName}/{projectId}/zerotouch-config-list',
                component: 'ztConfigList',
                params: {
                    viewScope: { value: 'project' }
                }
            },
            {
                name: 'asyncTaskList',
                url: '/{companyName}/{projectId}/async-task-list',
                component: 'asyncTaskList',
                params: {
                    viewScope: { value: 'project' }
                }
            },
            {
                name: 'asyncTaskListCompany',
                url: '/{companyName}/async-task-list',
                component: 'asyncTaskList',
                params: {
                    viewScope: { value: 'company' }
                }
            },
            {
                name: 'asyncTaskListAssets',
                url: '/{companyName}/company-model/async-task-list',
                component: 'asyncTaskList',
                params: {
                    viewScope: { value: 'assets' }
                }
            },
            {
                name: 'asyncTaskView',
                url: '/{companyName}/{projectId}/async-task/{taskId}',
                component: 'asyncTaskView',
                params: {
                    viewScope: { value: 'project' }
                }
            },
            {
                name: 'asyncTaskViewCompany',
                url: '/{companyName}/async-task/{taskId}',
                component: 'asyncTaskView',
                params: {
                    viewScope: { value: 'company' }
                }
            },
            {
                name: 'asyncTaskViewAssets',
                url: '/{companyName}/company-model/async-task/{taskId}',
                component: 'asyncTaskView',
                params: {
                    viewScope: { value: 'assets' }
                }
            },
            {
                name: 'asyncSubtaskLog',
                url: '/{companyName}/{projectId}/async-task/{taskId}/subtask/{subtaskId}/log',
                component: 'asyncSubtaskLog',
                params: {
                    viewScope: { value: 'project' }
                }
            },
            {
                name: 'asyncSubtaskLogCompany',
                url: '/{companyName}/async-task/{taskId}/subtask/{subtaskId}/log',
                component: 'asyncSubtaskLog',
                params: {
                    viewScope: { value: 'company' }
                }
            },
            {
                name: 'asyncSubtaskLogAssets',
                url: '/{companyName}/company-model/async-task/{taskId}/subtask/{subtaskId}/log',
                component: 'asyncSubtaskLog',
                params: {
                    viewScope: { value: 'assets' }
                }
            },
            {
                name: 'userSettings',
                url: '/personal-settings',
                component: 'userSettings'
            },
            {
                name: 'userSettingsCompany',
                url: '/{companyName}/personal-settings',
                component: 'userSettings',
                params: {
                    viewScope: { value: 'company' }
                }
            },
            {
                name: 'userSettingsProject',
                url: '/{companyName}/{projectId}/personal-settings',
                component: 'userSettings',
                params: {
                    viewScope: { value: 'project' }
                }
            },
        ];

        // Loop over the state definitions and register them
        states.forEach(function (state) {
            $stateProvider.state(state);
        });

        // Default state for company
        $urlRouterProvider.otherwise('/');
    });

'use strict';
/**
 * @ngdoc service
 * @name loopUiApp.service
 * @description
 * # service
 * Service in the loopUiApp.
 */
angular.module('loopUiApp.service', ['ngResource'])
    .factory('Service', ['$resource', 'appConfig', 'Transform', function ($resource, appConfig, Transform) {
        //Swagger link http://localhost:8080/api/v1/swagger-ui.html#/
        var apiUrl = appConfig.apiUrl + 'api/v' + appConfig.apiVersion + '/:res/:action/:actionExt';
        return {
            api: $resource(apiUrl, {}, {
                userByUsername: {
                    method: 'GET',
                    cache: false,
                    params: {
                        res: 'user'
                    }
                },
                userByEmail: {
                    method: 'GET',
                    cache: false,
                    params: {
                        res: 'user',
                        action: 'find-by-email',
                        email: '@email'
                    }
                },
                userAttributesGet: {
                    method: 'GET',
                    cache: false,
                    params: {
                        res: 'user',
                        action: '@username',
                        actionExt: 'attributes'
                    }
                },
                userAttributesSet: {
                    method: 'POST',
                    cache: false,
                    params: {
                        res: 'user',
                        action: '@username',
                        actionExt: 'attributes'
                    }
                },
                confirmEmail: {
                    method: 'POST',
                    cache: false,
                    params: {
                        res: 'confirm',
                        code: '@code'
                    }
                },
                confirmPsw: {
                    method: 'POST',
                    cache: false,
                    params: {
                        res: 'confirm'
                    }
                },
                company: {
                    method: 'POST',
                    cache: false,
                    params: {
                        res: 'company'
                    }
                },
                companyDelete: {
                    method: 'DELETE',
                    cache: false,
                    params: {
                        res: 'company',
                        name: '@name'
                    }
                },
                companyValidate: {
                    method: 'Get',
                    cache: false,
                    params: {
                        res: 'company',
                        action: 'name-validation',
                        name: '@name'
                    }
                },
                companyGet: {
                    method: 'GET',
                    cache: false,
                    params: {
                        res: 'company',
                        name: '@name'
                    }
                },
                companyList: {
                    method: 'GET',
                    cache: false,
                    isArray: true,
                    params: {
                        res: 'company',
                        action: 'list'
                    }
                },
                companyListStats: {
                    method: 'GET',
                    cache: false,
                    isArray: true,
                    params: {
                        res: 'company',
                        action: 'list',
                        actionExt: 'stats',
                    }
                },
                projectList: {
                    method: 'GET',
                    cache: false,
                    isArray: true,
                    params: {
                        res: 'project',
                        companyName: '@companyName',
                        amount: '@amount'
                    }
                },
                projectGetById: {
                    method: 'GET',
                    cache: false,
                    isArray: false,
                    params: {
                        res: 'project',
                        action: '@action'
                    }
                },
                project: {
                    method: 'POST',
                    cache: false,
                    isArray: false,
                    params: {
                        res: 'project'
                    }
                },
                projectListStats: {
                    method: 'GET',
                    cache: false,
                    isArray: true,
                    params: {
                        res: 'project',
                        action: 'list',
                        actionExt: 'stats'
                    }
                },
                projectDataEnricherOn: {
                    method: 'POST',
                    cache: false,
                    isArray: false,
                    params: {
                        res: 'project',
                        action: 'dataenricher',
                        actionExt: 'on',
                        projectId: '@projectId'
                    }
                },
                projectDataEnricherOff: {
                    method: 'POST',
                    cache: false,
                    isArray: false,
                    params: {
                        res: 'project',
                        action: 'dataenricher',
                        actionExt: 'off',
                        projectId: '@projectId'
                    }
                },
                projectDataEnricherSync: {
                    method: 'POST',
                    cache: false,
                    isArray: false,
                    params: {
                        res: 'project',
                        action: 'dataenricher',
                        actionExt: 'sync',
                        projectId: '@projectId'
                    }
                },
                projectDataEnricherStatus: {
                    method: 'GET',
                    cache: false,
                    isArray: false,
                    params: {
                        res: 'project',
                        action: 'dataenricher',
                        actionExt: 'status',
                        projectId: '@projectId'
                    }
                },
                projectGrafanaSync: {
                    method: 'POST',
                    cache: false,
                    isArray: false,
                    params: {
                        res: 'project',
                        action: 'grafana',
                        actionExt: 'sync',
                        projectId: '@projectId'
                    }
                },
                projectGrafanaSyncCurrentUser: {
                    method: 'POST',
                    cache: false,
                    isArray: false,
                    params: {
                        res: 'project',
                        action: 'grafana',
                        actionExt: 'sync-current-user',
                        orgId: '@orgId',
                        projectId: '@projectId',
                    }
                },
                projectDelete: {
                    method: 'DELETE',
                    cache: false,
                    isArray: false,
                    params: {
                        res: 'project',
                        action: '@action'
                    }
                },
                projectGrant: {
                    method: 'POST',
                    cache: false,
                    isArray: false,
                    params: {
                        res: 'project',
                        action: 'grant',
                        actionExt: '@actionExt'
                    }
                },
                projectRevoke: {
                    method: 'POST',
                    cache: false,
                    isArray: false,
                    params: {
                        res: 'project',
                        action: 'revoke',
                        actionExt: '@actionExt'
                    }
                },
                projectRetentionGet: {
                    method: 'GET',
                    cache: false,
                    isArray: false,
                    params: {
                        res: 'project',
                        action: 'retention',
                        actionExt: '@projectId',
                    }
                },
                projectRetention: {
                    method: 'PUT',
                    cache: false,
                    isArray: false,
                    params: {
                        res: 'project',
                        action: 'retention',
                        actionExt: '@projectId',
                    }
                }, 
                projectStoragePolicyGet: {
                    method: 'GET',
                    cache: false,
                    isArray: false,
                    params: {
                        res: 'project',
                        action: 'store-edge-data',
                        actionExt: '@projectId',
                    }
                },
                projectStoragePolicy: {
                    method: 'PUT',
                    cache: false,
                    isArray: false,
                    params: {
                        res: 'project',
                        action: 'store-edge-data',
                        actionExt: '@projectId',
                    }
                },
                projectEdgePollingSettingsGet: {
                    method: 'GET',
                    cache: false,
                    isArray: false,
                    params: {
                        res: 'project',
                        action: 'edge-polling-settings',
                        actionExt: '@projectId'
                    }
                },
                projectEdgePollingSettings: {
                    method: 'POST',
                    cache: false,
                    params: {
                        res: 'project',
                        action: 'edge-polling-settings',
                        actionExt: '@projectId'
                    }
                },
                projectEdgePollingStart: {
                    method: 'POST',
                    cache: false,
                    params: {
                        res: 'project',
                        action: 'edge-polling-execute',
                        actionExt: '@projectId'
                    }
                },
                projectEdgePollingStatus: {
                    method: 'GET',
                    url: apiUrl + '/:sessionId',
                    cache: false,
                    isArray: false,
                    params: {
                        res: 'project',
                        action: 'edge-polling-execute',
                        actionExt: 'status',
                        sessionId: '@sessionId'
                    }
                },
                instanceEdgePollingSettingsGet: {
                    method: 'GET',
                    cache: false,
                    isArray: false,
                    params: {
                        res: 'system',
                        action: 'edge-polling-settings-instance'
                    }
                },
                projectMqttCredentials: {
                    method: 'GET',
                    cache: false,
                    isArray: false,
                    params: {
                        res: 'project',
                        action: 'credentials',
                        actionExt: 'mqtt',
                    }
                },
                projectMqttDmCredentials: {
                    method: 'GET',
                    cache: false,
                    isArray: false,
                    params: {
                        res: 'project',
                        action: 'credentials',
                        actionExt: 'mqtt-dm',
                        projectId: '@projectId'
                    }
                },
                projectTopicsCredentials: {
                    method: 'GET',
                    cache: false,
                    isArray: true,
                    params: {
                        res: 'project',
                        action: 'credentials',
                        actionExt: 'topics',
                    }
                },
                projectMqttGetAccounts: {
                    method: 'GET',
                    url: apiUrl + '/:projectId',
                    cache: false,
                    isArray: true,
                    params: {
                        res: 'project',
                        action: 'mqtt',
                        actionExt: 'account',
                        projectId: '@projectId',
                    }
                },
                projectMqttCreateAccount: {
                    method: 'POST',
                    url: apiUrl + '/:projectId',
                    cache: false,
                    isArray: false,
                    params: {
                        res: 'project',
                        action: 'mqtt',
                        actionExt: 'account',
                        projectId: '@projectId',
                    }
                },
                projectMqttDeleteAccount: {
                    method: 'DELETE',
                    url: apiUrl + '/:projectId/:name',
                    cache: false,
                    isArray: false,
                    params: {
                        res: 'project',
                        action: 'mqtt',
                        actionExt: 'account',
                        projectId: '@projectId',
                        name: '@name'
                    }
                },
                projectMqttGrantAccount: {
                    method: 'POST',
                    url: apiUrl + '/:projectId/:account',
                    cache: false,
                    isArray: false,
                    params: {
                        res: 'project',
                        action: 'mqtt',
                        actionExt: 'grant',
                        projectId: '@projectId',
                        account: '@account'
                    }
                },
                projectMqttRevokeAccount: {
                    method: 'POST',
                    url: apiUrl + '/:projectId/:account',
                    cache: false,
                    isArray: false,
                    params: {
                        res: 'project',
                        action: 'mqtt',
                        actionExt: 'revoke',
                        projectId: '@projectId',
                        account: '@account'
                    }
                },
                projectMqttDeleteTopics: {
                    method: 'DELETE',
                    url: apiUrl + '/:type/:projectId/:name',
                    cache: false,
                    isArray: false,
                    params: {
                        res: 'project',
                        action: 'mqtt',
                        actionExt: 'topics',
                        type: 'custom',
                        projectId: '@projectId',
                        name: '@name'
                    }
                },
                projectMqttAddTopics: {
                    method: 'POST',
                    url: apiUrl + '/:type/:projectId/:name',
                    cache: false,
                    isArray: false,
                    params: {
                        res: 'project',
                        action: 'mqtt',
                        actionExt: 'topics',
                        type: 'custom',
                        projectId: '@projectId',
                        name: '@name'
                    }
                },
                projectActionList: {
                    method: 'GET',
                    cache: false,
                    isArray: true,
                    params: {
                        res: 'project',
                        action: 'action',
                        actionExt: 'templates',
                        projectId: '@projectId'
                    }
                },
                projectAddAction: {
                    method: 'POST',
                    url: apiUrl + '/:projectId',
                    cache: false,
                    isArray: false,
                    params: {
                        res: 'project',
                        action: 'action',
                        actionExt: 'templates',
                        projectId: '@projectId'
                    }
                },
                projectRemoveAction: {
                    method: 'DELETE',
                    url: apiUrl + '/:projectId/:templateId',
                    cache: false,
                    params: {
                        res: 'project',
                        action: 'action',
                        actionExt: 'templates',
                        projectId: '@projectId',
                        templateId: '@templateId'
                    }
                },
                projectTestAction: {
                    method: 'POST',
                    url: apiUrl + '/test/webhook',
                    cache: false,
                    isArray: false,
                    params: {
                        res: 'project',
                        action: 'action',
                    }
                },
                projectTimezone: {
                    method: 'POST',
                    cache: false,
                    params: {
                        res: 'project',
                        action: 'settings',
                        actionExt: 'timezone',
                        projectId: '@projectId',
                    }
                },
                projectTimezoneGet: {
                    method: 'GET',
                    cache: false,
                    isArray: false,
                    params: {
                        res: 'project',
                        action: 'settings',
                        actionExt: 'timezone',
                        projectId: '@projectId',
                    }
                },
                projectTimezoneList: {
                    method: 'GET',
                    cache: false,
                    isArray: true,
                    params: {
                        res: 'project',
                        action: 'settings',
                        actionExt: 'timezones',
                        projectId: '@projectId',
                    }
                },
                companyTeamGET: {
                    method: 'GET',
                    cache: false,
                    isArray: true,
                    params: {
                        res: 'company',
                        action: 'team'
                    }
                },
                companyTeam: {
                    method: 'POST',
                    cache: false,
                    params: {
                        res: 'company',
                        action: 'team',
                        companyName: '@companyName'
                    }
                },
                companyTeamRename: {
                    method: 'POST',
                    cache: false,
                    params: {
                        res: 'company',
                        action: 'team',
                        actionExt: 'rename',
                        companyName: '@companyName',
                        oldName: '@oldName',
                        newName: '@newName'
                    }
                },
                companyTeamDelete: {
                    method: 'DELETE',
                    cache: false,
                    params: {
                        res: 'company',
                        action: 'team',
                        companyName: '@companyName',
                        teamName: '@teamName'
                    }
                },
                companyTeamMemberAdd: {
                    method: 'POST',
                    cache: false,
                    params: {
                        res: 'company',
                        action: 'team',
                        actionExt: 'member',
                        companyName: '@companyName',
                        teamName: '@teamName',
                        username: '@username'
                    }
                },
                companyTeamMemberNonRegistered: {
                    method: 'POST',
                    url: apiUrl + '/:actionExt2',
                    cache: false,
                    params: {
                        res: 'company',
                        action: 'team',
                        actionExt: 'member',
                        actionExt2: 'non-registered',
                        companyName: '@companyName',
                        teamName: '@teamName',
                        email: '@email'
                    }
                },
                companyTeamMemberDelete: {
                    method: 'DELETE',
                    cache: false,
                    params: {
                        res: 'company',
                        action: 'team',
                        actionExt: 'member',
                        companyName: '@companyName',
                        teamName: '@teamName',
                        username: '@username'
                    }
                },
                omnaList: {
                    method: 'GET',
                    cache: true,
                    isArray: false,
                    params: {
                        res: 'project',
                        action: 'omna'
                    }
                },
                deviceList: {
                    method: 'GET',
                    cache: false,
                    isArray: false,
                    cancellable: true,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'device',
                        projectId: '@projectId',
                        tag: '@tag',
                        deviceType: '@deviceType',
                        requestedPage: '@requestedPage',
                        limit: '@limit'
                    }
                },
                childDeviceList: {
                    method: 'POST',
                    cache: false,
                    isArray: false,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'device',
                        action: 'child',
                        actionExt: '@projectId',
                        requestedPage: '@requestedPage',
                        limit: '@limit',
                        orderBy: '@orderBy'
                    }
                },
                device: {
                    method: 'POST',
                    cache: false,
                    params: {
                        res: 'device',
                        action: '@projectId'
                    }
                },
                deviceGet: {
                    method: 'GET',
                    cache: false,
                    params: {
                        res: 'device',
                        action: '@projectId',
                        actionExt: '@deviceId'
                    },
                    ignoreLoadingBar: true
                },
                deviceObjectValue: {
                    method: 'GET',
                    url: apiUrl + '/:objectId/:instanceId/:resourceId',
                    cache: false,
                    params: {
                        res: 'device',
                        action: '@projectId',
                        actionExt: '@deviceId',
                        objectId: '@objectId',
                        instanceId: '@instanceId',
                        resourceId: '@resourceId'
                    }
                },
                deviceObjectValueNative: {
                    method: 'GET',
                    url: apiUrl + '/:deviceId/:objectId/:instanceId/:resourceId',
                    cache: false,
                    params: {
                        res: 'device',
                        action: 'explore-native',
                        actionExt: '@projectId',
                        deviceId: '@deviceId',
                        objectId: '@objectId',
                        instanceId: '@instanceId',
                        resourceId: '@resourceId'
                    }
                },
                deviceObjectValueLatest: {
                    method: 'GET',
                    url: apiUrl + '/:deviceId',
                    cache: false,
                    isArray: true,
                    params: {
                        res: 'device',
                        action: 'explore-latest',
                        actionExt: '@projectId',
                        deviceId: '@deviceId'
                    }
                },
                devicePollData: {
                    method: 'GET',
                    url: apiUrl + '/:actionExt2',
                    cache: false,
                    params: {
                        res: 'device',
                        action: 'poll',
                        actionExt: '@projectId',
                        actionExt2: '@deviceId'
                    }
                },
                devicePollDataNative: {
                    method: 'GET',
                    url: apiUrl + '/:actionExt2',
                    cache: false,
                    params: {
                        res: 'device',
                        action: 'poll-native',
                        actionExt: '@projectId',
                        actionExt2: '@deviceId'
                    }
                },
                deviceAddDemo: {
                    method: 'POST',
                    cache: false,
                    params: {
                        res: 'device',
                        action: 'newdemo',
                        actionExt: '@projectId'
                    }
                },
                deviceResourceMatch: {
                    method: 'GET',
                    cache: false,
                    isArray: true,
                    params: {
                        res: 'device',
                        action: 'resources',
                        actionExt: 'match'
                    }
                },
                deviceTagList: {
                    method: 'GET',
                    cache: false,
                    isArray: true,
                    params: {
                        res: 'device',
                        action: 'tags',
                        projectId: '@projectId',
                        companyName: '@companyName'
                    }
                },
                deviceVersionList: {
                    method: 'GET',
                    cache: false,
                    isArray: true,
                    params: {
                        res: 'device',
                        action: 'versions',
                        projectId: '@projectId',
                        companyName: '@companyName'
                    }
                },
                deviceSetStatus: {
                    method: 'POST',
                    url: apiUrl + '/:actionExt2',
                    cache: false,
                    params: {
                        res: 'device',
                        action: 'status',
                        actionExt: '@projectId',
                        actionExt2: '@deviceId',
                        status: '@status'
                    }
                },
                deviceDisconnect: {
                    method: 'POST',
                    cache: false,
                    params: {
                        res: 'device',
                        action: 'disconnect',
                        projectId: '@projectId',
                        deviceId: '@deviceId'
                    }
                },
                deviceProperties: {
                    method: 'POST',
                    url: apiUrl + '/:actionExt2',
                    cache: false,
                    params: {
                        res: 'device',
                        action: 'properties',
                        actionExt: '@actionExt',
                        actionExt2: '@actionExt2',
                    }
                },
                deviceConfig: {
                    method: 'POST',
                    url: apiUrl + '/:actionExt2',
                    cache: false,
                    params: {
                        res: 'device',
                        action: 'config',
                        actionExt: '@projectId',
                        actionExt2: '@deviceId'
                    }
                },
                deviceConfigGet: {
                    method: 'GET',
                    url: apiUrl + '/:actionExt2',
                    cache: false,
                    isArray: false,
                    params: {
                        res: 'device',
                        action: 'config',
                        actionExt: '@projectId',
                        actionExt2: '@deviceId'
                    }
                },
                deviceImage: {
                    method: 'POST',
                    url: apiUrl + '/:actionExt2',
                    cache: false,
                    params: {
                        res: 'device',
                        action: 'images',
                        actionExt: '@projectId',
                        actionExt2: '@deviceId'
                    },
                    transformRequest: angular.identity,
                    headers: { 'Content-Type': undefined }
                },
                deviceImageDelete: {
                    method: 'DELETE',
                    url: apiUrl + '/:actionExt2',
                    cache: false,
                    params: {
                        res: 'device',
                        action: 'images',
                        actionExt: '@projectId',
                        actionExt2: '@deviceId'
                    }
                },
                deviceApiKeyGet: {
                    method: 'GET',
                    url: apiUrl + '/:deviceId/masked',
                    cache: false,
                    isArray: false,
                    params: {
                        res: 'device',
                        action: 'api-key',
                        actionExt: '@projectId',
                        deviceId: '@deviceId'
                    }
                },
                deviceApiKey: {
                    method: 'POST',
                    url: apiUrl + '/:deviceId',
                    cache: false,
                    isArray: false,
                    params: {
                        res: 'device',
                        action: 'api-key',
                        actionExt: '@projectId',
                        deviceId: '@deviceId'
                    }
                },
                deviceApiKeyVerify: {
                    method: 'POST',
                    url: apiUrl + '/:deviceId/verify',
                    cache: false,
                    isArray: false,
                    params: {
                        res: 'device',
                        action: 'api-key',
                        actionExt: '@projectId',
                        deviceId: '@deviceId'
                    }
                },
                loopEdgeDeviceActivate: {
                    method: 'POST',
                    url: apiUrl + '/:deviceId',
                    cache: false,
                    params: {
                        res: 'device',
                        action: 'activate',
                        actionExt: '@projectId',
                        deviceId: '@deviceId'
                    }
                },
                loopEdgeDeviceDeactivate: {
                    method: 'POST',
                    url: apiUrl + '/:deviceId',
                    cache: false,
                    params: {
                        res: 'device',
                        action: 'deactivate',
                        actionExt: '@projectId',
                        deviceId: '@deviceId',
                        force: '@force'
                    }
                },
                loopEdgeDeviceDelete: {
                    method: 'DELETE',
                    url: apiUrl + '/:projectId/:deviceId',
                    cache: false,
                    params: {
                        res: 'device',
                        action: 'delete',
                        projectId: '@projectId',
                        deviceId: '@deviceId'
                    }
                },
                loopEdgeDeviceStatus: {
                    method: 'GET',
                    url: apiUrl + '/:projectId/:deviceId',
                    cache: false,
                    isArray: false,
                    params: {
                        res: 'loopedge',
                        action: 'activate',
                        actionExt: 'status',
                        projectId: '@projectId',
                        deviceId: '@deviceId'
                    }
                },
                dataModel: {
                    method: 'POST',
                    cache: false,
                    params: {
                        res: 'datamodels',
                        action: '@projectId'
                    }
                },
                dataModelGet: {
                    method: 'GET',
                    cache: false,
                    params: {
                        res: 'datamodels',
                        action: '@modelId'
                    }
                },
                dataModelDelete: {
                    method: 'DELETE',
                    cache: false,
                    params: {
                        res: 'datamodels',
                        action: '@modelId'
                    }
                },
                dataModelList: {
                    method: 'GET',
                    cache: false,
                    isArray: true,
                    params: {
                        res: 'datamodels',
                        action: 'list',
                        actionExt: '@projectId'
                    }
                },
                dataModelParams: {
                    method: 'GET',
                    cache: false,
                    isArray: true,
                    params: {
                        res: 'device',
                        action: 'model',
                        actionExt: 'params'
                    }
                },
                dataModelParamsSets: {
                    method: 'GET',
                    url: apiUrl + '/:actionExt2',
                    cache: false,
                    isArray: true,
                    params: {
                        res: 'device',
                        action: 'model',
                        actionExt: 'params',
                        actionExt2: 'sets'
                    }
                },
                dataModelPredefinedSets: {
                    method: 'POST',
                    cache: false,
                    isArray: false,
                    params: {
                        res: 'datamodels',
                        action: 'predefined-sets',
                    }
                },
                dataModelPreview: {
                    method: 'GET',
                    url: apiUrl + '/:actionExt2/:modelId/:projectId',
                    cache: false,
                    isArray: false,
                    params: {
                        res: 'device',
                        action: 'deploy',
                        actionExt: 'single',
                        actionExt2: 'preview',
                        modelId: '@modelId',
                        projectId: '@projectId'
                    }
                },
                dataModelDownload: {
                    method: 'POST',
                    url: apiUrl + '/:projectId',
                    cache: false,
                    params: {
                        res: 'device',
                        action: 'deploy',
                        actionExt: 'single',
                        projectId: '@projectId'
                    }
                },
                dataModelBulkDownload: {
                    method: 'POST',
                    url: apiUrl + '/:projectId/:modelId',
                    cache: false,
                    params: {
                        res: 'device',
                        action: 'deploy',
                        actionExt: 'bulk',
                        projectId: '@projectId',
                        modelId: '@modelId'
                    }
                },
                dataModelImageUpload: {
                    method: 'POST',
                    cache: false,
                    params: {
                        res: 'datamodels',
                        action: 'uploadimage',
                        actionExt: '@modelId'
                    },
                    transformRequest: angular.identity,
                    headers: { 'Content-Type': undefined }
                },
                configGenerateLink: {
                    method: 'POST',
                    url: apiUrl + '/:deviceId',
                    cache: false,
                    params: {
                        res: 'config',
                        action: 'generate',
                        actionExt: '@projectId',
                        deviceId: '@deviceId'
                    },
                    transformResponse: function (data) {
                        return { response: data };
                    }
                },
                dataModelWsdlAction: {
                    method: 'POST',
                    url: apiUrl + '/:actionExt2',
                    cache: false,
                    isArray: true,
                    params: {
                        res: 'device',
                        action: 'deploy',
                        actionExt: 'wsdl',
                        actionExt2: 'action',
                        projectId: '@projectId'
                    }
                },
                dataModelWsdlPreview: {
                    method: 'POST',
                    url: apiUrl + '/:actionExt2',
                    cache: false,
                    params: {
                        res: 'device',
                        action: 'deploy',
                        actionExt: 'wsdl',
                        actionExt2: 'preview',
                        projectId: '@projectId',
                        portType: '@portType',
                        operation: '@operation',
                        binding: '@binding'
                    }
                },
                modelAdhocExecTransform: {
                    method: 'POST',
                    url: apiUrl + '/:actionExt2/:projectId',
                    cache: false,
                    isArray: true,
                    params: {
                        res: 'device',
                        action: 'poll',
                        actionExt: 'exec',
                        actionExt2: 'transform',
                        projectId: '@projectId'
                    }
                },
                modelExecTransform: {
                    method: 'POST',
                    cache: false,
                    isArray: false,
                    params: {
                        res: 'device',
                        action: 'transform',
                        actionExt: '@projectId',
                    }
                },
                dmExec: {
                    method: 'POST',
                    cache: false,
                    params: {
                        res: 'dm',
                        action: 'exec',
                        endpoint: '@endpoint',
                        object: '@object',
                        instance: '@instance',
                        resource: '@resource'
                    },
                    transformResponse: function (data) {
                        return { response: data };
                    }
                },
                dmExecPlain: {
                    method: 'POST',
                    cache: false,
                    params: {
                        res: 'dm',
                        action: 'exec',
                        endpoint: '@endpoint',
                        object: '@object',
                        instance: '@instance',
                        resource: '@resource'
                    }
                },
                dmObserve: {
                    method: 'POST',
                    cache: false,
                    params: {
                        res: 'dm',
                        action: 'observe',
                        actionExt: '@status',
                        endpoint: '@endpoint',
                        object: '@object',
                        instance: '@instance',
                        resource: '@resource'
                    }
                },
                dmRead: {
                    method: 'GET',
                    cache: false,
                    isArray: false,
                    params: {
                        res: 'dm',
                        action: 'read'
                    }
                },
                dmWrite: {
                    method: 'POST',
                    url: apiUrl + '/:objectid/:instanceid/:resourceid',
                    cache: false,
                    isArray: false,
                    params: {
                        res: 'dm',
                        action: 'write',
                        actionExt: '@endpoint',
                        objectid: '@objectid',
                        instanceid: '@instanceid',
                        resourceid: '@resourceid'
                    },
                    transformResponse: function (data) {
                        return { response: data };
                    }
                },
                deviceDetails: {
                    method: 'GET',
                    url: apiUrl + '/:projectId/:deviceId',
                    cache: false,
                    params: {
                        res: 'device',
                        action: 'details',
                        projectId: '@projectId',
                        deviceId: '@deviceId'
                    }
                },
                deviceReboot: {
                    method: 'POST',
                    cache: false,
                    params: {
                        res: 'loopedge-dm',
                        action: 'reboot',
                        projectId: '@projectId',
                        deviceId: '@deviceId'
                    }
                },
                incidentList: {
                    method: 'GET',
                    url: apiUrl + '/:projectId',
                    cache: false,
                    params: {
                        res: 'project',
                        action: 'incident',
                        projectId: '@projectId',
                        limit: '@limit',
                        requestedPage: '@requestedPage'
                    }
                },
                incidentResolve: {
                    method: 'POST',
                    url: apiUrl + '/:projectId/resolve',
                    cache: false,
                    params: {
                        res: 'project',
                        action: 'incident',
                        projectId: '@projectId',
                    }
                },
                alertTemplateList: {
                    method: 'GET',
                    cache: false,
                    isArray: true,
                    params: {
                        res: 'project',
                        action: 'trigger',
                        actionExt: 'templates'
                    }
                },
                trigger: {
                    method: 'POST',
                    url: apiUrl + '/:projectId',
                    cache: false,
                    isArray: false,
                    params: {
                        res: 'project',
                        action: 'trigger',
                        actionExt: 'definition',
                        projectId: '@projectId'
                    }
                },
                triggerList: {
                    method: 'GET',
                    cache: false,
                    isArray: true,
                    params: {
                        res: 'project',
                        action: 'trigger',
                        actionExt: 'definition'
                    }
                },
                triggerDelete: {
                    method: 'DELETE',
                    url: apiUrl + '/:projectId/:triggerId',
                    cache: false,
                    params: {
                        res: 'project',
                        action: 'trigger',
                        actionExt: 'definition',
                        projectId: '@projectId',
                        triggerId: '@triggerId'
                    }
                },
                triggerFunctionList: {
                    method: 'GET',
                    cache: false,
                    isArray: true,
                    params: {
                        res: 'project',
                        action: 'trigger',
                        actionExt: 'functions'
                    }
                },
                triggerExpression: {
                    method: 'GET',
                    cache: false,
                    isArray: false,
                    params: {
                        res: 'project',
                        action: 'trigger',
                        actionExt: 'expression',
                        projectId: '@projectId',
                        triggerId: '@triggerId'
                    },
                    transformResponse: function (data) {
                        return { response: data };
                    }
                },
                triggerVariablesList: {
                    method: 'GET',
                    url: apiUrl + '/:sourceType',
                    cache: false,
                    isArray: false,
                    params: {
                        res: 'project',
                        action: 'trigger',
                        actionExt: 'variables',
                        sourceType: '@sourceType'
                    }
                },
                keyValueList: {
                    method: 'GET',
                    cache: false,
                    isArray: false,
                    params: {
                        res: 'kv',
                        action: '@projectId'
                    }
                },
                keyList: {
                    method: 'GET',
                    cache: false,
                    isArray: true,
                    params: {
                        res: 'kv',
                        action: 'keys',
                        actionExt: '@projectId'
                    }
                },
                keyValue: {
                    method: 'POST',
                    cache: false,
                    params: {
                        res: 'kv',
                        action: '@projectId'
                    }
                },
                keyValueDelete: {
                    method: 'DELETE',
                    cache: false,
                    params: {
                        res: 'kv',
                        action: '@projectId',
                        actionExt: '@key'
                    }
                },
                keyValueGet: {
                    method: 'GET',
                    cache: false,
                    isArray: false,
                    params: {
                        res: 'kv',
                        action: '@projectId',
                        actionExt: '@key'
                    }
                },
                authCredsList: {
                    method: 'GET',
                    cache: false,
                    isArray: true,
                    params: {
                        res: 'auth',
                        action: 'creds'
                    }
                },
                authCredDelete: {
                    method: 'DELETE',
                    url: apiUrl + '/:credId',
                    cache: false,
                    params: {
                        res: 'auth',
                        action: 'creds',
                        actionExt: '@projectId',
                        credId: '@credId'
                    }
                },
                authCredBasic: {
                    method: 'POST',
                    url: apiUrl + '/:projectId',
                    cache: false,
                    params: {
                        res: 'auth',
                        action: 'creds',
                        actionExt: 'basic',
                        projectId: '@projectId'
                    }
                },
                authCredBasicDevice: {
                    method: 'POST',
                    url: apiUrl + '/:projectId/:deviceId',
                    cache: false,
                    params: {
                        res: 'auth',
                        action: 'creds',
                        actionExt: 'basic',
                        projectId: '@projectId',
                        deviceId: '@deviceId'
                    }
                },
                authCredHeader: {
                    method: 'POST',
                    url: apiUrl + '/:projectId',
                    cache: false,
                    params: {
                        res: 'auth',
                        action: 'creds',
                        actionExt: 'header',
                        projectId: '@projectId'
                    }
                },
                authCredHeaderDevice: {
                    method: 'POST',
                    url: apiUrl + '/:projectId/:deviceId',
                    cache: false,
                    params: {
                        res: 'auth',
                        action: 'creds',
                        actionExt: 'header',
                        projectId: '@projectId'
                    }
                },
                authCredQuery: {
                    method: 'POST',
                    url: apiUrl + '/:projectId',
                    cache: false,
                    params: {
                        res: 'auth',
                        action: 'creds',
                        actionExt: 'query',
                        projectId: '@projectId'
                    }
                },
                authCredQueryDevice: {
                    method: 'POST',
                    url: apiUrl + '/:projectId/:deviceId',
                    cache: false,
                    params: {
                        res: 'auth',
                        action: 'creds',
                        actionExt: 'query',
                        projectId: '@projectId'
                    }
                },
                authCredOauth: {
                    method: 'POST',
                    url: apiUrl + '/:projectId',
                    cache: false,
                    params: {
                        res: 'auth',
                        action: 'creds',
                        actionExt: 'oauth',
                        projectId: '@projectId'
                    }
                },
                authCredOauthToken: {
                    method: 'POST',
                    url: apiUrl + '/:projectId',
                    cache: false,
                    params: {
                        res: 'auth',
                        action: 'oauth',
                        actionExt: 'token',
                        projectId: '@projectId',
                        deviceId: '@deviceId',
                        credName: '@credName'
                    }
                },
                dashboardRealtime: {
                    method: 'GET',
                    url: apiUrl + '/:projectId',
                    cache: false,
                    isArray: true,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'dashboard',
                        action: 'realtime',
                        actionExt: 'services',
                        projectId: '@projectId',
                        timeshift: '@timeshift'
                    },
                    transformResponse: Transform.transformMessageChartData
                },
                dashboardServiceState: {
                    method: 'GET',
                    url: apiUrl + '/:projectId',
                    cache: false,
                    isArray: false,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'dashboard',
                        action: 'state',
                        actionExt: 'services',
                        projectId: '@projectId'
                    }
                },
                dashboardUsage: {
                    method: 'GET',
                    cache: false,
                    isArray: false,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'dashboard',
                        action: 'usage',
                        actionExt: '@projectId'
                    },
                    transformResponse: Transform.transformUsageData
                },
                dashboardAlerts: {
                    method: 'GET',
                    url: apiUrl + '/:projectId',
                    cache: false,
                    isArray: true,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'dashboard',
                        action: 'realtime',
                        actionExt: 'alerts',
                        projectId: '@projectId'
                    }
                },
                dashboardGfm: {
                    method: 'GET',
                    url: apiUrl + '/:projectId',
                    cache: false,
                    isArray: false,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'dashboard-gfm',
                    }
                },
                billingAgentStatus: {
                    method: 'GET',
                    cache: false,
                    isArray: false,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'dashboard-gfm',
                        action: 'billing-agent-status'
                    }
                },
                dashboardGfmBillingTags: { 
                    method: 'GET',
                    cache: false,
                    isArray: false,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'dashboard-gfm',
                        action: 'billing-tags'
                    }
                },
                dashboardGfmBillingTagsSummary: { 
                    method: 'GET',
                    cache: false,
                    isArray: false,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'dashboard-gfm',
                        action: 'billing-tags',
                        actionExt: 'summary'
                    }
                },
                dashboardEMRealtime: {
                    method: 'GET',
                    cache: false,
                    isArray: true,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'dashboard-em',
                        action: 'messages-chart',
                        actionExt: '@projectId',
                        timeshift: '@timeshift'
                    },
                    transformResponse: Transform.transformMessageChartData
                },
                dashboardEMUsage: {
                    method: 'GET',
                    cache: false,
                    isArray: false,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'dashboard-em',
                        action: 'usage',
                        actionExt: '@projectId',
                        timeshift: '@timeshift'
                    }
                },
                log: {
                    method: 'GET',
                    cache: false,
                    params: {
                        res: 'logs',
                        action: 'company',
                        actionExt: '@companyName',
                        projectId: '@projectId',
                        from: '@from',
                        to: '@to',
                        context: '@context',
                        requestedPage: '@requestedPage',
                        limit: '@limit'
                    }
                },
                logContexts: {
                    method: 'GET',
                    cache: false,
                    isArray: true,
                    params: {
                        res: 'logs',
                        action: 'contexts'
                    }
                },
                getApplicationVersion: {
                    method: 'GET',
                    ignoreLoadingBar: true,
                    url: '/version.json',
                    cache: false,
                    isArray: false,
                    params: {}
                },
                wgSubnetList: {
                    method: 'GET',
                    isArray: true,
                    cache: false,
                    params: {
                        res: 'wg',
                        action: 'subnet',
                        actionExt: 'list'
                    }
                },
                wgSubnetGet: {
                    method: 'GET',
                    isArray: false,
                    cache: false,
                    params: {
                        res: 'wg',
                        action: 'subnet'
                    }
                },
                wgPeer: {
                    method: 'POST',
                    cache: false,
                    params: {
                        res: 'wg',
                        action: 'peer'
                    }
                },
                wgPeerList: {
                    method: 'GET',
                    cache: false,
                    isArray: true,
                    params: {
                        res: 'wg',
                        action: 'peer',
                        actionExt: 'list'
                    }
                },
                wgStatsPeers: {
                    method: 'GET',
                    cache: false,
                    isArray: true,
                    params: {
                        res: 'wg',
                        action: 'stats',
                        actionExt: 'peers'
                    }
                },
                wgPeerDelete: {
                    method: 'DELETE',
                    cache: false,
                    params: {
                        res: 'wg',
                        action: 'peer',
                        actionExt: '@peerId'
                    }
                },
                wgCapacityInfo: {
                    method: 'GET',
                    cache: false,
                    isArray: true,
                    params: {
                        res: 'wg',
                        action: 'capacity-info',
                    }
                },
                loopedgeDmServiceList: {
                    method: 'GET',
                    cache: false,
                    isArray: true,
                    params: {
                        res: 'loopedge-dm',
                        action: 'service'
                    }
                },
                loopedgeDmServiceAction: {
                    method: 'POST',
                    url: apiUrl + '/:name',
                    cache: false,
                    isArray: false,
                    params: {
                        res: 'loopedge-dm',
                        action: 'service',
                        actionExt: '@action',
                        name: '@name',
                        projectId: '@projectId',
                        deviceId: '@deviceId'
                    }
                },
                loopedgeDmTime: {
                    method: 'GET',
                    cache: false,
                    isArray: false,
                    params: {
                        res: 'loopedge-dm',
                        action: 'host',
                        actionExt: 'time'
                    }
                },
                backupList: {
                    method: 'GET',
                    cache: false,
                    isArray: false,
                    params: {
                        res: 'backup',
                        action: 'list'
                    }
                },
                backupUploadLink: {
                    method: 'POST',
                    cache: false,
                    isArray: false,
                    params: {
                        res: 'backup',
                        action: 'put',
                        projectId: '@projectId',
                        deviceId: '@deviceId',
                        backupType: '@backupType'
                    },
                    transformResponse: function (data) {
                        return { link: data };
                    }
                },
                backupDownloadLink: {
                    method: 'POST',
                    cache: false,
                    isArray: false,
                    params: {
                        res: 'backup',
                        action: 'get',
                        projectId: '@projectId',
                        deviceId: '@deviceId',
                        backupType: '@backupType',
                        timestamp: '@timestamp'
                    },
                    transformResponse: function (data) {
                        return { link: data };
                    }
                },
                backupDelete: {
                    method: 'DELETE',
                    cache: false,
                    params: {
                        res: 'backup',
                        projectId: '@projectId',
                        deviceId: '@deviceId',
                        backupType: '@backupType',
                        timestamp: '@timestamp'
                    }
                },
                backupDeleteMultiple: {
                    method: 'POST',
                    cache: false,
                    params: {
                        res: 'backup',
                        action: 'delete-multiple',
                        projectId: '@projectId',
                        deviceId: '@deviceId',
                    }
                },
                backupInit: {
                    method: 'POST',
                    cache: false,
                    isArray: false,
                    params: {
                        res: 'backup',
                        action: 'init-backup',
                        projectId: '@projectId',
                        deviceId: '@deviceId',
                    }
                },
                backupRestoreInit: {
                    method: 'POST',
                    cache: false,
                    isArray: false,
                    params: {
                        res: 'backup',
                        action: 'init-restore',
                        projectId: '@projectId',
                        deviceId: '@deviceId',
                    }
                },
                billingPlanGet: {
                    method: 'GET',
                    cache: false,
                    isArray: false,
                    params: {
                        res: 'billing',
                        action: 'plan',
                        projectId: '@projectId'
                    }
                },
                billingPlan: {
                    method: 'POST',
                    cache: false,
                    isArray: false,
                    params: {
                        res: 'billing',
                        action: 'plan',
                        actionExt: '@projectId'
                    }
                },
                billingPlans: {
                    method: 'GET',
                    cache: false,
                    isArray: false,
                    params: {
                        res: 'billing',
                        action: 'plans'
                    }
                },
                getBillingUsage: {
                    method: 'GET',
                    cache: false,
                    ignoreLoadingBar: true,
                    isArray: false,
                    params: {
                        res: 'billing',
                        action: 'usage',
                        projectId: '@projectId',
                        period: '@period'
                    }
                },
                customAttributeTypes: {
                    method: 'GET',
                    cache: false,
                    ignoreLoadingBar: true,
                    isArray: false,
                    params: {
                        res: 'project',
                        action: 'custom-attribute',
                        actionExt: 'types'
                    }
                },
                customAttributeList: {
                    method: 'GET',
                    cache: false,
                    ignoreLoadingBar: true,
                    isArray: true,
                    params: {
                        res: 'project',
                        action: 'custom-attribute',
                        actionExt: 'list'
                    }
                },
                customAttribute: {
                    method: 'POST',
                    cache: false,
                    params: {
                        res: 'project',
                        action: 'custom-attribute',
                        actionExt: '@projectId'
                    }
                },
                asset: {
                    method: 'POST',
                    cache: false,
                    params: {
                        res: 'asset'
                    }
                },
                assetList: {
                    method: 'GET',
                    cache: false,
                    isArray: true,
                    params: {
                        res: 'asset',
                        action: 'list'
                    }
                },
                assetDelete: {
                    method: 'DELETE',
                    cache: false,
                    params: {
                        res: 'asset',
                        assetId: '@assetId'
                    }
                },
                site: {
                    method: 'POST',
                    cache: false,
                    params: {
                        res: 'site'
                    }
                },
                siteGet: {
                    method: 'GET',
                    cache: false,
                    isArray: false,
                    params: {
                        res: 'site',
                        action: '@siteId'
                    }
                },
                siteList: {
                    method: 'GET',
                    url: apiUrl + '/:projectId',
                    cache: false,
                    isArray: true,
                    params: {
                        res: 'site',
                        action: 'list',
                        projectId: '@projectId'
                    }
                },
                siteDelete: {
                    method: 'DELETE',
                    cache: false,
                    params: {
                        res: 'site',
                        action: '@siteId'
                    }
                },
                uploadSiteImage: {
                    method: 'POST',
                    cache: false,
                    params: {
                        res: 'site',
                        action: 'image',
                        actionExt: '@objectName'
                    },
                    transformRequest: angular.identity,
                    transformResponse: function (data, _, status) {
                        return status === 200 ? { imageUrl: data } : (JSON.parse(data) || data);
                    },
                    headers: { 'Content-Type': undefined }
                },
                siteImageDelete: {
                    method: 'DELETE',
                    cache: false,
                    params: {
                        res: 'site',
                        action: 'image',
                        actionExt: '@objectName'
                    },
                },
                ping: {
                    method: 'HEAD',
                    cache: false,
                    url: appConfig.apiUrl + 'lb-status',
                    ignoreLoadingBar: true,
                    ignoreAuth: true
                },
                firmwareUploadLink: {
                    method: 'POST',
                    cache: false,
                    params: {
                        res: 'firmware',
                        action: 'get',
                        objectName: '@objectName'
                    }
                },
                firmwareGet: {
                    method: 'GET',
                    isArray: false,
                    cache: false,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'firmware',
                        action: 'job'
                    }
                },
                firmwareList: {
                    method: 'GET',
                    isArray: true,
                    cache: false,
                    params: {
                        res: 'firmware',
                        action: 'list'
                    }
                },
                firmwareDelete: {
                    method: 'DELETE',
                    cache: false,
                    params: {
                        res: 'firmware',
                        objectName: '@objectName'
                    }
                },
                firwareJob: {
                    method: 'POST',
                    cache: false,
                    params: {
                        res: 'firmware',
                        action: 'job'
                    }
                },
                firwareJobList: {
                    method: 'GET',
                    cache: false,
                    isArray: true,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'firmware',
                        action: 'job',
                        actionExt: 'list'
                    }
                },
                firwareJobStart: {
                    method: 'POST',
                    url: apiUrl + '/:jobId',
                    cache: false,
                    params: {
                        res: 'firmware',
                        action: 'start',
                        actionExt: '@projectId',
                        jobId: '@jobId'
                    }
                },
                licenses: {
                    method: 'GET',
                    cache: false,
                    isArray: true,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'licenses2'
                    }
                },
                licensesEntitlementFeatures: {
                    method: 'GET',
                    cache: false,
                    isArray: true,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'licenses2',
                        action: 'features',
                    }
                },
                licensesVerify: {
                    method: 'GET',
                    cache: false,
                    isArray: false,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'licenses2',
                        action: 'verify',
                    }
                },
                licensesVerifyDeviceLimits: {
                    method: 'GET',
                    cache: false,
                    isArray: false,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'licenses2',
                        action: 'verify-device-limits',
                    }
                },
                firmwareUpgradeList: {
                    method: 'GET',
                    url: apiUrl + '/:deviceId',
                    isArray: true,
                    cache: false,
                    params: {
                        res: 'device',
                        action: 'firmware-upgrade',
                        actionExt: '@projectId',
                        deviceId: '@deviceId'
                    }
                },
                firmwareUpgradeDelete: {
                    method: 'DELETE',
                    url: apiUrl + '/:deviceId/:fileName',
                    cache: false,
                    params: {
                        res: 'device',
                        action: 'firmware-upgrade',
                        actionExt: '@projectId',
                        deviceId: '@deviceId',
                        fileName: '@fileName'
                    }
                },
                currentVersion: {
                    method: 'GET',
                    cache: false,
                    isArray: false,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'system',
                        action: 'current-version',
                    }
                },
                systemTime: {
                    method: 'GET',
                    cache: false,
                    isArray: false,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'system',
                        action: 'time',
                    }
                },
                deploymentInfo: {
                    method: 'GET',
                    cache: false,
                    isArray: false,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'system',
                        action: 'deployment-info',
                    }
                },
                experimentalFeatures: {
                    method: 'GET',
                    cache: false,
                    isArray: true,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'feature'
                    }
                },
                templateList: {
                    method: 'GET',
                    cache: false,
                    isArray: false,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'template',
                        action: 'list',
                    }
                },
                templateGet: {
                    method: 'GET',
                    cache: false,
                    isArray: false,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'template'
                    }
                },
                templateDelete: {
                    method: 'DELETE',
                    cache: false,
                    params: {
                        res: 'template',
                        templateName: '@templateName'
                    }
                },
                templateComposition: {
                    method: 'GET',
                    cache: false,
                    params: {
                        res: 'template',
                        action: 'composition'
                    }
                },
                templateDownloadLink: {
                    method: 'POST',
                    cache: false,
                    params: {
                        res: 'template',
                        action: 'download',
                        templateName: '@templateName'
                    }
                },
                templateParameterizedDownloadLink: {
                    method: 'GET',
                    cache: false,
                    params: {
                        res: 'template',
                        action: 'download-zip'
                    }
                },
                templateCreate: {
                    method: 'POST',
                    cache: false,
                    params: {
                        res: 'template',
                        action: 'create'
                    }
                },
                template: {
                    method: 'POST',
                    cache: false,
                    params: {
                        res: 'template',
                        templateName: '@templateName'
                    }
                },
                templateApply: {
                    method: 'POST',
                    cache: false,
                    params: {
                        res: 'template',
                        action: 'apply',
                        templateName: '@templateName'
                    }
                },
                templateUpload: {
                    method: 'POST',
                    cache: false,
                    params: {
                        res: 'template',
                        action: 'upload',
                        companyName: '@companyName',
                        projectId: '@projectId',
                        deviceId: '@deviceId',
                        scope: '@scope',
                        description: '@description'
                    },
                    headers: { 'Content-Type': undefined }
                },
                templateParameterizedUpload: {
                    method: 'PUT',
                    cache: false,
                    params: {
                        res: 'template',
                        action: 'upload-zip',
                        companyName: '@companyName',
                        projectId: '@projectId',
                        deviceId: '@deviceId',
                        scope: '@scope',
                        description: '@description'
                    },
                    headers: { 'Content-Type': undefined }
                },
                templateVariablesList: {
                    method: 'GET',
                    cache: false,
                    isArray: true,
                    params: {
                        res: 'template',
                        action: 'list-variables'
                    }
                },
                templateVariable: {
                    method: 'POST',
                    cache: false,
                    params: {
                        res: 'template',
                        action: 'variable',
                        templateName: '@templateName'
                    }
                },
                templateVariableDelete: {
                    method: 'DELETE',
                    cache: false,
                    params: {
                        res: 'template',
                        action: 'variable',
                        templateName: '@templateName',
                        varName: '@varName'
                    }
                },
                templateParameterizedGet: {
                    method: 'GET',
                    cache: false,
                    params: {
                        res: 'template',
                        action: 'parameterized',
                    },
                    transformResponse: function (data) {
                        return { data: data };
                    },
                },
                templateParameterized: {
                    method: 'POST',
                    cache: false,
                    params: {
                        res: 'template',
                        action: 'parameterized',
                        templateName: '@templateName'
                    }
                },
                templateParameterizedDelete: {
                    method: 'DELETE',
                    cache: false,
                    params: {
                        res: 'template',
                        action: 'parameterized',
                        templateName: '@templateName'
                    }
                },
                templateGenerate: {
                    method: 'POST',
                    cache: false,
                    params: {
                        res: 'template',
                        action: 'generate',
                    }
                },
                deviceLicenseList: {
                    method: 'GET',
                    cache: false,
                    isArray: true,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'device-licenses',
                        projectId: '@projectId',
                        deviceId: '@deviceId'
                    }
                },
                deviceLicenseDelete: {
                    method: 'DELETE',
                    cache: false,
                    params: {
                        res: 'device-licenses',
                        action: '@name',
                    }
                },
                deviceLicenseFeatureList: {
                    method: 'GET',
                    cache: false,
                    isArray: true,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'device-licenses',
                        action: 'entitlement',
                        actionExt: 'features',
                        projectId: '@projectId',
                        deviceId: '@deviceId'
                    }
                },
                deviceLicenseLimitList: {
                    method: 'GET',
                    cache: false,
                    isArray: true,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'device-licenses',
                        action: 'limits',
                    }
                },
                deviceFeatureLimitSet: {
                    method: 'PUT',
                    cache: false,
                    params: {
                        res: 'device-licenses',
                        action: 'limits',
                        actionExt: '@feature',
                    }
                },
                deviceLicenseOfflineEndpoint: {
                    method: 'GET',
                    cache: false,
                    isArray: false,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'device-licenses',
                        action: 'offline',
                        projectId: '@projectId',
                        deviceId: '@deviceId'
                    }
                },
                deviceLicenseOfflineRequest: {
                    method: 'POST',
                    cache: false,
                    isArray: false,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'device-licenses',
                        action: 'offline',
                        projectId: '@projectId',
                        deviceId: '@deviceId'
                    }
                },
                deviceLicenseOfflineActivate: {
                    method: 'POST',
                    cache: false,
                    isArray: false,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'device-licenses',
                        projectId: '@projectId',
                        deviceId: '@deviceId'
                    }
                },
                deviceLicenseOnlineActivate: {
                    method: 'PUT',
                    cache: false,
                    isArray: false,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'device-licenses',
                        projectId: '@projectId',
                        deviceId: '@deviceId'
                    }
                },
                deviceLicenseOnlineReactivate: {
                    method: 'PUT',
                    cache: false,
                    isArray: false,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'device-licenses',
                        action: 'online',
                        projectId: '@projectId',
                        deviceId: '@deviceId'
                    }
                },
                deviceLicenseType: {
                    method: 'POST',
                    cache: false,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'device-licenses',
                        action: 'type',
                        projectId: '@projectId',
                        deviceId: '@deviceId',
                        licenseType: '@licenseType'
                    }
                },
                deviceLicenseTypeGet: {
                    method: 'GET',
                    cache: false,
                    isArray: false,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'device-licenses',
                        action: 'type',
                    }
                },
                devicesLicenseMonitorExpiring: {
                    method: 'GET',
                    cache: false,
                    isArray: true,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'device-licenses-monitor',
                        action: 'expiring',
                        projectId: '@projectId',
                        expiryDays: '@expiryDays'
                    }
                },
                devicesLicenseMonitorExpired: {
                    method: 'GET',
                    cache: false,
                    isArray: true,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'device-licenses-monitor',
                        action: 'expired',
                        projectId: '@projectId'
                    }
                },
                devicesLicenseMonitorSummaryStatus: {
                    method: 'GET',
                    cache: false,
                    isArray: false,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'device-licenses-monitor',
                        action: 'summary-status',
                        projectId: '@projectId'
                    }
                },
                devicesLicenseMonitorSummaryFeatures: {
                    method: 'GET',
                    cache: false,
                    isArray: false,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'device-licenses-monitor',
                        action: 'summary-features',
                        projectId: '@projectId',
                    }
                },
                litmusLicensingLicenses: {
                    method: 'GET',
                    cache: false,
                    isArray: true,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'litmus-licensing',
                        action: 'licenses',
                    }
                },
                deviceLicensePoolList: {
                    method: 'GET',
                    cache: false,
                    isArray: false,
                    params: {
                        res: 'device-license-pool',
                        action: 'all',
                        projectId: '@projectId',
                    }
                },
                deviceLicensePoolUsedList: {
                    method: 'GET',
                    cache: false,
                    isArray: false,
                    params: {
                        res: 'device-license-pool',
                        action: 'used',
                    }
                },
                deviceLicensePoolAllCsvEmail: {
                    method: 'POST',
                    url: apiUrl + '/:actionExt2',
                    cache: false,
                    isArray: false,
                    params: {
                        res: 'device-license-pool',
                        action: 'all',
                        actionExt: 'csv',
                        actionExt2: 'email',
                        filter: '@filter',
                        status: '@status',
                        order: '@order',
                        licenseSku: '@licenseSku',
                        expiryDateFrom: '@expiryDateFrom',
                        expiryDateTo: '@expiryDateTo',
                        activationDateFrom: '@activationDateFrom',
                        activationDateTo: '@activationDateTo'
                    }
                },
                deviceLicensePoolSkus: {
                    method: 'GET',
                    cache: false,
                    isArray: true,
                    params: {
                        res: 'device-license-pool',
                        action: 'skus',
                        projectId: '@projectId',
                    }
                },
                deviceLicensePoolDelete: {
                    method: 'DELETE',
                    cache: false,
                    isArray: false,
                    params: {
                        res: 'device-license-pool',
                        projectId: '@projectId',
                    }
                },
                deviceLicensePoolStats: {
                    method: 'GET',
                    cache: false,
                    isArray: false,
                    params: {
                        res: 'device-license-pool',
                        action: 'stats',
                        projectId: '@projectId'
                    }
                },
                deviceLicensePoolCsvUpload: {
                    method: 'POST',
                    cache: false,
                    isArray: false,
                    params: {
                        res: 'device-license-pool',
                        action: 'csv',
                        projectId: '@projectId',
                    },
                    transformRequest: angular.identity,
                    headers: { 'Content-Type': undefined }
                },
                marketplaceApp: {
                    method: 'GET',
                    cache: false,
                    isArray: true,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'marketplace',
                        action: 'app',
                        projectId: '@projectId',
                        deviceId: '@deviceId',
                        applicationId: '@applicationId'
                    }
                },
                marketplaceAppPlainList: {
                    method: 'GET',
                    cache: false,
                    isArray: true,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'marketplace',
                        action: 'app',
                        actionExt: 'plain',
                        projectId: '@projectId'
                    }
                },
                marketplaceAppList: {
                    method: 'GET',
                    cache: false,
                    isArray: true,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'marketplace',
                        action: 'app',
                        actionExt: 'list',
                        projectId: '@projectId',
                        deviceId: '@deviceId',
                    }
                },
                marketplaceAppLaunch: {
                    method: 'POST',
                    cache: false,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'marketplace',
                        action: 'app',
                        actionExt: 'launch',
                        projectId: '@projectId',
                        deviceId: '@deviceId'
                    }
                },
                marketplaceAppLog: {
                    method: 'GET',
                    cache: false,
                    isArray: false,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'marketplace',
                        action: 'app',
                        actionExt: 'log',
                        projectId: '@projectId',
                        deviceId: '@deviceId',
                        applicationId: '@applicationId'
                    }
                },
                marketplaceContainerLog: {
                    method: 'GET',
                    url: apiUrl + '/:actionExt2',
                    cache: false,
                    isArray: false,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'marketplace',
                        action: 'app',
                        actionExt: 'components',
                        actionExt2: 'logs',
                        projectId: '@projectId',
                        deviceId: '@deviceId',
                        applicationId: '@applicationId',
                        componentId: '@componentId'
                    }
                },
                marketplaceAppComponents: {
                    method: 'GET',
                    cache: false,
                    isArray: true,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'marketplace',
                        action: 'app',
                        actionExt: 'components',
                        projectId: '@projectId',
                        deviceId: '@deviceId',
                        applicationId: '@applicationId',
                    }
                },
                marketplaceAppStart: {
                    method: 'POST',
                    cache: false,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'marketplace',
                        action: 'app',
                        actionExt: 'start',
                        projectId: '@projectId',
                        deviceId: '@deviceId',
                        applicationId: '@applicationId',
                    }
                },
                marketplaceAppStop: {
                    method: 'POST',
                    cache: false,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'marketplace',
                        action: 'app',
                        actionExt: 'stop',
                        projectId: '@projectId',
                        deviceId: '@deviceId',
                        applicationId: '@applicationId',
                    }
                },
                marketplaceAppDelete: {
                    method: 'DELETE',
                    cache: false,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'marketplace',
                        action: 'app',
                        projectId: '@projectId',
                        deviceId: '@deviceId',
                        applicationId: '@applicationId',
                        removeVolumes: '@removeVolumes'
                    }
                },
                marketplaceCatalogSync: {
                    method: 'PUT',
                    cache: false,
                    isArray: true,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'marketplace',
                        action: 'sync',
                        projectId: '@projectId',
                        deviceId: '@deviceId'
                    }
                },
                activationConfigList: {
                    method: 'GET',
                    cache: false,
                    isArray: true,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'activation',
                        action: 'config',
                        actionExt: 'list',
                        projectId: '@projectId'
                    }
                },
                activationConfigGet: {
                    method: 'GET',
                    cache: false,
                    isArray: false,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'activation',
                        action: 'config',
                        projectId: '@projectId',
                        code: '@code'
                    }
                },
                activationConfig: {
                    method: 'POST',
                    cache: false,
                    isArray: false,
                    params: {
                        res: 'activation',
                        action: 'config'
                    }
                },
                activationConfigKeepaliveValue: {
                    method: 'GET',
                    cache: false,
                    isArray: false,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'wg',
                        action: 'default-persistent-keepalive'
                    }
                },
                activationRequestList: {
                    method: 'GET',
                    cache: false,
                    isArray: false,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'activation',
                        action: 'request',
                        projectId: '@projectId',
                        code: '@code'
                    }
                },
                activationRequestStatus: {
                    method: 'POST',
                    cache: false,
                    isArray: true,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'activation',
                        action: 'request',
                        actionExt: 'status'
                    }
                },
                activationRequestRetry: {
                    method: 'POST',
                    cache: false,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'activation',
                        action: 'request',
                        actionExt: 'request-retry-provision',
                        projectId: '@projectId',
                        entryId: '@entryId',
                    }
                },
                activationRequestSummary: {
                    method: 'GET',
                    cache: false,
                    ignoreLoadingBar: true,
                    isArray: true,
                    params: {
                        res: 'activation',
                        action: 'status-summaries'
                    }
                },
                activationRequestTemplateVariable: {
                    method: 'POST',
                    url: apiUrl + '/:actionExt2',
                    cache: false,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'activation',
                        action: 'request',
                        actionExt: 'template',
                        actionExt2: 'vars'
                    }
                },
                templateVariableSet: {
                    method: 'POST',
                    cache: false,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'template',
                        action: 'variable-set',
                    }
                },
                templateVariableSetGet: {
                    method: 'GET',
                    isArray: true,
                    cache: false,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'template',
                        action: 'variable-set',
                    }
                },
                templateVariableSetDelete: {
                    method: 'DELETE',
                    cache: false,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'template',
                        action: 'variable-set',
                        setId: '@setId'
                    }
                },
                templateVariableSetCsv: {
                    method: 'POST',
                    cache: false,
                    params: {
                        res: 'template',
                        action: 'variable-set',
                        actionExt: 'csv',
                        activationCode: '@activationCode',
                        projectId: '@projectId'
                    },
                    headers: { 'Content-Type': undefined }
                },
                dtModelList: {
                    method: 'GET',
                    cache: false,
                    isArray: true,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'dt2',
                        action: 'models',
                        actionExt: '@companyName',
                    }
                },
                dtModelComplete: {
                    method: 'POST',
                    url: apiUrl + '/:companyName',
                    cache: false,
                    params: {
                        res: 'dt2',
                        action: 'model',
                        actionExt: 'complete',
                        companyName: '@companyName'
                    }
                },
                dtModel: {
                    method: 'POST',
                    url: apiUrl + '/:companyName',
                    cache: false,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'dt2',
                        action: 'model',
                        actionExt: '@companyName'
                    }
                },
                dtModelGet: {
                    method: 'GET',
                    cache: false,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'dt2',
                        action: 'model',
                        actionExt: '@id'
                    }
                },
                dtModelJson: {
                    method: 'GET',
                    url: apiUrl + '/:modelId/json',
                    cache: false,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'dt',
                        action: 'model',
                        modelId: '@modelId'
                    }
                },
                dtModelDelete: {
                    method: 'DELETE',
                    cache: false,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'dt2',
                        action: 'model',
                        actionExt: '@modelId'
                    }
                },
                dtModelExport: {
                    method: 'POST',
                    cache: false,
                    isArray: true,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'dt2',
                        action: 'export'
                    }
                },
                dtModelImport: {
                    method: 'POST',
                    cache: false,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'dt2',
                        action: 'import',
                        actionExt: '@companyName'
                    },
                    transformRequest: angular.identity,
                    headers: { 'Content-Type': undefined }
                },
                dtModelClone: {
                    method: 'POST',
                    url: apiUrl + '/:modelId',
                    cache: false,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'dt2',
                        action: 'model',
                        actionExt: 'clone'
                    }
                },
                dtModelPush: {
                    method: 'POST',
                    url: apiUrl + '/:projectId/:deviceId',
                    cache: false,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'dt2',
                        action: 'model',
                        actionExt: 'push'
                    }
                },
                dtModelImage: {
                    method: 'POST',
                    cache: false,
                    params: {
                        res: 'dt2',
                        action: 'image',
                        actionExt: '@modelId'
                    },
                    transformRequest: angular.identity,
                    headers: { 'Content-Type': undefined }
                },
                dtModelImageDelete: {
                    method: 'DELETE',
                    cache: false,
                    params: {
                        res: 'dt2',
                        action: 'image',
                        actionExt: '@modelId',
                    }
                },
                dtDeployedModels: {
                    method: 'GET',
                    cache: false,
                    isArray: true,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'dt2',
                        action: 'deployed-models'
                    }
                },
                dtInstanceList: {
                    method: 'GET',
                    cache: false,
                    isArray: true,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'dt2',
                        action: 'instance'
                    }
                },
                dtInstance: {
                    method: 'PUT',
                    cache: false,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'dt2',
                        action: 'instance',
                    }
                },
                dtInstanceGet: {
                    method: 'GET',
                    cache: false,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'dt2',
                        action: 'instance',
                        actionExt: '@id'
                    }
                },
                dtInstanceDelete: {
                    method: 'DELETE',
                    cache: false,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'dt2',
                        action: 'instance',
                        actionExt: '@instanceId'
                    }
                },
                dtInstanceState: {
                    method: 'POST',
                    cache: false,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'dt2',
                        action: 'instance',
                        actionExt: 'state'
                    }
                },
                dtInstanceStaticAttributeList: {
                    method: 'GET',
                    cache: false,
                    isArray: true,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'dt2',
                        action: 'instance-static-attributes',
                        actionExt: '@instanceId'
                    }
                },
                dtInstanceDynamicAttributeList: {
                    method: 'GET',
                    cache: false,
                    isArray: true,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'dt2',
                        action: 'instance-dynamic-attributes',
                        actionExt: '@instanceId'
                    }
                },
                dtNode: {
                    method: 'POST',
                    cache: false,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'dt2',
                        action: 'model',
                        actionExt: 'node'
                    }
                },
                dtNodes: {
                    method: 'GET',
                    url: apiUrl + '/:actionExt2',
                    cache: false,
                    ignoreLoadingBar: true,
                    isArray: false,
                    params: {
                        res: 'dt2',
                        action: 'model',
                        actionExt: 'node',
                        actionExt2: '@nodeId'
                    }
                },
                dtNodeParseCsv: {
                    method: 'POST',
                    url: apiUrl + '/parse-csv/:modelId',
                    cache: false,
                    isArray: false,
                    params: {
                        res: 'dt2',
                        action: 'model',
                        actionExt: 'node',
                        modelId: '@modelId'
                    },
                    transformRequest: angular.identity,
                    headers: { 'Content-Type': undefined }
                },
                dtStaticAttribute: {
                    method: 'POST',
                    isArray: true,
                    cache: false,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'dt2',
                        action: 'static-attribute',
                        actionExt: '@modelId'
                    }
                },
                dtStaticAttributeList: {
                    method: 'GET',
                    cache: false,
                    isArray: true,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'dt2',
                        action: 'static-attributes',
                        actionExt: '@modelId'
                    }
                },
                dtStaticAttributeDelete: {
                    method: 'DELETE',
                    cache: false,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'dt2',
                        action: 'static-attribute'
                    }
                },
                dtStaticAttributesParseCsv: {
                    method: 'POST',
                    url: apiUrl + '/:modelId',
                    cache: false,
                    isArray: true,
                    params: {
                        res: 'dt2',
                        action: 'static-attributes',
                        actionExt: 'parse-csv',
                        modelId: '@modelId'
                    },
                    transformRequest: angular.identity,
                    headers: { 'Content-Type': undefined }
                },
                dtDynamicAttribute: {
                    method: 'POST',
                    cache: false,
                    isArray: true,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'dt2',
                        action: 'dynamic-attribute'
                    }
                },
                dtDynamicAttributeList: {
                    method: 'GET',
                    cache: false,
                    isArray: true,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'dt2',
                        action: 'dynamic-attributes',
                        actionExt: '@modelId'
                    }
                },
                dtDynamicAttributeDelete: {
                    method: 'DELETE',
                    cache: false,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'dt2',
                        action: 'dynamic-attribute',
                        actionExt: '@ID'
                    }
                },
                dtDynamicAttributesParseCsv: {
                    method: 'POST',
                    url: apiUrl + '/:modelId',
                    cache: false,
                    isArray: true,
                    params: {
                        res: 'dt2',
                        action: 'dynamic-attributes',
                        actionExt: 'parse-csv',
                        modelId: '@modelId'
                    },
                    transformRequest: angular.identity,
                    headers: { 'Content-Type': undefined }
                },
                dtTransformation: {
                    method: 'POST',
                    cache: false,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'dt2',
                        action: 'transformation',
                        actionExt: '@modelId'
                    }
                },
                dtTransformations: {
                    method: 'GET',
                    cache: false,
                    isArray: true,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'dt2',
                        action: 'transformations',
                        actionExt: '@modelId'
                    }
                },
                dtInstanceTransformations: {
                    method: 'GET',
                    cache: false,
                    isArray: true,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'dt2',
                        action: 'instance-transformations',
                        actionExt: '@instanceId'
                    }
                },
                dtTransformationDelete: {
                    method: 'DELETE',
                    cache: false,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'dt2',
                        action: 'transformation',
                        actionExt: '@ID'
                    }
                },
                registry: {
                    method: 'POST',
                    cache: false,
                    params: {
                        res: 'omna'
                    }
                },
                registryGet: {
                    method: 'GET',
                    cache: false,
                    isArray: false,
                    params: {
                        res: 'omna',
                        action: '@objectID'
                    }
                },
                registryList: {
                    method: 'GET',
                    cache: false,
                    isArray: true,
                    params: {
                        res: 'omna'
                    }
                },
                registryDelete: {
                    method: 'DELETE',
                    cache: false,
                    params: {
                        res: 'omna',
                        action: '@objectID'
                    }
                },
                eventList: {
                    method: 'GET',
                    cache: false,
                    isArray: false,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'loopedge-events',
                        action: 'list',
                        actionExt: '@projectId'
                    }
                },
                eventRegistry: {
                    method: 'GET',
                    cache: false,
                    isArray: false,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'loopedge-events',
                        action: 'registry',
                    }
                },
                eventForwardingGet: {
                    method: 'GET',
                    cache: false,
                    isArray: false,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'loopedge-events',
                        action: 'forwarding'
                    }
                },
                eventForwarding: {
                    method: 'POST',
                    cache: false,
                    params: {
                        res: 'loopedge-events',
                        action: 'forwarding',
                        projectId: '@projectId',
                        deviceId: '@deviceId',
                        enabled: '@enabled'
                    }
                },
                passwordPolicyList: {
                    method: 'GET',
                    cache: false,
                    isArray: true,
                    params: {
                        res: 'password-policy'
                    }
                },
                passwordPolicyGet: {
                    method: 'GET',
                    cache: false,
                    isArray: false,
                    params: {
                        res: 'password-policy',
                        action: 'device',
                        actionExt: '@deviceId'
                    }
                },
                passwordPolicy: {
                    method: 'POST',
                    url: apiUrl + '/:policyId',
                    cache: false,
                    isArray: true,
                    params: {
                        res: 'password-policy',
                        action: 'device',
                        actionExt: '@deviceId',
                        policyId: '@policyId'
                    }
                },
                deviceEdgePollingSettingsGet: {
                    method: 'GET',
                    cache: false,
                    isArray: false,
                    params: {
                        res: 'device',
                        action: 'edge-polling-settings',
                        actionExt: '@deviceId'
                    }
                },
                deviceEdgePollingSettings: {
                    method: 'POST',
                    cache: false,
                    isArray: false,
                    params: {
                        res: 'device',
                        action: 'edge-polling-settings',
                        actionExt: '@deviceId',
                    }
                },
                metricsGet: {
                    method: 'POST',
                    cache: false,
                    isArray: true,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'device',
                        action: 'metrics',
                        actionExt: '@projectId',
                    }
                },
                asyncTaskList: {
                    method: 'GET',
                    cache: false,
                    isArray: false,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'async-task',
                        action: 'tasks'
                    }
                },
                asyncTaskGet: {
                    method: 'GET',
                    cache: false,
                    isArray: false,
                    params: {
                        res: 'async-task',
                        action: 'task',
                        actionExt: '@taskId'
                    }
                },
                asyncSubtaskList: {
                    method: 'GET',
                    cache: false,
                    isArray: true,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'async-task',
                        action: '@taskId',
                        actionExt: 'subtasks'
                    }
                },
                asyncSubtaskListAll: {
                    method: 'GET',
                    cache: false,
                    isArray: false,
                    ignoreLoadingBar: true,
                    params: {
                        res: 'async-task',
                        action: 'subtasks',
                    }
                },
                asyncTaskWithSubtasks: {
                    method: 'POST',
                    cache: false,
                    isArray: false,
                    params: {
                        res: 'async-task',
                        action: 'task-with-subtasks'
                    }
                },
                asyncSubtaskLogs: {
                    method: 'GET',
                    url: apiUrl + '/:subtaskId',
                    cache: false,
                    isArray: false,
                    params: {
                        res: 'async-task',
                        action: 'logs',
                        actionExt: 'subtask',
                        subtaskId: '@subtaskId'
                    }
                },
                asyncTaskCancel: {
                    method: 'POST',
                    cache: false,
                    isArray: true,
                    params: {
                        res: 'async-task',
                        action: 'task',
                        actionExt: 'cancel',
                    }
                },
                deviceCertificatesList: {
                    method: 'GET',
                    cache: false,
                    isArray: false,
                    params: {
                        res: 'device-certificates'
                    }
                },
                deviceCertificateSettings: {
                    method: 'GET',
                    cache: false,
                    isArray: false,
                    params: {
                        res: 'device-certificates',
                        action: 'settings',
                    }
                },
                deviceCertificateNew: {
                    method: 'POST',
                    cache: false,
                    isArray: false,
                    params: {
                        res: 'device-certificates',
                        action: 'new',
                    }
                },
                deviceCertificateUserDefined: {
                    method: 'POST',
                    cache: false,
                    isArray: false,
                    params: {
                        res: 'device-certificates',
                        action: 'user-defined',
                        projectId: '@projectId',
                        deviceId: '@deviceId',
                    },
                    transformRequest: angular.identity,
                    headers: { 'Content-Type': undefined }
                },
                deviceCertificateReset: {
                    method: 'POST',
                    cache: false,
                    isArray: false,
                    params: {
                        res: 'device-certificates',
                        action: 'reset',
                    }
                },
                domainSslDigicert: {
                    method: 'GET',
                    url: apiUrl + '/:actionExt2',
                    cache: false,
                    isArray: false,
                    params: {
                        res: 'domain',
                        action: 'ssl',
                        actionExt: 'digicert',
                        actionExt2: 'settings'
                    }
                },
                domainSslList: {
                    method: 'GET',
                    cache: false,
                    isArray: false,
                    params: {
                        res: 'domain',
                        action: 'ssl',
                    }
                },
                domainSslDetails: {
                    method: 'GET',
                    cache: false,
                    isArray: false,
                    params: {
                        res: 'domain',
                        action: 'ssl',
                        actionExt: '@type'
                    }
                },
                mlEdgeDeviceModels: {
                    method: 'GET',
                    cache: false,
                    isArray: false,
                    params: {
                        res: 'analytics',
                        action: '@projectId',
                        actionExt: 'models',
                    }
                },
                mlEdgeDeviceModelsAll: {
                    method: 'GET',
                    cache: false,
                    isArray: true,
                    params: {
                        res: 'analytics',
                        action: '@projectId',
                        actionExt: 'model-list',
                    }
                },
                mlModels: {
                    method: 'GET',
                    cache: false,
                    isArray: false,
                    params: {
                        res: 'file',
                        action: '@projectId',
                        actionExt: 'list'
                    }
                },
                mlModel: {
                    method: 'POST',
                    url: apiUrl + '/:fileName',
                    cache: false,
                    isArray: false,
                    params: {
                        res: 'file',
                        action: '@projectId',
                        actionExt: 'mlModel',
                        fileName: '@fileName',
                    }
                },
                mlModelUploadUrl: {
                    method: 'POST',
                    url: apiUrl + '/:fileName/upload-url',
                    cache: false,
                    isArray: false,
                    params: {
                        res: 'file',
                        action: '@projectId',
                        actionExt: 'mlModel',
                        fileName: '@fileName'
                    }
                },
                mlModelDownloadUrl: {
                    method: 'POST',
                    url: apiUrl + '/:fileName/download-url',
                    cache: false,
                    isArray: false,
                    params: {
                        res: 'file',
                        action: '@projectId',
                        actionExt: 'mlModel',
                        fileName: '@fileName'
                    }
                },
                mlModelDelete: {
                    method: 'DELETE',
                    url: apiUrl + '/:fileName',
                    cache: false,
                    isArray: false,
                    params: {
                        res: 'file',
                        action: '@projectId',
                        actionExt: 'mlModel',
                        fileName: '@fileName'
                    }
                },
                mlModelDeleteMultiple: {
                    method: 'POST',
                    url: apiUrl + '/delete-multiple',
                    cache: false,
                    params: {
                        res: 'file',
                        action: '@projectId'
                    }
                },
                ztConfigs: {
                    method: 'GET',
                    cache: false,
                    isArray: false,
                    params: {
                        res: 'zt',
                        action: '@projectId',
                        actionExt: 'config'
                    }
                },
                ztConfig: {
                    method: 'POST',
                    cache: false,
                    isArray: false,
                    params: {
                        res: 'zt',
                        action: '@projectId',
                        actionExt: 'config'
                    }
                },
                ztConfigClone: {
                    method: 'PUT',
                    url: apiUrl + '/:configId/clone',
                    cache: false,
                    isArray: false,
                    params: {
                        res: 'zt',
                        action: '@projectId',
                        actionExt: 'config',
                        configId: '@configId'
                    }
                },
                ztConfigDelete: {
                    method: 'DELETE',
                    url: apiUrl + '/:id',
                    cache: false,
                    isArray: false,
                    params: {
                        res: 'zt',
                        action: '@projectId',
                        actionExt: 'config',
                        id: '@id'
                    }
                },
                ztFileDownload: {
                    method: 'GET',
                    url: apiUrl + '/:id',
                    cache: false,
                    isArray: false,
                    params: {
                        res: 'zt',
                        action: '@projectId',
                        actionExt: 'download',
                        id: '@id'
                    }
                },
                getEula: {
                    method: 'GET',
                    cache: false,
                    isArray: false,
                    params: {
                        res: 'auth',
                        action: 'eula'
                    }
                },
            })
        };
    }])
    .factory('Commons', ['$q', '$mdToast', '$state', '$stateParams', '$location', '$mdDialog', 'FileSaver', 'Blob', '$http', 
        'Service', 'Auth', 'ServiceEventsMQTT', 'appConfig', 'gettextCatalog', 'ServiceAsyncTask', 'edgePollingCheck', 
        function ($q, $mdToast, $state, $stateParams, $location, $mdDialog, FileSaver, Blob, $http, 
            Service, Auth, ServiceEventsMQTT, appConfig, gettextCatalog, ServiceAsyncTask, edgePollingCheck) {
        var factory = {};

        factory.companyData = {};
        factory.currentUser = Auth.tokenParsed;
        //Project list
        factory.projectList = [];
        //Project list loading flag
        factory.isProjectListLoading = false;
        //LI dashboard sync process flag
        factory.isSynchronizing = false;
        //Current billing plan
        factory.currentBillingPlan = null;
        //Side bar menu slim/full
        factory.isFullMenu = true;
        //Current user position
        factory.coords = {};
        //License info object
        factory.licenseInfo = {};
        // Flag for toast error details dialog
        factory.isDetailsDialogOpen = false;
        // Set view scope. Used to select specific side left menu
        factory.viewScope = null;

        /**
        * Show toast
        * @param {string} text - message text
        * @param {number} delay - show message timeout (default value 3 sec)
        * @returns {void}
        */
        factory.toastShow = function (text, delay) {
            if (!text) {
                return;
            }
            var _delay = delay || 3000;
            return $mdToast.show(
                $mdToast.simple()
                    .textContent(text)
                    .position('bottom right')
                    .hideDelay(_delay)
            );
        };

        /**
        * Show toast
        * @param {string} message - message text
        * @param {string} messageDetails - message details
        * @param {number} status - HTTP status of error
        * @param {number} delay - show message timeout (default value 3 sec)
        * @returns {void}
        */
        factory.toastError = function (message, messageDetails, status, delay) {
            if (!message) {
                return;
            }
            var _delay = delay || 0;
            var _messageDetails = messageDetails || '';

            return $mdToast.show({
                hideDelay: _delay,
                position: 'bottom right',
                bindToController: true,
                templateUrl: '../scripts/components/common/detailsToast/detailsToast.html',
                locals: {
                    code: 'E',
                    message: message,
                    messageDetails: _messageDetails,
                    status: status
                },
                controllerAs: '$ctrl',
                controller: ['$mdToast', 'message', 'messageDetails', 'status', function ($mdToast, message, messageDetails, status) {
                    var vm = this;
                    vm.MESSAGE_LIMIT = 150;

                    vm.closeToast = function () {
                        $mdToast.hide();
                    };

                    vm.openDetails = function () {
                        if (factory.isDetailsDialogOpen) {
                            return;
                        }
                        factory.isDetailsDialogOpen = true;
                        $mdToast.hide();

                        factory.showConfirmation(
                            'Details',
                            '<b>Status: </b>' + status + '<br>' +
                            '<b>Message: </b>' + factory.stripHtmlTags(message) + '<br>' +
                            '<b>Details: </b>' + factory.stripHtmlTags(messageDetails) + '<br>',
                            null,
                            null,
                            'Close',
                            function() {
                                factory.isDetailsDialogOpen = false;
                            },
                            null);
                    };
                }]
            });
        };

        /**
         * Prepare error object
         * @param {Object} errorObject - error response from API 
         * @param {*} fallbackMessage - fallback message to show reason to user
         * @returns {object} - response object { message, messageDetails }
         */
        factory.createErrorObject = function (errorObject, fallbackMessage) {
            return {
                status: errorObject.status || -1,
                message: errorObject.data && errorObject.data.message ? errorObject.data.message : (fallbackMessage || 'No messages available'),
                messageDetails: errorObject.data && errorObject.data.messageDetails ? errorObject.data.messageDetails : 'No details available'
            };
        };

        /**
         * Get company name from url
         * @return {void}
         */
        factory.setCompanyData = function (company) {
            if (company) {
                factory.companyData = {
                    name: company.name,
                    currentCompany: company.name, //TODO: remove currentCompany
                    baseUrl: $location.host(),
                    needReload: true,
                    isBaseUrl: !(company && company.name),
                    profile: company
                };
                ServiceAsyncTask.startTaskPulling(company.name);
            } else {
                factory.companyData = {};
            }

        };


        /**
         * Clean up all non-url friendly chars
         * @param {String} Input url string
         * @return {String} result url friendly string
         */
        factory.cleanUrlText = function (text) {
            if (text) {
                return text.toLowerCase()
                    .replace(/\s+/g, '-')
                    .replace(/[^a-z0-9-]/ig, '');
            }
        };

        /**
         * Refresh project list
         */
        factory.refreshProjectList = function () {
            if (!factory.companyData || !factory.companyData.currentCompany) {
                return;
            }
            factory.projectList = [];
            factory.projectListPromise = Service.api.projectList({
                companyName: factory.companyData.currentCompany
            }).$promise;
            
            factory.projectListPromise
                .then(function (data) {
                    factory.projectList = data;
                })
                .catch(function (reason) {
                    factory.projectList = [];
                    console.log('Refresh Project list failure:' + JSON.stringify(reason));
                });
        };

        /**
        * Get billing plan for current project
        * //TODO: Disabled for OEM companies
        * @param {string} projectId - project identificator
        * @returns {void}
        */
        factory.refreshBillingPlan = function () {
            return;
            /*return Service.api.billingPlanGet({
                projectId: projectId
            }).$promise
                .then(function (response) {
                    factory.currentBillingPlan = response;
                })
                .catch(function (reason) {
                    console.log('Error billingPlan:' + JSON.stringify(reason));
                    var message = reason.data ? reason.data.message : 'Get current Billing Plan error';
                    factory.toastShow(message);
                });
            */
        };

        /**
         * Setup current project object
         * @param {Object} project object
         */
        factory.setCurrentProject = function (project) {
            factory.companyData.project = project;
            if (project && project.id) {
                ServiceEventsMQTT.connect(project.id);
                ServiceAsyncTask.startTaskPulling(null, project.id);
                edgePollingCheck.startCheck(project.id);
            } else {
                edgePollingCheck.stopCheck();
            }

        };

        /**
         * Toolbars visible sign. Hide toolbar only for company list
         * @return {Boolean}
         */
        factory.isToolbarVisible = function () {
            return ['companyList', 'companyNotAvailable', 'userSettings'].indexOf($state.current.name) === -1;
        };

        /**
         * Toggle left sidebar menu to full/slim mode
         */
        factory.toggleSideMenu = function () {
            factory.isFullMenu = !factory.isFullMenu;
        };

        /**
         * Download javascript object
         *
         * @param {any} data object to download
         * @param {any} fileName preferred file name
         */
        factory.downloadLink = function (data, filename) {
            try {
                data = JSON.parse(data);
                data = JSON.stringify(data, undefined, 2);
            } catch (e) {
                console.log('Data is not JSON');
            }
            data = new Blob([data], {
                type: 'application/octet-stream'
            });
            FileSaver.saveAs(data, filename);
        };


        /**
         * Show JSON modal dialog
         * @param {Object} event event object
         * @param {Object} data JSON object
         * @return {void}
         *
         */
        factory.jsonShow = function (event, data) {
            if (data === null) {
                this.toastShow('No JSON available');
                return;
            }
            $mdDialog.show({
                templateUrl: '../scripts/components/common/jsonDialog.html',
                parent: angular.element(document.body),
                targetEvent: event,
                clickOutsideToClose: true,
                preserveScope: true,
                skipHide: true,
                controllerAs: 'vm',
                locals: {
                    data: data
                },
                controller: ['$mdDialog', 'data', function ($mdDialog, data) {
                    var vm = this;
                    vm.data = data;
                    vm.cancel = function () {
                        $mdDialog.hide();
                    };
                }]
            });
        };

        factory.settingsModal = function (option) {
            return $mdDialog.show({
                templateUrl: '../scripts/components/company/companySettingsDialog.html',
                clickOutsideToClose: true,
                preserveScope: true,
                parent: angular.element(document.body),
                targetEvent: option.env,
                locals: { item: option.item },
                controller: ['item', '$scope', '$mdDialog', function (item, $scope, $mdDialog) {
                    $scope.item = angular.copy(item);
                    if ($scope.item) {
                        $scope.action = 'Update';
                    } else {
                        $scope.action = 'Create';
                    }
                    $scope.accept = function (project) {
                        $mdDialog.hide(project.name);
                    };
                    $scope.hide = function () {
                        $mdDialog.cancel();
                    };
                }]
            });
        };

        factory.alertModal = function (teamName) {
            var alert = $mdDialog.alert()
                .title(teamName + ' has already been added')
                .ok('Close');

            return $mdDialog.show(alert);
        };

        factory.deleteDialog = function (options, evn) {
            var event = evn ? evn : '';
            return $mdDialog.show({
                templateUrl: '../scripts/components/company/deleteDialog.html',
                parent: angular.element(document.body),
                targetEvent: event,
                clickOutsideToClose: false,
                preserveScope: true,
                locals: { toDelete: options },
                controllerAs: '$ctrl',
                controller: ['toDelete', '$mdDialog', function (toDelete, $mdDialog) {
                    var vm = this;
                    vm.toDeleteItem = toDelete.name;
                    vm.type = toDelete.type;
                    vm.matchText = '';

                    vm.submit = function () {
                        $mdDialog.hide();
                    };
                    vm.cancel = function () {
                        $mdDialog.cancel({ type: 'cancel' });
                    };
                }]
            });
        };

        factory.transformArray = function (teamsArray) {
            var outputArr = [];
            angular.forEach(teamsArray, function (value, key) {
                var obj = {};
                obj.teamName = key;
                obj.role = value;
                outputArr.push(obj);
            });
            return outputArr;
        };

        factory.stateChange = function (link) {
            var area = factory.viewScope;
            var companyName = $stateParams.companyName;
            var projectId = $stateParams.projectId;

            switch (area) {
                case 'company':
                case 'companyOEM':
                case 'assets':
                    $state.go(link, { companyName: companyName });
                    break;
                case 'project':
                    $state.go(link, { projectId: projectId, companyName: companyName });
                    break;
            }
        };


        /**
         * Check value to null or undefined
         */
        factory.isNullOrEmptyOrUndefined = function (value) {
            return !value;
        };

        /**
         * Make a set from an array
         * @param {Array} sourceArray - array to group
         * @returns {Array}
         */
        factory.uniqueArray = function (sourceArray) {
            var destinationArray = [];

            sourceArray.forEach(function (sourceElement) {
                var isInArray = false;
                isInArray = destinationArray.some(function (destinationElement) {
                    return sourceElement.id === destinationElement.id;
                });
                if (!isInArray) {
                    destinationArray.push(sourceElement);
                }
            });
            return destinationArray;
        };

        /**
         * Shows a custom confirm dialog
         * This one allows to set with the dialog width
         *
         * @param {string} title - message title
         * @param {string} body - message body
         * @param {string} confirmButton - confirm button text
         * @param {function} callback - confirmation callback function
         * @param {string} cancelButton - cancel button text
         * @param {function} reject - reject callback function
         * @param {Event} event - event object
         * @param {string} cssClass - custom css class
         */
        factory.showConfirmation = function (title, body, confirmButton, callback, cancelButton, reject, event, cssClass) {
            var confirmation = $mdDialog.confirm({
                targetEvent: event,
                template: '<md-dialog class="confirm-dialog" ng-class="$ctrl.cssClass">' +
                    '<div layout="row" layout-align="space-between center" class="confirm-dialog-header">' +
                    '<h2>{{$ctrl.title}}</h2>' +
                    '<md-button class="md-icon-button" ng-click="$ctrl.cancel()"><md-icon>cancel</md-icon></md-button>' +
                    '</div>' +
                    '<form>' +
                    '<md-dialog-content>' +
                    '<div class="md-dialog-content">' +
                    '<p ng-bind-html="$ctrl.body" class="confirm-dialog-content"></p>' +
                    '</md-dialog-content>' +
                    '<md-dialog-actions layout="row" layout-align="end center">' +
                    '<md-button ng-click="$ctrl.cancel()" ng-if="$ctrl.cancelButton">{{$ctrl.cancelButton}}</md-button>' +
                    '<md-button ng-click="$ctrl.hide()" class="confirm-dialog-confirm" ng-if="$ctrl.confirmButton">{{$ctrl.confirmButton}}</md-button>' +
                    '</md-dialog-actions>' +
                    '</form>' +
                    '</md-dialog>',
                skipHide: true,
                controller: ['$mdDialog', function ($mdDialog) {
                    var vm = this;
                    vm.body = body;
                    vm.title = title;
                    vm.cssClass = cssClass;
                    vm.confirmButton = confirmButton;
                    vm.cancelButton = cancelButton;

                    vm.hide = function () {
                        $mdDialog.hide();
                    };

                    vm.cancel = function () {
                        $mdDialog.cancel();
                    };
                }],
                controllerAs: '$ctrl'
            });

            $mdDialog.show(confirmation)
                .then(callback)
                .catch(reject);
        };

        /**
         * Shows warning dialog confirmation
         *
         * @param {string} title - message title
         * @param {string} body - message body
         * @param {string} confirmButton - confirm button text
         * @param {function} callback - confirmation callback function
         * @param {string} cancelButton - cancel button text
         * @param {function} reject - reject callback function
         * @param {Event} event - event object
         */
        factory.showConfirmationWarn = function (title, body, confirmButton, callback, cancelButton, reject, event) {
            factory.showConfirmation(title, body, confirmButton, callback, cancelButton, reject, event, 'confirm-dialog--warn');
        };

        /**
        * Returns an icon name for trigger scope type
        *
        * @param {string} scopeType
        * @returns {string}
        */
        factory.showIconForType = function (scopeType) {
            var iconName = '';
            switch (scopeType) {
                case 'USER':
                    iconName = 'person_outline';
                    break;
                case 'USAGE':
                    iconName = 'data_usage';
                    break;
                case 'SYSTEM':
                    iconName = 'memory';
                    break;
            }
            return iconName;
        };

        /**
         * Show custom alert dialog
         *
         * @param {string} title
         * @param {string} body
         * @param {Event} event
         * @returns
         */
        factory.showAlert = function (title, body, event) {
            var confirmation = $mdDialog.alert({
                targetEvent: event,
                template: '<md-dialog style="max-width: 500px;">' +
                    '<md-dialog-content>' +
                    '<div class="md-dialog-content">' +
                    '<h2>{{$ctrl.title}}</h2>' +
                    '<div layout="row">' +
                    '<md-input-container class="md-block" flex-gt-xs>' +
                    '<input ng-model="$ctrl.body" ng-readonly="true">' +
                    '</md-input-container>' +
                    '<md-input-container class="md-block">' +
                    '<copy-to-clipboard copy="{{$ctrl.body}}"></copy-to-clipboard>' +
                    '</md-input-container>' +
                    '</div>' +
                    '</md-dialog-content>' +
                    '<md-dialog-actions layout="row">' +
                    '<span flex></span>' +
                    '<md-button ng-click="$ctrl.hide()">OK</md-button>' +
                    '</md-dialog-actions>' +
                    '</md-dialog>',
                controller: ['$mdDialog', function ($mdDialog) {
                    var vm = this;
                    vm.body = body;
                    vm.title = title;

                    vm.hide = function () {
                        $mdDialog.hide();
                    };
                }],
                controllerAs: '$ctrl'
            });

            return $mdDialog.show(confirmation);
        };

        /**
             * Ring buffer function. Allow to save @bufferLength values
             * @param {Object} message object to store
             * @param {Array} buffer operation
             * @param {int} bufferLength buffer max value
             * @return {void}
             */
        factory.addToRingBuffer = function (message, buffer, bufferLength) {
            if (!angular.isArray(buffer)) {
                buffer = [];
            }
            var _bufferLength = bufferLength || 100;
            buffer.unshift({
                time: Date.now(),
                message: message
            });
            if (buffer.length > _bufferLength) {
                buffer.pop();
            }
            return buffer;
        };

        /**
        * Transform OMNA registry objects to object list
        * @param {Object} omnaObject object from OMNA registry API call
        * @return {Array} OMNA list as  array of objects
        */
        factory.transformOmnaObject = function (omnaObject) {
            var result = [];
            if (!omnaObject) {
                return result;
            }
            return Object.keys(omnaObject).map(function (key) {
                return omnaObject[key];
            });
        };

        /**
         * Convert template statistics from nested object to the flat array
         * input: '...\"marketplace\":{\"marketplaces\":2,\"applications\":1,\"registries\":8}...'
         * output: ["Marketplace:", "Marketplaces: 2", "Applications: 1", "Registries: 8"]
         * @param {string} stat - template statistics object 
         * @returns {Array}
         */
        factory.transformTemplateStat = function (stat) {
            if (!stat) {
                return [];
            }
            // Recursively flatten object
            function flattenObj(obj, parent, res) {
                var result = res || [];
                for (var key in obj) {
                    // Uppercase for the first letter
                    var _key = key.charAt(0).toUpperCase() + key.slice(1);
                    var propName = parent ? ' - ' + _key : _key;
                    if (typeof obj[key] === 'object') {
                        // Do not add objects with empty children
                        /* jshint ignore:start */
                        var isNonEmptyChilds = Object.keys(obj[key])
                            .some(function (childKey) {
                                return obj[key][childKey] > 0;
                            });
                        if (isNonEmptyChilds) {
                            // result.push(_key + ':');
                            var groupName = {};
                            groupName.key = _key;
                            groupName.value = '';
                            result.push(groupName);
                            flattenObj(obj[key], propName, result);
                        }
                        /* jshint ignore:end */
                    } else {
                        if (obj[key] > 0) {
                            //result.push(propName + ': ' + obj[key]);
                            var _obj = {};
                            _obj.key = propName;
                            _obj.value = obj[key];
                            result.push(_obj);
                        }
                    }
                }
                return result;
            }

            return flattenObj(JSON.parse(stat));
        };

        /*
         * Generate random string
         * @param {int} num - string length. 16 default value
         * @returns {String} - random string
         */
        factory.generateRandomString = function (num) {
            var result = '',
                charList = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789',
                _num = num || 16;

            for (var i = 0; i < _num; i++) {
                result += charList.charAt(Math.floor(Math.random() * charList.length));
            }
            return result;
        };

        /**
         * Create third level domain link
         * @param {String} domainName - third level domain name
         * @return {String} - link
         */
        factory.getDomainLink = function (domainName) {
            return 'https://' + domainName + '.' + $location.host().replace(/^[^\.]+\./i, '');
        };

        factory.log = function (groupName, args) {
            console.group(groupName);
            console.table(args);
            console.groupEnd();
        };

        /**
        * Start sync dashboard process
        * @returns {void}
        */
        factory.synchronizeDashboard = function () {
            console.log('Method synchronizeDashboard is not implemented');
            return;
        };

        /**
         * Open LoopInsights and start synchronize
         * @return {void}
         */
        factory.openInsightTemplates = function () {
            factory.synchronizeDashboard();
            // $window.open(appConfig.insightsDomain, '_blank');
        };

        /**
         * Open company page in same window
         * @param {String} name - company name
         * @return {void}
        */
        factory.companySelect = function (company) {
            factory.setCompanyData(company);
            factory.setCurrentProject(null);
            factory.projectList = [];
            factory.refreshProjectList();

            if (factory.viewScope === 'assets'){
                $state.go('dtModelList', { companyName: company.name });
            } else {
                $state.go('projectList', { companyName: company.name });
            }

        };

        /**
         * Select asset view
         * @param {String} name - company name
         * @return {void}
        */
        factory.assetsSelect = function (company) {
            factory.setCompanyData(company);
            factory.setCurrentProject(null);
            factory.projectList = [];
        };

        /**
        * Detect device status class
        * @param {Object} device
        */
        factory.getDeviceStatusObject = function (device) {
            var _activationStatus = device.activationStatus && device.activationStatus.status;
            var _activationStatusName = _activationStatus || '';
            // In case of regular deactivation show deactivation source
            if (_activationStatus === 'DEACTIVATED' && !device.deactivationReason) {
                _activationStatusName = device.deactivationSource === 'LEM' ? ('Deactivated from ' + appConfig.productName) : ('Deactivated from ' + appConfig.supportDeviceName);
            }
            // In case of deactivation with reason show that reason
            if (_activationStatus === 'DEACTIVATED' && device.deactivationReason) {
                _activationStatus = 'ABORTED';
            }
            // Protection against long error messages
            _activationStatusName = (device.deactivationReason || _activationStatusName).substring(0, 256);
            var result = {
                deviceStatus: device.status,
                online: device.online,
                deviceStatusTimestamp: device.statusTimestamp,
                version: factory.getObjectProperty(['properties', 'Firmware Version', 'value'], device),
                description: device.description,
                prettyName: device.prettyName,
                hostname: device.hostname,
                runtimeStatus: device.runtimeStatus || '',
                lastKnownIpData: device.lastKnownIpData,
                lastSeenDateData: device.lastSeenDateData,
                lastKnownIpCtl: device.lastKnownIpCtl,
                lastSeenDateCtl: device.lastSeenDateCtl,
                ctrlInterfaceType: device.ctrlInterfaceType,
                ctrlClientAddress: device.ctrlClientAddress,
                ctrlLastUpdate: device.ctrlLastUpdate,
                ctrlRegistrationDate: device.ctrlRegistrationDate,
                capabilities: device.capabilities,
                edgePollingSettings: device.edgePollingSettings,
                activationStatus: _activationStatus,
                activationStatusName: _activationStatusName,
                isActivated: device.activationStatus && device.activationStatus.activated
            };
            if (device.type === 'POLL' && device.runtimeStatus.poll_status === 'ONLINE') {
                result.class = 'success';
                result.status = 'ONLINE';
            } else if (device.type === 'WEBHOOK' && device.status === 'ACTIVE') {
                result.class = 'success';
                result.status = 'ONLINE';
            } else if (device.status === 'ACTIVE' && device.runtimeStatus) {
                result.status = device.online ? 'ONLINE' : 'OFFLINE';
                result.classControl = device.online ? 'success' : 'warning';
                result.classData = factory.isNullOrEmptyOrUndefined(device.runtimeStatus.mqtt_client_address) ? 'warning' : 'success';
            } else {
                result.class = 'unknown';
                result.classControl = 'unknown';
                result.classData = 'unknown';
                result.status = '';
            }
            return result;
        };

        /**
             * Safely convert string to JSON
             * @param {string} str - input string to transform
             * @return {Object|string} - parsed object or string
             */
        factory.jsonParseSafe = function (str) {
            try {
                return JSON.parse(str);
            } catch (e) {
                return str;
            }
        };

        /**
         * Transform teams array to hashmap => userName: teamNames[]
         *
         * @param {Array<*>} teams - Company teams
         * @returns {Object} - HashMap of users teams
         */
        factory.transformTeams = function (teams) {
            var userTeams = {};
            teams.forEach(function (team) {
                team.users.forEach(function (user) {
                    if (!userTeams[user.username]) {
                        userTeams[user.username] = [];
                    }
                    userTeams[user.username].push(team.name);
                });
            });
            return userTeams;
        };

        /**
         * Find object property in path deep
         * @param {Array} path - array of path elements, eg ['field1', 'field1.1', 'field1.1.1']
         * @param {Object} object - object to check
         * @returns {any} - found value or null if property not exists
         */
        factory.getObjectProperty = function (path, object) {
            return path.reduce(function (xs, x) {
                return (xs && xs[x]) ? xs[x] : null;
            }, object);
        };

        /**
         * Split device template file name by separator
         * @param {String} name - file name
         * Example:	test-mike/4v8n528yqaqugovk36m1xnny1/c96tzw7e3q9kvccay0xp9y183/PROJECT/1564684878929
         * @return {Array} - parsed array
         */
        factory.parseTemplateFileName = function (name) {
            return name && name.indexOf('/') > -1 ? name.split('/') : [];
        };

        /**
         * Return capability object by feature name
         * @param {Object} capabilitiesObject - object introduced in EM-1739
         * @param {*} featureName - feature name.
         * List of available features: [ACTIVATION_V1, BACKUP, EVENTS,  LWM2M, 
         * MARKETPLACE, MARKETPLACE_SYNC, REMOTE_UI, TEMPLATE_EXPORT,]
         * @returns {Object} - capability object {available, unavailabilityReason}
         */
        factory.checkFeatureCapability = function (capabilitiesObject, featureName) {
            var defaultObject = {
                available: false,
                unavailabilityReason: ''
            };
            try {
                return capabilitiesObject[featureName] || defaultObject;
            } catch (e) {
                return defaultObject;
            }
        };

        /**
         * Check if core license exist. If not, ask confirmation
         * @param {string} type - type of validation (CONFIG or REQUEST)
         * @return {Promise}
         */
        factory.licenseServerValidation = function (type) {
            var deferred = $q.defer();

            var _showConfirmation = function () {
                var adminUilink = factory.getAdminUiLink() + '/license-server';

                var isAllowToContinue = type === 'CONFIG';

                factory.showConfirmation(
                    gettextCatalog.getString('License server verification'),
                    gettextCatalog.getString('A valid core license was not found.<br> ' +
                        'You can add a new core license in <a href="' + adminUilink + '" target="_blank">Admin Console</a>.' +
                        (isAllowToContinue ? '<br>Do you want to save activation config anyway?' : '')
                    ),
                    (isAllowToContinue ? gettextCatalog.getString('Yes') : null),
                    function () {
                        // If user agree to continue
                        deferred.resolve({
                            code: 'S'
                        });
                    },
                    gettextCatalog.getString('Cancel'),
                    function () {
                        // If user doesn't want to continue
                        deferred.reject({
                            code: 'I'
                        });
                    },
                    null);
            };

            /**
             * Find license with akey and valid expiration date 
             * @param {Array} licenseList - list of license 
             * @returns {Boolean} - is there a valid license
             */
            var _checkCoreLicense = function (licenseList) {
                var expiryDateTs = 0;
                var currentTime = Date.now();
                return licenseList.some(function (license) {
                    try {
                        expiryDateTs = new Date(license.expiryDate).getTime();
                    } catch (e) {
                        console.log('License expiryDate is not valid:' + JSON.stringify(e));
                    }
                    return license.akey && expiryDateTs > currentTime;
                });
            };

            Service.api.litmusLicensingLicenses({
                primary: true
            }).$promise
                .then(function (data) {
                    if (_checkCoreLicense(data)) {
                        deferred.resolve({
                            code: 'S'
                        });
                    } else {
                        // If no license found then ask user confirmation
                        _showConfirmation();
                    }
                })
                .catch(function (reason) {
                    console.log('Error litmusLicensingLicenses:' + JSON.stringify(reason));
                    // In case of unknown error continue
                    deferred.resolve({
                        code: 'S'
                    });
                });

            return deferred.promise;
        };

        /**
          * Return device virtualization type
          * @param {Object} device - device object
          * @return {String} - device virtualization type
         */
        factory.getDeviceVirtualizationType = function (device) {
            return factory.getObjectProperty(['properties', 'virtualization', 'value'], device);
        };

        /**
         * ML model upload dialog
         * @param {Event} event - Selection event from fileUpload component
         * @param {Object} - scope object
         * @param {String} - project id
         * @param {Function} - callback function when uploading finish
         * @returns {void}
         */
        factory.uploadMlModel = function (event, scope, projectId, callback) {
            /**
             * Upload ML model function
             * @param {Object} data - upload data object 
             * {
             *  files: Files,
             *  fileData: FormData,
             *  fileName: string,
             *  fileDescription: string
             * } 
             * @returns 
             */
            var _uploadFn = function (data) {
                var deferred = $q.defer();
                factory.toastShow('Uploading started...');
                // Get pre-sign link
                Service.api.mlModelUploadUrl({
                    projectId: projectId,
                    fileName: data.fileName,
                }).$promise
                    .then(function (response) {
                        //Upload file to pre-sign link
                        return $http.put(response.url, data.files[0], {
                            _isTemplate: true, // Disable Auth Interceptor
                            headers: { 'Content-Type': undefined },
                            transformRequest: angular.identity
                        });
                    })
                    .then(function () {
                        // Save model description to DB
                        return Service.api.mlModel({
                            action: projectId,
                            fileName: data.fileName
                        }, {
                            description: data.fileDescription || '',
                        }).$promise;
                    })
                    .then(function () {
                        factory.toastShow('Model uploaded successfully');
                        deferred.resolve();
                    })
                    .catch(function (reason) {
                        deferred.reject(reason);
                    });

                return deferred.promise;
            };

            // Create an isolated scope to pass to the component
            var newScope = angular.extend(scope.$new(true), {
                title: 'Upload AI/ML Model',
                isDescriptionRequired: true,
                acceptType: '.zip',
                uploadFn: _uploadFn
            });

            $mdDialog.show({
                template: '<md-dialog style="max-width:300px;" aria-label="Upload AI/ML Model"><md-dialog-content>' +
                    '<upload-file-dialog title="title" accept-type="acceptType" ' +
                    'is-description-required="isDescriptionRequired" upload-fn="uploadFn">' +
                    '</upload-file-dialog>' +
                    '</md-dialog-content></md-dialog>',
                parent: angular.element(document.body),
                targetEvent: event,
                clickOutsideToClose: false,
                scope: newScope,
                preserveScope: true,
                skipHide: true,
            })
                .then(function () {
                    if (callback && typeof callback === 'function') {
                        callback();
                    }
                });
        };

        /**
         * Check if all form fields are pristine
         * @param {Form} form - form object
         * @returns 
         */
        factory.checkAllPristine = function(form) {
            // Iterate over all form controls and check if any of them are dirty (not pristine)
            for (var field in form) {
                if (form.hasOwnProperty(field)) {
                    if (form[field] && form[field].$pristine === false && typeof form[field].$pristine !== 'undefined') {
                        return false;  // If any field is not pristine, return false
                    }
                }
            }
            return true; // All fields are pristine
        };

        /**
         * Run validation for all form fields
         * @param {Object} form - form instance object 
         * @returns {boolean} - is form valid
         */
        factory.formValidate = function (form) {
            if (!form) { return false; }

            var result = true;

            angular.forEach(form, function (field, fieldName) {
                if (fieldName[0] !== '$' && field.$validate) {
                    field.$setTouched();
                    field.$setDirty();
                    field.$validate();
                    if (field.$invalid){
                        result = false;
                    }
                }
            });
            return result;
        };

        /**
         * Return to Admin UI.
         * Check if path is available in config, then don't use port
         * @returns {string} - return link
         */
        factory.getAdminUiLink = function () {
            var adminUiPort = appConfig.__env.adminUiPort || 8446;

            return 'https://' + window.location.hostname +
                (appConfig.__env.adminUiPath ? appConfig.__env.adminUiPath : ':' + adminUiPort);
        };

        /**
         * Clean HTML tags from string
         * @param {string} str - input string
         * @returns {string}
         */
        factory.stripHtmlTags = function (str) {
            try {
                return str.replace(/<[^>]*>?/gm, '');
            } catch (e) { return str; }
        };

        return factory;
    
    }])

    /**
     * Expired dialog factory
     */
    .factory('SessionExpired', ['$injector', function ($injector) {
        var factory = {};

        //Window show flag to prevent multi window show
        factory.isShow = false;

        /**
         * Show expired dialog
         * @returns {void}
         */
        factory.showDialog = function () {
            if (factory.isShow) {
                return;
            }
            factory.isShow = true;
            var $mdDialog = $injector.get('$mdDialog');
            $mdDialog.show({
                template: '<md-dialog aria-label="Expired Session Dialog" style="width:500px;">' +
                    '<md-toolbar>' +
                    '<div class="md-toolbar-tools"><h2 translate>User session expired</h2></div>' +
                    '</md-toolbar>' +
                    '<md-dialog-content layout-padding>' +
                    '<p translate>Your session has expired. Please <a href ng-click="$ctrl.logout()">log in</a>.</p>' +
                    '</md-dialog-content>' +
                    '</md-dialog>',
                parent: angular.element(document.body),
                targetEvent: null,
                clickOutsideToClose: false,
                escapeToClose: false,
                preserveScope: true,
                controller: ['Auth', function (Auth) {
                    var vm = this;

                    vm.logout = function () {
                        Auth.logout();
                    };
                }],
                controllerAs: '$ctrl'
            })
                .finally(function () {
                    factory.isShow = false;
                });
        };

        return factory;
    }])
    /**
     * Menu factory
     */
    .factory('menu', function (gettextCatalog) {
        var factory = {};

        factory.sections = {
            //company sidenav bar
            company: [
                {
                    name: gettextCatalog.getString('Company List'),
                    type: 'link',
                    icon: 'list_alt',
                    link: 'companyList'
                },
                {
                    name: gettextCatalog.getString('Project List'),
                    type: 'link',
                    icon: 'dashboard',
                    link: 'projectList'
                },
                {
                    name: gettextCatalog.getString('Templates'),
                    type: 'link',
                    icon: 'library_books',
                    link: 'companyTemplateList'
                },
                {
                    name: gettextCatalog.getString('Events'),
                    type: 'link',
                    icon: 'history',
                    link: 'companyEvents'
                },
                {
                    name: gettextCatalog.getString('Settings'),
                    type: 'link',
                    icon: 'settings',
                    link: 'companySettings'
                }
            ],
            companyOEM: [
                {
                    name: gettextCatalog.getString('Project List'),
                    type: 'link',
                    icon: 'dashboard',
                    link: 'projectList'
                },
                {
                    name: gettextCatalog.getString('Inventory'),
                    type: 'link',
                    icon: 'list',
                    link: 'instanceList'
                },
                {
                    name: gettextCatalog.getString('Models'),
                    type: 'toggle',
                    icon: 'developer_board',
                    pages: [
                        {
                            name: gettextCatalog.getString('Sensor'),
                            type: 'link',
                            icon: 'settings_input_component',
                            link: 'sensorModelList'
                        },
                        {
                            name: gettextCatalog.getString('Device'),
                            type: 'link',
                            icon: 'devices_other',
                            link: 'deviceModelList'
                        },
                        {
                            name: gettextCatalog.getString('Asset'),
                            type: 'link',
                            icon: 'map',
                            link: 'assetModelList'
                        }
                    ]
                },
                {
                    name: gettextCatalog.getString('Settings'),
                    type: 'link',
                    icon: 'settings',
                    link: 'companySettings'
                }
            ],
            // project sidenav bar
            project: [
                {
                    name: gettextCatalog.getString('Dashboard'),
                    type: 'link',
                    icon: 'dashboard',
                    link: 'dashboard'
                },
                {
                    name: gettextCatalog.getString('Licenses'),
                    type: 'link',
                    svg: 'images/license.svg',
                    link: 'licenseManagement'
                },
                {
                    name: gettextCatalog.getString('Sites'),
                    type: 'link',
                    icon: 'location_city',
                    link: 'sites'
                },
                {
                    name: gettextCatalog.getString('Edge Devices'),
                    type: 'link',
                    icon: 'list',
                    link: 'devices'
                },
                {
                    name: gettextCatalog.getString('Activation'),
                    type: 'toggle',
                    icon: 'playlist_add_check',
                    pages: [
                        {
                            name: gettextCatalog.getString('Configuration'),
                            type: 'link',
                            icon: 'phonelink_setup',
                            link: 'activationConfigList'
                        },
                        {
                            name: gettextCatalog.getString('Requests'),
                            type: 'link',
                            icon: 'playlist_play',
                            link: 'activationRequestList'
                        },
                        {
                            name: gettextCatalog.getString('Zerotouch'),
                            type: 'link',
                            icon: 'do_not_touch',
                            link: 'ztConfigList'
                        }
                    ]

                },
                {
                    name: gettextCatalog.getString('Templates'),
                    type: 'link',
                    icon: 'library_books',
                    link: 'templateList'
                },
                {
                    name: gettextCatalog.getString('Applications'),
                    type: 'link',
                    icon: 'add_shopping_cart',
                    link: 'edgeApplicationList'
                },
                {
                    name: gettextCatalog.getString('Certificates'),
                    type: 'link',
                    icon: 'snippet_folder',
                    link: 'certificatesList'
                },
                {
                    name: gettextCatalog.getString('AI/ML Models'),
                    type: 'link',
                    icon: 'analytics',
                    link: 'mlEdgeDeviceModels'
                },
                {
                    name: gettextCatalog.getString('Remote Access'),
                    type: 'link',
                    svg: 'images/network.svg',
                    link: 'network'
                },
                {
                    name: gettextCatalog.getString('Software Update'),
                    type: 'link',
                    svg: 'images/Firmware_Icon.svg',
                    link: 'firmwareJobs'
                },
                {
                    name: gettextCatalog.getString('Events'),
                    type: 'link',
                    icon: 'history',
                    link: 'events'
                },
                {
                    name: gettextCatalog.getString('Alerts'),
                    type: 'link',
                    icon: 'notifications_none',
                    link: 'alerts'
                },
                {
                    name: gettextCatalog.getString('Features'),
                    type: 'link',
                    icon: 'apps',
                    link: 'applicationsList'
                },
                {
                    name: gettextCatalog.getString('Settings'),
                    type: 'link',
                    icon: 'settings',
                    link: 'settings'
                }],
            assets: [
                {
                    name: gettextCatalog.getString('Company List'),
                    type: 'link',
                    icon: 'list_alt',
                    link: 'companyList'
                },
                {
                    name: gettextCatalog.getString('Models'),
                    type: 'link',
                    svg: 'images/dt-model.svg',
                    link: 'dtModelList',
                },
                {
                    name: gettextCatalog.getString('Instances'),
                    type: 'link',
                    svg: 'images/dt-instance.svg',
                    link: 'dtInstanceList',
                },
                {
                    name: gettextCatalog.getString('Events'),
                    type: 'link',
                    icon: 'history',
                    link: 'dtEvents'
                }
            ]
        };
        //current link will be saved here
        factory.link = '';

        /**
         *
         * @param {object} section
         *
         */
        factory.toggleSelectSection = function (section) {
            factory.openedSection = (factory.openedSection === section ? null : section);
        };

        /**
         *
         * @param {object} section
         * @returns {boolean}
         */
        factory.isSectionSelected = function (section) {
            return factory.openedSection === section;
        };

        /**
         *
         *
         * @returns {string} link name
         */
        factory.returnLink = function () {
            return factory.link;
        };

        return factory;

    })
    .factory('Languages', ['$window', 'localStorageService', 'Auth', function ($window, localStorageService, Auth) {
        var factory = {};

        /**
         * Reads previously stored value from storage
         *
         * @returns {string}
         */
        var _readSelectedLanguage = function () {
            return localStorageService.get('selectedLanguage', 'localStorage');
        };

        /**
         * Writes selected language into storage
         *
         * @param {string} languageCode
         * @returns {boolean}
         */
        var _storeSelectedLanguage = function (languageCode) {
            return localStorageService.set('selectedLanguage', languageCode, 'localStorage');
        };

        /**
         * Extracts language identifier, eg. en_US -> en
         *
         * @param {string} language
         * @returns {string}
         */
        var _prepareLanguageIdentifier = function (language) {
            return language.indexOf('-') !== -1 ?
                language.split('-')[0] :
                language.indexOf('_') !== -1 ?
                    language.split('_')[0] : language;
        };

        /**
         * Gets current locale from settings or token's locale property
         *
         * @returns {string} language identifier
         */
        var _currentLanguage = function () {
            var lang = Auth.tokenParsed && Auth.tokenParsed.locale ||
                $window.navigator.language ||
                $window.navigator.userLanguage;
            return _readSelectedLanguage() ||
                _prepareLanguageIdentifier(lang);
        };

        /**
         * Array of languages, defined in application
         */
        factory.definedLanguages = [
            {
                languageName: '日本語',
                languageCode: 'ja'
            },
            {
                languageName: 'English',
                languageCode: 'en'
            }
        ];

        /**
         * Returns current language code for the angular-gettext
         *
         * @returns {string}
         */
        factory.applicationLanguage = function () {
            return _currentLanguage();
        };

        /**
         * Sets selected language as default
         *
         * @param {any} languageCode
         * @returns {boolean}
         */
        factory.setApplicationLanguage = function (languageCode) {
            return _storeSelectedLanguage(languageCode);
        };

        return factory;
    }])

    .provider('versionControl', [function () {
        var delay = 300000;
        var postproneDelay = 3600000;

        /**
         * Configure delay via app.config
         * Part of API
         *
         * @param {number} milliseconds
         */
        this.setDelay = function (milliseconds) {
            delay = milliseconds;
        };

        /**
         * Configure postprone delay via app.config
         * Part of API
         *
         * @param {number} milliseconds
         */
        this.setPostproneDelay = function (milliseconds) {
            postproneDelay = milliseconds;
        };

        this.$get = ['Service', '$interval', 'Commons', 'gettextCatalog', '$window', function (Service, $interval, Commons, gettextCatalog, $window) {
            var isInitialCheck = true;
            var currentApplicationVersion;
            var postproneDue;
            var checkInProgress = false;
            var versionFailure = false;

            /**
             * Prepare data, in general converts date
             *
             * @param {Object} versionInfo
             */
            function getVersionInfo(versionInfo) {
                return {
                    buildDate: versionInfo.buildDate,
                    gitCommit: versionInfo.gitCommit,
                    gitBranch: versionInfo.gitBranch
                };
            }

            /**
             * Performs comparison and show confirmation
             *
             * @param {Object} serverVersion
             */
            function versionCheck(serverVersion) {
                if (checkInProgress || (new Date()).getTime() < postproneDue) {
                    return;
                }

                /**
                 * This part is non-generic and may vary in other project depending on the notification system used
                 */
                if (currentApplicationVersion.gitCommit !== serverVersion.gitCommit) {
                    checkInProgress = true;
                    Commons.showConfirmation(
                        gettextCatalog.getString('There is a newer version available'),
                        gettextCatalog.getString('Press "Reload" to reload WEB application now or "Notify me later" to get notified in a hour.'),
                        gettextCatalog.getString('Reload'),
                        function () {
                            $window.location.reload();
                        },
                        gettextCatalog.getString('Notify me later'),
                        function () {
                            postproneDue = new Date().getTime() + postproneDelay;
                            checkInProgress = false;
                        },
                        undefined
                    );
                }
            }

            /**
             * Get application version from server and compare with current
             */
            function runCheck () {
                if (versionFailure) {
                    return;
                }

                Service.api.getApplicationVersion().$promise
                    .then(function (versionInfo) {
                        if (isInitialCheck) {
                            currentApplicationVersion = getVersionInfo(versionInfo);
                            isInitialCheck = false;
                        }
                        versionCheck(getVersionInfo(versionInfo));
                    })
                    .catch(function () {
                        versionFailure = true;
                    });
            }

            return {
                startVersionCheck: function () {
                    runCheck();
                    $interval(runCheck, delay);
                }
            };
        }];
    }])
    /**
     * User idle provider
     * Allow to start user idle session
     */
    .provider('userIdle', [function () {
        var idleTime = 600000,
            warningTime = 60000;

        /**
         * Configure delay via app.config
         * Part of API
         * @param {number} milliseconds - num ms to idle notification
         * @returns {void}
         */
        this.setIdleTime = function (milliseconds) {
            idleTime = milliseconds;
        };

        /**
         * Configure postprone delay via app.config
         * Part of API
         * @param {number} milliseconds - num ms to firce logout
         * @returns {void}
         */
        this.setWarningTime = function (milliseconds) {
            warningTime = milliseconds;
        };

        this.$get = ['$timeout', '$document', 'Auth', 'SessionExpired', 'Commons', function ($timeout, $document, Auth, SessionExpired, Commons) {
            var idleTimeThread = null,
                warningTimeThread = null;

            /**
             * Performs comparison and show confirmation
             * @returns {void}
             */
            function idleConfirmation() {
                //Start logout timeout
                warningTimeThread = $timeout(function () {
                    Auth.logout();
                }, warningTime);

                //In case session already expired no need to show warning message
                if (SessionExpired.isShow) {
                    return;
                }

                //Show confirmation logout dialog
                Commons.showConfirmation(
                    'Your session timed out',
                    'Press the "Continue" button to continue the session, or you will be logged out automatically in ' + warningTime / 1000 + ' seconds',
                    'Logout',
                    function () {
                        Auth.logout();
                    },
                    'Continue',
                    function () {
                        $timeout.cancel(warningTimeThread);
                    },
                    undefined
                );
            }

            /**
             * Reset idle timer
             * @returns {void}
            */
            function timeoutReset() {
                // Stop the pending timeout
                $timeout.cancel(idleTimeThread);
                // Reset the timeout
                idleTimeThread = $timeout(function () {
                    idleConfirmation();
                }, idleTime);
            }

            return {
                startIdleCheck: function () {
                    // Start a timeout
                    idleTimeThread = $timeout(function () {
                        idleConfirmation();
                    }, idleTime);

                    var bodyElement = angular.element($document);

                    angular.forEach(['keydown', 'keyup', 'click', 'mousemove', 'DOMMouseScroll',
                        'mousewheel', 'mousedown', 'touchstart', 'touchmove', 'scroll', 'focus'],
                        function (eventName) {
                            bodyElement.bind(eventName, function () {
                                timeoutReset();
                            });
                        });
                }
            };
        }];
    }])
    .provider('billingMetrics', [function () {
        var delay = 5000;
        /**
         * Configure delay via app.config
         * Part of API
         *
         * @param {number} milliseconds
         */
        this.setDelay = function (milliseconds) {
            delay = milliseconds;
        };

        this.$get = ['$stateParams', '$interval', 'Service', 'Commons', function ($stateParams, $interval, Service, Commons) {
            var warningShow = true;
            var metricsData = {};
            //Usage object
            var usage = null;

            /**
             * Compare metric and selected billing
             * @param {Object} metricsData - metrics usage object
             * @param {String} metricCode - metric code
             * @returns {Object} billing plan params with usage values
             */
            var metricStatus = function (metricsData, metricCode) {
                var value = metricsData[metricCode],
                    hardLimit = Commons.currentBillingPlan.limits[metricCode].hardLimit,
                    softLimit = Commons.currentBillingPlan.limits[metricCode].softLimit,
                    percentage = value < hardLimit ? Math.round((value / hardLimit) * 100) : 100;
                switch (true) {
                case value < softLimit:
                    return { color: '#3adb90', value: percentage, status: null };
                case value >= softLimit && value < hardLimit:
                    return { color: '#e8904c', icon: 'warning', desc: 'Soft limits reached', value: percentage, status: 'I' };
                case value > hardLimit:
                    return { color: '#f70b49', icon: 'warning', desc: 'Limit exceeded', value: percentage, status: 'E' };
                default:
                    return { color: '', desc: 'UNKNOWN', value: percentage };
                }
            };

            /**
             * Check all metrics and return usage for each parameter
             * @param {Object} metricsData - metrics usage object
             * @returns {Object} - usage object
             */
            var getUsage = function (metricsData) {
                var _usage = {},
                    statusList = [];
                if (!Commons.currentBillingPlan || !Commons.currentBillingPlan.limits) {
                    return;
                }
                for (var key in Commons.currentBillingPlan.limits) {
                    _usage[key] = metricStatus(metricsData, key);
                    if (_usage[key].status) {
                        statusList.push(_usage[key].status);
                    }
                }
                //Find summary status to show toolbar indiacator
                if (statusList.indexOf('E') >= 0) {
                    _usage.summaryStatus = 'E';
                } else if (statusList.indexOf('E') < 0 && statusList.indexOf('I') >= 0) {
                    _usage.summaryStatus = 'I';
                } else {
                    _usage.summaryStatus = null;
                }
                return _usage;
            };


            return {
                /**
                 * Init check metrics poll
                 * @returns {void}
                 */
                startBillingStatusCheck: function () {
                    $interval(function () {
                        var projectId = $stateParams.projectId;
                        //Do not check metrics on company (non-project) scope
                        if (!projectId) {
                            return;
                        }
                        Service.api.getBillingUsage({
                            projectId: projectId,
                            period: 'MONTHS'
                        }).$promise
                            .then(function (response) {
                                metricsData = response;
                                usage = getUsage(metricsData);
                            })
                            .catch(function (reason) {
                                console.log('Error getBillingUsage:' + JSON.stringify(reason));
                            });
                    }, delay);
                },
                warningHide: function () {
                    warningShow = false;
                },
                getWarningShow: function () {
                    return warningShow;
                },
                getMetricsData: function () {
                    return metricsData;
                },
                getUsage: function () {
                    return usage;
                },
                resetUsage: function () {
                    usage = null;
                }

            };
        }];
    }])
    /**
     * Check connection provider.
     * Allow to start checking connection process
     */
    .provider('ping', [function () {
        var delay = 5000,   // Default check interval
            falseCount = 0, // Count of negative checks
            falseCountToWarning = 3; // How many negative check should get, before warning

        /**
         * Configure delay via app.config
         * Part of API
         * @param {number} milliseconds - delay in ms
         * @return {void}
         */
        this.setDelay = function (milliseconds) {
            delay = milliseconds;
        };

        this.$get = ['$interval', 'Service', 'Connectivity', function ($interval, Service, Connectivity) {
            return {
                /**
                 * Init check connectivity
                 * @returns {void}
                 */
                startPing: function () {
                    $interval(function () {
                        Service.api.ping().$promise
                            .then(function () {
                                falseCount = 0;
                                Connectivity.setConnectionWarning(false);
                            })
                            .catch(function () {
                                falseCount++;
                                // Set warning if falseCount more then falseCountToWarning
                                var isWarning = falseCount >= falseCountToWarning;
                                Connectivity.setConnectionWarning(isWarning);
                            });
                    }, delay);
                }
            };
        }];
    }])
    /**
     * Connectivity factory. Allow to store connection status
     */
    .factory('Connectivity', function () {
        //Internet connection warning flag
        var connectionWarning = false;
        return {
            getConnectionWarning: function () {
                return connectionWarning;
            },
            setConnectionWarning: function (value) {
                connectionWarning = value;
            }
        };
    })
    /**
     * Watcher factory allow to count watchers in the current scope
     * It's useful for debugging purposes and allows to detect performance issues
     */
    .factory('watcherCounter', function($rootScope) {
        return {
            countWatchers: function() {
                var watchers = [];
    
                var countWatchersInScope = function(scope) {
                    if (scope.$$watchers) {
                        watchers = watchers.concat(scope.$$watchers);
                    }
                    if (scope.$$childHead) {
                        countWatchersInScope(scope.$$childHead);
                    }
                    if (scope.$$nextSibling) {
                        countWatchersInScope(scope.$$nextSibling);
                    }
                };
    
                countWatchersInScope($rootScope);
                console.log(watchers);
                return watchers.length;
            }
        };
    });

'use strict';
/**
 * @ngdoc service
 * @name loopUiApp.serviceMB
 * @description
 * # service
 * Service Marketplace builder UI API
 */
angular.module('loopUiApp.serviceMPCS', ['ngResource'])
    .factory('ServiceMPCS', ['$resource', 'appConfig', function ($resource, appConfig) {
        var mbApiUrl = appConfig.__env.mbApiUrl + '/:res/:action/:actionExt';
        return {
            api: $resource(mbApiUrl, {}, {
                catalog: {
                    method: 'GET',
                    cache: false,
                    isArray: false,
                    params: {
                        res: 'catalogs',
                        action: '@catalogId'
                    }
                },
                catalogList: {
                    method: 'GET',
                    cache: false,
                    isArray: true,
                    params: {
                        res: 'catalogs'
                    }
                },
                applicationList: {
                    method: 'GET',
                    cache: false,
                    isArray: true,
                    params: {
                        res: 'catalogs',
                        action: '@catalogId',
                        actionExt: 'applications'
                    }
                },
                application: {
                    method: 'GET',
                    url: mbApiUrl + '/:catalog_id/applications/:application_id',
                    cache: false,
                    isArray: false,
                    params: {
                        res: 'catalogs',
                        catalog_id: '@catalogId',
                        application_id: '@applicationId'
                    }
                },
                releaseList: {
                    method: 'GET',
                    url: mbApiUrl + '/:catalog_id/applications/:application_id/releases',
                    cache: false,
                    isArray: true,
                    params: {
                        res: 'catalogs',
                        catalog_id: '@catalogId',
                        application_id: '@applicationId'
                    }
                },
                release: {
                    method: 'GET',
                    url: mbApiUrl + '/:catalog_id/applications/:application_id/releases/:release',
                    cache: false,
                    isArray: false,
                    params: {
                        res: 'catalogs',
                        catalog_id: '@catalogId',
                        application_id: '@applicationId',
                        release: '@release'
                    }
                }
            })
        };
    }]);
    
'use strict';
/**
 * @ngdoc Chart settings service
 * @name loopUiApp
 * @description
 * # Chart settings service
 * Service in the loopUiApp.
 */
angular.module('loopUiApp')
    .service('ServiceChart', function () {
        var vm = this;

        /**
         * Half-pie chart settings
         */
        vm.halfPieChartOptions = {
            chart: {
                type: 'pieChart',
                margin: {
                    top: 10,
                    right: 0,
                    bottom: 0,
                    left: 0
                },
                height: 200,
                //color: ['#9a9fa6', '#3adb90', '#ff8b00', '#a2dabe'],
                x: function (d) { return d.key; },
                y: function (d) { return d.y; },
                showLabels: true,
                labelsOutside: true,
                labelType: 'percent',
                donutRatio: 0.5,
                donut: true,
                padAngle: 0.05,
                transitionDuration: 500,
                labelThreshold: 0.05,
                legendPosition: 'right',
                legend: {
                    updateState: false
                },
                pie: {
                    startAngle: function (d) { return d.startAngle / 2 - Math.PI / 2; },
                    endAngle: function (d) { return d.endAngle / 2 - Math.PI / 2; },
                }
            }
        };

        /**
         * Pie chart settings
         */
        vm.pieChart = {
            chart: {
                type: 'pieChart',
                margin: {
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0
                },
                color: ['#9a9fa6', '#3adb90', '#ff8b00', '#a2dabe'],
                x: function (d) { return d.key; },
                y: function (d) { return d.y; },
                showLabels: true,
                callback: function () {
                    d3.selectAll('.nv-pieLabels text').style('fill', 'white');
                },
                labelsOutside: false,
                labelType: 'percent',
                donutRatio: 0.3,
                donut: true,
                transitionDuration: 500,
                labelThreshold: 0.05,
                legendPosition: 'right',
                legend: {
                    updateState: false
                }
            }
        };

        /**
         * Stacked area chart settings
         */
        vm.stackedAreaChart = {
            chart: {
                type: 'stackedAreaChart',
                height: 250,
                showControls: false,
                // color: ['#9a9fa6', '#061e49', '#3adb90', '#ff8b00'],
                x: function (d) { return d[0]; },
                y: function (d) { return d[1]; },
                useVoronoi: false,
                clipEdge: false,
                transitionDuration: 500,
                useInteractiveGuideline: true,
                xAxis: {
                    showMaxMin: false,
                    tickFormat: function (d) {
                        return d3.time.format('%X')(new Date(d));
                    }
                },
                yAxis: {
                    showMaxMin: false,
                    tickFormat: function (d) {
                        return d > 1e5 ? d3.format('s')(d) : d3.format(',.0f')(d);
                    }
                },
                interactiveLayer: {
                    tooltip: {}
                },
                forceY: [0],
                noErrorCheck: true
            },
            title: {
                enable: true
            }
        };

        /**
         * Line chart settings
         */
        vm.lineChart = {
            chart: {
                type: 'lineChart',
                height: 250,
                showControls: false,
                x: function (d) { return d[0]; },
                y: function (d) { return d[1]; },
                useInteractiveGuideline: true,
                xAxis: {
                    showMaxMin: true,
                    tickFormat: function (d) {
                        return d3.time.format('%H:%M')(new Date(d));
                    }
                },
                yAxis: {
                    showMaxMin: false,
                },
                interactiveLayer: {
                    tooltip: {}
                },
                forceY: [0],
                legend: {},
            },
            title: {
                enable: true,
                css: {
                    textAlign: 'left',
                    marginLeft: '55px'
                }
            }
        };

        /**
         * Bar chart settings
         */
        vm.barChart = {
            chart: {
                type: 'discreteBarChart',
                height: 200,
                margin: {
                    top: 15,
                    right: 20,
                    bottom: 40,
                    left: 50
                },
                x: function (d) { return d.label; },
                y: function (d) { return d.value; },
                showValues: true,
                valueFormat: function (d) {
                    return d3.format(',.0f')(d);
                },
                duration: 500,
                xAxis: {
                    axisLabel: 'Features'
                },
                yAxis: {
                    axisLabel: 'Devices',
                    axisLabelDistance: -10
                }
            }
        };

        /**
         * Multi bar chart settings
         */
        vm.multiBarChart = {
            chart: {
                type: 'multiBarHorizontalChart',
                height: 250,
                x: function (d) { return d.label; },
                y: function (d) { return d.value; },
                showControls: false,
                showValues: true,
                duration: 500,
                stacked: true,
                xAxis: {
                    showMaxMin: false,
                },
                yAxis: {
                    showMaxMin: false,
                    tickFormat: function (d) {
                        return Math.round(d);
                    },
                },
                tooltip: {
                    valueFormatter: function (d) {
                        return Math.round(d);
                    },
                },
                legend: {},
                multibar: {
                    dispatch: {}
                }
            },
            title: {
                enable: true,
                css: {
                    textAlign: 'left',
                    marginLeft: '55px'
                }
            },
            margin: {
                top: 0,
                right: 0,
                bottom: 0,
                left: 0
            },
        };
    });
'use strict';
/**
 * @ngdoc Chart settings service
 * @name loopUiApp
 * @description
 * # Chart settings service
 * Service in the loopUiApp.
 */
angular.module('loopUiApp')
    .service('ServiceMQTT', function ($q) {
        var vm = this;
        //MQTT client object
        vm.client = {};
        // Device config
        vm.config = {};
        //MQTT credentials
        vm.mqttCredentials = {};
        //Sent buffer length
        vm.sentBufferSize = 10;
        //Subscribe buffer length
        vm.subsribeBufferSize = 1000;
        //QoS list
        vm.qosList = [0, 1, 2];
        //Connection options
        vm.options = {
            keepalive: 60,
            clean: true,
            connectTimeout: 5000
        };
        //Commands list for iteraction with LE
        vm.commands = {
            launch: '/apps/launch',
            start: '/apps/start',
            stop: '/apps/stop',
            delete: '/apps/delete',
            list: '/apps/list'
        };
        //Map message id and command
        vm.trackCommand = {};

        /**
          * Connect to MQTT server via Websocket
          * To connect using MQTT.js client
          * @param {String} url - project identifier
          * @param {Object} options - connection options
          * @return {Promise} - connection promise
        */
        vm.connectPromise = function (url, options) {
            var deferred = $q.defer();

            //If already connected resolve
            if (vm.client && vm.client.connected) {
                deferred.resolve('connected');
                return deferred.promise;
            }

            vm.client = mqtt.connect(url, options);

            vm.client.on('connect', function () {
                deferred.resolve('connected');
            });

            vm.client.on('error', function () {
                deferred.reject('error');
            });

            return deferred.promise;
        };

        /**
         * Publish message promise
         * @param {String} topicName - topic
         * @param {String} message - message
         * @param {String} options - topic
         * @return {Promise} - publish promise
         */
        vm.publishPromise = function (topicName, message, options) {
            var deferred = $q.defer();
            var callback = function (err) {
                if (err) {
                    deferred.reject(err);
                } else {
                    deferred.resolve(message);
                }
            };
            if (!vm.client && !vm.client.connected) {
                deferred.reject('not_connected');
                return deferred.promise;
            }

            vm.client.publish(topicName, message, options, callback);

            return deferred.promise;
        };

        /**
         * Subscribe topic promise
         * @param {String} topicName - topic
         * @param {String} options - topic
         * @return {Promise} - Subscribe promise
         */
        vm.subscribePromise = function (topicName, options) {
            var deferred = $q.defer();
            var callback = function (err) {
                if (err) {
                    deferred.reject(err);
                } else {
                    deferred.resolve(topicName);
                }
            };
            if (!vm.client && !vm.client.connected) {
                deferred.reject('not_connected');
                return deferred.promise;
            }

            vm.client.subscribe(topicName, options, callback);

            return deferred.promise;
        };

        /**
         * Unsubscribe topic promise
         * @param {String} topicName - topic
         * @param {String} options - topic
         * @return {Promise} - unubscribe promise
         */
        vm.unSubscribePromise = function (topicName) {
            var deferred = $q.defer();
            var callback = function (err) {
                if (err) {
                    deferred.reject(err);
                } else {
                    deferred.resolve(topicName);
                }
            };
            if (!vm.client && !vm.client.connected) {
                deferred.reject('not_connected');
                return deferred.promise;
            }

            vm.client.unsubscribe(topicName, callback);

            return deferred.promise;
        };

        vm.endPromise = function (options) {
            var deferred = $q.defer();
            var callback = function (err) {
                if (err) {
                    deferred.reject(err);
                } else {
                    deferred.resolve();
                }
            };
            if (!vm.client && !vm.client.connected) {
                deferred.reject('not_connected');
                return deferred.promise;
            }

            vm.client.end(true, options, callback);

            return deferred.promise;
        };


        /**
         * Register for message
         * @param {function} handler - fuction handler. Get (topic, payload) as input
         * @returns {void}
         */
        vm.messageHandler = function (handler) {
            vm.client.on('message', handler);
        };

        /**
         * MQTT disconnect
         * @returns {void}
         */
        vm.disconnect = function () {
            if (vm.client) {
                vm.client.end();
            }
            //vm.topicQos = {};
        };

        /**
         * Save command name by request id
         * @param {String} id - 
         * @param {String} app_id -
         * @param {String} command -
         * @returns {void}
         */
        vm.trackCommand = function (id, app_id, command, request, response) {
            if (!vm.trackCommand[id]) {
                vm.trackCommand[id] = {};
            }
            var state = vm.trackCommand[id];
            vm.trackCommand[id].launched_app_id = app_id || state.launched_app_id;
            vm.trackCommand[id].command = command || state.command;
            vm.trackCommand[id].request = request || state.request;
            vm.trackCommand[id].response = response || state.response;

        };

        vm.getCommandById = function (id) {
            return vm.trackCommand[id] && vm.trackCommand[id].command ?
                vm.trackCommand[id].command : undefined;
        };
    });
'use strict';
/**
 * @ngdoc service
 * @name loopUiApp.serviceFeatures
 * @description
 * # service
 * Events MQTT service. 
 * Subscribe Events MQTT topic and show notification
 */
angular.module('loopUiApp.serviceEventsMQTT', ['ngResource'])
    .service('ServiceEventsMQTT', function ($stateParams, $q, $state, $mdToast, Service) {
        var vm = this;
        // Application status map
        vm.appsStatus = {};
        //MQTT client object
        vm.client = {};
        // Device config
        vm.config = {};
        //MQTT credentials
        vm.mqttCredentials = {};
        //Connection options
        vm.options = {
            keepalive: 60,
            clean: true,
            connectTimeout: 5000
        };

        /**
         * Connect to MQTT events topic
         * @param {string} projectId - project id
         * @returns {void}
         */
        vm.connect = function (projectId) {
            if (!projectId) {
                console.log('Can\'t connect to EVENTS topic, because projectId is empty');
                return;
            }
            // Events topic name for this project
            var _topicName = '';
            var _wssUrl = '';
            Service.api.projectMqttCredentials({
                projectId: projectId
            }).$promise
                .then(function (data) { // Get WSS URL
                    _wssUrl = data.wssUrl;
                    _topicName = data.eventsTopic;
                    return Service.api.projectMqttDmCredentials({
                        projectId: projectId
                    }).$promise;
                })
                .then(function(mqttCredentials) {
                    if (!_topicName || !_wssUrl){
                        return;
                    }
                    //Connect to MQTT
                    vm.options.username = mqttCredentials.accountName;
                    vm.options.password = mqttCredentials.password;
                    return vm.connectPromise(_wssUrl, vm.options); 
                })
                .then(function () {
                    //Message handler
                    vm.client.on('message', vm.messageHandler);
                })
                .then(function () {
                    // Subscribe to events topic
                    return vm.subscribePromise(_topicName);
                })
                .catch(function (reason) {
                    console.log('MQTT connection error:' + JSON.stringify(reason));
                });
        };

        /**
          * Connect to MQTT server via Websocket
          * To connect using MQTT.js client
          * @param {String} url - project identifier
          * @param {Object} options - connection options
          * @return {Promise} - connection promise
        */
        vm.connectPromise = function (url, options) {
            var deferred = $q.defer();

            //If already connected resolve
            if (vm.client && vm.client.connected) {
                vm.client.end(true);
            }

            vm.client = mqtt.connect(url, options);

            vm.client.on('connect', function () {
                deferred.resolve('connected');
            });

            vm.client.on('error', function () {
                deferred.reject('error');
            });

            return deferred.promise;
        };

        /**
        * Subscribe topic promise
        * @param {String} topicName - topic
        * @param {String} options - topic
        * @return {Promise} - Subscribe promise
        */
        vm.subscribePromise = function (topicName, options) {
            var deferred = $q.defer();
            var callback = function (err) {
                if (err) {
                    deferred.reject(err);
                } else {
                    deferred.resolve(topicName);
                }
            };
            if (!vm.client && !vm.client.connected) {
                deferred.reject('not_connected');
                return deferred.promise;
            }

            vm.client.subscribe(topicName, options, callback);

            return deferred.promise;
        };

        /**
         * Handle message from topic
         * @param {string} topic - topic name
         * @param {object} payload - recieved payload
         * @returns {void}
         */
        vm.messageHandler = function (topic, payload) {
            try {
                var _deviceId = topic.split('/')[2];
                var _projectId = topic.split('/')[3];
                var payloadParsed = JSON.parse(payload.toString());
                if (payloadParsed.component === 'mp') {
                    var _appName = payloadParsed.attrs.name;
                    var _message = _appName + ': ' + payloadParsed.msg;
                    vm.appsStatus[_deviceId] = vm.appsStatus[_deviceId] || {};
                    vm.appsStatus[_deviceId][_appName] = vm.appsStatus[_deviceId][_appName] || {};
                    vm.appsStatus[_deviceId][_appName].severity = payloadParsed.severity;
                    vm.appsStatus[_deviceId][_appName].eventId = payloadParsed.eventId;
                    vm.appsStatus[_deviceId][_appName].msg = payloadParsed.msg;
                    vm.toastShow(_message, function() {
                        vm.openDeviceView(_projectId, _deviceId);
                    });
                }
            } catch (e) {
                console.log(JSON.stringify(e));
            }

        };

        /**
         * Show toast message
         * @param {string} message - message to show
         * @returns {void}
         */
        vm.toastShow = function (message, callback) {
            var toast = $mdToast.simple()
                .textContent(message)
                .action('Details')
                .highlightAction(true)
                .position('bottom right')
                .hideDelay(10000);

            $mdToast.show(toast)
                .then(function (response) {
                    if (response === 'ok' &&
                        typeof callback === 'function') {
                        callback();
                    }
                });
        };

        /**
         * Open device details
         * @param {string} projectId - project id 
         * @param {string} deviceId - device id 
         * @returns {void}
         */
        vm.openDeviceView = function(projectId, deviceId) {
            $state.go('deviceView', {
                companyName: $stateParams.companyName,
                projectId: projectId,
                deviceId: deviceId,
                selectedTab: 'apps'
            });
        };

    });
'use strict';
/**
 * @ngdoc service
 * @name loopUiApp.service
 * @description
 * # service
 * Service in the loopUiApp.
 */
angular.module('loopUiApp.serviceLicense', ['ngResource'])
    /**
      * Check connection provider.
      * Allow to start checking connection process
      */
    .provider('licenseCheck', [function () {
        var delay = 5000;  // Default check interval

        /**
         * Configure delay via app.config
         * Part of API
         * @param {number} milliseconds - delay in ms
         * @return {void}
         */
        this.setDelay = function (milliseconds) {
            delay = milliseconds;
        };

        this.$get = ['$interval', '$mdDialog', 'gettextCatalog', 'SessionExpired', '$location', 'appConfig', 'ServiceNotification', 'Service', 'Commons', function ($interval, $mdDialog, gettextCatalog, SessionExpired, $location, appConfig, ServiceNotification, Service, Commons) {
            var falseCount = 0, // Count of negative checks
                falseCountToWarning = 3, // How many negative check should get, before warning
                isExpiredWarningShow = false, // Expired dialog already show
                isDevicesWarningShow = false, // Devices dialog already show
                features = {}, // Available features
                isFeaturesLoading = true; // Is it the first check. Allow to handle case then feature status is unknown yet

            /**
             * Show license expired dialog. Check if it already open
             * @param {Boolean} canClose - user can close by escape or click outside 
             * @returns {void}
             */
            var showExpiredDialog = function (canClose) {
                if (isExpiredWarningShow) {
                    return;
                }
                canClose = canClose || false;
                isExpiredWarningShow = true;
                $mdDialog.show({
                    template: '<md-dialog aria-label="Expired Dialog" style="width:500px;"><license-expired-dialog></license-expired-dialog></md-dialog>',
                    parent: angular.element(document.body),
                    clickOutsideToClose: canClose,
                    escapeToClose: canClose,
                    preserveScope: true,
                    skipHide: true,
                })
                    .finally(function () {
                        isExpiredWarningShow = false;
                    });
            };

            /** 
             * Get license info 
             * @returns {void}
            */
            var getLicenseInfo = function () {
                Service.api.licensesVerify().$promise
                    .then(function (data) {
                        falseCount = 0;
                        Commons.licenseInfo = data;
                        if (data.status === 'E') {
                            showExpiredDialog();
                        } else {
                            if (isExpiredWarningShow && !isDevicesWarningShow) {
                                $mdDialog.hide();
                            }
                        }
                    })
                    .catch(function (error) {
                        falseCount++;
                        // Set warning if falseCount more then falseCountToWarning
                        // API error is not 404
                        if (falseCount >= falseCountToWarning && error.status !== 404) {
                            if (isExpiredWarningShow || SessionExpired.isShow) {
                                return;
                            }
                            isExpiredWarningShow = true;
                            Commons.showConfirmation(
                                gettextCatalog.getString('License Server is not available'),
                                gettextCatalog.getString('Please try again later'),
                                gettextCatalog.getString('Ok'),
                                function () {
                                    falseCount = 0;
                                    isExpiredWarningShow = false;
                                },
                                undefined,
                                undefined,
                                null);
                        }
                    });
            };

            /** 
             * Analyze device usage 
             * @returns {void}
            */
            var getEdgeDevicesUsage = function () {
                Service.api.licensesVerifyDeviceLimits().$promise
                    .then(function (data) {
                        var key = 'LICENSE.DEVICES_TOTAL';

                        if (data.status === 'S') {
                            ServiceNotification.deleteItem(key);
                            return;
                        }
                        if (data.status === 'W' || data.status === 'E') {
                            ServiceNotification.addItem(key, {
                                time: Date.now(),
                                icon: data.status === 'E' ? 'error' : '',
                                statusClass: data.status === 'E' ? 'critical' : 'warning',
                                text: data.message,
                                infoText: 'Details...',
                                infoHandler: function () {
                                    isDevicesWarningShow = true;
                                    var adminUilink = Commons.getAdminUiLink() + '/license-server';
                                    Commons.showConfirmation(
                                        gettextCatalog.getString('Edge Devices limits'),
                                        data.message + '<br>Please check license in the <a href="' + adminUilink + '" target="_blank">Admin Console</a>.',
                                        gettextCatalog.getString('Ok'),
                                        function () { isDevicesWarningShow = false; },
                                        undefined,
                                        undefined,
                                        null);
                                },
                                hide: false
                            });
                        }
                    })
                    .catch(function (error) {
                        console.log('licensesVerifyDeviceLimits failure:' + JSON.stringify(error));
                    });
            };

            /**
             * Load list of features, available by license
             * @return {void}
             */
            var getEntitlementFeatures = function () {
                Service.api.licensesEntitlementFeatures().$promise
                    .then(function (data) {
                        features = data.reduce(function (acc, cur) {
                            acc[cur.name] = true;
                            return acc;
                        }, {});
                    })
                    .catch(function (reason) {
                        console.log('licensesEntitlementFeatures failure:' + JSON.stringify(reason));
                    })
                    .finally(function () {
                        isFeaturesLoading = false;
                    });
            };

            return {
                /**
                 * Init check connectivity
                 * @returns {void}
                 */
                startCheck: function () {
                    // Immediate check call
                    getLicenseInfo();
                    getEntitlementFeatures();
                    getEdgeDevicesUsage();
                    $interval(function () {
                        getLicenseInfo();
                        getEntitlementFeatures();
                        getEdgeDevicesUsage();
                    }, delay);
                },
                getEntitlementFeatures: function () {
                    return features;
                },
                /**
                 * Return flag is Marketplace available by license
                 * @return {boolean} - marketplace feature flag
                 */
                isMarketplaceAvailable: function () {
                    return features && features.catalog;
                },
                isFeaturesLoading: function () {
                    return isFeaturesLoading;
                }
            };
        }];
    }]);

'use strict';
/**
 * @ngdoc service
 * @name loopUiApp.service
 * @description
 * # service
 * Check async task status
 */
angular.module('loopUiApp.serviceAsyncTask', [])
    .service('ServiceAsyncTask', ['$interval', '$mdToast', '$timeout', '$q', '$state', '$stateParams', 'Service', function ($interval, $mdToast, $timeout, $q, $state, $stateParams, Service) {
        var _numTasks = 30;  // Number of tasks to load
        var _delay = 5000;   // Get task list interval
        var _checkStatusDelay = 1000;   // Check active task interval

        var vm = this;
        vm.isReady = false; // Flag if async task service is ready
        vm.taskList = [];  // List of all tasks
        vm.taskObject = {};  // Map of all tasks
        vm.watchTasks = {}; // List of tasks to control status change
        vm.currentWatchedTaskId = null; // Task id singleton for running task in promise
        vm.overallCount = 0; // Number of active or failed tasks
        vm.overallStatus = 'UNKNOWN'; // Overall status of all tasks
        // Available task types
        vm.taskTypes = {
            TEMPLATE_APPLY: {
                code: 'TEMPLATE_APPLY',
                name: 'Apply template',
                subtaskTypes: ['TEMPLATE_APPLY']
            },
            FIRMWARE_UPGRADE: {
                code: 'FIRMWARE_UPGRADE',
                name: 'Software update',
                subtaskTypes: [
                    'FIRMWARE_UPGRADE_DOWNLOAD', 'FIRMWARE_UPGRADE_EXECUTE'
                ]
            },
            FIRMWARE_UPGRADE_DOWNLOAD: {
                code: 'FIRMWARE_UPGRADE_DOWNLOAD',
                name: 'Download software update',
                subtaskTypes: ['FIRMWARE_UPGRADE_DOWNLOAD']
            },
            FIRMWARE_UPGRADE_EXECUTE: {
                code: 'FIRMWARE_UPGRADE_EXECUTE',
                name: 'Install software update',
                subtaskTypes: ['FIRMWARE_UPGRADE_EXECUTE']
            },
            MARKETPLACE_APPLICATION_LAUNCH: {
                code: 'MARKETPLACE_APPLICATION_LAUNCH',
                name: 'Launch Marketplace application',
                subtaskTypes: ['MARKETPLACE_APPLICATION_LAUNCH']
            },
            MARKETPLACE_APPLICATION_START: {
                code: 'MARKETPLACE_APPLICATION_START',
                name: 'Start Marketplace application',
                subtaskTypes: ['MARKETPLACE_APPLICATION_START']
            },
            MARKETPLACE_APPLICATION_STOP: {
                code: 'MARKETPLACE_APPLICATION_STOP',
                name: 'Stop Marketplace application',
                subtaskTypes: ['MARKETPLACE_APPLICATION_STOP']
            },
            MARKETPLACE_APPLICATION_DELETE: {
                code: 'MARKETPLACE_APPLICATION_DELETE',
                name: 'Delete Marketplace application',
                subtaskTypes: ['MARKETPLACE_APPLICATION_DELETE']
            },
            MARKETPLACE_APPLICATION_UPGRADE: {
                code: 'MARKETPLACE_APPLICATION_UPGRADE',
                name: 'Upgrade Marketplace application',
                subtaskTypes: ['MARKETPLACE_APPLICATION_UPGRADE']
            },
            MARKETPLACE_SYNC: {
                code: 'MARKETPLACE_SYNC',
                name: 'Sync Marketplace',
                subtaskTypes: ['MARKETPLACE_SYNC']
            },
            MARKETPLACE_APPLICATION_CACHE_REFRESH: {
                code: 'MARKETPLACE_APPLICATION_CACHE_REFRESH',
                name: 'Refresh Marketplace application cache',
                subtaskTypes: ['MARKETPLACE_APPLICATION_CACHE_REFRESH']
            },
            EDGE_BACKUP_CREATE: {
                code: 'EDGE_BACKUP_CREATE',
                name: 'Create Edge Device backup',
                subtaskTypes: ['EDGE_BACKUP_CREATE']
            },
            LICENSE_APPLY: {
                code: 'LICENSE_APPLY',
                name: 'Apply Edge Device license',
                subtaskTypes: ['LICENSE_APPLY']
            },
            ANALYTICS_ML_MODEL_UPLOAD: {
                code: 'ANALYTICS_ML_MODEL_UPLOAD',
                name: 'Upload AI/ML Models',
                subtaskTypes: ['ANALYTICS_ML_MODEL_UPLOAD']
            },
            EDGE_CERTIFICATE_RESET: {
                code: 'EDGE_CERTIFICATE_RESET',
                name: 'Reset to Edge default certificate',
                subtaskTypes: ['EDGE_CERTIFICATE_RESET']
            },
            EDGE_CERTIFICATE_ISSUE: {
                code: 'EDGE_CERTIFICATE_ISSUE',
                name: 'Issue a new certificate',
                subtaskTypes: ['EDGE_CERTIFICATE_ISSUE']
            },
            DIGITAL_TWINS_MODEL_DEPLOY: {
                code: 'DIGITAL_TWINS_MODEL_DEPLOY',
                name: 'Deploy DT models',
                subtaskTypes: ['DIGITAL_TWINS_MODEL_DEPLOY']
            },
            DIGITAL_TWINS_INSTANCES_UPGRADE: {
                code: 'DIGITAL_TWINS_INSTANCES_UPGRADE',
                name: 'Update DT instances',
                subtaskTypes: ['DIGITAL_TWINS_INSTANCES_UPGRADE']
            },
            ZT_FILE_GENERATE: {
                code: 'ZT_FILE_GENERATE',
                name: 'Generate ZeroTouch bundle file',
                subtaskTypes: ['ZT_FILE_GENERATE']
            }
        };
        // Available task statuses
        vm.taskStatuses = {
            NEW: {
                name: 'New',
                description: 'task is created',
            },
            WAITING: {
                name: 'Waiting',
                description: 'task is waiting',
            },
            RUNNING: {
                name: 'Running',
                description: 'task is running',
            },
            SUCCESS: {
                name: 'Success',
                description: 'task finished successfully'
            },
            ERROR: {
                name: 'Error',
                description: 'task finished with error'
            }
        };

        /**
         * Start async task pulling
         * @param {String} companyName - company name
         * @param {String} projectId - project id
         */
        vm.startTaskPulling = function (companyName, projectId) {
            vm.stopTaskPulling();
            // Reset task list
            vm.resetTaskList();

            vm.refreshTaskList(companyName, projectId);
            vm.pullingInterval = $interval(function () {
                vm.refreshTaskList(companyName, projectId);
            }, _delay);
        };

        /**
         * Stop async task pulling
         */
        vm.stopTaskPulling = function () {
            if (vm.pullingInterval) {
                $interval.cancel(vm.pullingInterval);
            }
        };

        /**
         * Get async task list
         * @param {String} companyName - company name
         * @param {String} projectId - project id
         * @return {void}
         */
        vm.refreshTaskList = function (companyName, projectId) {
            if (!companyName && !projectId) {
                return;
            }
            // Get tasks from last 24 hours
            var _lastDay = new Date().getTime() - 24 * 60 * 60 * 1000;
            Service.api.asyncTaskList({
                companyName: companyName,
                projectId: projectId,
                pageSize: _numTasks,
                createdOnFrom: _lastDay,
                requestedPage: 0
            }).$promise
                .then(function (data) {
                    vm.isReady = true;
                    vm.taskList = data.elements || [];
                    // Convert task list to object for faster access by id
                    vm.taskObject = vm.taskList.reduce(function (obj, task) {
                        obj[task.id] = task;
                        return obj;
                    }, {});
                    // Calculate overall status (count of active and failed tasks)
                    vm.calcOverallStatus();

                    // Check status changes and notify if ['NEW', 'RUNNING'] changed their status
                    vm.notifyAboutChangedTasks(vm.taskList);

                    // Get watch task object to track status changes
                    vm.watchTasks = vm.taskList
                        .filter(function (task) { // Filter only active or new tasks
                            return ['NEW', 'RUNNING'].indexOf(task.status) >= 0;
                        })
                        .reduce(function (obj, task) { // Create object with task id as key
                            obj[task.id] = task;
                            return obj;
                        }, {});
                })
                .catch(function (reason) {
                    console.log('asyncTaskList: ' + JSON.stringify(reason));
                });
        };

        /**
         * Get async task overall status
         * @return {void}
         */
        vm.calcOverallStatus = function () {
            var _activeTaskList = vm.taskList.filter(function (task) {
                return task.status === 'RUNNING';
            });
            var _failedTaskList = vm.taskList.filter(function (task) {
                return task.status === 'ERROR';
            });
            var _successTaskList = vm.taskList.filter(function (task) {
                return task.status === 'SUCCESS';
            });
            vm.overallStatus = _activeTaskList.length > 0 ? 'RUNNING' : _failedTaskList.length > 0 ? _successTaskList.length > 0 ? 'WARNING' : 'ERROR' : 'SUCCESS';
            vm.overallCount = _activeTaskList.length;
        };

        /**
         * Notify about changed tasks
         * @param {Array} taskList - List of tasks
         * @return {void}
         */
        vm.notifyAboutChangedTasks = function (taskList) {
            var _changedTasks = taskList.filter(function (task) {
                return vm.watchTasks[task.id] && vm.watchTasks[task.id].status !== task.status;
            });
            if (_changedTasks.length > 0) {
                _changedTasks.forEach(function (task) {
                    vm.showToastDetails(task);
                });
            }
        };

        /**
         * Show toast with task details and close button
         * @param {Object} task - Task object
         * @returns {void}
         */
        vm.showToastDetails = function (task) {
            var _message = task.name + ' ' + (vm.taskStatuses[task.status] ? vm.taskStatuses[task.status].description : task.status) + '.';
            var _delay = task.status === 'ERROR' ? 0 : 5000;
            return $mdToast.show({
                hideDelay: _delay,
                position: 'bottom right',
                bindToController: true,
                templateUrl: '../scripts/components/common/detailsToast/detailsToast.html',
                locals: {
                    message: _message,
                    code: task.status === 'ERROR' ? 'E' : 'S'
                },
                controllerAs: '$ctrl',
                controller: ['$mdToast', 'ServiceAsyncTask', function ($mdToast, ServiceAsyncTask) {
                    var vm = this;
                    vm.MESSAGE_LIMIT = 150;

                    vm.closeToast = function () {
                        $mdToast.hide();
                    };

                    vm.openDetails = function () {
                        $mdToast.hide();
                        ServiceAsyncTask.openTaskDetails(task.id);
                    };
                }]
            });
        };

        /**
         * Prepare task payload
         * @param {String} taskType - task type from map vm.taskTypes
         * @param {Array} subtaskTypes - list of subtasks' types
         * @param {String} taskDescription - task description
         * @param {Array} deviceList - list of devices
         * @param {Object} params - task params
         * @param {Boolean} waitForOnline - should wait for device online
         * @param {Function} extendSubtaskFn - function to extend subtask object based on device object, type
         * @param {Number} workersNum - number of workers
         * @returns {Object} - task with subtasks objects
         */
        vm.createTaskPayload = function (taskType, subtaskTypes, taskDescription, deviceList, params, waitForOnline, extendSubtaskFn, workersNum) {
            var _devicesCnt = deviceList
                .filter(function (device) {
                    return !!device.deviceId && device.deviceId !== 'none'; // Filter only real devices with id. Sometime deviceList doesn't have devices
                }).length;
            var _devicesCntMessage = _devicesCnt > 0 ? ' (' + deviceList.length + ' edge device' + (deviceList.length > 1 ? 's)' : ')') : '';

            /**
             * Create list of subtasks based on subtaskTypes and devices
             * @param {Array} types - list of subtasks' types
             * @param {Array} devices - list of devices
             * @param {Object} p - task params
             * @param {Function} fn - function to extend subtask object based on device object, type
             * @returns {Object} - task object with a list of subtasks
             */
            var _subtasksFn = function (types, devices, p, fn) {
                var _result = [];
                types.forEach(function (type, indexType) {
                    devices.forEach(function (device, indexDevice) {
                        var _subTask = {
                            deviceId: device.deviceId,
                            num: (indexType + indexDevice),
                            params: p,
                            type: type,
                            plannedExecTime: 0
                        };
                        // Add extra data to subtask if needed
                        if (fn && typeof fn === 'function') {
                            _subTask = fn(_subTask, type, device);
                        }
                        _result.push(_subTask);
                    });
                });
                return _result;
            };

            return {
                name: vm.taskTypes[taskType].name + _devicesCntMessage,
                description: taskDescription || '',
                params: {},
                companyName: $stateParams.companyName || null,
                projectId: $stateParams.projectId || null,
                subtasks: _subtasksFn(subtaskTypes, deviceList, params, extendSubtaskFn),
                type: taskType,
                waitForOnline: waitForOnline || false,
                workersNum: workersNum
            };
        };

        /**
         * 1. Create async task
         * 2. Check until task is finished
         * 3. Return promise
         * @param {String} taskType - task type from map vm.taskTypes
         * @param {Array} subtaskTypes - list of subtasks' types
         * @param {String} taskDescription - task description
         * @param {Array} deviceList - list of devices
         * @param {Object} params - task params
         * @param {Boolean} waitForOnline - should wait for device online
         * @param {Function} extendSubtaskFn - function to extend subtask object based on device object, type
         * @param {Number} workersNum - number of workers
         * @returns {Promise}
         */
        vm.createTaskAndWait = function (taskType, subtaskTypes, taskDescription, deviceList, params, waitForOnline, extendSubtaskFn, workersNum) {
            var _taskPayload = vm.createTaskPayload(taskType, subtaskTypes, taskDescription, deviceList, params, waitForOnline, extendSubtaskFn, workersNum);
            var _deferred = $q.defer();

            // Create task
            Service.api.asyncTaskWithSubtasks(_taskPayload).$promise
                // Wait 1 second when task started
                // Executor takes a task from the queue and start it once in 1 second
                .then(function (data) {
                    return $timeout(function () {
                        return data;
                    }, 1000);
                })
                .then(function (data) {
                    var _newTask = { id: data.taskId, status: 'NEW' };
                    vm.addTaskToWatched(_newTask); // Add task to watched list to track status

                    vm.refreshTaskList($stateParams.companyName, $stateParams.projectId);

                    // Save current watched task id and start polling status
                    vm.currentWatchedTaskId = data.taskId;
                    vm.checkTaskStatus(_deferred);
                })
                .catch(function (reason) {
                    console.log('asyncTaskWithSubtasks: ' + JSON.stringify(reason));
                    _deferred.reject(reason);
                });

            return _deferred.promise;
        };

        /**
         * 1. Create async task
         * 2. Return promise
         * @param {String} taskType - task type from map vm.taskTypes
         * @param {Array} subtaskTypes - list of subtasks' types
         * @param {String} taskDescription - task description
         * @param {Array} deviceList - list of devices
         * @param {Object} params - task params
         * @param {Boolean} waitForOnline - should wait for device online
         * @param {Function} extendSubtaskFn - function to extend subtask object based on device object, type
         * @param {Number} workersNum - number of workers
         * @returns {Promise}
         */
        vm.createTask = function (taskType, subtaskTypes, taskDescription, deviceList, params, waitForOnline, extendSubtaskFn, workersNum) {
            var _taskPayload = vm.createTaskPayload(taskType, subtaskTypes, taskDescription, deviceList, params, waitForOnline, extendSubtaskFn, workersNum);

            return Service.api.asyncTaskWithSubtasks(_taskPayload).$promise;
        };

        /**
         * Add task to watched list
         * @param {Object} task - Task object
         */
        vm.addTaskToWatched = function (task) {
            vm.watchTasks[task.id] = task;
        };

        /**
         * Cancel watching task
         * @returns {void}
         */
        vm.resetCurrentWatchedTask = function () {
            vm.currentWatchedTaskId = null;
        };

        /**
         * Polling task status. Wait until watched task is finished
         * @param {Object} deferred - deferred object
         * @returns {void}
         */
        vm.checkTaskStatus = function (deferred) {
            if (!vm.currentWatchedTaskId) {
                deferred.resolve();
                return;
            }

            // When task is finished (with success or error) resolve promise with task object
            if (vm.taskObject[vm.currentWatchedTaskId] && ['SUCCESS', 'ERROR'].indexOf(vm.taskObject[vm.currentWatchedTaskId].status) >= 0) {
                deferred.resolve(vm.taskObject[vm.currentWatchedTaskId]);
                return;
            }

            $timeout(function () {
                vm.checkTaskStatus(deferred);
                // console.log('Pulling task status...');
            }, _checkStatusDelay);
        };

        /**
          * Call type specific action
          * @param {Object} task - async task object
          * @returns {void}
         */
        vm.taskTypeAction = function (task) {
            switch (task.type) {
                case vm.taskTypes.TEMPLATE_APPLY.code:
                    $state.go('templateList', {
                        companyName: task.companyName,
                        projectId: task.projectId,
                    });
                    return;
                case vm.taskTypes.FIRMWARE_UPGRADE.code:
                case vm.taskTypes.FIRMWARE_UPGRADE_DOWNLOAD.code:
                case vm.taskTypes.FIRMWARE_UPGRADE_EXECUTE.code:
                    $state.go('firmwareJobs', {
                        companyName: task.companyName,
                        projectId: task.projectId,
                    });
                    return;
                case vm.taskTypes.MARKETPLACE_APPLICATION_LAUNCH.code:
                case vm.taskTypes.MARKETPLACE_APPLICATION_START.code:
                case vm.taskTypes.MARKETPLACE_APPLICATION_DELETE.code:
                case vm.taskTypes.MARKETPLACE_APPLICATION_UPGRADE.code:
                case vm.taskTypes.MARKETPLACE_SYNC.code:
                case vm.taskTypes.MARKETPLACE_APPLICATION_CACHE_REFRESH.code:
                    $state.go('edgeApplicationList', {
                        companyName: task.companyName,
                        projectId: task.projectId,
                    });
                    return;
                case vm.taskTypes.EDGE_BACKUP_CREATE.code:
                    $state.go('devices', {
                        companyName: task.companyName,
                        projectId: task.projectId,
                    });
                    return;
                case vm.taskTypes.LICENSE_APPLY.code:
                    $state.go('licenseManagement', {
                        companyName: task.companyName,
                        projectId: task.projectId,
                    });
                    return;
                case vm.taskTypes.ANALYTICS_ML_MODEL_UPLOAD.code:
                    $state.go('mlEdgeDeviceModels', {
                        companyName: task.companyName,
                        projectId: task.projectId,
                    });
                    return;
                case vm.taskTypes.EDGE_CERTIFICATE_RESET.code:
                    $state.go('certificatesList', {
                        companyName: task.companyName,
                        projectId: task.projectId,
                    });
                    return;
                case vm.taskTypes.EDGE_CERTIFICATE_RESET.code:
                case vm.taskTypes.EDGE_CERTIFICATE_ISSUE.code:
                    $state.go('certificatesList', {
                        companyName: task.companyName,
                        projectId: task.projectId,
                    });
                    return;
                case vm.taskTypes.DIGITAL_TWINS_MODEL_DEPLOY.code:
                    $state.go('dtModelList', {
                        companyName: task.companyName,
                    });
                    return;
                case vm.taskTypes.DIGITAL_TWINS_INSTANCES_UPGRADE.code:
                    $state.go('dtInstanceList', {
                        companyName: task.companyName,
                    });
                    return;
                case vm.taskTypes.ZT_FILE_GENERATE.code:
                    $state.go('ztConfigList', {
                        companyName: task.companyName,
                        projectId: task.projectId,
                    });
                    return;
                default:
                    return;
            }
        };

        /**
         * Reset all task lists
         */
        vm.resetTaskList = function () {
            vm.isReady = false;
            vm.taskList = [];
            vm.taskObject = {};
            vm.currentWatchedTaskId = null;
            vm.watchTasks = {};
        };

        /**
         * Open task list based on view scope
         * @returns {void}
         */
        vm.openTaskList = function () {
            var _stateName = null;
            switch ($stateParams.viewScope) {
                case 'project':
                    _stateName = 'asyncTaskList';
                    break;
                case 'company':
                    _stateName = 'asyncTaskListCompany';
                    break;
                case 'assets':
                    _stateName = 'asyncTaskListAssets';
                    break;
            }
            if (!_stateName) {
                console.log('Unknown view scope');
                return;
            }

            $state.go(_stateName, {
                companyName: $stateParams.companyName,
                projectId: $stateParams.projectId || null
            });
        };

        /**
         * Open task details
         * @param {Object} task - task object 
         */
        vm.openTaskDetails = function (taskId) {
            var _stateName = null;
            switch ($stateParams.viewScope) {
                case 'project':
                    _stateName = 'asyncTaskView';
                    break;
                case 'company':
                    _stateName = 'asyncTaskViewCompany';
                    break;
                case 'assets':
                    _stateName = 'asyncTaskViewAssets';
                    break;
            }
            if (!_stateName || !taskId) {
                console.log('Unknown view scope or task');
                return;
            }

            $state.go(_stateName, {
                companyName: $stateParams.companyName,
                projectId: $stateParams.projectId || null,
                taskId: taskId
            });
        };

        /**
         * Show task log
         * @param {Object} subtask - Subtask object
         */
        vm.openTaskLog = function (subtask) {
            var _stateName = null;
            switch ($stateParams.viewScope) {
                case 'project':
                    _stateName = 'asyncSubtaskLog';
                    break;
                case 'company':
                    _stateName = 'asyncSubtaskLogCompany';
                    break;
                case 'assets':
                    _stateName = 'asyncSubtaskLogAssets';
                    break;
            }
            if (!_stateName || !subtask) {
                console.log('Unknown view scope or subtask');
                return;
            }
            $state.go(_stateName, {
                companyName: $stateParams.companyName,
                projectId: $stateParams.projectId || null,
                taskId: subtask.taskId,
                subtaskId: subtask.id
            });
        };
    }]);
'use strict';
/**
 * @ngdoc service
 * @name loopUiApp.serviceFeatures
 * @description
 * # service
 * Feature service. Check feature status (on/off), experimental or stable
 */
angular.module('loopUiApp.serviceFeatures', ['ngResource'])
    /**
      * Check features provider.
      * Allow to start checking connection process
      */
    .provider('featuresCheck', [function () {
        var delay = 10000;  // Default check interval

        /**
         * Configure delay 
         * @param {number} milliseconds - delay in ms
         * @return {void}
         */
        this.setDelay = function (milliseconds) {
            delay = milliseconds;
        };

        this.$get = ['$interval', '$q', 'Service', function ($interval, $q, Service) {
            // Available features map
            var features = {};
            // Is it the first check. Allow to handle case then feature status is unknown yet
            var isFirstLoading = true;

            /**
             * Load list of experimental features
             * @return {void}
             */
            var getExperimentalFeatures = function() {
                var deferred = $q.defer();
                Service.api.experimentalFeatures().$promise
                .then(function(data) {
                    features = data.reduce(function(acc, cur) {
                        acc[cur.name] = cur.enabled === 1;
                        return acc;
                    }, {});
                    deferred.resolve(features);
                })
                .catch(function (reason) {
                    console.log('experimentalFeatures failure:' + JSON.stringify(reason));
                })
                .finally(function() {
                    isFirstLoading = false;
                });
                return deferred.promise;
            };

            return {
                /**
                 * Init check features list
                 * @returns {void}
                 */
                startCheck: function () {
                    // Immediate check call
                    getExperimentalFeatures();
                    $interval(function () {
                        getExperimentalFeatures();
                    }, delay);
                },
                loadExperimentalFeatures: getExperimentalFeatures,
                getExperimentalFeatures: function() {
                    return features;
                },
                setExperimentalFeatures: function(data) {
                    features = data;
                },
                isFeatureAvailable: function(name) {
                    return features && features[name];
                },
                isFirstLoading: function() {
                    return isFirstLoading;
                }
            };
        }];
    }]);

'use strict';
/**
 * @ngdoc service
 * @name loopUiApp.service
 * @description
 * # service
 * Service in the loopUiApp.
 */
angular.module('loopUiApp.serviceBillingAgent', ['ngResource'])
    /**
     * Billing agent check provider
     */
    .provider('billingAgentCheck', [function () {
        var delay = 60000;  // Default check interval
        var notificationKey = 'BILLING_AGENT.STATUS'; // Key for notification service
        var deploymentProvider = '';
        var providerMap = {
            'AZURE': 'Azure',
            'AWS': 'AWS'
        };

        /**
         * Configure delay
         * @param {number} milliseconds - delay in ms
         * @return {void}
         */
        this.setDelay = function (milliseconds) {
            delay = milliseconds;
        };

        this.$get = ['$interval', 'gettextCatalog', '$filter', 'appConfig', 'ServiceNotification', 'Service', 'Commons', function ($interval, gettextCatalog, $filter, appConfig, ServiceNotification, Service, Commons) {
            /**
             * Check if billing metrics available for the current deployment
             * @param {Object} deploymentInfo - deployment info object ({type: string, provider: string})
             * @returns {boolean}
             */
            var isBillingMetricsAvailable = function (deploymentInfo) {
                if (!deploymentInfo || !deploymentInfo.type || !deploymentInfo.provider) {
                    return false;
                }
                return deploymentInfo.type === 'VM_APP' && ['AZURE', 'AWS'].indexOf(deploymentInfo.provider) > -1;
            };

            /**
             * Show details dialog about billing warning
             * @param {Object} data - billing agent object {"status":"SUCCESS","lastReportSuccess":1739738400000,"unreportedTags":0}
             * @returns {void}
             */
            var showBillingAgentDetails = function (data) {
                var productName = appConfig.__env.productName || 'instance';
                var lastReportMessage = data.lastReportSuccess ? '<strong>' + $filter('humanInterval')(data.lastReportSuccess) + '</strong>' : 'a while';
                var tagsMessage = data.unreportedTags && data.unreportedTags > 0 ? 'The number of tags that weren\'t reported is <strong>' + data.unreportedTags + '</strong>.' : '';
                var providerName = providerMap[deploymentProvider] || deploymentProvider;
                var providerSpecificDetials = deploymentProvider === 'AWS' ? '<li>An IAM role with the required permissions is attached to the ' + productName + ' EC2 instance</li>' : '';
                Commons.showConfirmation(
                    gettextCatalog.getString(providerName + ' Marketplace Billing Service'),
                    gettextCatalog.getString('The latest successful report to the ' + providerName + ' Marketplace Billing Service<br> was ' + lastReportMessage + ' ago. ' +
                        tagsMessage + '<br><br>' +
                        'Please make sure that:<br>' +
                        '<ul><li>Firewall rules are configured properly</li>' +
                        '<li>The ' + productName + ' is configured properly and no services are disabled/removed</li>' +
                        providerSpecificDetials +
                        '</ul>' +
                        'Reach out to <a href="mailto:customers@litmus.io">customers@litmus.io</a> for any additional questions.'),
                    null,
                    null,
                    gettextCatalog.getString('Close'),
                    null,
                    null);
            };

            /**
             * Add warning about GCP Marketplace Billing Service 
             * @param {Object} data - billing agent object {"status":"SUCCESS","lastReportSuccess":1739738400000,"unreportedTags":0}
             * @returns {void}
             */
            var showWarning = function (data) {
                var providerName = providerMap[deploymentProvider] || deploymentProvider;

                ServiceNotification.addItem(notificationKey, {
                    time: Date.now(),
                    statusClass: 'warning',
                    text: 'The latest successful report to the ' + providerName + ' Marketplace Billing Service was a while ago.',
                    infoText: 'Details...',
                    infoHandler: function () {
                        showBillingAgentDetails(data);
                    },
                    hide: false
                });
            };

            /** 
             * Get billing agent info
             * @returns {void}
            */
            var getBillingAgentStatus = function () {
                Service.api.billingAgentStatus().$promise
                    .then(function (data) {
                        if (data.status === 'FAILED') {
                            showWarning(data);
                        } else {
                            ServiceNotification.deleteItem(notificationKey);
                        }
                    })
                    .catch(function (reason) {
                        showWarning(null);
                        console.log('Error billingAgentStatus:' + JSON.stringify(reason));
                    });
            };

            /**
             * Check deployment status and start checking billing agent
             * For: provider='AZURE', 'AWS' and type = 'VM_APP'
             * @returns {void}
             */
            var startCheck = function () {
                Service.api.deploymentInfo().$promise
                    .then(function (data) {
                        deploymentProvider = data.provider;
                        // Check instance info. For type = 'VM_APP' && provider === 'AZURE' and 'AWS' start checking billing agent
                        if (isBillingMetricsAvailable(data)) {
                            // Immediate check
                            getBillingAgentStatus();
                            $interval(function () {
                                getBillingAgentStatus();
                            }, delay);
                        }
                    })
                    .catch(function (reason) {
                        console.log('Error deploymentInfo:' + JSON.stringify(reason));
                    });
            };

            return {
                /**
                 * Init check billing agent
                 * @returns {void}
                 */
                startCheck: startCheck,
                isBillingMetricsAvailable: isBillingMetricsAvailable
            };
        }];
    }]);
'use strict';
/**
 * @ngdoc service
 * @name loopUiApp.serviceEdgePolling
 * @description
 * # service
 * Feature service. Check feature status (on/off), experimental or stable
 */
angular.module('loopUiApp.serviceEdgePolling', ['ngResource'])
    /**
      * Check features provider.
      * Allow to start checking connection process
      */
    .provider('edgePollingCheck', [function () {
        var delay = 60000;  // Default check interval
        var interval = null;
        var notificationKey = 'POLLING_SETTINGS';

        /**
         * Configure delay 
         * @param {number} milliseconds - delay in ms
         * @return {void}
         */
        this.setDelay = function (milliseconds) {
            delay = milliseconds;
        };

        this.$get = ['$interval', '$stateParams', '$mdDialog', 'Service', 'ServiceNotification', function ($interval, $stateParams, $mdDialog, Service, ServiceNotification) {
            /**
             * Show information message
             */
            var showInfo = function () {
                $mdDialog.show({
                    template: '<md-dialog style="width:600px;" aria-label="Info"><edge-polling-info-dialog></edge-polling-info-dialog></md-dialog>',
                    parent: angular.element(document.body),
                    clickOutsideToClose: false,
                    preserveScope: true,
                    skipHide: true
                });
            };

            var runPolling = function () {
                $mdDialog.show({
                    template: '<md-dialog style="width:500px;" aria-label="Run">' +
                        '<edge-polling-run-dialog></edge-polling-run-dialog>' +
                        '</md-dialog>',
                    parent: angular.element(document.body),
                    clickOutsideToClose: false,
                    preserveScope: true,
                    skipHide: true
                });
            };

            /**
             * Show warning notification
             * @return {void}
             */
            var addWarning = function () {
                ServiceNotification.addItem(notificationKey, {
                    time: Date.now(),
                    icon: '',
                    statusClass: 'warning',
                    text: 'Edge device metrics sync is disabled at the project level. This may result in outdated information being displayed.',
                    infoText: 'View Details...',
                    infoHandler: function () {
                        showInfo();
                    },
                    hide: false
                });
            };

            /**
             * Get polling settings for the project
             * @param {string} projectId - project id
             * @return {void}
             */
            var getEdgePollingSettings = function (projectId) {
                var _projectId = projectId || $stateParams.projectId;
                Service.api.projectEdgePollingSettingsGet({
                    actionExt: _projectId
                }).$promise
                    .then(function (data) {
                        if (data && data.enabled === false) {
                            addWarning();
                        } else {
                            ServiceNotification.deleteItem(notificationKey);
                        }
                    })
                    .catch(function (reason) {
                        console.log('Error projectEdgePollingSettingsGet:' + JSON.stringify(reason));
                    });
            };

            return {
                /**
                 * Init poll settings check
                 * @returns {void}
                 */
                startCheck: function (projectId) {
                    // Immediate check call
                    getEdgePollingSettings(projectId);
                    interval = $interval(function () {
                        getEdgePollingSettings(projectId);
                    }, delay);
                },
                /**
                 * Stop check
                 * @returns {void}
                 */
                stopCheck: function () {
                    // Remove notification when project polling is stopped
                    ServiceNotification.deleteItem(notificationKey);
                    if (interval) {
                        $interval.cancel(interval);
                    }
                },
                /**
                 * Show info dialog about polling
                 */
                showInfo: showInfo,
                /**
                 * Run polling manually
                 */
                runPolling: runPolling,
                /**
                 * Run refresh polling settings manually
                 */
                getEdgePollingSettings: getEdgePollingSettings
            };
        }];
    }]);

'use strict';
/**
 * @ngdoc Notification service
 * @name loopUiApp
 * @description
 * # Notification service
 * Service in the loopUiApp.
 * Notification object description:
 * 
    interface NotificationSet {
        key: NotificationObject;   - map of NotificationObject. Key of 
    }

    interface NotificationObject {
        icon?: string;            - notification bar icon. Default value: 'warning'
        time: number;             - notification created time. Timestamp
        text: string;             - notification bar text
        status: string;           - status. Enum: ['warning', 'critical']
        infoText: string;         - additional info text. Default value: 'Details...'
        infoHandler: function;    - additional info handler. Invoke on user click info
        hide: boolean;            - show/hide flag. User can hide notification
    }

    Example:
    notificationMap = {
        'LICENSE.DATA': {
            icon: 'pan_tool',
            time: Date.now(),
            text: 'Too many data',
            statusClass: 'critical',
            infoText: 'Details...',
            infoHandler: function () {
                console.log('LICENSE.DATA');
            },
            hide: false
        }
    }
 */
angular.module('loopUiApp')
    .service('ServiceNotification', function () {
        var vm = this;

        vm.notificationMap = {};

        

        /**
         * Hide object from list
         * @param {String} key - notification key
         * @returns {void}
         */
        vm.hideItem = function (key) {
            if (!vm.notificationMap[key]) {
                return;
            }
            vm.notificationMap[key].hide = true;
        };

        /**
         * Add new item to the notification list
         * @param {String} key - notification key
         */
        vm.addItem = function (key, notification) {
            if (vm.notificationMap[key]) {
                // Do not replace notification time and hide flag
                vm.notificationMap[key].text = notification.text;
                vm.notificationMap[key].icon = notification.icon;
                vm.notificationMap[key].statusClass = notification.statusClass;
                return;
            }
            vm.notificationMap[key] = notification;
        };

        /**
         * Remove notification item from list
         * @param {String} key - notification key
         */
        vm.deleteItem = function (key) {
            if (!vm.notificationMap[key]) {
                return;
            }
            delete vm.notificationMap[key];
        };
    });
'use strict';

angular.module('loopUiApp')
    .service('ServiceZenDesk', function () {
        var vm = this;
        // Name of Zendesk object in `window`
        var zenDeskObjectName = 'zE';
        // Version of Zendesk widget
        var zenDeskVersion = {};
        // Delay to open/hide chat
        var _toggleDelayMs = 200;
        // Interval to check if window['zE'] is loaded
        var _checkFeatureInterval = 300;
        // Max number of attempts to check if window['zE'] is loaded
        var _maxLoadAttempts = 400;
        // Number of attempts to check if window['zE'] is loaded
        var _loadAttempts = 0;
        // Number of unread messages
        vm.zenDeskMessagesCount = 0;
        // Is chat opened
        vm.isOpened = false;
        // In initialized and ready to show
        vm.zenDeskActive = false;

        /**
         * Detects the version of the Zendesk widget. Service supports two versions:
         * 1. Core messaging (newer version)
         * 2. Classic widget (older version)
         */
        vm.detectZendeskWidgetVersion = function () {
            try {
                // Try Core messaging specific method
                zE('messenger:on', 'open', function () { });
                console.log('Zendesk: Detected Core messaging Web Widget API');
                return { version: 'core', messengerName: 'messenger', unreadMessageEvent: 'unreadMessages' };
            } catch (e) { }

            try {
                // Try Classic widget specific method
                zE('webWidget:on', 'open', function () { });
                console.log('Zendesk: Detected Web Widget (Classic)');
                return { version: 'classic', messengerName: 'webWidget', unreadMessageEvent: 'chat:unreadMessages' };
            } catch (err) {
                console.error('Zendesk: Could not determine Zendesk widget version', err);
                return { version: null, messengerName: null, unreadMessageEvent: null };
            }
        };

        /**
         * Init Zendesk instance:
         * 1. Hide standard icon 
         * 2. Subscribe on events (onOpen, onClose, onUnreadMessage) 
         */
        vm.setup = function () {
            // Init Zendesk widget version object
            zenDeskVersion = this.detectZendeskWidgetVersion();
            if (!zenDeskVersion || !zenDeskVersion.messengerName) {
                console.error('Zendesk: Widget version is not detected');
                return;
            }

            vm.zenDeskActive = true;
            zE(zenDeskVersion.messengerName, 'close');
            zE(zenDeskVersion.messengerName, 'hide');

            zE(zenDeskVersion.messengerName + ':on', 'open', function () {
                setTimeout(function () {
                    zE(zenDeskVersion.messengerName, 'show');
                    vm.isOpened = true;
                }, _toggleDelayMs);
            });
            zE(zenDeskVersion.messengerName + ':on', 'close', function () {
                setTimeout(function () {
                    zE(zenDeskVersion.messengerName, 'hide');
                    vm.isOpened = false;
                }, _toggleDelayMs);
            });
            zE(zenDeskVersion.messengerName + ':on', zenDeskVersion.unreadMessageEvent, function (count) {
                vm.zenDeskMessagesCount = count;
            });
        };

        /**
         * Show/hide dialog
         * @returns {void}
         */
        vm.openZenDesk = function () {
            if (!zenDeskVersion || !zenDeskVersion.messengerName) {
                console.error('Zendesk: Widget version is not detected');
                return;
            }
            zE(zenDeskVersion.messengerName, 'open');
        };

        /**
         * Wait until window['zE'] is loaded
         */
        vm.delayedInitialization = function () {
            // Check number of attempts limit
            if (_loadAttempts > _maxLoadAttempts) {
                return;
            }
            if (!window[zenDeskObjectName]) {
                window.setTimeout(function () {
                    vm.delayedInitialization();
                }, _checkFeatureInterval);
                _loadAttempts++;
            } else {
                // Init Zendesk
                vm.setup();
            }
        };
    });
'use strict';
/**
 * @ngdoc service
 * @name loopUiApp.intercepter
 * @description
 * # service
 * AuthInterceptor in the loopUiApp.
 */
angular.module('loopUiApp.interceptor', [])
    .factory('AuthInterceptor', function ($q, Auth, SessionExpired, Connectivity) {
        /**
         * Check is refresh token exists and not expired
         * @returns {Boolean} is refresh token valid
         */
        var isRefreshTokenValid = function () {
            return Auth && Auth.refreshTokenParsed && Auth.refreshTokenParsed.exp > Date.now() / 1000;
        };

        return {
            request: function (config) {
                //Do not intercept templates
                //https://github.com/angular/angular.js/issues/10257
                if (config._isTemplate || config.ignoreAuth) {
                    return config;
                }
                var deferred = $q.defer();
                if (Auth.token) {
                    Auth.updateToken(5)
                        .then(function () {
                            config.headers = config.headers || {};
                            config.headers.Authorization = 'Bearer ' + Auth.token;
                            deferred.resolve(config);
                        })
                        .catch(function () {
                            //failed to update token
                            deferred.reject('Failed to refresh token');
                        });
                }
                return deferred.promise;
            },
            responseError: function (response) {
                if (response.status) {
                    console.log(response.status);
                }
                if (response.data && response.data.errorMessage) {
                    console.log(response.data.errorMessage);
                }
                else if (response === 'Failed to refresh token') {
                    console.log(response);
                    //Show expired window only if refresh token invalid
                    // or not able to refresh for some over unexpected reason (connection is ok, but token not refreshing)
                    if (!isRefreshTokenValid() || isRefreshTokenValid() && !Connectivity.getConnectionWarning()) {
                        SessionExpired.showDialog();
                    }
                }
                return $q.reject(response);
            }
        };
    });
'use strict';
/**
 * @ngdoc intercepter
 * @name templateCacheInterceptor
 * @description
 * Add uniq value to load template. This helps to invalidate template cache between builds
 */
angular.module('loopUiApp.interceptor')
    .factory('templateCacheInterceptor', function (appConfig) {
        return {
            request: function (config) {
                if (config._isTemplate && appConfig.__env.uuid &&
                    config.url && config.url.indexOf('../scripts/components/') >= 0) {
                    // For templates html files add uniq value - git commit of the bundle
                    config.url = config.url + '?h=' + appConfig.__env.uuid;
                }
                return config;
            }
        };
    });
'use strict';

/**
 * @ngdoc Transform
 * @name loopUiApp
 * @description
 * # Transform
 * Service in the loopUiApp.
 */
angular.module('loopUiApp')
    .factory('Transform', function () {
        var factory = {};

        /**
         * Transform data API response to NVD3 chart format 
         * @param {Array} response
         * @returns
         */
        factory.transformMessageChartData = function (response) {
            var data = [], tmp = {}, result = [];
            if (response) {
                try {
                    data = angular.fromJson(response);
                } 
                catch (e){
                    console.log('Wrong data for message data chart');
                    return;
                }
            }
            var first = data[0];
            for (var key in first) {
                if (key !== 'timestamp') {
                    tmp[key] = [];
                }
            }
            for (var i = 0; i < data.length; i++) {
                for (var k in data[i]) {
                    if (k !== 'timestamp') {
                        tmp[k].push([data[i].timestamp, data[i][k]]);
                    }
                }
            }
            for (var j in tmp) {
                result.push({ key: j, values: tmp[j] });
            }
            return result;
        };

        /**
         * Transform data API response for usage data to NVD3 chart format 
         * @param {Sting} response
         * @returns
         */
        factory.transformUsageData = function (response) {
            var data = [], result = {};
            if (response) {
                try {
                    data = angular.fromJson(response);
                } 
                catch (e){
                    console.log('Wrong data for usage data chart');
                    return;
                }
            }
            for (var i = 0 ; i < data.length; i++){
                if(!result[data[i].entClass]){
                    result[data[i].entClass] = {used: 0, limit: 0, type: []};
                }
                result[data[i].entClass].used += data[i].used;
                result[data[i].entClass].limit += data[i].limit;
                result[data[i].entClass].type.push({
                    key: data[i].entName,
                    y: data[i].used
                });

            }
            return result;
        };

        return factory;

    });
'use strict';

/**
 * @ngdoc component
 * @name loopUiApp.component:dashboard
 * @description
 * # dashboard
 */
angular.module('loopUiApp')
    .component('dashboard', {
        templateUrl: '../scripts/components/dashboard/dashboard.html',
        controller: function ($state, $interval, $stateParams, Service, billingAgentCheck) {
            var vm = this;
            // Current project and company name
            vm.companyName = $stateParams.companyName;
            vm.projectId = $stateParams.projectId;
            // Map of devices. Used to get device friendly name by device id
            vm.deviceObject = {};
            vm.metricsData = [];
            // Init metrics chart
            vm.isFirstLoadMetrics = true;
            // Show or not billable metrics [EM-4528]
            vm.isBillableMetricsAvailable = false;

            // System time variables
            vm.currentTime = null;
            vm.uptimeMs = null;

            // Alert list settings
            vm.alertQuery = {
                limit: 25,
                order: '-timestamp'
            };

            // Initial state
            vm.emUsage = {
                bytesByPeriod: 0,
                bytesTotal: 0,
                devicesOnline: 0,
                devicesTotal: 0,
                incidentsByPeriod: 0,
                incidentsTotal: 0,
                messagesByPeriod: 0,
                messagesTotal: 0
            };

            vm.$onInit = function () {
                // Get instance deployment info (VM | k8s | Azure APP)
                vm.getInstanceDeploymentInfo();

                // Refresh device list
                vm.refreshDeviceList();

                // Get dashboard object
                vm.refreshDashboardGfm();

                // Refresh current edge metrics
                vm.refreshMetrics();

                //Refresh Usage data
                vm.refreshUsage();

                // Refresh Alerts data
                vm.refreshAlerts();

                // Refresh system time
                vm.refreshSystemTime();

                //Auto update messages limits, status data, alerts, system time
                vm.refreshDataInterval = $interval(function () {
                    vm.refreshDashboardGfm();
                    vm.refreshMetrics();
                    vm.refreshUsage();
                    vm.refreshAlerts();
                    vm.refreshSystemTime();
                }, 5000);

                vm.refreshDevicesInterval = $interval(function () {
                    vm.refreshDeviceList();
                }, 60000);
            };

            vm.$onDestroy = function () {
                //Stop update after route change
                $interval.cancel(vm.refreshDataInterval);
                $interval.cancel(vm.refreshDevicesInterval);
                $interval.cancel(vm.refreshTagConsumptionInterval);
            };

            /**
             * Function to initialize tag
             */
            vm.initTagConsumptionPulling = function () {
                // Refresh tag consumption data
                vm.refreshTagConsumption();
                vm.refreshTagConsumptionSummary();

                vm.refreshTagConsumptionInterval = $interval(function () {
                    vm.refreshTagConsumptionSummary();
                    vm.refreshTagConsumption();
                }, 60000);
            };

            /**
             * Get current instance type and provider
             * It's used to find out if billable tag metrics available or not
             */
            vm.getInstanceDeploymentInfo = function () {
                Service.api.deploymentInfo().$promise
                    .then(function (data) {
                        // Check instance info. For type in ['VM_APP'] && provider === 'AZURE' and 'AWS' we can show billable metrics [EM-4528]
                        vm.isBillableMetricsAvailable = billingAgentCheck.isBillingMetricsAvailable(data);
                        if (vm.isBillableMetricsAvailable === true) {
                            vm.initTagConsumptionPulling();
                        }
                    })
                    .catch(function (reason) {
                        console.log('Error deploymentInfo:' + JSON.stringify(reason));
                    });
            };

            /**
             * Return usage resource object
             * @return {void}
             */
            vm.refreshUsage = function () {
                Service.api.dashboardEMUsage({
                    actionExt: vm.projectId
                }).$promise
                    .then(function (data) {
                        vm.emUsage = data;
                    })
                    .catch(function (reason) {
                        console.log('refreshUsage failed' + JSON.stringify(reason));
                    });
            };

            /**
             * Get dashboard GFM metrics
             * @returns {void}
             */
            vm.refreshDashboardGfm = function () {
                Service.api.dashboardGfm({ projectId: vm.projectId, timeshiftMinutes: vm.MAX_TIMESHIFT_MINUTES }).$promise
                    .then(function (data) {
                        vm.dashboardData = data;
                    })
                    .catch(function (reason) {
                        console.log('Error dashboardGfm:' + JSON.stringify(reason));
                    });
            };

            /**
             * Get summary tag consumption metrics
             * @returns {void}
             */
            vm.refreshTagConsumptionSummary = function () {
                Service.api.dashboardGfmBillingTagsSummary({
                    projectId: vm.projectId
                }).$promise
                    .then(function (data) {
                        vm.tagConsumptionDataSummary = data;
                    })
                    .catch(function (reason) {
                        console.log('Error dashboardTagConsumption:' + JSON.stringify(reason));
                    });
            };

            /**
             * Get tag consumption metrics by Edge device
             */
            vm.refreshTagConsumption = function () {
                Service.api.dashboardGfmBillingTags({
                    projectId: vm.projectId,
                    limit: 10
                }).$promise
                    .then(function (data) {
                        vm.tagConsumptionData = data;
                    })
                    .catch(function (reason) {
                        console.log('Error dashboardTagConsumption:' + JSON.stringify(reason));
                    });
            };

            /**
             * View tag consumption details
             * @returns {void}
             */
            vm.viewConsumptionDetails = function () {
                $state.go('tagConsumptionDetails', {
                    companyName: vm.companyName,
                    projectId: vm.projectId
                });
            };

            /**
             * Get metrics and fill chart data arrays
             * @returns {void}
             */
            vm.refreshMetrics = function () {
                Service.api.metricsGet({ actionExt: vm.projectId }, []).$promise
                    .then(function (data) {
                        vm.metricsData = data && data.length > 0 ? data : [];
                    })
                    .catch(function (reason) {
                        console.log('Error metricsGet:' + JSON.stringify(reason));
                    })
                    .finally(function () {
                        vm.isFirstLoadMetrics = false;
                    });
            };

            /**
             * Create device list object in order to get device 
             * details by device id
             * @return {void}
             */
            vm.refreshDeviceList = function () {
                Service.api.deviceList({
                    action: vm.projectId,
                    limit: 1000 // TODO: Get rid of magic number
                }).$promise
                    .then(function (data) {
                        vm.deviceObject = data.elements.reduce(function (acc, cur) {
                            acc[cur.deviceId] = {
                                prettyName: cur.prettyName,
                                hostname: cur.hostname,
                                deviceId: cur.deviceId
                            };
                            return acc;
                        }, {});
                    });
            };

            /**
             * Return alerts resource object
             * @return {void}
             */
            vm.refreshAlerts = function () {
                Service.api.dashboardAlerts({
                    projectId: vm.projectId
                }).$promise
                    .then(function (data) {
                        vm.alertList = data;
                    })
                    .catch(function (reason) {
                        console.log('refreshAlerts failed' + JSON.stringify(reason));
                    });
            };

            /**
             * Alerts service status
             * @param {String} status - service status name
             * @return {Object} - status object
             */
            vm.alertStatusDesc = function (status) {
                switch (status) {
                    case 'OK':
                        return { color: '#3adb90', icon: 'check_circle', desc: 'OK' };
                    case 'PROBLEM':
                        return { color: 'red', icon: 'error_outline', desc: 'OFF' };
                    default:
                        return { color: '', icon: 'warning', desc: 'UNKNOWN' };
                }
            };

            /**
             * Open device page
             * @param {String} deviceId - device object
             * @return {void}
             */
            vm.openDeviceDetails = function (deviceId) {
                $state.go('deviceView', {
                    companyName: vm.companyName,
                    projectId: vm.projectId,
                    deviceId: deviceId,
                });
            };

            /**
             * Refresh system time
             */
            vm.refreshSystemTime = function () {
                Service.api.systemTime().$promise
                    .then(function (data) {
                        vm.currentTime = data.time;
                        vm.uptimeMs = data.uptimeMs;
                    })
                    .catch(function (reason) {
                        console.log('refreshSystemTime failed' + JSON.stringify(reason));
                    });
            };
        }
    });

'use strict';

/**
 * @ngdoc component
 * @name loopUiApp.component:deviceMetricCharts
 * @description
 * # deviceMetricCharts
 */
angular.module('loopUiApp')
    .component('deviceMetricCharts', {
        templateUrl: '../scripts/components/dashboard/deviceMetricCharts/deviceMetricCharts.html',
        bindings: {
            dashboardData: '<',
            metricsData: '<',
            deviceObject: '<',
        },
        controller: function ($stateParams, $state, $filter, ServiceChart) {
            var vm = this;
            // Handle order of devices based of different metrics
            vm.deviceOrderObject = {};
            // Maximum number of chart elements
            vm.MAX_CHART_ITEMS = 10;

            // CC Traffic chart data
            vm.ccTrafficData = [];

            // CC pending messages chart data
            vm.ccPendingData = [];

            // Failed tags rate range
            vm.tagsFailedRateRangeData = [];

            // Processed tags rate range
            vm.tagsProcessedRateRangeData = [];

            // CPU chart
            vm.cpuData = [{
                key: 'CPU User',
                values: []
            },
            {
                key: 'CPU System',
                values: []
            }];
            vm.cpuMap = {};

            // Memory Chart
            vm.memoryData = [{
                key: 'Memory',
                values: []
            }];

            // Network Chart
            vm.networkData = [{
                key: 'Network TX',
                values: []
            },
            {
                key: 'Network RX',
                values: []
            }];

            // Storage Data
            vm.storageData = [{
                key: 'Storage Used',
                values: []
            },
            {
                key: 'Storage Available',
                values: []
            }];

            // Map to store legend states (enabled/disabled)
            vm.legendStates = {};

            vm.ccTrafficChartSettings = angular.copy(ServiceChart.lineChart);
            vm.ccPendingChartSettings = angular.copy(ServiceChart.lineChart);
            vm.tagsFailedRateChartSettings = angular.copy(ServiceChart.lineChart);
            vm.tagsProcessedRateChartSettings = angular.copy(ServiceChart.lineChart);
            vm.cpuChartSettings = angular.copy(ServiceChart.multiBarChart);
            vm.memoryChartSettings = angular.copy(ServiceChart.multiBarChart);
            vm.networkChartSettings = angular.copy(ServiceChart.multiBarChart);
            vm.storageChartSettings = angular.copy(ServiceChart.multiBarChart);

            vm.$onInit = function () {
                /**
                 * X axis tick formatter
                 * @param {String} value - label value
                 * @returns 
                 */
                var xAxisTickFormater = function (value, type) {
                    return vm.deviceOrderObject[value] && vm.deviceOrderObject[value][type] ? vm.deviceOrderObject[value][type].order : value;
                };

                /**
                 * Header formatter for tooltip
                 * @param {String} value - label value
                 * @returns 
                 */
                var headerFormatter = function (value) { 
                    return (vm.deviceObject && vm.deviceObject[value] ? 
                    (vm.deviceObject[value].prettyName || vm.deviceObject[value].hostname || vm.deviceObject.deviceId )
                    : value); 
                };

                /**
                 * Handle double click on bar chart
                 * @param {String} value - label value
                 * @returns 
                 */
                var handleDblClick = function (deviceId) {
                    if (deviceId) {
                        $state.go('deviceView', {
                            companyName: $stateParams.companyName,
                            projectId: $stateParams.projectId,
                            deviceId: deviceId,
                        });
                    }
                };

                vm.ccTrafficChartSettings.title.text = 'Integration. Traffic (msg/sec)';
                vm.ccTrafficChartSettings.chart.showTotalInTooltip = false;
                vm.ccTrafficChartSettings.chart.x = function (d) { return d.timestamp; };
                vm.ccTrafficChartSettings.chart.y = function (d) { return d.count; };
                vm.ccTrafficChartSettings.chart.yAxis.tickFormat = function (d) {
                    return d < 0 ? d.toFixed(0) : $filter('counters')(d, 1);
                };
                vm.ccTrafficChartSettings.chart.yAxis.width = 60;
                vm.ccTrafficChartSettings.chart.xAxis.height = 30;
                vm.ccTrafficChartSettings.chart.xAxis.tickFormat = function (d) {
                    return d3.time.format('%H:%M')(new Date(d * 1000));
                };
                vm.ccTrafficChartSettings.chart.interactiveLayer.tooltip.keyFormatter = headerFormatter;
                vm.ccTrafficChartSettings.chart.interactiveLayer.tooltip.headerEnabled = false;
                vm.ccTrafficChartSettings.chart.legend = {
                    key: function (d) {
                        return d.name;
                    },
                    dispatch: {
                        legendDblclick: function (data) { handleDblClick(data.key); },
                        legendClick: function (d) { vm.legendStates.ccTrafficChart[d.key] = !d.disabled; }
                    },
                    maxKeyLength: 14,
                    rightAlign: false
                };

                vm.ccPendingChartSettings.title.text = 'Integration. Buffer size';
                vm.ccPendingChartSettings.chart.showTotalInTooltip = false;
                vm.ccPendingChartSettings.chart.x = function (d) { return d.timestamp; };
                vm.ccPendingChartSettings.chart.y = function (d) { return d.size; };
                vm.ccPendingChartSettings.chart.yAxis.width = 55;
                vm.ccPendingChartSettings.chart.xAxis.height = 30;
                vm.ccPendingChartSettings.chart.yAxis.tickFormat = function (d) {
                    // Do not convert negative values to bytes
                    return d < 0 ? d.toFixed(1) : $filter('bytes')(d);
                };
                vm.ccPendingChartSettings.chart.xAxis.tickFormat = function (d) {
                    return d3.time.format('%H:%M')(new Date(d * 1000));
                };
                vm.ccPendingChartSettings.chart.interactiveLayer.tooltip.keyFormatter = headerFormatter;
                vm.ccPendingChartSettings.chart.interactiveLayer.tooltip.headerEnabled = false;
                vm.ccPendingChartSettings.chart.legend = {
                    key: function (d) {
                        return d.name;
                    },
                    dispatch: {
                        legendDblclick: function (data) { handleDblClick(data.key); },
                        legendClick: function (d) { vm.legendStates.ccPendingChart[d.key] = !d.disabled; }
                    },
                    maxKeyLength: 14,
                    rightAlign: false
                };

                vm.tagsProcessedRateChartSettings.title.text = 'Processed tags rate (tags/minute)';
                vm.tagsProcessedRateChartSettings.chart.showTotalInTooltip = false;
                vm.tagsProcessedRateChartSettings.chart.x = function (d) { return d.timestamp; };
                vm.tagsProcessedRateChartSettings.chart.y = function (d) { return d.rate; };
                vm.tagsProcessedRateChartSettings.chart.yAxis.tickFormat = function (d) {
                    return d < 0 ? d.toFixed(0) : $filter('counters')(d, 1);
                };
                vm.tagsProcessedRateChartSettings.chart.yAxis.width = 60;
                vm.tagsProcessedRateChartSettings.chart.xAxis.height = 30;
                vm.tagsProcessedRateChartSettings.chart.xAxis.tickFormat = function (d) {
                    return d3.time.format('%H:%M')(new Date(d * 1000));
                };
                vm.tagsProcessedRateChartSettings.chart.interactiveLayer.tooltip.keyFormatter = headerFormatter;
                vm.tagsProcessedRateChartSettings.chart.interactiveLayer.tooltip.headerEnabled = false;
                vm.tagsProcessedRateChartSettings.chart.legend = {
                    key: function (d) {
                        return d.name;
                    },
                    dispatch: {
                        legendDblclick: function (data) { handleDblClick(data.key); },
                        legendClick: function (d) { vm.legendStates.tagsProcessedRateChart[d.key] = !d.disabled; }
                    },
                    maxKeyLength: 14,
                    rightAlign: false
                };
                vm.tagsProcessedRateChartSettings.chart.forceY = [0, 1];

                vm.tagsFailedRateChartSettings.title.text = 'Failed tags rate (tags/minute)';
                vm.tagsFailedRateChartSettings.chart.showTotalInTooltip = false;
                vm.tagsFailedRateChartSettings.chart.x = function (d) { return d.timestamp; };
                vm.tagsFailedRateChartSettings.chart.y = function (d) { return d.rate; };
                vm.tagsFailedRateChartSettings.chart.yAxis.tickFormat = function (d) {
                    return d < 0 ? d.toFixed(0) : $filter('counters')(d, 1);
                };
                vm.tagsFailedRateChartSettings.chart.yAxis.width = 60;
                vm.tagsFailedRateChartSettings.chart.xAxis.height = 30;
                vm.tagsFailedRateChartSettings.chart.xAxis.tickFormat = function (d) {
                    return d3.time.format('%H:%M')(new Date(d * 1000));
                };
                vm.tagsFailedRateChartSettings.chart.interactiveLayer.tooltip.keyFormatter = headerFormatter;
                vm.tagsFailedRateChartSettings.chart.interactiveLayer.tooltip.headerEnabled = false;
                vm.tagsFailedRateChartSettings.chart.legend = {
                    key: function (d) {
                        return d.name;
                    },
                    dispatch: {
                        legendDblclick: function (data) { handleDblClick(data.key); },
                        legendClick: function (d) { vm.legendStates.tagsFailedRateChart[d.key] = !d.disabled; }
                    },
                    maxKeyLength: 14,
                    rightAlign: false
                };
                vm.tagsFailedRateChartSettings.chart.forceY = [0, 1];

                vm.cpuChartSettings.title.text = 'Edge Devices CPU Utilization';
                vm.cpuChartSettings.chart.yAxis.tickFormat = function (d) { return d + '%'; };
                vm.cpuChartSettings.chart.xAxis.tickFormat = function (d) { return xAxisTickFormater(d, 'cpu'); };
                vm.cpuChartSettings.chart.tooltip.valueFormatter = function (d) { return Math.round(d) + '%'; };
                vm.cpuChartSettings.chart.tooltip.headerFormatter = headerFormatter;
                vm.cpuChartSettings.chart.multibar.dispatch.elementDblClick = function (data) { handleDblClick(data.data.label); };
                vm.cpuChartSettings.chart.legend.rightAlign = false;

                vm.memoryChartSettings.title.text = 'Edge Devices Memory Used';
                vm.memoryChartSettings.chart.yAxis.tickFormat = function (d) { return d + '%'; };
                vm.memoryChartSettings.chart.xAxis.tickFormat = function (d) { return xAxisTickFormater(d, 'memory'); };
                vm.memoryChartSettings.chart.tooltip.valueFormatter = function (d) { return Math.round(d) + '%'; };
                vm.memoryChartSettings.chart.tooltip.headerFormatter = headerFormatter;
                vm.memoryChartSettings.chart.multibar.dispatch.elementDblClick = function (data) { handleDblClick(data.data.label); };
                vm.memoryChartSettings.chart.legend.rightAlign = false;

                vm.networkChartSettings.title.text = 'Edge Devices Network Load';
                vm.networkChartSettings.chart.yAxis.tickFormat = function (d) { return $filter('bytes')(d, undefined, undefined, undefined, '/s'); };
                vm.networkChartSettings.chart.xAxis.tickFormat = function (d) { return xAxisTickFormater(d, 'network'); };
                vm.networkChartSettings.chart.tooltip.valueFormatter = function (d) { return $filter('bytes')(d, undefined, undefined, undefined, '/s'); };
                vm.networkChartSettings.chart.tooltip.headerFormatter = headerFormatter;
                vm.networkChartSettings.chart.multibar.dispatch.elementDblClick = function (data) { handleDblClick(data.data.label); };
                vm.networkChartSettings.chart.legend.rightAlign = false;

                vm.storageChartSettings.title.text = 'Edge Devices Storage';
                vm.storageChartSettings.chart.yAxis.tickFormat = function (d) { return $filter('bytes')(d); };
                vm.storageChartSettings.chart.xAxis.tickFormat = function (d) { return xAxisTickFormater(d, 'storage'); };
                vm.storageChartSettings.chart.tooltip.valueFormatter = function (d) { return $filter('bytes')(d); };
                vm.storageChartSettings.chart.tooltip.headerFormatter = headerFormatter;
                vm.storageChartSettings.chart.multibar.dispatch.elementDblClick = function (data) { handleDblClick(data.data.label); };
                vm.storageChartSettings.chart.legend.rightAlign = false;
            };

            /**
             * Handle input data changes
             * @param {Object} changes - input changes object
             */
            vm.$onChanges = function (changes) {
                // Handle dashboardData changes
                if (changes.dashboardData && changes.dashboardData.currentValue) {
                    // Set forceY for charts based on max values. If max value is 0, set forceY to [0, 10] to avoid chart go below 0
                    if (vm.ccTrafficChartSettings) {
                        var _ccRateSecMax = vm.dashboardData.ccRateSecMax > 0 ? vm.dashboardData.ccRateSecMax * 1.05 : 10;
                        vm.ccTrafficChartSettings.chart.forceY = [0, _ccRateSecMax];
                    }
                    if (vm.ccPendingChartSettings) {
                        var _ccBufferSizeBytesMax = vm.dashboardData.ccBufferSizeBytesMax > 0 ? vm.dashboardData.ccBufferSizeBytesMax * 1.05 : 10;
                        vm.ccPendingChartSettings.chart.forceY = [0, _ccBufferSizeBytesMax];
                    }

                    vm.ccTrafficData = vm.convertDataToChart(vm.dashboardData.ccRateSec, 'ccTrafficChart');
                    vm.ccPendingData = vm.convertDataToChart(vm.dashboardData.ccBufferSizeBytes, 'ccPendingChart');
                    vm.tagsFailedRateRangeData = vm.convertDataToChart(vm.dashboardData.tagsFailedRateRange, 'tagsFailedRateChart');
                    vm.tagsProcessedRateRangeData = vm.convertDataToChart(vm.dashboardData.tagsProcessedRateRange, 'tagsProcessedRateChart');
                }
                // Handle metricsData changes
                if (changes.metricsData && changes.metricsData.currentValue) {
                    vm.prepareCpuMetrics(vm.metricsData);
                    vm.prepareMemoryMetrics(vm.metricsData);
                    vm.prepareNetworkMetrics(vm.metricsData);
                    vm.prepareStorageMetrics(vm.metricsData);
                }
            };

            /**
             * Prepare pending metrics to chart data
             * @param {Array} inputArray - array from metrics
             * @param {String} chartId - chart identifier 
             * @returns 
             */
            vm.convertDataToChart = function (inputArray, chartId) {
                if (!inputArray || !angular.isObject(inputArray)) {
                    return [];
                }

                vm.legendStates[chartId] = vm.legendStates[chartId] || {};

                return Object.keys(inputArray).map(function (deviceId, index) {
                    return {
                        key: deviceId,
                        values: inputArray[deviceId],
                        name: 'Edge Device ' + (index + 1),
                        disabled: vm.legendStates[chartId][deviceId] || false
                    };
                });
            };

            /**
             * Prepare CPU charts data
             * @param {Array} metricList - list of metrics 
             */
            vm.prepareCpuMetrics = function (metricList) {
                try {
                    vm.cpuData[0].values = [];
                    vm.cpuData[1].values = [];
                    metricList
                        .sort(function (metric1, metric2) {
                            return (metric2.node.cpuUser + metric2.node.cpuSystem) - (metric1.node.cpuUser + metric1.node.cpuSystem);
                        })
                        .filter(function (item, index) {
                            return index < vm.MAX_CHART_ITEMS;
                        })
                        .map(function (metric, index) {
                            vm.deviceOrderObject[metric.deviceId] = vm.deviceOrderObject[metric.deviceId] || {};
                            vm.deviceOrderObject[metric.deviceId].cpu = {
                                order: (index + 1)
                            };
                            // Add CPU User
                            vm.addMetric(vm.cpuData[0].values, metric, metric.node.cpuUser);
                            // Add CPU System
                            vm.addMetric(vm.cpuData[1].values, metric, metric.node.cpuSystem);
                        });
                    vm.fillDummyData(vm.cpuData[0].values);
                    vm.fillDummyData(vm.cpuData[1].values);
                } catch (e) { console.log(e); }
            };

            /**
             * Prepare Memory charts data
             * @param {Array} metricList - list of metrics 
             */
            vm.prepareMemoryMetrics = function (metricList) {
                try {
                    vm.memoryData[0].values = [];
                    metricList
                        .sort(function (metric1, metric2) {
                            return metric2.node.memoryUsed - metric1.node.memoryUsed;
                        })
                        .filter(function (item, index) {
                            return index < vm.MAX_CHART_ITEMS;
                        })
                        .map(function (metric, index) {
                            vm.deviceOrderObject[metric.deviceId] = vm.deviceOrderObject[metric.deviceId] || {};
                            vm.deviceOrderObject[metric.deviceId].memory = {
                                order: (index + 1)
                            };
                            // Add Memory
                            vm.addMetric(vm.memoryData[0].values, metric, metric.node.memoryUsed);
                        });

                    vm.fillDummyData(vm.memoryData[0].values);
                } catch (e) { console.log(e); }
            };

            /**
             * Prepare Network charts data
             * @param {Array} metricList - list of metrics 
             */
            vm.prepareNetworkMetrics = function (metricList) {
                try {
                    vm.networkData[0].values = [];
                    vm.networkData[1].values = [];
                    metricList
                        .sort(function (metric1, metric2) {
                            return (metric2.node.networkTransmitRate + metric2.node.networkReceiveRate) - (metric1.node.networkTransmitRate + metric1.node.networkReceiveRate);
                        })
                        .filter(function (item, index) {
                            return index < vm.MAX_CHART_ITEMS;
                        })
                        .map(function (metric, index) {
                            vm.deviceOrderObject[metric.deviceId] = vm.deviceOrderObject[metric.deviceId] || {};
                            vm.deviceOrderObject[metric.deviceId].network = {
                                order: (index + 1)
                            };
                            // Network TX
                            vm.addMetric(vm.networkData[0].values, metric, metric.node.networkTransmitRate);
                            // Network RX
                            vm.addMetric(vm.networkData[1].values, metric, metric.node.networkReceiveRate);
                        });

                    vm.fillDummyData(vm.networkData[0].values);
                    vm.fillDummyData(vm.networkData[1].values);
                } catch (e) { console.log(e); }
            };

            /**
             * Prepare Storage charts data
             * @param {Array} metricList - list of metrics 
             */
            vm.prepareStorageMetrics = function (metricList) {
                try {
                    vm.storageData[0].values = [];
                    vm.storageData[1].values = [];
                    metricList
                        .sort(function (metric1, metric2) {
                            return (metric2.node.storageUsed + metric2.node.storageAvailable) - (metric1.node.storageUsed + metric1.node.storageAvailable);
                        })
                        .filter(function (item, index) {
                            return index < vm.MAX_CHART_ITEMS;
                        })
                        .map(function (metric, index) {
                            vm.deviceOrderObject[metric.deviceId] = vm.deviceOrderObject[metric.deviceId] || {};
                            vm.deviceOrderObject[metric.deviceId].storage = {
                                order: (index + 1)
                            };
                            // Storage used
                            vm.addMetric(vm.storageData[0].values, metric, metric.node.storageUsed);
                            // Storage available
                            vm.addMetric(vm.storageData[1].values, metric, metric.node.storageAvailable);
                        });

                    vm.fillDummyData(vm.storageData[0].values);
                    vm.fillDummyData(vm.storageData[1].values);
                } catch (e) { console.log(e); }
            };

            /**
             * Add CPU metric to chart array
             * @param {Object} metric - metric object
             * @param {String} label - label name 
             * @param {number} value - metric value
             */
            vm.addMetric = function (chart, metric, value) {
                chart.push({
                    label: metric && metric.deviceId ? metric.deviceId : '',
                    value: value
                });
            };

            /**
             * Fill chart array to get minimum number of bars
             * @param {Array} chart - chart array to add object 
             * @param {*} maxValue - max value to fill 
             * @returns 
             */
            vm.fillDummyData = function (chart, maxValue) {
                var _maxValue = maxValue || vm.MAX_CHART_ITEMS;
                if (!angular.isArray(chart) || chart.length >= _maxValue) {
                    return;
                }

                for (var i = 0; i < _maxValue - chart.length; i++) {
                    vm.addMetric(chart, { deviceId: (chart.length + i + 1) }, null);
                }
            };
        }
    });
'use strict';

/**
 * @ngdoc component
 * @name loopUiApp.component:tagConsumption
 * @description
 * # tagConsumption
 */
angular.module('loopUiApp')
    .component('tagConsumption', {
        templateUrl: '../scripts/components/dashboard/tagConsumption/tagConsumption.html',
        bindings: {
            data: '<',
            deviceObject: '<',
            isSummary: '<',
            isHeaderEnable: '<'
        },
        controller: function ($state, $stateParams, appConfig, ServiceChart) {
            var vm = this;
            vm.chartData = [];
            // Name of Edge Device
            vm.supportDeviceName = appConfig.supportDeviceName;

            vm.$onInit = function () {
                vm.companyName = $stateParams.companyName;
                vm.projectId = $stateParams.projectId;
            };

            vm.$onChanges = function (changes) {
                if (changes.data && changes.data.currentValue && changes.data.currentValue.billingTags) {
                    if (!vm.chartSettings) {
                        vm.initChart();
                    }
                    var _maxValue = vm.data.billingTagsMax * 1.05;
                    vm.chartSettings.chart.forceY = [0, _maxValue];
                    vm.chartData = vm.convertDataToChart(vm.data.billingTags);
                }
            };

            /** 
             * Init chart settings
             * @returns {void}
             **/
            vm.initChart = function () {
                vm.chartSettings = angular.copy(ServiceChart.stackedAreaChart);
                vm.chartSettings.title.text = vm.isSummary ? 'Tags Consumption, summary' : 'Tags Consumption, per Edge Device';
                vm.chartSettings.title.enable = vm.isHeaderEnable;
                vm.chartSettings.chart.height = 300;
                vm.chartSettings.chart.showTotalInTooltip = false;
                vm.chartSettings.chart.yAxis.width = 60;
                vm.chartSettings.chart.xAxis.height = 30;
                vm.chartSettings.chart.xAxis.showMaxMin = false;
                vm.chartSettings.chart.xAxis.tickFormat = function (d) {
                    return d3.time.format('%d.%m %H:00')(new Date(d * 1000));
                };
                vm.chartSettings.chart.interactiveLayer.tooltip.keyFormatter = function (value) {
                    return vm.isSummary ? 'All' : ((vm.deviceObject && vm.deviceObject[value] ?
                        (vm.deviceObject[value].prettyName || vm.deviceObject[value].hostname || vm.deviceObject.deviceId)
                        : 'License client id=' + value));
                };
                vm.chartSettings.chart.legend = {
                    key: function (d) {
                        return d.name;
                    },
                    dispatch: {
                        legendDblclick: function (data) {
                            if (data && data.key) {
                                $state.go('deviceView', {
                                    companyName: vm.companyName,
                                    projectId: vm.projectId,
                                    deviceId: data.key,
                                });
                            }
                        }
                    },
                    maxKeyLength: 16,
                    rightAlign: false
                };
                vm.chartSettings.chart.forceY = [0, 1];
                vm.chartSettings.chart.noData = 'Tags consumption details are not available for this period';
            };

            /**
             * Prepare data to chart data
             * @param {Array} inputArray - array from metrics 
             * @returns 
             */
            vm.convertDataToChart = function (inputObject) {
                if (!inputObject || !angular.isObject(inputObject)) {
                    return [];
                }
                try {
                    var _result = {};
                    // Map of all device ids available in inputObject
                    var _deviceMap = {};
                    // Map of all timestamps available in inputObject
                    var _tsMap = {};
                    // Create map of all timestamps. Value is deviceId and count
                    Object.keys(inputObject)
                        .forEach(function (deviceId) {
                            _deviceMap[deviceId] = true;
                            return inputObject[deviceId].forEach(function (row) {
                                if (!_tsMap[row.timestamp]) {
                                    _tsMap[row.timestamp] = {};
                                }
                                _tsMap[row.timestamp][deviceId] = row.count;
                            });
                        });
                    // For each timestamp create array of values for each device.
                    // If value is not available for device, set count = 0
                    Object.keys(_tsMap)
                        .sort()
                        .forEach(function (ts) {
                            Object.keys(_deviceMap).forEach(function (deviceId) {
                                if (!_result[deviceId]) {
                                    _result[deviceId] = [];
                                }
                                _result[deviceId].push([ts, (_tsMap[ts][deviceId] || 0)]);
                            });
                        });
                    // Convert map to array of objects suitable for chart
                    return Object.keys(_result).map(function (deviceId, index) {
                        return {
                            key: deviceId,
                            values: _result[deviceId],
                            name: vm.isSummary ? 'All' : (vm.supportDeviceName + ' ' + (index + 1))
                        };
                    });
                }
                catch (e) {
                    return [];
                }
            };
        }
    });
'use strict';

/**
 * @ngdoc component
 * @name loopUiApp.component:tagConsumptionDetails
 * @description
 * # tagConsumptionDetails
 */
angular.module('loopUiApp')
    .component('tagConsumptionDetails', {
        templateUrl: '../scripts/components/dashboard/tagConsumptionDetails/tagConsumptionDetails.html',
        controller: function ($stateParams, $http, $timeout, FileSaver, appConfig, Service, Commons) {
            var vm = this;
            vm.filterActive = false;
            vm.deviceList = [];
            vm.deviceObject = {};
            vm.filterObject = {};
            vm.filterParams = {};

            vm.$onInit = function () {
                vm.companyName = $stateParams.companyName;
                vm.projectId = $stateParams.projectId;

                // Maximum period in days for the filter
                vm.MAX_PERIOD_DAYS = 90;

                var dateFrom = new Date();
                // Set default value of dateFrom to 7 days ago
                dateFrom.setHours(-168, 0, 0, 0);
                var dateTo = new Date();

                // Default values of filter
                vm.initialFilterObject = {
                    deviceId: null,
                    from: dateFrom,
                    to: dateTo
                };

                vm.filterObject = angular.copy(vm.initialFilterObject);

                // Set form validation limits based on default values
                vm.recalculateDateLimits(vm.initialFilterObject);

                // Get list device for filters
                vm.refreshDeviceList();
                vm.refreshTagConsumption();
            };

            /**
             * Get tag consumption data
             * @returns {void}
             */
            vm.refreshTagConsumption = function () {
                vm.isLoading = true;
                
                var _today = new Date();
                var _from = vm.filterObject.from.setHours(0, 0, 0);
                var _to = vm.filterObject.to.getTime();

                // Set to 23:59:59 if date to is not today
                if (_today.toLocaleDateString() !== vm.filterObject.to.toLocaleDateString()) {
                    _to = vm.filterObject.to.setHours(23, 59, 59);
                }

                vm.filterParams = {
                    projectId: vm.projectId,
                    deviceId: vm.filterObject.deviceId,
                    from: _from,
                    to: _to,
                    limit: 0
                };

                Service.api.dashboardGfmBillingTags(vm.filterParams).$promise
                    .then(function (data) {
                        vm.tagConsumptionData = data;
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Failed to load tag consumption data');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Failed to load tag consumption data:' + JSON.stringify(reason));
                    })
                    .finally(function () {
                        vm.isLoading = false;
                    });
            };

            /**
             * Load device list
             * @returns {void}
             */
            vm.refreshDeviceList = function () {
                Service.api.deviceList({
                    projectId: vm.projectId,
                    tag: null,
                    deviceType: 'LOOPEDGE',
                    requestedPage: 0,
                    limit: 1000, // TODO: remove hardcoded limit
                    onlineOnly: false
                }).$promise
                    .then(function (data) {
                        vm.deviceList = data.elements;
                        vm.deviceList.unshift({ deviceId: null, prettyName: 'All' });
                        vm.deviceObject = data.elements.reduce(function (acc, cur) {
                            acc[cur.deviceId] = {
                                prettyName: cur.prettyName,
                                hostname: cur.hostname,
                                deviceId: cur.deviceId
                            };
                            return acc;
                        }, {});
                    });
            };

            /**
             * Show/hide filter elements
             * @returns {void}
             */
            vm.toggleFilter = function () {
                vm.filterActive = !vm.filterActive;
            };

            /**
             * Set filter into initial state
             * @return {void}
             */
            vm.reset = function () {
                vm.recalculateDateLimits(vm.initialFilterObject);

                // Change model value when limits changed, on the next event loop cycle
                $timeout(function () {
                    vm.filterObject = angular.copy(vm.initialFilterObject);
                    vm.refreshTagConsumption();
                }, 0);
            };

            /**
             * Recalculate min date for datepicker
             * @returns {void}
             */
            vm.recalculateDateLimits = function (filterObject) {
                vm.minDateFrom = angular.copy(filterObject.to);
                vm.minDateFrom.setDate(vm.minDateFrom.getDate() - vm.MAX_PERIOD_DAYS);
                vm.minDateFrom.setHours(0, 0, 0);

                vm.maxDateFrom = angular.copy(filterObject.to);
                vm.maxDateFrom.setHours(0, 0, 0);


                vm.minDateTo = angular.copy(filterObject.from);
                vm.minDateTo.setHours(23, 59, 59);

                vm.maxDateTo = angular.copy(filterObject.from);
                vm.maxDateTo.setDate(vm.maxDateTo.getDate() + vm.MAX_PERIOD_DAYS);
                vm.maxDateTo = vm.maxDateTo > new Date() ? new Date() : vm.maxDateTo;
                vm.maxDateTo.setHours(23, 59, 59);
            };

            /**
             * Export data to CSV with selected filter
             * @returns {void}
             */
            vm.saveAsCsv = function () {
                var req = {
                    url: appConfig.apiUrl + 'api/v' + appConfig.apiVersion + '/dashboard-gfm/billing-tags/csv',
                    method: 'POST',
                    responseType: 'arraybuffer',
                    params: vm.filterParams || {},
                };

                $http(req)
                    .then(function (resp) {
                        var headers = resp.headers();
                        var type = headers['content-type'];
                        var filename = headers['content-disposition'] ? headers['content-disposition'].split("filename=")[1] : 'export.csv';
                        var serverData = new Blob([resp.data], { type: type });
                        FileSaver.saveAs(serverData, filename);
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Save to CSV failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Billing tags save to CSV failed:' + JSON.stringify(reason));
                    });
            };
        }
    });

'use strict';
/**
 * @ngdoc component
 * @name loopUiApp.component:licenseManagement
 * @description
 * # licenseManagement
 */
angular.module('loopUiApp')
    .component('licenseManagement', {
        templateUrl: '../scripts/components/license/licenseManagement/licenseManagement.html',
        controller: function ($scope, $state, $mdDialog, $stateParams, $http, $interval, $filter, appConfig, FileSaver, Service, Commons) {
            var vm = this;
            vm.totalItems = 0;
            vm.licensePoolList = [];
            vm.selectedLicenses = [];
            vm.filterStatus = null;
            vm.filterExpiryDate = {
                from: null,
                to: null
            };
            vm.filterActivationDate = {
                from: null,
                to: null
            };
            vm.filterExpiryFeatureDate = {
                from: null,
                to: null
            };
            vm.stats = undefined;
            // Flag to show or hide progress bar in the table
            vm.showProgress = true;
            vm.lastUpdateDate = undefined;
            vm.lastUpdateDateStr = '';

            vm.$onInit = function () {
                vm.projectId = $stateParams.projectId;

                vm.sortField = 'deviceFriendlyName';
                vm.sortMap = {
                    'deviceFriendlyName': 'DEVICEFRIENDLYNAME_ASC',
                    '-deviceFriendlyName': 'DEVICEFRIENDLYNAME_DESC',
                    'deviceName': 'DEVICENAME_ASC',
                    '-deviceName': 'DEVICENAME_DESC',
                    'activationDate': 'ACTIVATIONDATE_ASC',
                    '-activationDate': 'ACTIVATIONDATE_DESC',
                    'status': 'LICENSESTATUS_ASC',
                    '-status': 'LICENSESTATUS_DESC',
                    'expiryDate': 'EXPIRYDATE_ASC',
                    '-expiryDate': 'EXPIRYDATE_DESC',
                    'expiryFeatureDate': 'EXPIRYFEATUREDATE_ASC',
                    '-expiryFeatureDate': 'EXPIRYFEATUREDATE_DESC',
                    'licenseKey': 'LICENSEKEY_ASC',
                    '-licenseKey': 'LICENSEKEY_DESC',
                    'licenseSku': 'LICENSESKU_ASC',
                    '-licenseSku': 'LICENSESKU_DESC',
                };

                // Handle stats code: add name and action
                vm.statsNameMap = {
                    types: {
                        name: 'Licenses Types',
                        action: null,
                        subItems: [
                            { name: 'Core', value: null },
                            { name: 'Add-on', value: null }
                        ]
                    },
                    total: {
                        name: 'Total Licenses',
                        action: null
                    },
                    used: {
                        name: 'Used Licenses',
                        action: null,
                        subItems: [
                            { name: 'Active', value: function () { return vm.stats ? vm.stats.active : 0; } },
                            { name: 'Expired', value: function () { return vm.stats ? vm.stats.expired : 0; } }
                        ]
                    },
                    unused: {
                        name: 'Un-Used Licenses',
                        action: function (event) {
                            vm.showLicenseListDialog(event, 'NEW');
                        }
                    }
                };

                // Init pagination object
                vm.itemsPagination = {
                    limitOptions: [10, 50, 100],
                    limit: 10,
                    page: 1,
                };

                // Stats card actions
                vm.cardActions = [
                    {
                        name: 'Reload',
                        icon: 'refresh',
                        buttonClick: function () {
                            vm.refresh(true);
                        }
                    }
                ];

                // List of actions
                vm.filterActions = [{
                    icon: 'upload',
                    name: 'Bulk Deploy Licenses',
                    type: 'BUTTON',
                    buttonClick: function (event) {
                        vm.viewLicenseAppyWizard(event, vm.selectedLicenses);
                    }
                },
                {
                    icon: 'description',
                    name: 'Generate Report',
                    type: 'MENU',
                    disabled: function () {
                        return !vm.licensePoolList || vm.licensePoolList.length === 0;
                    },
                    buttonClick: function () {
                        console.log('Generate Report');
                    },
                    subActions: [
                        {
                            icon: 'email',
                            name: 'Email CSV',
                            buttonClick: function (event) {
                                vm.openEmailSendDialog(event);
                            }
                        },
                        {
                            icon: 'file_download',
                            name: 'Export CSV',
                            buttonClick: function (event) {
                                vm.getLicensePoolUsedCsv(event);
                            }
                        }]
                },
                {
                    icon: 'file_upload',
                    name: 'Upload License CSV',
                    type: 'BUTTON',
                    buttonClick: function (event) {
                        vm.upload(event);
                    }
                }];

                // Table rows actions
                vm.listActions = [{
                    name: 'Deploy License',
                    icon: 'upload',
                    function: function (event, item) {
                        vm.viewLicenseAppyWizard(event, [item]);
                    }
                },
                {
                    name: 'Show license features',
                    icon: 'list',
                    function: function (event, item) {
                        vm.featuresDialog(event, item.deviceId);
                    }
                }];

                // Settings for table filters
                vm.filterObj = {
                    status: {
                        type: 'select',
                        multiple: false,
                        name: 'License Status',
                        selectedValue: null,
                        defaultValue: null,
                        values: [{ code: 'OK', name: 'Active' }, { code: 'EXPIRED', name: 'Expired' }],
                        visible: false,
                        action: function (value) {
                            vm.filterStatus = value;
                            vm.statusOperator = !!value ? 'IS' : 'NOT';
                            vm.refreshList(true);
                        }
                    },
                    licenseSku: {
                        type: 'select',
                        multiple: true,
                        name: 'License SKU',
                        selectedValue: null,
                        defaultValue: null,
                        values: [],
                        visible: false,
                        action: function (value) {
                            vm.filterLicenseSku = angular.isArray(value) ? value.join(',') : value;
                            vm.refreshList(true);
                        }
                    },
                    expiryDate: {
                        type: 'date',
                        multiple: false,
                        name: 'Expiry Date',
                        selectedValue: null,
                        defaultValue: {
                            from: null,
                            to: null
                        },
                        values: [],
                        visible: false,
                        action: function (value) {
                            vm.filterExpiryDate = value;
                            vm.refreshList(true);
                        }
                    },
                    expiryFeatureDate: {
                        type: 'date',
                        multiple: false,
                        name: 'Feature Expiry Date',
                        selectedValue: null,
                        defaultValue: {
                            from: null,
                            to: null
                        },
                        values: [],
                        visible: false,
                        action: function (value) {
                            vm.filterExpiryFeatureDate = value;
                            vm.refreshList(true);
                        }
                    },
                    activationDate: {
                        type: 'date',
                        multiple: false,
                        name: 'Activation Date',
                        selectedValue: null,
                        defaultValue: {
                            from: null,
                            to: null
                        },
                        values: [],
                        visible: false,
                        action: function (value) {
                            vm.filterActivationDate = value;
                            vm.refreshList(true);
                        }
                    }
                };

                vm.refresh(true);
                vm.startListRefresh();
            };

            /**
             * Disable pooling on close
             */
            vm.$onDestroy = function () {
                $interval.cancel(vm.refreshInterval);
            };

            /**
             * Start list changes pulling
             * @returns {void}
             */
            vm.startListRefresh = function () {
                if (vm.refreshInterval) {
                    $interval.cancel(vm.refreshInterval);
                }
                vm.refreshInterval = $interval(function () {
                    vm.lastUpdateDateStr = vm.getLastUpdateDateStr(vm.lastUpdateDate);
                }, 10000);
            };

            /**
             * Refresh stats and used license list
             * @param showProgress - boolean. 'true' - main table will show progress bar, 'false' - hide
             */
            vm.refresh = function (showProgress) {
                vm.refreshStats();
                vm.refreshList(showProgress);
                vm.refreshLicenseSkus();
            };

            /**
             * Refresh list of licenses
             * @param showProgress - boolean. 'true' - main table will show progress bar, 'false' - hide
             */
            vm.refreshList = function (showProgress) {
                vm.showProgress = showProgress;
                vm.selectedLicenses = [];
                // Show grouped version of table for vm.sortField in ['deviceFriendlyName', 'deviceName']
                if (['deviceFriendlyName', 'deviceName', '-deviceFriendlyName', '-deviceName'].indexOf(vm.sortField) >= 0) {
                    vm.refreshLicensePoolUsedList();
                } else {
                    vm.refreshLicensePoolList();
                }
            };

            /**
             * Refresh the list of used licenses
             * @returns {void}
             */
            vm.refreshLicensePoolUsedList = function () {
                vm.licensePoolListPromise = Service.api.deviceLicensePoolUsedList({
                    projectId: vm.projectId,
                    limit: vm.itemsPagination.limit,
                    requestedPage: vm.itemsPagination.page - 1,
                    filter: vm.filterStr,
                    status: vm.filterStatus,
                    order: vm.sortMap[vm.sortField],
                    licenseSku: vm.filterLicenseSku,
                    expiryDateFrom: vm.filterExpiryDate.from ? vm.filterExpiryDate.from.setHours(0, 0, 0, 0) : null,
                    expiryDateTo: vm.filterExpiryDate.to ? vm.filterExpiryDate.to.setHours(23, 59, 59, 59) : null,
                    expiryFeatureDateFrom: vm.filterExpiryFeatureDate.from ? vm.filterExpiryFeatureDate.from.setHours(0, 0, 0, 0) : null,
                    expiryFeatureDateTo: vm.filterExpiryFeatureDate.to ? vm.filterExpiryFeatureDate.to.setHours(23, 59, 59, 59) : null,
                    activationDateFrom: vm.filterActivationDate.from ? vm.filterActivationDate.from.setHours(0, 0, 0, 0) : null,
                    activationDateTo: vm.filterActivationDate.to ? vm.filterActivationDate.to.setHours(23, 59, 59, 59) : null
                }).$promise;

                vm.licensePoolListPromise
                    .then(function (data) {
                        vm.totalItems = data.totalSize;
                        vm.licensePoolList = data.elements;
                        vm.lastUpdateDate = Date.now();
                        vm.lastUpdateDateStr = vm.getLastUpdateDateStr(vm.lastUpdateDate);
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Get used licenses failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error deviceLicensePoolNewList:' + JSON.stringify(reason));
                    });
            };

            /**
             * Refresh flat list of licenses
             */
            vm.refreshLicensePoolList = function () {
                vm.licensePoolListPromise = Service.api.deviceLicensePoolList({
                    projectId: vm.projectId,
                    limit: vm.itemsPagination.limit,
                    requestedPage: vm.itemsPagination.page - 1,
                    statusOperator: !!vm.filterStatus ? 'IS' : 'NOT', // Return only non-NEW licenses by default
                    status: vm.filterStatus || 'NEW',
                    order: vm.sortMap[vm.sortField],
                    filter: vm.filterStr,
                    licenseSku: vm.filterLicenseSku,
                    expiryDateFrom: vm.filterExpiryDate.from ? vm.filterExpiryDate.from.setHours(0, 0, 0, 0) : null,
                    expiryDateTo: vm.filterExpiryDate.to ? vm.filterExpiryDate.to.setHours(23, 59, 59, 59) : null,
                    expiryFeatureDateFrom: vm.filterExpiryFeatureDate.from ? vm.filterExpiryFeatureDate.from.setHours(0, 0, 0, 0) : null,
                    expiryFeatureDateTo: vm.filterExpiryFeatureDate.to ? vm.filterExpiryFeatureDate.to.setHours(23, 59, 59, 59) : null,
                    activationDateFrom: vm.filterActivationDate.from ? vm.filterActivationDate.from.setHours(0, 0, 0, 0) : null,
                    activationDateTo: vm.filterActivationDate.to ? vm.filterActivationDate.to.setHours(23, 59, 59, 59) : null
                }).$promise;

                vm.licensePoolListPromise
                    .then(function (data) {
                        vm.totalItems = data.totalSize;
                        vm.licensePoolList = data.elements.map(function (item) {
                            item.licenses = [
                                {
                                    licenseSku: item.licenseSku,
                                    licenseKey: item.licenseKey,
                                    activationDate: item.activationDate,
                                    status: item.status,
                                    expiryDate: item.expiryDate,
                                    expiryFeatureDate: item.expiryFeatureDate
                                }];
                            return item;
                        });
                        vm.lastUpdateDate = Date.now();
                        vm.lastUpdateDateStr = vm.getLastUpdateDateStr(vm.lastUpdateDate);
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Get licenses failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error deviceLicensePoolList:' + JSON.stringify(reason));
                    });
            };

            /**
             * Refresh the license list
             */
            vm.refreshLicenseSkus = function () {
                Service.api.deviceLicensePoolSkus({
                    projectId: vm.projectId,
                }).$promise
                    .then(function (data) {
                        vm.filterObj.licenseSku.values = data.map(function (item) {
                            return {
                                code: item.licenseSku,
                                name: item.licenseSku
                            };
                        });
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Get unused licenses failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error deviceLicensePoolSkus:' + JSON.stringify(reason));
                    });
            };

            /**
             * Send CSV file with filtered licenses via email
             */
            vm.sendLicensePoolUsedEmail = function (emails) {
                var _deviceIds = vm.selectedLicenses.map(function (license) {
                    return license.deviceId;
                });
                var _payload = {
                    deviceIds: _deviceIds,
                    emails: emails
                };
                Service.api.deviceLicensePoolAllCsvEmail({
                    projectId: vm.projectId,
                    filter: vm.filterStr,
                    status: vm.filterStatus,
                    licenseSku: vm.filterLicenseSku,
                    order: vm.sortMap[vm.sortField],
                    expiryDateFrom: vm.filterExpiryDate.from ? vm.filterExpiryDate.from.setHours(0, 0, 0, 0) : null,
                    expiryDateTo: vm.filterExpiryDate.to ? vm.filterExpiryDate.to.setHours(23, 59, 59, 59) : null,
                    expiryFeatureDateFrom: vm.filterExpiryFeatureDate.from ? vm.filterExpiryFeatureDate.from.setHours(0, 0, 0, 0) : null,
                    expiryFeatureDateTo: vm.filterExpiryFeatureDate.to ? vm.filterExpiryFeatureDate.to.setHours(23, 59, 59, 59) : null,
                    activationDateFrom: vm.filterActivationDate.from ? vm.filterActivationDate.from.setHours(0, 0, 0, 0) : null,
                    activationDateTo: vm.filterActivationDate.to ? vm.filterActivationDate.to.setHours(23, 59, 59, 59) : null
                }, _payload).$promise
                    .then(function () {
                        Commons.toastShow('Email sent');
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Send email failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error deviceLicensePoolAllCsvEmail:' + JSON.stringify(reason));
                    });
            };

            /**
             * Get CSV file with used licenses
             */
            vm.getLicensePoolUsedCsv = function () {
                var _deviceIds = vm.selectedLicenses.map(function (license) {
                    return license.deviceId;
                });
                var _filter = {
                    projectId: vm.projectId,
                    statusOperator: !!vm.filterStatus ? 'IS' : 'NOT', // Return only non-NEW licenses by default
                    status: vm.filterStatus || 'NEW',
                    order: vm.sortMap[vm.sortField],
                    filter: vm.filterStr,
                    licenseSku: vm.filterLicenseSku,
                    expiryDateFrom: vm.filterExpiryDate.from ? vm.filterExpiryDate.from.setHours(0, 0, 0, 0) : null,
                    expiryDateTo: vm.filterExpiryDate.to ? vm.filterExpiryDate.to.setHours(23, 59, 59, 59) : null,
                    expiryFeatureDateFrom: vm.filterExpiryFeatureDate.from ? vm.filterExpiryFeatureDate.from.setHours(0, 0, 0, 0) : null,
                    expiryFeatureDateTo: vm.filterExpiryFeatureDate.to ? vm.filterExpiryFeatureDate.to.setHours(23, 59, 59, 59) : null,
                    activationDateFrom: vm.filterActivationDate.from ? vm.filterActivationDate.from.setHours(0, 0, 0, 0) : null,
                    activationDateTo: vm.filterActivationDate.to ? vm.filterActivationDate.to.setHours(23, 59, 59, 59) : null
                };
                var _queryString = Object.keys(_filter)
                    .filter(function (key) {
                        return _filter[key] !== undefined && _filter[key] !== null;
                    })
                    .map(function (key) {
                        return key + '=' + encodeURIComponent(_filter[key]);
                    }).join('&');
                var req = {
                    url: appConfig.apiUrl + 'api/v' + appConfig.apiVersion +
                        '/device-license-pool/all/csv?' + _queryString,
                    method: 'POST',
                    responseType: 'arraybuffer',
                    data: {
                        deviceIds: _deviceIds
                    }
                };
                $http(req)
                    .then(function (resp) {
                        var serverData = new Blob([resp.data], { type: 'text/csv' });
                        FileSaver.saveAs(serverData, 'license_used_export.csv');
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Save to CSV failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('device-license-pool/used/csv:' + JSON.stringify(reason));
                    });
            };

            /**
             * Send CSV file with selected licenses via email
             * @param {Event} event - mouse click event
             */
            vm.openEmailSendDialog = function (event) {
                $mdDialog.show({
                    template: '<md-dialog aria-label="License Deploy Dialog" style="width: 600px;"><license-send-report-dialog></license-send-report-dialog></md-dialog>',
                    parent: angular.element(document.body),
                    targetEvent: event,
                    clickOutsideToClose: false
                })
                    .then(function (recipients) {
                        if (!recipients || recipients.length === 0) {
                            return;
                        }
                        vm.sendLicensePoolUsedEmail(recipients);
                    });
            };

            /**
             * Refresh license stats
             */
            vm.refreshStats = function () {
                Service.api.deviceLicensePoolStats({
                    projectId: vm.projectId
                }).$promise
                    .then(function (data) {
                        vm.stats = data;
                        vm.stats.total = (data.active || 0) + (data.expired || 0) + (data.unused || 0);
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Get license stats failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error deviceLicensePoolStats:' + JSON.stringify(reason));
                    });
            };

            /**
             * Open license apply wizard
             * @param {Event} event - mouse click event
             * @returns {void}
             */
            vm.viewLicenseAppyWizard = function (event, selectedLicenses) {
                var _selectedLicenses = angular.copy(selectedLicenses) || [];
                // Create an isolated scope to pass to the component
                var scope = angular.extend($scope.$new(true), {
                    preselectedDevices: _selectedLicenses.map(function (device) {
                        return {
                            deviceId: device.deviceId,
                            prettyName: device.deviceFriendlyName
                        };
                    }) || undefined,
                });

                $mdDialog.show({
                    template:
                        '<md-dialog aria-label="License Deploy Dialog">' +
                        '<license-deploy-dialog preselected-devices="preselectedDevices"></license-deploy-dialog>' +
                        '</md-dialog>',
                    parent: angular.element(document.body),
                    targetEvent: event,
                    scope: scope,
                    clickOutsideToClose: false
                })
                    .then(function () {
                        vm.refresh(true);
                    });
            };

            /**
             * Upload list of licenses from CSV file
             * @param {Event} event - Selection event from fileUpload component
             * @returns {void}
             */
            vm.upload = function (event) {
                // Create an isolated scope to pass to the component
                var scope = angular.extend($scope.$new(true), {
                    title: 'Upload license keys',
                    exampleLink: '/scripts/components/license/license-upload-example.csv',
                });

                $mdDialog.show({
                    template: '<md-dialog style="max-width:300px;"><md-dialog-content>' +
                        '<upload-file-dialog title="title" example-link="exampleLink">' +
                        '</upload-file-dialog></md-dialog-content></md-dialog>',
                    parent: angular.element(document.body),
                    targetEvent: event,
                    clickOutsideToClose: false,
                    scope: scope,
                    preserveScope: true,
                    skipHide: true,
                })
                    .then(function (data) {
                        if (data && data.fileData) {
                            Service.api.deviceLicensePoolCsvUpload({
                                projectId: vm.projectId,
                            }, data.fileData).$promise
                                .then(function () {
                                    Commons.toastShow('Licenses imported');
                                    vm.refreshStats();
                                })
                                .catch(function (reason) {
                                    var messageObject = Commons.createErrorObject(reason, 'Import failed');
                                    Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                                    console.log('Error deviceLicensePoolCsvUpload:' + JSON.stringify(reason));
                                });
                        }
                    });
            };

            /**
             * Open license list window for selected status
             * @param {Event} event - mouse click event 
             * @param {string} status - license status
             */
            vm.showLicenseListDialog = function (event, status) {
                // Create an isolated scope to pass to the component
                var scope = angular.extend($scope.$new(true), {
                    status: status
                });
                $mdDialog.show({
                    template: '<md-dialog aria-label="License List Dialog" style="width:800px;">' +
                        '<license-pool-list-dialog status="status"></license-pool-list-dialog>' +
                        '</md-dialog>',
                    parent: angular.element(document.body),
                    targetEvent: event,
                    scope: scope,
                    clickOutsideToClose: false
                })
                    .then(function () {
                        vm.refreshStats();
                    });
            };

            /**
             * Open with the list of features for Edge device
             * @param {Event} event - mouse click event 
             * @param {string} deviceId - Edge device ID
             */
            vm.featuresDialog = function (event, deviceId) {
                // Create an isolated scope to pass to the component
                var scope = angular.extend($scope.$new(true), {
                    deviceId: deviceId
                });
                $mdDialog.show({
                    template: '<md-dialog aria-label="Feature List Dialog" style="width:800px;">' +
                        '<feature-list-dialog device-id="deviceId"></feature-list-dialog>' +
                        '</md-dialog>',
                    parent: angular.element(document.body),
                    targetEvent: event,
                    scope: scope,
                    clickOutsideToClose: true
                });
            };

            /**
             * Is data available after load
             * @return {boolean} - data exist flag
             */
            vm.showNoData = function () {
                return !vm.licensePoolList || vm.licensePoolList.length === 0 &&
                    !(vm.licensePoolListPromise && vm.licensePoolListPromise.$$state && vm.licensePoolListPromise.$$state.status === 0 && vm.showProgress);
            };

            /**
             * Open device page
             * @return {void}
             */
            vm.openDeviceDetails = function (deviceId) {
                $state.go('deviceView', {
                    companyName: $stateParams.companyName,
                    projectId: $stateParams.projectId,
                    deviceId: deviceId,
                    selectedTab: 'license'
                });
            };

            /**
             * Handle filter open event
             * @param {Event} event - mouse click event 
             * @param {String} field - name of the field that's filtered
             */
            vm.onFilter = function (event, field) {
                // Position for filter menu
                var _leftPosition = event.clientX - 90 + 'px';
                var _topPosition = event.clientY + 10 + 'px';
                var scope = angular.extend($scope.$new(true), {
                    leftPosition: _leftPosition,
                    topPosition: _topPosition,
                    filterObject: vm.filterObj[field]
                });
                $mdDialog.show({
                    template: '<md-dialog class="md-table-filter" ng-style="{\'left\': leftPosition, \'top\': topPosition}" aria-label="Filter menu">' +
                        '<filter-menu filter-object="filterObject"></filter-menu>' +
                        '</md-dialog>',
                    clickOutsideToClose: true,
                    skipHide: true,
                    scope: scope,
                    hasBackdrop: false,
                })
                    .then(function (result) {
                        vm.itemsPagination.page = 1;
                        if (result.use === true) {
                            vm.filterApplyHandler(field, result.value);
                        } else {
                            vm.filterResetHandler(field);
                        }
                    });
            };

            /**
             * Handle filter apply
             * @param {string} field - field name
             * @param {any} value - value from the filter
             */
            vm.filterApplyHandler = function (field, value) {
                vm.filterObj[field].visible = true;
                vm.filterObj[field].selectedValue = value;
                vm.filterObj[field].action(value);
            };

            /**
             * On filter reset: set value to default and hide filter icon
             * @param {string} field - field name
             */
            vm.filterResetHandler = function (field) {
                vm.filterObj[field].visible = false;
                vm.filterObj[field].selectedValue = angular.copy(vm.filterObj[field].defaultValue);
                vm.filterObj[field].action(vm.filterObj[field].defaultValue);
            };

            /**
             * Handle filter search
             * @param {string} str - filter string
             */
            vm.filter = function (str) {
                vm.filterStr = str;
                vm.itemsPagination.page = 1;
                vm.refreshList(true);
            };

            /**
             * Reset all filters
             */
            vm.resetFilters = function () {
                vm.filterStr = null;
                vm.filterStatus = null;
                vm.filterLicenseSku = null;
                vm.filterExpiryDate = {
                    from: null,
                    to: null
                };
                vm.filterExpiryFeatureDate = {
                    from: null,
                    to: null
                };
                vm.filterActivationDate = {
                    from: null,
                    to: null
                };
                Object.keys(vm.filterObj).forEach(function (key) {
                    vm.filterObj[key].selectedValue = angular.copy(vm.filterObj[key].defaultValue);
                    vm.filterObj[key].visible = false;
                });
                vm.itemsPagination.page = 1;
                vm.refreshList(true);
            };

            /**
             * Handle sorting change
             */
            vm.onSort = function () {
                vm.itemsPagination.page = 1;
                vm.refreshList();
            };

            /**
             * Check if filter is set
             * @return {boolean} - filter set flag
             */
            vm.isFilterSet = function () {
                return vm.filterStr || vm.filterStatus || vm.filterLicenseSku || vm.filterExpiryDate.from ||
                    vm.filterActivationDate.from || vm.filterExpiryFeatureDate.from;
            };

            /**
             * Return license status CSS class 'text-success' or 'text-error'
             * @param {string} status - license status
             * @returns 
             * 
             */
            vm.licenseStatusClass = function (status) {
                return status === 'OK' ? 'text-success' : 'text-error';
            };

            /**
             * Return feature status CSS class 'text-success' or 'text-error'
             * @param {number} date - min expiry date of all features
             * @returns
             */
            vm.featureStatusClass = function (date) {
                return date > Date.now() ? 'text-success' : 'text-error';
            };

            /**
             * Prepare the string of human readable interval of last update
             * @param {number} lastUpdateDate - last update timestamp
             * @returns 
             */
            vm.getLastUpdateDateStr = function (lastUpdateDate) {
                if (!lastUpdateDate) {
                    return '';
                }
                if (Date.now() - lastUpdateDate < 1000 * 5) {
                    return 'Last update: now';
                }
                return 'Last update: ' + $filter('humanInterval')(lastUpdateDate) + ' ago';
            };
        }
    });
'use strict';
/**
 * @ngdoc component
 * @name loopUiApp.component:licensePoolListDialog
 * @description
 * # licensePoolListDialog
 */
angular.module('loopUiApp')
    .component('licensePoolListDialog', {
        bindings: {
            status: '<',
        },
        templateUrl: '../scripts/components/license/licensePoolListDialog/licensePoolListDialog.html',
        controller: function ($scope, $http, $mdDialog, $stateParams, gettextCatalog, appConfig, Service, Commons) {
            var vm = this;
            vm.selectedItems = [];
            vm.licenseList = [];
            vm.totalSize = 0;
            vm.filterStr = '';

            vm.$onInit = function () {
                vm.companyName = $stateParams.companyName;
                vm.projectId = $stateParams.projectId;

                // License status map
                vm.statusMap = {
                    NEW: 'Un-Used',
                    OK: 'Used',
                    EXPIRED: 'Expired'
                };

                vm.listSetup = {
                    sortField: 'licenseSku',
                    showIndex: false,
                    editable: false,
                    removable: false,
                    serverPagination: true,
                    limit: 10,
                    limitOptions: [10, 50, 100],
                    fields: [
                        {
                            name: 'Edge Device Name',
                            column: 'deviceFriendlyName'
                        },
                        {
                            name: 'License Key',
                            column: 'licenseKey',
                            transformation: function (row) {
                                return row.licenseKey || 'N/A';
                            }
                        },
                        {
                            name: 'License SKU',
                            column: 'licenseSku',
                        },
                        {
                            name: 'Type',
                            column: 'isCore',
                            transformation: function (row) {
                                return row.isCore === true ? 'Core' : 'Add-on';
                            }
                        }
                    ]
                };

                // Init pagination object
                vm.itemsPagination = {
                    limitOptions: vm.listSetup.limitOptions,
                    limit: vm.listSetup.limit,
                    page: 1
                };

                // Filter actions
                vm.filterActions = [
                    {
                        label: 'Refresh',
                        name: 'refresh',
                        icon: 'refresh',
                        buttonClick: vm.refreshList
                    },
                    {
                        label: 'Upload licenses CSV',
                        name: 'upload',
                        icon: 'file_upload',
                        buttonClick: function (event) {
                            vm.upload(event);
                        }
                    }
                ];

                // License actions
                vm.licenseActions = [
                    {
                        name: 'Delete selected licenses',
                        icon: 'delete',
                        function: vm.removeItems
                    }
                ];

                /** 
                 * For NEW license add options:
                    - Add "Delete" option
                    - Remove "Edge Device Name" from the list
                 */
                if (vm.status === 'NEW') {
                    vm.listSetup.rowSelection = true;
                    vm.listSetup.multipleSelection = true;

                    // Remove Edge Device Name from the list
                    vm.listSetup.fields = vm.listSetup.fields.filter(function (field) {
                        return field.column !== 'deviceFriendlyName';
                    });

                    // List action
                    vm.additionalActions = [{
                        name: 'Delete',
                        icon: 'delete',
                        function: function (event, item) {
                            vm.removeItems(event, [item]);
                        }
                    }];
                }
                /**
                 * For licenses that are not NEW remove options:
                    - Upload licenses CSV
                */
                if (vm.status !== 'NEW') {
                    vm.filterActions = vm.filterActions.filter(function (action) {
                        return action.name !== 'upload';
                    });
                }

                vm.refreshList();
            };

            /**
             * Refresh the license list
             */
            vm.refreshList = function () {
                vm.selectedItems = [];
                vm.listPromise = Service.api.deviceLicensePoolList({
                    projectId: vm.projectId,
                    requestedPage: vm.itemsPagination.page - 1,
                    limit: vm.itemsPagination.limit,
                    filter: vm.filterStr || null,
                    status: vm.status
                }).$promise;

                vm.listPromise
                    .then(function (response) {
                        vm.licenseList = response.elements;
                        vm.totalSize = response.totalSize;
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Get license list failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error deviceLicensePoolList:' + JSON.stringify(reason));
                    });
            };

            /**
             * Upload list of licenses from CSV file
             * @param {Event} event - Selection event from fileUpload component
             * @returns {void}
             */
            vm.upload = function (event) {
                // Create an isolated scope to pass to the component
                var scope = angular.extend($scope.$new(true), {
                    title: 'Upload license keys',
                    exampleLink: '/scripts/components/license/license-upload-example.csv',
                });

                $mdDialog.show({
                    template: '<md-dialog style="max-width:300px;"><md-dialog-content>' +
                        '<upload-file-dialog title="title" example-link="exampleLink">' +
                        '</upload-file-dialog></md-dialog-content></md-dialog>',
                    parent: angular.element(document.body),
                    targetEvent: event,
                    clickOutsideToClose: false,
                    scope: scope,
                    preserveScope: true,
                    skipHide: true,
                })
                    .then(function (data) {
                        if (data && data.fileData) {
                            Service.api.deviceLicensePoolCsvUpload({
                                projectId: vm.projectId,
                            }, data.fileData).$promise
                                .then(function () {
                                    Commons.toastShow('Licenses imported');
                                    vm.refreshList();
                                })
                                .catch(function (reason) {
                                    var messageObject = Commons.createErrorObject(reason, 'Import failed');
                                    Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                                    console.log('Error deviceLicensePoolCsvUpload:' + JSON.stringify(reason));
                                });
                        }
                    });
            };

            /**
             * Remove item from the list
             * @param {Event} event - click event
             * @param {Object} item - license object
             */
            vm.removeItems = function (event, items) {
                var _deleteFunction = function () {
                    var _deleteUrl = appConfig.apiUrl + 'api/v' + appConfig.apiVersion + '/device-license-pool?projectId=' + vm.projectId;

                    $http({
                        method: 'DELETE',
                        url: _deleteUrl,
                        data: {
                            licenseKeys: items.map(function (item) {
                                return item.licenseKey;
                            })
                        },
                        headers: { 'Content-Type': 'application/json' }
                    })
                        .then(function () {
                            Commons.toastShow('License removed');
                            vm.refreshList();
                        })
                        .catch(function (reason) {
                            var messageObject = Commons.createErrorObject(reason, 'Delete license failed');
                            Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                            console.log('Error deviceLicensePoolDelete:' + JSON.stringify(reason));
                        });
                };

                Commons.showConfirmationWarn(
                    gettextCatalog.getString('Remove confirmation'),
                    gettextCatalog.getString('Are you sure you want to remove ' + items.length + ' license ' + (items.length > 1 ? 'keys?' : 'key?')),
                    gettextCatalog.getString('Yes, remove'),
                    _deleteFunction,
                    gettextCatalog.getString('No'),
                    null,
                    event);
            };

            /**
             * Filter on filter change
             * @param {string} filterStr - filter string
             */
            vm.filterHandler = function (filterStr) {
                vm.filterStr = filterStr;
                vm.itemsPagination.page = 1; // Reset page to 1 on filtering
                vm.refreshList();
            };

            /**
             * Update pagination object and run list refresh
             * @param {Object} paginationObject - pagination object
             * @return {void}
             */
            vm.paginationHandler = function (paginationObject) {
                vm.itemsPagination = paginationObject;
                vm.refreshList();
            };

            /**
             * Handler for license selection
             * @param {Array} items - list of selected license items 
             */
            vm.onLicenseSelect = function (items) {
                vm.selectedItems = items;
            };

            /**
             * Hides the dialog
             * @returns {void}
             */
            vm.hide = function () {
                $mdDialog.hide();
            };
        }
    });
'use strict';
/**
 * @ngdoc component
 * @name loopUiApp.component:featureListDialog
 * @description
 * # featureListDialog
 */
angular.module('loopUiApp')
    .component('featureListDialog', {
        templateUrl: '../scripts/components/license/featureListDialog/featureListDialog.html',
        bindings: {
            deviceId: '<'
        },
        controller: function ($stateParams, $mdDialog, Service, Commons) {
            var vm = this;

            vm.$onInit = function () {
                vm.refreshFeatureList();
            };

            /**
             * Refresh feature list
             * @returns {void}
             */
            vm.refreshFeatureList = function () {
                vm.featureListPromise = Service.api.deviceLicenseFeatureList({
                    projectId: $stateParams.projectId,
                    deviceId: vm.deviceId
                }).$promise;

                vm.featureListPromise.then(function (data) {
                    vm.featureList = data;
                })
                .catch(function (reason) {
                    var messageObject = Commons.createErrorObject(reason, 'Get feature list failed');
                    Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                    console.log('Error deviceLicenseFeatureList:' + JSON.stringify(reason));
                });
            };

            /**
             * Hides the dialog
             * @returns {void}
             */
            vm.hide = function () {
                $mdDialog.hide();
            };
        }
    });
'use strict';
/**
 * @ngdoc component
 * @name loopUiApp.component:licenseApplySummary
 * @description
 * # licenseApplySummary
 */
angular.module('loopUiApp')
    .component('licenseApplySummary', {
        templateUrl: '../scripts/components/license/licenseApplySummary/licenseApplySummary.html',
        bindings: {
            selectedDevices: '<',
            selectedSkus: '<'
        },
        controller: function () {}
    });
'use strict';
/**
 * @ngdoc component
 * @name loopUiApp.component:licenseDeployDialog
 * @description
 * # licenseDeployDialog
 */
angular.module('loopUiApp')
    .component('licenseDeployDialog', {
        bindings: {
            preselectedDevices: '<',
        },
        templateUrl: '../scripts/components/license/licenseDeployDialog/licenseDeployDialog.html',
        controller: function ($stateParams, $state, $mdDialog, gettextCatalog, ServiceAsyncTask, Service, Commons) {
            var vm = this;
            vm.selectedDevices = [];
            vm.selectedSkus = [];
            vm.licenseList = [];
            vm.currentStep = 0;
            vm.currentStepCode = 'DEVICES';
            // Flag to show if there is a license that can not be applied to the selected number of devices
            vm.isUncapableSkuExists = false;

            vm.$onInit = function () {
                vm.companyName = $stateParams.companyName;
                vm.projectId = $stateParams.projectId;

                //Wizard steps
                vm.wizardSetup = {
                    wizardName: null,
                    steps: [
                        {
                            code: 'DEVICES',
                            name: 'Select Devices',
                            description: gettextCatalog.getString('Select Target Device(s)'),
                        },
                        {
                            code: 'LICENSE',
                            name: 'License',
                            description: gettextCatalog.getString('Select license SKU to deploy'),
                        },
                        {
                            code: 'REVIEW',
                            name: 'Review',
                            description: gettextCatalog.getString('Review and Run'),
                        },
                        {
                            code: 'RESULT',
                            name: 'Result',
                            description: gettextCatalog.getString('Result'),
                            icon: 'flag'
                        }
                    ]
                };

                if (vm.preselectedDevices && vm.preselectedDevices.length) {
                    // Remove devices step if devices are preselected
                    vm.wizardSetup.steps = vm.wizardSetup.steps.filter(function (item) {
                        return item.code !== 'DEVICES';
                    });
                    vm.currentStepCode = 'LICENSE';
                    vm.onDeviceSelect(vm.preselectedDevices);
                }

                // Setup license list
                vm.licenseListSetup = {
                    sortField: 'licenseSku',
                    showIndex: false,
                    editable: false,
                    removable: false,
                    rowSelection: true,
                    multipleSelection: false,
                    limit: 10,
                    limitOptions: [10, 50, 100],
                    selectionDisabledFunction: function (item) {
                        return item.count < vm.selectedDevices.length;
                    },
                    fields: [
                        {
                            name: 'License SKU',
                            column: 'licenseSku',
                        },
                        {
                            name: 'Number of Keys',
                            column: 'count',
                        }
                    ]
                };

                // Setup result list
                vm.resultListSetup = {
                    sortField: 'name',
                    showIndex: false,
                    editable: false,
                    removable: false,
                    limit: 10,
                    limitOptions: [10, 50, 100],
                    fields: [
                        {
                            name: 'Edge Device Id',
                            column: 'deviceId',
                            link: true,
                            limit: 5,
                            style: '{"width": "50px"}',
                            fieldAction: function (item) {
                                $state.go('deviceView', {
                                    companyName: vm.companyName,
                                    projectId: vm.projectId,
                                    deviceId: item.deviceId,
                                    selectedTab: 'apps'
                                });
                            }
                        },
                        {
                            name: 'Friendly Name',
                            column: 'devicePrettyName'
                        },
                        {
                            name: 'Message',
                            column: 'msg'
                        },
                        {
                            name: 'Status',
                            label: function (item) {
                                return item.status;
                            },
                            iconButton: true,
                            style: '{"width": "50px"}',
                            iconName: function (item) {
                                switch (item.status) {
                                    case 'NEW':
                                        return 'schedule';
                                    case 'ERROR':
                                        return 'highlight_off';
                                    case 'SUCCESS':
                                        return 'check_circle_outline';
                                    default:
                                        return 'help_outline';
                                }
                            }
                        }
                    ]
                };

                vm.refreshLicenseList();
            };

            /**
             * Refresh the license list
             */
            vm.refreshLicenseList = function () {
                vm.licenseListPromise = Service.api.deviceLicensePoolSkus({
                    projectId: vm.projectId,
                    status: 'NEW'
                }).$promise;

                vm.licenseListPromise
                    .then(function (data) {
                        vm.licenseList = data;
                        if (vm.selectedDevices && vm.selectedDevices.length) {
                            vm.onDeviceSelect(vm.selectedDevices);
                        }
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Get unused licenses failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error deviceLicensePoolSkus:' + JSON.stringify(reason));
                    });
            };

            /**
             * Check current step for validity.
             *
             * @param {number} step                 - Step number
             * @returns {boolean}                   - True if step data pass validation.
             */
            vm.stepInvalid = function (code) {
                switch (code) {
                    case 'DEVICES':
                        return vm.selectedDevices.length === 0;
                    case 'LICENSE':
                        return vm.selectedSkus.length === 0;
                    default:
                        return false;
                }
            };

            /**
             * Go to previous step
             *
             * @returns {void}
             */
            vm.previousStep = function () {
                if (vm.currentStep === 0) {
                    return;
                }
                vm.currentStep--;
                vm.currentStepCode = vm.wizardSetup.steps[vm.currentStep].code;
            };

            /**
             * Go to the next step
             *
             * @returns {void}
             */
            vm.nextStep = function () {
                if (vm.currentStep === vm.wizardSetup.steps.length - 1) {
                    return;
                }
                vm.currentStep++;
                vm.currentStepCode = vm.wizardSetup.steps[vm.currentStep].code;
            };

            /**
             * Check if is last step of wizard
             *
             * @returns {boolean}           - True if this is last step
             */
            vm.isLastStep = function () {
                return vm.currentStep === vm.wizardSetup.steps.length - 1;
            };

            /**
             * Select devices callback
             * @param {Array} devices - list of devices 
             */
            vm.onDeviceSelect = function (devices) {
                vm.selectedDevices = angular.copy(devices);
                // Check SKU list and find if there is a license that can not be applied to the selected number of devices
                vm.isUncapableSkuExists = vm.licenseList.some(function (item) {
                    return item.count < devices.length;
                });
            };

            /**
             * Select licenses callback
             * @param {Array} licenses - list of selected licenses
             */
            vm.onLicenseSelect = function (licenses) {
                vm.selectedSkus = licenses;
            };

            /**
             * Create a new async task to deploy licenses to selected devices
             */
            vm.deploy = function () {
                // Open result tab
                vm.nextStep();

                vm.launchResult = vm.initLaunchResultList(vm.selectedDevices, 'Deploying licenses...', 'NEW');

                vm.launchPromise = ServiceAsyncTask.createTaskAndWait(
                    ServiceAsyncTask.taskTypes.LICENSE_APPLY.code, // Task type
                    ServiceAsyncTask.taskTypes.LICENSE_APPLY.subtaskTypes, // Subtask types
                    '',  // Task description 
                    vm.selectedDevices,
                    {
                        licenseSku: vm.selectedSkus[0].licenseSku
                    },   // Task params
                    false // Wait device for online
                );

                vm.launchPromise
                    .then(function (task) {
                        if (!task || !task.id) {
                            return;
                        }
                        // Get subtasks for current task
                        return Service.api.asyncSubtaskList({
                            action: task.id
                        }).$promise;
                    })
                    .then(function (data) {
                        // If no subtasks, then show error
                        if (!data || !data.length) {
                            vm.initLaunchResultList(vm.selectedDevices, '', 'ERROR');
                            return;
                        }
                        // Get launch results from subtasks
                        vm.launchResult = data.map(function (item) {
                            return {
                                deviceId: item.deviceId,
                                devicePrettyName: item.devicePrettyName,
                                msg: item.msg,
                                status: item.status
                            };
                        });
                    })
                    .catch(function (reason) {
                        if (!reason) { // If not reason provided, then task was canceled
                            return;
                        }
                        console.log('License deploy failure:' + JSON.stringify(reason));
                        var messageObject = Commons.createErrorObject(reason, 'License deploy failure');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                    });
            };

            /**
             * Init launch result list
             * @param {Array} deviceList - selected device list for launch 
             * @param {String} msg - state message 
             * @param {String} status - application status
             * @returns {Array} empty launch list
             */
            vm.initLaunchResultList = function (deviceList, msg, status) {
                if (!deviceList || !angular.isArray(deviceList)) {
                    return [];
                }
                return deviceList.map(function (item) {
                    return {
                        deviceId: item.deviceId,
                        devicePrettyName: item.prettyName,
                        msg: msg,
                        status: status
                    };
                });
            };

            /**
             * Cancel dialog button
             * @return {void}
             */
            vm.cancel = function () {
                $mdDialog.cancel(false);
            };
        }
    });
'use strict';
/**
 * @ngdoc component
 * @name loopUiApp.component:licenseSendReportDialog
 * @description
 * # licenseSendReportDialog
 */
angular.module('loopUiApp')
    .component('licenseSendReportDialog', {
        templateUrl: '../scripts/components/license/licenseSendReportDialog/licenseSendReportDialog.html',
        controller: function ($timeout, $mdDialog) {
            var vm = this;
            vm.recipients = [];

            vm.$onInit = function () {
                $timeout(vm.performArrayValidation, 0);
            };

            /**
             * Validates an email address
             * 
             * @param {string} email 
             * @returns 
             */
            vm.validateEmail = function (email) {
                // Src https://emailregex.com/
                var reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return reg.test(email);
            };

            /**
             * Performs overall validation and sets isValid attribute for action
             */
            vm.performArrayValidation = function () {
                var hasInvalidEmail = vm.recipients.some(function (recipient) {
                    return !vm.validateEmail(recipient);
                });
                if (vm.form.emailField) {
                    vm.form.emailField.$setValidity('emailInvalid', !hasInvalidEmail);
                    vm.form.emailField.$setValidity('emailEmpty', vm.recipients.length > 0);
                }
            };

            /**
             * Close dialog and send list of recipients
             */
            vm.send = function () {
                $mdDialog.hide(vm.recipients);
            };

            /**
             * Close dialog windows
             * @return {undefined}
             */
            vm.hide = function () {
                $mdDialog.hide();
            };
        }
    });
'use strict';

/**
 * @ngdoc component
 * @name loopUiApp.component:valueTotalSparkline
 * @description
 * # valueTotalSparkline
 */
angular.module('loopUiApp')
    .component('valueTotalSparkline', {
        bindings: {
            data: '<',
            name: '<',
            subname: '<',
            value: '<',
            total: '<',
            color: '<',
            textColor: '<',
            valueColor: '<',
            totalColor: '<',
            inverted: '<',
            tooltipText: '<'
        },
        templateUrl: '../scripts/components/valueTotalSparkline/valueTotalSparkline.html',
        controller: function ($stateParams) {

            var vm = this;
            //Current project
            vm.projectId = $stateParams.projectId;
            vm.options = {
                chart: {
                    type: 'sparklinePlus',
                    height: 100,
                    margin: {
                        top: 10,
                        bottom: 0,
                        left: 0,
                        right: 0
                    },
                    sparkline: {
                        showMinMaxPoints: false,
                        showCurrentPoint: false
                    },
                    showLastValue: false,
                    color: function () { return !vm.inverted ? vm.color || 'rgba(70, 182, 123, .5)' : 'rgb(255, 255, 255)'; },
                    x: function(d, i){return i;},
                    xTickFormat: function(d) {
                        return d3.time.format('%x')(new Date(vm.data[d].x));
                    },
                    duration: 50,
                    noData: ''
                },
                title: {
                    enable: true,
                    text: vm.name,
                    css: {
                        color: vm.inverted ? 'rgba(255, 255, 255, 1)' : 'rgba(0, 0, 0, .5)',
                        'white-space': 'nowrap',
                        'overflow-x': 'hidden',
                        'text-overflow': 'ellipsis',
                        'margin': '0 8px'
                    }
                },
                subtitle: {
                    enable: vm.subname ? true : false,
                    text: vm.subname,
                    className: 'md-caption',
                    css: {
                        color: vm.inverted ? 'rgba(255, 255, 255, 1)' : 'rgba(0, 0, 0, .5)',
                        'margin': '0 8px',
                        'white-space': 'nowrap',
                        'overflow-x': 'hidden',
                        'text-overflow': 'ellipsis'
                    }
                },
                styles: {
                    css: {
                        'stroke-width': 2
                    }
                }
            };

            vm.$onInit = function () {
                if (!vm.data) {
                    vm.data = [];
                }
            };

            vm.$onDestroy = function () {

            };


        }
    });

'use strict';

/**
 * @ngdoc component
 * @name loopUiApp.component:stackedAreaChart
 * @description
 * # stackedAreaChart
 */
angular.module('loopUiApp')
    .component('stackedAreaChart', {
        bindings: {
            data: '<',
            name: '<',
            value: '<',
            total: '<',
            colors: '<',
            textColor: '<',
            inverted: '<',
            yDomain: '<',
            rate: '<'
        },
        templateUrl: '../scripts/components/stackedAreaChart/stackedAreaChart.html',
        controller: function ($stateParams) {

            var vm = this;
            //Current project
            vm.projectId = $stateParams.projectId;

            vm.haveRate = function () {
                return !Number.isNaN(Number(vm.rate));
            };

            vm.$onInit = function () {
                // Config options http://krispo.github.io/angular-nvd3/#/quickstart
                vm.config = {
                    deepWatchOptions: true
                };

                vm.options = {
                    chart: {
                        type: 'stackedAreaChart',
                        height: 250,
                        margin: {
                            top: 40,
                            bottom: 40,
                            left: vm.haveRate() ? 0 : 40,
                            right: 30
                        },
                        color: vm.colors,
                        x: function (d) { return d[0]; },
                        y: function (d) { return d[1]; },
                        useVoronoi: false,
                        clipEdge: true,
                        transitionDuration: 500,
                        useInteractiveGuideline: true,
                        xAxis: {
                            showMaxMin: false,
                            tickFormat: function (d) {
                                return d3.time.format('%X')(new Date(d));
                            }
                        },
                        yAxis: {
                            tickFormat: function (d) {
                                return d3.format('.2s')(d);
                            }
                        },
                        forceY: [0],
                        showControls: false
                    },
                    title: {
                        enable: false,
                        text: vm.name
                    },
                    styles: {
                        css: {
                            'stroke-width': 0.5
                        }
                    }
                };

                if (!vm.data) {
                    vm.data = [];
                }
            };

            vm.$onChanges = function (changes) {
                if (changes.yDomain && changes.yDomain.currentValue) {
                    vm.options.chart.yDomain = changes.yDomain.currentValue;
                }
            };


        }
    });

'use strict';

/**
 * @ngdoc component
 * @name loopUiApp.component:totalLastPanel
 * @description
 * # totalLastPanel
 */
angular.module('loopUiApp')
    .component('totalLastPanel', {
        bindings: {
            name: '<',
            last: '<',
            total: '<',
            textColor: '<',
            formatter: '<'
        },
        templateUrl: '../scripts/components/totalLastPanel/totalLastPanel.html',
        controller: function ($stateParams) {

            var vm = this;
            //Current project
            vm.projectId = $stateParams.projectId;


            vm.$onInit = function () {

            };

            vm.$onDestroy = function () {

            };

            vm.formatValue = function (value) {
                return !vm.formatter ? value : vm.formatter(value);
            };


        }
    });

'use strict';

/**
 * @ngdoc component
 * @name loopUiApp.component:counterPanel
 * @description
 * # counterPanel
 */
angular.module('loopUiApp')
    .component('counterPanel', {
        bindings: {
            name: '<',
            value: '<',
            valueDefinition: '<',
            textColor: '<'
        },
        templateUrl: '../scripts/components/counterPanel/counterPanel.html',
        controller: function ($stateParams) {

            var vm = this;
            //Current project
            vm.projectId = $stateParams.projectId;


            vm.$onInit = function () {

            };

            vm.$onDestroy = function () {

            };


        }
    });

'use strict';

/**
 * @ngdoc component
 * @name loopUiApp.component:confirm
 * @description
 * # confirmation for changing email or psw 
 */
angular.module('loopUiApp')
    .component('confirm', {
        templateUrl: '../scripts/components/user/emailConfirmation.html',
        controller: function (Service, $stateParams) {

            var vm = this;
            vm.token = $stateParams.token;
            vm.json = {};

            //uncode token
            vm.status = {
                success: false,
                error: false,
                type: '',
                showConfirm: false,
                res: ''
            };

            //try to parse to json if fail show error 
            try {
                vm.json = atob(vm.token);
                vm.json = JSON.parse(vm.json);
            }
            catch (err) {
                vm.status.error = true;
                return;
            }
            /**
             * if type is password show password component else verify code
             */

            vm.status.type = vm.json.type;
            switch (vm.json.type) {
            case 'EMAIL_UPDATED':
            case 'USER_REGISTERED':
            case 'USER_INVITED':
                Service.api.confirmEmail({ code: vm.json.code }).$promise
                    .then(function (res) {
                        vm.status.success = true;
                        vm.status.res = res ? res.message : 'Your email has been activated';
                    }, function (reason) {
                        console.log('Error confirmEmail:' + JSON.stringify(reason));
                        vm.status.error = true;
                        vm.status.res = reason.data ? reason.data.message : 'Add action failure';
                    });            
                break;
            case 'PASSWORD_RECOVERY':
                vm.json = vm.json;
                break;
            default:
                vm.status.error = true;
                break;
            }

        }
    });


'use strict';
/**
 * @ngdoc Component for invite link. Redirect to company page
 * @name loopUiApp.component:invite
 * @description
 * # invite
 */
angular.module('loopUiApp')
    .component('invite', {
        templateUrl: '../scripts/components/user/invite/invite.html',
        controller: function ($stateParams, $state, $location, Commons) {
            var vm = this;

            vm.$onInit = function () {
                vm.companyName = $stateParams.companyName;
                if (vm.companyName) {
                    Commons.companySelect({
                        companyName: vm.companyName,
                        name: vm.companyName,
                        baseUrl: $location.host(),
                        needReload: true,
                        isBaseUrl: !(vm.companyName),
                        profile: null
                    });
                } else {
                    $state.go('companyNotAvailable');
                }
            };
        }
    });
'use strict';

/**
 * @ngdoc component
 * @name loopUiApp.component:sideNavLeft
 * @description
 * # sideNavLeft
 */
angular.module('loopUiApp')
    .component('sideNavLeft', {
        templateUrl: '../scripts/components/toolbar/sideNavLeft.html',
        controller:
            function sideBar($scope, $state, $stateParams, appConfig, menu, $transitions, $mdMedia, Service, Commons) {
                var vm = this;
                vm.cm = Commons;
                //functions for menu-link and menu-toggle
                vm.autoFocusContent = false;
                vm.menu = menu;
                //set current state name to menu link
                vm.menu.link = $state.$current.name;
                //Logo link
                vm.logoLink = '/images/' + appConfig.__env.logoTopName;
                vm.logoSmallLink = '/images/' + appConfig.__env.logoSmallTopName;
                vm.logoBottomLink = '/images/' + appConfig.__env.logoBottomName;
                vm.showPoweredBy = appConfig.__env.showPoweredBy;
                vm.companyName = appConfig.__env.companyName;
                vm.productName = appConfig.__env.productName;

                //Component init
                vm.$onInit = function () {
                    vm.year = new Date().getFullYear();

                    vm.status = {
                        isFirstOpen: true,
                        isFirstDisabled: false
                    };
                };

                // Handle route changes
                $transitions.onSuccess({}, function (res) {
                    Commons.viewScope = $stateParams.viewScope;
                    // If company change, reload company data
                    if (Commons.viewScope === 'company' && (!Commons.companyData || !Commons.companyData.profile) ||
                        (Commons.companyData && Commons.companyData.currentCompany && Commons.companyData.currentCompany !== $stateParams.companyName)) {
                        vm.restoreSelectedCompany();
                    }
                    // If project change, reload select project data
                    if (Commons.viewScope === 'project' && !Commons.companyData.project ||
                        Commons.companyData.project && Commons.companyData.project.id !== $stateParams.projectId) {
                        vm.restoreSelectedProject();
                    }
                    //on state change set current state name to menu link
                    var currentState = res.to();
                    vm.menu.link = currentState.name === 'deviceView' ? 'devices' : currentState.name;
                });

                /**
                * Apply slim nav if media size is on the phone 
                */
                $scope.$watch(function () { return $mdMedia('gt-md'); }, function (gtMedium) {
                    if (gtMedium === true) {
                        vm.cm.isFullMenu = true;
                    } else {
                        vm.cm.isFullMenu = false;
                    }
                });

                vm.stateChange = function (link) {
                    Commons.stateChange(link);
                };

                vm.isOpen = function (section) {
                    return menu.isSectionSelected(section);
                };

                vm.toggleOpen = function (section) {
                    menu.toggleSelectSection(section);
                };

                /**
                 * Filter disabled first level menu items from config file
                 * @param {Object} menuItem - menu item object
                 * @returns {boolean} - True if the menu item is enabled.
                 */
                vm.filterMenu = function (menuItem) {
                    var disabledMenuItems = appConfig.disabledMenuItems || [];
                    if (disabledMenuItems.length === 0) {
                        return true;
                    }
                    return disabledMenuItems.indexOf(menuItem.link) < 0;
                };

                /**
                 * Restore selected project object
                 * @returns {void}
                 */
                vm.restoreSelectedProject = function () {
                    if (!$stateParams.projectId) {
                        return;
                    }
                    Service.api.projectGetById({
                        action: $stateParams.projectId
                    }).$promise
                        .then(function (data) {
                            Commons.companyData.project = data;
                        })
                        .catch(function (reason) {
                            console.log('Error projectGetById:' + JSON.stringify(reason));
                        });
                };

                /**
                 * Restore selected company object
                 * @returns {void}
                 */
                vm.restoreSelectedCompany = function () {
                    if (!$stateParams.companyName) {
                        return;
                    }
                    Service.api.companyGet({
                        name: $stateParams.companyName
                    }).$promise
                        .then(function (data) {
                            Commons.setCompanyData(data);
                            Commons.refreshProjectList();
                        })
                        .catch(function (reason) {
                            console.log('Error companyGet:' + JSON.stringify(reason));
                        });
                };

                /**
                 * Open company list page
                 * @returns {void}
                 */
                vm.openCompanyList = function () {
                    $state.go('companyList');
                };
            }
    });

'use strict';
/**
 * @ngdoc component
 * @name loopUiApp.component:toolbar
 * @description
 * # toolbar
 */
angular.module('loopUiApp')
    .component('toolbar', {
        templateUrl: '../scripts/components/toolbar/toolbar.html',
        controller: function ($state, $stateParams, Auth, gettextCatalog, ServiceAsyncTask, Service, Commons, $mdDialog, Languages, appConfig, $window, billingMetrics, Connectivity) {
            var vm = this;
            //Toolbar visible sign
            vm.cm = Commons;
            vm.bm = billingMetrics;
            vm.auth = Auth;
            vm.con = Connectivity;
            vm.sp = $stateParams;
            //Use docCode value as state name
            vm.state = $state;
            vm.productName = appConfig.__env.productName;
            vm.logoLink = '/images/' + appConfig.__env.logoTopName;
            vm.documentationBaseUrl = appConfig.__env.documentationBaseUrl;
            vm.supportUrl = appConfig.__env.supportUrl;
            vm.universityUrl = appConfig.__env.universityUrl;
            vm.hideLanguageSelect = appConfig.__env.hideLanguageSelect;
            // Check if GTM is configured to show/hide the connected features (Personal Settings)
            vm.isConnectedFeaturesAvailable = !!appConfig.__env.gtmId;

            /**
             * Internationalization routines
             */
            vm.languages = Languages;
            vm.applicationLanguage = vm.languages.applicationLanguage();

            vm.$onInit = function () {
                vm.additionalActions = [
                    {
                        type: 'divider',
                    },
                    {
                        type: 'menuItem',
                        name: 'Admin Console',
                        icon: 'admin_panel_settings',
                        enable: Commons.isAdminRole,
                        function: function() {
                            window.open(Commons.getAdminUiLink(), '_blank');
                        }
                    },
                    {
                        type: 'menuItem',
                        name: 'User Manual',
                        icon: 'help',
                        enable: !!vm.documentationBaseUrl,
                        function: function() {
                            window.open(vm.documentationBaseUrl, '_blank');
                        }
                    },
                    {
                        type: 'menuItem',
                        name: 'Litmus Support',
                        icon: 'support',
                        enable: !!vm.supportUrl,
                        function: function() {
                            window.open(vm.supportUrl, '_blank');
                        } 
                    },
                    {
                        type: 'menuItem',
                        name: 'Litmus Academy',
                        icon: 'school',
                        enable: !!vm.universityUrl,
                        function: function() {
                            window.open(vm.universityUrl, '_blank');
                        }
                    },
                    {
                        type: 'menuItem',
                        name: 'View EULA',
                        icon: 'copyright',
                        enable: true,
                        function: function(event) {
                            Service.api.getEula().$promise
                            .then(function(data) {
                                Commons.showConfirmation(
                                    gettextCatalog.getString('End-user License Agreement'),
                                    data.text,
                                    gettextCatalog.getString('Close'),
                                    null,
                                    gettextCatalog.getString('Download'),
                                    function() {
                                        Commons.downloadLink(data.text, 'EULA.txt');
                                    },
                                    event,
                                    'dialog-eula');
                            });
                        }
                    },
                    {
                        type: 'divider',
                    },
                    {
                        type: 'menuItem',
                        name: 'Profile',
                        icon: 'account_circle',
                        enable: true,
                        function: function() {
                            var url = Auth.createAccountUrl();
                            window.open(url);
                        }
                    },
                    {
                        type: 'menuItem',
                        name: 'Personal Settings',
                        icon: 'settings',
                        enable: vm.isConnectedFeaturesAvailable,
                        function: vm.openPersonalSettings
                    },
                    {
                        type: 'menuItem',
                        name: 'Logout',
                        icon: 'exit_to_app',
                        enable: true,
                        function: vm.logout
                    },
                ];

                vm.refreshCompanyList();
                vm.refreshVersionInfo();
            };

            /**
             * Sets application language and if succeed then reloads window
             *
             */
            vm.setApplicationLanguage = function () {
                if (vm.languages.setApplicationLanguage(vm.applicationLanguage)) {
                    $window.location.reload();
                }
            };

            /**
             * Redirect to profile page
             */
            vm.goProfilePage = function () {
                var url = Auth.createAccountUrl();
                window.open(url);
            };

            vm.goHelpPage = function () {
                window.open(vm.documentationBaseUrl, '_blank');
            };

            /**
             * Change current project
             */
            vm.changeProject = function (project) {
                Commons.setCurrentProject(project);
                //Load project billing plan
                Commons.refreshBillingPlan(project.id);
                billingMetrics.resetUsage();
                $state.go('dashboard', { companyName: $stateParams.companyName, projectId: project.id });
            };

            /**
             * Open project list view for current company
             * @returns {void}
             */
            vm.openProjectList = function () {
                Commons.refreshProjectList();
                Commons.setCurrentProject(null);
                ServiceAsyncTask.startTaskPulling($stateParams.companyName);
                $state.go('projectList', { companyName: $stateParams.companyName });
            };
            /**
             * Open menu
             */
            vm.openMenu = function ($mdOpenMenu, ev) {
                $mdOpenMenu(ev);
            };
            /**
             * Prompt Dialog, then reload project list and current state
             */
            vm.addProjectDialog = function (event) {
                $mdDialog.show({
                    template: '<project-dialog aria-label="Add Project"></project-dialog>',
                    targetEvent: event,
                    parent: angular.element(document.body),
                    clickOutsideToClose: false,
                    preserveScope: true
                })
                    .then(function () {
                        Commons.refreshProjectList();
                        $state.reload();
                    });
            };

            /**
             * Allow user to hide notification bar for warning message
             */
            vm.closeBillingStatusBar = function () {
                billingMetrics.warningHide();
            };

            /**
             * Show notification bar in case:
             * 1) metric status is not undefined
             * 2) Status is 'I'(INFO) and user didn't hide notification
             * 3) user on project level (projectId selected)
             * @return {boolean} show/not show
             */
            vm.isBillingNotiticationShow = function () {
                var status = billingMetrics.getUsage() ? billingMetrics.getUsage().summaryStatus : null,
                    warningShow = billingMetrics.getWarningShow();
                return (status === 'E' || status === 'I' && warningShow) && $stateParams.projectId;
            };

            /**
             * Open project setting page - billing tab
             * @return {void}
             */
            vm.openBillingPage = function () {
                $state.go('settings', { companyName: $stateParams.companyName, projectId: $stateParams.projectId });
            };

            /**
             * Get company list
             * @return {void}
             */
            vm.refreshCompanyList = function () {
                Service.api.companyList().$promise
                    .then(function (data) {
                        vm.companyList = data;
                    })
                    .catch(function (reason) {
                        vm.companyList = [];
                        console.log('Add action failure:' + JSON.stringify(reason));
                    });
            };

            /**
             * Get current version info
             * @return {void}
             */
            vm.refreshVersionInfo = function () {
                Service.api.currentVersion().$promise
                    .then(function (data) {
                        vm.currentVersion = data.version || '';
                    })
                    .catch(function (reason) {
                        console.log('currentVersion failure:' + JSON.stringify(reason));
                    });
            };

            /**
             * Remove saved company name, make logout
             * @return {void}
             */
            vm.logout = function () {
                Auth.logout();
            };

            /**
             * Open user personal setting page
             * @returns {void}
             */
            vm.openPersonalSettings = function() {
                if ($stateParams.projectId) { // If project level
                    $state.go('userSettingsProject', { companyName: $stateParams.companyName, projectId: $stateParams.projectId });
                    return;
                }
                // else company level
                if ($stateParams.companyName) { // If project level
                    $state.go('userSettingsCompany', { companyName: $stateParams.companyName });
                    return;
                }
                // Else instance level
                $state.go('userSettings');
            };

            /**
             * Open company list page
             * @returns {void}
             */
             vm.openCompanyList = function () {
                $state.go('companyList');
            };
        }
    });

'use strict';
/**
 * @ngdoc component
 * @name loopUiApp.component:documentationLink
 * @description
 * # documentationLink
 */
angular.module('loopUiApp')
    .component('documentationLink', {
        bindings: {
            docCode: '<',
            param: '<'
        },
        templateUrl: '../scripts/components/toolbar/documentationLink.html',
        controller: function ($window, appConfig) {
            var vm = this;

            vm.$onInit = function () {
                vm.isDocumentationExists = !!appConfig.documentationBaseUrl;

                /** 
                Documentation map: docCode - documentationPath
                1) docCode can be Route State name
                2) docCode can be Constant which set directrly in component
                */
                vm.docCodeMap = {
                    default: 'LoopCloud+Getting+Started+Guide',
                    dashboard: 'Validate+and+Use+LoopCloud',
                    companyList: 'Create+a+Company',
                    companySettings: 'Configure+a+Company',
                    companyDialog: 'Company',
                    projectList: 'Create+a+Project+for+a+Company',
                    projectDialog: 'Project',
                    settings: {
                        teams: 'Configure+Project+Teams',
                        credentials: 'MQTT+Wildcards',
                    },
                    modelDialog: 'Model+and+Device',
                    modelList: 'Create+a+Device+Model',
                    devices: 'LoopCloud+Device+Management',
                    deviceView: 'Explore+a+LoopCloud+Device',
                    deviceObjectDialog: 'Data+Values',
                    jobs: 'Batch+Mode+Device+Management',
                    alerts: 'Alerts',
                    authList: 'Auth',
                    keyValue: 'Key-Value',
                    applicationDataEnricher: 'Data+Enricher',
                    poll: 'POLL'
                };

                //Related document
                vm.docPath = vm.getDocumentPath(vm.docCode, vm.param);
            };

            /**
             * Detect docCode change to change documentation link
             * @param {Object} changes changes object
             * @returns {void}
             */
            vm.$onChanges = function (changes) {
                if (vm.docCodeMap && (changes.docCode || changes.param)) {
                    vm.docPath = vm.getDocumentPath(vm.docCode, vm.param);
                }
            };

            /**
             * Open related documentation link
             * @return {void}
             */
            vm.openDocumentationLink = function () {
                var _url = appConfig.documentationBaseUrl; // + vm.docPath; TODO: Skip before we change docCodeMap
                $window.open(_url, '_blank');
            };

            /**
             * Get documentation path
             * @param {String} docCode document code
             * @param {String} param extended parameter 
             * @returns {String} documentation path
             */
            vm.getDocumentPath = function (docCode, param) {
                var _result = vm.docCodeMap[docCode];

                if (!_result) {
                    return vm.docCodeMap.default;
                }

                //If result is string return result
                if (typeof _result === 'string') {
                    return _result;
                }

                //If result is object try to find _result[param]
                return _result[param] || vm.docCodeMap.default;
            };
        }
    });
'use strict';
/**
 * @ngdoc component
 * @name loopUiApp.component:notificationList
 * @description
 * # notificationList
 */
angular.module('loopUiApp')
    .component('notificationList', {
        templateUrl: '../scripts/components/notification/notificationList.html',
        controller: function (ServiceNotification) {
            var vm = this;
            vm.sn = ServiceNotification;

            /**
             * Hide notification item from list
             * @param {key} - item key
             * @return {void}
             */
            vm.hideItem = function (key) {
                ServiceNotification.hideItem(key);
            };

            /**
             * Invoke notification info handler for 
             * additional information about notification
             * @param {Function} handler - item key
             * @return {void}
             */
            vm.infoHandler = function (handler) {
                if(typeof handler === 'function'){
                    handler();
                }
            };
        }
    });
'use strict';
/**
 * @ngdoc component
 * @name loopUiApp.component:notificationBar
 * @description
 * # notificationBar
 * Component that represents generic notification bar.
 *
 * Takes following as an input:
 *
 * - `icon`          - Notification bar icon from Material icon set. Type: String
 * - `statusClass`   - CSS class name for notification bar. Type: String
 * - `content`       - Text content of notification bar. Type: String
 * - `linkText`      - Link name to get aditional notification info. Type: String
 *
 * and uses the following as an output:
 *
 * - `onLinkClick`    - Event that emits when info link clicked
 * - `onClose`        - Event that emits when close icon clicked
 *
 */
angular.module('loopUiApp')
    .component('notificationBar', {
        bindings: {
            icon: '<',
            statusClass: '<',
            content: '<',
            linkText: '<',
            onLinkClick: '&',
            onClose: '&',
        },
        templateUrl: '../scripts/components/notification/notificationBar.html',
        controller: function ($attrs) {
            var vm = this;
            vm.attrs = $attrs;
        }
    });
'use strict';

/**
 * @ngdoc component
 * @name loopUiApp.component:companyList
 * @description
 * # companyList
 */
angular.module('loopUiApp')
    .component('companyList', {
        templateUrl: '../scripts/components/company/companyList.html',
        controller: function ($mdDialog, $state, $timeout, $interval, featuresCheck, ServiceAsyncTask, Service, Commons) {
            var vm = this;
            vm.companyList = [];
            vm.companyStats = {};
            vm.dtFeatureCode = 'DigitalTwin';
            vm.cm = Commons;
            // Feature check service
            vm.fc = featuresCheck;
            vm.isDtAvailable = false;
            // Flag allows to reinit grid in order to redraw it. This is necessary to change
            vm.initFlag = true;

            // System time variables
            vm.currentTime = null;
            vm.uptimeMs = null;

            vm.$onInit = function () {
                Commons.setCompanyData(null);
                // Stop async task pulling if it is running
                ServiceAsyncTask.stopTaskPulling();

                vm.refreshData();

                vm.entityName = 'Companies';
                vm.newEntityTooltip = 'Create a company';

                vm.gridSetup = {
                    sortField: 'name',
                    showIndex: true,
                    editable: false,
                    removable: false,
                    rowHeight: 230,
                    limit: 11,
                    limitOptions: [10, 50, 100],
                    cardType: 'companyCard',
                    itemClickable: true,
                    dataMapping: {
                        title: {
                            column: 'name',
                            transformation: function (item) {
                                return item.realName || item.name;
                            }
                        },
                        subtitle: {
                            column: 'description'
                        },
                        content: {
                            column: 'name',
                            transformation: function (item) {
                                return vm.companyStats && vm.companyStats[item.name] ? vm.companyStats[item.name] : null;
                            }
                        }
                    },
                };
                vm.additionalActions = [
                    {
                        name: 'Edge Lifecycle Management',
                        icon: 'computer',
                        description: 'Open "Edge Lifecycle Management" page',
                        visible: function () {
                            return vm.isDtAvailable;
                        },
                        class: 'grid-card__link-primary',
                        function: vm.openGenericView
                    },
                    {
                        name: 'Asset Management',
                        icon: 'conveyor_belt',
                        description: 'Open "Asset Management" page',
                        visible: function () {
                            return vm.isDtAvailable;
                        },
                        class: 'grid-card__link-secondary',
                        function: vm.openDigitalTwinsView
                    }
                ];

                // Filtered list of item. Hide items which are not visible
                vm.additionalActionsFiltered = vm.filterAdditionalActions(vm.additionalActions);

                vm.filterActions = [{
                    label: 'Refresh',
                    icon: 'refresh',
                    buttonClick: vm.refreshData
                }];

                // Run experimental feature check 
                if (featuresCheck.isFirstLoading()) { // On first load wait feature availability
                    featuresCheck.loadExperimentalFeatures()
                        .then(function (data) {
                            featuresCheck.setExperimentalFeatures(data);
                            vm.isDtAvailable = featuresCheck.isFeatureAvailable(vm.dtFeatureCode);
                            vm.additionalActionsFiltered = vm.filterAdditionalActions(vm.additionalActions);
                            vm.reInitGrid();
                        });
                } else {
                    vm.isDtAvailable = featuresCheck.isFeatureAvailable(vm.dtFeatureCode);
                    vm.additionalActionsFiltered = vm.filterAdditionalActions(vm.additionalActions);
                    vm.reInitGrid();
                }

                vm.refreshSystemTime();
                //Auto update messages limits, status data, alerts, system time
                vm.refreshInterval = $interval(function () {
                    vm.refreshSystemTime();
                }, 10000);
            };

            vm.$onDestroy = function () {
                $interval.cancel(vm.refreshInterval);
            };

            /**
             * Refresh company list and company stats
             */
            vm.refreshData = function () {
                vm.refreshCompanyList();
                vm.refreshStats();
            };

            /**
             * Reinit grid in order to redraw it
             */
            vm.reInitGrid = function () {
                vm.initFlag = false;
                $timeout(function () {
                    vm.gridSetup.rowHeight = vm.isDtAvailable ? 230 : 185;
                    vm.initFlag = true;
                }, 0);
            };

            /**
             * Filter list of items to remove invisible items
             * @param {Array} items - card actions
             * @returns 
             */
            vm.filterAdditionalActions = function (items) {
                return items.filter(function (item) {
                    return item.visible();
                });
            };

            /**
             * Get company list
             * @return {void}
             */
            vm.refreshCompanyList = function () {
                vm.companyListPromise = Service.api.companyList().$promise;

                vm.companyListPromise
                    .then(function (data) {
                        vm.companyList = data;
                    })
                    .catch(function (reason) {
                        vm.companyList = [];
                        var messageObject = Commons.createErrorObject(reason, 'Get company list failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error companyList:' + JSON.stringify(reason));
                    });
            };

            /**
             * Get stats for companies
             * @return {void}
             */
            vm.refreshStats = function () {
                Service.api.companyListStats().$promise
                    .then(function (data) {
                        if (data) {
                            data.forEach(function (stat) {
                                vm.companyStats[stat.companyName] = [{
                                    name: 'Projects',
                                    value: stat.totalNumOfProjects || 0,
                                    visible: function () {
                                        return true;
                                    }
                                },
                                {
                                    name: 'Edge Devices',
                                    value: (stat.numOfOnlineDevices || 0) + ' / ' + (stat.totalNumOfDevices || 0), // + ' (online / total)',
                                    description: 'Online / Total',
                                    visible: function () {
                                        return true;
                                    }
                                },
                                {
                                    name: 'Digital Twins Models',
                                    value: stat.totalNumOfModels || 0,
                                    visible: function () {
                                        return vm.isDtAvailable;
                                    }
                                }];
                            });
                        }
                    })
                    .catch(function (reason) {
                        console.log('companyStats failure:' + JSON.stringify(reason));
                    });
            };

            /**
             * Company edit window function
             * @param {event} event object
             * @param {Object} company object
             * @return {undefined} 
             */
            vm.showCompanyDialog = function (event, company) {
                $mdDialog.show({
                    template: '<company-dialog class="descriptiveDialog" aria-label="Company"></company-dialog>',
                    parent: angular.element(document.body),
                    targetEvent: event,
                    clickOutsideToClose: false,
                    preserveScope: true,
                    resolve: {
                        //Send company to settings window
                        company: function () {
                            return company;
                        }
                    }
                })
                    .then(function () {
                        $state.reload();
                    });
            };

            /**
             * Open Digital Twins view
             * @param {Object} event - mouse click event
             * @param {Object} company - company object
             */
            vm.openDigitalTwinsView = function (event, company) {
                Commons.assetsSelect(company);
                $state.go('dtModelList', { companyName: company.name });
            };

            /**
             * Open generic LEM view (Edge device management)
             * @param {Object} event - mouse click event
             * @param {Object} company - company object
             */
            vm.openGenericView = function (event, company) {
                Commons.companySelect(company);
            };

            /**
             * Filter company list based on search criteria
             *
             * @param {string} searchText    - Search string
             * @return {void}
             */
            vm.filter = function (searchText) {
                vm.searchText = searchText;
            };

            /**
             * Function for filtering list of providers 
             * @param {Object} row - list item 
             * @returns {Boolean} - is item satisfies filter
             */
            vm.filterList = function (row) {
                if (!vm.searchText) {
                    return true;
                }
                return row.name.toLowerCase().indexOf(vm.searchText.toLowerCase()) >= 0;
            };

            /**
             * Refresh system time
             */
            vm.refreshSystemTime = function () {
                Service.api.systemTime().$promise
                    .then(function (data) {
                        vm.currentTime = data.time;
                        vm.uptimeMs = data.uptimeMs;
                    })
                    .catch(function (reason) {
                        console.log('refreshSystemTime failed' + JSON.stringify(reason));
                    });
            };

            /**
             * Open admin console in a new tab
             */
            vm.openAdminConsole = function () {
                window.open(Commons.getAdminUiLink(), '_blank');
            };
        }
    });
'use strict';
/**
 * @ngdoc component
 * @name loopUiApp.component:companyDialog
 * @description
 * # companyDialog
 */
angular.module('loopUiApp')
    .component('companyDialog', {
        templateUrl: '../scripts/components/company/companyDialog.html',
        binding: {
            company: '<'
        },
        controller: function ($mdDialog, $location, appConfig, Service, Commons) {
            var vm = this;
            //Create company process indicator
            vm.isLoading = false;
            //Is this version contains OEM features
            vm.oem = appConfig.__env.oem;
            //Company types
            vm.companyTypeList = ['USER', 'OEM'];
            //Company object
            vm.company = { realName: '', name: '', companyType: vm.companyTypeList[0], description: '', newCompany: true };
            //First level domain
            vm.domain = $location.host();

            /**
             * Change domain name after real company name changed
             * @param {String} name - real company name
             * @return {void}
             */
            vm.onCompanyNameChange = function (name) {
                //Change name value only for untouched name field
                if (vm.companyForm.nameField.$untouched) {
                    vm.company.name = Commons.cleanUrlText(name);
                    vm.companyForm.nameField.$setDirty();
                }
            };

            /**
             * Create new company
             * @param Object company
             */
            vm.add = function (company) {
                //Create company
                Service.api.companyValidate({ name: company.name }).$promise
                    .then(function (output) {
                        if (output.code === 'E') {
                            //show error message 
                            if (output.message) {
                                Commons.toastShow(output.message);
                            }
                        }
                        else {
                            vm.isLoading = true;
                            Service.api.company({}, company).$promise
                                .then(function () {
                                    Commons.toastShow('Company was created');
                                })
                                .catch(function (reason) {
                                    console.log('Error Company create:' + JSON.stringify(reason));
                                    var messageObject = Commons.createErrorObject(reason, 'Company creation error');
                                    Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                                })
                                .finally(function () {
                                    vm.isLoading = false;
                                    $mdDialog.hide(company.name);
                                });
                        }
                    });
            };

            /**
             * Close dialog windows
             * @return {undefined}
             */
            vm.hide = function () {
                $mdDialog.hide();
            };
            /**
             * Cancel dialog button
             * @return {undefined}
             */
            vm.cancel = function () {
                $mdDialog.cancel();
            };

        }
    });
'use strict';
/**
 * @ngdoc component
 * @name loopUiApp.component:companyNotAvailable
 * @description
 * # companyNotAvailable
 */
angular.module('loopUiApp')
    .component('companyNotAvailable', {
        templateUrl: '../scripts/components/company/companyNotAvailable.html',
        controller: function ($mdDialog, $state, $location, $timeout, Auth, Service, Commons) {
            var vm = this;
            vm.auth = Auth;
            vm.cm = Commons;
            //Company exist flag
            vm.isCompanyExists = false;
            //Company check in progress flag
            vm.isLoading = true;

            //Component init
            vm.$onInit = function () {
                vm.companyName = $state.params.companyName;
                
                vm.isLoading = true;
                //Check is company already exist
                Service.api.companyValidate({
                    name: vm.companyName
                }).$promise
                    .then(function (response) {
                        vm.isLoading = false;
                        if (response.code === 'E' &&
                            response.message.indexOf('conflicts with another company') >= 0) {
                            vm.isCompanyExists = true;
                        }
                    })
                    .finally(function () {
                        vm.isLoading = false;
                    });
            };

            /**
             * Company edit window function
             * @param {event} event object
             * @param {Object} company object
             * @return {undefined} 
             */
            vm.showCompanyDialog = function (event, company) {
                $mdDialog.show({
                    template: '<company-dialog class="descriptiveDialog" aria-label="Company"></company-dialog>',
                    parent: angular.element(document.body),
                    targetEvent: event,
                    clickOutsideToClose: false,
                    preserveScope: true,
                    resolve: {
                        //Send company to settings window
                        company: function () {
                            return company;
                        }
                    }
                })
                    .then(function (companyName) {
                        var href = $location.protocol() + '://' + companyName + '.' + $location.host().replace(/^[^\.]+\./i, '') + ':' + $location.port();
                        window.location.href = href;
                    })
                    .catch(function (reason) {
                        console.log(reason);
                    });
            };

            /**
             * Move to company list page
             * @returns {void}
             */
            vm.companyListGo = function () {
                $state.go('companyList');
            };

            /**
             * Logout function. Move to base url before logout
             * @return {void}
             */
            vm.logout = function () {
                $state.go('companyList')
                    .then(function () {
                        $timeout(function () {
                            Auth.logout();
                        }, 0);
                    });
            };
        }
    });
'use strict';
/**
 * @ngdoc component
 * @name loopUiApp.component:licenseNotification
 * @description
 * # licenseNotification
 */
angular.module('loopUiApp')
    .component('licenseNotification', {
        templateUrl: '../scripts/components/company/license/licenseNotification.html',
        controller: function ($mdDialog, Commons) {
            var vm = this;
            vm.cm = Commons;

            /**
             * Show or not license panel
             * @returns {Boolean} - show/hide flag
             */
            vm.isShow = function () {
                return Commons.licenseInfo.status === 'W';
            };

            /**
             * Show license info dialog
             * @returns {void}
             */
            vm.showDetails = function () {
                $mdDialog.show({
                    template: '<md-dialog style="width:500px;"><license-expired-dialog></license-expired-dialog></md-dialog>',
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                    preserveScope: true,
                    skipHide: true
                });
            };
        }
    });
'use strict';
/**
 * @ngdoc component
 * @name loopUiApp.component:licenseExpiredDialog
 * @description
 * # licenseExpiredDialog
 */
angular.module('loopUiApp')
    .component('licenseExpiredDialog', {
        templateUrl: '../scripts/components/company/license/licenseExpiredDialog.html',
        controller: function (appConfig, Commons) {
            var vm = this;
            vm.adminUiName = appConfig.__env.adminUiName || 'Admin Console';
            vm.adminUiLink = Commons.getAdminUiLink() + '/license';

            /**
             * Is expired check
             * @returns {Boolean} - check is license expires
             */
            vm.isLicenseExpired = function() {
                return Commons.licenseInfo.status === 'E';
            };
        }
    });
'use strict';

/**
 * @ngdoc component
 * @name loopUiApp.component:settings
 * @description
 * # settings
 */
angular.module('loopUiApp')
    .component('companySettings', {
        templateUrl: '../scripts/components/company/companySettings.html',
        controller: function ($q, $mdDialog, $state, $stateParams, $scope, Auth, Service, Commons) {
            var vm = this;

            vm.cm = Commons;
            
            vm.item = {};
            vm.item.selected = false;

            vm.linktoTeams = function () {
                // Sets currently selected tab and return it number to the changeTab function
                vm.changeTab((vm.selectedTab = 0));
            };
            /*-----projects----*/
            var projectIndex = -1;
            var currentProjectId = null;

            vm.currentProject = '';

            //for projects md-table
            vm.query = {
                order: 'name'
            };

            vm.teamBeDisabled = false;

            //for company md-table
            vm.queryCompany = {
                order: 'name'
            };

            //for company description buttons
            vm.showButtons = false;

            // Private array used to convert selected tab number to state name and vice versa
            vm.tabs = [
                'company',
                'projects'
            ];

            vm.$onInit = function () {
                vm.showCurrentProject(vm.cm.projectList[0]);

                /**
                 * Company Management Form
                 */
                Service.api.companyGet({
                    name: $stateParams.companyName
                }).$promise
                    .then(function (res) {
                        vm.company = res;
                        //add first team to the team member card
                        vm.teamForm(vm.company.teams[0]);
                    }, function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Get company error');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error companyGet:' + JSON.stringify(reason));
                    });

                // Sets selected tab on load
                vm.selectedTab = $stateParams.selectedTab !== undefined ? vm.tabs.indexOf($stateParams.selectedTab) : 0;

            };

            /**
             * Updates the URL on tab change to persist currently selected tab
             *
             */
            vm.changeTab = function (selectedTab) {
                $state.go('.', { selectedTab: vm.tabs[selectedTab] }, { location: 'replace' });
            };

            vm.refreshCompany = function () {
                return Service.api.companyGet({
                    name: $stateParams.companyName
                }).$promise
                    .then(function (company) {
                        vm.company = company;
                        vm.selectTeam();
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Get company error');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error companyGet:' + JSON.stringify(reason));
                    });
            };

            /**
             * Find index in company teams array
             * @param {string} teamName
             * @returns {number} index
             */
            function teamIndex(teamName) {
                var index = vm.company.teams.map(function (x) { return x.name; }).indexOf(teamName);
                return index;
            }

            /**
             *
             * Shows current project
             * populate current id and index of projects
             * @param {any} project
             */
            vm.showCurrentProject = function (project) {
                vm.currentTeams = [];

                if (project) {
                    vm.currentProject = angular.copy(project);

                    //transform project.teams array to arr[{roles:{@string}, teamName:{@string}}]
                    vm.currentTeams = Commons.transformArray(project.teams);
                    // current project id, and index in projects array for updating role and adding teams to projects
                    currentProjectId = vm.currentProject.id;
                    projectIndex = vm.cm.projectList.map(function (x) { return x.id; }).indexOf(currentProjectId);
                }
            };

            vm.hideCurrentProject = function () {
                vm.currentProject = null;
                vm.currentTeams = null;
                currentProjectId = null;
                projectIndex = -1;
            };

            /**
             * Update current project description
             *
             * @param {object} project
             */
            vm.updateProject = function (project, env) {
                //create an isolated scope to pass to the component
                var scope = angular.extend($scope.$new(true), {
                    item: project
                });

                $mdDialog.show({
                    template: '<project-dialog project="item" aria-label="add Project"></project-dialog>',
                    targetEvent: env,
                    parent: angular.element(document.body),
                    scope: scope,
                    clickOutsideToClose: true,
                    preserveScope: true
                })
                    .then(function () {
                        Commons.refreshProjectList();
                        Commons.toastShow('Project updated');
                    });
            };

            /**
             *
             * Revert current project
             * @param {any} $event
             */
            vm.cancelUpdateProject = function () {
                vm.currentProject = vm.cm.projectList[projectIndex];
            };
            /**
             *
             * add role [read, write] to a team
             * @param {string} team
             */
            vm.updateTeamRole = function (team) {
                Service.api.projectGrant({ actionExt: currentProjectId }, team).$promise
                    .then(function () {
                        vm.cm.projectList[projectIndex].teams[team.teamName] = team.role;
                        Commons.toastShow('Role added');
                    });
            };

            /**
             * Add company teams to current Project
             * @param {string} team - team name
             * @returns {void}
             */
            vm.addTeamProject = function (team) {
                var index = vm.currentTeams.map(function (x) { return x.teamName; }).indexOf(team.teamName);
                if (index > -1) {
                    Commons.toastShow('Team already added');
                    vm.projectTeam = {};
                    return;
                }
                else {
                    Service.api.projectGrant({
                        actionExt: currentProjectId
                    }, team).$promise
                        .then(function () {
                            vm.cm.projectList[projectIndex].teams[team.teamName] = team.role;
                            vm.currentTeams.push(team);
                            vm.projectTeam = {};
                            vm.addTeamProjectForm.$setUntouched();
                            vm.addTeamProjectForm.$setPristine();
                            Commons.toastShow('Team added');
                        });
                }
            };

            /**
             * Remove a project/ opens dialog
             *
             * @param {object} project
             * @param {object} event
             */
            vm.deleteProject = function (project, event) {
                var toDeleteItem = {
                    name: project.name,
                    type: 'project'
                };
                Commons.deleteDialog(toDeleteItem, event)
                    .then(function () {
                        vm.projectPromise = Service.api.projectDelete({ action: project.id }).$promise;
                        return vm.projectPromise;
                    })
                    .then(function () {
                        Commons.refreshProjectList();
                        toDeleteItem = null;
                    });
            };

            /**
             * Remove team from projects
             *
             * @param {any} team
             */
            vm.removeTeamProject = function (team) {
                var _team = {};
                _team.teamName = team.teamName;
                Service.api.projectRevoke({ actionExt: currentProjectId }, _team).$promise
                    .then(function () {
                        var index = vm.currentTeams.map(function (x) { return x.teamName; }).indexOf(team.teamName);
                        vm.currentTeams.splice(index, 1);
                        delete vm.currentProject.teams[team.teamName];
                        delete vm.cm.projectList[projectIndex].teams[_team.teamName];
                        Commons.toastShow('Team removed');

                    }, function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Project Revoke error');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error projectRevoke:' + JSON.stringify(reason));
                    });

            };

            /**
             * Create a Project
             * @param {any} event
             */
            vm.addProject = function (event) {
                $mdDialog.show({
                    template: '<project-dialog aria-label="Add Project"></project-dialog>',
                    targetEvent: event,
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                    preserveScope: false
                })
                    .then(function () {
                        Commons.refreshProjectList();
                        Commons.toastShow('Project added');
                    });
            };

            /**
             * on focus show buttons and turn set blink class to false
             */
            vm.onFocus = function () {
                vm.showButtons = true;
                vm.item.blink = false;
            };

            /**
             * Update company name
             *
             * @param {string} description
             */
            vm.updateCompany = function () {
                var company = {
                    companyType: vm.company.companyType,
                    description: vm.company.description,
                    name: vm.company.name,
                    newCompany: false,
                    realName: vm.company.realName
                };
                vm.success = true;
                Service.api.company(company).$promise
                    .then(function (data) {
                        vm.item.blink = true;
                        vm.showButtons = false;
                        vm.companyEdit.$setPristine();
                        Commons.companyData.profile = data;
                        Commons.toastShow('Company updated');
                    }, function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Save company info error');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Company post error:' + JSON.stringify(reason));
                    });
            };

            /**
             * update team name
             * Currently does not work/ no api created yet
             *
             * @param {object} team
             * @param {$event} env
             */
            vm.updateTeam = function (team, env) {
                var options = {
                    item: team,
                    env: env
                };

                Commons.settingsModal(options)
                    .then(function (teamName) {
                        team.name = teamName;
                    });
            };

            /**
             *
             * Add team and push to company team array
             * @param {object} team
             */
            vm.createTeam = function (env) {
                var options = {
                    env: env
                };

                Commons.settingsModal(options)
                    .then(function (teamName) {
                        var index = teamIndex(teamName);
                        if (index > -1) {
                            Commons.alertModal(teamName);
                            return;

                        } else {
                            //create team and add current user to that team

                            var team = {
                                'name': teamName,
                                'users': [
                                    {
                                        'username': Auth.tokenParsed.preferred_username,
                                        'attrs': {
                                            'status': 'ONBOARD'
                                        }
                                    }
                                ]
                            };

                            Service.api.companyTeam({
                                companyName: $stateParams.companyName
                            }, team).$promise
                                .then(function () {
                                    vm.teamStatus = 'Updated';
                                    vm.teamBeDisabled = true;
                                    //copt current team
                                    vm.teamForm(team);
                                    vm.company.teams.push(team);
                                    Commons.toastShow('Team added');

                                }, function (reason) {
                                    var messageObject = Commons.createErrorObject(reason, 'Save team error');
                                    Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                                    console.log('Error companyTeam:' + JSON.stringify(reason));
                                });
                        }
                    });

            };

            /**
             * Add new team to the company
             *
             */
            vm.addTeam = function () {
                if (vm.teamForEdit !== undefined) {
                    Service.api.companyTeamRename({
                        companyName: $stateParams.companyName,
                        oldName: vm.teamForEdit.name,
                        newName: vm.teamName
                    }).$promise
                        .then(function () {
                            vm.teamForEdit.name = vm.teamName;
                            vm.teamName = '';
                            vm.teamForEdit = undefined;
                            Commons.toastShow('Team name changed');
                        })
                        .catch(function (reason) {
                            console.log('Error companyTeamRename:' + JSON.stringify(reason));
                        });
                } else {
                    var team = {
                        'name': vm.teamName,
                        'users': [
                            {
                                'username': Auth.tokenParsed.preferred_username,
                                'attrs': {
                                    'status': 'ONBOARD'
                                }
                            }
                        ]
                    };

                    Service.api.companyTeam({
                        companyName: $stateParams.companyName
                    }, team).$promise
                        .then(function () {
                            vm.teamForm(team);
                            vm.company.teams.push(team);
                            Commons.toastShow('Team added');
                            vm.teamName = '';
                        }, function (reason) {
                            var messageObject = Commons.createErrorObject(reason, 'Add team error');
                            Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                            console.log('Error companyTeam:' + JSON.stringify(reason));
                        });
                }
            };

            /**
             * Select team for editing
             *
             * @param {Object} team
             */
            vm.editTeam = function (team) {
                vm.teamName = team.name;
                vm.teamForEdit = team;
            };

            /**
             * Utility function for check if model is empty string or undefined
             *
             * @param {String} model
             * @returns {Boolean}
             */
            vm.isControlDisabled = function (model) {
                return model === '' || model === undefined;
            };

            /**
             * Proxy function for align with current routines
             *
             */
            vm.selectTeam = function () {
                vm.teamForm(vm.company.teams[teamIndex(vm.selectedTeam)]);
            };

            /**
             * Search user by email
             * @param {Object} user - user form object
             * @return {Promise} - search promise
             */
            vm.findUserByEmail = function (user) {
                return Service.api.userByUsername({
                    username: user.username
                }).$promise
                    .then(function (userByName) {
                        console.log('Found by name' + JSON.stringify(userByName));
                        return userByName;
                    })
                    .catch(function () { // Catch if user not found
                        return;
                    });
            };

            /**
             * Search user by username
             * @param {Object} user - user form object
             * @return {Promise} - search promise
             */
            vm.findUserByUsername = function (user) {
                return Service.api.userByEmail({
                    email: user.username
                }).$promise
                    .catch(function () { // Catch if user not found
                        return;
                    });
            };

            /**
             * Show invite dialog to sent user email
             * @param {Object} user - user form object
             * @return {Promise} - dialog
             */
            vm.inviteUser = function (user) {
                // Create an isolated scope to pass to the component
                var scope = angular.extend($scope.$new(true), {
                    user: user,
                    teamName: vm.team.name
                });

                return $mdDialog.show({
                    template: '<md-dialog aria-label="Invite Dialog"><company-invite-dialog user="user" team-name="teamName"></company-invite-dialog></md-dialog>',
                    parent: angular.element(document.body),
                    clickOutsideToClose: false,
                    preserveScope: true,
                    scope: scope,
                    skipHide: true
                });
            };

            /**
             * Seach user and add to the team
             * 1. Search user by email
             * 2. (OR) Search user by username
             * 3. (OR) Send invite
             * 4. Add to the team
             * @param {Object} user - user form object
             * @return {void}
             */
            vm.addUser = function (user) {
                $q.when()
                    //1. Search user by email
                    .then(function () {
                        return vm.findUserByEmail(user);
                    })
                    .then(function (userByEmail) {
                        if (userByEmail) {
                            return userByEmail;
                            //2. Search user by username
                        } else {
                            return vm.findUserByUsername(user);
                        }
                    })
                    .then(function (userByName) {
                        if (userByName) {
                            return userByName;
                        } else {
                            //3. Send invite
                            return vm.inviteUser(user);
                        }
                    })
                    .then(function (user) {
                        if (user) {
                            // Add to then team
                            return Service.api.companyTeamMemberAdd({
                                companyName: $stateParams.companyName,
                                teamName: vm.team.name,
                                username: user.username
                            }).$promise
                                .then(function () {
                                    Commons.toastShow('User ' + user.username + ' added to the team ' + vm.team.name);
                                })
                                .catch(function (reason) {
                                    var messageObject = Commons.createErrorObject(reason, 'Add user failed');
                                    Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                                });
                        }
                    })
                    .then(function () {
                        vm.user.username = null;
                        vm.refreshCompany();
                    })
                    .catch(function (reason) {
                        if (reason) {
                            var messageObject = Commons.createErrorObject(reason, 'Add user failed');
                            Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                            console.log('Error addUser:' + JSON.stringify(reason));
                        }
                    });
            };

            /**
             * @param  {team}
             * Populate form and chips disable team input
             */
            vm.teamForm = function (team) {
                vm.team = angular.copy(team);
            };

            /**
             * @param  {user}
             * @remove user from a team
             */
            vm.removeUser = function (user) {
                var _index = vm.team.users.indexOf(user);
                Service.api.companyTeamMemberDelete({ companyName: $stateParams.companyName, teamName: vm.team.name, username: user.username }).$promise
                    .then(function () {
                        vm.team.users.splice(_index, 1);
                        var indexTeam = teamIndex(vm.team.name);
                        vm.company.teams[indexTeam].users = vm.team.users;
                        Commons.toastShow('User successfully deleted');
                    }, function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Remove user from team error');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error companyTeamMemberDelete:' + JSON.stringify(reason));
                    });
            };

            /**
             * @param  {index}
             * remove team from company object
             */
            vm.removeTeam = function (team) {
                var teamName = team.name;
                Service.api.companyTeamDelete({ companyName: vm.company.name, teamName: teamName }).$promise
                    .then(function () {
                        var teamIndex = vm.company.teams.map(function (x) { return x.id; }).indexOf(currentProjectId);
                        vm.company.teams.splice(teamIndex, 1);
                        Commons.toastShow('Team successfully deleted');

                    }, function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Team delete error');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error companyTeamDelete:' + JSON.stringify(reason));
                    });
            };

            /**
             * hide form and clear fields
             */
            vm.cancel = function () {
                vm.team = null;
                vm.user = null;
            };

            /**
             * Delete company
             * @param {object} company - company object
             * @param {Object} event - mouse event
             * @return {void}
             */
            vm.deleteCompany = function (company, event) {
                var toDeleteItem = {
                    name: company.realName,
                    type: 'company'
                };
                Commons.deleteDialog(toDeleteItem, event)
                    .then(function () {
                        return Service.api.companyDelete({ name: company.name }).$promise;
                    })
                    .then(function () {
                        $state.go('companyList');
                    })
                    .catch(function (reason) {
                        if (reason && reason.type === 'cancel') {
                            return;
                        }
                        var message = reason.data && reason.data.messageDetails ? reason.data.messageDetails : 'Delete company error';
                        Commons.toastShow(message);
                    });
            };

            /**
             * Check if user can edit/remove team
             *
             * @param {string} teamName - Name of the team to check
             * @returns {boolean} - Is team controllable
             */
            vm.isTeamControllable = function (teamName) {
                return teamName === 'OWNER';
            };
        }
    });

'use strict';
/**
 * @ngdoc company level: Registry
 * @name loopUiApp.component:companyInviteDialog
 * @description
 * # companyInviteDialog
 */
angular.module('loopUiApp')
    .component('companyInviteDialog', {
        templateUrl: '../scripts/components/company/companyInviteDialog.html',
        bindings: {
            user: '<',
            teamName: '<'
        },
        controller: function ($stateParams, $mdDialog, Service, Commons) {
            var vm = this;

            vm.$onInit = function () {
                //If user enter name looks like email, then use it for invite
                vm.email = vm.user.username &&
                    /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,63})$/.test(vm.user.username) ? vm.user.username : '';
            };

            /**
             * Hides the dialog
             * @param {String} email - user email
             * @returns {void}
             */
            vm.save = function (email) {
                Service.api.companyTeamMemberNonRegistered({
                    companyName: $stateParams.companyName,
                    teamName: vm.teamName,
                    email: email
                }).$promise
                    .then(function (data) {
                        if (data && data.code === 'W') {
                            var messageObject = {
                                message: 'The user was added, but the invite wasn\'t sent by email',
                                messageDetails: data.messageDetails,
                                status: -1
                            };
                            Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                            $mdDialog.hide();
                            return;
                        }
                        Commons.toastShow('The invite was sent');
                        $mdDialog.hide();
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Send invite failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error companyTeamMemberNonRegistered:' + JSON.stringify(reason));
                        $mdDialog.cancel();
                    });
            };

            /**
             * Cancel dialog button
             * @returns {void}
             */
            vm.cancel = function () {
                $mdDialog.cancel();
            };
        }
    });
'use strict';
/**
 * @ngdoc component
 * @name loopUiApp.component:templateList
 * @description
 * # templateList
 */
angular.module('loopUiApp')
    .component('templateList', {
        templateUrl: '../scripts/components/templates/templateList/templateList.html',
        controller: function ($scope, $state, $mdDialog, $stateParams, $http, FileSaver, gettextCatalog, appConfig, Service, Commons) {
            var vm = this;

            vm.templateList = [];
            vm.filterStr = '';

            vm.$onInit = function () {
                vm.projectId = $stateParams.projectId || '';
                vm.companyName = $stateParams.companyName;

                vm.scope = vm.isProjectLevel() ? 'PROJECT' : 'COMPANY';

                vm.entityName = 'Templates';

                // Init pagination object
                vm.itemsPagination = {
                    limitOptions: [10, 50, 100],
                    limit: 10,
                    page: 1,
                };

                vm.listActions = [
                    {
                        name: 'Edit Template',
                        icon: 'create',
                        code: 'edit',
                        function: vm.templateEdit
                    },
                    {
                        name: 'Parameterize Template',
                        icon: 'format_list_numbered',
                        code: 'parameterized',
                        function: vm.editParameterized
                    },
                    {
                        name: 'Download Template',
                        icon: 'cloud_download',
                        code: 'download',
                        function: vm.templateDownload
                    },
                    {
                        name: 'Delete',
                        icon: 'delete',
                        code: 'delete',
                        function: vm.templateDelete
                    }
                ];

                // Add Apply template feature to Project Level view only
                if (vm.isProjectLevel()) {
                    vm.listActions.unshift(
                        {
                            name: 'Apply Template',
                            icon: 'save',
                            function: vm.showApplyDialog
                        }
                    );
                }

                vm.additionalActions = [
                    {
                        name: 'Export from Edge Device',
                        icon: 'note_add',
                        label: 'Create Template from device',
                        buttonClick: vm.templateImport
                    },
                    {
                        name: 'Load Template from file',
                        label: 'Load template from file',
                        icon: 'cloud_upload',
                        buttonClick: vm.templateUploadDialog
                    },
                    {
                        name: 'Refresh',
                        icon: 'refresh',
                        label: 'Reload Template list',
                        buttonClick: vm.refreshTemplateList
                    }
                ];
                // On company level view do now allow to export template from LoopEdge
                if (!vm.isProjectLevel()) {
                    vm.additionalActions.splice(0, 1);
                }

                vm.refreshTemplateList();

            };

            /**
             * Check if current scope is project
             * @returns {Boolean}
             */
            vm.isProjectLevel = function () {
                return $stateParams.viewScope === 'project';
            };

            /**
             * Get template list
             * @returns {void}
             */
            vm.refreshTemplateList = function () {
                vm.isLoading = true;

                vm.templateListPromise = Service.api.templateList({
                    companyName: vm.companyName,
                    projectId: vm.projectId,
                    limit: vm.itemsPagination.limit,
                    requestedPage: vm.itemsPagination.page - 1,
                    filter: vm.filterStr
                }).$promise;

                vm.templateListPromise.then(function (data) {
                    vm.templateList = data.elements
                        .map(function (item) {
                            try {
                                item.statFlat = Commons.transformTemplateStat(item.stat);
                            }
                            catch (e) { }
                            return item;
                        });
                    vm.totalItems = data.totalSize;
                })
                    .catch(function (reason) {
                        console.log('refreshTemplateList failure:' + JSON.stringify(reason));
                        var messageObject = Commons.createErrorObject(reason, 'Template list get failure');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                    })
                    .finally(function () {
                        vm.isLoading = false;
                    });
            };

            /**
             * Delete template
             * @param {Event} event - MouseEvent
             * @param {Object} template - template object
             * @returns {void}
             */
            vm.templateDelete = function (event, template) {
                if (template.scope === 'INSTANCE') {
                    Commons.toastShow('Only administrator can delete instance level template from ' + appConfig.__env.adminUiName, 5000);
                    return;
                }
                Commons.showConfirmationWarn(
                    gettextCatalog.getString('Remove Template'), 
                    gettextCatalog.getString('Are you sure you want to remove?<br>Removed template cannot be restored.'), 
                    gettextCatalog.getString('Remove'), function () {
                    Service.api.templateDelete({
                        templateName: template.name
                    }).$promise
                        .then(function () {
                            Commons.toastShow('Template was deleted');
                            vm.refreshTemplateList();
                        })
                        .catch(function (reason) {
                            console.log('templateDelete failure:' + JSON.stringify(reason));
                            var messageObject = Commons.createErrorObject(reason, 'Template delete failure');
                            Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        });

                }, gettextCatalog.getString('Cancel'), undefined, event);
            };

            /**
             * Show template dialog
             * @param {MouseEvent} event - MouseEvent
             * @param {Object} template - template object
             * @return {void} 
             */
            vm.showApplyDialog = function (event, template) {
                // Create an isolated scope to pass to the component 
                var scope = angular.extend($scope.$new(true), {
                    template: template
                });

                $mdDialog.show({
                    template: '<template-apply-dialog template="template"></template-apply-dialog>',
                    parent: angular.element(document.body),
                    targetEvent: event,
                    clickOutsideToClose: false,
                    preserveScope: true,
                    skipHide: true,
                    scope: scope,
                });
            };

            /**
             * Download template
             * @param {MouseEvent} event - event object
             * @param {Object} item - template object
             * @returns {void}
             */
            vm.templateDownload = function (event, item) {
                if (item.parameterized) {
                    vm.templateDownloadParameterized(item);
                    return;
                }
                vm.templateDownloadPlain(item);
            };

            /**
             * Download plain template
             * @param {Object} item - template object
             * @returns {void}
             */
            vm.templateDownloadPlain = function (item) {
                Service.api.templateDownloadLink({
                    templateName: item.name
                }).$promise
                    .then(function (data) {
                        Commons.downloadLink(JSON.stringify(data), vm.getTemplateFileName(item));
                    })
                    .catch(function (reason) {
                        console.log('templateDownloadLink failure:' + JSON.stringify(reason));
                        var messageObject = Commons.createErrorObject(reason, 'Template download failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                    });
            };

            /**
             * Download parameterized template
             * @param {Object} item - template object
             * @returns {void}
             */
            vm.templateDownloadParameterized = function (item) {
                var req = {
                    url: appConfig.apiUrl + 'api/v' + appConfig.apiVersion +
                        '/template/download-zip?templateName=' + item.name,
                    method: 'GET',
                    responseType: 'arraybuffer'
                };
                $http(req)
                    .then(function (resp) {
                        var serverData = new Blob([resp.data], { type: resp.headers()['content-type'] });
                        FileSaver.saveAs(serverData, vm.getTemplateFileName(item, 'zip'));
                    })
                    .catch(function (reason) {
                        console.log('templateDownloadParameterized failure:' + JSON.stringify(reason));
                        Commons.toastShow('Template download failed');
                    });
            };

            /**
             * Generate template name
             * @param {Object} template - template object
             * @return {string} - template file name
             * @return {string} - file type
             */
            vm.getTemplateFileName = function (template, type) {
                var _company = template.companyName + '_' || '';
                var _project = template.projectId + '_' || '';
                var _type = type ? '.' + type : '.json';

                var timestamp = template.timestamp || '';
                return 'template_' + template.scope +
                    (template.scope === 'INSTANCE' ? '_' + timestamp + _type :
                        '_' + _company + _project + timestamp + _type);
            };

            /**
             * Filter template list based on search criteria
             *
             * @param {string} searchText    - Search string
             * @return {void}
             */
            vm.filter = function (searchText) {
                vm.filterStr = searchText;
                vm.itemsPagination.page = 1;
                vm.refreshTemplateList();
            };

            /**
             * Open upload dialog
             * @param {Event} event - event object
             * @return {void}
             */
            vm.templateUploadDialog = function (event) {
                $mdDialog.show({
                    template: '<md-dialog style="max-width: 500px;"><md-dialog-content><template-upload-dialog></template-upload-dialog></md-dialog-content></md-dialog>',
                    parent: angular.element(document.body),
                    targetEvent: event,
                    clickOutsideToClose: false,
                    preserveScope: true,
                    skipHide: true,
                })
                    .then(function (data) {
                        if (data) {
                            Commons.toastShow('Uploading start...');
                            // Use different API based on template type
                            var _updloadService = data.templateType.code === 'PARAMETERIZED' ?
                                'templateParameterizedUpload' : 'templateUpload';
                            Service.api[_updloadService]({
                                companyName: vm.companyName,
                                projectId: vm.projectId,
                                deviceId: 'id',
                                scope: vm.scope,
                                description: data.description
                            }, data.fileData).$promise
                                .then(function () {
                                    Commons.toastShow('Template file uploaded');
                                    vm.refreshTemplateList();
                                })
                                .catch(function (reason) {
                                    var messageObject = Commons.createErrorObject(reason, 'File upload failed');
                                    Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                                });
                        }
                    });
            };

            /**
             * Open template upload page
             * @returns {void}
             */
            vm.templateImport = function () {
                $state.go('templateImport', { companyName: vm.companyName, projectId: vm.projectId });
            };

            /**
             * Open edit template dialog
             * @param {MouseEvent} event - event object
             * @param {Object} template - template object
             * @return {void}
             */
            vm.templateEdit = function (event, template) {
                // Create an isolated scope to pass to the component 
                var scope = angular.extend($scope.$new(true), {
                    template: angular.copy(template)
                });

                $mdDialog.show({
                    template: '<md-dialog style="width:500px;"><template-edit-dialog template="template"></template-edit-dialog></md-dialog>',
                    parent: angular.element(document.body),
                    targetEvent: event,
                    clickOutsideToClose: false,
                    preserveScope: true,
                    scope: scope,
                    skipHide: true,
                })
                    .then(function (data) {
                        if (data) {
                            vm.refreshTemplateList();
                        }
                    });
            };

            /**
             * Open parameterized template 
             * @param {Event} event - mouse click event
             * @param {*} item - list object
             * @returns {void}
             */
            vm.editParameterized = function (event, item) {
                var warnWindow = function () {
                    Commons.showConfirmation(gettextCatalog.getString('Instance Scope Template'),
                        gettextCatalog.getString('You can\'t edit the INSTANCE scope template.'),
                        gettextCatalog.getString('Ok'),
                        function () { },
                        undefined,
                        undefined,
                        event);
                };

                if (item.scope === 'INSTANCE') {
                    warnWindow();
                    return;
                }

                if (vm.scope === 'COMPANY') {
                    $state.go('templateParameterizedCompany', {
                        companyName: vm.companyName,
                        templateName: item.name
                    });
                    return;
                }

                if (vm.scope === 'PROJECT') {
                    $state.go('templateParameterized', {
                        companyName: vm.companyName,
                        projectId: vm.projectId,
                        templateName: item.name
                    });
                    return;
                }
            };

        }
    });
'use strict';
/**
 * @ngdoc component
 * @name loopUiApp.component:templateSelectDialog
 * @description
 * # templateSelectDialog
 */
angular.module('loopUiApp')
    .component('templateSelectDialog', {
        templateUrl: '../scripts/components/templates/templateSelectDialog/templateSelectDialog.html',
        bindings: {
            selectedTemplates: '<'
        },
        controller: function ($stateParams, $mdDialog, $filter, Service, Commons) {
            var vm = this;
            vm.templateList = [];
            vm.filterStr = '';

            vm.$onInit = function () {
                vm.companyName = $stateParams.companyName;
                vm.projectId = $stateParams.projectId;

                // Generic table setup
                vm.listSetup = {
                    sortField: 'name',
                    keyName: 'name',
                    showIndex: true,
                    editable: false,
                    removable: false,
                    rowSelection: true,
                    multipleSelection: true,
                    serverPagination: true,
                    limit: 10,
                    limitOptions: [10, 50, 100],
                    fields: [
                        {
                            name: 'Description',
                            column: 'desc'
                        },
                        {
                            name: 'Scope',
                            column: 'name',
                            transformation: function (row) {
                                var nameArray = Commons.parseTemplateFileName(row.name);
                                return nameArray[3] ? nameArray[3] : '';
                            }
                        },
                        {
                            name: 'Template Statistic',
                            component: 'templateStat',
                            transformation: function (row) {
                                return row.statFlat;
                            }
                        },
                        {
                            name: 'Parameterized?',
                            style: '{"width": "50px"}',
                            transformation: function (item) {
                                return item.parameterized ? 'True' : null;
                            }
                        },
                        {
                            name: 'Created At',
                            transformation: function (row) {
                                var nameArray = Commons.parseTemplateFileName(row.name);
                                return nameArray[4] ? $filter('date')(nameArray[4], 'yyyy-MM-dd HH:mm:ss') : '';
                            }
                        }
                    ]
                };

                // Init pagination object
                vm.itemsPagination = {
                    limit: vm.listSetup.limit,
                    page: 1
                };

                vm.refreshTemplateList();
            };

            /**
             * Get template list
             * @returns {void}
             */
            vm.refreshTemplateList = function () {
                vm.isLoading = true;

                vm.templateListPromise = Service.api.templateList({
                    companyName: vm.companyName,
                    projectId: vm.projectId,
                    limit: vm.itemsPagination.limit,
                    requestedPage: vm.itemsPagination.page - 1,
                    filter: vm.filterStr
                }).$promise;

                vm.templateListPromise.then(function (data) {
                    vm.templateList = data.elements
                        .map(function (item) {
                            try {
                                item.statFlat = Commons.transformTemplateStat(item.stat);
                            }
                            catch (e) { }
                            return item;
                        });
                    vm.totalItems = data.totalSize;
                })
                    .catch(function (reason) {
                        console.log('refreshTemplateList failure:' + JSON.stringify(reason));
                        var messageObject = Commons.createErrorObject(reason, 'Template list get failure');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                    })
                    .finally(function () {
                        vm.isLoading = false;
                    });
            };

            /**
             * Close dialog windows
             * @return {undefined}
            */
            vm.hide = function () {
                $mdDialog.hide(vm.selectedTemplates);
            };

            /**
             * Close dialog without data select
             * @returns {void}
             */
            vm.cancel = function () {
                $mdDialog.cancel();
            };

            /**
             * Select templates handler
             * @param {Array} items - device list
             * @returns {void}
             */
            vm.checkSelection = function (items) {
                vm.selectedTemplates = items;
            };

            /**
             * Server side filter Filter based on search criteria
             *
             * @param {string} searchText           - Search string
             * @return {void}
             */
            vm.filter = function (searchText) {
                vm.filterStr = searchText;
                vm.refreshTemplateList();
            };

            /**
             * Update pagination object and run list refresh
             * @param {Object} paginationObject - pagination object
             * @return {void}
             */
            vm.paginationHandler = function (paginationObject) {
                vm.itemsPagination = paginationObject;
                vm.refreshTemplateList();
            };
        }
    });
'use strict';
/**
 * @ngdoc component
 * @name loopUiApp.component:templateUploadDialog
 * @description
 * # templateUploadDialog
 */
angular.module('loopUiApp')
    .component('templateUploadDialog', {
        templateUrl: '../scripts/components/templates/templateUploadDialog/templateUploadDialog.html',
        controller: function ($mdDialog) {
            var vm = this;
            //Selected files array
            vm.files = [];
            // Template types
            vm.templateTypes = [
                {code: 'SIMPLE', name: 'Simple Template', allowedFile: '.json'}, 
                {code: 'PARAMETERIZED', name: 'Parameterized Template', allowedFile: '.zip'}, 
            ];
            // Selected template
            vm.templateType = vm.templateTypes[0];

            /**
            * Close dialog windows
            * @return {undefined}
            */
            vm.hide = function () {
                $mdDialog.hide();
            };

            /**
             * Return formData element to upload
             * @return {void}
             */
            vm.upload = function () {
                var fileData = new FormData();
                angular.forEach(vm.files, function (data) {
                    fileData.append('file', data);
                });
                $mdDialog.hide({
                    fileData: fileData,
                    description: vm.description,
                    templateType: vm.templateType
                });
            };
        }
    });
'use strict';
/**
 * @ngdoc component
 * @name loopUiApp.component:templateApplyDialog
 * @description
 * # templateApplyDialog
 */
angular.module('loopUiApp')
    .component('templateApplyDialog', {
        templateUrl: '../scripts/components/templates/templateApplyDialog/templateApplyDialog.html',
        bindings: {
            template: '<'
        },
        controller: function ($scope, $q, $mdDialog, ServiceAsyncTask, Service, Commons) {
            var vm = this;
            vm.deviceList = [];

            /**
             * Hides the dialog
             * @returns {void}
             */
            vm.hide = function () {
                ServiceAsyncTask.resetCurrentWatchedTask();
                $mdDialog.hide();
            };

            /**
             * Apply device list to  template
             * @return {void}
             */
            vm.apply = function () {
                /**
                 * Run template apply
                 * @return {void}
                 */
                var applyFunc = function (params) {
                    vm.isApplying = true;
                    ServiceAsyncTask.createTaskAndWait(
                        ServiceAsyncTask.taskTypes.TEMPLATE_APPLY.code, // Task type
                        ServiceAsyncTask.taskTypes.TEMPLATE_APPLY.subtaskTypes, // Subtask types
                        '', // Task description 
                        vm.deviceList,
                        { templateName: vm.template.name, values: params || null }, // Task params
                        false // Wait device for online
                    )
                        .then(function () {
                            vm.hide();
                        })
                        .catch(function (reason) {
                            if (!reason) { // If not reason provided, then task was canceled
                                return;
                            }
                            console.log('templateApply failure:' + JSON.stringify(reason));
                            var messageObject = Commons.createErrorObject(reason, 'Apply template failure');
                            Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        })
                        .finally(function () {
                            vm.isApplying = false;
                        });
                };

                // For parametrized template ask variables
                if (vm.template.parameterized) {
                    var promiseList = [
                        // Get parameterized template
                        Service.api.templateParameterizedGet({ templateName: vm.template.name }).$promise,
                        // Get variables list
                        Service.api.templateVariablesList({ templateName: vm.template.name }).$promise,

                    ];
                    $q.all(promiseList)
                        .then(function (data) {
                            try {
                                vm.jsonData = JSON.parse(data[0].data);
                            } catch (e) {
                                vm.jsonData = {};
                            }
                            vm.variableList = data[1];

                            // If no variables specified for template, then return empty map
                            if (!vm.variableList || (vm.variableList && vm.variableList.length === 0)) {
                                return {};
                            }

                            var templateObjects = {};
                            templateObjects[vm.template.name] = {
                                template: vm.template,
                                variableList: vm.variableList,
                                jsonData: vm.jsonData
                            };

                            var scope = angular.extend($scope.$new(true), {
                                // variableList: vm.variableList || [],
                                // jsonData: vm.jsonData || {},
                                templateObjects: templateObjects
                            });
                            return $mdDialog.show({
                                template: '<md-dialog style="width:700px;"><template-values-dialog template-objects="templateObjects"></template-values-dialog></md-dialog>',
                                parent: angular.element(document.body),
                                clickOutsideToClose: false,
                                preserveScope: true,
                                scope: scope,
                                skipHide: true
                            });
                        })
                        .then(function (params) {
                            applyFunc(params[vm.template.name]);
                        });
                }
                else {
                    applyFunc();
                }
            };
        }
    });
'use strict';
/**
 * @ngdoc component
 * @name loopUiApp.component:templateEditDialog
 * @description
 * # templateEditDialog
 */
angular.module('loopUiApp')
    .component('templateEditDialog', {
        bindings: {
            template: '<'
        },
        templateUrl: '../scripts/components/templates/templateEditDialog/templateEditDialog.html',
        controller: function ($mdDialog, Service, Commons) {
            var vm = this;

            
            vm.$onInit = function() {
                vm.scopeList = ['COMPANY', 'PROJECT'];
                // Do not allow change scope to low level
                vm.disableChangeScope = vm.template.scope === vm.scopeList[0];
                vm.isInstanceScope = vm.template.scope === 'INSTANCE';
            };

            /**
             * Save template
             */
            vm.save = function () {
                var templateObject = {
                    scope: vm.template.scope,
                    desc: vm.template.desc
                };
                vm.isLoading = true;
                Service.api.template({
                    templateName: vm.template.name
                }, templateObject).$promise
                    .then(function () {
                        $mdDialog.hide(true);
                    })
                    .catch(function (reason) {
                        console.log('Save template failure:' + JSON.stringify(reason));
                        var messageObject = Commons.createErrorObject(reason, 'Save template failure');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                    })
                    .finally(function() {
                        vm.isLoading = false;
                    });
            };

            /**
             * Close dialog windows
             * @return {undefined}
            */
            vm.hide = function () {
                $mdDialog.hide(false);
            };
        }
    });
'use strict';

/**
 * @ngdoc component
 * @name loopUiApp.component:templateStat
 * @description
 * # templateStat
 */
angular.module('loopUiApp')
  .component('templateStat', {
    templateUrl: '../scripts/components/templates/templateStat/templateStat.html',
    bindings: {
        stat: '<'
    },
    controller: function () {
        var vm = this;

        // Map of template names to display names
        vm.nameMap = {
            Dtwin: 'Digital Twin',
        };
    }
});
'use strict';

/**
 * @ngdoc component
 * @name loopUiApp.component:templateImport
 * @description
 * # templateImport
 */
angular.module('loopUiApp')
  .component('templateImport', {
    templateUrl: '../scripts/components/templates/templateImport/templateImport.html',
    controller: function ($state, $stateParams, Service, Commons) {
      var vm = this;

      vm.$onInit = function () {
        vm.projectId = $stateParams.projectId;
        
        vm.selectedTab = 0;
        vm.maxTab = 1;
      };

      /**
        * Select device from source device list
        * @param {Array} devices - selected devices list
        * @returns {void}
      */
      vm.deviceSelect = function (devices) {
        var deviceCapability = {};
        if (devices.length === 0) {
          vm.templateComposition = {};
          vm.selectedDevice = null;
          return;
        }
        vm.selectedDevice = devices[0];
        deviceCapability = Commons.checkFeatureCapability(vm.selectedDevice.capabilities, 'TEMPLATE_EXPORT');
        vm.isLicenseAvailable = deviceCapability.available;
        vm.disabledByLicenseMessage = deviceCapability.unavailabilityReason;
        vm.getDeviceComposition(vm.projectId, vm.selectedDevice.deviceId);
      };

      /**
        * Load device composition
        * @param {string} projectId - project id
        * @param {string} deviceId - device id
        * @returns {void}
        */
      vm.getDeviceComposition = function (projectId, deviceId) {
        vm.isCompositionLoading = true;
        vm.templateComposition = angular.copy(vm.emptyTemplateComposition);

        // Get template composition promise
        vm.templateCompositionPromise = Service.api.templateComposition({
          projectId: projectId,
          deviceId: deviceId
        }).$promise;

        vm.templateCompositionPromise.then(function (data) {
          vm.templateComposition = data;
        })
          .catch(function (reason) {
            vm.templateComposition = angular.copy(vm.emptyTemplateComposition);
            var messageObject = Commons.createErrorObject(reason[0], 'Get Template composition failed');
            Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
            console.log('Error templateComposition:' + JSON.stringify(reason));
          })
          .finally(function () {
            vm.isCompositionLoading = false;
          });
      };

      /**
       * Create template
       */
      vm.createTemplate = function () {
        var _payload = vm.hierarchyApi.createTemplate();
        vm.isCreating = true;
        Service.api.templateCreate(_payload).$promise
          .then(function () {
            Commons.toastShow('Template created successfully');
          })
          .catch(function (reason) {
            console.log('Error templateCreate:' + JSON.stringify(reason));
            var messageObject = Commons.createErrorObject(reason, 'Create template failed');
            Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
          })
          .finally(function () {
            vm.isCreating = false;
          });
      };

      /**
       * Step back
       * 
       */
      vm.previous = function () {
        vm.selectedTab = vm.selectedTab-- < 0 ? 0 : vm.selectedTab;
      };

      /**
       * Step forward
       * 
       */
      vm.next = function () {
        //vm.selectedTab = vm.selectedTab++ > vm.maxTab ? vm.maxTab : vm.selectedTab;
        vm.selectedTab = vm.selectedTab + 1;
      };

      /**
       * Check if next master step is disabled
       * @return {Boolean} - if next step disabled
       */
      vm.isNextDisabled = function () {
        return vm.selectedTab === 0 && !vm.selectedDevice;
      };

      /**
       * Check if allow to export template
       * @return {Boolean} - is export allowed
       */
      vm.isTemplateCreateDisabled = function () {
        return vm.templateForm && vm.templateForm.$invalid || vm.isCompositionLoading || vm.isCreating || !vm.isLicenseAvailable || !vm.hierarchyApi.isAnyNodeSelected();
      };

      /**
       * Return to the template list page
       */
      vm.close = function () {
        $state.go('templateList', { companyName: $stateParams.companyName, projectId: $stateParams.projectId });
      };
    }
  });
'use strict';

/**
 * @ngdoc component
 * @name loopUiApp.component:templateHierarchy
 * @description
 * # templateHierarchy
 */
angular.module('loopUiApp')
    .component('templateHierarchy', {
        bindings: {
            device: '<',
            templateComposition: '<',
            isCompositionLoading: '<',
            formInstance: '<',
            exposeApi: '&',
        },
        templateUrl: '../scripts/components/templates/templateImport/templateHierarchy/templateHierarchy.html',
        controller: function (treeConfig, Commons) {
            var vm = this;
            vm.selectedNodesMap = {};

            vm.$onInit = function () {
                // Change default angular-ui-tree classes 
                treeConfig.nodesClass = 'template-ui-tree-nodes';
                treeConfig.treeClass = 'template-ui-tree';
                treeConfig.handleClass = 'template-ui-tree-handle';

                vm.templateDescription = '';
                vm.treeObject = {};
                // All possible template objects
                vm.templateObject = {
                    auth: {
                        name: 'auth',
                        displayName: 'Auth',
                        description: '',
                        defaultValue: {
                            providers: []
                        },
                        transformation: vm.nestedObjectTransformation
                    },
                    connectors: {
                        name: 'connectors',
                        displayName: 'Connectors',
                        description: '',
                        defaultValue: [],
                        transformation: function (item) {
                            return vm.keyTransformation(item, 'id');
                        }
                    },
                    country: {
                        name: 'country',
                        displayName: 'Country',
                        description: '',
                        defaultValue: false,
                        transformation: vm.booleanTransformation
                    },
                    devices: {
                        name: 'devices',
                        displayName: 'Devices',
                        description: '',
                        defaultValue: [],
                        transformation: function (item) {
                            return vm.keyTransformation(item, 'id');
                        }
                    },
                    dns: {
                        name: 'dns',
                        displayName: 'DNS',
                        description: '',
                        defaultValue: false,
                        transformation: vm.booleanTransformation
                    },
                    docker: {
                        name: 'docker',
                        displayName: 'Docker',
                        description: '',
                        defaultValue: false,
                        transformation: vm.booleanTransformation
                    },
                    dtwin: {
                        name: 'digitalTwin',
                        displayName: 'Digital Twin',
                        description: '',
                        defaultValue: null,
                        transformation: vm.nestedObjectTransformation
                    },
                    flows: {
                        name: 'flows',
                        displayName: 'Flows',
                        description: '',
                        defaultValue: [],
                        transformation: function (item) {
                            return vm.keyTransformation(item, 'id');
                        }
                    },
                    groups: {
                        name: 'groups',
                        displayName: 'Analytics Groups',
                        description: '',
                        defaultValue: [],
                        transformation: function (item) {
                            return vm.keyTransformation(item, 'name');
                        }
                    },
                    marketplace: {
                        name: 'marketplace',
                        displayName: 'Marketplace',
                        description: '',
                        defaultValue: {
                            catalogs: [],
                            registries: []
                        },
                        transformation: vm.nestedObjectTransformation
                    },
                    ntp: {
                        name: 'ntp',
                        displayName: 'NTP',
                        description: '',
                        defaultValue: false,
                        transformation: vm.booleanTransformation
                    },
                    opcua: {
                        name: 'opcua',
                        displayName: 'OPC UA',
                        description: '',
                        defaultValue: [],
                        transformation: vm.objectTransformation
                    },
                    timezone: {
                        name: 'timezone',
                        displayName: 'Timezone',
                        description: '',
                        defaultValue: false,
                        transformation: vm.booleanTransformation
                    }
                };

                // Exposed API allow to call create template action from parent component
                vm.api = {
                    createTemplate: vm.createTemplate,
                    isAnyNodeSelected: vm.isAnyNodeSelected,
                };
                vm.exposeApi({ $API: vm.api });
            };

            vm.$onChanges = function (changes) {
                if (changes.templateComposition && changes.templateComposition.currentValue) {
                    vm.composition = Object.keys(vm.templateComposition)
                        .filter(function (key) {
                            return !!vm.templateObject[key];
                        })
                        .reduce(function (acc, cur) {
                            acc[cur] = vm.templateComposition[cur];
                            return acc;
                        }, {});

                    vm.treeObject = { name: 'root', childNodes: vm.convertTemplateToTree(vm.composition) };
                }
            };

            /**
             * Create template action
             */
            vm.createTemplate = function () {
                return {
                    deviceId: vm.device.deviceId,
                    templateDescription: vm.templateDescription,
                    creationOptions: vm.createTemplatePayload(vm.treeObject)
                };
            };

            /**
             * Convert template object to tree object
             * treObject has a structure like this:
             * {
             *      "name": string,
             *      "isSelected": boolean,
             *      "object": any,
             *      "childNodes": Array<treeObject>
             * }
             * @param {Object} obj - template object from /template/composition 
             * @returns 
             */
            vm.convertTemplateToTree = function (obj, level) {
                var result = [];
                var _level = (level + 1) || 0;
                var childNodes = [];
                for (var key in obj) {
                    if (Array.isArray(obj[key])) {
                        /* jshint ignore:start */
                        childNodes = obj[key]
                            .map(function (child) {
                                var _key = child.key || child.name || child.label;
                                var _obj = {};
                                _obj[_key] = child;
                                return vm.convertTemplateToTree(_obj, _level)[0];
                            });
                        /* jshint ignore:end */
                        result.push({ name: key, level: _level, isSelected: false, childNodes: childNodes, $ID: Commons.generateRandomString(16) });
                    } else if (typeof obj[key] === "object" && obj[key] !== null) {
                        childNodes = vm.convertTemplateToTree(obj[key], _level);
                        result.push({ name: key, level: _level, isSelected: false, object: vm.getObject(obj[key]), childNodes: childNodes, $ID: Commons.generateRandomString(16) });
                    } else if (typeof obj[key] === "boolean" && obj[key] !== null) {
                        result.push({ name: key, level: _level, isSelected: false, childNodes: [], $ID: Commons.generateRandomString(16) });
                    } else if (obj[key] === null) {
                        result.push({ name: key, level: _level, isSelected: null, childNodes: [], $ID: Commons.generateRandomString(16) });
                    }
                }
                return result;
            };

            /**
             * Get first level object for node element
             * @param {Object} obj - node object
             * @returns 
             */
            vm.getObject = function (obj) {
                return {
                    id: obj.id,
                    name: obj.name,
                    provider: obj.provider,
                    type: obj.type,
                    label: obj.label,
                };
            };

            /**
             * Convert tree object to payload object
             * 1. Filter selected nodes
             * 2. Transform selected nodes based on node type
             * @param {Object} treeObject - tree hierarchy object 
             * @returns 
             */
            vm.createTemplatePayload = function (treeObject) {
                return treeObject.childNodes.filter(function (node) {
                    if (node.childNodes && node.childNodes.length > 0 && node.isSelected) {
                        return vm.createTemplatePayload(node);
                    } else {
                        return node.isSelected === true || node.level === 0;
                    }
                })
                    .reduce(function (acc, cur) {
                        if (vm.templateObject[cur.name] && vm.templateObject[cur.name].transformation) {
                            var _key = vm.templateObject[cur.name] ? vm.templateObject[cur.name].name : cur.name;
                            var _defaultValue = vm.templateObject[cur.name] ? vm.templateObject[cur.name].defaultValue : null;
                            try {
                                acc[_key] = vm.templateObject[cur.name].transformation(cur);
                            } catch (e) {
                                acc[_key] = _defaultValue;
                            }
                            return acc;
                        }
                        return acc;
                    }, {});
            };

            /**
             * Check is node has child nodes and some of them are selected
             * @param {Object} node - node object from treeObject 
             * @returns 
             */
            vm.isIndeterminate = function (node) {
                return (node.childNodes.some(function (childNode) {
                    return childNode.isSelected;
                }) && !vm.isAllChildSelected(node));
            };


            /**
             * Check is all child nodes are selected
             * @param {Object} node - node object from treeObject
             * @returns 
             */
            vm.isAllChildSelected = function (node) {
                return node.childNodes.every(function (childNode) {
                    return childNode.isSelected;
                });
            };

            /**
             * Toggle node and all child nodes
             * @param {Object} node - node object from treeObject
             * @param {Object} parent - $parentScope of node object
             */
            vm.toggleFolder = function (node, parent) {
                node.isSelected = !node.isSelected;
                vm.toggleChild(node);
                vm.toggleParent(parent);
            };

            /**
             * Toggle all child nodes
             * @param {Object} node - node object from treeObject 
             * @param {Boolean} value - true or false
             * @returns 
             */
            vm.toggleAll = function (node, value) {
                vm.trackSelection(node);
                if (!node || !node.childNodes) {
                    return;
                }
                node.childNodes.forEach(function (childNode) {
                    childNode.isSelected = value;
                    vm.trackSelection(childNode);
                    vm.toggleAll(childNode, value);
                });
            };

            /**
             * Toggle all child nodes
             * @param {Object} node - node object from treeObject 
             * @returns 
             */
            vm.toggleChild = function (node) {
                vm.trackSelection(node);
                if (!node || !node.childNodes) {
                    return;
                }
                node.childNodes.forEach(function (childNode) {
                    childNode.isSelected = node.isSelected;
                    vm.trackSelection(childNode);
                    vm.toggleChild(childNode);
                });
            };

            /**
             * Check all parent recursively. 
             * If all child nodes are selected then parent node should be selected too
             * @param {Object} parent - $parentScope of node object
             * @returns 
             */
            vm.toggleParent = function (parent) {
                if (!parent || !parent.node) {
                    return;
                }
                parent.node.isSelected = vm.isAllChildSelected(parent.node);
                vm.trackSelection(parent.node);
                if (parent.$parentNodesScope) {
                    vm.toggleParent(parent.$parentNodesScope);
                }
            };

            /**
             * Get node name for the view
             * @param {Object} node - node object from treeObject
             * @returns 
             */
            vm.getNodeName = function (node) {
                return node.level === 0 && vm.templateObject[node.name] ? vm.templateObject[node.name].displayName : node.name;
            };

            // Transform functions for each node type

            /**
             * Convert boolean node object payload format
             * @param {Object} object - first level object from the tree 
             * @returns 
             */
            vm.booleanTransformation = function (object) {
                if (object && object.isSelected !== undefined) {
                    return object.isSelected;
                }
            };

            /**
             * Convert and filter complex node object with nested nodes to the payload format
             * @param {Object} object - first level object from the tree 
             * @returns 
             */
            vm.nestedObjectTransformation = function (object) {
                return object.childNodes.reduce(function (acc, cur) {
                    if (Array.isArray(cur.childNodes)) {
                        acc[cur.name] = cur.childNodes
                            .filter(function (item) {
                                return item.isSelected === true;
                            })
                            .map(function (node) {
                                if (Array.isArray(node.childNodes)) {
                                    var _result = { id: node.object.id, name: node.object.name };
                                    Object.assign(_result, vm.nestedObjectTransformation(node));
                                    return _result;
                                }
                                else {
                                    return {
                                        id: node.object.id,
                                        name: node.object.name,
                                        type: node.object.type
                                    };
                                }
                            });
                    }
                    return acc;
                }, {});
            };

            /**
             * Convert and filter simple node object to the list of {key}
             * @param {Object} object - first level object from the tree 
             * @returns 
             */
            vm.keyTransformation = function (object, key) {
                return object.childNodes
                    .filter(function (item) {
                        return item.isSelected === true;
                    })
                    .map(function (item) {
                        return item.object[key];
                    });
            };

            /**
             * Convert and filter simple node object to the list of {key}
             * @param {Object} object - first level object from the tree 
             * @returns 
             */
            vm.objectTransformation = function (object) {
                return object.childNodes
                    .filter(function (item) {
                        return item.isSelected === true;
                    })
                    .map(function (item) {
                        return {
                            id: item.object.id,
                            name: item.object.name,
                            type: item.object.type,
                            label: item.object.label
                        };
                    });
            };

            /**
             * Add or remove node $ID from the selectedNodesMap based on node.isSelected value
             * @param {Object} node - node object
             */
            vm.trackSelection = function (node) {
                if (vm.selectedNodesMap[node.$ID] && !node.isSelected) {
                    delete vm.selectedNodesMap[node.$ID];
                }
                else if (node.isSelected === true) {
                    vm.selectedNodesMap[node.$ID] = node.name;
                }
            };

            /**
             * Check is any node selected
             */
            vm.isAnyNodeSelected = function () {
                return Object.keys(vm.selectedNodesMap).length > 0;
            };
        }
    });
'use strict';

/**
 * @ngdoc component
 * @name loopUiApp.component:templateParameterized
 * @description
 * # templateParameterized
 */
angular.module('loopUiApp')
    .component('templateParameterized', {
        templateUrl: '../scripts/components/templates/templateParameterized/templateParameterized.html',
        controller: function ($scope, $stateParams, jsonTreeConfig, $mdDialog, gettextCatalog, Service, Commons) {
            var vm = this;
            vm.template = {};
            vm.variableList = [];
            vm.jsonDataOrig = {};
            vm.isLoading = false;

            vm.$onInit = function () {
                vm.projectId = $stateParams.projectId || '';
                vm.templateName = $stateParams.templateName;
                vm.companyName = $stateParams.companyName;
                vm.viewScope = $stateParams.viewScope;

                jsonTreeConfig.templateUrl = '../scripts/components/templates/templateParameterized/jsonTemplate.html';

                vm.checkVariableRegex = new RegExp('.*\"\\$\\{\\S+}\".*');

                vm.getTemplate(vm.templateName);

                vm.refreshVariableList();

                // Generic table setup
                vm.variableListSetup = {
                    sortField: 'name',
                    showIndex: false,
                    editable: false,
                    removable: false,
                    limit: 10,
                    limitOptions: [10, 50, 100],
                    fields: [
                        {
                            name: 'Name',
                            column: 'name'
                        },
                        {
                            name: 'Description',
                            column: 'description',
                            style: '{"padding": 0}',
                        },
                        {
                            name: 'Type',
                            column: 'type',
                            component: 'statusDisplay',
                            style: '{"width":"50px", "padding": 0}',
                            transformation: function (item) {
                                return {
                                    positive: true,
                                    statusText: item.type
                                };
                            }
                        },
                    ]
                };

                vm.filterActions = [
                    {
                        icon: 'add',
                        label: 'Add variable',
                        buttonClick: vm.editVariable
                    },
                    {
                        icon: 'refresh',
                        label: 'Reload',
                        buttonClick: vm.refreshVariableList
                    }
                ];

                vm.variableActions = [
                    {
                        icon: 'edit',
                        name: 'Edit',
                        function: vm.editVariable
                    },
                    {
                        icon: 'delete',
                        name: 'Delete',
                        function: vm.deleteVariable
                    }
                ];

                vm.templateActions = [
                    {
                        icon: 'save',
                        label: 'Save parameterized template',
                        buttonClick: vm.saveParameterizedTemplate
                    },
                    {
                        icon: 'playlist_play',
                        label: 'Preview Template',
                        buttonClick: vm.generateTemplate
                    },
                    {
                        icon: 'delete',
                        label: 'Delete Parameterized Template',
                        buttonClick: vm.deleteParameterizedTemplate
                    },
                ];
            };

            /**
             * Get template data
             * @param {string} name - template name
             * @returns {void}
             */
            vm.getTemplate = function (name) {
                vm.isLoading = true;
                Service.api.templateGet({
                    templateName: name
                }).$promise
                    .then(function (template) {
                        try {
                            vm.template = template;
                            vm.jsonData = JSON.parse(template.data);
                            vm.jsonDataOrig = angular.copy(vm.jsonData);
                        } catch (e) {
                            vm.jsonData = null;
                        }
                        return template;
                    })
                    .then(function (template) {
                        // In case if template already parameterized load parameterized template 
                        if (template.parameterized) {
                            Service.api.templateParameterizedGet({
                                templateName: vm.templateName
                            }).$promise
                                .then(function (response) {
                                    if (response.data) {
                                        try {
                                            vm.jsonData = JSON.parse(response.data);
                                        } catch (e) {
                                            console.log('Error wrong parameterized template');
                                        }
                                    }
                                })
                                .catch(function (reason) {
                                    console.log('Error templateParameterizedGet:' + JSON.stringify(reason));
                                });
                        }
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Get template list failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error templateList:' + JSON.stringify(reason));
                    })
                    .finally(function () {
                        vm.isLoading = false;
                    });
            };

            /**
             * Load variables list for template
             * @returns {void}
             */
            vm.refreshVariableList = function () {
                vm.isVariablesLoading = true;
                vm.variableListPromise = Service.api.templateVariablesList({ templateName: vm.templateName }).$promise;

                vm.variableListPromise.then(function (data) {
                    vm.variableList = data || [];
                    vm.origVariableList = angular.copy(vm.variableList);
                })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Get variables failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error templateVariablesList:' + JSON.stringify(reason));
                    })
                    .finally(function () {
                        vm.isVariablesLoading = false;
                    });
            };

            /**
             * Save variable
             * @param {object} variable - variable object
             * @return {void}
             */
            vm.saveVariable = function (variable) {
                Service.api.templateVariable({
                    templateName: vm.templateName
                }, variable).$promise
                    .then(function () {
                        vm.refreshVariableList();
                        Commons.toastShow('Variable saved');
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Save variables failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error templateVariable:' + JSON.stringify(reason));
                    });
            };

            /**
             * Variable edit dialog
             * @param {Object} event - Mouse click event
             * @param {Object} variable - variable object
             * @returns {void}
             */
            vm.editVariable = function (event, variable) {
                // Create an isolated scope to pass to the component
                var scope = angular.extend($scope.$new(true), {
                    variable: variable,
                    variableList: angular.copy(vm.variableList)
                });
                $mdDialog.show({
                    template: '<md-dialog style="width:700px;"><template-variable-dialog variable="variable" variable-list="variableList"></template-variable-dialog></md-dialog>',
                    parent: angular.element(document.body),
                    clickOutsideToClose: false,
                    preserveScope: true,
                    scope: scope,
                    skipHide: true
                })
                    .then(function (variable) {
                        if (variable) {
                            vm.saveVariable(variable);
                        }
                    });
            };

            /**
             * Delete variable
             * @param {Object} event - Mouse click event
             * @param {Object} variable - variable object
             * @returns {void}
             */
            vm.deleteVariable = function (event, variable) {
                var searchString = '${'+ variable.name + ':';
                // Check if variable is used in the template
                var jsonDataString = JSON.stringify(vm.jsonData);
                var variableInUse = jsonDataString.includes(searchString);
                if (variableInUse) {
                    vm.variableInUseWarning(event, variable);
                    return;
                }

                Commons.showConfirmationWarn(
                    gettextCatalog.getString('Remove Variable'),
                    gettextCatalog.getString('Are you sure you want to remove?<br>Removed variable cannot be restored'),
                    gettextCatalog.getString('Remove'),
                    function () {
                        Service.api.templateVariableDelete({
                            templateName: vm.templateName,
                            varName: variable.name
                        }).$promise
                            .then(function () {
                                Commons.toastShow('Variable deleted');
                                vm.refreshVariableList();
                            })
                            .catch(function (reason) {
                                var messageObject = Commons.createErrorObject(reason, 'Delete variable failed');
                                Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                                console.log('Error templateVariableDelete:' + JSON.stringify(reason));
                            });
                    }, gettextCatalog.getString('Cancel'), undefined, event);
            };

            /** 
             * Check is variable use in the template
             * @param {Object} event - mouse click event
             * @param {Object} variable - variable object
             * @returns {void}
            */
            vm.variableInUseWarning = function (event, variable) {
                Commons.showConfirmation(
                    gettextCatalog.getString('Delete'),
                    gettextCatalog.getString('The variable <strong>' + variable.name + '</strong> is used in the template.'),
                    null,
                    undefined,
                    gettextCatalog.getString('Cancel'), undefined, event);
            };

            /**
             * Save Parameterized Template
             * @returns {void}
             */
            vm.saveParameterizedTemplate = function () {
                Service.api.templateParameterized({
                    templateName: vm.templateName
                }, vm.jsonData).$promise
                    .then(function () {
                        Commons.toastShow('Parameterized template saved');
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Save parameterized template failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error templateParameterized:' + JSON.stringify(reason));
                    });
            };

            /**
             * Delete parameterized template
             * @param {Object} event - Mouse click event
             * @param {Object} item - template object
             * @returns {void}
             */
            vm.deleteParameterizedTemplate = function (event) {
                Commons.showConfirmationWarn(
                    gettextCatalog.getString('Remove Parameterized Template'),
                    gettextCatalog.getString('Are you sure you want to remove?<br>All parameters will be removed from the template.'),
                    gettextCatalog.getString('Remove'),
                    function () {
                        Service.api.templateParameterizedDelete({
                            templateName: vm.templateName
                        }).$promise
                            .then(function () {
                                Commons.toastShow('Parameters were deleted');
                                vm.jsonData = vm.jsonDataOrig;
                            })
                            .catch(function (reason) {
                                var messageObject = Commons.createErrorObject(reason, 'Delete parameterized template failed');
                                Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                                console.log('Error templateParameterizedDelete:' + JSON.stringify(reason));
                            });
                    }, gettextCatalog.getString('Cancel'), undefined, event);
            };

            /**
             * Variable list filter function
             *
             * @param {string} searchText           - Search string
             * @return {void}
             */
            vm.filter = function (searchText) {
                //Check object fields
                var firstRow = vm.origVariableList[0];
                if (!searchText || !firstRow.hasOwnProperty('description') || !firstRow.hasOwnProperty('name')) {
                    vm.variableList = vm.origVariableList;
                    return;
                }
                vm.variableList = vm.origVariableList.filter(function (row) {
                    return (row.description + row.name).toLowerCase().indexOf(searchText.toLowerCase()) >= 0;
                });
            };

            /**
             * Variable edit dialog
             * @returns {void}
             */
            vm.generateTemplate = function () {
                var templateObjects = {};
                templateObjects[vm.templateName] = {
                    template: vm.template,
                    variableList: vm.variableList || [],
                    jsonData: vm.jsonData
                };

                // Create an isolated scope to pass to the component
                var scope = angular.extend($scope.$new(true), {
                    templateObjects: templateObjects,
                    isPreview: true
                });

                $mdDialog.show({
                    template: '<md-dialog style="width:700px;"><template-values-dialog template-objects="templateObjects" is-preview="isPreview"></template-values-dialog></md-dialog>',
                    parent: angular.element(document.body),
                    clickOutsideToClose: false,
                    preserveScope: true,
                    scope: scope,
                    skipHide: true
                })
                    .then(function (params) {
                        vm.previewTemplate(vm.template, vm.jsonData, params[vm.templateName]);
                    });
            };

            /**
             * Preview compiled template
             * @param {Object} template - template object 
             * @param {Object} jsonData - parameterized template 
             * @param {Object} params - params map 
             * @return {void}
             */
            vm.previewTemplate = function (template, jsonData, params) {
                // Create an isolated scope to pass to the component
                var scope = angular.extend($scope.$new(true), {
                    template: template || {},
                    jsonData: jsonData || {},
                    params: params || {},
                });
                $mdDialog.show({
                    template: '<md-dialog style="width:700px;"><template-preview-dialog template="template" json-data="jsonData" params="params"></template-preview-dialog></md-dialog>',
                    parent: angular.element(document.body),
                    clickOutsideToClose: false,
                    preserveScope: true,
                    scope: scope,
                    skipHide: true
                });
            };
        }
    });
'use strict';
/**
 * @ngdoc component
 * @name loopUiApp.component:templateVariableDialog
 * @description
 * # templateVariableDialog
 */
angular.module('loopUiApp')
    .component('templateVariableDialog', {
        templateUrl: '../scripts/components/templates/templateVariableDialog/templateVariableDialog.html',
        bindings: {
            variable: '<',
            variableList: '<'
        },
        controller: function ($mdDialog) {
            var vm = this;
            
            vm.$onInit = function() {
                // Check if variable already exist
                vm.isNew = vm.variable ? false : true;

                vm.dataTypes = ['STRING', 'NUMBER'];

                vm.newVariable = {
                    name: '',
                    type: vm.dataTypes[0],
                    description: '',
                };

                vm.variable = vm.variable || angular.copy(vm.newVariable);
            };

            /**
             * Check is editing variable already in list
             * @param {Object} variable - variable name
             * @returns {void}
             */
            vm.validateVariableName = function (variable) {
                // Do not validate existing and empty name var
                if (!vm.isNew || !variable) {
                    return;
                }
                var isVaribleExist = vm.variableList.some(function(item) {
                    return item.name.toUpperCase() === variable.toUpperCase();
                });
                
                vm.varForm.nameField.$setValidity('exists', !isVaribleExist);
            };
                
            /**
             * Hides the dialog
             * @returns {void}
             */
            vm.hide = function () {
                $mdDialog.hide(vm.variable);
            };

            /**
             * Cancel dialog button
             * @returns {void}
             */
            vm.cancel = function () {
                $mdDialog.cancel();
            };

        }
    });
'use strict';
/**
 * @ngdoc component
 * @name loopUiApp.component:templateValuesDialog
 * @description
 * # templateValuesDialog
 */
angular.module('loopUiApp')
    .component('templateValuesDialog', {
        templateUrl: '../scripts/components/templates/templateValuesDialog/templateValuesDialog.html',
        bindings: {
            templateObjects: '<', // Map<{template, variableList, jsonData}>
            isPreview: '<',
            hostname: '<',
            activationCode: '<'
        },
        controller: function ($stateParams, $mdDialog, Service, Commons) {
            var vm = this;
            vm.variable = {}; // Variable map with key - template name

            vm.$onInit = function () {
                vm.projectId = $stateParams.projectId;
                vm.selectedTemplate = Object.keys(vm.templateObjects)[0];

                vm.loadVariableValues();
            };

            /**
             * Run template generation
             * @return {void}
             */
            vm.generateTemplate = function () {
                var variable = vm.variable[vm.selectedTemplate];
                var jsonData = vm.templateObjects[vm.selectedTemplate].jsonData;
                var request = {
                    parametrizedTemplate: JSON.stringify(jsonData),
                    values: variable,
                    templateName: vm.selectedTemplate
                };
                vm.isLoading = true;
                Service.api.templateGenerate({}, request).$promise
                    .then(function (data) {
                        Commons.downloadLink(JSON.stringify(data), 'Template_compiled.json');
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Generate template operation failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error templateGenerate:' + JSON.stringify(reason));
                    })
                    .finally(function () {
                        vm.isLoading = false;
                    });
            };

            /**
             * Load values for template variables
             * @returns {void}
             */
            vm.loadVariableValues = function () {
                vm.isValuesLoading = true;
                Service.api.templateVariableSetGet({
                    projectId: vm.projectId,
                    activationCode: vm.activationCode
                }).$promise
                    .then(function (data) {
                        // Map variable values to the structure:
                        // { "hostname": { "var1": "value1", "var2": "value2" }}
                        var values = data.reduce(function (acc, set) {
                            var varMap = set.variables.reduce(function (innerAcc, variable) {
                                innerAcc[variable.name] = variable.value;
                                return innerAcc;
                            }, {});
                            acc[(set.hostName || 'ALL')] = varMap;
                            return acc;
                        }, {});
                        vm.initValues(values);
                    })
                    .catch(function (reason) {
                        console.log('Error templateVariableSetGet:' + JSON.stringify(reason));
                    })
                    .finally(function () {
                        vm.isValuesLoading = false;
                    });
            };

            /**
             * Init template with variables
             * @param {Object} values - values object 
             * @returns {void}
             */
            vm.initValues = function (values) {
                vm.templateObjects[vm.selectedTemplate].variableList.forEach(function (_var) {
                    vm.variable[vm.selectedTemplate] = vm.variable[vm.selectedTemplate] || {};
                    if (values[vm.hostname]) {
                        vm.variable[vm.selectedTemplate][_var.name] = values[vm.hostname][_var.name] || null;
                    } else {
                        vm.variable[vm.selectedTemplate][_var.name] = values.ALL ? values.ALL[_var.name] : null;
                    }
                });
            };

            /**
             * Select template name from tab
             * @param {String} templateName - template name
             * @return {void}
             */
            vm.selectTemplate = function (templateName) {
                vm.selectedTemplate = templateName;
            };

            /**
             * Hides the dialog
             * @returns {void}
             */
            vm.hide = function () {
                $mdDialog.hide(vm.variable);
            };

            /**
             * Cancel dialog button
             * @returns {void}
             */
            vm.cancel = function () {
                $mdDialog.cancel();
            };

        }
    });
'use strict';
/**
 * @ngdoc component
 * @name loopUiApp.component:templatePreviewDialog
 * @description
 * # templatePreviewDialog
 */
angular.module('loopUiApp')
    .component('templatePreviewDialog', {
        templateUrl: '../scripts/components/templates/templatePreviewDialog/templatePreviewDialog.html',
        bindings: {
            template: '<',
            jsonData: '<',
            params: '<'
        },
        controller: function ($mdDialog, Service, Commons) {
            var vm = this;
            vm.compiledTemplate = null;

            vm.$onInit = function () {
                vm.generateTemplate();
            };

            /**
             * Run template generation
             * @return {void}
             */
            vm.generateTemplate = function () {
                var request = {
                    parametrizedTemplate: JSON.stringify(vm.jsonData),
                    values: vm.params,
                    templateName: vm.template.name
                };
                vm.isLoading = true;
                Service.api.templateGenerate({}, request).$promise
                    .then(function (data) {
                        vm.compiledTemplate = data.toJSON();
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Generate template operation failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error templateGenerate:' + JSON.stringify(reason));
                    })
                    .finally(function() {
                        vm.isLoading = false;
                    });
            };

            /**
             * Download template
             * @returns {void}
             */
            vm.download = function () {
                Commons.downloadLink(JSON.stringify(vm.compiledTemplate), (vm.template.desc || 'Template') + '_compiled.json');
            };

            /**
             * Cancel dialog button
             * @returns {void}
             */
            vm.cancel = function () {
                $mdDialog.cancel();
            };
        }
    });
'use strict';
/**
 * @ngdoc company level model: Edge app list container
 * @name loopUiApp.component:edgeApplicationContainer
 * @description
 * # edgeApplicationContainer
 */
angular.module('loopUiApp')
    .component('edgeApplicationContainer', {
        templateUrl: '../scripts/components/edgeApps/edgeApplicationContainer.html',
        controller: function (appConfig, licenseCheck, Commons) {
            var vm = this;
            vm.lc = licenseCheck;

            vm.$onInit = function() {
                vm.adminUiName = appConfig.__env.adminUiName || 'Admin Console';
                vm.adminUilink = Commons.getAdminUiLink() + '/license';
            };
        }
    });
'use strict';
/**
 * @ngdoc company level model: Edge app list
 * @name loopUiApp.component:edgeApplicationList
 * @description
 * # edgeApplicationList
 */
angular.module('loopUiApp')
    .component('edgeApplicationList', {
        templateUrl: '../scripts/components/edgeApps/edgeApplicationList.html',
        controller: function ($scope, $q, $state, $stateParams, $mdDialog, $mdToast, $timeout, Auth, ServiceMPCS, Commons) {
            var vm = this;

            vm.auth = Auth;
            vm.catalogList = [];
            vm.catalogListObject = {};
            vm.catalogFilter = [];
            vm.appFilter = {
                catalogList: []
            };
            vm.noPermissions = false;
            
            // Maximum number or retries to get the list of apps
            vm.RETRY_ATTEMPTS = 2;
            // Error counter to get the list of apps
            vm.errorCount = 0;

            vm.appList = [];

            vm.$onInit = function () {
                vm.refreshCatalogList();

                vm.entityName = 'Applications';
                // Generic table setup
                vm.listSetup = {
                    sortField: 'name',
                    showIndex: false,
                    editable: false,
                    removable: false,
                    limit: 10,
                    limitOptions: [10, 50, 100],
                    fields: [
                        {
                            name: 'Image',
                            column: 'icon',
                            image: true,
                            style: '{"width": "20px"}',
                            transformation: function (item) {
                                return item.icon ? 'data:image/jpeg;base64,' + item.icon : '/images/photo.svg';
                            }

                        },
                        {
                            name: 'Name',
                            column: 'name',
                            link: true,
                            fieldAction: function (item) {
                                $state.go('edgeApplicationDetails', {
                                    companyName: $stateParams.companyName,
                                    projectId: $stateParams.projectId,
                                    catalogId: item.catalogId,
                                    applicationId: item.id
                                });
                            }
                        },
                        {
                            name: 'Publisher',
                            column: 'publisherName'
                        },
                        {
                            name: 'Category',
                            column: 'category'
                        },
                        {
                            name: 'Description',
                            column: 'description'
                        }
                    ]
                };

                vm.additionalActions = [
                    {
                        name: 'Launch App',
                        icon: 'playlist_add',
                        function: vm.viewDeviceSelector
                    },
                    {
                        name: 'Details',
                        icon: 'assignment',
                        function: function (event, item) {
                            $state.go('edgeApplicationDetails', {
                                companyName: $stateParams.companyName,
                                projectId: $stateParams.projectId,
                                catalogId: item.catalogId,
                                applicationId: item.id
                            });
                        }
                    }
                ];

                vm.filterActions = [
                    {
                        label: 'Push Marketplace catalogs to Edge devices',
                        icon: 'cloud_sync',
                        buttonClick: vm.viewDeviceCatalogSelector
                    },
                    {
                        label: 'Refresh',
                        icon: 'refresh',
                        buttonClick: function () {
                            vm.refreshAppList(vm.catalogList);
                        }
                    }
                ];
            };

            /**
             * Refresh MP list
             * @returns {void}
             */
            vm.refreshCatalogList = function () {
                vm.isCatalogLoading = true;
                ServiceMPCS.api.catalogList().$promise
                    .then(function (data) {
                        vm.noPermissions = false;
                        vm.catalogListOrig = data;
                        vm.catalogList = data;
                        // Prepare catalog map - key as catalog identificator
                        vm.catalogListObject = data.reduce(function (acc, cur) {
                            acc[cur.id] = cur;
                            return acc;
                        }, {});
                        vm.refreshAppList(vm.catalogList);
                        vm.catalogFilter = data.map(function (item) {
                            return {
                                id: item.id,
                                name: item.name
                            };
                        });
                    })
                    .catch(function (reason) {
                        // If catalog API returns 4xx error then show notification
                        if ([401, 403].indexOf(reason.status) > -1) {
                            vm.noPermissions = true;
                        }
                        var messageObject = Commons.createErrorObject(reason, 'Get catalogs failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('catalogList:' + JSON.stringify(reason));
                    })
                    .finally(function () {
                        vm.isCatalogLoading = false;
                    });
            };

            /**
             * Refresh application list
             * @param {Array} catalogList - list of catalogs
             * @param {Boolean} isRetry - flag to retry applications.
             * In case of true, do not clean vm.appList, add new apps to the list
             * In case of false | undefined, clean vm.appList and add apps again
             * @returns {void}
             */
            vm.refreshAppList = function (catalogList, isRetry) {
                var promiseHash = {};
                // List of failed catalogs to retry
                var failedCatalogs = [];
                vm.isAppLoading = true;
                vm.appList = isRetry ? vm.appList : [];
                // Get all apps as hash promise object with catalog key
                catalogList.forEach(function (catalog) {
                    promiseHash[catalog.id] = $q(function (resolve) {
                        ServiceMPCS.api.applicationList({
                            action: catalog.id
                        }).$promise
                            .then(function (data) {
                                resolve({
                                    isError: false,
                                    catalog: catalog,
                                    data: data
                                });
                            })
                            .catch(function (error) {
                                resolve({
                                    isError: true,
                                    catalog: catalog,
                                    data: error
                                });
                            });
                    });
                });

                vm.appListPromise = $q.all(promiseHash);

                vm.appListPromise.then(function (resultObject) {
                    vm.noPermissions = false;
                    for (var catalogId in resultObject) {
                        // In case of success add all apps to the vm.appList
                        if (!resultObject[catalogId].isError) {
                            for (var i = 0; i < resultObject[catalogId].data.length; i++) {
                                // Enrich applist objects with catalog id
                                var app = resultObject[catalogId].data[i];
                                app.catalogId = catalogId;
                                vm.appList.push(app);
                            }
                        }
                        else {
                            // In case of error add catalog to retry list
                            failedCatalogs.push({
                                id: catalogId,
                            });
                        }
                    }
                    vm.origAppList = angular.copy(vm.appList);

                    // If there are failed catalogs
                    if (failedCatalogs.length > 0) {
                        // If error count has reached max retry count then show error
                        if (vm.errorCount >= vm.RETRY_ATTEMPTS) {
                            vm.showRetryToast(failedCatalogs);
                        } else {
                            // If error count is less than max retry count then retry automatically
                            $timeout(function () {
                                vm.refreshAppList(failedCatalogs, true);
                                vm.errorCount++;
                            }, 500);
                        }
                    } else {
                        // Reset error count
                        vm.errorCount = 0;
                    }
                })
                    .finally(function () {
                        vm.isAppLoading = false;
                    });
            };

            /**
             * Show warning toast which allows to retry failed catalogs
             * @param {Array} catalogList - list of catalogs to retry
             */
            vm.showRetryToast = function (catalogList) {
                var toast = $mdToast.simple()
                    .textContent('Some applications were not loaded. Please retry later.')
                    .action('Retry')
                    .highlightAction(true)
                    .position('bottom right')
                    .hideDelay(0);

                $mdToast.show(toast)
                    .then(function () {
                        vm.refreshAppList(catalogList, true);
                    });
            };

            /**
             * Filter app list based on search criteria
             *
             * @param {string} searchText           - Search string
             * @return {void}
             */
            vm.filter = function (searchText) {
                if (!searchText) {
                    vm.appList = vm.origAppList;
                    return;
                }
                vm.appList = vm.origAppList.filter(function (row) {
                    return (row.description + row.name).toLowerCase().indexOf(searchText.toLowerCase()) >= 0;
                });
            };

            /**
             * Show device selector dialog
             *
             * @param {Event} event      - Mouse click event to determine target
             * @param {Object} app       - application to start on device
             * @returns {void}
             */
            vm.viewDeviceSelector = function (event, app) {
                // Create an isolated scope to pass to the component
                var scope = angular.extend($scope.$new(true), {
                    app: app,
                    catalog: vm.catalogListObject[app.catalogId]
                });
                $mdDialog.show({
                    template: '<md-dialog aria-label="Device select"><device-for-app-dialog app="app" catalog="catalog"></evice-for-app-dialog></md-dialog>',
                    parent: angular.element(document.body),
                    targetEvent: event,
                    clickOutsideToClose: false,
                    preserveScope: true,
                    scope: scope,
                    skipHide: true
                });
            };

            /**
             * Show device and catalog selector dialog
             * @param {Event} event - Mouse click event to determine target
             * @returns {void}
             */
            vm.viewDeviceCatalogSelector = function (event) {
                $mdDialog.show({
                    template: '<md-dialog aria-label="Device select"><device-for-catalog-dialog></device-for-app-dialog></md-dialog>',
                    parent: angular.element(document.body),
                    targetEvent: event,
                    clickOutsideToClose: false,
                    preserveScope: true,
                    skipHide: true
                });
            };

            /**
             * Refresh app list by selected catalog
             * @param {Array} filteredList - selected catalogs
             * @returns {void} 
             */
            vm.filterByCatalog = function (filteredList) {
                vm.catalogList = filteredList.length > 0 ? filteredList : vm.catalogListOrig;
                vm.refreshAppList(vm.catalogList);
            };
        }
    });
'use strict';
/**
 * @ngdoc company level model: Edge application settings
 * @name loopUiApp.component:edgeAppSettings
 * @description
 * # edgeAppSettings
 */
angular.module('loopUiApp')
    .component('edgeAppSettings', {
        templateUrl: '../scripts/components/edgeApps/edgeAppSettings.html',
        bindings: {
            app: '<',
            deviceAppList: '<',
            selectedRelease: '=',
            paramValue: '=',
            isUpgrade: '<'
        },
        controller: function ($q, Service, ServiceMPCS) {
            var vm = this;
            vm.READ_ONLY_PARAM = 'EDGE_API_TOKEN';

            vm.$onInit = function () {
                vm.selectedRelease = null;
                vm.paramValue = {};
                // List of all app names install on selected devices
                vm.usedNames = [];

                if (!vm.isUpgrade) {
                    // Do not allow to change version if selected device contains 3.0 version
                    vm.disableNameChange = vm.deviceAppList.some(function (device) {
                        return vm.compareVersion('3.0', device.properties['Firmware Version'].value);
                    });
    
                    // Get information about installed apps
                    vm.createAppStatus(vm.deviceAppList);
                }

                vm.refreshReleaseList(vm.app);
            };

            /**
             * Get release list for application
             * @param {Object} app - application object
             * @returns {void}
             */
            vm.refreshReleaseList = function (app) {
                ServiceMPCS.api.releaseList({
                    catalog_id: app.catalogId,
                    application_id: app.id
                }).$promise
                    .then(function (data) {
                        vm.releaseList = data;
                        vm.selectedRelease = vm.releaseList[0];
                        vm.initDefaultValues(vm.selectedRelease);
                        vm.checkComponentExist(vm.selectedRelease);
                    })
                    .catch(function (reason) {
                        console.log('Error releaseList:' + JSON.stringify(reason));
                    });
            };

            /**
             * Get release list for application
             * @param {Object} app - application object
             * @param {Object} release - release object
             * @returns {void}
             */
            vm.getRelease = function (app, release) {
                ServiceMPCS.api.release({
                    catalog_id: app.catalogId,
                    application_id: app.id,
                    release: release.name
                }).$promise
                    .then(function (data) {
                        vm.releaseData = data;
                    })
                    .catch(function (reason) {
                        console.log('Error releaseList:' + JSON.stringify(reason));
                    });
            };

            /**
             * Set default param values for app parameters
             * @param {Object} release - selected release
             * @return {void}
             */
            vm.initDefaultValues = function (release) {
                if (!release || !angular.isArray(release.variables) || release.variables.length === 0) {
                    return;
                }
                vm.deviceAppList.forEach(function (deviceApp) {
                    // In case when application already exist use a key with device id and app name
                    deviceApp.deviceAppId = deviceApp.deviceAppId || deviceApp.deviceId + (deviceApp.name ? '_' + deviceApp.name : '');
                    // If params already init then exit
                    if (vm.paramValue[vm.selectedRelease.name] && vm.paramValue[vm.selectedRelease.name][deviceApp.deviceAppId]) {
                        return;
                    }
                    vm.paramValue[vm.selectedRelease.name] = vm.paramValue[vm.selectedRelease.name] || {};
                    vm.paramValue[vm.selectedRelease.name][deviceApp.deviceAppId] = {};
                    release.variables.forEach(function (variable) {
                        vm.paramValue[vm.selectedRelease.name][deviceApp.deviceAppId][variable.name] = vm.restoreValue(variable, deviceApp.parameters);
                    });
                });
            };

            /**
             * Try to find existing params value.
             * Or return default for this variable
             * @param {Object} variable - variable object
             * @param {Object} existingParameters - map of values which come from launched application
             * @returns {any} param value
             */
            vm.restoreValue = function (variable, existingParameters) {
                try {
                    return variable.type === 'int' ? parseInt(existingParameters[variable.name]) : (existingParameters[variable.name] || '');
                } catch (e) {
                    return variable.type === 'int' ? parseInt(variable.default) : (variable.default || '');
                }
            };

            /**
             * Validate release - check if it has components
             * @param {Object} release - release object
             */
            vm.checkComponentExist = function (release) {
                if (release && release.components && release.components.length > 0) {
                    vm.paramForm.releaseField.$setValidity('no-component', true);
                } else {
                    vm.paramForm.releaseField.$setTouched();
                    vm.paramForm.releaseField.$setValidity('no-component', false);
                }
            };

            /**
             * Get list of app names launched on selected devices
             * @param {Array} deviceList - list of devices to launch app
             * @returns {void}
             */
            vm.createAppStatus = function (deviceList) {
                var appPromiseHash = {};

                deviceList.forEach(function (device) {
                    appPromiseHash[device.deviceId] =
                        // Wrap call to catch en error in the concurrent calls
                        $q(function (resolve) {
                            Service.api.marketplaceAppList({
                                projectId: device.projectId,
                                deviceId: device.deviceId
                            }).$promise
                                .then(function (data) {
                                    resolve({
                                        data: data,
                                        error: null
                                    });
                                })
                                .catch(function (error) {
                                    // Catch error and return error object
                                    resolve({
                                        data: [],
                                        error: error
                                    });
                                });
                        });
                });

                $q.all(appPromiseHash)
                    .then(function (appObject) {
                        // All existing app names for selected devices
                        vm.usedNames = [];
                        Object.keys(appObject)
                            .forEach(function (deviceId) {
                                appObject[deviceId].data.forEach(function(app) {
                                    vm.usedNames.push(app.name.toUpperCase());
                                });
                            });
                        // Run validation once stats ready
                        vm.checkNameValidity(vm.app.name);
                        vm.paramForm.appNameField.$setTouched();
                    });
            };

            /**
             * Check app name validity. Do not allow to launch app with the same name
             * @param {string} value - name field value 
             * @return {void}
             */
            vm.checkNameValidity = function (value) {
                if (vm.usedNames.indexOf(value.toUpperCase()) >= 0) {
                    vm.paramForm.appNameField.$setValidity('name-exist', false);
                } else {
                    vm.paramForm.appNameField.$setValidity('name-exist', true);
                }
            };

            /**
             * Compare first 2 digits of LE version
             * @param {string} version1 - string of version  1, like 3.0.1
             * @param {string} version2 - string of version  2
             * @return {boolean} - is equal
             */
            vm.compareVersion = function (version1, version2) {
                // Return array of number first 2
                var parseVersion = function (version) {
                    return version.split('.')
                        .slice(0, 2)
                        .map(function (item) {
                            try {
                                return Number.parseInt(item);
                            } catch (e) {
                                return 0;
                            }
                        });
                };
                var parsedVersion1 = parseVersion(version1);
                var parsedVersion2 = parseVersion(version2);
                return parsedVersion1[0] === parsedVersion2[0] &&
                    parsedVersion1[1] === parsedVersion2[1];
            };
        }
    });
'use strict';
/**
 * @ngdoc company level model: Edge app device selector
 * @name loopUiApp.component:edgeApplicationDetails
 * @description
 * # edgeApplicationDetails
 */
angular.module('loopUiApp')
    .component('edgeApplicationDetails', {
        templateUrl: '../scripts/components/edgeApps/edgeApplicationDetails.html',
        controller: function ($state, $scope, $filter, $interval, $stateParams, $window, $mdDialog, gettextCatalog,
            appConfig, licenseCheck, ServiceAsyncTask, Service, ServiceMPCS, Commons) {
            var vm = this;
            vm.lc = licenseCheck;

            // Application object
            vm.application = {};
            vm.deviceAppList = [];
            vm.deviceAppListOrigin = [];
            // Devices map
            vm.devicesMap = {};
            vm.selectedDevices = [];
            // Number of online devices
            vm.allDevicesCnt = undefined;

            vm.deviceFilter = null;
            vm.groupList = [];
            vm.catalog = {};
            vm.releaseList = [];
            vm.statusList = [];
            vm.deviceStatusList = [{ name: 'Online' }];

            vm.isActionRunning = false;

            vm.$onInit = function () {
                vm.companyName = $stateParams.companyName;
                vm.projectId = $stateParams.projectId;
                vm.applicationId = $stateParams.applicationId;
                vm.catalogId = $stateParams.catalogId;

                // Load application data
                vm.refreshCatalogData(vm.catalogId);
                vm.refreshApplicationData(vm.catalogId, vm.applicationId);
                vm.refreshReleaseList(vm.catalogId, vm.applicationId);
                // Load device tags
                vm.refreshTagList();
                // Load device stats
                vm.refreshDevicesStats();

                vm.entityName = 'Edge Devices';

                // Generic table setup
                vm.listSetup = {
                    sortField: 'name',
                    keyName: 'deviceId',
                    showIndex: false,
                    editable: false,
                    removable: false,
                    rowSelection: false,
                    selectionDisabledFunction: function (item) {
                        return item.deviceOnline === false;
                    },
                    multipleSelection: false,
                    limit: 10,
                    limitOptions: [10, 50, 100],
                    fields: [
                        {
                            name: 'Device Id',
                            column: 'prettyName',
                            link: true,
                            fieldAction: function (item) {
                                $state.go('deviceView', {
                                    companyName: vm.companyName,
                                    projectId: vm.projectId,
                                    deviceId: item.deviceId,
                                    selectedTab: 'apps'
                                });
                            },
                        },
                        {
                            name: 'Device Status',
                            column: 'deviceOnline',
                            style: '{"width":"40px"}',
                            component: 'statusDisplay',
                            transformation: function (item) {
                                return {
                                    positive: item.deviceOnline,
                                    statusText: item.deviceOnline ? 'Online' : 'Offline'
                                };
                            }
                        },
                        {
                            name: 'App Name',
                            column: 'name'
                        },
                        {
                            name: 'Release',
                            column: 'releaseName'
                        },
                        {
                            name: 'Groups',
                            column: 'tags',
                            transformation: function (item) {
                                return item.tags.join(', ');
                            }
                        },
                        {
                            name: 'App Status',
                            column: 'status'
                        },
                        {
                            name: 'App Status Time',
                            column: 'statusChangedAt',
                            transformation: function (item) {
                                // Check timestamp format milliseconds or seconds
                                // Workaround as MPC API has changed timestamp format from version 3.0
                                var _ts = item.statusChangedAt < 1E11 ? item.statusChangedAt * 1000 : item.statusChangedAt;
                                return $filter('date')(_ts, 'yyyy-MM-dd HH:mm');
                            }
                        },
                    ]
                };

                vm.additionalActions = [
                    {
                        name: 'Start Application',
                        icon: 'play_arrow',
                        function: function (event, item) {
                            vm.startApp([item]);
                        },
                        disable: function (item) {
                            return item.deviceOnline === false;
                        }
                    },
                    {
                        name: 'Stop Application',
                        icon: 'stop',
                        function: function (event, item) {
                            vm.stopApp([item]);
                        },
                        disable: function (item) {
                            return item.deviceOnline === false;
                        }
                    },
                    {
                        name: 'Update Application',
                        icon: 'system_update',
                        function: function (event, item) {
                            vm.upgradeApp([item]);
                        },
                        disable: function (item) {
                            return item.deviceOnline === false;
                        }
                    },
                    {
                        name: 'Delete Application',
                        icon: 'delete',
                        function: function (event, item) {
                            vm.deleteApp([item]);
                        },
                        disable: function (item) {
                            return item.deviceOnline === false;
                        }
                    },
                    {
                        name: 'Logs',
                        icon: 'subject',
                        function: vm.showLog,
                        disable: function (item) {
                            return item.deviceOnline === false;
                        }
                    }
                ];

                vm.listActions = [
                    {
                        name: 'Deploy application to device(s)',
                        icon: 'playlist_add',
                        function: vm.viewDeviceSelector
                    },
                    {
                        name: 'Multiple Select',
                        icon: 'done_all',
                        function: vm.toggleSelectMode
                    },
                    /* {
                        name: 'Refresh application cache',
                        icon: 'published_with_changes',
                        function: function () {
                            vm.refreshAppCache();
                        }
                    }, */
                    {
                        name: 'Refresh list',
                        icon: 'refresh',
                        function: function () {
                            vm.createAppStat(vm.application);
                            // Load device tags
                            vm.refreshTagList();
                            // Load device stats
                            vm.refreshDevicesStats();
                        }
                    },
                ];

                // Application actions
                vm.appActions = [{
                    name: 'Start',
                    icon: 'play_arrow',
                    function: function (appList) {
                        vm.startApp(appList);
                    }
                },
                {
                    name: 'Stop',
                    icon: 'stop',
                    function: function (appList) {
                        vm.stopApp(appList);
                    }
                },
                {
                    name: 'Update Application',
                    icon: 'system_update',
                    function: function (appList) {
                        vm.upgradeApp(appList);
                    }
                },
                {
                    name: 'Delete',
                    icon: 'delete',
                    function: function (appList) {
                        vm.deleteApp(appList);
                    }
                }];

                // Filters block
                vm.groupFilterSettings = {
                    name: 'Groups',
                    filter: true,
                    entityIcon: 'done_all'
                };

                vm.releaseFilterSettings = {
                    name: 'Release',
                    filter: true,
                    entityIcon: 'label'
                };

                vm.statusFilterSettings = {
                    name: 'Status',
                    filter: true,
                    entityIcon: 'play_arrow'
                };

            };

            vm.$onDestroy = function () {
                if (vm.logPullInterval) {
                    $interval.cancel(vm.logPullInterval);
                }
            };

            /**
             * Load application data
             * @param {String} catalogId - catalog id
             * @param {String} applicationId - application id
             * @returns {void}
             */
            vm.refreshApplicationData = function (catalogId, applicationId) {
                ServiceMPCS.api.application({
                    catalog_id: catalogId,
                    application_id: applicationId
                }).$promise
                    .then(function (data) {
                        vm.application = data;
                        // Enrich app object with catalogId
                        vm.application.catalogId = vm.catalogId;
                        vm.applicationIcon = data.icon ? 'data:image/jpeg;base64,' + data.icon : '/images/photo.svg';

                        // Calc app stat
                        vm.createAppStat(vm.application);

                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Failed to load application data');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                    });
            };

            /**
             * Load catalog data
             * @param {String} catalogId - catalog id
             * @returns {void}
             */
            vm.refreshCatalogData = function (catalogId) {
                ServiceMPCS.api.catalog({
                    action: catalogId
                }).$promise
                    .then(function (data) {
                        vm.catalog = data;
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Failed to load catalog data');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                    });
            };

            /**
             * Load application data
             * @param {String} catalogId - catalog id
             * @param {String} applicationId - application id
             * @returns {void}
             */
            vm.refreshReleaseList = function (catalogId, applicationId) {
                ServiceMPCS.api.releaseList({
                    catalog_id: catalogId,
                    application_id: applicationId
                }).$promise
                    .then(function (releaseList) {
                        // Calculate latest release
                        vm.latestRelease = vm.getLatestRelease(releaseList);
                    })
                    .catch(function (reason) {
                        var message = reason.data && reason.data.message ? reason.data.message : 'Failed to load release list';
                        Commons.toastShow(message);
                    });
            };

            /**
             * Load tags list
             * @returns {void}
             */
            vm.refreshTagList = function () {
                Service.api.deviceTagList({
                    projectId: vm.projectId
                }).$promise
                    .then(function (data) {
                        vm.groupList = data.map(function (item) {
                            return { name: item, count: null };
                        });
                    })
                    .catch(function () {
                        vm.groupList = [];
                    });
            };

            /**
             * Calculate statistic by appList field
             * @param {Array} deviceAppList - device-app list
             * @param {String} fieldName - field name to get stat
             * @return {Array} - result array for status filter
             */
            vm.getGroupList = function (deviceAppList, fieldName) {
                var object = deviceAppList.reduce(function (acc, cur) {
                    acc[cur[fieldName]] = acc[cur[fieldName]] === undefined ? 1 : acc[cur[fieldName]] + 1;
                    return acc;
                }, {});
                return Object.keys(object).map(function (key) {
                    return {
                        name: key,
                        count: object[key]
                    };
                });
            };

            /**
             * Calculate device statistic
             */
            vm.refreshDevicesStats = function () {
                Service.api.deviceList({
                    projectId: vm.projectId,
                    tag: null,
                    deviceType: 'LOOPEDGE',
                    requestedPage: 0,
                    limit: 1000,
                    onlineOnly: false // Get all devices
                }).$promise
                    .then(function (data) {
                        // Number of all devices
                        vm.allDevicesCnt = data.totalSize;
                        vm.devicesMap = vm.transformDeviceList(data.elements);
                    })
                    .catch(function (reason) {
                        console.log('Error deviceList:' + JSON.stringify(reason));
                    });
            };

            /**
             * Calculate app statistic by devices
             * @param {Object} application - app object
             * @returns {void}
             */
            vm.createAppStat = function (application) {
                vm.deviceAppPromise = Service.api.marketplaceAppPlainList({
                    projectId: vm.projectId,
                    catalogApplicationId: application.id
                }).$promise;

                vm.deviceAppPromise
                    .then(function (data) {
                        vm.deviceAppList = data;
                        vm.deviceAppListOrigin = angular.copy(vm.deviceAppList);

                        // In case if filter is not empty - filter apps
                        if (vm.isFilterChanged(vm.deviceFilter)) {
                            vm.filter(vm.deviceFilter);
                        }

                        // Calculate online devices
                        vm.deviceStatusList[0].count = data.reduce(function (acc, cur) {
                            return cur.deviceOnline === true ? acc + 1 : acc;
                        }, 0);
                        vm.statusList = vm.getGroupList(vm.deviceAppListOrigin, 'status');
                        vm.releaseList = vm.getGroupList(vm.deviceAppListOrigin, 'releaseName');
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Get application details failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error marketplaceAppPlainList:' + JSON.stringify(reason));
                    });
            };

            /**
             * Start application on device(s)
             * @param {Array} appList - application by device list
             * @returns {void}
             */
            vm.startApp = function (appList) {
                vm.isActionRunning = true;
                vm.runningStatusText = 'Starting app...';

                // Add instance app id to params
                var _enrichParams = function (subTask, type, app) {
                    var _subTask = angular.copy(subTask);
                    _subTask.params.applicationId = app.id; // Here "id" is an instance app id
                    return _subTask;
                };

                ServiceAsyncTask.createTaskAndWait(
                    ServiceAsyncTask.taskTypes.MARKETPLACE_APPLICATION_START.code, // Task type
                    ServiceAsyncTask.taskTypes.MARKETPLACE_APPLICATION_START.subtaskTypes, // Subtask types
                    '', // Task description 
                    appList,
                    {}, // Task params
                    false, // Wait device for online
                    _enrichParams
                )
                    .then(function () {
                        vm.refreshApplicationData(vm.catalogId, vm.applicationId);
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Start app list failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error marketplaceAppStart:' + JSON.stringify(reason));
                    })
                    .finally(function () {
                        vm.isActionRunning = false;
                        vm.runningStatusText = '';
                    });
            };

            /**
             * Stop application on device(s)
             * @param {Array} appList - application by device list
             * @returns {void}
             */
            vm.stopApp = function (appList) {
                vm.isActionRunning = true;
                vm.runningStatusText = 'Stopping app...';

                // Add instance app id to params
                var _enrichParams = function (subTask, type, app) {
                    var _subTask = angular.copy(subTask);
                    _subTask.params.applicationId = app.id; // Here "id" is an instance app id
                    return _subTask;
                };

                ServiceAsyncTask.createTaskAndWait(
                    ServiceAsyncTask.taskTypes.MARKETPLACE_APPLICATION_STOP.code, // Task type
                    ServiceAsyncTask.taskTypes.MARKETPLACE_APPLICATION_STOP.subtaskTypes, // Subtask types
                    '', // Task description 
                    appList,
                    {}, // Task params
                    false, // Wait device for online
                    _enrichParams
                )
                    .then(function () {
                        vm.refreshApplicationData(vm.catalogId, vm.applicationId);
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Stop app list failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error marketplaceAppStop:' + JSON.stringify(reason));
                    })
                    .finally(function () {
                        vm.isActionRunning = false;
                        vm.runningStatusText = '';
                    });
            };

            /**
             * Run delete action with confirmation
             * @param {Array} appList - application by device list
             * @returns {void}
             */
            vm.deleteApp = function (appList) {
                var _deleteApp = function (appList) {
                    vm.isActionRunning = true;
                    vm.runningStatusText = 'Deleting app...';

                    // Add instance app id to params
                    var _enrichParams = function (subTask, type, app) {
                        var _subTask = angular.copy(subTask);
                        _subTask.params.applicationId = app.id; // Here "id" is an instance app id
                        return _subTask;
                    };

                    ServiceAsyncTask.createTaskAndWait(
                        ServiceAsyncTask.taskTypes.MARKETPLACE_APPLICATION_DELETE.code, // Task type
                        ServiceAsyncTask.taskTypes.MARKETPLACE_APPLICATION_DELETE.subtaskTypes, // Subtask types
                        '', // Task description 
                        appList,
                        {}, // Task params
                        false, // Wait device for online
                        _enrichParams
                    )
                        .then(function () {
                            vm.selectedDevices = undefined;
                            vm.refreshApplicationData(vm.catalogId, vm.applicationId);
                        })
                        .catch(function (reason) {
                            var messageObject = Commons.createErrorObject(reason, 'Delete app list failed');
                            Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                            console.log('Error marketplaceAppDelete:' + JSON.stringify(reason));
                        })
                        .finally(function () {
                            vm.isActionRunning = false;
                            vm.runningStatusText = '';
                        });
                };

                Commons.showConfirmationWarn(
                    gettextCatalog.getString('Remove Application'),
                    gettextCatalog.getString('Are you sure you want to remove application from ' + appList.length + ' device(s)?'),
                    gettextCatalog.getString('Remove'),
                    function () {
                        _deleteApp(appList);
                    },
                    gettextCatalog.getString('Cancel'),
                    null,
                    event);
            };

            /**
             * Upgrade app params
             * @param {Array} deviceAppList - application by device list
             * @returns {void}
             */
            vm.upgradeApp = function (deviceAppList) {
                var scope = angular.extend($scope.$new(true), {
                    app: vm.application,
                    deviceAppList: deviceAppList
                });
                $mdDialog.show({
                    template: '<edge-application-upgrade app="app" device-app-list="deviceAppList"></edge-application-upgrade>',
                    parent: angular.element(document.body),
                    clickOutsideToClose: false,
                    preserveScope: true,
                    scope: scope,
                    skipHide: true
                })
                    .then(function (data) {
                        var selectedRelease = data.selectedRelease.name;
                        var paramValue = data.paramValue[selectedRelease] || {};
                        vm.upgradeAppAction(deviceAppList, selectedRelease, paramValue);
                    });
            };

            /**
             * Run upgrade action:
             * 0) Take confirmation
             * 1) Launch app upgrade with a new version (release)
             * @param {Array} appList - app/device objects array
             * @param {String} selectedRelease - upgrade release
             * @param {Object} paramValue - params for upgrade release
             * @returns {void} 
             */
            vm.upgradeAppAction = function (appList, selectedRelease, paramValue) {
                var _upgrade = function () {
                    vm.isActionRunning = true;
                    vm.runningStatusText = 'Upgrading app...';

                    // Add instance app id to params
                    var _enrichParams = function (subTask, type, app) {
                        // In case when application already exist use a key with device id and app name
                        var deviceAppId = app.deviceId + (app.name ? '_' + app.name : '');

                        var _subTask = angular.copy(subTask);
                        _subTask.params.applicationId = app.catalogApplicationId; // // Here is app id from catalog
                        _subTask.params.launchedApplicationId = app.id; // Here "id" is an instance app id
                        _subTask.params.applicationName = app.name;
                        _subTask.params.applicationParameters = paramValue[deviceAppId] || {};
                        return _subTask;
                    };

                    ServiceAsyncTask.createTaskAndWait(
                        ServiceAsyncTask.taskTypes.MARKETPLACE_APPLICATION_UPGRADE.code, // Task type
                        ServiceAsyncTask.taskTypes.MARKETPLACE_APPLICATION_UPGRADE.subtaskTypes, // Subtask types
                        '', // Task description 
                        appList,
                        {
                            applicationDescription: vm.application.description || '',
                            applicationId: null, // Will be filled in the _enrichParams
                            applicationName: null, // Will be filled in the _enrichParams
                            applicationParameters: {}, // Will be filled in the _enrichParams
                            applicationVersion: selectedRelease,
                            catalogId: vm.catalog.id,
                            catalogName: vm.catalog.name,
                            catalogPrivate: appConfig.__env.mbCatalogPrivate,
                            catalogTlsSkipVerify: appConfig.__env.mbCatalogTlsSkipVerify,
                            catalogUrl: appConfig.__env.mbApiUrl
                        }, // Task params
                        false, // Wait device for online
                        _enrichParams
                    )
                        .then(function () {
                            vm.refreshApplicationData(vm.catalogId, vm.applicationId);
                            vm.selectedDevices = undefined;
                        })
                        .catch(function (reason) {
                            var messageObject = Commons.createErrorObject(reason, 'Stop app list failed');
                            Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                            console.log('Error marketplaceAppStop:' + JSON.stringify(reason));
                        })
                        .finally(function () {
                            vm.isActionRunning = false;
                            vm.runningStatusText = '';
                        });
                };

                Commons.showConfirmation(
                    gettextCatalog.getString('Update Application'),
                    gettextCatalog.getString('Are you sure you want to update the application on ' + appList.length + ' device(s)?<br>' + 
                        'Previous release will be removed.'),
                    gettextCatalog.getString('Yes, Update'),
                    _upgrade,
                    gettextCatalog.getString('Cancel'),
                    null,
                    event);
            };

            /**
             * Refresh application cache
             * @returns {void}
             */
            vm.refreshAppCache = function () {
                vm.isActionRunning = true;
                vm.runningStatusText = 'Refreshing application cache...';
                ServiceAsyncTask.createTaskAndWait(
                    ServiceAsyncTask.taskTypes.MARKETPLACE_APPLICATION_CACHE_REFRESH.code, // Task type
                    ServiceAsyncTask.taskTypes.MARKETPLACE_APPLICATION_CACHE_REFRESH.subtaskTypes, // Subtask types
                    '', // Task description 
                    [{ deviceId: '' }],
                    { projectId: vm.projectId }, // Task params
                    false // Wait device for online
                )
                    .then(function () {
                        vm.createAppStat(vm.application);
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Refresh cache failed failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error marketplaceCacheRefresh:' + JSON.stringify(reason));
                    })
                    .finally(function () {
                        vm.isActionRunning = false;
                        vm.runningStatusText = '';
                    });
            };

            /**
             * Find latest app release
             * For now it just a latest release in array
             * @param {Array} releaseList - release list
             * @returns {String} - latest release
             */
            vm.getLatestRelease = function (releaseList) {
                if (!angular.isArray(releaseList)) {
                    return '';
                }
                var _releaseList = releaseList.filter(function (release) {
                    return release.state === 'submitted';
                });
                return _releaseList.length > 0 ? _releaseList[_releaseList.length - 1] : '';
            };

            /**
             * Open application in MPC UI
             * @return {void}
             */
            vm.openCatalogApplication = function () {
                var mpcLink = appConfig.__env.marketplaceCatalogLink +
                    '/catalogs/' + vm.catalogId + '/applications/' + vm.applicationId;
                $window.open(mpcLink, '_blank');
            };

            /**
             * Change selection mode: single/multiple
             * @returns {void}
             */
            vm.toggleSelectMode = function () {
                vm.listSetup.rowSelection = !vm.listSetup.rowSelection;
                vm.listSetup.multipleSelection = !vm.multipleSelection;
                vm.selectedDevices = [];
            };

            /**
             * Transform device list to object (Map)
             * @param {Array} deviceList - list of devices
             * @returns {Object} map by device id
             */
            vm.transformDeviceList = function (deviceList) {
                if (!angular.isArray(deviceList)) {
                    return {};
                }
                return deviceList.reduce(function (obj, device) {
                    obj[device.deviceId] = device;
                    return obj;
                }, {});
            };

            /**
             * Select device handler
             * @param {Array} items - device list
             * @returns {void}
             */
            vm.checkSelection = function (items) {
                vm.selectedDevices = items;
            };

            /**
             * Show device selector dialog
             * @returns {void}
             */
            vm.viewDeviceSelector = function () {
                if (!vm.catalog.id || !vm.catalog.name) {
                    Commons.toastShow('Catalog data is not available. Please reload page.');
                    return;
                }
                // Create an isolated scope to pass to the component
                var scope = angular.extend($scope.$new(true), {
                    app: vm.application,
                    catalog: vm.catalog
                });
                $mdDialog.show({
                    template: '<md-dialog aria-label="Device select"><device-for-app-dialog app="app" catalog="catalog"></device-for-app-dialog></md-dialog>',
                    parent: angular.element(document.body),
                    clickOutsideToClose: false,
                    preserveScope: true,
                    scope: scope,
                    skipHide: true
                })
                    .finally(function () {
                        vm.refreshApplicationData(vm.catalogId, vm.applicationId);
                    });
            };

            /**
             * Open app log dialog
             * @param {MouseEvent} event - application object
             * @param {Object} app - application object
             * @returns {void}
             */
            vm.showLog = function (event, app) {
                // Check capability for multi-container feature
                var _device = vm.devicesMap[app.deviceId] || [];
                var containersCapabilityObject = Commons.checkFeatureCapability(_device.capabilities, 'MP_APP_CONTAINER_LOGS');
                var _componentId = null;
                // Create an isolated scope to pass it to the component 
                var _scope = angular.extend($scope, {
                    title: 'Application Log',
                    messages: null,
                    filterList: null,
                    onFilter: null
                });

                /**
                 * Refresh logs for application
                 * @returns {void}
                 */
                var _refreshAppLog = function () {
                    Service.api.marketplaceAppLog({
                        projectId: vm.projectId,
                        deviceId: app.deviceId,
                        applicationId: app.id,
                    }).$promise
                        .then(function (data) {
                            _scope.messages = data.log ? atob(data.log) : '';
                        })
                        .catch(function (reason) {
                            console.log('Error marketplaceAppLog:' + JSON.stringify(reason));
                        });
                };

                /**
                 * Refresh logs for application
                 * @returns {void}
                 */
                var _refreshContainerLog = function (componentId) {
                    Service.api.marketplaceContainerLog({
                        projectId: vm.projectId,
                        deviceId: app.deviceId,
                        applicationId: app.id,
                        componentId: componentId
                    }).$promise
                        .then(function (data) {
                            _scope.messages = data.log ? atob(data.log) : '';
                        })
                        .catch(function (reason) {
                            console.log('Error marketplaceAppLog:' + JSON.stringify(reason));
                        });
                };

                /**
                 * Load logs
                 * @returns {void}
                 */
                var _fetchLogs = function () {
                    // If component is specified, then show component log
                    if (_componentId) {
                        _refreshContainerLog(_componentId);
                        return;
                    }
                    _refreshAppLog();
                };

                /**
                 * Load list of components for application
                 * @returns {void}
                 */
                var _getComponentList = function () {
                    Service.api.marketplaceAppComponents({
                        projectId: vm.projectId,
                        deviceId: app.deviceId,
                        applicationId: app.id
                    }).$promise
                        .then(function (data) {
                            _scope.filterList = data.map(function (component) {
                                return {
                                    id: component.id,
                                    name: component.name
                                };
                            });
                        })
                        .catch(function (reason) {
                            console.log('Error marketplaceAppComponents:' + JSON.stringify(reason));
                        });
                };

                /**
                 * Handle filter change and filter logs
                 * @param {string} item - selected filter value
                 */
                var _onFilter = function (item) {
                    _componentId = item;
                    _scope.messages = null;
                    _fetchLogs();
                };

                _scope.onFilter = _onFilter;

                // Get list of components for application 
                // if this feature is available
                if (containersCapabilityObject.available) {
                    _getComponentList();
                }

                // Start pulling logs
                _fetchLogs();
                vm.logPullInterval = $interval(_fetchLogs, 5000);

                $mdDialog.show({
                    template: '<process-log title="title" messages="messages" filter-list="filterList" on-filter="onFilter(item)"></process-log>',
                    parent: angular.element(document.body),
                    targetEvent: event,
                    clickOutsideToClose: false,
                    preserveScope: true,
                    scope: _scope,
                    skipHide: true
                })
                    .then(function () {
                        // Stop pulling logs
                        $interval.cancel(vm.logPullInterval);
                    })
                    .catch(function () {

                    });
            };

            /**
             * Handle group filter change
             * @param {Object} deviceFilter - group selected filter object
             * @returns {void}
             */
            vm.filter = function (deviceFilter) {
                // Save state of deviceFilter
                vm.deviceFilter = angular.copy(deviceFilter);

                // Reset deviceAppList
                vm.deviceAppList = angular.copy(vm.deviceAppListOrigin);

                // 1. Filter by groupList
                if (deviceFilter.groupList.length > 0) {
                    vm.deviceAppList = vm.deviceAppListOrigin.filter(function (deviceApp) {
                        return deviceApp.tags.some(function (tag) {
                            return deviceFilter.groupList.indexOf(tag) >= 0;
                        });
                    });
                }
                // Filter by statusList
                if (deviceFilter.statusList.length > 0) {
                    vm.deviceAppList = vm.deviceAppList.filter(function (deviceApp) {
                        return deviceFilter.statusList.indexOf(deviceApp.status) >= 0;
                    });
                }
                // Filter by releaseList
                if (deviceFilter.releaseList.length > 0) {
                    vm.deviceAppList = vm.deviceAppList.filter(function (deviceApp) {
                        return deviceFilter.releaseList.indexOf(deviceApp.releaseName) >= 0;
                    });
                }
                // Filter by device status
                if (deviceFilter.deviceStatusList.length > 0) {
                    vm.deviceAppList = vm.deviceAppList.filter(function (deviceApp) {
                        return deviceApp.deviceOnline === true;
                    });
                }
            };

            /**
             * Check if filter is changed
             * @param {Object} deviceFilter - group selected filter object
             * @returns {boolean} - true if filter is changed
             */
            vm.isFilterChanged = function (deviceFilter) {
                if (!deviceFilter) {
                    return false;
                }
                return deviceFilter.groupList.length > 0 || deviceFilter.statusList.length > 0 ||
                    deviceFilter.releaseList.length > 0 || deviceFilter.deviceStatusList.length > 0;
            };
        }
    });

'use strict';
/**
 * @ngdoc Edge application upgrade window
 * @name loopUiApp.component:edgeApplicationUpgrade
 * @description
 * # edgeApplicationUpgrade
 */
angular.module('loopUiApp')
    .component('edgeApplicationUpgrade', {
        templateUrl: '../scripts/components/edgeApps/edgeApplicationUpgrade.html',
        bindings: {
            app: '<',
            deviceAppList: '<'
        },
        controller: function ($mdDialog) {
            var vm = this;

            /**
             * Hides the dialog
             * @returns {void}
             */
            vm.hide = function () {
                $mdDialog.hide({
                    selectedRelease: vm.selectedRelease,
                    paramValue: vm.paramValue
                });
            };

            /**
             * Cancel dialog button
             *
             * @returns {void}
             */
            vm.cancel = function () {
                $mdDialog.cancel();
            };

        }
    });
'use strict';
/**
 * @ngdoc 
 * @name loopUiApp.component:appCommandFailedDialog
 * @description
 * # appCommandFailedDialog
 */
angular.module('loopUiApp')
    .component('appCommandFailedDialog', {
        templateUrl: '../scripts/components/edgeApps/appCommandFailedDialog.html',
        bindings: {
            title: '<',
            itemList: '<'
        },
        controller: function ($state, $stateParams, $mdDialog) {
            var vm = this;

            vm.$onInit = function() {
                // Generic table setup
                vm.listSetup = {
                    sortField: 'name',
                    showIndex: false,
                    editable: false,
                    removable: false,
                    limit: 10,
                    limitOptions: [10, 50, 100],
                    fields: [
                        {
                            name: 'Device Id',
                            column: 'id',
                            link: true,
                            limit: 5,
                            fieldAction: function (item) {
                                $state.go('deviceView', {
                                    companyName: $stateParams.companyName,
                                    projectId: $stateParams.projectId,
                                    deviceId: item.deviceId,
                                    selectedTab: 'apps'
                                });
                            },
                            transformation: function (item) {
                                return item.deviceId.substring(0, 5);
                            }
                        },
                        {
                            name: 'Operation',
                            column: 'operation',
                        },
                        {
                            name: 'Message',
                            transformation: function (item) {
                                return item.error.data && item.error.data.message ? item.error.data.message : 'No message';
                            }
                        },
                    ]
                };
            };

            /**
             * Hides the dialog
             * @returns {void}
             */
            vm.hide = function () {
                $mdDialog.hide();
            };
        }
    });
'use strict';
/**
 * @ngdoc
 * @name loopUiApp.component:appFilter
 * @description
 * # appFilter
 */
angular.module('loopUiApp')
    .component('appFilter', {
        templateUrl: '../scripts/components/edgeApps/appFilter.html',
        bindings: {
            appFilter: '=',
            catalogFilter: '<',
            isAppsLoading: '<',
            onApply: '&'
        },
        controller: function () {
            var vm = this;

            vm.catalogListSettings = {
                name: 'Catalog',
                filter: true,
                entityIcon: 'map'
            };

            /**
             * Show Apply button or not
             * @returns {Boolean} - show flag
             */
            vm.isApplyShow = function () {
                return vm.appFilter.catalogList.length > 0;
            };

            /**
             * Apply filter action
             * @param {Array} selectedList - selected catalog to filter
             * @return {void}
             */
            vm.applyFilter = function (selectedList) {
                var _catalogList = selectedList.map(function(item) {
                    return {
                        id: item
                    };
                });
                vm.onApply({ catalogList: _catalogList});
            };
        }
    });
'use strict';
/**
 * @ngdoc company level model: Edge app device selector
 * @name loopUiApp.component:deviceForAppDialog
 * @description
 * # deviceForAppDialog
 */
angular.module('loopUiApp')
    .component('deviceForAppDialog', {
        templateUrl: '../scripts/components/edgeApps/deviceForAppDialog.html',
        bindings: {
            app: '<',
            catalog: '<'
        },
        controller: function (gettextCatalog, $state, $stateParams, $mdDialog, appConfig, ServiceAsyncTask, Service, Commons) {
            var vm = this;

            vm.$onInit = function () {
                vm.companyName = $stateParams.companyName;
                vm.projectId = $stateParams.projectId;
                //Selected target devices
                vm.selectedDevices = [];

                //Wizard steps
                vm.allSteps = [
                    gettextCatalog.getString('Select at least one online device'),
                    gettextCatalog.getString('Application Settings'),
                    gettextCatalog.getString('Preview'),
                    gettextCatalog.getString('Result')
                ];

                //Add step num for steps array
                vm.steps = vm.allSteps.map(function (item, index) {
                    return 'Step ' + (index + 1) + ' - ' + item;
                });

                vm.selectedTab = 0;
                vm.maxTab = vm.steps.length - 1;
                vm.currentStep = vm.steps[0];

                // Flag shows is any docker device selected
                vm.isDockerDeviceSelected = false;

                // Generic table setup
                vm.listSetup = {
                    sortField: 'name',
                    showIndex: false,
                    editable: false,
                    removable: false,
                    limit: 10,
                    limitOptions: [10, 50, 100],
                    fields: [
                        {
                            name: 'Device Id',
                            column: 'deviceId',
                            link: true,
                            limit: 5,
                            style: '{"width": "50px"}',
                            fieldAction: function (item) {
                                $state.go('deviceView', {
                                    companyName: vm.companyName,
                                    projectId: vm.projectId,
                                    deviceId: item.deviceId,
                                    selectedTab: 'apps'
                                });
                            }
                        },
                        {
                            name: 'Host Name',
                            column: 'devicePrettyName'
                        },
                        {
                            name: 'Message',
                            column: 'msg'
                        },
                        {
                            name: 'Status',
                            label: function (item) {
                                return item.status;
                            },
                            iconButton: true,
                            style: '{"width": "50px"}',
                            iconName: function (item) {
                                switch (item.status) {
                                    case 'NEW':
                                        return 'schedule';
                                    case 'ERROR':
                                        return 'highlight_off';
                                    case 'SUCCESS':
                                        return 'check_circle_outline';
                                    default:
                                        return 'help_outline';
                                }
                            }
                        }
                    ]
                };
            };

            /**
             * Start launch app on for all selected devices
             * @return {Promise} launch promise
             */
            vm.launch = function () {
                vm.isAppStarting = true;

                // Open result tab
                vm.next();

                // Get app params for each device
                var _enrichParams = function (subTask, type, device) {
                    var _subTask = angular.copy(subTask);
                    _subTask.params.applicationParameters = vm.paramValue[vm.selectedRelease.name] && vm.paramValue[vm.selectedRelease.name][device.deviceId] ?
                        vm.paramValue[vm.selectedRelease.name][device.deviceId] : {};
                    return _subTask;
                };

                vm.launchResult = vm.initLaunchResultList(vm.selectedDevices, 'Launching app...', 'NEW');

                vm.launchPromise = ServiceAsyncTask.createTaskAndWait(
                    ServiceAsyncTask.taskTypes.MARKETPLACE_APPLICATION_LAUNCH.code, // Task type
                    ServiceAsyncTask.taskTypes.MARKETPLACE_APPLICATION_LAUNCH.subtaskTypes, // Subtask types
                    '', // Task description 
                    vm.selectedDevices,
                    {
                        applicationDescription: vm.app.description || '',
                        applicationId: vm.app.id,
                        applicationName: vm.app.name || '',
                        applicationParameters: {}, // Params will be added later inside _enrichParams function
                        applicationVersion: vm.selectedRelease.name,
                        catalogId: vm.catalog.id,
                        catalogName: vm.catalog.name,
                        catalogPrivate: appConfig.__env.mbCatalogPrivate,
                        catalogTlsSkipVerify: appConfig.__env.mbCatalogTlsSkipVerify,
                        catalogUrl: appConfig.__env.mbApiUrl
                    }, // Task params
                    false, // Wait device for online
                    _enrichParams // Enrich params with params specific for each device
                );

                vm.launchPromise
                    .then(function (task) {
                        if (!task || !task.id) {
                            return;
                        }
                        // Get subtasks for current task
                        return Service.api.asyncSubtaskList({
                            action: task.id
                        }).$promise;
                    })
                    .then(function (data) {
                        // If no subtasks, then show error
                        if (!data || !data.length) {
                            vm.initLaunchResultList(vm.selectedDevices, '', 'ERROR');
                            return;
                        }
                        // Get launch results from subtasks
                        vm.launchResult = data.map(function (item) {
                            return {
                                deviceId: item.deviceId,
                                devicePrettyName: item.devicePrettyName,
                                msg: item.msg,
                                status: item.status
                            };
                        });
                    })
                    .catch(function (reason) {
                        if (!reason) { // If not reason provided, then task was canceled
                            return;
                        }
                        console.log('Application launch failure:' + JSON.stringify(reason));
                        var messageObject = Commons.createErrorObject(reason, 'Application launch failure');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                    })
                    .finally(function () {
                        vm.isAppStarting = false;
                    });
            };

            /**
             * Init launch result list
             * @param {Array} deviceList - selected device list for launch 
             * @param {String} msg - state message 
             * @param {String} status - application status
             * @returns {Array} empty launch list
             */
            vm.initLaunchResultList = function (deviceList, msg, status) {
                if (!deviceList || !angular.isArray(deviceList)) {
                    return [];
                }
                return deviceList.map(function (item) {
                    return {
                        deviceId: item.deviceId,
                        devicePrettyName: item.prettyName,
                        msg: msg,
                        status: status
                    };
                });
            };

            /**
             * Open current application details page
             * @return {void}
             */
            vm.openAppDetails = function () {
                $state.go('edgeApplicationDetails', {
                    companyName: $stateParams.companyName,
                    projectId: $stateParams.projectId,
                    catalogId: vm.catalog.id,
                    applicationId: vm.app.id
                });
                $mdDialog.hide();
            };

            /**
             * Updates the current step description
             * @param {any} selectedTab 
             */
            vm.updateCurrentStep = function (selectedTab) {
                vm.currentStep = vm.steps[selectedTab];
            };

            /**
             * Step back
             * 
             */
            vm.previous = function () {
                vm.selectedTab = vm.selectedTab-- < 0 ? 0 : vm.selectedTab;
                vm.updateCurrentStep(vm.selectedTab);
            };

            /**
             * Step forward
             * 
             */
            vm.next = function () {
                //vm.selectedTab = vm.selectedTab++ > vm.maxTab ? vm.maxTab : vm.selectedTab;
                vm.selectedTab = vm.selectedTab + 1;
                vm.updateCurrentStep(vm.selectedTab);
            };

            /**
             * Check if next master step is disabled
             * @return {Boolean} - if next step disabled
             */
            vm.isNextDisabled = function () {
                return vm.selectedTab === 1 && vm.appForm && vm.appForm.$invalid ||
                    vm.selectedTab === 0 && vm.selectedDevices.length === 0;
            };

            /**
             * Call back for device loaded event
             * Check if device list contains docker devices
             * @param {Array} devices - check if device list con 
             */
            vm.onDevicesLoaded = function (devices) {
                vm.isDockerDeviceExists = devices.some(function (device) {
                    return Commons.getDeviceVirtualizationType(device) === 'docker';
                });
            };

            /**
             * Hides the dialog
             * @returns {void}
             */
            vm.hide = function () {
                $mdDialog.hide();
            };

            /**
             * Cancel dialog button
             * @returns {void}
             */
            vm.cancel = function () {
                $mdDialog.cancel();
            };
        }
    });
'use strict';
/**
 * @ngdoc Select list of catalogs and devices to sync
 * @name loopUiApp.component:deviceForCatalogDialog
 * @description
 * # deviceForCatalogDialog
 */
angular.module('loopUiApp')
    .component('deviceForCatalogDialog', {
        templateUrl: '../scripts/components/edgeApps/deviceForCatalogDialog.html',
        controller: function ($state, $stateParams, $mdDialog, gettextCatalog, appConfig, ServiceAsyncTask, Service, ServiceMPCS, Commons) {
            var vm = this;

            vm.$onInit = function () {
                vm.companyName = $stateParams.companyName;
                vm.projectId = $stateParams.projectId;
                // Selected devices to sync
                vm.selectedCatalogs = [];
                // Selected target devices
                vm.selectedDevices = [];

                // Wizard steps
                vm.allSteps = [
                    gettextCatalog.getString('Select catalogs to push'),
                    gettextCatalog.getString('Select at least one online Edge device'),
                    gettextCatalog.getString('Preview'),
                    gettextCatalog.getString('Result')
                ];

                //Add step num for steps array
                vm.steps = vm.allSteps.map(function (item, index) {
                    return 'Step ' + (index + 1) + ' - ' + item;
                });

                vm.selectedTab = 0;
                vm.maxTab = vm.steps.length - 1;
                vm.currentStep = vm.steps[0];

                // Generic table setup
                vm.catalogListSetup = {
                    sortField: 'name',
                    rowSelection: true,
                    multipleSelection: true,
                    showIndex: false,
                    editable: false,
                    removable: false,
                    limit: 10,
                    limitOptions: [10, 50, 100],
                    fields: [
                        {
                            name: 'Catalog Name',
                            column: 'name'
                        }
                    ]
                };

                vm.resultListSetup = {
                    sortField: 'name',
                    showIndex: false,
                    editable: false,
                    removable: false,
                    limit: 10,
                    limitOptions: [10, 50, 100],
                    fields: [
                        {
                            name: 'Device Id',
                            column: 'deviceId',
                            link: true,
                            limit: 5,
                            style: '{"width": "50px"}',
                            fieldAction: function (item) {
                                $state.go('deviceView', {
                                    companyName: vm.companyName,
                                    projectId: vm.projectId,
                                    deviceId: item.deviceId,
                                    selectedTab: 'apps'
                                });
                            }
                        },
                        {
                            name: 'Host Name',
                            column: 'devicePrettyName'
                        },
                        {
                            name: 'Message',
                            column: 'msg'
                        },
                        {
                            name: 'Status',
                            label: function (item) {
                                return item.status;
                            },
                            iconButton: true,
                            style: '{"width": "50px"}',
                            iconName: function (item) {
                                switch (item.status) {
                                    case 'NEW':
                                        return 'schedule';
                                    case 'ERROR':
                                        return 'highlight_off';
                                    case 'SUCCESS':
                                        return 'check_circle_outline';
                                    default:
                                        return 'help_outline';
                                }
                            }
                        }
                    ]
                };

                vm.catalogListFilterActions = [
                    {
                        label: 'Refresh',
                        icon: 'refresh',
                        buttonClick: vm.refreshCatalogList
                    }
                ];

                vm.refreshCatalogList();
            };

            /**
             * Refresh MP catalog list
             * @returns {void}
             */
            vm.refreshCatalogList = function () {
                vm.catalogListPromise = ServiceMPCS.api.catalogList().$promise;

                vm.catalogListPromise
                    .then(function (data) {
                        vm.catalogList = data;
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Get catalogs failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('catalogList:' + JSON.stringify(reason));
                    });
            };

            /**
             * Start sync selected catalogs on selected devices
             * @return {void}
             */
            vm.sync = function () {
                var _params = vm.selectedCatalogs.map(function (catalog) {
                    return {
                        catalogId: catalog.id,
                        catalogName: catalog.name,
                        catalogPrivate: appConfig.__env.mbCatalogPrivate,
                        catalogTlsSkipVerify: appConfig.__env.mbCatalogTlsSkipVerify,
                        catalogUrl: appConfig.__env.mbApiUrl
                    };
                });
                vm.isCatalogSyncing = true;

                // Open result tab
                vm.next();

                vm.syncResult = vm.initSyncResultList(vm.selectedDevices, 'Catalogs are syncing...', 'NEW');

                vm.syncPromise = ServiceAsyncTask.createTaskAndWait(
                    ServiceAsyncTask.taskTypes.MARKETPLACE_SYNC.code, // Task type
                    ServiceAsyncTask.taskTypes.MARKETPLACE_SYNC.subtaskTypes, // Subtask types
                    '', // Task description 
                    vm.selectedDevices,
                    _params, // Task params
                    true // Wait device for online
                );

                vm.syncPromise
                    .then(function (task) {
                        if (!task || !task.id) {
                            return;
                        }
                        // Get subtasks for current task
                        return Service.api.asyncSubtaskList({
                            action: task.id
                        }).$promise;
                    })
                    .then(function (data) {
                        // If no subtasks, then show error
                        if (!data || !data.length) {
                            vm.syncResult = vm.initSyncResultList(vm.selectedDevices, '', 'ERROR');
                            return;
                        }
                        // Get launch results from subtasks
                        vm.syncResult = data.map(function (item) {
                            return {
                                deviceId: item.deviceId,
                                devicePrettyName: item.devicePrettyName,
                                msg: item.msg || 'Success',
                                status: item.status
                            };
                        });
                    })
                    .catch(function (reason) {
                        if (!reason) { // If not reason provided, then task was canceled
                            return;
                        }
                        console.log('Catalogs sync failure:' + JSON.stringify(reason));
                        var messageObject = Commons.createErrorObject(reason, ' failure');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                    })
                    .finally(function () {
                        vm.isCatalogSyncing = false;
                    });
            };

            /**
             * Init launch result list
             * @param {Array} deviceList - selected device list for launch 
             * @param {String} msg - state message 
             * @param {String} status - application status
             * @returns {Array} empty launch list
             */
            vm.initSyncResultList = function (deviceList, msg, status) {
                if (!deviceList || !angular.isArray(deviceList)) {
                    return [];
                }
                return deviceList.map(function (item) {
                    return {
                        deviceId: item.deviceId,
                        devicePrettyName: item.prettyName,
                        msg: msg,
                        status: status
                    };
                });
            };

            /**
             * Call back for device loaded event
             * Check if device list contains docker devices
             * @param {Array} devices - check if device list con 
             */
            vm.onDevicesLoaded = function (devices) {
                vm.isDockerDeviceExists = devices.some(function (device) {
                    return Commons.getDeviceVirtualizationType(device) === 'docker';
                });
            };

            /**
             * Updates the current step description
             * @param {any} selectedTab 
             */
            vm.updateCurrentStep = function (selectedTab) {
                vm.currentStep = vm.steps[selectedTab];
            };

            /**
             * Step back
             */
            vm.previous = function () {
                vm.selectedTab = vm.selectedTab-- < 0 ? 0 : vm.selectedTab;
                vm.updateCurrentStep(vm.selectedTab);
            };

            /**
             * Step forward
             * 
             */
            vm.next = function () {
                vm.selectedTab = vm.selectedTab + 1;
                vm.updateCurrentStep(vm.selectedTab);
            };

            /**
             * Check if next master step is disabled
             * @return {Boolean} - if next step disabled
             */
            vm.isNextDisabled = function () {
                return vm.selectedTab === 0 && vm.selectedCatalogs.length === 0 ||
                    vm.selectedTab === 1 && vm.selectedDevices.length === 0;
            };

            /**
             * Handle catalog select
             * @param {Array} items - selected catalog items
             */
            vm.onCatalogSelect = function (items) {
                vm.selectedCatalogs = items;
            };

            /**
             * Hides the dialog
             * @returns {void}
             */
            vm.hide = function () {
                $mdDialog.hide();
            };

            /**
             * Cancel dialog button
             * @returns {void}
             */
            vm.cancel = function () {
                $mdDialog.cancel();
            };
        }
    });
'use strict';
/**
 * @ngdoc 
 * @name loopUiApp.component:deviceAppFilter
 * @description
 * # deviceAppFilter
 */
angular.module('loopUiApp')
    .component('deviceAppFilter', {
        templateUrl: '../scripts/components/edgeApps/deviceAppFilter.html',
        bindings: {
            groupList: '<',
            releaseList: '<',
            statusList: '<',
            deviceStatusList: '<',
            onApply: '&'
        },
        controller: function () {
            var vm = this;

            vm.$onInit = function () {
                vm.groupFilterSettings = {
                    name: 'Device Groups',
                    filter: true,
                    entityIcon: 'done_all'
                };

                vm.releaseFilterSettings = {
                    name: 'Release',
                    filter: true,
                    entityIcon: 'label'
                };

                vm.statusFilterSettings = {
                    name: 'Status',
                    filter: true,
                    entityIcon: 'play_arrow'
                };
                
                vm.deviceStatusFilterSettings = {
                    name: 'Device Status',
                    filter: true,
                    entityIcon: 'power_settings_new'
                };
            };

            /**
             * Handle select filter
             * @param {string} listName - name of selected list
             * @param {Array} list - select values from list
             * @returns {void}
             */
            vm.getSelected = function(listName, list) {
                vm.deviceFilter[listName] = list;
                vm.onApply({deviceFilter : vm.deviceFilter});
            };
        }
    });
'use strict';
/**
 * @ngdoc 
 * @name loopUiApp.component:activationConfigList
 * @description
 * # activationConfigList
 */
angular.module('loopUiApp')
    .component('activationConfigList', {
        templateUrl: '../scripts/components/activation/activationConfig/activationConfigList.html',
        controller: function ($stateParams, $state, $location, $filter, $http, gettextCatalog, appConfig, Service, Commons) {
            var vm = this;
            vm.cm = Commons;
            vm.activationConfigList = [];
            vm.isLoading = false;

            vm.$onInit = function () {
                vm.projectId = $stateParams.projectId;
                vm.companyName = $stateParams.companyName;

                vm.entityName = 'Activation Config';
                // Table setup
                vm.listSetup = {
                    sortField: '-createdOn',
                };

                // Decode license type to human readable format
                vm.licenseTypeMap = {
                    NODE_LOCKED: 'Node-locked',
                    FLOATING: 'Site'
                };

                vm.listActions = [
                    {
                        icon: 'create',
                        name: 'Edit',
                        function: vm.editConfig
                    },
                    {
                        icon: 'playlist_add_check',
                        name: 'Show Usage',
                        function: vm.showUsage
                    },
                    /*{
                        icon: 'file_download',
                        name: 'Download',
                        function: vm.configDownload
                    },*/
                    {
                        icon: 'delete',
                        name: 'Remove',
                        function: vm.deleteConfig
                    },
                ];

                vm.configActions = [
                    {
                        icon: 'add',
                        name: 'Add activation config',
                        function: vm.editConfig
                    },
                    {
                        icon: 'refresh',
                        name: 'Reload',
                        function: vm.refreshActivationConfigList
                    }
                ];

                // Get config list
                vm.refreshActivationConfigList();
            };

            /**
             * Get config list
             * @returns {void}
             */
            vm.refreshActivationConfigList = function () {
                vm.isLoading = true;
                vm.activationConfigListPromise = Service.api.activationConfigList({
                    projectId: vm.projectId
                }).$promise;

                vm.activationConfigListPromise.then(function (data) {
                    vm.activationConfigList = data;
                })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Get activation config list failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error activationConfigList:' + JSON.stringify(reason));
                    })
                    .finally(function () {
                        vm.isLoading = false;
                    });
            };

            /**
             * Edit/Add new activation config
             * @param {Event} event - mouse click event
             * @param {Object} item - activation config object
             * @returns {void} 
             */
            vm.editConfig = function (event, item) {
                var _code = item && item.code ? item.code : 'new';
                $state.go('activationConfigDetails', {
                    projectId: vm.projectId,
                    companyName: vm.companyName,
                    code: _code
                });
            };

            /**
             * Open code usage page
             * @param {Event} event - mouse click event
             * @param {String} item - activation config object
             * @returns {void} 
             */
            vm.showUsage = function (event, item) {
                $state.go('activationRequestListByCode', {
                    projectId: vm.projectId,
                    companyName: vm.companyName,
                    code: item.code
                });
            };

            /**
             * Download config as json file
             * @param {Event} event - mouse click event
             * @param {String} item - activation config object
             * @returns {void}
             */
            vm.configDownload = function (event, item) {
                var _name = item.code + '.json';
                var _config = {
                    code: item.code,
                    url: $location.protocol() + '://' + $location.host(), 
                    expireAt: item.expiresAt
                };
                Service.api.projectMqttCredentials({ projectId: vm.projectId} ).$promise
                .then(function (data) {
                    _config.caCert =  data.caCertificate;
                    Commons.downloadLink(JSON.stringify(_config), _name);
                })
                .catch(function (reason) {
                    var messageObject = Commons.createErrorObject(reason, 'Get project credentials error');
                    Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                    console.log('Error projectMqttCredentials:' + JSON.stringify(reason));
                });
            };

            /**
             * Delete config
             * @param {Event} event - mouse click event
             * @param {String} item - activation config object
             * @returns {void} 
             */
            vm.deleteConfig = function (event, item) {
                var deleteFunction = function () {
                    var _activationConfig = {
                        code: item.code,
                        hostname: null,
                        projectId: vm.projectId

                    };
                    var _deleteUrl = appConfig.apiUrl + 'api/v' + appConfig.apiVersion + '/activation/config';

                    $http({
                        method: 'DELETE',
                        url: _deleteUrl,
                        data: _activationConfig,
                        headers: { 'Content-Type': 'application/json' }
                    })
                        .then(function () {
                            Commons.toastShow('Activation config deleted');
                            vm.refreshActivationConfigList();
                        })
                        .catch(function (reason) {
                            var messageObject = Commons.createErrorObject(reason, 'Delete activation config failed');
                            Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                            console.log('Error activationConfigDelete:' + JSON.stringify(reason));
                        });
                };

                Commons.showConfirmationWarn(
                    gettextCatalog.getString('Remove Activation Config'),
                    gettextCatalog.getString('Are you sure you want to remove activation config?<br>Removed config cannot be restored'),
                    gettextCatalog.getString('Remove'),
                    deleteFunction,
                    gettextCatalog.getString('Cancel'),
                    null,
                    event);
            };

            /**
             * Open activation config details
             * @param {object} item - config object 
             * @return {void}
             */
            vm.openActivationConfig = function(item) {
                $state.go('activationConfigDetails', {
                    projectId: vm.projectId,
                    companyName: vm.companyName,
                    code: item.code
                });
            };

            /**
             * Return string representation of date
             * @param {object} item - config object 
             * @return {string} - return date string
             */
            vm.expiresDate = function (item) {
                var _isExpiredText = Date.now() > item.expiresAt ? '(expired)' : '';
                return $filter('date')(item.expiresAt, 'yyyy-MM-dd') + ' ' + _isExpiredText;
            };
        }
    });
'use strict';
/**
 * @ngdoc 
 * @name loopUiApp.component:activationConfigDetails
* @description
 * # activationConfigDetails
 */
angular.module('loopUiApp')
    .component('activationConfigDetails', {
        templateUrl: '../scripts/components/activation/activationConfig/activationConfigDetails.html',
        controller: function ($scope, $stateParams, $location, $state, $timeout, $mdDialog, $filter, $q, appConfig, Service, Commons) {
            var vm = this;
            vm.cm = Commons;
            // List of exiting templates
            vm.templateList = [];
            // Selected templates list
            vm.selectedTemplates = [];
            // Variable sets lists
            vm.variableSets = [];
            // List of parameterized template variables
            vm.variableList = [];
            // Flag to show loading variable spinner
            vm.isTemplateVariablesLoading = false;
            // Maximum value for WG Persistent Keepalive option
            vm.wgPersistentKeepaliveMax = 25;
            // Default value for WG Persistent Keepalive option
            vm.wgPersistentKeepaliveDefault = null;

            vm.$onInit = function () {
                vm.projectId = $stateParams.projectId;
                vm.companyName = $stateParams.companyName;

                vm.activationUrl = $location.protocol() + '://' + $location.host();

                vm.minDate = new Date();

                // On edit load config from API
                if ($stateParams.code !== 'new') {
                    vm.getActivationConfig($stateParams.code);
                } else {
                    // Init activation object
                    var currentDate = new Date();
                    currentDate.setDate(currentDate.getDate());

                    var maxDate = new Date(currentDate.getFullYear() + 1, currentDate.getMonth(), currentDate.getDate(), 0, 0, 0);

                    vm.activation = {
                        projectId: vm.projectId,
                        code: null,
                        expiresAt: maxDate,
                        deviceCount: 10,
                        leaseTtl: 365,
                        licenseSkus: [],
                        templateNames: [],
                        licenseType: 'NODE_LOCKED',
                        licenseServerHost: null,
                        licenseServerPort: appConfig.__env.licenseServerPort,
                        options: {
                            DEFAULT_PASSWORD_POLICY: false
                        },
                        wgPersistentKeepalive: null
                    };

                    // Select node locked type by default
                    vm.licenseType = 'NODE_LOCKED';
                }

                vm.licenseActions = [
                    {
                        icon: 'delete',
                        name: 'Delete',
                        function: vm.removeLicense
                    }
                ];

                // Generic table setup
                vm.templateListSetup = {
                    sortField: 'desc',
                    showIndex: true,
                    editable: false,
                    removable: false,
                    limit: 10,
                    limitOptions: [10, 50, 100],
                    fields: [
                        {
                            name: 'Description',
                            column: 'desc'
                        },
                        {
                            name: 'Scope',
                            column: 'name',
                            transformation: function (row) {
                                var nameArray = Commons.parseTemplateFileName(row.name);
                                return nameArray[3] ? nameArray[3] : '';
                            }
                        },
                        {
                            name: 'Template Statistic',
                            component: 'templateStat',
                            transformation: function (row) {
                                return row.statFlat;
                            }
                        },
                        {
                            name: 'Parameterized?',
                            style: '{"width": "50px"}',
                            transformation: function (item) {
                                return item.parameterized ? 'True' : null;
                            }
                        },
                        {
                            name: 'Created At',
                            transformation: function (row) {
                                var nameArray = Commons.parseTemplateFileName(row.name);
                                return nameArray[4] ? $filter('date')(nameArray[4], 'yyyy-MM-dd HH:mm:ss') : '';
                            }
                        }
                    ]
                };

                vm.templateFilterActions = [
                    {
                        icon: 'add',
                        name: 'Add template',
                        function: vm.addTemplate
                    }
                ];

                vm.templateActions = [
                    {
                        icon: 'delete',
                        name: 'Delete',
                        function: vm.removeTemplate
                    }
                ];

                // Additional provision option
                vm.provisionOptions = [
                    {
                        code: 'AWS_SITEWISE',
                        name: 'AWS SiteWise Edge Integration',
                        description: 'Auto-provision AWS IoT SiteWise Edge connector to Litmus Edge',
                    },
                    {
                        code: 'DEFAULT_PASSWORD_POLICY',
                        name: 'Password Policy',
                        description: 'Apply Password Policy during activation',
                    }];

                // Remove AWS SiteWise option for generic (LEM) products
                if (appConfig.__env.productPrefix !== 'em') {
                    vm.provisionOptions = vm.provisionOptions
                        .filter(function (option) {
                            return option.code !== 'AWS_SITEWISE';
                        });
                }

                $timeout(function () {
                    vm.activationForm.expiresAt.$setTouched();
                }, 0);

                // Load default value for WG Persistent Keepalive option
                vm.loadDefaultKeepalivedValue();
            };

            /**
             * Load activation object by code
             * @param {String} code - activation code
             * @returns {void}
             */
            vm.getActivationConfig = function (code) {
                var _templatesTotal = 100;
                Service.api.activationConfigGet({
                    projectId: vm.projectId,
                    code: code
                }).$promise
                    .then(function (data) {
                        vm.activation = data;
                        vm.activation.expiresAt = new Date(data.expiresAt);
                        vm.activation.licenseServerPort = data.licenseServerPort || appConfig.__env.licenseServerPort;
                        // Load variable sets
                        vm.loadVariableSets(vm.activation.code);
                    })
                    // Load template list
                    .then(function () {
                        return Service.api.templateList({
                            companyName: vm.companyName,
                            projectId: vm.projectId,
                            requestedPage: 0,
                            limit: _templatesTotal
                        }).$promise;
                    })
                    .then(function (data) {
                        // If template list totalSize more then templatesTotal (100 for now), 
                        // then request list again with data.totalSize limit
                        if (data.totalSize > _templatesTotal) {
                            return Service.api.templateList({
                                companyName: vm.companyName,
                                projectId: vm.projectId,
                                requestedPage: 0,
                                limit: data.totalSize
                            }).$promise;
                        } else {
                            return data;
                        }
                    })
                    .then(function (data) {
                        // Restore template object list
                        if (angular.isArray(data.elements) && data.elements.length > 0 &&
                            vm.activation.templateNames.length > 0) {
                            vm.restoreSelectedTemplates(data.elements);
                        }
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Get activation config failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error activationConfigGet:' + JSON.stringify(reason));
                    });
            };

            /**
             * Load default value for WG Persistent Keepalive option
             * @return {void}
             */
            vm.loadDefaultKeepalivedValue = function () {
                Service.api.activationConfigKeepaliveValue().$promise
                    .then(function (data) {
                        vm.wgPersistentKeepaliveDefault = data.wgPersistentKeepalive;
                    })
                    .catch(function (reason) {
                        console.log('Error activationConfigKeepaliveValue:' + JSON.stringify(reason));
                    });
            };

            /**
             * Save activation config
             * @return {void}
             */
            vm.saveActivationConfig = function () {
                var _activation = angular.copy(vm.activation);
                _activation.expiresAt = _activation.expiresAt.getTime();
                $q.when()
                    .then(function () {
                        if (_activation.licenseType === 'FLOATING') {
                            // Check if any valid license exist
                            return Commons.licenseServerValidation('CONFIG');
                        }
                    })
                    .then(function () {
                        return Service.api.activationConfig(_activation).$promise;
                    })
                    .then(function (data) {
                        vm.activation.code = data.code;
                        Commons.toastShow('Activation config saved');
                    })
                    .then(function () {
                        // Save variable sets
                        vm.saveSets();
                    })
                    .catch(function (reason) {
                        // In case of reject from validation vm.topicValidation do not show error
                        if (reason && reason.code === 'I') {
                            return;
                        }

                        var messageObject = Commons.createErrorObject(reason, 'Save activation config failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error activationConfig:' + JSON.stringify(reason));
                    });
            };

            /**
            * Load variable sets for current config
            * @param {string} activationCode - activation code
            * @returns {void}
            */
            vm.loadVariableSets = function (activationCode) {
                Service.api.templateVariableSetGet({
                    projectId: vm.projectId,
                    activationCode: activationCode
                }).$promise
                    .then(function (data) {
                        vm.variableSets = data;
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Get variable sets failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error templateVariableSetGet:' + JSON.stringify(reason));
                    });
            };

            /**
             * Save all sets
             * @returns {void}
             */
            vm.saveSets = function () {
                if (vm.activation.code) {
                    var promiseList = vm.variableSets.map(function (set) {
                        // Enrich variable set with activation code
                        set.activationCode = vm.activation.code;
                        return Service.api.templateVariableSet(null, set).$promise;
                    });
                    // Multiple call for each variable set
                    return $q.all(promiseList);
                }
            };

            /**
             * Delete variable set if it already stored.
             * @param {Number} setId - variable set id
             * @returns {void}
             */
            vm.removeVariableSet = function (setId) {
                Service.api.templateVariableSetDelete({ setId: setId }).$promise
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Delete variable set failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error templateVariableSetDelete:' + JSON.stringify(reason));
                    });
            };

            /**
             * 
             * @param {Object} sets - list of variable sets 
             */
            vm.updateVariableSet = function (sets) {
                vm.variableSets = sets;
            };

            /**
             * Upload variable sets
             * @param {FormData} fileData - uploaded files formdata 
             * @return {void}
             */
            vm.uploadVariableSet = function (fileData) {
                Service.api.templateVariableSetCsv({
                    projectId: vm.projectId,
                    activationCode: vm.activation.code
                }, fileData).$promise
                    .then(function () {
                        vm.loadVariableSets(vm.activation.code);
                        Commons.toastShow('File uploaded');
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Upload failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error templateVariableSetCsv:' + JSON.stringify(reason));
                    });
            };

            /**
             * Select template from list of templates
             * @param {MouseEvent} event - Mouse click event
             * @returns {void}
             */
            vm.addTemplate = function (event) {
                // Create an isolated scope to pass to the component 
                var scope = angular.extend($scope.$new(true), {
                    selectedTemplates: vm.selectedTemplates
                });
                $mdDialog.show({
                    template: '<template-select-dialog selected-templates="selectedTemplates"></template-select-dialog>',
                    parent: angular.element(document.body),
                    targetEvent: event,
                    clickOutsideToClose: false,
                    preserveScope: true,
                    skipHide: true,
                    scope: scope
                })
                    .then(function (data) {
                        vm.selectedTemplates = data
                            .map(function (item) {
                                try {
                                    // Enrich template with statistics
                                    item.statFlat = Commons.transformTemplateStat(item.stat);
                                }
                                catch (e) { }
                                return item;
                            });
                        // Get the list of variables for each template
                        vm.refreshTemplateVariables(data);
                        vm.activation.templateNames = data.map(function (template) {
                            return template.name;
                        });
                    });
            };

            /**
             * Remove template from list
             * @param {Event} event - mouse click event
             * @param {Object} item - template list item
             * @returns {void}
             */
            vm.removeTemplate = function (event, item) {
                vm.selectedTemplates = vm.selectedTemplates.filter(function (template) {
                    return template.name !== item.name;
                });

                vm.refreshTemplateVariables(vm.selectedTemplates);

                vm.activation.templateNames = vm.selectedTemplates.map(function (template) {
                    return template.name;
                });
            };

            /**
             * Restore array of template object from template name array
             * @param {Array} templates - array of templates in project
             * @returns {void}
             */
            vm.restoreSelectedTemplates = function (templates) {
                vm.selectedTemplates = [];
                vm.activation.templateNames.forEach(function (name) {
                    for (var i = 0; i < templates.length; i++) {
                        if (templates[i].name === name) {
                            var _template = templates[i];
                            // Enrich template with statistics
                            _template.statFlat = Commons.transformTemplateStat(_template.stat);
                            vm.selectedTemplates.push(_template);
                        }
                    }
                });

                vm.refreshTemplateVariables(vm.selectedTemplates || []);
            };

            /**
             * Refresh the list of template variables
             * @param {Array} templateList - list of templates
             */
            vm.refreshTemplateVariables = function (templateList) {
                if (!templateList || templateList.length === 0) {
                    vm.variableList = [];
                    return;
                }

                var _promiseList = templateList
                    // Find parameterized templates
                    .filter(function (template) {
                        return template.parameterized === true;
                    })
                    // Get variable for each template
                    .map(function (template) {
                        return Service.api.templateVariablesList({ templateName: template.name }).$promise;
                    });

                if (_promiseList.length === 0) {
                    vm.variableList = [];
                    return;
                }

                vm.isTemplateVariablesLoading = true;

                /**
                 * 1. Get all variables
                 * 2. Merge all variables into one list and remove duplicates
                 * 3. Sort by variable name
                 */
                var _resultMap = {};
                $q.all(_promiseList)
                    .then(function (result) {
                        result.forEach(function (variables) {
                            variables.forEach(function (variable) {
                                _resultMap[variable.name] = variable;
                            });
                        });
                        vm.variableList = Object.keys(_resultMap)
                            .map(function (key) {
                                return _resultMap[key];
                            })
                            .sort(function (a, b) {
                                return a.name.localeCompare(b.name);
                            });
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Get template variables failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error templateVariablesList:' + JSON.stringify(reason));
                    })
                    .finally(function () {
                        vm.isTemplateVariablesLoading = false;
                    });
            };

            /**
             * On settings change update activation object
             * @param {Array} items - list of selected license SKUs
             */
            vm.handleLicenseSettingChange = function (items) {
                vm.activation.licenseSkus = items;
            };

            /**
             * Close details page. Open config list page
             * @returns {void}
             */
            vm.close = function () {
                $state.go('activationConfigList', {
                    companyName: vm.companyName,
                    projectId: vm.projectId
                });
            };
        }
    });
'use strict';
/**
 * @ngdoc 
 * @name loopUiApp.component:siteLicenseSettings
 * @description
 * # siteLicenseSettings
 */
angular.module('loopUiApp')
    .component('siteLicenseSettings', {
        templateUrl: '../scripts/components/activation/activationConfig/siteLicenseSettings.html',
        bindings: {
            licenseType: '=',
            isActive: '<',
            formInstance: '<'
        },
        controller: function () {
            var vm = this;

            vm.$onInit = function () {
                // License type list
                vm.licenseTypes = {
                    'NODE_LOCKED': {
                        name: 'Node-locked',
                        description: 'Node-locked license. One license to each device'
                    },
                    'FLOATING': {
                        name: 'Site',
                        description: 'The device gets licenses from the license server.'
                    }
                };
            };
        }
    });
'use strict';
/**
 * @ngdoc 
 * @name loopUiApp.component:templateVariableSets
 * @description
 * # templateVariableSets
 */
angular.module('loopUiApp')
    .component('templateVariableSets', {
        templateUrl: '../scripts/components/activation/activationConfig/templateVariableSets.html',
        bindings: {
            formInstance: '<',
            activationCode: '<',
            variableSets: '<',
            variableList: '<',
            isLoading: '<',
            onChange: '&',
            onRemove: '&',
            onUpload: '&'
        },
        controller: function ($scope, $mdDialog, $stateParams, $timeout, gettextCatalog, Commons) {
            var vm = this;
            vm.showSet = {};
            // Overall variables sub-form validity flag
            vm.formVariableValidy = {};

            vm.$onInit = function () {
                vm.projectId = $stateParams.projectId;

                vm.variableActions = [
                    {
                        icon: 'delete',
                        name: 'Remove variable',
                        function: vm.removeVariable
                    }
                ];

                vm.variableFilterActions = [
                    {
                        icon: 'add',
                        name: 'Add new variable to the set',
                        function: vm.addVariable
                    },
                    {
                        icon: 'delete',
                        name: 'Remove variable set',
                        function: vm.removeVariableSet
                    },
                ];
            };

            vm.$onChanges = function (changes) {
                // Handle variableList changes
                if (changes.variableList && vm.variableSets && vm.variableSets.length > 0) {
                    vm.variableSets.forEach(function (set) {
                        vm.validateAllSetVariables(set);
                    });
                }
                // Handle variableSets changes
                if (changes.variableSets && changes.variableSets.currentValue && changes.variableSets.currentValue.length > 0) {
                    vm.variableSets.forEach(function (set) {
                        vm.validateAllSetVariables(set);
                    });
                }
            };

            /**
             * Add a new set
             * @returns {void}
             */
            vm.addVariableSet = function () {
                $mdDialog.show({
                    template: '<md-dialog style="width:500px;"><add-variable-set-dialog></add-variable-set-dialog></md-dialog>',
                    parent: angular.element(document.body),
                    clickOutsideToClose: false,
                    preserveScope: true,
                    skipHide: true
                })
                    .then(function (setObject) {
                        if (setObject) {
                            var _newSet = {
                                activationCode: null,
                                hostName: setObject.usePerHost ? setObject.hostName : null,
                                projectId: vm.projectId,
                                variables: []
                            };
                            vm.addSet(_newSet);
                        }
                    });
            };

            /**
             * Add new set
             * @param {Object} set - set object 
             * @returns {void}
             */
            vm.addSet = function (set) {
                // Check is generic host exists
                var isGenericExist = vm.variableSets.some(function (_set) {
                    return !_set.hostName;
                });
                // Check is variable set for this host exists
                var isPerHostExist = vm.variableSets.some(function (_set) {
                    return _set.hostName === set.hostName;
                });
                if (isGenericExist && !set.hostName || isPerHostExist && set.hostName) {
                    var messageText = isGenericExist && !set.hostName ? 'Only one <strong>generic</strong> variable set is allowed' :
                        'Variable set for host name <strong>' + set.hostName + '</strong> already exists';
                    Commons.showConfirmation(gettextCatalog.getString('Variable Set Exists'),
                        gettextCatalog.getString(messageText),
                        null,
                        undefined,
                        gettextCatalog.getString('Ok'), undefined, event);
                    return;
                }
                vm.variableSets.push(set);

                vm.onChange({ sets: vm.variableSets });
            };

            /**
             * Remove variable set
             * @param {Object} set - variable set 
             * @returns {void}
             */
            vm.removeVariableSet = function (set) {
                var _deleteFn = function (set) {
                    vm.variableSets = vm.variableSets.filter(function (_set) {
                        return _set.hostName !== set.hostName;
                    });
                    // Remove variable set from DB if it already stored
                    if (set.id) {
                        vm.onRemove({ setId: set.id });
                    }

                    var _key = set.hostName || 'EMPTY';
                    delete vm.formVariableValidy[_key];

                    vm.onChange({ sets: vm.variableSets });
                };

                Commons.showConfirmationWarn(
                    gettextCatalog.getString('Remove Variable Set'),
                    gettextCatalog.getString('Are you sure you want to remove variable set?'),
                    gettextCatalog.getString('Remove'),
                    function () {
                        _deleteFn(set);
                    },
                    gettextCatalog.getString('Cancel'),
                    null,
                    event);
            };

            /**
             * Add new variable
             * @param {object} set - set object
             * @returns {void}
             */
            vm.addVariable = function (set) {
                vm.showSet[set.hostName] = true;
                set.variables.push({
                    name: '',
                    value: ''
                });

                vm.onChange({ sets: vm.variableSets });
            };

            /**
             * Remove variable from set
             * @param {Event} event - mouse click event 
             * @param {Object} set - variable set
             * @param {number} index - variable index in set
             * @returns {void}
             */
            vm.removeVariable = function (event, set, index) {
                set.variables.splice(index, 1);
                
                $timeout(function () {
                    vm.validateAllSetVariables(set);
                }, 0);

                vm.onChange({ sets: vm.variableSets });
            };

            /**
             * Check current variable
             * @param {Object} set - variables set
             * @param {*} variable - variable to check
             * @param {*} index - variable index
             * @returns {void}
             */
            vm.validateVariables = function (set, variable, index) {
                var isVariableExist = set.variables
                    .filter(function (item) {
                        if (!item.name || !variable.name) {
                            return false;
                        }
                        return variable.name.toUpperCase() === item.name.toUpperCase();
                    }).length > 1;
                var isVariableNotInList = vm.variableList
                    .some(function (item) {
                        return variable.name.toUpperCase() === item.name.toUpperCase();
                    });
                if (vm.formInstance['variable_name_' + (set.hostName || 'EMPTY') + '_' + index]) {
                    vm.formInstance['variable_name_' + (set.hostName || 'EMPTY') + '_' + index].$setValidity('variableExists', !isVariableExist);
                    vm.formInstance['variable_name_' + (set.hostName || 'EMPTY') + '_' + index].$setValidity('unknownVariable', isVariableNotInList);
                    vm.formInstance['variable_name_' + (set.hostName || 'EMPTY') + '_' + index].$setTouched();
                    vm.formInstance['variable_value_' + (set.hostName || 'EMPTY') + '_' + index].$setTouched();
                }
            };

            /**
             * Run validation for all variables in set
             * @param {Object} set - variables set
             * @returns {void}
             */
            vm.validateAllSetVariables = function (set) {
                set.variables.forEach(function (variable, index) {
                    vm.validateVariables(set, variable, index);
                });
                vm.validateOverallVariableForm(set);
            };

            /**
             * Calculate and fill validity flag for variable subform
             * @param {Object} set - variable set object
             * @returns 
             */
            vm.validateOverallVariableForm = function (set) {
                var _key = set.hostName || 'EMPTY';

                // Check is any of 'variable_*' have error
                var formItems = Object.keys(vm.formInstance)
                    .filter(function (key) {
                        return key.indexOf('variable_name_' + _key) === 0 || key.indexOf('variable_value_' + _key) === 0;
                    });

                if (formItems.length === 0) {
                    vm.formVariableValidy[_key] = false;
                    return;
                }

                vm.formVariableValidy[_key] = formItems
                    .some(function (key) {
                        return vm.formInstance[key].$invalid;
                    });
            };

            /**
            * Open menu
            * @param {*} $mdOpenMenu - Menu instance
            * @param {*} ev - Event
            * @returns {void}
            */
            vm.openMenu = function ($mdOpenMenu, ev) {
                ev.stopPropagation();
                $mdOpenMenu(ev);
            };

            /**
             * Show/hide variable set
             * @param {int} setId - variable set id 
             * @returns {void}
             */
            vm.toggleVariables = function (setId) {
                vm.showSet[setId] = !vm.showSet[setId];
            };

            /**
             * Upload variable sets
             * @param {Object} event - event object
             * @returns {void}
             */
            vm.showUploadDialog = function (event) {
                // If code doesn't exit ask user to save config
                if (!vm.activationCode) {
                    Commons.showConfirmation(gettextCatalog.getString('Warning'),
                        gettextCatalog.getString('Save activation config before upload variables'),
                        null,
                        undefined,
                        gettextCatalog.getString('Ok'), undefined, event);
                    return;
                }

                // Create an isolated scope to pass to the component
                var scope = angular.extend($scope.$new(true), {
                    title: 'Upload variable sets',
                    exampleLink: '/scripts/components/activation/activationConfig/variable-sets-example.csv',
                });

                $mdDialog.show({
                    template: '<md-dialog style="max-width:300px;"><md-dialog-content aria-label="Upload Variable set"><upload-file-dialog title="title" example-link="exampleLink"></upload-file-dialog></md-dialog-content></md-dialog>',
                    parent: angular.element(document.body),
                    targetEvent: event,
                    clickOutsideToClose: false,
                    scope: scope,
                    preserveScope: true,
                    skipHide: true,
                })
                    .then(function (data) {
                        if (data && data.fileData) {
                            vm.onUpload({ fileData: data.fileData });
                        }
                    });
            };

            /**
             * Function for search in rule list
             * @param {String} query - search query 
             * @returns 
             */
            vm.querySearch = function (query) {
                return (query ? vm.variableList
                    .filter(
                        function (item) {
                            return (item.name.toLowerCase().indexOf(query.toLowerCase()) >= 0);
                        }) : vm.variableList).map(function (item) {
                            return item.name;
                        });
            };
        }
    });
'use strict';
/**
 * @ngdoc 
 * @name loopUiApp.component:addVariableSetDialog
 * @description
 * # addVariableSetDialog
 */
angular.module('loopUiApp')
    .component('addVariableSetDialog', {
        templateUrl: '../scripts/components/activation/activationConfig/addVariableSetDialog.html',
        controller: function ($mdDialog) {
            var vm = this;
            // Set object to return
            vm.setObject = {
                usePerHost: false,
                hostName: null
            };

            /**
             * Hides the dialog
             * @param {object} setObject - variable set object
             * @return {void}
             */
            vm.hide = function () {
                $mdDialog.hide(vm.setObject);
            };

            /**
             * Cancel dialog button
             * @return {void}
             */
            vm.cancel = function () {
                $mdDialog.cancel();
            };
        }
    });
'use strict';
/**
 * @ngdoc 
 * @name loopUiApp.component:licenseProvisionSettings
 * @description
 * # licenseProvisionSettings
 */
angular.module('loopUiApp')
    .component('licenseProvisionSettings', {
        bindings: {
            selectedSkus: '<',
            onLicenseSettingChange: '&'
        },
        templateUrl: '../scripts/components/activation/activationConfig/licenseProvisionSettings.html',
        controller: function ($stateParams, Service, Commons) {
            var vm = this;
            vm.licenseList = [];
            vm.preselectedLicenses = [];

            vm.$onInit = function () {
                vm.projectId = $stateParams.projectId;

                vm.listSetup = {
                    sortField: '-isCore',
                    keyName: 'licenseSku',
                    showIndex: false,
                    editable: false,
                    removable: false,
                    rowSelection: true,
                    multipleSelection: false,
                    selectionDisabledFunction: function (item) {
                        // Allow selection only for core licenses
                        return item.isCore === false;
                    },
                    limit: 10,
                    limitOptions: [10, 50, 100],
                    fields: [
                        {
                            name: 'License SKU',
                            column: 'licenseSku',
                        },
                        {
                            name: 'License Type',
                            column: 'isCoreStr'
                        },
                        {
                            name: 'Available Keys',
                            column: 'count',
                        }
                    ]
                };

                // Filter actions
                vm.filterActions = [
                    {
                        label: 'Refresh',
                        name: 'refresh',
                        icon: 'refresh',
                        buttonClick: vm.refreshList
                    }
                ];

                vm.refreshList();
            };

            /**
             * Refresh the license list
             */
            vm.refreshList = function () {
                vm.licenseListPromise = Service.api.deviceLicensePoolSkus({
                    projectId: vm.projectId,
                    status: 'NEW'
                }).$promise;

                vm.licenseListPromise
                    .then(function (data) {
                        vm.licenseList = data
                        .filter(function(row) {
                            return row.isCore === true;
                        })
                        .map(function (row) {
                            row.isCoreStr = 'Core';
                            return row;
                        });

                        vm.lisenseListOrig = angular.copy(vm.licenseList);

                        // If activation config doesn't have selected licenses, return
                        if (!vm.selectedSkus || vm.selectedSkus.length === 0) {
                            return;
                        }

                        // Create a map of the existing licenses
                        var _skuMap = data.reduce(function (map, item) {
                            map[item.licenseSku] = true;
                            return map;
                        }, {});

                        // Add the selected licenses to the list with a count of 0
                        vm.selectedSkus.forEach(function (item) {
                            if (!_skuMap[item]) {
                                vm.licenseList.push({
                                    licenseSku: item,
                                    count: 0
                                });
                            }
                        });

                        // Find selected licenses from selectedSkus
                        vm.preselectedLicenses = vm.licenseList
                            .filter(function (item) {
                                return vm.selectedSkus.indexOf(item.licenseSku) >= 0;
                            });
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Get unused licenses failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error deviceLicensePoolSkus:' + JSON.stringify(reason));
                    });
            };

            /**
             * Handle license selection change
             * @param {Array} selectedItems - list of selected keys
             */
            vm.onLicenseSelect = function (selectedItems) {
                var _items = selectedItems.map(function (item) {
                    return item.licenseSku;
                });
                vm.onLicenseSettingChange({ items: _items });
            };

            /**
             * On filter handler
             * @param {String} predicate - search string
             * @return {void}
             */
            vm.filterHandler = function (predicate) {
                vm.licenseList = vm.lisenseListOrig.filter(function (item) {
                    if (!predicate) {
                        return true;
                    }
                    return (item.licenseSku + item.isCoreStr).toLowerCase().indexOf(predicate.toLowerCase()) >= 0;
                });
            };
        }
    });
'use strict';
/**
 * @ngdoc 
 * @name loopUiApp.component:activationRequestList
 * @description
 * # activationRequestList
 */
angular.module('loopUiApp')
    .component('activationRequestList', {
        templateUrl: '../scripts/components/activation/activationRequest/activationRequestList.html',
        controller: function ($scope, $q, $stateParams, $state, $http, $interval, $timeout, $mdDialog, gettextCatalog, appConfig, Service, Commons) {
            var vm = this;

            vm.$onInit = function () {
                vm.isFirstInit = true;
                vm.status = '';
                vm.activationRequestList = [];
                vm.activationRequestGroups = {};
                vm.totalSize = 0;
                vm.selectedRequests = [];
                vm.parameterizedRequests = {};

                vm.companyName = $stateParams.companyName;
                vm.projectId = $stateParams.projectId;
                vm.code = $stateParams.code;

                // Generic table setup
                vm.listSetup = {
                    sortField: '-createdOn',
                    rowSelection: false,
                    multipleSelection: false,
                    limit: 10,
                    limitOptions: [10, 50, 100]
                };

                vm.itemsPagination = {
                    limit: vm.listSetup.limit,
                    page: 1,
                    limitOptions: vm.listSetup.limitOptions
                };
                // Activation statuses map
                vm.activationStatusMap = {
                    RECEIVED: { name: 'Waiting for approval', icon: 'arrow_circle_right', class: 'waiting' },
                    APPROVED: { name: 'Processing', icon: 'schedule', class: 'active' },
                    ACTIVATED: { name: 'Processed', icon: 'check_circle_outline', class: 'done' },
                    ERROR: { name: 'Failed', icon: 'highlight_off', class: 'error' },
                    REJECTED: { name: 'Rejected', icon: 'block', class: 'rejected' },
                    DEACTIVATED: { name: 'Deactivated', icon: 'power_settings_new', class: 'deactivated' }
                };

                // Sort map
                vm.sortMap = {
                    'activationCode': 'ACTIVATION_CODE_ASC',
                    '-activationCode': 'ACTIVATION_CODE_DESC',
                    'hostname': 'HOSTNAME_ASC',
                    '-hostname': 'HOSTNAME_DESC',
                    'friendlyName': 'FRIENDLY_NAME_ASC',
                    '-friendlyName': 'FRIENDLY_NAME_DESC',
                    'macAddress': 'MAC_ADDRESS_ASC',
                    '-macAddress': 'MAC_ADDRESS_DESC',
                    'createdOn': 'CREATED_ON_ASC',
                    '-createdOn': 'CREATED_ON_DESC',
                    'status': 'STATUS_ASC',
                    '-status': 'STATUS_DESC'
                };


                // Request actions
                vm.requestActions = [
                    {
                        name: 'Approve',
                        status: 'APPROVED',
                        icon: 'check',
                        disabled: function (item) {
                            return item.status === 'DEACTIVATED';
                        },
                        function: function (event, item) {
                            var _items = angular.isArray(item) ? item : [item];
                            vm.changeStatus(_items, 'APPROVED');
                        }
                    },
                    {
                        name: 'Reject',
                        icon: 'close',
                        status: 'REJECTED',
                        disabled: function (item) {
                            return item.status === 'DEACTIVATED';
                        },
                        function: function (event, item) {
                            var _items = angular.isArray(item) ? item : [item];
                            vm.changeStatus(_items, 'REJECTED');
                        }
                    },
                    {
                        name: 'Retry Failed',
                        icon: 'autorenew',
                        disabled: function (item) {
                            return item.status === 'DEACTIVATED';
                        },
                        function: function (event, item) {
                            var _items = angular.isArray(item) ? item : [item];
                            vm.retryRequest(_items);
                        }
                    },
                    {
                        name: 'Delete',
                        icon: 'delete',
                        disabled: function () {
                            return false;
                        },
                        function: function (event, item) {
                            var _items = angular.isArray(item) ? item : [item];
                            vm.deleteRequest(_items);
                        }
                    }
                ];

                vm.listActions = [
                    {
                        name: 'Multiple Select',
                        icon: function () { return vm.listSetup.multipleSelection ? 'list' : 'done_all'; },
                        function: vm.toggleSelectMode
                    },
                    {
                        name: 'Refresh',
                        icon: function () { return 'refresh'; },
                        function: function () {
                            vm.refreshActivationRequestList();
                            vm.refreshSummary();
                        }
                    },
                ];

                vm.refreshActivationRequestList();
                vm.refreshSummary();

                vm.startListRefresh();
            };

            vm.$onDestroy = function () {
                $interval.cancel(vm.refreshActivationRequestInterval);
            };

            /**
             * Start request list changes pulling
             * @returns {void}
             */
            vm.startListRefresh = function () {
                if (vm.refreshActivationRequestInterval) {
                    $interval.cancel(vm.refreshActivationRequestInterval);
                }
                vm.refreshActivationRequestInterval = $interval(function () {
                    vm.refreshActivationRequestList(true);
                    vm.refreshSummary();
                }, 10000);
            };

            /**
             * Refresh request list. 
             * @param {Boolean} hideProgress - show/hide progress bar, and errors in case API fails
             * @returns {void}
             */
            vm.refreshActivationRequestList = function (hideProgress) {
                vm.isLoading = true;

                vm.hideProgress = hideProgress;

                vm.activationRequestListPromise = Service.api.activationRequestList({
                    projectId: vm.projectId,
                    code: vm.code,
                    status: vm.status,
                    limit: vm.itemsPagination.limit,
                    sortOrder: vm.sortMap[vm.listSetup.sortField] || null,
                    requestedPage: vm.itemsPagination.page - 1
                }).$promise;

                vm.activationRequestListPromise
                    .then(function (data) {
                        vm.totalSize = data.totalSize;
                        // Find request with parameterized templates
                        vm.parameterizedRequests = vm.findParametrizedTemplate(data.elements);

                        // Transform steps
                        vm.activationRequestList = data.elements.map(function (item) {
                            item.stages = vm.transformProvisionSteps(item.provisionStatus, item.status);
                            return item;
                        });
                    })
                    .catch(function (reason) {
                        if (!hideProgress) {
                            var messageObject = Commons.createErrorObject(reason, 'Get activation request list failed');
                            Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        }
                        console.log('Error activationRequestList:' + JSON.stringify(reason));
                    })
                    .finally(function () {
                        vm.isLoading = false;
                        vm.isFirstInit = false;
                    });
            };

            /**
             * Refresh summary object
             */
            vm.refreshSummary = function () {
                Service.api.activationRequestSummary({
                    projectId: vm.projectId
                }).$promise
                    .then(function (data) {
                        vm.activationRequestGroups = data.reduce(function (acc, curr) {
                            acc[curr.status] = curr.cnt;
                            return acc;
                        }, {});
                    })
                    .catch(function (reason) {
                        console.log('Error activationRequestSummary:' + JSON.stringify(reason));
                    });
            };

            /**
             * Handle sorting change
             */
            vm.onSort = function () {
                vm.itemsPagination.page = 1;
                vm.refreshActivationRequestList();
            };

            /**
             * Handle pagination change
             */
            vm.onPaginate = function () {
                vm.refreshActivationRequestList();
            };

            /**
             * Split steps by stages
             * @param {array} steps - provision step list
             * @param {string} requestStatus - status of request itself
             * @returns {object} - return provision object with keys by stage name 
             */
            vm.transformProvisionSteps = function (steps, requestStatus) {
                if (!angular.isArray(steps)) {
                    return {};
                }
                return steps.reduce(function (acc, item) {
                    acc[item.stageName] = acc[item.stageName] || {};
                    // Catch status when request received, but not approved yet
                    var _status = item.stageStatus;
                    if (requestStatus === 'RECEIVED' && item.stage === 'ACTIVATION') {
                        _status = 'RECEIVED';
                    }
                    // Catch status when request is deactivated, and step is aborted, then set stage status to aborted
                    if (requestStatus === 'DEACTIVATED' && item.step === 'ABORTED') {
                        _status = 'ABORTED';
                    }
                    acc[item.stageName].status = _status;
                    acc[item.stageName].name = item.stageName;
                    acc[item.stageName].steps = acc[item.stageName].steps || [];
                    acc[item.stageName].steps.push(item);
                    return acc;
                }, {});
            };

            /**
             * Change status
             * @param {Array} requestList - activation request objects list
             * @param {String} status - status name ('APPROVED', 'REJECTED')
             * @returns {void}
             */
            vm.changeStatus = function (requestList, status) {
                if (requestList.length === 0) {
                    return;
                }

                // Filter only simple request without parameters or reject request
                var requestListSimple = requestList.filter(function (request) {
                    return status === 'REJECTED' || !vm.parameterizedRequests[request.entryID];
                });

                // Filter parameterized approve request
                var requestListParateterized = requestList.filter(function (request) {
                    return status === 'APPROVED' && vm.parameterizedRequests[request.entryID];
                });

                if (requestListSimple.length > 0) {
                    // Launch simple status change
                    vm.changeStatusSimple(requestListSimple, status);
                }

                if (requestListParateterized.length > 0) {
                    // Launch parameterized status change
                    vm.changeStatusParameterized(requestListParateterized, status);
                }
            };

            /**
             * Change status without parameterized
             * @param {Array} requestList - activation request objects list
             * @param {String} status - status name ('APPROVED', 'REJECTED')
             * @returns {void}
             */
            vm.changeStatusSimple = function (requestList, status) {
                vm.runningStatusText = 'Changing status...';
                vm.isActionRunning = true;
                var _errorList = [];

                var getPromiseList = function () {
                    return requestList.map(function (request) {
                        return $q(function (resolve) {
                            Service.api.activationRequestStatus(null, {
                                entryID: request.entryID,
                                projectId: request.projectId,
                                status: status
                            }).$promise
                                .then(function () {
                                    resolve({
                                        hostname: request.hostname,
                                        status: status,
                                        error: null
                                    });
                                })
                                .catch(function (error) {
                                    resolve({
                                        hostname: request.hostname,
                                        status: status,
                                        error: error
                                    });
                                });
                        });
                    });
                };

                $q.when()
                    .then(function () {
                        if (status === 'APPROVED' && vm.isFloatingRequestExist(requestList)) {
                            vm.runningStatusText = 'Checking license server...';
                            // Check if any valid license exist
                            return Commons.licenseServerValidation('REQUEST');
                        }
                    })
                    .then(function () {
                        // Check if there is enough device in license add new Edge Devices
                        return vm.checkLicenseCapacity(requestList, status);
                    })
                    .then(function () {
                        // Check if hostnames from request already exist
                        return vm.checkHostname(requestList, status);
                    })
                    .then(function () {
                        // Check if there is enough network capacity to add new peers
                        return vm.checkNetworkCapacity(requestList, status);
                    })
                    .then(function () {
                        var _promiseList = getPromiseList();
                        return $q.all(_promiseList);
                    })
                    .then(function (result) {
                        var _message = '';
                        _errorList = vm.errorHandler(result);
                        if (_errorList.length > 1) {
                            _message = _errorList[0].error.data && _errorList[0].error.data.message ? _errorList[0].error.data.message : 'Status change failed';
                            vm.runningStatusText = 'Status change finished with error for ' + _errorList.length + ' device(s). ' + _message;
                        }
                        else if (_errorList.length === 1) {
                            _message = _errorList[0].error.data && _errorList[0].error.data.message ? _errorList[0].error.data.message : 'Status change failed';
                            vm.runningStatusText = _message;
                        }
                        else {
                            vm.runningStatusText = 'Status changed';
                        }
                        Commons.toastShow(vm.runningStatusText);
                        vm.refreshActivationRequestList();
                    })
                    .finally(function () {
                        vm.isActionRunning = false;
                        vm.runningStatusText = '';
                    });
            };

            /**
             * Change status for parameterized
             * @param {Array} requestList - list of selected requests
             * @param {String} status - status name ('APPROVED', 'REJECTED') 
             * @return {void}
             */
            vm.changeStatusParameterized = function (requestList, status) {
                vm.runningStatusText = 'Changing status...';
                vm.isActionRunning = true;
                var bindWindow = function (requestId, templates, hostname, activationCode) {
                    var promiseVariablesMap = {};
                    var promiseTemplateMap = {};
                    var templateObjects = {};

                    $q.when()
                        .then(function () {
                            if (vm.isFloatingRequestExist(requestList)) {
                                vm.runningStatusText = 'Checking license server...';
                                // Check if any valid license exist
                                return Commons.licenseServerValidation('REQUEST');
                            }
                        })
                        .then(function () {
                            // Check if there is enough device in license add new Edge Devices
                            return vm.checkLicenseCapacity(requestList, status);
                        })
                        .then(function () {
                            // Check if hostnames from request already exist
                            return vm.checkHostname(requestList, status);
                        })
                        .then(function () {
                            // Check if there is enough network capacity to add new peers
                            return vm.checkNetworkCapacity(requestList, status);
                        })
                        .then(function () {
                            templates.forEach(function (template) {
                                promiseVariablesMap[template.name] = Service.api.templateVariablesList({ templateName: template.name }).$promise;
                            });

                            templates.forEach(function (template) {
                                promiseTemplateMap[template.name] = Service.api.templateParameterizedGet({ templateName: template.name }).$promise;
                            });
                            // Get variables for each template
                            return $q.all(promiseVariablesMap);
                        })
                        .then(function (result) {
                            templates.forEach(function (template) {
                                templateObjects[template.name] = {
                                    template: template,
                                    variableList: result[template.name] || []
                                };
                            });

                        })
                        .then(function () {
                            // Get parameterized template for each template
                            return $q.all(promiseTemplateMap);
                        })
                        .then(function (result) {
                            templates.forEach(function (template) {
                                var jsonData = {};
                                try {
                                    jsonData = JSON.parse(result[template.name].data);
                                } catch (e) {
                                    jsonData = {};
                                }
                                templateObjects[template.name].jsonData = jsonData;
                            });
                        })
                        .then(function () {
                            var scope = angular.extend($scope.$new(true), {
                                templateObjects: templateObjects,
                                hostname: hostname,
                                activationCode: activationCode
                            });

                            return $mdDialog.show({
                                template: '<md-dialog style="width:700px;"><template-values-dialog template-objects="templateObjects" hostname="hostname" activation-code="activationCode"></template-values-dialog></md-dialog>',
                                parent: angular.element(document.body),
                                clickOutsideToClose: false,
                                preserveScope: true,
                                scope: scope,
                                skipHide: true
                            });
                        })
                        .then(function (variables) {
                            return vm.saveTemplateVariables(requestId, variables);
                        })
                        .then(function () {
                            return Service.api.activationRequestStatus(null, {
                                entryID: requestId,
                                projectId: vm.projectId,
                                status: status
                            }).$promise;
                        })
                        .then(function () {
                            Commons.toastShow('Request approved');
                        })
                        .catch(function (reason) {
                            if (reason && reason.code !== 'I') {
                                var messageObject = Commons.createErrorObject(reason, 'Approve request failed');
                                Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                                console.log('Error' + JSON.stringify(reason));
                            }
                        })
                        .finally(function () {
                            vm.isActionRunning = false;
                            vm.runningStatusText = '';
                        });
                };

                // For each request with parameterized templates ask params
                requestList.forEach(function (request) {
                    bindWindow(request.entryID, vm.parameterizedRequests[request.entryID], request.hostname, request.code);
                });
            };

            /**
             * Check request list if device with hostname already exists in the current project 
             * @param {Array} requestList - list of activation request
             * @param {String} status - status of request
             * @returns Promise
             */
            vm.checkHostname = function (requestList, status) {
                if (status !== 'APPROVED') {
                    return;
                }
                vm.runningStatusText = 'Checking hostname...';
                var deferred = $q.defer();
                var hostnameList = requestList.map(function (request) {
                    return request.hostname;
                });
                Service.api.deviceList({
                    projectId: vm.projectId,
                    limit: 1000 // TODO: Get rid of magic number
                }).$promise
                    .then(function (data) {
                        return data.elements
                            .filter(function (device) {
                                return hostnameList.indexOf(device.hostname) >= 0;
                            })
                            .map(function (device) {
                                return device.hostname;
                            });
                    })
                    .then(function (data) {
                        if (data && data.length > 0) {
                            var _hostList = data.join(', ');
                            Commons.showConfirmation(
                                gettextCatalog.getString('Hostname already exists'),
                                gettextCatalog.getString('The edge device' + (data.length > 1 ? 's' : '') + ' with hostname <strong>' + _hostList + '</strong> already exists. ' +
                                    'The new edge device will replace the existing one.<br>Do you want to continue?'),
                                gettextCatalog.getString('Continue'),
                                function () {
                                    deferred.resolve();
                                },
                                gettextCatalog.getString('Cancel'),
                                function () {
                                    deferred.reject({
                                        code: 'I',
                                        message: 'hostname_exists'
                                    });
                                },
                                null);
                        } else {
                            deferred.resolve();
                        }
                    });
                return deferred.promise;
            };

            /**
             * Check if license allow to add new devices 
             * @param {Array} requestList - list of activation requests
             * @param {string} status - status of request
             * @returns 
             */
            vm.checkLicenseCapacity = function (requestList, status) {
                if (status !== 'APPROVED') {
                    return;
                }
                vm.runningStatusText = 'Checking license capacity...';
                var deferred = $q.defer();

                Service.api.licensesVerifyDeviceLimits().$promise
                    .then(function (data) {
                        var _availableDevices = data.maxDeviceCount - data.currentDeviceCount;
                        _availableDevices = _availableDevices <= 0 ? 0 : _availableDevices; // If number is negative for some reason
                        if (_availableDevices >= requestList.length || data.maxDeviceCount === 0 || !data.maxDeviceCount) {
                            deferred.resolve();
                        } else {
                            var _callbackFn = function () {
                                deferred.reject({
                                    code: 'I',
                                    message: 'license_capacity'
                                });
                            };
                            var adminUilink = Commons.getAdminUiLink() + '/license-server';

                            Commons.showConfirmationWarn(
                                gettextCatalog.getString('Unable to add new Edge Devices'),
                                gettextCatalog.getString(
                                    data.message + '<br><br>' +
                                    '<strong>Available by license</strong>: ' + _availableDevices + '<br>' +
                                    '<strong>Requested</strong>: ' + requestList.length + '<br><br>' +
                                    'Please check license in the <a href="' + adminUilink + '" target="_blank">Admin Console</a>.'
                                ),
                                gettextCatalog.getString('Close'),
                                _callbackFn,
                                null,
                                null,
                                null);
                        }
                    })
                    .catch(function (reason) {
                        console.log('Error licensesVerifyDeviceLimits' + JSON.stringify(reason));
                        deferred.resolve();
                    });
                return deferred.promise;
            };

            /**
             * Check if there is enough network capacity to add new peers
             * @param {Array} requestList - list of activation requests
             * @param {string} status - status of request
             * @returns 
             */
            vm.checkNetworkCapacity = function (requestList, status) {
                if (status !== 'APPROVED') {
                    return;
                }
                vm.runningStatusText = 'Checking network capacity...';
                var deferred = $q.defer();

                Service.api.wgCapacityInfo({
                    subnetProjectId: vm.projectId
                }).$promise
                    .then(function (data) {
                        var _availableSlots = data[0].totalNumOfAddresses - data[0].numOfPeers;
                        var _subnet = data[0].subnet;
                        if (_availableSlots >= requestList.length) {
                            deferred.resolve();
                        } else {
                            Commons.showConfirmationWarn(
                                gettextCatalog.getString('Unable to Add New Peers'),
                                gettextCatalog.getString(
                                    '<strong>Subnet: </strong>: ' + _subnet + '<br>' +
                                    '<strong>Available addresses: </strong>: ' + _availableSlots + '<br><br>' +
                                    'The project\'s network does not have IP addresses to add new peers.<br>' +
                                    'You can remove inactive Edge devices.'
                                ),
                                gettextCatalog.getString('Close'),
                                function () {
                                    deferred.reject({
                                        code: 'I',
                                        message: 'network_capacity'
                                    });
                                },
                                null,
                                null,
                                null);
                        }
                    })
                    .catch(function (reason) {
                        console.log('Error wgCapacityInfo' + JSON.stringify(reason));
                        deferred.resolve();
                    });
                return deferred.promise;
            };

            /**
             * Retry activation request failed steps
             * @param {Array} requestList - activation request objects list
             * @returns {void}
             */
            vm.retryRequest = function (requestList) {
                vm.runningStatusText = 'Retrying...';
                vm.isActionRunning = true;
                var _errorList = [];
                var _promiseList = requestList.map(function (request) {
                    return $q(function (resolve) {
                        Service.api.activationRequestRetry({
                            entryId: request.entryID,
                            projectId: request.projectId,
                        }).$promise
                            .then(function () {
                                resolve({
                                    hostname: request.hostname,
                                    error: null
                                });
                            })
                            .catch(function (error) {
                                resolve({
                                    hostname: request.hostname,
                                    error: error
                                });
                            });
                    });
                });

                $q.all(_promiseList)
                    .then(function (result) {
                        var _message = '';
                        _errorList = vm.errorHandler(result);
                        if (_errorList.length > 1) {
                            _message = _errorList[0].error.data && _errorList[0].error.data.message ? _errorList[0].error.data.message : 'Retry failed';
                            vm.runningStatusText = 'Retry finished with error for ' + _errorList.length + ' device(s). ' + _message;
                        }
                        else if (_errorList.length === 1) {
                            _message = _errorList[0].error.data && _errorList[0].error.data.message ? _errorList[0].error.data.message : 'Retry failed';
                            vm.runningStatusText = _message;
                        }
                        else {
                            vm.runningStatusText = 'Activation steps were retried';
                        }
                        Commons.toastShow(vm.runningStatusText);
                        vm.refreshActivationRequestList();
                    })
                    .finally(function () {
                        vm.isActionRunning = false;
                        vm.runningStatusText = '';
                    });
            };

            /**
             * Delete activation requests
             * @param {Array} requestList - list of request
             * @returns {void}
             */
            vm.deleteRequest = function (requestList) {
                if (requestList.length === 0) {
                    return;
                }
                var deleteFunction = function (requestList) {
                    vm.runningStatusText = 'Delete in progress...';
                    vm.isActionRunning = true;
                    var _deleteUrl = appConfig.apiUrl + 'api/v' + appConfig.apiVersion + '/activation/request';
                    var _errorList = [];
                    var _promiseList = requestList.map(function (request) {
                        return $q(function (resolve) {
                            $http({
                                method: 'DELETE',
                                url: _deleteUrl,
                                data: {
                                    entryID: request.entryID,
                                    projectId: request.projectId,
                                },
                                headers: { 'Content-Type': 'application/json' }
                            })
                                .then(function () {
                                    resolve({
                                        hostname: request.hostname,
                                        error: null
                                    });
                                })
                                .catch(function (error) {
                                    resolve({
                                        hostname: request.hostname,
                                        error: error
                                    });
                                });
                        });
                    });

                    $q.all(_promiseList)
                        .then(function (result) {
                            var _message = '';
                            _errorList = vm.errorHandler(result);
                            if (_errorList.length > 1) {
                                _message = _errorList[0].error.data && _errorList[0].error.data.message ? _errorList[0].error.data.message : 'Delete failed';
                                vm.runningStatusText = 'Delete finished with error for ' + _errorList.length + ' device(s). ' + _message;
                            }
                            else if (_errorList.length === 1) {
                                _message = _errorList[0].error.data && _errorList[0].error.data.message ? _errorList[0].error.data.message : 'Delete failed';
                                vm.runningStatusText = _message;
                            }
                            else {
                                vm.runningStatusText = requestList.length > 1 ? 'Requests deleted' : 'Request deleted';
                            }
                            Commons.toastShow(vm.runningStatusText);
                            vm.refreshActivationRequestList();
                        })
                        .finally(function () {
                            vm.selectedRequests = [];
                            vm.isActionRunning = false;
                            vm.runningStatusText = '';
                        });
                };

                Commons.showConfirmationWarn(
                    gettextCatalog.getString('Remove Activation Request'),
                    gettextCatalog.getString('Are you sure you want to remove activation ' + (requestList.length > 1 ? 'requests?' : 'request?')),
                    gettextCatalog.getString('Remove'),
                    function () {
                        deleteFunction(requestList);
                    },
                    gettextCatalog.getString('Cancel'),
                    null,
                    event);
            };

            /**
             * Create form resolved error object list of errors
             * @param {Object} resultList - resolved list from promise array response
             * @returns {Array} - new error list
             */
            vm.errorHandler = function (resultList) {
                return resultList.filter(function (result) {
                    return !!result.error;
                });
            };

            /**
             * Change selection mode: single/multiple
             * @returns {void}
             */
            vm.toggleSelectMode = function () {
                vm.listSetup.rowSelection = !vm.listSetup.rowSelection;
                vm.listSetup.showIndex = !vm.listSetup.showIndex;
                vm.listSetup.multipleSelection = !vm.listSetup.multipleSelection;
                vm.selectedRequests = [];
                vm.runningStatusText = '';
            };

            /**
             * Open config details
             * @param {object} item activation request
             * @returns {void}
             */
            vm.openActivationConfig = function (item) {
                $state.go('activationConfigDetails', {
                    projectId: vm.projectId,
                    companyName: vm.companyName,
                    code: item.code
                });
            };

            /**
             * Reset refresh interval to show stepper menu
             * @returns {void}
             */
            vm.jobStepperOpenHandler = function () {
                $interval.cancel(vm.refreshActivationRequestInterval);
                // Start auto-refresh in 10 seconds
                $timeout(vm.startListRefresh, 10000);
            };

            /**
             * Open menu for activation request
             * @param {Object} $mdOpenMenu - menu object
             * @param {Event} event - event object
             * @returns {void}
             */
            vm.openActionsMenu = function ($mdOpenMenu, event) {
                $interval.cancel(vm.refreshActivationRequestInterval);
                $mdOpenMenu(event);
                // Start auto-refresh in 10 seconds
                $timeout(vm.startListRefresh, 10000);
            };

            /**
             * Save variables for template per request
             * @param {String} requestId - 
             * @param {Object} variables -
             * @returns {void}
             */
            vm.saveTemplateVariables = function (requestId, variables) {
                var savePromiseList = [];
                for (var templateName in variables) {
                    var payload = {
                        projectId: vm.projectId,
                        requestId: requestId,
                        templateName: templateName,
                        values: variables[templateName]
                    };
                    savePromiseList.push(Service.api.activationRequestTemplateVariable({}, payload).$promise);
                }
                return $q.all(savePromiseList);
            };

            /**
             * Find all request with parameterized template
             * @param {Array} requestList - array of requests
             * @return {Object} - return Map<{requestId, Array<template>}>
             */
            vm.findParametrizedTemplate = function (requestList) {
                var result = {};
                // Filter selected request and find parameterized templates
                requestList.forEach(function (request) {
                    request.templates.map(function (template) {
                        if (!template.parameterized) {
                            return;
                        }
                        result[request.entryID] = result[request.entryID] || [];
                        result[request.entryID].push({
                            name: template.name,
                            desc: template.desc
                        });
                    });
                });
                return result;
            };

            /**
             * Edit/Add new activation config
             * @param {Event} event - mouse click event
             * @param {Object} item - activation config object
             * @returns {void} 
             */
            vm.editConfig = function (event, item) {
                var _code = item && item.code ? item.code : 'new';
                $state.go('activationConfigDetails', {
                    projectId: vm.projectId,
                    companyName: vm.companyName,
                    code: _code
                });
            };

            /**
             * Check if there is at least one 
             * request with FLOATING license
             * @param {Array} requestList - request list
             * @returns {Boolean} - is request exists
             */
            vm.isFloatingRequestExist = function (requestList) {
                return requestList.some(function (request) {
                    return request.licenseType === 'FLOATING';
                });
            };

            /**
             * Change filter status
             * @param {String} status 
             */
            vm.changeFilterStatus = function (status) {
                vm.status = status;
                vm.selectedRequests = [];
                vm.itemsPagination.page = 1;
                vm.refreshActivationRequestList();
            };
        }
    });
'use strict';

/**
 * @ngdoc Zerotouch Config List
 * @name loopUiApp.component:ztConfigList
 * @description
 * # ztConfigList
 */
angular.module('loopUiApp')
    .component('ztConfigList', {
        templateUrl: '../scripts/components/zerotouch/ztConfigList/ztConfigList.html',
        controller: function ($scope, $window, $stateParams, $mdDialog, gettextCatalog, appConfig, ServiceAsyncTask, Service, Commons) {
            var vm = this;
            vm.cm = Commons;
            vm.items = [];
            vm.selectedItems = [];

            vm.$onInit = function () {
                vm.companyName = $stateParams.companyName;
                vm.projectId = $stateParams.projectId;

                vm.entityName = 'Zerotouch Configurations';
                vm.entityHelpText = 'Zerotouch provisioning allows you to automatically install ' +
                    (appConfig.__env.supportDeviceName || 'edge device') +
                    ' configurations, applications, and docker files onto multiple devices';

                // Init pagination object
                vm.itemsPagination = {
                    limitOptions: [10, 50, 100],
                    limit: 10,
                    page: 1,
                };

                // Actions in filter
                vm.filterActions = [
                    {
                        label: 'Refresh',
                        icon: 'refresh',
                        buttonClick: vm.refreshZtConfigList
                    }
                ];

                // List menu items
                vm.additionalActions = [
                    {
                        name: function (item) {
                            return !!item.ztBundleFileName ? 'View' : 'Edit';
                        },
                        icon: 'edit',
                        function: function (event, item) {
                            vm.edit(event, item, !!item.ztBundleFileName);
                        }
                    },
                    {
                        name: 'Clone',
                        icon: 'file_copy',
                        function: vm.clone
                    },
                    {
                        name: 'Generate',
                        icon: 'phonelink_setup',
                        function: function (event, item) {
                            if (!!item.ztBundleFileName) {
                                vm.readOnlyWarning(event, item);
                                return;
                            }
                            vm.generate(event, item);
                        }
                    },
                    {
                        name: 'Download',
                        icon: 'download',
                        disabled: function (item) {
                            return !item.ztBundleFileName;
                        },
                        function: vm.download
                    },
                    {
                        name: 'Show Log',
                        icon: 'subject',
                        function: vm.log,
                        disabled: function (item) {
                            return !item.asyncSubtaskId;
                        }
                    },
                    {
                        name: 'Delete',
                        icon: 'delete',
                        function: vm.delete
                    }
                ];

                // Actions in button right after filter
                vm.buttonActions = [
                    {
                        name: 'Add Zerotouch Configuration',
                        label: 'Create a new Zerotouch Configuration',
                        icon: 'add',
                        buttonClick: function (event) {
                            vm.edit(event, null, false);
                        }
                    }
                ];

                // New config object template
                vm.newConfig = {
                    id: null,
                    configName: '',
                    staticIPEnabled: false,
                    ztConfig: {
                        version: '1.0',
                        activation: {
                            code: '',
                        },
                        containers: [],
                        staticIP: {
                            interface: '',
                            ip: '',
                            gateway: '',
                            wan: false
                        }
                    }
                };

                // Order map
                vm.sortField = '-updateTime';
                vm.orderMap = {
                    'configName': 'BY_NAME',
                    '-configName': 'BY_NAME_DESC',
                    'updateTime': 'BY_UPDATE_TIME',
                    '-updateTime': 'BY_UPDATE_TIME_DESC',
                    'generateTime': 'BY_GENERATE_TIME',
                    '-generateTime': 'BY_GENERATE_TIME_DESC'
                };

                vm.refreshZtConfigList();
            };

            /**
             * Get the list of ZT configs
             * @returns {void}
             */
            vm.refreshZtConfigList = function () {
                vm.itemListPromise = Service.api.ztConfigs({
                    action: vm.projectId,
                    requestedPage: vm.itemsPagination.page - 1,
                    limit: vm.itemsPagination.limit,
                    order: vm.orderMap[vm.sortField] || null
                }).$promise;
                vm.itemListPromise
                    .then(function (data) {
                        vm.items = data.elements;
                        vm.totalItems = data.totalSize;
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Get Zerotouch configurations failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error ztConfigs:' + JSON.stringify(reason));
                    });
            };

            /**
             * Open configuration master dialog
             * @param {MouseEvent} event - Mouse click event object
             * @param {Object} item - config object
             * @param {boolean} isReadOnly - read-only flag
             * @return {void}
             */
            vm.edit = function (event, item, isReadOnly) {
                var scope = angular.extend($scope.$new(true), {
                    config: angular.copy(item || vm.newConfig),
                    configList: vm.items,
                    isReadOnly: isReadOnly
                });

                $mdDialog.show({
                    template: '<md-dialog style="width:800px;">' +
                        '<zt-config-dialog config="config" config-list="configList" is-read-only="isReadOnly"></zt-config-dialog>' +
                        '</md-dialog>',
                    parent: angular.element(document.body),
                    targetEvent: event,
                    clickOutsideToClose: false,
                    preserveScope: true,
                    scope: scope,
                    skipHide: true
                })
                    .then(function (data) {
                        if (data) {
                            vm.save(data.config, data.requireGenerate);
                        }
                    });
            };

            /**
             * Clone configuration
             * @param {MouseEvent} event - Mouse click event object 
             * @param {Object} item - config object 
             */
            vm.clone = function (event, item) {
                // Add copy to the new config name
                var _newName = item.configName + '_copy';
                var _counter = 1;
                var _isNameExists = function (existingItem) {
                    return existingItem.configName === _newName;
                };
                // Check if the new name already exists add number
                while (vm.items.some(_isNameExists)) {
                    _newName = item.configName + '_copy' + _counter;
                    _counter++;
                }
                var _cloneItem = {
                    configName: _newName,
                    staticIPEnabled: item.staticIPEnabled,
                    ztConfig: angular.copy(item.ztConfig)
                };
                vm.edit(event, _cloneItem, false);
            };

            /**
             * Save ZT config settings
             * @param {Object} item - ZT config object
             * @param {boolean} requireGenerate - flag to generate config file after saving
             * @return {void}
             */
            vm.save = function (item, requireGenerate) {
                var _payload = {
                    id: item.id,
                    configName: item.configName,
                    staticIPEnabled: item.staticIPEnabled,
                    ztConfig: angular.copy(item.ztConfig)
                };
                // Set 'wan' to false if 'gateway' is empty
                if (_payload.staticIPEnabled && _payload.ztConfig &&
                    _payload.ztConfig.staticIP && !_payload.ztConfig.staticIP.gateway) {
                    _payload.ztConfig.staticIP.wan = false;
                }
                // We need to remove staticIP object if staticIPEnabled is false
                if (!_payload.staticIPEnabled && _payload.ztConfig && _payload.ztConfig.staticIP) {
                    delete _payload.ztConfig.staticIP;
                }
                Service.api.ztConfig({
                    action: vm.projectId
                }, _payload).$promise
                    .then(function (data) {
                        Commons.toastShow('Zerotouch configuration saved');
                        vm.refreshZtConfigList();
                        if (requireGenerate) {
                            vm.generate(null, data);
                        }
                    })
                    .catch(function (reason) {
                        if (item) {
                            vm.edit(null, item, false);
                        }
                        var messageObject = Commons.createErrorObject(reason, 'Save Zerotouch configuration failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error ztConfig:' + JSON.stringify(reason));
                    });
            };

            /**
             * Download ZT file
             * @param {Object} event - event object
             * @param {object} item - backup list object
             * @returns {void}
             */
            vm.download = function (event, item) {
                Service.api.ztFileDownload({
                    action: vm.projectId,
                    id: item.id
                }).$promise
                    .then(function (data) {
                        $window.open(data.url, '_blank');
                    })
                    .catch(function (reason) {
                        console.log('ztFileDownload failure:' + JSON.stringify(reason));
                        var messageObject = Commons.createErrorObject(reason, 'ZT file download failure');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                    });
            };

            /**
             * Show warning message for read-only configuration
             * @param {MouseEvent} event - Mouse click event object
             * @param {Object} item - config object
             */
            vm.readOnlyWarning = function (event, item) {
                Commons.showConfirmation(
                    gettextCatalog.getString('Warning'),
                    gettextCatalog.getString('Once the configuration file is created, it will become read-only. ' +
                        'To make changes, you will need to create a new copy of the configuration.'),
                    gettextCatalog.getString('Clone Configuration'),
                    function () {
                        vm.clone(event, item);
                    },
                    gettextCatalog.getString('Cancel'),
                    null,
                    event);
            };

            /**
             * Generate ZT configuration file
             * @param {MouseEvent} event - Mouse click event object
             * @param {Object} item - config object
             */
            vm.generate = function (event, item) {
                var scope = angular.extend($scope.$new(true), {
                    config: angular.copy(item)
                });

                $mdDialog.show({
                    template: '<md-dialog style="width:800px;" aria-label="Generation file dialog">' +
                        '<zt-file-generate-dialog config="config"></zt-file-generate-dialog>' +
                        '</md-dialog>',
                    parent: angular.element(document.body),
                    targetEvent: event,
                    clickOutsideToClose: false,
                    preserveScope: true,
                    scope: scope,
                    skipHide: true
                })
                    .then(function (data) {
                        vm.refreshZtConfigList();
                        if (data && data.id) {
                            vm.download(event, data);
                        }
                    });
            };

            /**
             * Show subtask log
             * @param {MouseEvent} event - Mouse click event object 
             * @param {Object} item - config object
             */
            vm.log = function (event, item) {
                ServiceAsyncTask.openTaskLog({
                    taskId: 'none',
                    id: item.asyncSubtaskId
                });
            };

            /**
             * Open delete configuration
             * @param {MouseEvent} event - Mouse click event object
             * @param {Object} item - config object
             * @return {void}
             **/
            vm.delete = function (event, item) {
                // Delete function
                var _delete = function () {
                    Service.api.ztConfigDelete({
                        action: vm.projectId,
                        id: item.id
                    }).$promise
                        .then(function () {
                            Commons.toastShow('Zerotouch configuration removed');
                            vm.refreshZtConfigList();
                        })
                        .catch(function (reason) {
                            var messageObject = Commons.createErrorObject(reason, 'Delete Zerotouch configuration failed');
                            Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                            console.log('Error ztConfigDelete:' + JSON.stringify(reason));
                        });
                };

                Commons.showConfirmationWarn(
                    gettextCatalog.getString('Remove Configuration'),
                    gettextCatalog.getString('Are you sure you want to remove configuration?'),
                    gettextCatalog.getString('Remove'),
                    function () {
                        _delete();
                    },
                    gettextCatalog.getString('Cancel'),
                    null,
                    event);
            };

            /**
             * Decode config generation status
             * @param {string} status - status code
             * @returns 
             */
            vm.statusObject = function (status) {
                switch (status) {
                    case 'NEW':
                    case 'WAITING':
                        return {
                            icon: 'pause_circle_outline',
                            cssClass: 'zt-status-icon__waiting',
                            name: 'NEW'
                        };
                    case 'BUILDING':
                        return {
                            icon: 'schedule',
                            cssClass: 'zt-status-icon__running',
                            name: 'Building'
                        };
                    case 'ERROR':
                        return {
                            icon: 'highlight_off',
                            cssClass: 'zt-status-icon__error',
                            name: 'Error'
                        };
                    case 'SUCCESS':
                        return {
                            icon: 'check_circle_outline',
                            cssClass: 'zt-status-icon__success',
                            name: 'Success'
                        };
                    default:
                        return {
                            icon: 'help_outline',
                            cssClass: 'zt-status-icon__unknown',
                            name: status
                        };
                }
            };

            /**
             * Check is value type of function
             * @param {*} value - value to check
             * @returns {boolean} - is it function
            */
            vm.isFunction = function (value) {
                return typeof value === 'function';
            };

            /**
             * Is data available after load
             * @return {boolean} - data exists flag
             */
            vm.showNoData = function () {
                return !vm.items || vm.items.length === 0 &&
                    !(vm.itemListPromise && vm.itemListPromise.$$state && vm.itemListPromise.$$state.status === 0);
            };
        }
    });
'use strict';

/**
 * @ngdoc Zerotouch Config Master
 * @name loopUiApp.component:ztConfigDialog
 * @description
 * # ztConfigDialog
 */
angular.module('loopUiApp')
    .component('ztConfigDialog', {
        templateUrl: '../scripts/components/zerotouch/ztConfigDialog/ztConfigDialog.html',
        bindings: {
            config: '<',
            configList: '<',
            isReadOnly: '<',
        },
        controller: function ($stateParams, $mdDialog, gettextCatalog, appConfig, Service, Commons) {
            var vm = this;

            vm.$onInit = function () {
                vm.projectId = $stateParams.projectId;
                // Validation patterns
                vm.cidrPattern = /^(?=\d+\.\d+\.\d+\.\d+($|\/))(([1-9]?\d|1\d\d|2[0-4]\d|25[0-5])\.?){4}(\/([0-9]|[1-2][0-9]|3[0-1]))$/;
                vm.ipv4Pattern = /^(?=\d+\.\d+\.\d+\.\d+($|\/))(([1-9]?\d|1\d\d|2[0-4]\d|25[0-5])\.?){4}$/;
                vm.interfaceNamePattern = /^[a-zA-Z0-9_]+$/;

                // Wizard steps
                vm.wizardSetup = {
                    wizardName: null,
                    steps: [
                        {
                            code: 'ACTIVATION_CONFIG',
                            name: 'Zerotouch Activation',
                            description: gettextCatalog.getString('Please ensure the following field values are correct. All values are automatically populated and cannot be edited'),
                            helpText: gettextCatalog.getString('Zerotouch Activation enables Edge devices to securely connect to ' + appConfig.__env.productName + ' automatically upon boot up, without the need for manual setup.'),
                            componentId: 'activation_config_id.html',
                            isGroupSwitcher: false
                        },
                        {
                            code: 'STATIC_IP',
                            name: 'Static IP',
                            description: gettextCatalog.getString('Fill out the following fields to configure Static IP'),
                            helpText: gettextCatalog.getString('Enter a unique IP address, subnet mask, gateway, and DNS to configure a static IP for your device.'),
                            componentId: 'static_ip_id.html',
                            isGroupSwitcher: true
                        },
                        {
                            code: 'CONTAINER',
                            name: 'Docker Containers',
                            description: gettextCatalog.getString('Fill out the following table to configure Docker Containers'),
                            helpText: gettextCatalog.getString('To run a Docker container, use the docker run command with necessary options to specify image, ports, volumes, and environment variables.'),
                            componentId: 'container_id.html',
                            isGroupSwitcher: false
                        }
                    ]
                };

                // Wizard current step
                vm.currentStep = 0;
                vm.currentStepCode = vm.wizardSetup.steps[0].code;

                vm.licenseTypes = {
                    'NODE_LOCKED': {
                        name: 'Node-locked'
                    },
                    'FLOATING': {
                        name: 'Site'
                    }
                };

                vm.refreshActivationConfigList();
            };

            /**
             * Get config list
             * @returns {void}
             */
            vm.refreshActivationConfigList = function () {
                vm.isConfigListLoading = true;
                Service.api.activationConfigList({
                    projectId: vm.projectId
                }).$promise
                    .then(function (data) {
                        var _currentDate = new Date().getTime();
                        // Add flag expired to each config
                        vm.activationConfigList = data.map(function(item) {
                            item.$expired = item.expiresAt < _currentDate;
                            return item;
                        });
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Get activation config list failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error activationConfigList:' + JSON.stringify(reason));
                    })
                    .finally(function () {
                        vm.isConfigListLoading = false;
                    });
            };

            /**
             * Add new container row
             * @returns {void}
             */
            vm.add = function () {
                if (!vm.config || !vm.config.ztConfig || !vm.config.ztConfig.containers) {
                    return;
                }
                vm.config.ztConfig.containers.push({
                    name: '',
                    'run-cmd': '',
                });
            };

            /**
             * Remove container row
             * @param {number} index - index of container
             * @returns {void}
             **/
            vm.remove = function (index) {
                if (!vm.config || !vm.config.ztConfig || !vm.config.ztConfig.containers) {
                    return;
                }
                vm.config.ztConfig.containers.splice(index, 1);
            };

            /**
             * Check if model name already exists
             * @param {Object} config - model object
             * @returns {void}
             */
            vm.validateName = function (config) {
                if (!config.configName || !angular.isArray(vm.configList)) {
                    return;
                }
                var isNameExist = vm.configList.some(function (item) {
                    return item.configName.toUpperCase() === config.configName.toUpperCase() && (item.id !== config.id || !config.id);
                });

                vm.subform.ACTIVATION_CONFIG.configNameField.$setValidity('exists', !isNameExist);
            };

            /**
             * Check if container name already exists
             * @param {string} container - container name
             * @param {number} index - index of container
             * @returns {void}
             */
            vm.validateContainerName = function (container, index) {
                if (!angular.isArray(vm.config.ztConfig.containers) || !container) {
                    return;
                }
                var isContainerExist = vm.config.ztConfig.containers.filter(function (item) {
                    return item.name.toUpperCase() === container.toUpperCase() ;
                }).length > 1;

                vm.subform.CONTAINER['name' + index].$setValidity('exists', !isContainerExist);
            };

            /**
             * Go to previous step
             *
             * @returns {void}
             */
            vm.previous = function () {
                if (vm.currentStep === 0) {
                    return;
                }
                vm.currentStep--;
                vm.currentStepCode = vm.wizardSetup.steps[vm.currentStep].code;
            };

            /**
             * Go to the next step
             *
             * @returns {void}
             */
            vm.next = function () {
                if (vm.currentStep === vm.wizardSetup.steps.length - 1) {
                    return;
                }
                vm.currentStep++;
                vm.currentStepCode = vm.wizardSetup.steps[vm.currentStep].code;
            };


            /**
             * Check if is first step of wizard
             * @returns {boolean} - True if this is first step
             */
            vm.isFirstStep = function () {
                return vm.currentStep === 0;
            };

            /**
             * Check if is last step of wizard
             *
             * @returns {boolean}           - True if this is last step
             */
            vm.isLastStep = function () {
                return vm.currentStep === vm.wizardSetup.steps.length - 1;
            };

            /**
             * Check if next master step is disabled
             * @return {Boolean} - if next step disabled
             */
            vm.isNextDisabled = function () {
                return vm.subform[vm.currentStepCode] && vm.subform[vm.currentStepCode].$invalid;
            };

            /**
             * Save configuration object
             */
            vm.save = function () {
                $mdDialog.hide({
                    config: vm.config,
                    requireGenerate: false
                });
            };

            /**
             * Save configuration object and generate file immediately
             */
            vm.saveAndGenerate = function () {
                $mdDialog.hide({
                    config: vm.config,
                    requireGenerate: true
                });
            };

            /**
             * Close dialog
             */
            vm.cancel = function () {
                $mdDialog.cancel();
            };
        }
    });
'use strict';

/**
 * @ngdoc Zerotouch Generate dialog
 * @name loopUiApp.component:ztFileGenerateDialog
 * @description
 * # ztFileGenerateDialog
 */
angular.module('loopUiApp')
    .component('ztFileGenerateDialog', {
        templateUrl: '../scripts/components/zerotouch/ztFileGenerateDialog/ztFileGenerateDialog.html',
        bindings: {
            config: '<'
        },
        controller: function ($mdDialog, ServiceAsyncTask, Commons) {
            var vm = this;
            // Status of generation: INIT, IN_PROGRESS, SUCCESS, ERROR
            vm.status = 'INIT';

            /**
             * Save configuration object
             */
            vm.generate = function () {
                vm.status = 'IN_PROGRESS';
                ServiceAsyncTask.createTaskAndWait(
                    ServiceAsyncTask.taskTypes.ZT_FILE_GENERATE.code, // Task type
                    ServiceAsyncTask.taskTypes.ZT_FILE_GENERATE.subtaskTypes, // Subtask types
                    '', // Task description 
                    [{ deviceId: "none" }], // As devices are mandatory, we need to pass 'none'. It will be replaced on task creation  
                    { ztConfigId: vm.config.id }, // Task params
                    false // Wait device for online
                )
                    .then(function (data) {
                        // Check the task status
                        if (data && data.status === 'ERROR') {
                            vm.status = 'ERROR';
                            return;
                        }
                        vm.status = 'SUCCESS';
                        Commons.toastShow('Zerotouch file generated');
                    })
                    .catch(function (reason) {
                        vm.status = 'ERROR';
                        var messageObject = Commons.createErrorObject(reason, 'Generation failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error activationConfigGet:' + JSON.stringify(reason));
                    });
            };

            /**
             * Close dialog and download the file
             * @returns {void}
             */
            vm.download = function () {
                $mdDialog.hide({
                    id: vm.config.id
                });
            };

            /**
             * Close dialog
             */
            vm.cancel = function () {
                $mdDialog.cancel();
            };

            /**
             * Close dialog
             */
            vm.close = function () {
                $mdDialog.hide();
            };
        }
    });
'use strict';

/**
 * @ngdoc component
 * @name loopUiApp.component:projectList
 * @description
 * # projectList
 */
angular.module('loopUiApp')
    .component('projectList', {
        templateUrl: '../scripts/components/project/projectList.html',
        controller: function ($state, $stateParams, $mdDialog, appConfig, Service, Commons, billingMetrics) {
            var vm = this;
            vm.cm = Commons;
            //Is this version contains OEM features
            vm.oem = appConfig.__env.oem;
            //Project list size for check lifecycle
            vm.projectListSize = Commons.projectList.length;
            vm.projectList = [];
            // Project level statistics
            vm.projectStats = {};

            // Component init
            vm.$onInit = function () {
                //Current company and project
                vm.companyName = $stateParams.companyName;
                vm.projectList = Commons.projectList;

                vm.pageName = vm.getCompanyType() === 'OEM' ? 'Customer Projects' : 'Projects';

                vm.entityName = 'Project';
                vm.newEntityTooltip = 'Create a project';

                // Generic table setup
                vm.listSetup = {
                    sortField: 'name',
                    showIndex: true,
                    editable: false,
                    removable: false,
                    rowSelection: false,
                    limit: 10,
                    limitOptions: [10, 50, 100],
                    rowMouseClick: vm.goProject,
                    fields: [
                        {
                            name: 'Name',
                            column: 'name',
                            style: '{"max-width": "200px", "overflow": "hidden", "text-overflow": "ellipsis"}',
                        },
                        {
                            name: 'Description',
                            column: 'description',
                            style: '{"max-width": "200px", "overflow": "hidden", "text-overflow": "ellipsis"}',
                        },
                        {
                            name: 'Devices (Online/Total)',
                            transformation: function (item) {
                                return vm.projectStats[item.id] && vm.projectStats[item.id][0] ? vm.projectStats[item.id][0].value : '0 / 0';
                            }
                        },
                        {
                            name: 'Teams',
                            transformation: function (item) {
                                return vm.projectStats[item.id] && vm.projectStats[item.id][2] ? vm.projectStats[item.id][2].value : 0;
                            }
                        }
                    ]
                };

                // Grid setup
                vm.gridSetup = {
                    sortField: 'name',
                    limit: 11,
                    limitOptions: [10, 50, 100],
                    cardType: 'companyCard',
                    itemClickable: true,
                    rowHeight: 230,
                    dataMapping: {
                        avatar: {
                            column: 'image'
                        },
                        title: {
                            column: 'name'
                        },
                        subtitle: {
                            column: 'description'
                        },
                        content: {
                            transformation: function (item) {
                                return vm.projectStats && vm.projectStats[item.id] ? vm.projectStats[item.id] : null;
                            }
                        }
                    }
                };

                vm.filterActions = [{
                    label: 'Refresh',
                    icon: 'refresh',
                    buttonClick: function() {
                        Commons.refreshProjectList();
                    }
                }];

                vm.randomActions = [
                    {
                        icon: 'remove_red_eye',
                        name: 'Open project',
                        function: vm.goProject
                    },
                    {
                        icon: 'edit',
                        name: 'Edit',
                        function: vm.editProject
                    },
                    {
                        icon: 'delete',
                        name: 'Delete',
                        function: vm.deleteProject
                    }
                ];

                vm.states = [
                    {
                        icon: 'view_list',
                        value: 0,
                        description: 'Table view'
                    },
                    {
                        icon: 'view_module',
                        value: 1,
                        description: 'Module view'
                    }
                ];
                vm.selectedState = vm.states[1];

                vm.refreshStats();

            };

            /**
             * Check lifecycle hook to get project list loaded
             */
            vm.$doCheck = function () {
                if (vm.projectListSize !== Commons.projectList.length) {
                    vm.projectListSize = Commons.projectList.length;
                    vm.projectList = Commons.projectList;
                    vm.refreshStats();
                }
            };

            /**
             * Get project statistics for selected company
             * @return {void}
             */
            vm.refreshStats = function () {
                Service.api.projectListStats({
                    companyName: vm.companyName
                }).$promise
                    .then(function (data) {
                        if (data) {
                            data.forEach(function (stat) {
                                vm.projectStats[stat.projectId] = [{
                                    name: 'Edge Devices',
                                    value: (stat.numOfOnlineDevices || 0) + ' / ' + (stat.totalNumOfDevices || 0), // '(online / total)',
                                    description: 'Online / Total',
                                    visible: function () {
                                        return true;
                                    }
                                },
                                {
                                    name: 'Teams',
                                    value: stat.totalNumOfTeams || 0,
                                    visible: function () {
                                        return true;
                                    }
                                }];
                            });
                        }
                    })
                    .catch(function (reason) {
                        console.log('projectListStats failure:' + JSON.stringify(reason));
                    });
            };

            /**
             * Create project proxy function.
             * Based on company type open specific project wizard
             * @param {event} event - event object
             * @returns {void}
             */
            vm.createProject = function (event) {
                var companyType = vm.getCompanyType();
                if (!companyType) {
                    return;
                }
                switch (companyType) {
                case 'USER':
                    vm.openUserProjectDialog(event);
                    break;
                case 'OEM':
                    vm.openProjectWizard();
                    break;
                default:
                    return;
                }
            };

            /**
             * Prompt Dialog, then reload project list and current state
             * @param {event} event - event object
             * @returns {void}
             */
            vm.openUserProjectDialog = function (event) {
                //Not allow to add new project before list loaded
                if (Commons.isProjectListLoading) {
                    return;
                }
                $mdDialog.show({
                    template: '<project-dialog aria-label="add Project"></project-dialog>',
                    targetEvent: event,
                    parent: angular.element(document.body),
                    clickOutsideToClose: false,
                    preserveScope: true
                })
                    .then(function () {
                        Commons.refreshProjectList();
                    });
            };

            /**
             * Open OEM project wizard
             * @return {void}
             */
            vm.openProjectWizard = function (event, project) {
                $state.go('projectWizard', { companyName: vm.companyName, projectId: project ? project.id : null });
            };

            /**
             * Edit project setting
             * Different actions for user and oem project
             * @param {event} event - event object
             * @param {object} project - project object
             * @returns {void}
             */
            vm.editProject = function(event, project) {
                var companyType = vm.getCompanyType();
                if (!companyType) {
                    return;
                }
                switch (companyType) {
                case 'USER':
                    $state.go('settings', { companyName: vm.companyName, projectId: project ? project.id : null});
                    break;
                case 'OEM':
                    vm.openProjectWizard(event, project);
                    break;
                default:
                    return;
                }
            };

            /**
             * Open project page
             * @param {MouseEvent} event - Mouse click event
             * @param {Object} project - project object
             * @returns {void}
             */
            vm.goProject = function (event, project) {
                Commons.setCurrentProject(project);
                //Load project billing plan
                Commons.refreshBillingPlan(project.id);
                billingMetrics.resetUsage();
                $state.go('dashboard', { companyName: vm.companyName, projectId: project.id });
            }; 
            
            /**
             * Return company type
             * @return {String} - company type
             */
            vm.getCompanyType = function () {
                if (!Commons.companyData.profile) {
                    return undefined;
                }
                return Commons.companyData.profile.companyType;
            };

            /**
             * Remove a project with dialog
             * @param {MouseEvent} event - mouse event
             * @param {object} project - project object
             * @returns {void}
             */
            vm.deleteProject = function (event, project) {
                var toDeleteItem = {
                    name: project.name,
                    type: 'project'
                };
                Commons.deleteDialog(toDeleteItem, event)
                    .then(function () {
                        vm.projectPromise = Service.api.projectDelete({ action: project.id }).$promise;
                        return vm.projectPromise;
                    })
                    .then(function () {
                        Commons.refreshProjectList();
                    })
                    .catch(function (reason) {
                        if (reason && reason.type === 'cancel') {
                            return;
                        }
                        var messageObject = Commons.createErrorObject(reason, 'Delete project failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error deleteDialog:' + JSON.stringify(reason));
                    });
            };

            /**
             * Switch view state list/module
             *
             * @param {*} state             - Newly selected state
             * @returns {void}
             */
            vm.selectState = function (state) {
                vm.selectedState = state;
            };

            /**
             * Filter project list based on search criteria
             *
             * @param {string} searchText           - Search string
             * @return {void}
             */
            vm.filter = function (searchText) {
                //Check project fields
                var firstRow = vm.projectList[0];
                if (!searchText || !firstRow.hasOwnProperty('description') || !firstRow.hasOwnProperty('name')) {
                    vm.projectList = Commons.projectList;
                    return;
                }
                vm.projectList = Commons.projectList.filter(function (row) {
                    return (row.description + row.name).toLowerCase().indexOf(searchText.toLowerCase()) >= 0;
                });
            };
        }
    });

'use strict';
/**
 * @ngdoc component
 * @name loopUiApp.component:addProject
 * @description
 * # dashboard
 */
angular.module('loopUiApp')
    .component('projectDialog', {
        templateUrl: '../scripts/components/project/projectAddDialog.html',
        bindings: {
            project: '<'
        },
        controller: function ($stateParams, Service, Commons, $mdDialog) {
            var vm = this;
            vm.isLoading = false;

            if (vm.project) {
                vm.action = 'Update';
            } else {
                vm.action = 'Create';
                vm.project = {};
                vm.project.name = '';
                vm.project.description = '';
                vm.project.companyName = $stateParams.companyName;
            }

            /**
             * Create a project
             * @param {any} project - project object
             * @returns {void}
             */
            vm.addProjects = function (project) {

                vm.isLoading = true;
                Service.api.project(project).$promise
                    .then(function (res) {
                        vm.isLoading = false;
                        $mdDialog.hide(res);
                    },
                    function (reason) {
                        vm.isLoading = false;
                        console.log('Error project POST:' + JSON.stringify(reason));

                        var messageObject = Commons.createErrorObject(reason, 'Add project error');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);

                        $mdDialog.hide();
                    });
            };

            vm.hide = function () {
                $mdDialog.hide();
            };

            vm.cancel = function () {
                $mdDialog.cancel();
            };
        }
    });
'use strict';

/**
 * @ngdoc component
 * @name loopUiApp.component:deviceView
 * @description
 * # deviceDialog
 */

angular.module('loopUiApp')
    .component('deviceView', {
        templateUrl: '../scripts/components/device/deviceView.html',
        bindings: {
            device: '<'
        },
        controller: function ($state, $stateParams, $window, $interval, licenseCheck, Service, Commons, featuresCheck) {
            var vm = this;
            vm.sp = $stateParams;
            vm.lc = licenseCheck;
            
            vm.$onInit = function () {
                //Current company and project
                vm.companyName = $stateParams.companyName;
                vm.projectId = $stateParams.projectId;

                vm.deviceStatusObject = Commons.getDeviceStatusObject(vm.device);
                vm.deviceOnline = vm.isDeviceOnline(vm.device);
                vm.deviceVirtualizationType = Commons.getDeviceVirtualizationType(vm.device);
                
                vm.refreshInterval = $interval(function(){
                    vm.refreshDeviceData();
                }, 10000);
            };

            vm.$onDestroy = function () {
                //ServiceMQTT.disconnect();
                $interval.cancel(vm.refreshInterval);
            };

            /**
            * Refresh device data
            * @returns {void}
            */
            vm.refreshDeviceData = function () {
                Service.api.deviceGet({
                    action: vm.projectId,
                    actionExt: vm.device.deviceId
                }).$promise
                    .then(function (data) {
                        vm.device = data;
                        vm.deviceStatusObject = Commons.getDeviceStatusObject(data);
                        vm.deviceOnline = vm.isDeviceOnline(data);
                        vm.deviceVirtualizationType = Commons.getDeviceVirtualizationType(data);
                    });
            };

            /**
             * Check device online status
             * @param {Object} device - device object
             * @return {Boolean} - active device or not
             */
            vm.isDeviceOnline = function (device) {
                return device && device.online;
            };

            /**
             * Go back to device list
             */
            vm.backToDevices = function () {
                $state.go('devices', {
                    companyName: vm.companyName,
                    projectId: vm.projectId
                });
            };

            /**
             * Get back with history
             *
             * @returns {void}
            */
            vm.historyBack = function () {
                $window.history.back();
            };

            /**
             * Updates the URL on tab change to persist currently selected tab
             *
             */
            vm.changeTab = function (selectedTab) {
                $state.go('.', { 
                    selectedTab: selectedTab,
                    selectedSubtab: selectedTab === 'manage' ? $stateParams.selectedSubtab : null
                }, 
                { location: 'replace' });
            };

            /**
             * Show/hide logic for tab
             * @param {String} tabName - tab name 
             * @returns {boolean} - show or hide tad flag
             */
            vm.isTabAvailable = function(tabName) {
                switch (tabName) {
                case 'mqtt':
                    return vm.device.config && vm.device.config.mqttHostName;
                case 'events':
                    return !vm.device.hasParent && featuresCheck.isFeatureAvailable('EdgeEvents');
                case 'details':
                case 'metrics':
                case 'manage':
                case 'apps':
                case 'policy':
                case 'license':
                case 'backup':
                    return !vm.device.hasParent;
                default:
                    return true;
                }
            };
            
        }
    });

'use strict';

/**
 * @ngdoc component
 * @name loopUiApp.component:devices
 * @description
 * # devices
 */
angular.module('loopUiApp')
    .component('devices', {
        templateUrl: '../scripts/components/device/devices.html',
        controller: function ($stateParams, $interval, $mdDialog, $scope, $q, $state, $http, Service, Commons, appConfig, gettextCatalog) {

            var vm = this;
            vm.isActivationInProgress = {};

            //project id
            vm.projectId = $stateParams.projectId;
            //Device object
            vm.deviceObject = { elements: [] };
            // Child devices hash map
            vm.childDevices = {};
            //Handle device with child visible flag
            vm.childVisible = {};
            // Track loading status of child devices
            vm.childDevicesPromise = {};
            //Device status object
            vm.deviceStatusObject = {};
            // Map to track overall device status (CRITICAL | WARNING) by license and DH device metrics
            vm.deviceWarningStatus = {};
            //Total number of device returned by API
            vm.deviceCnt = 0;
            // Total number of devices with children on current page
            vm.parentDevicesCnt = 0;
            // List of devices id showing on current page
            vm.deviceIds = [];
            //Device capability object
            vm.deviceCabilityObject = {};
            //License object
            vm.devicesLicense = {};
            // Current company
            vm.companyName = $stateParams.companyName;
            //Current project
            vm.projectId = $stateParams.projectId;
            //Current selected device
            vm.selectedDevice = {};
            //Filter value
            vm.filter = '';
            //Device filter object
            vm.deviceFilter = {
                //siteList: [],
                //assetList: [],
                tagList: [],
                versionList: [],
                statusList: [],
                searchText: ''
            };
            //Pagination object
            vm.query = {
                size: 0,
                limit: 10,
                limitOptions: [10, 50, 100],
                page: 1
            };

            vm.options = {
                rowSelection: false,
                multiSelect: true,
                autoSelect: true,
                limitSelect: true,
                pageSelect: true
            };
            //for multi list edit
            vm.tableSelect = [];
            //Refresh interval
            vm.refreshPeriod = 3000;
            //Refresh metrics interval
            vm.refreshMetricsPeriod = 30000;
            //Refresh license interval
            vm.refreshLicensePeriod = 60000;
            //Flag to cancel request. It used then use send new request, but old one still active
            vm.requestCanceled = false;
            //Expire soon days limit
            vm.expireSoonLimit = 15;
            //Expire days for critical level
            vm.expireCriticalLimit = 7;

            vm.order = '-createdAt';
            vm.orderMap = {
                'createdAt': 'CREATEDON_ASC',
                '-createdAt': 'CREATEDON_DESC',
                'hostname': 'HOSTNAME_ASC',
                '-hostname': 'HOSTNAME_DESC',
                'description': 'DESCRIPTION_ASC',
                '-description': 'DESCRIPTION_DESC',
                'statusTimestamp': 'STATUSTIMESTAMP_ASC',
                '-statusTimestamp': 'STATUSTIMESTAMP_DESC',
                'status': 'ONLINE_ASC',
                '-status': 'ONLINE_DESC',
                'version': 'VERSION_ASC',
                '-version': 'VERSION_DESC',
                'prettyName': 'PRETTY_NAME_ASC',
                '-prettyName': 'PRETTY_NAME_DESC',
            };

            vm.productName = appConfig.productName;
            vm.preloadedModelName = appConfig.preloadedModelName;
            vm.supportDeviceName = appConfig.supportDeviceName;

            /**
             * Component init
             */
            vm.$onInit = function () {
                vm.refreshDeviceList();
                vm.refreshLicenseList();

                //Start auto-refresh device status object
                vm.refreshInterval = $interval(function () {
                    vm.refreshOnlyStatus();
                }, vm.refreshPeriod);

                //Start auto-refresh device metrics object
                vm.refreshMetricsInterval = $interval(function () {
                    vm.refreshMetrics();
                }, vm.refreshMetricsPeriod);

                //Start auto-refresh device license object
                vm.refreshLicenseInterval = $interval(function () {
                    vm.refreshLicenseList();
                }, vm.refreshLicensePeriod);

                // Unique value to get fresh device image
                vm.imageHash = Date.now();

                // Device groups actions
                vm.deviceMultiActions = [
                    {
                        name: 'Edit selected edge devices',
                        icon: 'edit',
                        function: function (event, deviceList) {
                            vm.editProperties(event, deviceList);
                        }
                    },
                    {
                        name: 'Manage edge device(s) services',
                        icon: 'settings_applications',
                        function: function (event, deviceList) {
                            vm.devicesServiceManage(event, deviceList);
                        }
                    },
                    {
                        name: 'Backup edge device(s)',
                        icon: 'backup',
                        function: function (event, deviceList) {
                            vm.devicesBackup(event, deviceList);
                        }
                    },
                    {
                        name: 'Manage Events forwarding',
                        icon: 'fast_forward',
                        function: function (event, deviceList) {
                            vm.devicesForwardingManage(event, deviceList);
                        }
                    },
                    {
                        name: 'Manage Edge Device Metrics Sync settings',
                        icon: 'trending_up',
                        function: function (event, deviceList) {
                            vm.devicesPollingSettings(event, deviceList);
                        }
                    },
                    {
                        name: 'Change Password Policy',
                        icon: 'policy',
                        function: function (event, deviceList) {
                            vm.devicesPolicyManage(event, deviceList);
                        }
                    },
                    {
                        name: 'Delete edge device(s)',
                        icon: 'delete',
                        function: function (event, deviceList) {
                            vm.deleteDevices(event, deviceList);
                        }
                    }
                ];

                // Device action
                vm.deviceActions = [
                    {
                        name: 'Deactivate',
                        code: 'deactivate',
                        icon: 'clear',
                        function: vm.deactivateLoopEdgeDevice
                    },
                    {
                        name: 'Delete',
                        code: 'delete',
                        icon: 'delete',
                        function: vm.deleteLoopEdgeDevice
                    },
                    {
                        name: 'Restore',
                        code: 'restore',
                        icon: 'restore_from_trash',
                        function: vm.restoreLoopEdgeDevice
                    },
                ];

                // Remote UI actions
                vm.remoteUIActions = [
                    {
                        name: 'Open UI',
                        code: 'open',
                        icon: 'open_in_browser',
                        function: function (event, device) {
                            vm.openDevicePage(event, device, false);
                        }
                    },
                    {
                        name: 'Open UI (new tab)',
                        code: 'open',
                        icon: 'input',
                        function: function (event, device) {
                            vm.openDevicePage(event, device, true);
                        }
                    },
                ];

                // Device list filter actions
                vm.filterActions = [{
                    label: 'Switch to multi-select mode',
                    icon: 'done_all',
                    buttonClick: vm.showList,
                },
                {
                    label: 'Refresh device list',
                    icon: 'refresh',
                    buttonClick: vm.refreshDeviceList,
                }];
            };

            /**
             * Component destroy handler
             */
            vm.$onDestroy = function () {
                $interval.cancel(vm.refreshInterval);
                $interval.cancel(vm.refreshMetricsInterval);
                $interval.cancel(vm.refreshLicenseInterval);
            };

            /**
             * Refresh device list
             */
            vm.refreshDeviceList = function () {
                //clear selected items
                vm.tableSelect = [];
                vm.childDevices = {};
                vm.childVisible = {};
                vm.childDevicesPromise = {};

                var page = vm.query.page - 1;
                var onlineFilter = vm.deviceFilter.statusList.length > 0 ? vm.deviceFilter.statusList[0] === 'Online' : undefined;

                vm.devicesResource = Service.api.deviceList({
                    projectId: vm.projectId,
                    tag: vm.deviceFilter.tagList,
                    versions: vm.deviceFilter.versionList,
                    assetIds: vm.deviceFilter.assetList,
                    onlineOnly: onlineFilter,
                    deviceType: null,
                    requestedPage: page,
                    limit: vm.query.limit,
                    deviceStatus: 'ACTIVE',
                    order: vm.orderMap[vm.order],
                    filter: vm.deviceFilter.searchText
                });

                vm.devicesPromise = vm.devicesResource.$promise;

                vm.devicesPromise
                    .then(function (data) {
                        vm.deviceObject = data;
                        vm.deviceCnt = data.totalSize;
                        // Calculate and cache number of parent devices
                        vm.parentDevicesCnt = data.elements
                            .filter(function (item) {
                                return item.hasChildren === true;
                            }).length;
                        // Get list of device ids for current page
                        vm.deviceIds = data.elements.map(function (item) {
                            return item.deviceId;
                        });
                        if (vm.query.size !== data.totalSize) {
                            vm.query.size = data.totalSize;
                        }
                        vm.refreshDeviceStatus(data.elements);
                        vm.refreshMetrics();
                        vm.refreshCapabilityObject(data.elements);
                    })
                    .catch(function (reason) {
                        if (vm.requestCanceled) {
                            vm.requestCanceled = false;
                            return;
                        }
                        var messageObject = Commons.createErrorObject(reason, 'Refresh device list error');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error refreshDeviceList:' + JSON.stringify(reason));
                    });
            };

            /**
             * Refresh the child devices list
             * The key is parent device Id
             * @param {String} parentDeviceId - parent device Id
             * @param {number} page - page number for child devices
             * @param {number} limit - limit for page
             * @param {String} orderBy - order field
             * @returns {void}
             */
            vm.refreshChildDevices = function (parentDeviceId, page, limit, orderBy) {
                vm.childDevicesPromise[parentDeviceId] = Service.api.childDeviceList({
                    actionExt: vm.projectId,
                    requestedPage: (page - 1) || 0,
                    limit: limit || 5,
                    orderBy: orderBy || null
                }, [parentDeviceId]).$promise;

                vm.childDevicesPromise[parentDeviceId]
                    .then(function (data) {
                        vm.childDevices[parentDeviceId] = data;
                    })
                    .catch(function (reason) {
                        console.log('Error childDeviceList:' + JSON.stringify(reason));
                    });
            };

            /**
             * refresh only device status object
             */
            vm.refreshOnlyStatus = function () {
                var page = vm.query.page - 1;
                var onlineFilter = vm.deviceFilter.statusList.length > 0 ? vm.deviceFilter.statusList[0] === 'Online' : undefined;

                Service.api.deviceList({
                    projectId: vm.projectId,
                    tag: vm.deviceFilter.tagList,
                    versions: vm.deviceFilter.versionList,
                    assetIds: vm.deviceFilter.assetList,
                    onlineOnly: onlineFilter,
                    deviceType: null,
                    requestedPage: page,
                    limit: vm.query.limit,
                    deviceStatus: 'ACTIVE',
                    order: vm.orderMap[vm.order],
                    filter: vm.deviceFilter.searchText
                }).$promise
                    .then(function (data) {
                        // Calculate number of parent devices. If it has changed, reload device list
                        var _parentDevicesCnt = data.elements
                            .filter(function (item) {
                                return item.hasChildren === true;
                            }).length;

                        if (vm.deviceCnt !== data.totalSize || vm.parentDevicesCnt !== _parentDevicesCnt) {
                            // Reload device list if total number of devices has changed
                            vm.refreshDeviceList();
                            return;
                        }
                        vm.refreshDeviceStatus(data.elements);
                    });
            };

            /**
             * Refresh device metrics
             * @return {void}
             */
            vm.refreshMetrics = function () {
                Service.api.metricsGet({
                    actionExt: vm.projectId
                }, vm.deviceIds).$promise
                    .then(function (data) {
                        // Create metrics object: deviceId as a key
                        vm.metricsObject = data.reduce(function (acc, cur) {
                            acc[cur.deviceId] = cur;

                            if (cur.dh && cur.dh.devices && cur.dh.devices.length > 0) {
                                acc[cur.deviceId].devicesStatusObject = cur.dh.devices.reduce(function (deviceAcc, deviceCur) {
                                    deviceAcc[deviceCur.name] = deviceCur;
                                    return deviceAcc;
                                }, {});
                                // If there is at least one device with failed tags, set device status to WARNING
                                acc[cur.deviceId].dhDevicesWarning = cur.dh.devices.some(function (device) {
                                    return device.tagsFailedRate && device.tagsFailedRate > 0;
                                });
                                // If device status is already CRITICAL, do not change it to WARNING
                                vm.deviceWarningStatus[cur.deviceId] = vm.deviceWarningStatus[cur.deviceId] !== 'CRITICAL' && acc[cur.deviceId].dhDevicesWarning ? 'WARNING' : vm.deviceWarningStatus[cur.deviceId];
                            }
                            return acc;
                        }, {});
                    });
            };

            /**
             * Handle filter change
             * @param {Object} filterObject - filter object from <device-filter>
             */
            vm.refreshDeviceFilter = function (filterObject) {
                vm.deviceFilter = angular.copy(filterObject);
                vm.refreshDeviceList();
                vm.refreshOnlyStatus();
            };

            /**
             * Open device details view
             * @param {Object} detail object
             */
            vm.openDeviceDetail = function (device) {
                $state.go('deviceView', {
                    companyName: vm.companyName,
                    projectId: device.projectId,
                    deviceId: device.deviceId,
                });
            };

            /**
             * Change device status
             * @param {int} deviceId
             * @param {String} status name
             */
            vm.changeDeviceStatus = function (device, status) {
                if (status === 'DISCONNECT') {
                    vm.disconnectDevice(device);
                    return;
                }
                device.status = status;
                var deviceList = [device];
                Service.api.device({
                    action: vm.projectId,
                }, deviceList).$promise
                    .then(function () {
                        vm.refreshDeviceList();
                        Commons.toastShow('Updated Status');
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Change Device status error');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error changeDeviceStatus:' + JSON.stringify(reason));
                    });
            };

            /**
             * Deactivate LoopEdge device
             * @param {Event} event - mouse event
             * @param {Object} device - device object
             * @returns {void}
             */
            vm.deactivateLoopEdgeDevice = function (event, device) {
                var _deactivateFunc = function (forceEnable) {
                    vm.isActivationInProgress[device.deviceId] = true;
                    Service.api.loopEdgeDeviceDeactivate({
                        projectId: device.projectId,
                        deviceId: device.deviceId,
                        force: forceEnable
                    }).$promise
                        .then(function () {
                            Commons.toastShow('Device deactivated');
                            vm.refreshDeviceList();
                        })
                        .catch(function (reason) {
                            var messageObject = Commons.createErrorObject(reason, 'Deactivation error');
                            Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                            console.log('Error loopEdgeDeviceDeactivate:' + JSON.stringify(reason));
                        })
                        .finally(function () {
                            vm.isActivationInProgress[device.deviceId] = false;
                        });
                };
                // Show confirmation dialog
                $mdDialog.show({
                    template: '<md-dialog style="width: 500px;" layout-padding><deactivation-dialog></deactivation-dialog></md-dialog>',
                    targetEvent: event,
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                    preserveScope: true,
                    skipHide: false
                })
                    .then(function (forceEnable) {
                        _deactivateFunc(forceEnable);
                    });

            };

            /**
             * Delete LoopEdge device
             * @param {Event} event - mouse event
             * @param {Object} device - device object
             * @returns {void}
             */
            vm.deleteLoopEdgeDevice = function (event, device) {
                var _deleteFunc = function () {
                    Service.api.loopEdgeDeviceDelete({
                        projectId: device.projectId,
                        deviceId: device.deviceId
                    }).$promise
                        .then(function () {
                            vm.updateFilter = true;
                            vm.refreshDeviceList();
                        })
                        .catch(function (reason) {
                            var messageObject = Commons.createErrorObject(reason, 'Delete edge device error');
                            Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                            console.log('Error loopEdgeDeviceDelete:' + JSON.stringify(reason));
                        });
                };
                Commons.showConfirmationWarn(
                    gettextCatalog.getString('Delete Edge Device'),
                    gettextCatalog.getString('Are you sure you want to delete edge device?<br>' + 
                        'The deleted edge device can not be restored'),
                    gettextCatalog.getString('Delete'),
                    _deleteFunc,
                    gettextCatalog.getString('Cancel'),
                    null,
                    event);
            };

            /**
             * Change status
             * @param {Event} event - mouse slick event
             * @param {Array} deviceList - device objects list
             * @returns {void}
             */
            vm.deleteDevices = function (event, deviceList) {
                if (deviceList.length === 0) {
                    return;
                }
                var errorHandler = function (resultList) {
                    return resultList.filter(function (result) {
                        return !!result.error;
                    });
                };
                var _deleteFunc = function () {
                    var _errorList = [];
                    var _promiseList = deviceList.map(function (device) {
                        return $q(function (resolve) {
                            Service.api.loopEdgeDeviceDelete({
                                projectId: device.projectId,
                                deviceId: device.deviceId
                            }).$promise
                                .then(function () {
                                    resolve({
                                        device: device.deviceId,
                                        status: status,
                                        error: null
                                    });
                                })
                                .catch(function (error) {
                                    resolve({
                                        device: device.deviceId,
                                        status: status,
                                        error: error
                                    });
                                });
                        });
                    });

                    $q.all(_promiseList)
                        .then(function (result) {
                            var _message = '';
                            _errorList = errorHandler(result);
                            if (_errorList.length > 1) {
                                _message = _errorList[0].error.data && _errorList[0].error.data.message ? _errorList[0].error.data.message : 'Delete failed';
                                vm.runningStatusText = 'Failed for ' + _errorList.length + ' device(s). ' + _message;
                            }
                            else if (_errorList.length === 1) {
                                _message = _errorList[0].error.data && _errorList[0].error.data.message ? _errorList[0].error.data.message : 'Delete failed';
                                vm.runningStatusText = _message;
                            }
                            else {
                                vm.runningStatusText = 'Deleted successfully';
                            }
                            Commons.toastShow(vm.runningStatusText);
                        })
                        .finally(function () {
                            vm.updateFilter = true;
                            vm.refreshDeviceList();
                        });
                };

                Commons.showConfirmationWarn(
                    gettextCatalog.getString('Delete Edge Device'),
                    gettextCatalog.getString('Are you sure you want to delete edge device(s)?<br>' + 
                        'The deleted edge device can not be restored'),
                    gettextCatalog.getString('Delete'),
                    _deleteFunc,
                    gettextCatalog.getString('Cancel'),
                    null,
                    event);
            };

            /**
             * Disconnect device action
             * @param {Object} device
             */
            vm.disconnectDevice = function (device) {
                Service.api.deviceDisconnect({
                    projectId: device.projectId,
                    deviceId: device.deviceId,
                }).$promise
                    .then(function () {
                        vm.refreshDeviceList();
                        Commons.toastShow('Device was disconnected');
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Disconnect edge device failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error deviceDisconnect:' + JSON.stringify(reason));
                    });
            };

            /**
             * Multiple device update properties
             */
            vm.editProperties = function (event, tableSelect) {
                $mdDialog.show({
                    template: '<md-dialog  aria-label="property" class="properties-dialog" flex="75">' +
                        '<device-properties-dialog></device-properties-dialog>' +
                        '</md-dialog>',
                    targetEvent: event,
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                    preserveScope: true
                })
                    .then(function (properties) {
                        //values array of properties
                        var vals = [];
                        // Save promises array
                        var promises = [];
                        vm.output = properties;
                        //checks if property values are not empty
                        angular.forEach(vm.output.properties, function (value, key) {
                            if (value) {
                                vals.push(key);
                            }
                        });
                        //loop through selected devices and make api calls
                        angular.forEach(tableSelect, function (device, index) {
                            //description api call

                            if (vm.output.description !== '') {
                                tableSelect[index].description = vm.output.description;
                            }
                            //if properties exist
                            if (vals.length > 0) {
                                if (vm.output.properties.Latitude) {
                                    tableSelect[index].properties.Latitude.value = vm.output.properties.Latitude;
                                }
                                if (vm.output.properties.Longitude) {
                                    tableSelect[index].properties.Longitude.value = vm.output.properties.Longitude;
                                }
                            }
                            //Tag save
                            if (vm.output.tag.length !== 0) {
                                tableSelect[index].tags = vm.output.tag;
                            }
                        });

                        // Save device promise
                        var saveDevicesDataPromise = Service.api.device({
                            action: vm.projectId
                        }, tableSelect).$promise;

                        promises.push(saveDevicesDataPromise);

                        // If image changes save image for each devices
                        if (properties.imageData) {
                            angular.forEach(tableSelect, function (device) {
                                promises.push(
                                    Service.api.deviceImage({
                                        actionExt: device.projectId,
                                        actionExt2: device.deviceId
                                    }, properties.imageData)
                                        .$promise);
                            });
                        }

                        return $q.all(promises);
                    })
                    .then(function () {
                        vm.options.rowSelection = false;
                        vm.updateFilter = true;
                        //refresh data
                        vm.refreshDeviceList();
                        Commons.toastShow('Devices were saved');

                    })
                    //if closed then empty selected
                    .catch(function (reason) {
                        tableSelect = [];

                        if (reason) {
                            var messageObject = Commons.createErrorObject(reason, 'Multi-device save error');
                            Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                            console.log('Error multi-device save:' + reason.data.messageDetails || JSON.stringify(reason));
                        }
                    });
            };

            /**
             * Manage services for devices groups
             * @param {Event} event - mouse slick event
             * @param {Array} tableSelect - selected devices
             * @return {void}
             */
            vm.devicesServiceManage = function (event, tableSelect) {
                //create an isolated scope to pass to the component
                var scope = angular.extend($scope.$new(true), {
                    devices: tableSelect
                });

                $mdDialog.show({
                    template: '<md-dialog style="width:500px;"><devices-service-manage devices="devices"></devices-service-manage></md-dialog>',
                    targetEvent: event,
                    scope: scope,
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                    preserveScope: true,
                    skipHide: false
                });
            };

            /**
             * Manage Events forwarding settings
             * @param {Event} event - mouse slick event
             * @param {Array} tableSelect - selected devices
             * @return {void}
             */
            vm.devicesForwardingManage = function (event, tableSelect) {
                // Update device status due vm.deviceObject.elements doesn't contain fresh online status
                // Refresh status function is vm.refreshOnlyStatus
                var _tableSelect = tableSelect.map(function (device) {
                    device.online = vm.deviceStatusObject[device.deviceId].online;
                    return device;
                });

                //create an isolated scope to pass to the component
                var scope = angular.extend($scope.$new(true), {
                    devices: _tableSelect
                });

                $mdDialog.show({
                    template: '<md-dialog style="width:500px;"><devices-forwarding-manage devices="devices"></devices-forwarding-manage></md-dialog>',
                    targetEvent: event,
                    scope: scope,
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                    preserveScope: true,
                    skipHide: false
                });
            };

            /**
             * Manage edge device metrics sync settings
             * @param {Event} event - mouse slick event
             * @param {Array} tableSelect - selected devices
             * @return {void}
             */
            vm.devicesPollingSettings = function (event, tableSelect) {
                //create an isolated scope to pass to the component
                var scope = angular.extend($scope.$new(true), {
                    devices: tableSelect
                });

                $mdDialog.show({
                    template: '<md-dialog style="width:500px;" aria-label="Edge Device Metrics Sync Settings">' +
                        '<devices-polling-settings devices="devices"></devices-polling-settings>' +
                        '</md-dialog>',
                    targetEvent: event,
                    scope: scope,
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                    preserveScope: true,
                    skipHide: false
                });
            };

            /**
             * Manage password policy for devices groups
             * @param {Event} event - mouse slick event
             * @param {Array} tableSelect - selected devices
             * @return {void}
             */
            vm.devicesPolicyManage = function (event, tableSelect) {
                // Update device status due vm.deviceObject.elements doesn't contain fresh online status
                // Refresh status function is vm.refreshOnlyStatus
                var _devices = tableSelect.map(function (device) {
                    device.online = vm.deviceStatusObject[device.deviceId].online;
                    return device;
                });

                //create an isolated scope to pass to the component
                var scope = angular.extend($scope.$new(true), {
                    devices: _devices
                });


                $mdDialog.show({
                    template: '<md-dialog style="width:500px;"><device-policy-dialog devices="devices"></device-policy-dialog></md-dialog>',
                    targetEvent: event,
                    scope: scope,
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                    preserveScope: true,
                    skipHide: false
                });
            };

            /**
             * Run Backup for devices groups
             * @param {Event} event - mouse slick event
             * @param {Array} tableSelect - selected devices
             * @return {void}
             */
            vm.devicesBackup = function (event, tableSelect) {
                // Update device status due vm.deviceObject.elements doesn't contain fresh online status
                // Refresh status function is vm.refreshOnlyStatus
                var _devices = tableSelect.map(function (device) {
                    device.online = vm.deviceStatusObject[device.deviceId].online;
                    return device;
                });

                //create an isolated scope to pass to the component
                var scope = angular.extend($scope.$new(true), {
                    devices: _devices
                });

                $mdDialog.show({
                    template: '<md-dialog style="width:500px;"><devices-backup devices="devices"></devices-backup></md-dialog>',
                    targetEvent: event,
                    scope: scope,
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                    preserveScope: true,
                    skipHide: false
                });
            };

            /**
             * Create device object status
             * @param {Array} deviceList device list
             */
            vm.refreshDeviceStatus = function (deviceList) {
                deviceList.forEach(function (device) {
                    vm.deviceStatusObject[device.deviceId] = Commons.getDeviceStatusObject(device);
                });
            };

            /**
             * Get capability map for each device
             * @param {Array} deviceList - devices list 
             * @return {void}
             */
            vm.refreshCapabilityObject = function (deviceList) {
                deviceList.forEach(function (device) {
                    vm.deviceCabilityObject[device.deviceId] = {};
                    vm.deviceCabilityObject[device.deviceId].REMOTE_UI = Commons.checkFeatureCapability(device.capabilities, 'REMOTE_UI');
                });
            };

            /**
             * Show/hide device child view
             * @param {String} id device id
             */
            vm.toggleChildVisible = function (id) {
                vm.childVisible[id] = !vm.childVisible[id];
                if (vm.childVisible[id]) {
                    vm.refreshChildDevices(id);
                }
            };

            /**
             * to show checkboxes on table
             */
            vm.showList = function () {
                vm.options.rowSelection = !vm.options.rowSelection;
                vm.filterActions[0].icon = vm.options.rowSelection ? 'list' : 'done_all';
                vm.filterActions[0].label = vm.options.rowSelection ? 'Switch to single-select mode' : 'Switch to multi-select mode';
            };

            /**
             * Get full image URL
             * @returns {string} - full image url
             */
            vm.getDeviceImagePath = function (imageUri) {
                return imageUri ? appConfig.apiUrl.slice(0, -1) + imageUri + '?' + vm.imageHash : '/images/photo.svg';
            };

            /**
             * Refresh license list
             * @return {void}
             */
            vm.refreshLicenseList = function () {
                // Promise to get expiring license
                var expiringPromise = Service.api.devicesLicenseMonitorExpiring({
                    projectId: vm.projectId,
                    expiryDays: vm.expireSoonLimit
                }).$promise;
                // Promise to get expired license
                var expiredPromise = Service.api.devicesLicenseMonitorExpired({
                    projectId: vm.projectId
                }).$promise;

                $q.all([expiringPromise, expiredPromise])
                    .then(function (result) {
                        var allResults = [];
                        // Combine results from both APIs
                        allResults = result[0].concat(result[1]);
                        // Find all licenses for device
                        vm.deviceLicenses = allResults.reduce(function (result, device) {
                            result[device.deviceId] = result[device.deviceId] || [];
                            if (device.license) {
                                result[device.deviceId].push(device.license);
                            }
                            return result;
                        }, {});
                        // Set device status if any of license is critical
                        vm.deviceWarningStatus = allResults.reduce(function (result, device) {
                            if (result[device.deviceId] === 'CRITICAL' ||
                                device.licenseStatus === 'UNKNOWN') {
                                return result;
                            }
                            result[device.deviceId] = !device.license ||
                                device.license.expiryDays < vm.expireCriticalLimit ? 'CRITICAL' : 'WARNING';
                            return result;
                        }, {});
                    })
                    .catch(function (reason) {
                        console.log('devicesLicenseMonitorExpired failed' + JSON.stringify(reason));
                    });
            };

            /**
             * Action device action filter
             * @param {Object} action - action menu object
             * @param {Object} device - device object
             * @returns {Boolean} - show/hide menu action
             */
            vm.deviceActionFilter = function (action, device) {
                var _activationStatus = device.activationStatus && device.activationStatus.status;
                return action.code === 'deactivate' && device.status === 'ACTIVE' && _activationStatus === 'ACTIVATED' ||
                    action.code === 'delete' && device.status === 'ACTIVE' ||
                    action.code === 'restore' && device.status === 'DELETED';
            };

            /**
             * Reset handler after tags updated
             * @return {void}
             */
            vm.resetUpdateHandler = function () {
                vm.updateFilter = false;
            };

            /**
             * Open LE UI for device
             * @param {Object} event - Mouse click event
             * @param {Object} device - selected device object 
             * @param {Boolean} newTab - open UI in the new tab 
             * @returns {void}
             */
            vm.openDevicePage = function (event, device, newTab) {
                var url = appConfig.apiUrl + 'remote-ui/' + device.deviceId;
                var remoteUiUrl = url + '/en-US/index.html';
                var pingUrl = url + '/en-US/assets/version.json';
                var scope = angular.extend($scope.$new(true), {
                    url: remoteUiUrl,
                    title: device.prettyName || device.hostname || device.deviceId
                });

                // Open inside EM UI
                var openPage = function () {
                    $mdDialog.show({
                        template: '<md-dialog style="width:100vw;height:100vh;max-height:none;max-width:none;"><external-page url="url" title="title"></external-page></md-dialog>',
                        targetEvent: event,
                        parent: angular.element(document.body),
                        clickOutsideToClose: true,
                        preserveScope: true,
                        scope: scope,
                        skipHide: false,
                        event: event
                    });
                };

                // Open in the new tab
                var openNewTab = function () {
                    window.open(remoteUiUrl, '_blank');
                };

                // Show warning in case if ping is not available
                var showWarning = function () {
                    Commons.showConfirmation(
                        gettextCatalog.getString('Remote UI is not available'),
                        gettextCatalog.getString('Please check the device\'s network connection'),
                        gettextCatalog.getString('Ok'),
                        null,
                        null,
                        null,
                        event);
                };

                //Check remote ping URL before open
                $http({
                    url: pingUrl,
                    method: 'HEAD'
                }).then(function () {
                    // Open page
                    if (newTab) {
                        openNewTab();
                    } else {
                        openPage();
                    }
                }, function () {
                    // Show error
                    showWarning();
                });
            };

            /**
             * Check if RemoteUI available
             * @param {Object} device - device object
             * @returns {boolean} - show/hide remote ui features
             */
            vm.isRemoteUIAvailable = function (device) {
                return device.activationStatus && device.activationStatus.status !== 'DEACTIVATED';
            };

            vm.onFilter = function (searchText) {
                vm.deviceFilter.searchText = searchText;
                vm.refreshDeviceList();
            };

            /**
             * Is data available after load
             * @return {boolean} - data exist flag
             */
            vm.showNoData = function () {
                return vm.deviceObject.elements && vm.deviceObject.elements.length === 0 &&
                    !(vm.devicesPromise && vm.devicesPromise.$$state && vm.devicesPromise.$$state.status === 0);
            };
        }
    });

'use strict';

/**
 * @ngdoc component
 * @name loopUiApp.component:deviceInfo
 * @description
 * # deviceInfo
 */
angular.module('loopUiApp')
    .component('deviceInfo', {
        templateUrl: '../scripts/components/device/deviceInfo.html',
        bindings: {
            device: '<',
            virtualizationType: '<',
            onSave: '&',
        },
        controller: function ($stateParams, appConfig, gettextCatalog, Service, Commons) {
            var vm = this;
            //Current project
            vm.projectId = $stateParams.projectId;

            vm.$onInit = function () {
                vm.tags = vm.device.tags || [];
                vm.description = vm.device.description || '';

                //Device image
                vm.deviceImagePath = vm.device.imageURL ? appConfig.apiUrl.slice(0, -1) + vm.device.imageURL + '?' + Date.now() : null;

                vm.refreshTagList();
            };

            /**
             * Save device data
             * device {Object} device data object
             */
            vm.save = function (device) {
                var _device = angular.copy(device);
                _device.tags = vm.tags;
                _device.description = vm.description;
                //API param is array
                var deviceList = [_device];
                //Save device data
                Service.api.device({
                    action: vm.projectId
                }, deviceList).$promise
                    .then(function () {
                        Commons.toastShow('Device info saved');
                        vm.onSave();
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Save device error');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error device POST:' + JSON.stringify(reason));
                    });
            };

            /**
             * Load Tag list
             * @returns {void}
             */
            vm.refreshTagList = function () {
                Service.api.deviceTagList({
                    projectId: vm.projectId
                }).$promise
                    .then(function (data) {
                        vm.tagList = data;
                    })
                    .catch(function () {
                        vm.tagList = [];
                    });
            };

            /**
             * Check if device image exists
             * @return {boolean} - exists flag
             */
            vm.haveImage = function () {
                return !!(vm.device && vm.device.imageURL) || vm.imagePreview;
            };

            /**
            * Prepare image upload data and call preview.
            *
            * @param {Event} event             - Selection event from fileUpload component
            * @returns {void}
            */
            vm.uploadImage = function (event) {
                if (event.target.files && event.target.files.length > 0) {
                    vm.imageData = new FormData();
                    angular.forEach(event.target.files, function (data) {
                        vm.imageData.append('file', data);
                    });
                    vm.previewImage(event.target);
                    vm.saveImage(vm.imageData);
                }
            };

            /**
             * Upload image to server and add image url to the device model
             *
             * @param {FormData} image            - Image FormData
             * @returns {void}
             */
            vm.saveImage = function (image) {
                if (!image) {
                    return;
                }
                return Service.api.deviceImage({
                    actionExt: vm.device.projectId,
                    actionExt2: vm.device.deviceId
                }, image).$promise
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Failed to upload image');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error imageUpload:' + JSON.stringify(reason));
                    });
            };

            /**
             * Enable image previewer.
             *
             * @param {HTMLElement} input             - Input element
             * @returns {void}
             */
            vm.previewImage = function (input) {
                if (input.files && input.files[0]) {
                    var reader = new FileReader();
                    reader.onload = function (e) {
                        angular.element(document.querySelector('img.device-info__image')).attr('src', e.target.result);
                        vm.imagePreview = true;
                    };
                    reader.readAsDataURL(input.files[0]);
                }
            };

            /**
             * Remove device image
             * @returns {void}
             */
            vm.removeImage = function () {
                var deleteFunction = function () {
                    vm.fileUploadApi.cleanSelection();
                    Service.api.deviceImageDelete({
                        actionExt: vm.device.projectId,
                        actionExt2: vm.device.deviceId
                    }).$promise
                        .then(function () {
                            vm.device.imageURL = null;
                            vm.imagePreview = false;
                        })
                        .catch(function (reason) {
                            var messageObject = Commons.createErrorObject(reason, 'Failed to delete image');
                            Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        });
                };

                Commons.showConfirmationWarn(
                    gettextCatalog.getString('Remove Image'),
                    gettextCatalog.getString('Are you sure you want to remove image?'),
                    gettextCatalog.getString('Remove'),
                    deleteFunction,
                    gettextCatalog.getString('Cancel'),
                    undefined,
                    event);
            };

            /**
             * List of existing tags
             * @param {string} criteria - search criteria 
             * @return {array} - result
             */
            vm.tagQuerySearch = function (criteria) {
                return criteria ? vm.tagList.filter(vm.createFilterFor(criteria)) : vm.tagList;
            };

            /**
             * Create filter function for a query string
             * @param {string} query - search string
             * @return {function} filter function
             */
            vm.createFilterFor = function (query) {
                var lowercaseQuery = query.toLowerCase();

                return function filterFn(tag) {
                    return (tag.toLowerCase().indexOf(lowercaseQuery) !== -1);
                };
            };
        }
    });

'use strict';

/**
 * @ngdoc component
 * @name loopUiApp.component:deviceWebsocket
 * @description
 * # deviceDialog
 */

angular.module('loopUiApp')
    .component('deviceWebsocket', {
        templateUrl: '../scripts/components/device/deviceWebsocket.html',
        bindings: {
            device: '<',
            mqttConnect: '<'
        },
        controller: function ($timeout, $stateParams, Service, ServiceMQTT, Commons) {
            var vm = this;
            vm.cm = Commons;
            vm.serviceMQTT = ServiceMQTT;

            //Current project
            vm.projectId = $stateParams.projectId;

            //Messages object
            vm.messages = {};

            //Pagination settings
            vm.limitOptions = [10, 20, 50];
            vm.respPagination = {
                limit: vm.limitOptions[0],
                page: 1
            };
            vm.dataPagination = {
                limit: vm.limitOptions[0],
                page: 1
            };

            vm.$onInit = function () {
                vm.dataTopic = vm.device.config.mqttDataTopicName;
                vm.subscribeList = {};

                //Selected topic QoS
                vm.topicQos = {};
                vm.topicQos[vm.dataTopic] = 0;

                //Retained sign
                vm.retain = false;

                Service.api.projectMqttCredentials({
                    projectId: vm.device.projectId
                }).$promise
                    .then(function (mqttCredentials) {
                        //Connect
                        var options = ServiceMQTT.options;
                        options.username = vm.device.config.mqttUserName;
                        options.password = vm.device.config.mqttPassword;
                        return ServiceMQTT.connectPromise(mqttCredentials.wssUrl, options);
                    })
                    .then(function () {
                        //Message handler
                        ServiceMQTT.messageHandler(vm.messageHandler);
                    })
                    .catch(function (reason) {
                        console.log('MQTT connection error:' + JSON.stringify(reason));
                    });
            };

            // Component destroy handle
            vm.$onDestroy = function () {
                vm.messages = {};
                if (ServiceMQTT.client && ServiceMQTT.client.connected) {
                    ServiceMQTT.client.end();
                }
            };

            /**
             * Subscribe to topic
             * @param {String} topicName topic name to subscribe
             * @return {void}
             */
            vm.subscribe = function (topicName) {
                var options = {
                    qos: vm.topicQos[topicName]
                };
                ServiceMQTT.subscribePromise(topicName, options)
                    .then(function () {
                        vm.subscribeList[topicName] = true;
                        Commons.toastShow('Subscribed');
                    })
                    .catch(function () {
                        Commons.toastShow('Subscribe failed');
                    });
            };

            /**
             * Unsubscribe from topic
             * @param {String} topicName topic name to unsubscribe
             * @return {void}
             */
            vm.unsubscribe = function (topicName) {
                var options = {
                    qos: vm.topicQos[topicName]
                };
                ServiceMQTT.unSubscribePromise(topicName, options)
                    .then(function () {
                        vm.subscribeList[topicName] = false;
                        Commons.toastShow('Unsubscribed');
                    })
                    .catch(function () {
                        Commons.toastShow('Unsubscribe failed');
                    });
            };

            /**
             * Create MQTT response data handler
             * @param {String} topic - topic name to handle
             * @param {Binary} payload - message payload
             * @returns {void}
             */
            vm.messageHandler = function (topic, payload) {
                $timeout(function () {
                    vm.addToBuffer(
                        payload.toString(),
                        topic,
                        vm.subsribeBufferSize
                    );
                }, 0);
            };

            /**
             * Check is message available for topic
             * @param {String} topicName topic name to check
             * @return {void} 
             */
            vm.isMessageAvailable = function (topicName) {
                return vm.messages[topicName] && vm.messages[topicName].length > 0;
            };

            /**
             * Message count per topic
             * @param {String} topicName topic name to check
             * @return {int} message count
             */
            vm.messageCount = function (topicName) {
                if (!vm.messages[topicName]) {
                    return;
                }
                return vm.messages[topicName].length < 100 ? vm.messages[topicName].length : '99+';
            };

            /**
             * Ring buffer function. Allow to save @bufferLength values 
             * @param {Object} value sent object
             * @param {String} bufferName buffer name
             * @param {int} bufferLength buffer max value
             * @return {void}
             */
            vm.addToBuffer = function (value, bufferName, bufferLength) {
                if (!angular.isArray(vm.messages[bufferName])) {
                    vm.messages[bufferName] = [];
                }
                var _bufferLength = bufferLength || 100;
                vm.messages[bufferName].unshift({
                    time: Date.now(),
                    payload: value
                });
                if (vm.messages[bufferName].length > _bufferLength) {
                    vm.messages[bufferName].pop();
                }
            };

        }
    });
'use strict';

/**
 * @ngdoc component
 * @name loopUiApp.component:deviceAppsMpc
 * @description
 * # deviceAppsMpc
 */
angular.module('loopUiApp')
    .component('deviceAppsMpc', {
        templateUrl: '../scripts/components/device/deviceAppsMpc.html',
        bindings: {
            device: '<',
            deviceOnline: '<'
        },
        controller: function ($scope, $mdDialog, $interval, $filter, gettextCatalog, ServiceAsyncTask, Service, Commons) {
            var vm = this;
            vm.appList = [];
            
            vm.$onInit = function () {
                vm.messages = 0;
                vm.entityName = 'Applications';

                // Check capability for Marketplace feature
                vm.mpCapabilityObject = Commons.checkFeatureCapability(vm.device.capabilities, 'MARKETPLACE');

                // Generic table setup
                vm.listSetup = {
                    sortField: 'name',
                    showIndex: true,
                    editable: false,
                    removable: false,
                    limit: 10,
                    limitOptions: [10, 50, 100],
                    fields: [
                        {
                            name: 'Name',
                            column: 'name'
                        },
                        {
                            name: 'Release',
                            column: 'releaseName'
                        },
                        {
                            name: 'Status',
                            column: 'status',
                            style: '{"width": "60px"}'
                        },
                        {
                            name: 'Status Time',
                            column: 'statusChangedAt',
                            style: '{"width": "100px"}',
                            transformation: function (item) {
                                // Check timestamp format milliseconds or seconds
                                // Workaround as MPC API has changed timestamp format from version 3.0
                                var _ts = item.statusChangedAt < 1E11 ? item.statusChangedAt * 1000 : item.statusChangedAt;
                                return $filter('date')(_ts, 'yyyy-MM-dd HH:mm');
                            }
                        },

                    ]
                };

                vm.additionalActions = [
                    {
                        name: 'Start',
                        icon: 'play_arrow',
                        function: vm.startApp,
                        disable: function () {
                            return !vm.mpCapabilityObject.available;
                        }
                    },
                    {
                        name: 'Stop',
                        icon: 'stop',
                        function: vm.stopApp,
                        disable: function () {
                            return !vm.mpCapabilityObject.available;
                        }
                    },
                    {
                        name: 'Delete',
                        icon: 'delete',
                        function: vm.deleteApp,
                        disable: function () {
                            return !vm.mpCapabilityObject.available;
                        }
                    },
                    {
                        name: 'Logs',
                        icon: 'subject',
                        function: vm.showLog,
                        disable: function () {
                            return !vm.mpCapabilityObject.available;
                        }
                    }
                ];

                vm.filterActions = [
                    {
                        icon: 'refresh',
                        label: 'Reload',
                        buttonClick: vm.refreshList
                    }
                ];

                if (vm.deviceOnline) {
                    vm.refreshList();
                }
            };

            vm.$onDestroy = function () {
                $interval.cancel(vm.logPullInterval);
            };

            /**
             * Get application list for device
             * @returns {void}
             */
            vm.refreshList = function () {
                vm.isLoading = true;
                vm.appListPromise = Service.api.marketplaceAppList({
                    projectId: vm.device.projectId,
                    deviceId: vm.device.deviceId
                }).$promise;

                vm.appListPromise.then(function (data) {
                    vm.appList = data;
                    vm.origAppList = data;
                })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Get app list failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error marketplaceAppList:' + JSON.stringify(reason));
                    })
                    .finally(function () {
                        vm.isLoading = false;
                    });
            };

            /**
             * Start application on device
             * @param {MouseEvent} event - application object
             * @param {Object} app - application object
             * @returns {void}
             */
            vm.startApp = function (event, app) {
                ServiceAsyncTask.createTaskAndWait(
                    ServiceAsyncTask.taskTypes.MARKETPLACE_APPLICATION_START.code, // Task type
                    ServiceAsyncTask.taskTypes.MARKETPLACE_APPLICATION_START.subtaskTypes, // Subtask types
                    '', // Task description 
                    [vm.device],
                    { applicationId: app.id }, // Task params
                    false // Wait device for online
                )
                    .then(function () {
                        vm.refreshList();
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Start app list failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error marketplaceAppStart:' + JSON.stringify(reason));
                    });
            };

            /**
             * Stop application on device
             * @param {MouseEvent} event - application object
             * @param {Object} app - application object
             * @returns {void}
             */
            vm.stopApp = function (event, app) {
                ServiceAsyncTask.createTaskAndWait(
                    ServiceAsyncTask.taskTypes.MARKETPLACE_APPLICATION_STOP.code, // Task type
                    ServiceAsyncTask.taskTypes.MARKETPLACE_APPLICATION_STOP.subtaskTypes, // Subtask types
                    '', // Task description 
                    [vm.device],
                    { applicationId: app.id }, // Task params
                    false // Wait device for online
                )
                    .then(function () {
                        vm.refreshList();
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Stop app list failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error marketplaceAppStop:' + JSON.stringify(reason));
                    });
            };

            /**
             * Delete application on device
             * @param {MouseEvent} event - application object
             * @param {Object} app - application object
             * @returns {void}
             */
            vm.deleteApp = function (event, app) {
                var _deleteAppFn = function () {
                    ServiceAsyncTask.createTaskAndWait(
                        ServiceAsyncTask.taskTypes.MARKETPLACE_APPLICATION_DELETE.code, // Task type
                        ServiceAsyncTask.taskTypes.MARKETPLACE_APPLICATION_DELETE.subtaskTypes, // Subtask types
                        '', // Task description 
                        [vm.device],
                        { applicationId: app.id, removeVolumes: true }, // Task params
                        false // Wait device for online
                    )
                        .then(function () {
                            vm.refreshList();
                        })
                        .catch(function (reason) {
                            var messageObject = Commons.createErrorObject(reason, 'Delete app list failed');
                            Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                            console.log('Error marketplaceAppDelete:' + JSON.stringify(reason));
                        });
                };
                Commons.showConfirmationWarn(
                    gettextCatalog.getString('Remove Application'),
                    gettextCatalog.getString('Are you sure you want to remove application from device?'),
                    gettextCatalog.getString('Remove'),
                    _deleteAppFn,
                    gettextCatalog.getString('Cancel'),
                    null,
                    event);
            };

            /**
             * Open app log dialog
             * @param {MouseEvent} event - application object
             * @param {Object} app - application object
             * @returns {void}
             */
            vm.showLog = function (event, app) {
                // Check capability for multi-container feature
                var containersCapabilityObject = Commons.checkFeatureCapability(vm.device.capabilities, 'MP_APP_CONTAINER_LOGS');

                var _componentId = null;
                // Create an isolated scope to pass to the component 
                var _scope = angular.extend($scope, {
                    title: 'Application Log',
                    messages: null,
                    filterList: null,
                    onFilter: null
                });

                /**
                 * Refresh logs for application
                 * @returns {void}
                 */
                var _refreshAppLog = function () {
                    Service.api.marketplaceAppLog({
                        projectId: vm.device.projectId,
                        deviceId: vm.device.deviceId,
                        applicationId: app.id
                    }).$promise
                        .then(function (data) {
                            _scope.messages = data.log ? atob(data.log) : '';
                        })
                        .catch(function (reason) {
                            console.log('Error marketplaceAppLog:' + JSON.stringify(reason));
                        });
                };

                /**
                 * Refresh logs for application
                 * @returns {void}
                 */
                var _refreshContainerLog = function (componentId) {
                    Service.api.marketplaceContainerLog({
                        projectId: vm.device.projectId,
                        deviceId: vm.device.deviceId,
                        applicationId: app.id,
                        componentId: componentId
                    }).$promise
                        .then(function (data) {
                            _scope.messages = data.log ? atob(data.log) : '';
                        })
                        .catch(function (reason) {
                            console.log('Error marketplaceAppLog:' + JSON.stringify(reason));
                        });
                };

                /**
                 * Load logs
                 * @returns {void}
                 */
                var _fetchLogs = function () {
                    // If component is specified, then show component log
                    if (_componentId) {
                        _refreshContainerLog(_componentId);
                        return;
                    }
                    _refreshAppLog();
                };

                /**
                 * Load list of components for application
                 * @returns {void}
                 */
                var _getComponentList = function () {
                    Service.api.marketplaceAppComponents({
                        projectId: vm.device.projectId,
                        deviceId: vm.device.deviceId,
                        applicationId: app.id
                    }).$promise
                        .then(function (data) {
                            _scope.filterList = data.map(function (component) {
                                return {
                                    id: component.id,
                                    name: component.name
                                };
                            });
                        })
                        .catch(function (reason) {
                            console.log('Error marketplaceAppComponents:' + JSON.stringify(reason));
                        });
                };

                /**
                 * Handle filter change and filter logs
                 * @param {string} item - selected filter value
                 */
                var _onFilter = function (item) {
                    _componentId = item;
                    _scope.messages = null;
                    _fetchLogs();
                };

                _scope.onFilter = _onFilter;

                // Get list of components for application 
                // if this feature is available
                if (containersCapabilityObject.available) {
                    _getComponentList();
                }

                // Start pulling logs
                _fetchLogs();
                vm.logPullInterval = $interval(_fetchLogs, 5000);

                $mdDialog.show({
                    template: '<process-log title="title" messages="messages" filter-list="filterList" on-filter="onFilter(item)"></process-log>',
                    parent: angular.element(document.body),
                    targetEvent: event,
                    clickOutsideToClose: false,
                    preserveScope: true,
                    scope: _scope,
                    skipHide: true
                })
                    .then(function () {
                        // Stop pulling logs
                        $interval.cancel(vm.logPullInterval);
                    })
                    .catch(function () {

                    });
            };

            /**
             * Filter app list based on search criteria
             * @param {String} searchText - search string
             * @return {void}
             */
            vm.filter = function (searchText) {
                //Check object fields 
                var firstRow = vm.origAppList[0];
                if (!searchText || !firstRow.hasOwnProperty('name') || !firstRow.hasOwnProperty('parameters')
                ) {
                    vm.appList = vm.origAppList;
                    return;
                }
                vm.appList = vm.origAppList.filter(function (row) {
                    return (JSON.stringify(row.parameters) + row.name).toLowerCase().indexOf(searchText.toLowerCase()) >= 0;
                });
            };
        }
    });
'use strict';

/**
 * @ngdoc component
 * @name loopUiApp.component:deviceEvents
 * @description
 * # deviceEvents
 */
angular.module('loopUiApp')
    .component('deviceEvents', {
        templateUrl: '../scripts/components/device/deviceEvents.html',
        bindings: {
            device: '<',
            deviceOnline: '<',
        },
        controller: function (Service, Commons) {
            var vm = this;
            // Disable switcher on load
            vm.forwardingState = -1;

            vm.$onInit = function() {
                // Check capability for events feature
                vm.eventsCapabilityObject = Commons.checkFeatureCapability(vm.device.capabilities, 'EVENTS');
                
                vm.getForwardingStatus();
            };

            // Track online status change
            vm.$onChanges = function(changes) {
                if(changes.deviceOnline && !changes.deviceOnline.isFirstChange()) {
                    vm.getForwardingStatus();
                }
            };

            /**
             * Get forwarding event status
             * @returns {void}
             */
            vm.getForwardingStatus = function() {
                // Block switcher on load status
                vm.forwardingState = -1;
                // Do not check status for offline and device not capatable device
                if (!vm.deviceOnline || !(vm.eventsCapabilityObject && vm.eventsCapabilityObject.available)) { 
                    return;
                }
                Service.api.eventForwardingGet({
                    projectId: vm.device.projectId,
                    deviceId: vm.device.deviceId
                }).$promise
                .then(function(data) {
                    vm.forwardingState = data.enabled;
                })
                .catch(function (reason) {
                    vm.forwardingState = undefined;
                    var messageObject = Commons.createErrorObject(reason, 'Get forwarding status failed');
                    Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                    console.log('Error eventForwardingGet:' + JSON.stringify(reason));
                });
            };

            /**
             * Set forwarding status
             * @param {Boolean} status - status
             * @return {void}
             */
            vm.setForwardingStatus = function(status) {
                Service.api.eventForwarding({
                    projectId: vm.device.projectId,
                    deviceId: vm.device.deviceId,
                    enabled: status
                }).$promise
                .then(function() {
                    Commons.toastShow('Status changed');
                })
                .catch(function (reason) {
                    var messageObject = Commons.createErrorObject(reason, 'Set forwarding status failed');
                    Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                    console.log('Error eventForwarding:' + JSON.stringify(reason));
                });
            };

            /**
             * Get filter object value
             * @param {Objecy} data - filter object
             * @returns {void}
             */
            vm.applyFilter = function(data) {
                vm.filterObject = angular.copy(data);
            };

            /**
             * Add new value into filter
             * @param {Object} value - key-value filter object 
             * @return {void}
             */
            vm.addFilter = function(value) {
                vm.filterActive = true;
                vm.filterObject = angular.copy(Object.assign(vm.filterObject, value));
            };
        }
    });
'use strict';

/**
 * @ngdoc component
 * @name loopUiApp.component:deactivationDialog
 * @description
 * # deactivationDialog
 */
angular.module('loopUiApp')
    .component('deactivationDialog', {
        templateUrl: '../scripts/components/device/deactivationDialog.html',
        controller: function ($mdDialog) {
            var vm = this;

            // Force deactivation flag
            vm.forceEnable = false;

            /**
             * Close dialog windows
             * @return {undefined}
             */
            vm.hide = function () {
                $mdDialog.hide(vm.forceEnable);
            };

            /**
             * Cancel dialog button
             * @return {undefined}
             */
            vm.cancel = function () {
                $mdDialog.cancel();
            };
        }
    });
        
'use strict';

/**
 * @ngdoc component
 * @name loopUiApp.component:edgePollingSettingsDevice
 * @description
 * # deviceDialog
 */

angular.module('loopUiApp')
    .component('edgePollingSettingsDevice', {
        templateUrl: '../scripts/components/device/edgePollingSettingsDevice.html',
        bindings: {
            isLoading: '<',
            isSaving: '<',
            isMultiple: '<',
            pollingSettingsProject: '<',
            pollingSettingsDevice: '<',
            onSave: '&',
            onClose: '&?'
        },
        controller: function ($stateParams, Commons) {
            var vm = this;
            // Metrics sync interval limits
            vm.POLLING_MIN_INTERVAL = 30;
            vm.POLLING_MAX_INTERVAL = 604800;
            vm.POLLING_INTERVAL_WARN_VALUE = 1000;

            vm.$onInit = function () {
                vm.companyName = $stateParams.companyName;
                vm.projectId = $stateParams.projectId;

                vm.adminUilink = Commons.getAdminUiLink() + '/settings/management';

                vm.pollingSettingsDevice = vm.pollingSettingsDevice || {
                    enabled: true,
                    intervalSec: 30,
                    useProjectSettings: false
                };
            };

            /**
             * Call save metrics event
             */
            vm.save = function () {
                vm.onSave({
                    settings: vm.pollingSettingsDevice
                });
            };

            /**
             * Show warning if project level polling is disabled 
             * and project level settings are used
             * @returns {boolean}
             */
            vm.isProjectWarningShown = function () {
                return vm.pollingSettingsProject.enabled === false && vm.pollingSettingsDevice.useProjectSettings === true;
            };

            /**
             * Check if project level settings require the warning:
             * 1. If polling interval is higher than the minimum allowed interval
             * 2. If polling is disabled
             * @returns {boolean}
             */
            vm.isWarningShown = function () {
                return (vm.pollingSettingsDevice.intervalSec > vm.POLLING_INTERVAL_WARN_VALUE || vm.pollingSettingsDevice.enabled === false) &&
                    vm.pollingSettingsDevice.useProjectSettings === false;
            };

            /**
             * Check if the whole settings are disabled
             * @returns {boolean}
             */
            vm.isSettingDisabled = function () {
                return vm.pollingSettingsDevice.useProjectSettings === true;
            };

            /**
             * Check if interval is disabled: if polling on device or project is disabled 
             * or if project interval is used
             * @returns {boolean}
             */
            vm.isIntervalDisabled = function () {
                return vm.isSettingDisabled() || vm.pollingSettingsDevice.enabled === false || vm.pollingSettingsDevice.useProjectSettings === true;
            };

        }
    }); 
'use strict';
/**
 * @ngdoc component
 * @name loopUiApp.component:licenseView
 * @description
 * # licenseView
 */

angular.module('loopUiApp')
    .component('licenseView', {
        templateUrl: '../scripts/components/device/license/licenseView.html',
        bindings: {
            device: '<',
            deviceOnline: '<',
            onLicenseChange: '&',
        },
        controller: function ($stateParams, $timeout, gettextCatalog, Service, Commons) {
            var vm = this;

            vm.$onInit = function () {
                vm.projectId = $stateParams.projectId;

                // Check capability for floating license feature
                vm.floatingLicenseCapabilityObject = Commons.checkFeatureCapability(vm.device.capabilities, 'FLOATING_LICENSING');
                
                // List of feature action
                vm.featureActions = [
                    {
                        icon: 'refresh',
                        label: 'Reload',
                        buttonClick: vm.refreshFeatureList
                    }
                ];
                // List of features with limits action
                vm.featureWithLimitsActions = [
                    {
                        icon: 'refresh',
                        label: 'Reload',
                        buttonClick: vm.refreshFeaturesWithLimits
                    }
                ];

                vm.getLicenseType();
            };

            /**
             * Change type handler
             * @param {string} type - license type
             * @returns {void}
            */
            vm.changeLicenseType = function (type) {
                var _changeFn = function (type) {
                    vm.isTypeSaving = true;
                    Service.api.deviceLicenseType({
                        deviceId: vm.device.deviceId,
                        projectId: vm.device.projectId,
                        licenseType: type
                    }).$promise
                        .then(function () {
                            vm.licenseType = type;
                            vm.refresh();
                            Commons.toastShow('License type changed');
                        })
                        .catch(function (reason) {
                            var messageObject = Commons.createErrorObject(reason, 'Change license type failed');
                            Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                            console.log('Error deviceLicenseType:' + JSON.stringify(reason));
                        })
                        .finally(function () {
                            vm.isTypeSaving = false;
                        });
                };

                Commons.showConfirmation(
                    gettextCatalog.getString('Change License Type'),
                    gettextCatalog.getString('Are you sure you want to change device license type?'),
                    gettextCatalog.getString('Yes, Change'),
                    function () {
                        _changeFn(type);
                    },
                    gettextCatalog.getString('Cancel'),
                    null,
                    event);
            };

            /**
             * Load device type
             * @returns {void}
             */
            vm.getLicenseType = function () {
                vm.isTypeLoading = true;
                Service.api.deviceLicenseTypeGet({
                    deviceId: vm.device.deviceId,
                    projectId: vm.device.projectId
                }).$promise
                    .then(function (data) {
                        vm.licenseType = data.licenseType;
                        vm.refresh();
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Get license server information failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error getLicenseType:' + JSON.stringify(reason));
                    })
                    .finally(function () {
                        vm.isTypeLoading = false;
                    });
            };

            /**
             * Delete license
             * @param {Object} license - license object 
             */
            vm.deleteLicense = function (license) {
                Service.api.deviceLicenseDelete({
                    projectId: vm.device.projectId,
                    deviceId: vm.device.deviceId,
                    action: license.key.value,
                }).$promise
                .then(function () {
                    Commons.toastShow('License deleted');
                    vm.refresh();
                })
                .catch(function (reason) {
                    var messageObject = Commons.createErrorObject(reason, 'Delete license failed');
                    Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                    console.log('Error deviceLicenseDelete:' + JSON.stringify(reason));
                });
            };

            /**
            * Refresh license list
            * @returns {void}
            */
            vm.refreshLicenseList = function () {
                vm.isLicenseListLoading = true;
                vm.licenseListPromise = Service.api.deviceLicenseList({
                    projectId: vm.projectId,
                    deviceId: vm.device.deviceId
                }).$promise;

                vm.licenseListPromise.then(function (data) {
                    vm.licenseList = data;
                })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Get license list failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error licenseList:' + JSON.stringify(reason));
                    })
                    .finally(function () {
                        vm.isLicenseListLoading = false;
                    });
            };

            /**
             * Refresh feature limits
             * @returns {void}
             */
            vm.refreshLimitsList = function () {
                vm.limitsObject = {};
                Service.api.deviceLicenseLimitList({
                    projectId: vm.projectId,
                    deviceId: vm.device.deviceId
                }).$promise
                    .then(function (data) {
                        vm.limitsList = data;
                        vm.limitsObject = data.reduce(function (acc, cur) {
                            acc[cur.feature] = cur;
                            return acc;
                        }, {});
                    })
                    .catch(function (reason) {
                        console.log('Error deviceLicenseLimitList:' + JSON.stringify(reason));
                    });
            };

            /**
             * Refresh feature list
             * @returns {void}
             */
            vm.refreshFeatureList = function () {
                vm.featureListPromise = Service.api.deviceLicenseFeatureList({
                    projectId: vm.projectId,
                    deviceId: vm.device.deviceId
                }).$promise;

                vm.featureListPromise.then(function (data) {
                    vm.featureList = data;
                })
                    .catch(function (reason) {
                        console.log('Error featureList:' + JSON.stringify(reason));
                    });
            };

            /**
             * Refresh features with limits 
             */
            vm.refreshFeaturesWithLimits = function () {
                if (vm.licenseType === 'FLOATING' && vm.deviceOnline) {
                    vm.refreshLimitsList();
                }
                vm.refreshFeatureList();
            };

            /**
             * Refresh all lists
             */
            vm.refresh = function () {
                vm.refreshLicenseList();
                vm.refreshFeaturesWithLimits();
                // Callback after 1 sec, to wait when capability object updated
                $timeout(function() {
                    vm.onLicenseChange();
                }, 1000);
            };
        }
    });

'use strict';
/**
 * @ngdoc component
 * @name loopUiApp.component:licenseList
 * @description
 * # licenseList
 */

angular.module('loopUiApp')
    .component('licenseList', {
        templateUrl: '../scripts/components/device/license/licenseList.html',
        bindings: {
            device: '<',
            deviceOnline: '<',
            items: '<',
            itemsPromise: '<',
            isLoading: '<',
            onDelete: '&',
            onRefreshList: '&',
            onRefreshAll: '&'
        },
        controller: function (gettextCatalog, Commons) {
            var vm = this;
            vm.isShowLicenseForm = false;
            vm.isNewLicense = undefined;
            // Flag to show if core license exists
            vm.isCoreLicenseExists = false;
            vm.isNonCoreLicenseExists = false;

            vm.$onInit = function () {
                // Check if device support licenseV2 capability
                vm.licenseV2CapabilityObject = Commons.checkFeatureCapability(vm.device.capabilities, 'LICENSE_VERSION_V2');

                vm.items = [];
                //Table name
                vm.entityName = 'License';
                // Generic table setup
                vm.listSetup = {
                    sortField: '-isCore',
                };

                vm.cardActions = [
                    {
                        icon: 'refresh',
                        label: 'Reload',
                        buttonClick: vm.refreshList
                    }
                ];
            };

            vm.$onChanges = function (changes) {
                if (changes.items && changes.items.currentValue) {
                    vm.isCoreLicenseExists = vm.findCoreLicense(changes.items.currentValue);
                    vm.isNonCoreLicenseExists = vm.findNoneCoreLicense(changes.items.currentValue);
                }
            };
            /**
             * Refresh list callback
             */
            vm.refreshList = function () {
                vm.onRefreshList();
            };

            /**
             * Delete license
             * @param {Object} event - mouse click event
             * @param {*} license - License object
             */
            vm.deleteLicense = function (event, license) {
                Commons.showConfirmationWarn(
                    gettextCatalog.getString('Confirmation Required'),
                    gettextCatalog.getString('Are you sure you want to remove license <strong>' + license.name + '</strong>?'),
                    gettextCatalog.getString('Yes, remove license'),
                    function() {
                        vm.onDelete({license: license});
                    },
                    gettextCatalog.getString('No'),
                    null,
                    event);
            };

            /**
             * Refresh license list, list of features, and performance pack
             */
            vm.refreshAll = function () {
                vm.isShowLicenseForm = false;
                vm.onRefreshAll();
            };

            /**
             * Check is if any core license exist
             * @param {Array} items - license list 
             * @returns 
             */
            vm.findCoreLicense = function (items) {
                if (!angular.isArray(items)) {
                    return false;
                }
                return items.some(function (item) {
                    return item.isCore;
                });
            };

            /**
             * Check is if any non-core (feature) license exist
             * @param {Array} items - license list 
             * @returns 
             */
            vm.findNoneCoreLicense = function (items) {
                if (!angular.isArray(items)) {
                    return false;
                }
                return items.some(function (item) {
                    return !item.isCore;
                });
            };

            /**
             * Show/hide add/upgrade new license block
             * @param {Boolean} isNewLicense - flag to show
             * true - show add new license block
             * false - show upgrade license block
             */
            vm.openLicenseForm = function (isNewLicense) {
                vm.isShowLicenseForm = true;
                vm.isNewLicense = isNewLicense;
            };

            /**
             * Hide add/upgrade new license block
             */
            vm.closeLicenseForm = function () {
                vm.isShowLicenseForm = false;
                vm.isNewLicense = undefined;
            };
        }
    });
'use strict';
/**
 * @ngdoc component
 * @name loopUiApp.component:featureList
 * @description
 * # featureList
 */

angular.module('loopUiApp')
    .component('featureList', {
        templateUrl: '../scripts/components/device/license/featureList.html',
        bindings: {
            items: '<',
            itemsPromise: '<',
            sortField: '<',
        },
        controller: function () {
            var vm = this;

            vm.$onInit = function () {
                // Generic table setup
                vm.listSetup = {
                    sortField: vm.sortField || 'count',
                    showIndex: false,
                    editable: false,
                    removable: false,
                    limit: 10,
                    limitOptions: [10, 50, 100],
                };
            };

            /**
             * Refresh list callback
             */
            vm.refreshList = function () {
                vm.onRefresh();
            };

            /**
             * Return license status CSS class 'text-error'
             * @param {string} status - license status
             * @returns 
             * 
             */
            vm.licenseStatusClass = function(feature) {
                return feature.enabled === true ? '' : 'text-error';
            };

            /**
             * Is data available after load
             * @return {boolean} - data exists flag
             */
            vm.showNoData = function () {
                return vm.items && vm.items.length === 0 &&
                    !(vm.itemsPromise && vm.itemsPromise.$$state && vm.itemsPromise.$$state.status === 0);
            };
        }
    });
'use strict';
/**
 * @ngdoc component
 * @name loopUiApp.component:featureWithLimitsList
 * @description
 * # featureWithLimitsList
 */

angular.module('loopUiApp')
    .component('featureWithLimitsList', {
        templateUrl: '../scripts/components/device/license/featureWithLimitsList.html',
        bindings: {
            device: '<',
            items: '<',
            itemsPromise: '<',
            limitsObject: '<',
            licenseType: '<',
            onRefresh: '&'
        },
        controller: function ($scope, $mdDialog, Service, Commons) {
            var vm = this;
            vm.limitsUpdating = {};

            vm.$onInit = function () {

                // Table setup
                vm.listSetup = {
                    sortField: ['count', 'name'],
                    showIndex: false,
                    editable: false,
                    removable: false,
                    limit: 10,
                    limitOptions: [10, 50, 100]
                };

                vm.itemsPagination = {
                    limit: vm.listSetup.limit,
                    page: 1,
                    limitOptions: vm.listSetup.limitOptions
                };
            };

            /**
             * 
             * @param {Object} event - mouse click object 
             * @param {*} item - feature item
             */
            vm.editLimits = function (event, item) {
                var _data = vm.limitsObject[item.name] || { limit: null, reservation: null };
                var scope = angular.extend($scope.$new(true), {
                    item: item,
                    data: _data
                });

                $mdDialog.show({
                    template: '<md-dialog style="width:500px;"><limits-dialog item="item" data="data"></limits-dialog></md-dialog>',
                    parent: angular.element(document.body),
                    targetEvent: event,
                    clickOutsideToClose: false,
                    preserveScope: true,
                    scope: scope,
                    skipHide: true,
                })
                    .then(function (data) {
                        if (data) {
                            vm.limitsUpdating[item.name] = true;
                            Service.api.deviceFeatureLimitSet({
                                actionExt: item.name,
                                projectId: vm.device.projectId,
                                deviceId: vm.device.deviceId
                            }, data).$promise
                                .then(function () {
                                    vm.onRefresh();
                                    Commons.toastShow('Limits changed');
                                })
                                .catch(function (reason) {
                                    var messageObject = Commons.createErrorObject(reason, 'Change limits failed');
                                    Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                                    console.log('Error deviceFeatureLimitSet:' + JSON.stringify(reason));
                                })
                                .finally(function() {
                                    vm.limitsUpdating[item.name] = false;
                                });

                        }
                    });
            };

            /**
             * Is data available after load
             * @return {boolean} - data exists flag
             */
            vm.showNoData = function () {
                return vm.items && vm.items.length === 0 &&
                    !(vm.itemsPromise && vm.itemsPromise.$$state && vm.itemsPromise.$$state.status === 0);
            };
        }
    });
'use strict';
/**
 * @ngdoc component
 * @name loopUiApp.component:limitsDialog
 * @description
 * # limitsDialog
 */

angular.module('loopUiApp')
    .component('limitsDialog', {
        templateUrl: '../scripts/components/device/license/limitsDialog.html',
        bindings: {
            data: '<'
        },
        controller: function ($mdDialog) {
            var vm = this;
            vm.payload = {
                limit: null,
                reservation: null
            };

            vm.$onInit = function() {
                vm.payload.limit = vm.data.limits.effective;
                vm.payload.reservation = vm.data.reservations.effective;
            };

            /**
             * Save button
             * @return {void}
             */
             vm.save = function () {
                $mdDialog.hide(vm.payload);
            };

            /**
             * Cancel dialog button
             * @return {void}
             */
             vm.cancel = function () {
                $mdDialog.cancel();
            };

        }
    });
'use strict';
/**
 * @ngdoc component
 * @name loopUiApp.component:performancePackList
 * @description
 * # performancePackList
 */

angular.module('loopUiApp')
    .component('performancePackList', {
        templateUrl: '../scripts/components/device/license/performancePackList.html',
        bindings: {
            items: '<',
            itemsPromise: '<',
            isLoading: '<',
            onRefresh: '&'
        },
        controller: function () {
            var vm = this;
            
            vm.$onInit = function() {
                //Table name
                vm.entityName = 'Performance Packs';
                // Generic table setup
                vm.listSetup = {
                    sortField: 'name',
                    showIndex: false,
                    editable: false,
                    removable: false,
                    limit: 10,
                    limitOptions: [10, 50, 100],
                    fields: [
                        {
                            name: 'Name',
                            column: 'name'
                        },
                        {
                            name: 'Description',
                            column: 'desc'
                        },
                        {
                            name: 'Maximum Value',
                            column: 'count',
                            transformation: function (item) {
                                return item.count === -1 ? 'Unlimited' : item.count;
                            }
                        }
                    ]
                };

                vm.cardActions = [
                    {
                        icon: 'refresh',
                        label: 'Reload',
                        buttonClick: vm.refreshList
                    }
                ];
            };

            /**
             * Refresh list callback
             */
            vm.refreshList = function (){
                vm.onRefresh();
            };
        }
    });
'use strict';
/**
 * @ngdoc component
 * @name loopUiApp.component:onlineActivation
 * @description
 * # onlineActivation
 */

angular.module('loopUiApp')
    .component('onlineActivation', {
        templateUrl: '../scripts/components/device/license/onlineActivation.html',
        bindings: {
            device: '<',
            items: '<',
            isNewLicense: '<',
            onActivate: '&',
            onCancel: '&'
        },
        controller: function (gettextCatalog, Service, Commons) {
            var vm = this;

            /**
             * Online activation
             * @returns boolean
             */
            vm.activate = function () {
                // If core license exist (non-trial) ask confirmation to upgrade
                if (vm.isNewLicense) {
                    vm.activateWithoutConfirmation();
                    return;
                }
                vm.activateWithConfirmation();
            };

            /**
             * Activate function without asking confirmation
             * @returns {void}
             */
            vm.activateWithoutConfirmation = function () {
                var _action = vm.isNewLicense ? 'deviceLicenseOnlineActivate' : 'deviceLicenseOnlineReactivate';
                var _payload = vm.isNewLicense ? { value: vm.license } : { key: vm.license };
                vm.isLoading = true;
                Service.api[_action]({
                    projectId: vm.device.projectId,
                    deviceId: vm.device.deviceId
                }, _payload).$promise
                    .then(function () {
                        Commons.toastShow('License added');
                        vm.onActivate();
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Online activation failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error ' + _action + ':' + JSON.stringify(reason));
                    })
                    .finally(function () {
                        vm.isLoading = false;
                    });
            };

            /**
             * Activate function with confirmation
             * @returns {void}
             */
            vm.activateWithConfirmation = function () {
                Commons.showConfirmation(
                    gettextCatalog.getString('Confirmation Required'),
                    gettextCatalog.getString('There is a valid license installed. It will be replaced by a new license. <br>Do you want to continue?'),
                    gettextCatalog.getString('Yes, Replace'),
                    function () {
                        vm.activateWithoutConfirmation();
                    },
                    gettextCatalog.getString('No'),
                    null,
                    null);
            };
        }
    });
'use strict';
/**
 * @ngdoc component
 * @name loopUiApp.component:offlineActivation
 * @description
 * # offlineActivation
 */

angular.module('loopUiApp')
    .component('offlineActivation', {
        templateUrl: '../scripts/components/device/license/offlineActivation.html',
        bindings: {
            device: '<',
            items: '<',
            isNewLicense: '<',
            onActivate: '&',
            onCancel: '&'
        },
        controller: function (gettextCatalog, Service, Commons) {
            var vm = this;
            vm.cm = Commons;
            // Offline activation key
            vm.activationKey = null;

            vm.$onInit = function () {
                vm.getActivationEndpoint();
            };

            /**
             * Load Offline activation endpoint
             * @returns {void} 
             */
            vm.getActivationEndpoint = function () {
                Service.api.deviceLicenseOfflineEndpoint({
                    projectId: vm.device.projectId,
                    deviceId: vm.device.deviceId
                }).$promise
                    .then(function (data) {
                        vm.activationUrl = data.activationURL;
                    });
            };

            /**
             * Generate offline activation request
             * @returns {void}
             */
            vm.generateRequest = function () {
                if (vm.isNewLicense) {
                    vm.generateRequestWithoutConfirmation();
                    return;
                }
                vm.generateRequestWithConfirmation();
            };

            /**
             * Generate offline activation request without confirmation
             * @returns {void} 
             */
            vm.generateRequestWithoutConfirmation = function () {
                vm.isActivationRequestLoading = true;
                vm.activationRequest = null;
                Service.api.deviceLicenseOfflineRequest({
                    projectId: vm.device.projectId,
                    deviceId: vm.device.deviceId
                }, {
                    key: vm.activationKey,
                    upgrade: !vm.isNewLicense // Replace if core license exists
                }).$promise
                    .then(function (data) {
                        vm.activationRequest = data.request;
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Offline activation failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error deviceLicenseOfflineRequest:' + JSON.stringify(reason));
                    })
                    .finally(function () {
                        vm.isActivationRequestLoading = false;
                    });
            };

            /**
             * Generate offline activation request with confirmation
             * @returns {void}
             */
            vm.generateRequestWithConfirmation = function () {
                Commons.showConfirmation(
                    gettextCatalog.getString('Confirmation Required'),
                    gettextCatalog.getString('There is a valid license installed. It will be replaced by a new license. <br>Do you want to continue?'),
                    gettextCatalog.getString('Yes'),
                    function () {
                        vm.generateRequestWithoutConfirmation();
                    },
                    gettextCatalog.getString('No'),
                    null,
                    null);
            };

            /**
             * Open license portal
             */
            vm.openLicensePortal = function () {
                window.open(vm.activationUrl, '_blank');
            };

            /**
             * Activate function
             * @returns {void}
             */
            vm.activate = function () {
                vm.isLoading = true;
                Service.api.deviceLicenseOfflineActivate({
                    projectId: vm.device.projectId,
                    deviceId: vm.device.deviceId
                }, { license: vm.license }).$promise
                    .then(function () {
                        Commons.toastShow('License added');
                        vm.onActivate();
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Offline activation failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error licenseOfflineActivate:' + JSON.stringify(reason));
                    })
                    .finally(function () {
                        vm.isLoading = false;
                    });
            };

            /**
             * Refresh license list
             */
            vm.refreshList = function () {
                vm.onRefresh();
            };
        }
    });
'use strict';
/**
 * @ngdoc component
 * @name loopUiApp.component:deviceSiteLicense
 * @description
 * # deviceSiteLicense
 */

angular.module('loopUiApp')
    .component('deviceSiteLicense', {
        bindings: {
            device: '<',
            deviceOnline: '<',
            licenseType: '<',
            isLoading: '<',
            isSaving: '<',
            onChange: '&'
        },
        templateUrl: '../scripts/components/device/license/deviceSiteLicense.html',
        controller: function () {
            var vm = this;

            /**
             * Change license type
             * @param {string} type - type name 
             */
            vm.changeType = function(type) {
                vm.onChange({ type: type });
            };
        }
    });
'use strict';
/**
 * @ngdoc component
 * @name loopUiApp.component:devicePolicyView
 * @description
 * # devicePolicyView
 */

angular.module('loopUiApp')
    .component('devicePolicyView', {
        templateUrl: '../scripts/components/device/devicePolicy/devicePolicyView.html',
        bindings: {
            device: '<',
            deviceOnline: '<'
        },
        controller: function (Service, Commons) {
            var vm = this;

            vm.$onInit = function() {
                // Check capability for Password Policy feature
                vm.policyCapabilityObject = Commons.checkFeatureCapability(vm.device.capabilities, 'PASSWORD_POLICY');
            };

            /**
             * Save policy
             * @param {string} policyId - policy id
             * @returns {void}
             */
            vm.savePolicy = function(policyId){
                Service.api.passwordPolicy({
                    deviceId: vm.device.deviceId,
                    policyId: policyId
                }).$promise
                .then(function() {
                    Commons.toastShow('Policy for device saved');
                })
                .catch(function (reason) {
                    var messageObject = Commons.createErrorObject(reason, 'Save policy failed');
                    Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                    console.log('Error passwordPolicy:' + JSON.stringify(reason));
                });
            };
        }
    });
'use strict';
/**
 * @ngdoc component
 * @name loopUiApp.component:devicePolicy
 * @description
 * # devicePolicy
 */

angular.module('loopUiApp')
    .component('devicePolicy', {
        templateUrl: '../scripts/components/device/devicePolicy/devicePolicy.html',
        bindings: {
            device: '<',
            onSave: '&'
        },
        controller: function (Service) {
            var vm = this;
            vm.isLoading = false;
            vm.policyList = [];
            vm.currentPolicy = {};

            vm.$onInit = function() {
                vm.getPolicyList();
                
                // For single device load current policy
                if (vm.device) {
                    vm.getCurrentPolicy();
                }

                // Policy params map
                vm.codeMap = {
                    minPasswordLen:  'Minimum password length',
                    maxPasswordLen:  'Maximum password length',
                    autoGeneratedPasswordLen:  'Auto generated password length',
                    minUppercaseChars: 'Minimum uppercase characters',
                    minLowercaseChars: 'Minimum lowercase characters',
                    minDigits: 'Minimum number of digits',
                    specialChars: 'List of special characters allowed',
                    minSpecialChars: 'Minimum number ofspecial characters'
                };
            };

            /**
             * Load policy list
             * @returns {void}
             */
            vm.getPolicyList = function() {
                vm.isLoading = true;
                Service.api.passwordPolicyList().$promise
                .then(function(data) {
                    vm.policyList = data;
                })
                .catch(function (reason) {
                    console.log('Error passwordPolicyList:' + JSON.stringify(reason));
                })
                .finally(function() {
                    vm.isLoading = false;
                });
            };

            /**
             * Load current password policy
             * @returns {void}
             */
            vm.getCurrentPolicy = function() {
                vm.isLoading = true;
                Service.api.passwordPolicyGet({
                    actionExt: vm.device.deviceId
                }).$promise
                .then(function(data) {
                    vm.currentPolicy = data;
                })
                .catch(function (reason) {
                    console.log('Error passwordPolicyGet:' + JSON.stringify(reason));
                })
                .finally(function() {
                    vm.isLoading = false;
                });
            };

            /**
             * Save hook
             * @param {string} policyId - policy id
             * @returns {void}
             */
            vm.save = function(policyId) {
                vm.onSave({ policyId: policyId});
            };
        }
    });

'use strict';
/**
 * @ngdoc component
 * @name loopUiApp.component:devicePolicyDialog
 * @description
 * # devicePolicyDialog
 */

angular.module('loopUiApp')
    .component('devicePolicyDialog', {
        bindings: {
            devices: '<'
        },
        templateUrl: '../scripts/components/device/devicePolicy/devicePolicyDialog.html',
        controller: function ($mdDialog, $q, Service, Commons) {
            var vm = this;

            vm.$onInit = function() {
                vm.onlineCount = vm.filterOnlineDevices(vm.devices).length;
            };

            /**
             * Change policy
             * @param {boolean} policyId - polocy id
             * @returns {void}
             */
            vm.save = function (policyId) {
                var onlineDevice = vm.filterOnlineDevices(vm.devices);
                if (onlineDevice.length === 0) {
                    Commons.toastShow('The policy can be applied to online devices only', 5000);
                    return;
                }
                vm.actionInProgress = true;
                var _errorList = [];
                var _promiseList = onlineDevice // Send only online devices
                    .map(function (device) {
                        return $q(function (resolve) {
                            Service.api.passwordPolicy({
                                deviceId: device.deviceId,
                                policyId: policyId
                            }).$promise
                                .then(function () {
                                    resolve({
                                        device: device.deviceId,
                                        status: status,
                                        error: null
                                    });
                                })
                                .catch(function (error) {
                                    resolve({
                                        device: device.deviceId,
                                        status: status,
                                        error: error
                                    });
                                });
                        });
                    });

                $q.all(_promiseList)
                    .then(function (result) {
                        var _message = '';
                        _errorList = vm.errorHandler(result);
                        if (_errorList.length > 1) {
                            _message = _errorList[0].error.data && _errorList[0].error.data.message ? _errorList[0].error.data.message : 'Save policy action failed';
                            vm.runningStatusText = 'Change policy operation completed with an error for ' + _errorList.length + ' device(s). ' + _message;
                        }
                        else if (_errorList.length === 1) {
                            _message = _errorList[0].error.data && _errorList[0].error.data.message ? _errorList[0].error.data.message : 'Save policy action failed';
                            vm.runningStatusText = _message;
                        }
                        else {
                            vm.runningStatusText = 'Policy was changed';
                            Commons.toastShow(vm.runningStatusText);
                            $mdDialog.hide();
                        }
                        Commons.toastShow(vm.runningStatusText);
                    })
                    .finally(function () {
                        vm.actionInProgress = false;
                    });
            };

            /**
             * Create form resolved error object list of errors
             * @param {Object} resultList - resolved list from promise array response
             * @returns {Array} - new error list
             */
            vm.errorHandler = function (resultList) {
                return resultList.filter(function (result) {
                    return !!result.error;
                });
            };

            /**
             * Filter only online devices
             * @param {Array} devices - selected device list
             * @return {Array} online device list
             */
            vm.filterOnlineDevices = function (devices) {
                return devices.filter(function (device) {
                    return device.online;
                });
            };


            /**
             * Cancel dialog button
             * @return {undefined}
             */
            vm.cancel = function () {
                $mdDialog.cancel();
            };
        }
    });
'use strict';

/**
 * @ngdoc component
 * @name loopUiApp.component:deviceBackup
 * @description
 * # deviceDialog
 */

angular.module('loopUiApp')
    .component('deviceBackup', {
        templateUrl: '../scripts/components/device/deviceBackup/deviceBackup.html',
        bindings: {
            device: '<',
        },
        controller: function ($scope, $stateParams, $mdDialog, $window, $filter, gettextCatalog, Service, Commons) {
            var vm = this;
            //List of backup files
            vm.backupList = [];
            vm.selectedFiles = [];
            vm.isLoading = false;

            vm.$onChanges = function (changes) {
                if (changes.device && changes.device.currentValue) {
                    // Check capability for backup feature
                    vm.backupCapabilityObject = Commons.checkFeatureCapability(vm.device.capabilities, 'BACKUP');
                }
            };

            vm.$onInit = function () {
                vm.companyName = $stateParams.companyName;
                vm.projectId = $stateParams.projectId;
                vm.deviceId = $stateParams.deviceId;

                //Generic table settings
                vm.entityName = 'backup';
                vm.listSetup = {
                    sortField: '-timestamp',
                    keyName: 'objectName',
                    rowSelection: false,
                    multipleSelection: false,
                    showIndex: false,
                    editable: false,
                    removable: false,
                    limitOptions: [10, 50, 100],
                    limit: 10,
                    serverPagination: true,
                    fields: [
                        {
                            name: 'Type',
                            column: 'backupType'
                        },
                        {
                            name: 'Name',
                            column: 'objectName'
                        },
                        {
                            name: 'Size',
                            column: 'objectSize',
                            transformation: function (item) {
                                return $filter('bytes')(item.objectSize);
                            }
                        },
                        {
                            name: 'Time',
                            column: 'timestamp',
                            transformation: function (item) {
                                return $filter('date')(item.timestamp, 'yyyy-MM-dd HH:mm');
                            }
                        }
                    ]
                };

                // Init pagination object
                vm.itemsPagination = {
                    limit: vm.listSetup.limit,
                    page: 1
                };

                // Filter actions
                vm.listActions = [
                    {
                        name: 'Make device backup',
                        icon: 'backup',
                        function: vm.initBackup
                    },
                    {
                        name: 'Upload new backup file',
                        icon: 'add',
                        function: vm.backupUploadDialog
                    },
                    {
                        name: 'Multiple Select',
                        icon: 'done_all',
                        function: vm.toggleSelectMode
                    },
                    {
                        name: 'Refresh',
                        icon: 'refresh',
                        function: vm.refreshBackupList
                    }
                ];

                // Action list
                vm.additionalActions = [
                    {
                        name: 'Download',
                        icon: 'file_download',
                        function: vm.backupDownload
                    },
                    {
                        name: 'Start Restore',
                        icon: 'restore',
                        function: vm.initBackupRestore,
                        disable: !vm.backupCapabilityObject.available
                    },
                    {
                        name: 'Remove',
                        icon: 'delete',
                        function: function (event, item) {
                            vm.backupDelete(event, [item]);
                        }
                    }
                ];

                vm.refreshBackupList();
                vm.refreshProjectRetention();
            };

            /**
             * Get backup list
             * @returns {void}
             */
            vm.refreshBackupList = function () {
                vm.selectedFiles = [];
                vm.listPromise = Service.api.backupList({
                    projectId: vm.projectId,
                    deviceId: vm.deviceId,
                    limit: vm.itemsPagination.limit,
                    requestedPage: vm.itemsPagination.page - 1
                }).$promise;
                vm.listPromise
                    .then(function (data) {
                        vm.backupList = data.elements;
                        vm.totalItems = data.totalSize;
                        // Calc summary size
                        vm.summarySize = $filter('bytes')(vm.calcTotalSize(data.elements));
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Get Backup list failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error backupList:' + JSON.stringify(reason));
                    });
            };

            /**
             * Get backup retention policy for the current project
             * @returns {void}
             */
            vm.refreshProjectRetention = function () {
                Service.api.projectRetentionGet({
                    actionExt: vm.projectId
                }).$promise
                    .then(function (data) {
                        vm.latestBackupsToKeep = data.latestBackupsToKeep || 0;
                    });
            };

            /**
             * Open upload dialog
             * @param {Event} event - event object
             * @return {void}
             */
            vm.backupUploadDialog = function (event) {
                //create an isolated scope to pass to the component 
                var scope = angular.extend($scope.$new(true), {
                    module: vm.selectedModule
                });

                $mdDialog.show({
                    template: '<md-dialog style="max-width: 200px;"><md-dialog-content><backup-upload-dialog></backup-upload-dialog></md-dialog-content></md-dialog>',
                    parent: angular.element(document.body),
                    targetEvent: event,
                    clickOutsideToClose: false,
                    preserveScope: true,
                    scope: scope,
                    skipHide: true,
                })
                    .then(function () {
                        vm.refreshBackupList();
                    })
                    .then(function () {
                        Commons.toastShow('File uploaded');
                    });
            };

            /**
             * Remove file
             * @param {Event} event - event object
             * @param {Array} items - backup files list 
             * @return {void}
             */
            vm.backupDelete = function (event, items) {
                var deleteFn = function () {
                    var _payload = items.map(function (item) {
                        return {
                            backupType: item.backupType,
                            timestamp: item.timestamp
                        };
                    });
                    vm.isLoading = true;
                    Service.api.backupDeleteMultiple({
                        projectId: vm.projectId,
                        deviceId: vm.deviceId,
                    }, _payload).$promise
                        .then(function () {
                            var _resultMessage = items.length > 1 ? 'Files were removed' : 'File was removed';
                            Commons.toastShow(_resultMessage);
                            vm.refreshBackupList();
                        })
                        .catch(function (reason) {
                            console.log('backupDelete failure:' + JSON.stringify(reason));
                            var messageObject = Commons.createErrorObject(reason, 'Backup Delete action failure');
                            Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        })
                        .finally(function () {
                            vm.isLoading = false;
                        });
                };

                var _message = items.length > 1 ? 'Are you sure you want to remove selected files?' : 'Are you sure you want to remove file?';
                Commons.showConfirmationWarn(
                    gettextCatalog.getString('Remove Confirmation'),
                    gettextCatalog.getString(_message + '<br>Removed files cannot be restored.'),
                    gettextCatalog.getString('Remove'),
                    function () {
                        deleteFn();
                    },
                    gettextCatalog.getString('Cancel'),
                    undefined,
                    event);
            };

            /**
             * Download backup files
             * @param {Object} event - event object
             * @param {object} item - backup list object
             * @returns {void}
             */
            vm.backupDownload = function (event, item) {
                Service.api.backupDownloadLink({
                    projectId: item.projectId,
                    deviceId: item.deviceId,
                    backupType: item.backupType,
                    timestamp: item.timestamp
                }).$promise
                    .then(function (data) {
                        $window.open(data.link, '_blank');
                    })
                    .catch(function (reason) {
                        console.log('backupDelete failure:' + JSON.stringify(reason));
                        var messageObject = Commons.createErrorObject(reason, 'Backup download action failure');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                    });
            };

            /**
             * Initialize backup process
             * @param {Object} event - event object
             * @param {Object} item - backup list object
             * @returns {void}
             */
            vm.initBackupRestore = function (event, item) {
                vm.isLoading = true;
                Commons.toastShow('Restore started...');
                Service.api.backupRestoreInit({
                    projectId: item.projectId,
                    deviceId: item.deviceId
                }, item.objectName).$promise
                    .then(function () {
                        Commons.toastShow('Restore finished');
                    })
                    .catch(function (reason) {
                        console.log('Restore failure:' + JSON.stringify(reason));
                        var messageObject = Commons.createErrorObject(reason, 'Restore action failure');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                    })
                    .finally(function () {
                        vm.isLoading = false;
                    });
            };

            /**
             * Start backup process
             * @param {String} type - backup type
             * @return {void}
             */
            vm.initBackup = function () {
                vm.isLoading = true;
                Commons.toastShow('Backup started...');
                Service.api.backupInit({
                    projectId: vm.device.projectId,
                    deviceId: vm.device.deviceId,
                }).$promise
                    .then(function () {
                        Commons.toastShow('Backup finished');
                        vm.refreshBackupList();
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Backup action failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                    })
                    .finally(function () {
                        vm.isLoading = false;
                    });
            };

            /**
             * Calculate summary backup files size
             * @param {Array} backupList - list of backup files 
             * @returns {int} - summary backup files size
             */
            vm.calcTotalSize = function (backupList) {
                if (!angular.isArray(backupList)) {
                    return 0;
                }
                return backupList.reduce(function (acc, currentValue) {
                    return acc + currentValue.objectSize;
                }, 0);
            };

            /**
             * Update pagination object and run list refresh
             * @param {Object} paginationObject - pagination object
             * @return {void}
             */
            vm.paginationHandler = function (paginationObject) {
                vm.itemsPagination = paginationObject;
                vm.refreshBackupList();
            };

            /**
             * Select device handler
             * @param {Array} items - device list
             * @returns {void}
             */
            vm.checkSelection = function (items) {
                vm.selectedFiles = angular.copy(items);
            };

            /**
             * Change selection mode: single/multiple
             * @returns {void}
             */
            vm.toggleSelectMode = function () {
                vm.listSetup.rowSelection = !vm.listSetup.rowSelection;
                vm.listSetup.multipleSelection = !vm.listSetup.multipleSelection;
                vm.selectedFiles = [];
            };
        }
    });

'use strict';

/**
 * @ngdoc component
 * @name loopUiApp.component:backupUploadDialog
 * @description
 * # deviceDialog
 */

angular.module('loopUiApp')
    .component('backupUploadDialog', {
        templateUrl: '../scripts/components/device/deviceBackup/backupUploadDialog.html',
        controller: function ($mdDialog, $stateParams, $http, Service, Commons) {
            var vm = this;
            //Selected files array
            vm.files = [];
            //Backup type list
            vm.backupTypeList = [
                { name: 'MASTER', icon: 'cloud_upload' },
                { name: 'FLOWS', icon: 'device_hub' }
            ];

            vm.$onInit = function () {
                vm.projectId = $stateParams.projectId;
                vm.deviceId = $stateParams.deviceId;
            };

            /**
             * Upload artifact
             * @return {void}
             */
            vm.uploadContent = function () {
                Commons.toastShow('Uploading start...');

                //Get upload pre-sign link
                Service.api.backupUploadLink({
                    projectId: vm.projectId,
                    deviceId: vm.deviceId,
                    backupType: vm.backupType.name
                }).$promise
                    .then(function (data) {
                        var file = vm.files[0];
                        //Upload file to pre-sign link
                        $http.put(data.link, file, {
                            _isTemplate: true, // Disable Auth Interceptor
                            headers: { 'Content-Type': file.type },
                            transformRequest: angular.identity
                        })
                            .success(function () {
                                vm.hide();
                            })
                            .error(function (reason) {
                                var messageObject = Commons.createErrorObject(reason, 'Upload failed');
                                Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                                console.log('Backup upload failure:' + JSON.stringify(reason));
                            });
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Generate upload link failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error backupUploadLink:' + JSON.stringify(reason));
                    });
            };

            /**
            * Close dialog windows
            * @return {undefined}
            */
            vm.hide = function () {
                $mdDialog.hide();
            };

            /**
             * Cancel dialog button
             * @return {undefined}
             */
            vm.cancel = function () {
                $mdDialog.cancel();
            };
        }
    });
'use strict';

/**
 * @ngdoc component
 * @name loopUiApp.component:childDevices
 * @description
 * # childDevices
 */
angular.module('loopUiApp')
    .component('childDevices', {
        templateUrl: '../scripts/components/device/childDevices/childDevices.html',
        bindings: {
            devices: '<',
            listPromise: '<',
            parentDeviceId: '<',
            metricsObject: '<',
            onUpdate: '&'
        },
        controller: function ($interval) {
            var vm = this;
            
            // Pagination settings
            vm.itemsPagination = {
                limit: 5,
                minLimit: 5,
                page: 1,
                limitOptions: [5, 10, 50, 100]
            };

            // Current order
            vm.order = null;

            // List of possible order options
            vm.orderMap = {
                'prettyName': 'PRETTY_NAME_ASC',
                '-prettyName': 'PRETTY_NAME_DESC',
                'description': 'DESCRIPTION_ASC',
                '-description': 'DESCRIPTION_DESC',
                'deviceTypeName': 'DH_DEVICE_TYPE_NAME_ASC',
                '-deviceTypeName': 'DH_DEVICE_TYPE_NAME_DESC',
                'online': 'ONLINE_ASC',
                '-online': 'ONLINE_DESC',
                'tagProcessedRate': 'TAGS_PROCESSED_RATE_ASC',
                '-tagProcessedRate': 'TAGS_PROCESSED_RATE_DESC',
                'tagFailedRate': 'TAGS_FAILED_RATE_ASC',
                '-tagFailedRate': 'TAGS_FAILED_RATE_DESC'
            };

            // Refresh child devices interval
            vm.refreshPeriod = 10000;

            vm.$onInit = function () {
                // Start pulling child devices information
                vm.refreshInterval = $interval(function () {
                    vm.changeHandler();
                }, vm.refreshPeriod);
                
            };

            vm.$onDestroy = function () {
                // Stop pulling child devices
                $interval.cancel(vm.refreshInterval);
            };

            /**
             * Handle pagination
             * @returns {void}
             */
            vm.changeHandler = function () {
                vm.onUpdate({
                    parentDeviceId: vm.parentDeviceId,
                    page: vm.itemsPagination.page,
                    limit: vm.itemsPagination.limit,
                    orderBy: vm.orderMap[vm.order]
                });
            };
        }
    });
'use strict';

/**
 * @ngdoc component
 * @name loopUiApp.component:deviceLog
 * @description
 * # deviceLog
 */
angular.module('loopUiApp')
    .component('deviceLog', {
        templateUrl: '../scripts/components/device/deviceLog.html',
        bindings: {
            device: '<'
        },
        controller: function ($stateParams, Service, Commons) {
            var vm = this;
            vm.events = [];
            vm.filter = '';

            vm.$onInit = function () {
                vm.projectId = $stateParams.projectId;
                vm.currentCommpanyName = $stateParams.companyName;

                // Query options
                vm.eventsQuery = {};
                vm.eventsQuery.startDate = new Date();
                vm.eventsQuery.endDate = new Date();
                vm.eventsQuery.type = null;

                vm.maxDate = new Date();

                /**
                 * Pagination settings
                 */
                vm.query = {
                    page: 1,
                    limit: 10,
                    limitOptions: [10, 50, 100]
                };

                vm.getEvents();
            };

            /**
             * Load events
             * @returns {void}
             */
            vm.getEvents = function () {
                vm.eventsPromise = Service.api.log({
                    actionExt: vm.currentCommpanyName,
                    from: vm.eventsQuery.startDate.setHours(0, 0, 0, 0),
                    to: vm.eventsQuery.endDate.setHours(23, 59, 59, 59),
                    context: 'device',
                    contextId: vm.device.deviceId,
                    projectId: vm.projectId,
                    filter: vm.filter,
                    requestedPage: (vm.query.page - 1),
                    limit: vm.query.limit
                }).$promise;
                vm.eventsPromise
                    .then(function (res) {
                        vm.totalSize = res.totalSize;
                        vm.events = res.elements;
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Get events failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error log:' + JSON.stringify(reason));
                    });
            };

            /**
             * Is data available after load
             * @return {boolean} - data exist flag
             */
            vm.showNoData = function () {
                return !vm.events || vm.events.length === 0 &&
                    !(vm.eventsPromise && vm.eventsPromise.$$state && vm.eventsPromise.$$state.status === 0);
            };
        }
    });
'use strict';
/**
 * @ngdoc component
 * @name loopUiApp.component:loopedgeDetails (DM)
 * @description
 * # loopedgeDetails
 */

angular.module('loopUiApp')
    .component('loopedgeDetails', {
        templateUrl: '../scripts/components/device/loopedgeDetails.html',
        bindings: {
            device: '<',
            deviceOnline: '<'
        },
        controller: function ($interval, $timeout, $filter, Service, ServiceChart, Commons) {
            var vm = this;

            vm.$onInit = function () {
                vm.loopEdgeData = {};

                // Device system time variables
                vm.currentTime = null;
                vm.uptimeMs = null;

                // Check capability for LWM2M feature
                vm.lwm2mCapabilityObject = Commons.checkFeatureCapability(vm.device.capabilities, 'LWM2M');

                //Maximum number of auto retry attempts
                vm.RETRY_ATTEMPTS = 3;

                //Autorefresh flag
                vm.autorefresh = false;
                //Update interval
                vm.refreshPeriod = 10000;
                vm.refreshOptions = [{ name: '5 second', value: 5000 }, { name: '10 seconds', value: 10000 }, { name: '30 seconds', value: 30000 }, { name: '60 seconds', value: 60000 }];

                //Read API data error count
                vm.errorCount = 0;

                //Get object data
                vm.refreshObjectData();

                // Refresh device system time
                vm.refreshDeviceTime();
                vm.refreshDeviceTimeInterval = $interval(function () {
                    vm.refreshDeviceTime();
                }, 10000);

                //CPU list settings
                vm.cpuListSetup = {
                    showIndex: false,
                    editable: false,
                    removable: false,
                    rowSelection: false,
                    limit: 10,
                    limitOptions: [10, 50, 100],
                    fields: [
                        {
                            name: 'Model',
                            column: 'modelName'
                        },
                        {
                            name: 'Cores #',
                            column: 'numCores'
                        },
                        {
                            name: 'Clock Speed',
                            column: 'clockMHz'
                        },
                        {
                            name: 'Vendor ID',
                            column: 'vendorID'
                        }
                    ]
                };

                //Network list generic table setup
                vm.networkListSetup = {
                    showIndex: false,
                    editable: false,
                    removable: false,
                    rowSelection: false,
                    limit: 10,
                    limitOptions: [10, 50, 100],
                    fields: [
                        {
                            name: 'Interface',
                            column: 'name'
                        },
                        {
                            name: 'MAC Address',
                            column: 'hwAddr'
                        },
                        {
                            name: 'IP Address',
                            column: 'address'
                        },
                        {
                            name: 'Address Family',
                            column: null
                        },
                        {
                            name: 'Type',
                            column: 'addrType'
                        }
                    ]
                };

                //Serial list table setup
                vm.serialListSetup = {
                    showIndex: false,
                    editable: false,
                    removable: false,
                    rowSelection: false,
                    limit: 10,
                    limitOptions: [10, 50, 100],
                    fields: [
                        {
                            name: 'Name',
                            column: 'name'
                        },
                        {
                            name: 'Model',
                            column: 'model'
                        },
                        {
                            name: 'Manufacturer',
                            column: 'manufacturer'
                        },
                        {
                            name: 'Serial #',
                            column: 'serialNumber'
                        },
                        {
                            name: 'Speed (Baudrate)',
                            column: 'baudRate'
                        }
                    ]
                };
            };

            /**
             * Component destroy handler
             * @returns {void}
             */
            vm.$onDestroy = function () {
                $interval.cancel(vm.refreshInterval);
                $interval.cancel(vm.refreshDeviceTimeInterval);
            };

            /**
             * Refresh custom object data
             * @returns {void}
             */
            vm.refreshObjectData = function () {
                vm.refreshDeviceData();
                vm.readDeviceDetails();
            };

            /**
             * Setup new interval then it changed
             * @returns {void}
             */
            vm.updateInterval = function () {
                if (vm.refreshInterval) {
                    $interval.cancel(vm.refreshInterval);
                    vm.refreshInterval = $interval(function () {
                        vm.refreshObjectData();
                    }, vm.refreshPeriod);
                }
            };

            /**
             * Autorefresh checkbox toggler
             * @returns {void}
             */
            vm.autoRefreshToggle = function () {
                if (vm.autorefresh) {
                    vm.refreshInterval = $interval(function () {
                        vm.refreshObjectData();
                    }, vm.refreshPeriod);
                } else {
                    $interval.cancel(vm.refreshInterval);
                }
            };

            /**
             * Check if loopedge object empty
             * @returns {Boolean} - is empty status
             */
            vm.isLoopEdgeDataEmpty = function () {
                return angular.equals({}, vm.loopEdgeData);
            };

            /**
             * Refresh device data
             * @return {void}
             */
            vm.refreshDeviceData = function () {
                Service.api.deviceGet({
                    action: vm.device.projectId,
                    actionExt: vm.device.deviceId
                }).$promise
                    .then(function (data) {
                        vm.device = data;
                        vm.statusClass = vm.deviceStatusClass(vm.device);
                    })
                    .catch(function (reason) {
                        console.log('Error deviceGet:' + JSON.stringify(reason));
                    });
            };

            /**
             * Read all resources value for object
             * @return {Promise} - read resource promise
             */
            vm.readDeviceDetails = function () {
                vm.isLoading = true;
                Service.api.deviceDetails({
                    projectId: vm.device.projectId,
                    deviceId: vm.device.deviceId
                }).$promise
                    .then(function (data) {
                        vm.isLoading = false;
                        // Data can be empty if device is offline and no details were saved
                        if (!data || !data.content) {
                            vm.loopEdgeData = {};
                            return;
                        }
                        var parsedData = Commons.jsonParseSafe(data.content);
                        vm.updatedTime = data.updatedOn;
                        vm.loopEdgeData = vm.transformData(parsedData.values);
                        vm.mapChartData(vm.loopEdgeData);
                        //Reset error count
                        vm.errorCount = 0;
                    })
                    .catch(function (reason) {
                        console.log('Error dmRead:' + JSON.stringify(reason));
                        vm.errorCount++;
                        if (vm.errorCount <= vm.RETRY_ATTEMPTS) {
                            vm.isLoading = true;
                            //Try to recall API
                            $timeout(function () {
                                vm.refreshObjectData();
                            }, 3000);
                        } else {
                            vm.isLoading = false;
                        }
                    });
            };

            /**
             * Transform object data to map by resource
             * @param {Array} resourceList - resource list
             * @return {Object} - map
             */
            vm.transformData = function (resourceList) {
                var result = {};
                if (!angular.isArray(resourceList)) {
                    return result;
                }
                resourceList.forEach(function (resource) {
                    var id = resource.resourceId;
                    result[id] = resource;
                    result[id].value = Commons.jsonParseSafe(result[id].value);
                });
                return result;
            };

            /**
             * Create chart data by device data
             * @param {Object} loopEdgeData - loop edge custom object
             * @returns {void}
             */
            vm.mapChartData = function (loopEdgeData) {
                vm.diskChartData = vm.createDiskChartDataObject(loopEdgeData[6].value);
                vm.memoryChartData = vm.createMemoryChartDataObject(loopEdgeData[5].value);
            };

            /**
             * Prepare Disk data object for chart
             * @param {Object} data - loopedge data object
             * @returns {Object} - chart object
             */
            vm.createDiskChartDataObject = function (data) {
                var _result = {
                    used: data.dataPartSizeKiB > 0 ? data.dataPartSizeKiB * 1024 : 0,
                    free: data.dataPartFreeKib > 0 ? data.dataPartFreeKib * 1024 : 0,
                };
                _result.total = _result.used + _result.free;
                _result.usedPercent = _result.total > 0 ? Math.round((_result.used / _result.total) * 100) : 0;
                return _result;
            };

            /**
             * Prepare Memory data object for chart
             * @param {Object} data - loopedge data object
             * @returns {Object} - chart object
             */
            vm.createMemoryChartDataObject = function (data) {
                var _result = {
                    used: data.memUsedKiB > 0 ? data.memUsedKiB * 1024 : 0,
                    free: data.memAvailableKiB > 0 ? data.memAvailableKiB * 1024 : 0,
                    total: data.memTotalKiB > 0 ? data.memTotalKiB * 1024 : 0
                };
                _result.usedPercent = _result.total > 0 ? Math.round((_result.used / _result.total) * 100) : 0;
                return _result;
            };

            /**
             * Return device status class object
             * @param {Object} device - device object
             * @return {Object} - status object
             */
            vm.deviceStatusClass = function (device) {
                if (device.status === 'ACTIVE' && device.online) {
                    return { class: 'active-icon', status: 'ONLINE', runtimeStatus: device.runtimeStatus };
                } else {
                    return { class: '', status: '', runtimeStatus: device.runtimeStatus };
                }
            };

            /**
             * Show device notification message
             * @returns {sting} - notification message
             */
            vm.getNotificationBarText = function () {
                var _message = 'Device is offline now. ';
                if (vm.updatedTime) {
                    _message += 'The device details were saved ' + $filter('humanInterval')(vm.updatedTime) + ' ago.';
                }
                return _message;
            };

            /**
             * Load device time
             * @returns {void}
             */
            vm.refreshDeviceTime = function () {
                if (!vm.deviceOnline) {
                    return;
                }
                Service.api.loopedgeDmTime({
                    projectId: vm.device.projectId,
                    deviceId: vm.device.deviceId
                }).$promise
                    .then(function (data) {
                        if (data && data.uptime) {
                            vm.currentTime = data.epoch * 1000;
                            vm.uptimeMs = data.uptime.raw * 1000;
                        }
                    })
                    .catch(function (reason) {
                        console.log('Error deviceTime:' + JSON.stringify(reason));
                    });
            };
        }
    });
'use strict';
/**
 * @ngdoc component
 * @name loopUiApp.component:loopedgeManage (DM)
 * @description
 * # loopedgeManage
 */

angular.module('loopUiApp')
    .component('loopedgeManage', {
        templateUrl: '../scripts/components/device/loopedgeManage.html',
        bindings: {
            device: '<',
            deviceOnline: '<',
            virtualizationType: '<'
        },
        controller: function ($state, $http, $stateParams, FileSaver, gettextCatalog, appConfig, Service, Commons) {
            var vm = this;
            // Device API key
            vm.apiKey = { value: null };
            vm.supportDeviceName = appConfig.supportDeviceName;
            // Loading polling settings for project level
            vm.isLoadingProjectSettings = false;
            // Loading polling settings for device level
            vm.isLoadingDeviceSettings = false;
            // Project level metrics settings
            vm.pollingSettingsProject = {};
            // Device level metrics settings
            vm.pollingSettingsDevice = {};

            vm.$onInit = function () {
                vm.projectId = $stateParams.projectId;
                vm.companyName = $stateParams.companyName;
                // Check capability for Services feature
                vm.servicesCapabilityObject = Commons.checkFeatureCapability(vm.device.capabilities, 'SERVICES');
                // Check capability for async Software feature
                vm.asyncSoftwareCapabilityObject = Commons.checkFeatureCapability(vm.device.capabilities, 'DM_V2_API');

                vm.serviceList = [];

                // Order service flag
                vm.serviceOrder = {
                    devicehub: 1,
                    flows: 2,
                    ssh: 3,
                    zerotier: 4,
                    bacnet: 5,
                };

                // List of subtabs
                vm.tabs = [
                    'services',
                    'metrics',
                    'api',
                    'software',
                    'reboot'
                ];
                var index = $stateParams.selectedSubtab ? vm.tabs.indexOf($stateParams.selectedSubtab) : 0;
                vm.selectedIndex = index >= 0 ? index : 0;

                vm.actionInProgress = {};

                // Do not refresh service list if it's not available
                if (vm.servicesCapabilityObject.available) {
                    vm.refreshServiceList();
                }

                // Load metrics settings: instance, project and device levels
                vm.refreshPollingProjectSettings();
                vm.refreshPollingDeviceSettings();
                
                vm.getApiKey();
            };

            /**
             * Reboot action
             * @param {Object} event - event object
             * @return {void}
             */
            vm.reboot = function (event) {
                Commons.showConfirmationWarn(
                    gettextCatalog.getString('Reboot Edge Device'),
                    gettextCatalog.getString('Are you sure you want to reboot device?'),
                    gettextCatalog.getString('Reboot'),
                    function () {
                        Service.api.deviceReboot({
                            projectId: vm.device.projectId,
                            deviceId: vm.device.deviceId
                        }).$promise
                            .then(function () {
                                Commons.toastShow('Reboot action performed');
                            })
                            .catch(function (reason) {
                                var messageObject = Commons.createErrorObject(reason, 'Reboot action failed');
                                Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                            });
                    }, gettextCatalog.getString('Cancel'), undefined, event);
            };

            /** 
             * Load service list
             * @returns {void}
             */
            vm.refreshServiceList = function () {
                // For offline device show mock service array
                if (!vm.deviceOnline) {
                    return;
                }
                vm.serviceListLoading = true;
                Service.api.loopedgeDmServiceList({
                    projectId: vm.device.projectId,
                    deviceId: vm.device.deviceId
                }).$promise
                    .then(function (data) {
                        vm.serviceList = data;
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Get Service list failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                    })
                    .finally(function () {
                        vm.serviceListLoading = false;
                    });
            };

            /**
             * Send action command to the service
             * @param {string} serviceName - service name
             * @param {string} action - action name
             * @returns {void}
             */
            vm.serviceAction = function (serviceName, action) {
                vm.actionInProgress[serviceName] = true;
                Service.api.loopedgeDmServiceAction({
                    action: action,
                    name: serviceName,
                    projectId: vm.device.projectId,
                    deviceId: vm.device.deviceId
                }).$promise
                    .then(function () {
                        vm.refreshServiceList();
                        var message = '';
                        switch (action) {
                        case 'start':
                            message = 'Service ' + serviceName + ' started';
                            break;
                        case 'stop':
                            message = 'Service ' + serviceName + ' stopped';
                            break;
                        case 'reboot':
                            message = 'Service ' + serviceName + ' restarted';
                            break;
                        default:
                            break;
                        }
                        Commons.toastShow(message);
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Service action failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                    })
                    .finally(function () {
                        vm.actionInProgress[serviceName] = false;
                    });
            };

            /**
             * Return service order in service list
             * @param {Object} service - service object
             * @return {Number} - service order number
             */
            vm.getServiceOrder = function (service) {
                return vm.serviceOrder[service.name] || 99;
            };

            /**
             * Check if action is allowed
             * @param {string} code - service code
             * @returns {boolean} - allowed flag
             */
            vm.isActionActive = function (code) {
                return !vm.deviceOnline || vm.actionInProgress[code];
            };

            /**
             * Change Edge device metrics sync settings
             * @param {Object} settings - metrics settings object
             * @returns {void}
             */
            vm.edgePollingSettingsSave = function (settings) {
                vm.isPollingSettingsSaving = true;
                Service.api.deviceEdgePollingSettings({
                    actionExt: vm.device.deviceId
                }, settings).$promise
                    .then(function () {
                        Commons.toastShow('Sync settings saved');
                        if (settings.useProjectSettings === true) {
                            vm.refreshPollingDeviceSettings();
                        }
                    })
                    .catch(function (reason) {
                        console.log('Error deviceEdgePollingSettings:' + JSON.stringify(reason));
                        var messageObject = Commons.createErrorObject(reason, 'Failed to save sync settings');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                    })
                    .finally(function () {
                        vm.isPollingSettingsSaving = false;
                    });
            };

            /**
             * Get edge device metrics sync settings for the current project
             * @returns {void}
             */
            vm.refreshPollingProjectSettings = function () {
                vm.isLoadingProjectSettings = true;
                Service.api.projectEdgePollingSettingsGet({
                    actionExt: vm.device.projectId
                }).$promise
                    .then(function (data) {
                        vm.pollingSettingsProject = data;
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Failed to get sync settings for the project');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error projectEdgePollingSettingsGet:' + JSON.stringify(reason));
                    })
                    .finally(function () {
                        vm.isLoadingProjectSettings = false;
                    });
            };

            /**
             * Load edge device metrics sync settings for current device
             */
            vm.refreshPollingDeviceSettings = function () {
                vm.isLoadingDeviceSettings = true;
                Service.api.deviceEdgePollingSettingsGet({
                    actionExt: vm.device.deviceId,
                }).$promise
                    .then(function (data) {
                        vm.pollingSettingsDevice = data;
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Failed to get sync settings for the edge device');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error deviceEdgePollingSettingsGet:' + JSON.stringify(reason));
                    })
                    .finally(function () {
                        vm.isLoadingDeviceSettings = false;
                    });
            };

            /**
             * Get device API key
             * @returns {void}
             */
            vm.getApiKey = function () {
                vm.isApiKeyLoading = true;
                Service.api.deviceApiKeyGet({
                    actionExt: vm.device.projectId,
                    deviceId: vm.device.deviceId
                }).$promise
                    .then(function (data) {
                        vm.apiKeyMasked = data.value;
                    })
                    .catch(function (reason) {
                        console.log('Error deviceApiKeyGet:' + JSON.stringify(reason));
                    })
                    .finally(function () {
                        vm.isApiKeyLoading = false;
                    });
            };

            /**
             * Save device API key
             * @returns {void}
             */
            vm.saveApiKey = function () {
                vm.isApiKeyLoading = true;
                Service.api.deviceApiKey({
                    actionExt: vm.device.projectId,
                    deviceId: vm.device.deviceId
                }, vm.apiKey
                ).$promise
                    .then(function () {
                        Commons.toastShow('API token saved');
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Failed to get API token');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                    })
                    .finally(function () {
                        vm.isApiKeyLoading = false;
                    });
            };

            /**
             * Updates the URL on tab change to persist currently selected tab
             * @param {string} selectedIndex - name (state) of the selected tab
             * @returns {void}
             */
            vm.changeTab = function (selectedIndex) {
                $state.go('.', { selectedSubtab: vm.tabs[selectedIndex] }, { location: 'replace' });
            };

            /**
             * Download support bundle
             * @return {void}
             */
            vm.downloadSupportBundle = function () {
                var req = {
                    url: appConfig.apiUrl + 'api/v' + appConfig.apiVersion +
                        '/loopedge-dm/supportbundle/generate?deviceId=' + vm.device.deviceId + '&projectId=' + vm.device.projectId,
                    method: 'GET',
                    responseType: 'arraybuffer'
                };

                vm.isBundleDownloading = true;
                $http(req)
                    .then(function (resp) {
                        var headers = resp.headers();
                        var type = headers['content-type'];
                        var filename = headers['content-disposition'] ? headers['content-disposition'].split("filename=")[1] : 'support-bundle.zip';
                        var serverData = new Blob([resp.data], { type: type });
                        FileSaver.saveAs(serverData, filename);
                    })
                    .catch(function (reason) {
                        if (reason.data instanceof ArrayBuffer) {
                            // As we have response as ArrayBuffer, we need to decode error response as well
                            var decodedData = new TextDecoder('utf-8').decode(new Uint8Array(reason.data));
                            try {
                                // Change reason.data with decoded version
                                reason.data = JSON.parse(decodedData);

                            } catch (e) {
                                console.log('Error:', decodedData);  // If not JSON, handle as plain text
                            }
                        }
                        var messageObject = Commons.createErrorObject(reason, 'Support bundle download failure');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Support bundle download failure:' + JSON.stringify(reason));
                    })
                    .finally(function () {
                        vm.isBundleDownloading = false;
                    });
            };
        }
    });
'use strict';
/**
 * @ngdoc component
 * @name loopUiApp.component:softwareUpdates
 * @description
 * # softwareUpdates
 */

angular.module('loopUiApp')
    .component('softwareUpdates', {
        templateUrl: '../scripts/components/device/softwareUpdates.html',
        bindings: {
            device: '<'
        },
        controller: function ($scope, $filter, $mdDialog, gettextCatalog, ServiceAsyncTask, Service, Commons) {
            var vm = this;
            // List of updated uploaded to the device
            vm.firmwareUpgradeList = [];

            vm.$onInit = function () {
                vm.listSetup = {
                    sortField: '-version',
                    showIndex: false,
                    editable: false,
                    removable: false,
                    serverPagination: true,
                    limit: 10,
                    limitOptions: [10, 50, 100],
                    fields: [
                        {
                            name: 'File Name',
                            column: 'filename',
                        },
                        {
                            name: 'Version',
                            column: 'version',
                            transformation: function (item) {
                                return item.version ? item.version : 'N/A';
                            }
                        },
                        {
                            name: 'Size',
                            column: 'size',
                            transformation: function (item) {
                                return item.size ? $filter('bytes')(item.size) : 'N/A';
                            }
                        }
                    ]
                };

                vm.cardActions = [
                    {
                        name: 'Reload',
                        icon: 'refresh',
                        buttonClick: vm.refreshList
                    }
                ];

                vm.listActions = [
                    {
                        name: 'Update',
                        icon: 'update',
                        function: vm.runUpdate
                    },
                    {
                        name: 'Delete',
                        icon: 'delete',
                        function: vm.delete
                    }
                ];

                vm.refreshList();
            };

            /**
             * Refresh the list of firmware updates
             * @return {void}
             */
            vm.refreshList = function () {
                vm.listPromise = Service.api.firmwareUpgradeList({
                    actionExt: vm.device.projectId,
                    deviceId: vm.device.deviceId
                }).$promise;

                vm.listPromise
                    .then(function (data) {
                        vm.firmwareUpgradeList = data;
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Get firmware list failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error firmwareUpgradeList:' + JSON.stringify(reason));
                    });
            };

            /**
             * Confirm and start update
             * @param {Object} file - file object
             * @returns {void}
             */
            vm.runUpdate = function (event, file) {
                var _runUpdateFn = function () {
                    var _currentDeviceVersion = Commons.getObjectProperty(['properties', 'Firmware Version', 'value'], vm.device);
                    ServiceAsyncTask.createTask(
                        ServiceAsyncTask.taskTypes.FIRMWARE_UPGRADE.code,
                        [ServiceAsyncTask.taskTypes.FIRMWARE_UPGRADE_EXECUTE.code],
                        '',
                        [vm.device],
                        {
                            versionName: file.filename,
                            fwFileName: file.filename,
                            deviceVersion: _currentDeviceVersion,
                            newDeviceVersion: file.version,
                            allowDelayedUpgrade: true
                        },
                        true,
                        undefined,
                        1
                    )
                        .then(function () {
                            Commons.toastShow('Task was created');
                        })
                        .catch(function (reason) {
                            var messageObject = Commons.createErrorObject(reason, 'Create task failed');
                            Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                            console.log('Error createTask:' + JSON.stringify(reason));
                        });
                };

                var scope = angular.extend($scope.$new(true), {
                    file: file,
                    device: vm.device,
                });

                $mdDialog.show({
                    template: '<md-dialog style="width:700px;" aria-label="Update Confirmation"><software-updates-confirmation-dialog file="file" device="device"></software-updates-confirmation-dialog></md-dialog>',
                    parent: angular.element(document.body),
                    targetEvent: event,
                    clickOutsideToClose: false,
                    scope: scope,
                    preserveScope: true,
                    skipHide: true
                })
                    .then(function () {
                        _runUpdateFn();
                    });
            };

            /**
             * Delete upgrade file from the device
             * @param {Object} file - file object 
             */
            vm.delete = function (event, file) {
                var _deleteFn = function () {
                    Service.api.firmwareUpgradeDelete({
                        actionExt: vm.device.projectId,
                        deviceId: vm.device.deviceId,
                        fileName: file.filename
                    }).$promise
                        .then(function () {
                            vm.refreshList();
                        })
                        .catch(function (reason) {
                            var messageObject = Commons.createErrorObject(reason, 'Delete firmware failed');
                            Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                            console.log('Error firmwareUpgradeDelete:' + JSON.stringify(reason));
                        });
                };
                Commons.showConfirmationWarn(
                    gettextCatalog.getString('Remove Update File'),
                    gettextCatalog.getString('Are you sure you want to remove the downloaded software update?'),
                    gettextCatalog.getString('Yes, Remove'),
                    _deleteFn,
                    gettextCatalog.getString('Cancel'),
                    null,
                    event);
            };
        }
    });
'use strict';
/**
 * @ngdoc component
 * @name loopUiApp.component:softwareUpdatesConfirmationDialog
 * @description
 * # softwareUpdatesConfirmationDialog
 */

angular.module('loopUiApp')
    .component('softwareUpdatesConfirmationDialog', {
        templateUrl: '../scripts/components/device/softwareUpdatesConfirmationDialog.html',
        bindings: {
            file: '<',
            device: '<'
        },
        controller: function ($mdDialog, Service, Commons) {
            var vm = this;

            /**
             * Start backup process
             * @param {String} type - backup type
             * @return {void}
             */
            vm.initBackup = function () {
                vm.isLoading = true;
                Commons.toastShow('Backup started...');
                Service.api.backupInit({
                    projectId: vm.device.projectId,
                    deviceId: vm.device.deviceId,
                }).$promise
                    .then(function () {
                        Commons.toastShow('Backup finished');
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Backup action failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                    })
                    .finally(function () {
                        vm.isLoading = false;
                    });
            };

            /**
             * Confirm update
             * @returns {void}
             */
            vm.update = function () {
                $mdDialog.hide();
            };

            /**
             * Close dialog with no action
             * @return {void}
             */
            vm.cancel = function () {
                $mdDialog.cancel();
            };
        }
    });
'use strict';

/**
 * @ngdoc component
 * @name loopUiApp.component:deviceView
 * @description
 * # deviceDialog
 */

angular.module('loopUiApp')
    .component('devicePropertiesDialog', {
        templateUrl: '../scripts/components/device/devicePropertiesDialog.html',
        controller: function ($mdDialog, $stateParams, appConfig, Service) {
            var vm = this;

            vm.$onInit = function () {
                //Current project
                vm.projectId = $stateParams.projectId;
            
                //default to this cords
                vm.defaultCords = { lat: 37.374, lng: -121.919 };
                //Coordinates for map
                vm.cords = angular.copy(vm.defaultCords);
                vm.cords.default = true;

                //status options
                vm.statuses = [{ name: 'Active', value: 'ACTIVE' }, { name: 'Delete', value: 'DELETED' }, { name: 'Maintenance', value: 'MAINTENANCE' }, { name: 'Block', value: 'BLOCKED' }];
                //model
                vm.device = {
                    properties: {
                        Latitude: '',
                        Longitude: '',
                    },
                    description: '',
                    tag: []
                };

                vm.refreshTagList();
            };
            /**
             * Change location after 
             */
            vm.placeChanged = function () {
                vm.place = this.getPlace();
                var lat, lng;
                try {
                    vm.map.setCenter(vm.place.geometry.location);
                    lat = vm.place.geometry.location.lat();
                    lng = vm.place.geometry.location.lng();
                    vm.cords = {
                        lat: lat,
                        lng: lng
                    };
                    vm.cords.default = false;
                }
                catch (e) {
                    console.log(e);
                    vm.cords = vm.defaultCords;
                }
            };

            /**
            * Close dialog windows
            * @return {undefined}
            */
            vm.hide = function (device) {
                //set coordinates if they are not the default ones 
                if (!angular.equals(vm.cords, vm.defaultCords)) {
                    device.properties.Latitude = vm.cords.lat;
                    device.properties.Longitude = vm.cords.lng;
                }
                if (vm.files && vm.files.length > 0) {
                    var formData = new FormData();
                    angular.forEach(vm.files, function (data) {
                        formData.append('file', data);
                    });
                    device.imageData = formData;
                }
                $mdDialog.hide(device);
            };
            /**
             * Cancel dialog button
             * @return {undefined}
             */
            vm.cancel = function () {
                $mdDialog.cancel();
            };

            /**
             * get location of cursor
             *
             */
            vm.getCurrentLocation = function (event) {
                var positon = event.latLng;
                var lat = positon.lat();
                var lng = positon.lng();
                vm.map.setCenter(positon);
                vm.cords = {
                    lat: lat,
                    lng: lng,
                    default: false
                };
            };

            /**
            * clear address and coordinates  
            */
            vm.clearCords = function () {
                vm.showMap = false;
                vm.cords = angular.copy(vm.defaultCords);
                vm.cords.default = true;
                vm.address = '';
            };

            /**
             * Load Tag list
             * @returns {void}
             */
            vm.refreshTagList = function () {
                Service.api.deviceTagList({
                    projectId: vm.projectId
                }).$promise
                    .then(function (data) {
                        vm.tagList = data;
                    })
                    .catch(function () {
                        vm.tagList = [];
                    });
            };

            /**
             * List of existing tags
             * @param {strint} criteria - search criteria 
             * @return {array} - result
             */
            vm.tagQuerySearch = function (criteria) {
                return criteria ? vm.tagList.filter(vm.createFilterFor(criteria)) : vm.tagList;
            };

            /**
             * Create filter function for a query string
             * @param {string} query - search string
             * @return {function} filter function
             */
            vm.createFilterFor = function (query) {
                var lowercaseQuery = query.toLowerCase();

                return function filterFn(tag) {
                    return (tag.toLowerCase().indexOf(lowercaseQuery) !== -1);
                };
            };

        }
    });

'use strict';

/**
 * @ngdoc component
 * @name loopUiApp.component:groupActionsView
 * @description
 * # 
 */

angular.module('loopUiApp')
    .component('groupActionsView', {
        templateUrl: '../scripts/components/device/groupActionsView.html',
        bindings: {
            result: '<',
            resultListSize: '<'
        },
        controller: function () {
            var vm = this;

            vm.pagination = {
                limit: 10,
                page: 1,
                limitOptions: [5, 10, 100]
            };
        }
    });
'use strict';

/**
 * @ngdoc component
 * @name loopUiApp.component:devicesServiceManage
 * @description
 * # devicesServiceManage
 */
angular.module('loopUiApp')
    .component('devicesServiceManage', {
        templateUrl: '../scripts/components/device/devicesServiceManage.html',
        bindings: {
            devices: '<'
        },
        controller: function ($q, $mdDialog, Service, Commons) {
            var vm = this;
            vm.actionInProgress = {};

            vm.$onInit = function () {
                vm.onlineCount = vm.filterOnlineDevices(vm.devices).length;

                // Group actions result
                vm.result = {};
                vm.resultListSize = 0;
                // Map object to get service name
                vm.serviceMap = {
                    'ssh': {
                        name: 'SSH Service',
                        description: '',
                        restartable: false
                    }
                };

                // Service action list
                vm.actionList = [{
                    name: 'start',
                    description: 'Start service',
                    icon: 'play_arrow',
                    function: function (deviceList, serviceName) {
                        vm.serviceAction(deviceList, serviceName, 'start');
                    }
                },
                {
                    name: 'stop',
                    description: 'Stop service',
                    icon: 'stop',
                    function: function (deviceList, serviceName) {
                        vm.serviceAction(deviceList, serviceName, 'stop');
                    }
                },
                {
                    name: 'restart',
                    description: 'Restart service',
                    icon: 'update',
                    function: function (deviceList, serviceName) {
                        vm.serviceAction(deviceList, serviceName, 'restart');
                    }
                }];
            };

            /**
             * Change status
             * @param {Array} deviceList - device objects list
             * @param {string} serviceName - service name
             * @param {string} action - service action name [start, stop, restart]
             * @returns {void}
             */
            vm.serviceAction = function (deviceList, serviceName, action) {
                if (deviceList.length === 0) {
                    return;
                }
                vm.actionInProgress[serviceName] = true;
                vm.result = {};
                vm.resultListSize = 0;
                var _errorList = [];
                var _promiseList = vm.filterOnlineDevices(deviceList).map(function (device) {
                    return $q(function (resolve) {
                        Service.api.loopedgeDmServiceAction({
                            action: action,
                            name: serviceName,
                            projectId: device.projectId,
                            deviceId: device.deviceId
                        }).$promise
                            .then(function () {
                                resolve({
                                    device: device,
                                    status: action,
                                    error: null
                                });
                            })
                            .catch(function (error) {
                                resolve({
                                    device: device,
                                    status: action,
                                    error: error
                                });
                            });
                    });
                });

                $q.all(_promiseList)
                    .then(function (result) {
                        vm.result = result;
                        vm.resultListSize = Object.keys(result).length;
                        _errorList = vm.errorHandler(result);
                        if (_errorList.length > 0) {
                            vm.runningStatusText = 'Actions failed. Check tab \'Result\'';
                        }
                        else {
                            vm.runningStatusText = 'Action "' + action.toUpperCase() + '" completed successfully';
                        }
                        Commons.toastShow(vm.runningStatusText, 5000);
                    })
                    .finally(function () {
                        vm.actionInProgress[serviceName] = false;
                    });
            };

            /**
             * Create form resolved error object list of errors
             * @param {Object} resultList - resolved list from promise array response
             * @returns {Array} - new error list
             */
            vm.errorHandler = function (resultList) {
                return resultList.filter(function (result) {
                    return !!result.error;
                });
            };

            /**
             * Filter only online devices
             * @param {Array} devices - selected device list
             * @return {Array} online device list
             */
            vm.filterOnlineDevices = function (devices) {
                return devices.filter(function (device) {
                    return device.online;
                });
            };

            /**
             * Check if service action available for current service
             * @param {Object} service - service object
             * @param {Object} action - action object
             * @returns {boolean} is action available
             */
            vm.isActionAvailable = function (service, action) {
                return (action.name === 'restart' && service.restartable) ||
                    (action.name !== 'restart' && !service.restartable);
            };

            /**
             * Hides the dialog
             * @returns {void}
             */
            vm.hide = function () {
                $mdDialog.hide();
            };
        }
    });
'use strict';

/**
 * @ngdoc component
 * @name loopUiApp.component:devicesBackup
 * @description
 * # devicesBackup
 */
angular.module('loopUiApp')
    .component('devicesBackup', {
        templateUrl: '../scripts/components/device/devicesBackup.html',
        bindings: {
            devices: '<'
        },
        controller: function ($stateParams, $mdDialog, ServiceAsyncTask, Service, Commons) {
            var vm = this;

            vm.$onInit = function () {
                vm.onlineCount = vm.filterOnlineDevices(vm.devices).length;

                // Group actions result
                vm.result = {};
                vm.resultListSize = 0;

                // Backup action list
                vm.actionList = [{
                    name: 'start',
                    description: 'Run backup',
                    icon: 'play_arrow',
                    function: function(deviceList) {
                        var _onlineDeviceList = vm.filterOnlineDevices(deviceList);
                        vm.action(_onlineDeviceList);
                    }
                }];
            };

            /**
             * Run backup action for online devices
             * @param {Array} deviceList - list of online Edge devices
             */
            vm.action = function (deviceList) {
                vm.actionInProgress = true;

                vm.result = vm.initResultList(deviceList);

                ServiceAsyncTask.createTaskAndWait(
                    ServiceAsyncTask.taskTypes.EDGE_BACKUP_CREATE.code, // Task type
                    ServiceAsyncTask.taskTypes.EDGE_BACKUP_CREATE.subtaskTypes, // Subtask types
                    '',                     // Task description 
                    deviceList,             // Device list for run backup
                    {},                     // Task params
                    false                   // Wait device for online
                )
                    .then(function (task) {
                        if (!task || !task.id) {
                            return;
                        }
                        // Get subtasks for current task
                        return Service.api.asyncSubtaskList({
                            action: task.id
                        }).$promise;
                    })
                    .then(function (data) {
                        // If no subtasks, then show error
                        if (!data || !data.length) {
                            vm.result = vm.initResultList(deviceList, 'Edge Device backup failed');
                            vm.resultListSize = Object.keys(vm.result).length;
                            return;
                        }
                        // Get backup results from subtasks
                        vm.result = data.reduce(function (acc, cur) {
                            acc[cur.deviceId] = {
                                device: {
                                    deviceId: cur.deviceId,
                                    prettyName: cur.devicePrettyName
                                },
                                error: cur.status === 'ERROR' ? { data: { message: cur.msg } } : null
                            };
                            return acc;
                        }, {});
                        vm.resultListSize = Object.keys(vm.result).length;
                    })
                    .catch(function (reason) {
                        if (!reason) { // If not reason provided, then task was canceled
                            return;
                        }
                        console.log('Async task EDGE_BACKUP_CREATE failure:' + JSON.stringify(reason));
                        var messageObject = Commons.createErrorObject(reason, 'Edge Device backup failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                    })
                    .finally(function () {
                        vm.actionInProgress = false;
                    });
            };

            /**
             * Init launch result list
             * @param {Array} deviceList - selected device list for launch 
             * @param {String} error - state message 
             * @returns {Array} empty launch list
             */
            vm.initResultList = function (deviceList, error) {
                if (!deviceList || !angular.isArray(deviceList)) {
                    return [];
                }
                return deviceList.reduce(function (acc, cur) {
                    acc[cur.deviceId] = {
                        device: cur,
                        error: error,
                    };
                    return acc;
                }, {});
            };

            /**
             * Filter only online devices
             * @param {Array} devices - selected device list
             * @return {Array} online device list
             */
            vm.filterOnlineDevices = function (devices) {
                return devices.filter(function (device) {
                    return device.online;
                });
            };

            /**
             * Hides the dialog
             * @returns {void}
             */
            vm.hide = function () {
                $mdDialog.hide();
            };
        }
    });
'use strict';

/**
 * @ngdoc component
 * @name loopUiApp.component:devicesForwardingManage
 * @description
 * # devicesForwardingManage
 */
angular.module('loopUiApp')
    .component('devicesForwardingManage', {
        templateUrl: '../scripts/components/device/devicesForwardingManage.html',
        bindings: {
            devices: '<'
        },
        controller: function ($q, $mdDialog, Service, Commons) {
            var vm = this;

            vm.$onInit = function () {
                vm.onlineCount = vm.filterOnlineDevices(vm.devices).length;

                // Group actions result
                vm.result = {};
                vm.resultListSize = 0;

                // Service action list
                vm.actionList = [{
                    name: 'start',
                    description: 'Enable Forwarding',
                    icon: 'play_arrow',
                    function: function (deviceList) {
                        vm.action(deviceList, true);
                    }
                },
                {
                    name: 'stop',
                    description: 'Disable Forwarding',
                    icon: 'stop',
                    function: function (deviceList) {
                        vm.action(deviceList, false);
                    }
                }];
            };


            /**
             * Change forwarding status
             * @param {Array} deviceList - device objects list
             * @param {boolean} status - status enable/disable
             * @returns {void}
             */
            vm.action = function (deviceList, status) {
                if (deviceList.length === 0) {
                    return;
                }
                vm.actionInProgress = true;
                vm.result = {};
                vm.resultListSize = 0;
                var _errorList = [];
                var _promiseList = vm.filterOnlineDevices(deviceList) // Send only online devices
                    .map(function (device) {
                        return $q(function (resolve) {
                            Service.api.eventForwarding({
                                projectId: device.projectId,
                                deviceId: device.deviceId,
                                enabled: status
                            }).$promise
                                .then(function () {
                                    resolve({
                                        device: device,
                                        status: status,
                                        error: null
                                    });
                                })
                                .catch(function (error) {
                                    resolve({
                                        device: device,
                                        status: status,
                                        error: error
                                    });
                                });
                        });
                    });

                $q.all(_promiseList)
                    .then(function (result) {
                        vm.result = result;
                        vm.resultListSize = Object.keys(result).length;
                        _errorList = vm.errorHandler(result);
                        if (_errorList.length > 0) {
                            vm.runningStatusText = 'Actions failed. Check tab \'Result\'';
                        }
                        else {
                            vm.runningStatusText = 'Forwarding status changed';
                        }
                        Commons.toastShow(vm.runningStatusText);
                    })
                    .finally(function () {
                        vm.actionInProgress = false;
                    });
            };

            /**
             * Create form resolved error object list of errors
             * @param {Object} resultList - resolved list from promise array response
             * @returns {Array} - new error list
             */
            vm.errorHandler = function (resultList) {
                return resultList.filter(function (result) {
                    return !!result.error;
                });
            };

            /**
             * Filter only online devices
             * @param {Array} devices - selected device list
             * @return {Array} online device list
             */
            vm.filterOnlineDevices = function (devices) {
                return devices.filter(function (device) {
                    return device.online;
                });
            };

            /**
             * Hides the dialog
             * @returns {void}
             */
            vm.hide = function () {
                $mdDialog.hide();
            };

        }
    });
'use strict';

/**
 * @ngdoc component
 * @name loopUiApp.component:devicesPollingSettings
 * @description
 * # devicesPollingSettings
 */
angular.module('loopUiApp')
    .component('devicesPollingSettings', {
        templateUrl: '../scripts/components/device/devicesPollingSettings.html',
        bindings: {
            devices: '<'
        },
        controller: function ($stateParams, $q, $mdDialog, Service, Commons) {
            var vm = this;
            vm.isLoadingProjectSettings = false;
            vm.pollingSettingsProject = {};

            vm.$onInit = function () {
                vm.projectId = $stateParams.projectId;
                // Group actions result
                vm.result = {};
                vm.resultListSize = 0;

                vm.refreshPollingProjectSettings();
            };

            /**
             * Get metrics settings for current project
             * @returns {void}
             */
            vm.refreshPollingProjectSettings = function () {
                vm.isLoadingProjectSettings = true;
                Service.api.projectEdgePollingSettingsGet({
                    actionExt: vm.projectId
                }).$promise
                    .then(function (data) {
                        vm.pollingSettingsProject = data;
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Get metrics settings failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error projectEdgePollingSettingsGet:' + JSON.stringify(reason));
                    })
                    .finally(function () {
                        vm.isLoadingProjectSettings = false;
                    });
            };


            /**
             * Change polling settings
             * @param {boolean} status - status enable/disable
             * @returns {void}
             */
            vm.action = function (settings) {
                if (vm.devices.length === 0) {
                    return;
                }
                vm.actionInProgress = true;
                vm.result = {};
                vm.resultListSize = 0;
                var _errorList = [];
                var _promiseList = vm.devices
                    .map(function (device) {
                        return $q(function (resolve) {
                            Service.api.deviceEdgePollingSettings({
                                actionExt: device.deviceId
                            }, settings).$promise
                                .then(function () {
                                    resolve({
                                        device: device,
                                        status: status,
                                        error: null
                                    });
                                })
                                .catch(function (error) {
                                    resolve({
                                        device: device,
                                        status: status,
                                        error: error
                                    });
                                });
                        });
                    });

                $q.all(_promiseList)
                    .then(function (result) {
                        vm.result = result;
                        vm.resultListSize = Object.keys(result).length;
                        _errorList = vm.errorHandler(result);
                        if (_errorList.length > 0) {
                            vm.runningStatusText = 'Actions failed. Check tab \'Result\'';
                        }
                        else {
                            vm.runningStatusText = 'Sync settings saved';
                        }
                        Commons.toastShow(vm.runningStatusText, 5000);
                    })
                    .finally(function () {
                        vm.actionInProgress = false;
                    });
            };

            /**
             * Create form resolved error object list of errors
             * @param {Object} resultList - resolved list from promise array response
             * @returns {Array} - new error list
             */
            vm.errorHandler = function (resultList) {
                return resultList.filter(function (result) {
                    return !!result.error;
                });
            };

            /**
             * Hides the dialog
             * @returns {void}
             */
            vm.hide = function () {
                $mdDialog.hide();
            };

        }
    });
'use strict';
/**
 * @ngdoc component
 * @name loopUiApp.component:deviceFilter
 * @description
 * # deviceFilter
 */

angular.module('loopUiApp')
    .component('deviceFilter', {
        templateUrl: '../scripts/components/device/deviceFilter/deviceFilter.html',
        bindings: {
            deviceFilter: '<',
            updateHandler: '<',
            onApply: '&',
            onUpdate: '&'
        },
        controller: function ($stateParams, Service) {
            var vm = this;
            vm.projectId = $stateParams.projectId;

            vm.assetFilterSettings = {
                name: 'Asset',
                filter: true,
                entityIcon: 'map'
            };

            vm.tagFilterSettings = {
                name: 'Groups',
                filter: true,
                entityIcon: 'label'
            };

            vm.statusFilterSettings = {
                name: 'Status',
                filter: true,
                entityIcon: 'power_settings_new',
                multipleSelection: false
            };

            vm.versionFilterSettings = {
                name: 'Version',
                filter: true,
                entityIcon: 'format_list_numbered',
                multipleSelection: true
            };

            vm.$onInit = function () {
                //Device filter object
                vm.newFilter = {
                    //siteList: [],
                    //assetList: [],
                    tagList: [],
                    versionList: [],
                    statusList: [],
                };

                vm.deviceFilter = angular.copy(vm.newFilter);

                vm.tagList = [];
                vm.versionList = [];
                vm.assetList = [];
                vm.statusList = [{ name: 'Online' }];

                vm.refreshTagList();
                vm.refreshVersionList();
                vm.refreshAssets();
            };

            /**
             * Listen updateHandler parameter and refresh filters value
             * @param {Object} changes - changes object
             * @returns {void}
             */
            vm.$onChanges = function (changes) {
                if (changes && changes.updateHandler && changes.updateHandler.currentValue && !changes.updateHandler.isFirstChange()) {
                    vm.refreshTagList();
                    vm.refreshVersionList();
                    vm.refreshAssets();
                    vm.onUpdate();
                }
            };

            /**
             * Load Tag list
             * @returns {void}
             */
            vm.refreshTagList = function () {
                Service.api.deviceTagList({
                    projectId: vm.projectId
                }).$promise
                    .then(function (data) {
                        vm.tagList = data.map(function (item) {
                            return { name: item, count: null };
                        });
                    })
                    .catch(function () {
                        vm.tagList = [];
                    });
            };

            /**
             * Load version list
             * @returns {void}
             */
            vm.refreshVersionList = function () {
                Service.api.deviceVersionList({
                    projectId: vm.projectId
                }).$promise
                    .then(function (data) {
                        vm.versionList = data.map(function (item) {
                            return { name: item.version, count: item.cnt };
                        });
                    })
                    .catch(function () {
                        vm.versionList = [];
                    });
            };

            /**
             * Load Asset list
             * @returns {void}
             */
            vm.refreshAssets = function () {
                Service.api.assetList({
                    projectId: vm.projectId
                }).$promise
                    .then(function (data) {
                        //Group asset array by asset name
                        var assetsObject = vm.groupAssetFilterByName(data);
                        vm.assetList = Object.keys(assetsObject).map(function (asset) {
                            return {
                                name: asset,
                                count: null,
                                ids: assetsObject[asset]
                            };
                        });
                    })
                    .catch(function () {
                        vm.assetList = [];
                    });
            };

            /**
             * Apply selected filter
             * @return {void}
             */
            vm.applyFilter = function () {
                vm.onApply({
                    deviceFilter: vm.deviceFilter
                });
            };

            /**
             * Group asset list by name as key and array off id as value
             * @param {Array} assetList - asset list
             * @return {Object} - grouped asset object
             */
            vm.groupAssetFilterByName = function (assetList) {
                if (!assetList) {
                    return {};
                }
                return assetList.reduce(function (acc, cur) {
                    if (!acc[cur.name]) {
                        acc[cur.name] = [];
                    }
                    acc[cur.name].push(cur.entryID);
                    return acc;
                }, {});
            };
        }
    });
'use strict';
/**
 * @ngdoc component
 * @name loopUiApp.component:deviceStatus
 * @description
 * # deviceStatus
 */

angular.module('loopUiApp')
    .component('deviceStatus', {
        templateUrl: '../scripts/components/device/deviceStatus/deviceStatus.html',
        bindings: {
            type: '<',
            deviceStatusObject: '<',
            tooltipDirection: '<'
        },
        controller: function (Commons) {
            var vm = this;
            
            vm.$onInit = function () {
                if (vm.deviceStatusObject) {
                    // Check capability for LWM2M feature
                    vm.lwm2mCapabilityObject = Commons.checkFeatureCapability(vm.deviceStatusObject.capabilities, 'LWM2M');
                }
                
                // Select device status view based on device type
                vm.statusType = ['LOOPEDGE', 'EMBEDDED', 'DEMO'].indexOf(vm.type) >= 0 ? 'runtimeStatus' : 'simple';
                vm.tooltipDirection = vm.tooltipDirection || 'left';
            };
        }
    });
'use strict';

/**
 * @ngdoc component
 * @name loopUiApp.component:deviceMetricsStatus
 * @description
 * # deviceMetricsStatus
 */
angular.module('loopUiApp')
    .component('deviceMetricsStatus', {
        templateUrl: '../scripts/components/device/deviceMetricsStatus.html',
        bindings: {
            device: '<',
            deviceStatusObject: '<',
            metricsObject: '<',
        },
        controller: function ($state, $stateParams, Commons) {
            var vm = this;
            vm.onlineDevices = 0;
            vm.onlineConnectors = 0;

            vm.$onInit = function() {
                // Max number of element inside metrics list
                vm.METRIC_LIST_LIMIT = 5;
                
                // Check capability for metrics feature
                vm.metricsCapabilityObject = Commons.checkFeatureCapability(vm.deviceStatusObject.capabilities, 'METRICS');
            };
            
            /**
             * Handle input changes
             * @param {Object} changes - changes object
             * @return {void}
             */
            vm.$onChanges = function(changes) {
                if(changes && changes.metricsObject && changes.metricsObject.currentValue) {
                    if (vm.metricsObject && vm.metricsObject.dh && vm.metricsObject.dh.devices) {
                        vm.onlineDevices = vm.metricsObject.dh.devices.filter(function(item) {
                            return item.status === 1;
                        }).length;
                    }
                    if (vm.metricsObject && vm.metricsObject.cc && vm.metricsObject.cc.connectors) {
                        vm.onlineConnectors = vm.metricsObject.cc.connectors.filter(function(item) {
                            return item.status === 1;
                        }).length;
                    }
                }
            };

            /**
             * Get metrics badge based on metrics object and device's edgePollingSettings.enabled and online status
             * @returns {string} - metrics badge class
             */
            vm.metricsBadgeClass = function() {
                if (!vm.deviceStatusObject.edgePollingSettings || !vm.deviceStatusObject.edgePollingSettings.enabled) {
                    return 'metrics-badge__unknown';
                }
                return !!vm.metricsObject && vm.deviceStatusObject.online ? 'metrics-badge__success' : 'metrics-badge__warning';
            };

            /**
             * Open device page
             * @return {void}
             */
             vm.openDeviceDetails = function() {
                 if (!vm.deviceStatusObject || !vm.deviceStatusObject.online){
                     return;
                 }
                $state.go('deviceView', {
                    companyName: $stateParams.companyName,
                    projectId: vm.device.projectId,
                    deviceId: vm.device.deviceId,
                    selectedTab: 'metrics'
                });
            };
        }
    });
'use strict';

/**
 * @ngdoc component
 * @name loopUiApp.component:deviceMetrics
 * @description
 * # deviceMetrics
 */
angular.module('loopUiApp')
    .component('deviceMetrics', {
        templateUrl: '../scripts/components/device/deviceMetrics.html',
        bindings: {
            device: '<'
        },
        controller: function ($stateParams, $interval, Service, Commons) {
            var vm = this;
            vm.deviceMetrics = [];

            vm.$onInit = function() {
                vm.projectId = $stateParams.projectId;
                vm.companyName = $stateParams.companyName;

                // Metrics capability object
                vm.metricsCapabilityObject = Commons.checkFeatureCapability(vm.device.capabilities, 'METRICS');

                vm.dhPagination = {
                    limit: 10,
                    page: 1,
                    limitOptions: [10, 50, 100]
                };

                vm.ccPagination = {
                    limit: 10,
                    page: 1,
                    limitOptions: [10, 50, 100]
                };

                vm.refreshMetrics();
                vm.refreshInterval = $interval(function () {
                    vm.refreshMetrics();
                }, 10000);
            };

            vm.$onDestroy = function() {
                $interval.cancel(vm.refreshInterval);
            };

            /**
             * Refresh device metrics
             * @return {void}
             */
             vm.refreshMetrics = function () {
                Service.api.metricsGet({
                    actionExt: vm.device.projectId
                }, [vm.device.deviceId]).$promise
                    .then(function (data) {
                        vm.deviceMetrics = data[0] || {};
                    });
            };
        }
    });
'use strict';
/**
 * @ngdoc company level model: device model list
 * @name loopUiApp.component:sitesList
 * @description
 * # sitesList
 */
angular.module('loopUiApp')
    .component('sitesList', {
        templateUrl: '../scripts/components/device/sites/sitesList/sitesList.html',
        controller: function ($q, $mdDialog, $state, $stateParams, Service, $scope, Commons, gettextCatalog) {
            var vm = this;
            vm.sitesList = [];
            vm.origSitesList = [];

            // List load promise
            vm.sitesListPromise = null;
            vm.isLoading = false;

            vm.$onInit = function () {
                vm.companyName = $stateParams.companyName;
                vm.projectId = $stateParams.projectId;

                vm.entityName = 'Sites';

                vm.newSite = {
                    projectId: vm.projectId,
                    mapDefinition: {},
                    properties: {}
                };

                vm.gridSetup = {
                    sortField: 'name',
                    showIndex: true,
                    editable: false,
                    removable: false,
                    itemClickable: true,
                    limit: 11,
                    limitOptions: [10, 50, 100],
                    cardType: 'logoGridCard',
                    footerItems: [
                        {
                            itemIcon: 'location_on',
                            itemTooltip: 'Points',
                            itemCounter: function (item) {
                                return item.mapDefinition && item.mapDefinition.points ? item.mapDefinition.points.length : 0;
                            }
                        },
                        {
                            itemIcon: 'info',
                            itemTooltip: 'Status',
                            itemCounter: function (item) {
                                if (!item.mapDefinition || !item.mapDefinition.points) {
                                    return 'OK';
                                }
                                return item.mapDefinition.points.some(function (point) { return point.status === 'CRITICAL'; }) ? 'CRIT' : item.mapDefinition.points.some(function (point) { return point.status === 'WARNING'; }) ? 'WARN' : 'OK';
                            }
                        }
                    ],
                    dataMapping: {
                        avatar: {
                            column: 'imageUrl',
                            transformation: function (item) {
                                return item.mapDefinition && item.mapDefinition.imageUrl ? item.mapDefinition.imageUrl + '?' + vm.imageHash : '/images/photo.svg';
                            }
                        },
                        title: {
                            column: 'name'
                        },
                        subtitle: {
                            column: 'description'
                        },
                        actions: [
                            {
                                name: 'Dashboard',
                                link: 'dashboardTemplate'
                            }
                        ]
                    },
                };

                vm.listSetup = {
                    sortField: 'name',
                    showIndex: true,
                    editable: false,
                    removable: false,
                    limit: 10,
                    limitOptions: [10, 50, 100],
                    fields: [
                        {
                            name: 'Name',
                            column: 'name'
                        },
                        {
                            name: 'Description',
                            column: 'description'
                        },
                        {
                            name: 'Points',
                            column: 'points',
                            transformation: function (item) {
                                return item.mapDefinition && item.mapDefinition.points && item.mapDefinition.points.length ?
                                    item.mapDefinition.points.length : 0;
                            }
                        }
                    ]
                };

                vm.filterActions = [
                    {
                        icon: 'refresh',
                        label: 'Reload',
                        buttonClick: vm.refreshSiteList
                    }
                ];

                vm.additionalActions = [
                    {
                        name: 'View/Edit',
                        icon: 'edit',
                        function: function (event, item) {
                            vm.viewSite(event, item);
                        }
                    },
                    {
                        name: 'Show Site Points',
                        icon: 'map',
                        function: function (_, item) {
                            $state.go('siteMap', {
                                companyName: vm.companyName,
                                projectId: vm.projectId,
                                siteId: item.id
                            });
                        }
                    },
                    {
                        name: 'Delete',
                        icon: 'delete',
                        function: vm.removeSiteConfirmation
                    }
                ];
                vm.states = [
                    {
                        icon: 'view_module',
                        value: 1,
                        description: 'Module view'
                    },
                    {
                        icon: 'view_list',
                        value: 0,
                        description: 'Table view'
                    }
                ];
                vm.selectedState = vm.states[0];

                vm.refreshSiteList();
            };

            /**
             * Call to API for refresh site list
             *
             * @returns {void}
             */
            vm.refreshSiteList = function () {
                vm.isLoading = true;
                vm.siteListPromise = Service.api.siteList({
                    projectId: vm.projectId
                }).$promise;
                vm.siteListPromise
                    .then(function (data) {
                        // Unique value to get fresh device image
                        vm.imageHash = Date.now();

                        vm.sitesList = data;
                        // Save to restore filter
                        vm.origSitesList = angular.copy(data);
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Get Site list failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error siteList:' + JSON.stringify(reason));
                    })
                    .finally(function () {
                        vm.isLoading = false;
                    });
            };

            /**
             * Switch view state list/module
             *
             * @param {*} state             - Newly selected state
             * @returns {void}
             */
            vm.selectState = function (state) {
                vm.selectedState = state;
            };

            /**
             * Filter Device list based on search criteria
             *
             * @param {string} searchText           - search string
             * @return {void}
             */
            vm.filter = function (searchText) {
                // Check object fields
                var firstRow = vm.origSitesList[0];
                if (!searchText || !firstRow.hasOwnProperty('name') || !firstRow.hasOwnProperty('description')) {
                    vm.sitesList = vm.origSitesList;
                    return;
                }
                vm.sitesList = vm.origSitesList.filter(function (row) {
                    return (row.name + row.description).toLowerCase().indexOf(searchText.toLowerCase()) >= 0;
                });
            };

            /**
             * Show model removal confirmation dialog.
             *
             * @param {MouseEvent} event                - Click event
             * @param {any} item                        - Device model
             * @returns {void}
             */
            vm.removeSiteConfirmation = function (event, item) {
                var deleteFn = function () {
                    Service.api.siteDelete({
                        action: item.id
                    }).$promise
                        .then(function () {
                            vm.refreshSiteList();
                            Commons.toastShow('Site ' + item.name + ' was removed');
                        })
                        .catch(function (reason) {
                            var messageObject = Commons.createErrorObject(reason, 'Site removal failed');
                            Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                            console.log('Error siteDelete: ' + JSON.stringify(reason));
                        });
                };

                Commons.showConfirmationWarn(
                    gettextCatalog.getString('Remove Site'),
                    gettextCatalog.getString('Site <strong>' + item.name + '</strong> will be removed'),
                    gettextCatalog.getString('Remove'),
                    deleteFn,
                    gettextCatalog.getString('Cancel'),
                    undefined,
                    event);
            };

            /**
             * Show add/edit site dialog.
             *
             * @param {MouseEvent} event                - Click event
             * @param {any} site                        - Site data
             * @returns {void}
             */
            vm.viewSite = function (event, site) {
                // Create an isolated scope to pass to the component
                var scope = angular.extend($scope.$new(true), {
                    site: angular.copy(site || vm.newSite)
                });

                $mdDialog.show({
                    template: '<md-dialog aria-label="Site"><define-site site="site"></define-site></md-dialog>',
                    parent: angular.element(document.body),
                    targetEvent: event,
                    clickOutsideToClose: false,
                    preserveScope: true,
                    scope: scope,
                    skipHide: true
                })
                    .then(function (payloadData) {
                        if (payloadData && payloadData.site) {
                            return vm.save(payloadData.site, payloadData.image);
                        }
                    })
                    .catch(function (reason) {
                        if (reason) {
                            console.log('Error create site:' + JSON.stringify(reason));
                            var messageObject = Commons.createErrorObject(reason, 'Site create failed');
                            Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        }
                    })
                    .finally(function() {
                        vm.refreshSiteList();
                    });
            };

            /**
             * Save site data an
             * @param {Object} site - object 
             * @param {*} image - image object
             * @returns 
             */
            vm.save = function (site, image) {
                var deferred = $q.defer();
                Service.api.site(site).$promise
                    .then(function (savedSite) {
                        if (!image) {
                            return;
                        }
                        // Save image if site was saved
                        return Service.api.uploadSiteImage({
                            actionExt: savedSite.id
                        }, image).$promise;
                    })
                    .then(function () {
                        Commons.toastShow('Site saved');
                        deferred.resolve();
                    })
                    .catch(function (reason) {
                        if (reason.status === 413) {
                            deferred.reject({
                                status: reason.status,
                                data: {
                                    message: 'The image is too large to upload',
                                    messageDetails: 'Maximum image size is 2Mb'
                                }
                            });
                            return;
                        }
                        deferred.reject(reason);
                    });
                return deferred.promise;
            };
        }
    });

'use strict';
/**
 * @ngdoc project level sites list: lites list
 * @name loopUiApp.component:siteMap
 * @description
 * # siteMap
 */

angular.module('loopUiApp')
    .component('siteMap', {
        templateUrl: '../scripts/components/device/sites/siteMap/siteMap.html',
        controller: function ($state, $stateParams, $mdDialog, $scope, $q, appConfig, Commons, Service, gettextCatalog) {
            var vm = this;

            vm.$onInit = function () {
                //Is this version contains OEM features
                vm.oem = appConfig.__env.oem;

                // Unique value to get fresh device image
                vm.imageHash = Date.now();

                vm.image = undefined;
                vm.isSiteImageAvailable = false;
                vm.multiplierX = 1;
                vm.multiplierY = 1;
                vm.markerSize = 36;
                vm.movingPoint = undefined;
                vm.movingElement = undefined;
                vm.companyName = $stateParams.companyName;
                vm.projectId = $stateParams.projectId;
                vm.siteId = $stateParams.siteId;
                vm.points = [];
                vm.getMapDefinition();
                vm.setupTableView();
                vm.items = [];
                vm.itemStatusObject = {};
                vm.itemObject = {};
            };

            /**
             * Setup table for points.
             *
             * @returns {void}
             */
            vm.setupTableView = function () {
                vm.listSetup = {
                    sortField: 'name',
                    showIndex: true,
                    editable: false,
                    removable: false,
                    limit: 10,
                    limitOptions: [10, 50, 100],
                    rowMouseEnter: function (item) {
                        angular.element(
                            document.querySelector('[data-entity="' + item.entity.entityId + '"]')
                        ).addClass('map__marker--highlight');
                    },
                    rowMouseLeave: function (item) {
                        angular.element(
                            document.querySelector('[data-entity="' + item.entity.entityId + '"]')
                        ).removeClass('map__marker--highlight');
                    },
                    fields: [
                        {
                            name: 'Device',
                            column: 'entityId',
                            link: true,
                            fieldAction: function (item) {
                                $state.go('deviceView', {
                                    companyName: vm.companyName,
                                    projectId: vm.projectId,
                                    deviceId: item.entity.entityId
                                });
                            },
                            transformation: function (item) {
                                return item.entity && item.entity.entityId ?
                                    item.entity.entityId.substring(0, 5) : '-';
                            }
                        },
                        {
                            name: 'Friendly Name',
                            column: 'prettyName',
                            transformation: function (item) {
                                var id = item.entity && item.entity.entityId ? item.entity.entityId : null;
                                return vm.getDeviceProperty(id, 'prettyName');
                            }
                        },
                        {
                            name: 'Type',
                            column: 'entityType',
                            transformation: function (item) {
                                return item.entity ? item.entity.type : '-';
                            }
                        },
                        {
                            name: 'Name',
                            column: 'name',
                            editable: true,
                            input: 'text'
                        },
                        {
                            name: 'Description',
                            column: 'description',
                            editable: true,
                            input: 'text'
                        },
                        {
                            name: 'Status',
                            component: 'deviceStatus',
                            type: 'LOOPEDGE', //TODO: Think about different device type
                            transformation: function (item) {
                                return item.entity && item.entity.entityId ?
                                    vm.itemStatusObject[item.entity.entityId] : '';
                            }
                        }
                    ]
                };
                vm.tableActions = [
                    {
                        name: 'Remove',
                        icon: 'delete',
                        function: vm.removePoint.bind(vm)
                    }
                ];

                vm.filterActions = [
                    {
                        label: 'Add a new point',
                        icon: 'add',
                        disable: function () {
                            return !vm.isSiteImageAvailable;
                        },
                        buttonClick: vm.selectPointEntity
                    },
                    {
                        label: 'Save',
                        icon: 'save',
                        disable: function () {
                            return !vm.isSiteImageAvailable;
                        },
                        buttonClick: vm.save.bind(vm, null)
                    }
                ];

                vm.selectType('DEVICE');
            };

            /**
             * Get site information from API.
             *
             * @returns {void}
             */
            vm.getMapDefinition = function () {
                Service.api.siteGet({ action: vm.siteId }).$promise
                    .then(function (site) {
                        vm.site = site;
                        vm.isSiteImageAvailable = vm.site.mapDefinition && vm.site.mapDefinition.imageUrl;
                        vm.points = vm.site.mapDefinition && vm.site.mapDefinition.points ? angular.copy(vm.site.mapDefinition.points) : [];
                        vm.refreshEntityDetails(vm.points);
                    });
            };

            /**
             * Get details for map points
             * @param {Object} points - points list
             * @returns {void}
             */
            vm.refreshEntityDetails = function (points) {
                points.forEach(function (point) {
                    if (point.entity.type === 'DEVICE') {
                        vm.getDeviceData(point.entity);
                    }
                });
            };

            /**
             * Get device data object
             * @param {Object} entity - map entity object
             * @return {void}
             */
            vm.getDeviceData = function (entity) {
                Service.api.deviceGet({
                    action: vm.projectId,
                    actionExt: entity.entityId
                }).$promise
                    .then(function (data) {
                        if (data.status === 'DELETED') {
                            vm.points = vm.points.filter(function (point) {
                                return point.entity.entityId !== entity.entityId;
                            });
                            return;
                        }
                        vm.itemStatusObject[entity.entityId] = Commons.getDeviceStatusObject(data);
                        vm.itemObject[entity.entityId] = data;
                    });
            };

            /**
             * Map image loaded event for calculate original image size.
             *
             * @param {Event} event             - Image loaded event
             * @returns {void}
             */
            vm.imageLoaded = function (event) {
                vm.image = event.target;
                vm.calculateMultiplier();
            };

            /**
             * Calculate multiplier based on image size and viewport size.
             *
             * @returns {void}
             */
            vm.calculateMultiplier = function () {
                if (!vm.image || !vm.image.clientWidth || !vm.image.clientHeight) {
                    return;
                }
                vm.multiplierX = vm.image.clientWidth / vm.site.mapDefinition.imageWidth;
                vm.multiplierY = vm.image.clientHeight / vm.site.mapDefinition.imageHeight;
            };

            /**
             * Get point x coordinate.
             *
             * @param {number} x            - X coordinate in image space
             * @returns {number}            - X coordinate in viewport space
             */
            vm.getX = function (x) {
                return x * vm.multiplierX - vm.markerSize / 2;
            };

            /**
             * Get point y coordinate.
             *
             * @param {number} y            - Y coordinate in image space
             * @returns {number}            - Y coordinate in viewport space
             */
            vm.getY = function (y) {
                return y * vm.multiplierY - vm.markerSize / 2;
            };

            /**
             * Grab point on click.
             *
             * @param {MouseEvent} event    - Mouse event
             * @param {any} point           - Point object
             * @returns {void}
             */
            vm.grabPoint = function (event, point) {
                vm.movingElement = event.target;
                vm.movingElement.style.pointerEvents = 'none';
                vm.movingPoint = point;
            };

            /**
             * Place moved point or create a new one.
             *
             * @param {MouseEvent} event    - Mouse event on button up
             * @returns {void}
             */
            vm.placePoint = function () {
                if (vm.movingPoint) {
                    if (vm.movingPoint.status === 'New') {
                        vm.movingPoint.status = 'OPERATIONAL';
                    }
                    vm.movingPoint = undefined;
                    vm.movingElement.style.pointerEvents = 'all';
                    vm.movingElement = undefined;
                    vm.save(true);
                }
            };

            /**
             * Track mouse movement.
             *
             * @param {MouseEvent} event    - Mouse event on cursor moving
             * @returns {void}
             */
            vm.movePoint = function (event) {
                if (!vm.movingPoint) {
                    return;
                }
                vm.movingPoint.x = event.offsetX / vm.multiplierX;
                vm.movingPoint.y = event.offsetY / vm.multiplierY;
            };

            /**
             * Track window resize for calculate multiplier
             *
             * @returns {void}
             */
            vm.windowResize = function () {
                vm.calculateMultiplier();
            };

            /**
             * Performs filtering by points.
             *
             * @param {string} searchText                   - Predicate text
             * @returns {void}
             */
            vm.filter = function (searchText) {
                //Check object fields
                var firstRow = vm.site.mapDefinition.points[0];
                if (!searchText || !firstRow.hasOwnProperty('name') || !firstRow.hasOwnProperty('status')) {
                    vm.points = angular.copy(vm.site.mapDefinition.points);
                    return;
                }
                vm.points = vm.site.mapDefinition.points.filter(function (row) {
                    return (row.name + row.status).toLowerCase().indexOf(searchText.toLowerCase()) >= 0;
                });
            };

            /**
             * Initialize and add new point to the points array.
             * @param {any} locationEntity                  - Location entity object
             * @returns {void}
             */
            vm.addPoint = function (locationEntity) {
                if (vm.block()) {
                    vm.flashPoint(angular.element(document.querySelector('.map__marker--new')), 'map__marker--flashing');
                    Commons.toastShow(gettextCatalog.getString('Place a new point on it\'s location on map'));
                    return;
                }
                var point = {
                    x: vm.image ? vm.image.width / 2 / vm.multiplierX : 0,
                    y: vm.image ? vm.image.height / 2 / vm.multiplierY : 0,
                    name: 'New point',
                    status: 'New',
                    description: 'Point description',
                    entity: locationEntity
                };
                vm.points.push(point);
                vm.site.mapDefinition.points = angular.copy(vm.points);
            };

            /**
             * Save site data.
             *
             * @param {boolean} savedFromMovement                   - Is save called from point placement
             * @returns {void}
             */
            vm.save = function (savedFromMovement) {
                if (vm.block()) {
                    vm.flashPoint(angular.element(document.querySelector('.map__marker--new')), 'map__marker--flashing');
                    Commons.toastShow('Place a new point on it\'s place');
                    return;
                }
                vm.site.mapDefinition.points = angular.copy(vm.points);
                Service.api.site(vm.site).$promise
                    .then(function () {
                        if (!savedFromMovement) {
                            Commons.toastShow(gettextCatalog.getString('Site saved successfully'));
                        }
                        vm.getMapDefinition();
                        vm.selectType('DEVICE');
                    })
                    .catch(function (reason) {
                        if (reason) {
                            console.log('Error update site:' + JSON.stringify(reason));
                            var messageObject = Commons.createErrorObject(reason, 'Site update failed');
                            Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        }
                    });
            };

            /**
             * Flash point by adding and then removing flashing class to the element.
             *
             * @param {any} point                       - Point element
             * @param {string} flashClass               - CSS class for flash
             * @returns {void}
             */
            vm.flashPoint = function (point, flashClass) {
                point.addClass(flashClass);
                setTimeout(function () {
                    point.removeClass(flashClass);
                }, 300);
            };

            /**
             * Check if there is a new point that didn't placed anywhere on map.
             *
             * @returns {boolean}                       - True if that point exists
             */
            vm.block = function () {
                return vm.points.some(function (point) { return point.status === 'New'; });
            };

            /**
             * Removes point from the points array.
             *
             * @param {MouseEvent} _                    - Click event. Not used.
             * @param {any} point                       - Point to remove
             * @returns {void}
             */
            vm.removePoint = function (_, point) {
                vm.points.splice(vm.points.indexOf(point), 1);
                //Clean up status object if exists
                if(vm.itemStatusObject[point.entity.entityId]){
                    delete vm.itemStatusObject[point.entity.entityId];
                    delete vm.itemObject[point.entity.entityId];
                }
                vm.save();
            };

            /**
             * Called when user change type inside entity selection dialog,
             * then calls and API and map result to an array of following objects:
             *
             * { name: 'Entity name', description: 'Entity description', id: 'entityIdentifier' }
             *
             * @param {string} selectedType                        - Type name
             * @returns {void}
             */
            vm.selectType = function (selectedType) {
                var promise;
                switch (selectedType) {
                case 'ASSET':
                    promise = Service.api.assetList({
                        projectId: vm.projectId
                    }).$promise;
                    break;
                case 'DEVICE':
                    promise = Service.api.deviceList({
                        projectId: vm.projectId,
                        limit: 1000 // TODO: Get rid of magic number
                    }).$promise;
                    break;
                case 'SENSOR':
                    // * Fetch devices list.
                    promise = Service.api.deviceList({
                        projectId: vm.projectId,
                        limit: 1000
                    }).$promise.then(function (response) {
                        // * Prepare array of promises to get devices children
                        return $q.all(
                            response.elements
                            // * Filter out devices without children
                                .filter(function (element) {
                                    return element.hasChildren;
                                })
                            // * Map devices to a promises which resolves their children
                                .map(function (device) {
                                    return Service.api.childDeviceList({
                                        actionExt: vm.projectId,
                                        parentDeviceId: device.deviceId
                                    }).$promise;
                                })
                        ).then(function (responses) {
                            return responses.map(function (response) {
                                return response.elements;
                            });
                        });
                    });
                    break;
                default:
                    break;
                }

                promise.then(function (response) {
                    var items = [];
                    (response instanceof Array ?
                        response.filter(function (item) { return item.status !== 'DELETED';}).map(vm.mapItems(selectedType)) :
                        response.elements.filter(function (item) { return item.status !== 'DELETED';}).map(vm.mapItems(selectedType)))
                        .forEach(function (item) {
                            if (item instanceof Array) {
                                item
                                    .filter(function (item) {
                                        return !vm.checkForExistence(item);
                                    })
                                    .forEach(function (element) {
                                        vm.items.push(element);
                                    });
                            } else {
                                if (vm.checkForExistence(item)) {
                                    return;
                                }
                                items.push(item);
                            }
                        });
                    vm.items = items;
                });
            };

            /**
             * Check if asset, device or sensor already on the map.
             *
             * @param {any} item                    - Entity item
             * @returns {boolean}                   - True if item in the points array
             */
            vm.checkForExistence = function (item) {
                return vm.points
                    .some(function (point) {
                        return point.entity.entityId === item.id;
                    });
            };

            /**
             * Create map callback based on entity type selected.
             *
             * @param {string} type                     - Type name
             * @returns {function}                      - Function that used as callback for mapping
             */
            vm.mapItems = function (type) {
                switch (type) {
                case 'ASSET':
                    return function (asset) {
                        return {
                            name: asset.name,
                            description: asset.description,
                            id: asset.assetUuid
                        };
                    };
                case 'DEVICE':
                    return function (device) {
                        return {
                            name: device.hostname,
                            prettyName: device.prettyName,
                            description: device.description,
                            id: device.deviceId
                        };
                    };
                case 'SENSOR':
                    return function (item) {
                        return item.map(function (sensor) {
                            return {
                                name: sensor.type + ':' + sensor.parentId.substring(0, 5) + ':' + sensor.deviceId.substring(0, 5),
                                description: sensor.description,
                                id: sensor.deviceId
                            };
                        });
                    };
                default:
                    break;
                }
            };

            /**
             * Select Asset, Device or Sensor to attach to the point.
             *
             * @param {MouseEvent} event                    - Mouse click event
             * @returns {void}
             */
            vm.selectPointEntity = function (event) {
                if (vm.block()) {
                    vm.flashPoint(angular.element(document.querySelector('.map__marker--new')), 'map__marker--flashing');
                    vm.flashPoint(angular.element(document.querySelector('.map__asset--new')), 'map__marker--flashing');
                    vm.flashPoint(angular.element(document.querySelector('.map__device--new')), 'map__marker--flashing');
                    vm.flashPoint(angular.element(document.querySelector('.map__sensor--new')), 'map__marker--flashing');
                    Commons.toastShow(gettextCatalog.getString('Place a new point on it\'s location on map'));
                    return;
                }
                // Create an isolated scope to pass to the component
                var scope = angular.extend($scope.$new(true), {
                    items: vm.items,
                    selectType: vm.selectType,
                    locationEntity: { type: 'DEVICE', display: 'MANAGED', status: 'OPERATIONAL' }
                });

                $mdDialog.show({
                    template: '<md-dialog aria-label="Point Entity"><select-point-entity items="items" location-entity="locationEntity" select-type="selectType(locationEntity.type)"></select-point-entity></md-dialog>',
                    parent: angular.element(document.body),
                    targetEvent: event.event,
                    clickOutsideToClose: false,
                    preserveScope: true,
                    scope: scope,
                    skipHide: true
                })
                    .then(function (entity) {
                        if (!entity) {
                            return;
                        }
                        vm.addPoint(entity.entity);
                    })
                    .catch(function (reason) {
                        if (reason) {
                            console.log('Error selectPointEntity:' + JSON.stringify(reason));
                            var messageObject = Commons.createErrorObject(reason, 'Add new point failed');
                            Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        }
                    });
            };

            /**
             * Get map point CSS class based on device status
             * @param {Object} point    - point object
             * @return {String}         - CSS class for point
             */
            vm.pointCssClass = function(point) {
                if(point.entity.type === 'DEVICE') {
                    //For device get status from status object
                    point.status = vm.decodeDeviceStatus(point);
                }
                return 'map__' + (point.entity.type.toLowerCase() || 'marker') + '--' + point.status.toLowerCase();
            };

            /**
             * Transform device status to map point status
             * @param {String} point - point object
             * @returns {String} - map point status representation
             */
            vm.decodeDeviceStatus = function(point) {
                var status = vm.itemStatusObject[point.entity.entityId] ? vm.itemStatusObject[point.entity.entityId].status : point.status;
                switch (status) {
                case 'OFFLINE':
                case '':
                    return 'WARNING';
                case 'ONLINE':
                    return 'OPERATIONAL';
                default:
                    return status;
                }
            };

            /**
             * Return element property
             * @param {string} entityId - element id 
             * @param {*} propertyName - element property name
             * @returns {string} - property value
             */
            vm.getDeviceProperty = function(entityId, propertyName){
                if (!entityId) {
                    return '';
                }
                var device = vm.itemObject[entityId] || {};
                return device ? device[propertyName] : null;
            };

            /**
             * Get full image URL
             * @param {Object} site - site object
             * @returns {string} - full image url
             */
             vm.getSiteImagePath = function (site) {
                return site.mapDefinition && site.mapDefinition.imageUrl ? site.mapDefinition.imageUrl + '?' + vm.imageHash : '/images/photo.svg';
            };

            /**
             * Return to sites list
             * @returns {void}
             */
            vm.returnToSiteList = function () {
                $state.go('sites', {
                    projectId: vm.projectId,
                    companyName: vm.companyName,
                });
            };
        }
    })
    /**
     * @ngdoc project level sites list: image load callback directive
     * @name loopUiApp.directive:loopLoad
     * @description Call passed function when image loaded
     * # loopLoad
     */
    .directive('loopLoad', ['$parse', function ($parse) {
        return {
            restrict: 'A',
            link: function (scope, elem, attrs) {
                var fn = $parse(attrs.loopLoad);
                elem.on('load', function (event) {
                    scope.$apply(function () {
                        fn(scope, { $event: event });
                    });
                });
            }
        };
    }])
    /**
     * @ngdoc project level sites list: window resize callback directive
     * @name loopUiApp.directive:loopResize
     * @description Call passed function when window resized
     * # loopResize
     */
    .directive('loopResize', ['$window', '$parse', function ($window, $parse) {
        return {
            link: function (scope, element, attrs) {
                var fn = $parse(attrs.loopResize);

                angular.element($window).on('resize', function (event) {
                    scope.$apply(function () {
                        fn(scope, { $event: event, $width: $window.innerWidth });
                    });
                });
                scope.$on('$destroy', function () {
                    angular.element($window).off('resize');
                });
            },
            restrict: 'A'
        };
    }]);

'use strict';
/**
 * @ngdoc project level site: site view
 * @name loopUiApp.component:defineSite
 * @description
 * # defineSite
 *
 * Component that represents view/edit site dialog.
 *
 * Component accept following parameters as an input:
 *
 * - `site`                 - Site itself. Type: any
 */
angular.module('loopUiApp')
    .component('defineSite', {
        templateUrl: '../scripts/components/device/sites/defineSite/defineSite.html',
        bindings: {
            site: '<'
        },
        controller: function ($scope, $mdDialog, gettextCatalog, Service, Commons) {
            var vm = this;
            
            /**
             * Hides the dialog
             *
             * @returns {void}
             *
             */
            vm.hide = function () {
                $mdDialog.hide();
            };

            /**
             * Cancel dialog button
             *
             * @returns {void}
             */
            vm.cancel = function () {
                $mdDialog.cancel();
            };

            /**
             * Pass new model to the parent component and close dialog.
             *
             * @returns {void}
             */
            vm.save = function () {
                $mdDialog.hide({ site: vm.site, image: vm.imageData });
            };

            vm.haveImage = function () {
                return !!(vm.site.mapDefinition && vm.site.mapDefinition.imageUrl) || vm.imagePreview;
            };

            /**
             * Prepare image upload data and call preview.
             *
             * @param {Event} event             - Selection event from fileUpload component
             * @returns {void}
             */
            vm.uploadImage = function (event) {
                var target = event.target;
                vm.imageData = new FormData();
                angular.forEach(target.files, function(data) {
                    vm.imageData.append('file', data);
                });
                vm.previewImage(target);
            };

            /**
             * Enable image previewer.
             *
             * @param {HTMLElement} input             - Input element
             * @returns {void}
             */
            vm.previewImage = function (input) {
                if (input.files && input.files[0]) {
                    var reader = new FileReader();

                    reader.onload = function (e) {
                        var image = document.querySelector('img.define-site__site-map');
                        angular.element(image).attr('src', e.target.result);
                        vm.imagePreview = true;
                        $scope.$apply();
                    };

                    reader.readAsDataURL(input.files[0]);
                }
            };

            /**
             * Remove site image
             * @returns {void}
             */
             vm.removeImage = function () {
                var deleteFunction = function () {
                    vm.fileUploadApi.cleanSelection();
                    Service.api.siteImageDelete({
                        actionExt: vm.site.id
                    }).$promise
                        .then(function () {
                            vm.site.mapDefinition.imageUrl = null;
                            vm.imagePreview = false;
                            vm.imageData = undefined;
                        })
                        .catch(function (reason) {
                            var messageObject = Commons.createErrorObject(reason, 'Failed to delete image');
                            Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        });
                };

                Commons.showConfirmationWarn(
                    gettextCatalog.getString('Remove Image'),
                    gettextCatalog.getString('Are you sure you want to remove image?'),
                    gettextCatalog.getString('Remove'),
                    deleteFunction,
                    gettextCatalog.getString('Cancel'),
                    undefined,
                    null);
            };
        }
    });

'use strict';
/**
 * @ngdoc company level model: OEM model view
 * @name loopUiApp.component:selectPointEntity
 * @description
 * # selectPointEntity
 *
 * Component that represents view/edit model dialog.
 *
 * Component accept following parameters as an input:
 *
 * - `devices`             - List of the devices. Type: Array<any>
 * - `assets`              - List of assets. Type: Array<any>
 */
angular.module('loopUiApp')
    .component('selectPointEntity', {
        templateUrl: '../scripts/components/device/sites/selectPointEntity/selectPointEntity.html',
        bindings: {
            items: '<',
            selectType: '&',
            locationEntity: '<'
        },
        controller: function ($mdDialog, appConfig) {
            var vm = this;

            vm.$onInit = function () {
                //Is this version contains OEM features
                vm.oem = appConfig.__env.oem;

                vm.listSetup = {
                    sortField: 'name',
                    showIndex: false,
                    editable: false,
                    removable: false,
                    limit: 10,
                    limitOptions: [10, 50, 100],
                    fields: [
                        {
                            name: 'Edge Device ID',
                            column: 'id',
                            link: true,
                            fieldAction: function (item) {
                                vm.locationEntity.entityId = item.id;
                                $mdDialog.hide({ entity: vm.locationEntity });
                            }
                        },
                        {
                            name: 'Name',
                            column: 'name',
            
                        },
                        {
                            name: 'Friendly Name',
                            column: 'prettyName',
                        },
                        {
                            name: 'Description',
                            column: 'description'
                        }
                    ]
                };
            };

            /**
             * Hides the dialog
             *
             * @returns {void}
             *
             */
            vm.hide = function () {
                $mdDialog.hide();
            };

            /**
             * Cancel dialog button
             *
             * @returns {void}
             */
            vm.cancel = function () {
                $mdDialog.cancel();
            };

            vm.changeType = function () {
                vm.selectType({ type: vm.locationEntity.type });
            };

            vm.selectEntity = function () {
                $mdDialog.hide({ entity: vm.locationEntity });
            };

        }
    });

'use strict';
/**
 * @ngdoc company level model: asset list
 * @name loopUiApp.component:assetList
 * @description
 * # assetList
 */
angular.module('loopUiApp')
    .component('assetList', {
        templateUrl: '../scripts/components/device/assetList/assetList.html',
        controller: function ($scope, $stateParams, $mdDialog, gettextCatalog, Service, Commons) {
            var vm = this;

            vm.$onInit = function () {
                vm.projectId = $stateParams.projectId;

                vm.gridSetup = {
                    sortField: 'name',
                    showIndex: true,
                    editable: false,
                    removable: false,
                    limit: 10,
                    limitOptions: [10, 50, 100],
                    cardType: 'logoGridCard',
                    dataMapping: {
                        avatar: {
                            column: 'imageUrl',
                            transformation: function (item) {
                                return item.imageUrl ? item.imageUrl : '/images/photo.svg';
                            }
                        },
                        title: {
                            column: 'name'
                        },
                        subtitle: {
                            column: 'description'
                        },
                        actions: []
                    },
                    footerItems: [
                        {
                            itemIcon: 'devices_other',
                            itemTooltip: 'Devices',
                            itemCounter: function (item) { 
                                return item.devices ? item.devices.length : 0; 
                            }
                        }
                    ]
                };

                // Generic table setup
                vm.listSetup = {
                    sortField: 'name',
                    showIndex: true,
                    editable: false,
                    removable: false,
                    limit: 10,
                    limitOptions: [10, 50, 100],
                    fields: [
                        {
                            name: 'Image',
                            column: 'imageUrl',
                            image: true,
                            transformation: function (item) {
                                return item.imageUrl ? item.imageUrl + '_preview' : '/images/photo.svg';
                            }
                        },
                        {
                            name: 'Name',
                            column: 'name'
                        },
                        {
                            name: 'Description',
                            column: 'description'
                        }

                    ]
                };

                vm.additionalActions = [
                    {
                        name: 'View/Edit',
                        icon: 'edit',
                        function: vm.viewAsset
                    },
                    {
                        name: 'Delete',
                        icon: 'delete',
                        function: vm.removeAssetConfirmation
                    }
                ];

                vm.states = [
                    {
                        icon: 'view_module',
                        value: 1,
                        description: 'Module view'
                    },
                    {
                        icon: 'view_list',
                        value: 0,
                        description: 'Table view'
                    }
                ];

                //Empty device model object
                vm.newAsset = {
                    projectId: vm.projectId,
                    name: null,
                    description: null,
                    dashboardTemplate: null ,
                    imageUrl: null
                };

                vm.selectedState = vm.states[0];

                vm.entityName = 'Assets';

                vm.refreshAssetList();
            };

            /**
             * Call to API for refresh asset list
             *
             * @returns {void}
             */
            vm.refreshAssetList = function () {
                vm.isLoading = true;
                vm.assetListPromise = Service.api.assetList({
                    projectId: vm.projectId
                }).$promise;
                vm.assetListPromise
                    .then(function (data) {
                        vm.assetList = data;
                        // Save to restore filter
                        vm.origAssetList = data;
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Get Asset list failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error assetList:' + JSON.stringify(reason));
                    })
                    .finally(function () {
                        vm.isLoading = false;
                    });
            };

            /**
             * Filter Asset list based on search criteria
             *
             * @param {string} searchText           - search string
             * @return {void}
             */
            vm.filter = function (searchText) {
                // Check object fields
                var firstRow = vm.origAssetList[0];
                if (!searchText || !firstRow.hasOwnProperty('name') || !firstRow.hasOwnProperty('description')) {
                    vm.assetList = vm.origAssetList;
                    return;
                }
                vm.assetList = vm.origAssetList.filter(function (row) {
                    return (row.name + row.description).toLowerCase().indexOf(searchText.toLowerCase()) >= 0;
                });
            };

            /**
             * Switch view state list/module
             *
             * @param {*} state             - Newly selected state
             * @returns {void}
             */
            vm.selectState = function (state) {
                vm.selectedState = state;
            };

            /**
             * Show Add/Edit asset dialog and handle the result
             *
             * @param {MouseEvent} event      - Mouse click event to determine target
             * @param {*} asset               - Device model to edit
             * @returns {void}
             */
            vm.viewAsset = function (event, asset) {
                if (!asset) {
                    Commons.toastShow('Add new Asset function is not implemented');
                    return;
                }
                // Create an isolated scope to pass to the component
                var scope = angular.extend($scope.$new(true), {
                    asset: angular.copy(asset || vm.newAsset),
                    projectId: vm.projectId
                });

                $mdDialog.show({
                    template: '<md-dialog aria-label="Asset Model"><oem-model-view oem-model="asset" model-name="Asset"></oem-model-view></md-dialog>',
                    parent: angular.element(document.body),
                    targetEvent: event,
                    clickOutsideToClose: false,
                    preserveScope: true,
                    scope: scope,
                    skipHide: true
                })
                    .then(function (asset) {
                        if (!asset) {
                            return;
                        }
                        return vm.saveAsset(asset); //TODO: API is not implemented 
                    })
                    .then(function (createdAsset) {
                        if (!createdAsset) {
                            return;
                        }
                        Commons.toastShow('Asset model was saved');
                        vm.refreshAssetList();
                    })
                    .catch(function (reason) {
                        if (reason) {
                            console.log('Error create Asset:' + JSON.stringify(reason));
                            var messageObject = Commons.createErrorObject(reason, 'Asset create failed');
                            Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        }
                    });
            };

            /**
             * Create an Asset.
             *
             * @param {any} asset             - Asset definition
             * @returns {Promise<any>}        - Promise with Asset creation result
             */
            vm.saveAsset = function (asset) {
                return Service.api.asset(asset).$promise;
            };

            /**
             * Show model removal confirmation dialog.
             *
             * @param {MouseEvent} event                - Click event
             * @param {any} item                        - Asset model
             * @returns {void}
             */
            vm.removeAssetConfirmation = function (event, item) {
                var confirm = $mdDialog.confirm()
                    .title(gettextCatalog.getString('Remove Asset Model?'))
                    .htmlContent(gettextCatalog.getString('Model <strong>') + item.name + gettextCatalog.getString('</strong> will be removed.'))
                    .ariaLabel(gettextCatalog.getString('Remove Asset Model'))
                    .targetEvent(event)
                    .ok(gettextCatalog.getString('Remove'))
                    .cancel(gettextCatalog.getString('Cancel'));
                $mdDialog.show(confirm)
                    .then(function (decision) {
                        if (decision) {
                            vm.removeAsset(item);
                        }
                    });
            };

            /**
             * Remove Asset
             *
             * @param {any} item    - Device model
             * @returns {void}
             */
            vm.removeAsset = function (item) {
                Service.api.assetDelete({
                    action: item.entryID
                }).$promise
                    .then(function () {
                        vm.refreshAssetList();
                        Commons.toastShow(item.name + ' was removed');
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Asset removal failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error assetDelete:' + JSON.stringify(reason));
                    });
            };
        }
    });

'use strict';
/**
 * @ngdoc component
 * @name loopUiApp.component:network
 * @description
 * # network
 */
angular.module('loopUiApp')
    .component('network', {
        templateUrl: '../scripts/components/network/network.html',
        controller: function () {}
    });
'use strict';
/**
 * @ngdoc component
 * @name loopUiApp.component:wireguardNetwork
 * @description
 * # wireguardNetwork
 */
angular.module('loopUiApp')
    .component('wireguardNetwork', {
        templateUrl: '../scripts/components/network/wireguardNetwork.html',
        controller: function ($stateParams, $state, $interval, $mdDialog, appConfig, gettextCatalog, Service, Commons) {
            var vm = this;
            vm.peerList = [];
            vm.currentSubnet = {};
            //Peer stats object
            vm.peerStatsObject = {};
            //Autorefresh flag
            vm.autorefresh = false;
            //Update interval
            vm.refreshPeriod = 10000;
            //Autorefresh settings
            vm.refreshOptions = [
                { name: '5 second', value: 5000 },
                { name: '10 seconds', value: 10000 },
                { name: '30 seconds', value: 30000 },
                { name: '60 seconds', value: 60000 }
            ];

            vm.$onInit = function () {
                vm.companyName = $stateParams.companyName;
                vm.projectId = $stateParams.projectId;

                // Peer action
                vm.peerActions = [{
                    name: 'Delete',
                    icon: 'delete',
                    function: vm.delete
                }];

                vm.refreshListAndStat();
                vm.refreshSubnetInfo();
            };

            // Component destroy
            vm.$onDestroy = function () {
                if (vm.refreshInterval) {
                    $interval.cancel(vm.refreshInterval);
                }
            };

            /**
             * Get peer list and update peer statistics
             * @returns {void}
             */
            vm.refreshListAndStat = function () {
                vm.refreshPeerList();
                vm.refreshStatsPeer();
            };

            /**
             * Load subnet info
             * @return {void}
             */
            vm.refreshSubnetInfo = function () {
                vm.isSubnetLoading = true;
                Service.api.projectGetById({
                    action: vm.projectId
                }).$promise
                    .then(function (projectData) {
                        var currentSubnetId = projectData.subnetId;
                        return Service.api.wgSubnetGet({
                            subnetId: currentSubnetId
                        });
                    })
                    .then(function (subnetData) {
                        vm.currentSubnet = subnetData;
                    })
                    .catch(function (reason) {
                        console.log('Error get subnet:' + JSON.stringify(reason));
                    })
                    .finally(function () {
                        vm.isSubnetLoading = false;
                    });
            };

            /**
             * Reload peer list
             * @return {void}
             */
            vm.refreshPeerList = function () {
                Service.api.wgPeerList({ projectId: vm.projectId }).$promise
                    .then(function (peers) {
                        vm.peerList = peers;
                    })
                    .catch(function (reason) {
                        console.log('Error:' + JSON.stringify(reason));
                    });
            };

            /**
             * Refresh peer stats
             * @returns {void}
             */
            vm.refreshStatsPeer = function () {
                Service.api.wgStatsPeers({ projectId: vm.projectId }).$promise
                    .then(function (data) {
                        vm.peerStatsObject = data.reduce(function (acc, currentValue) {
                            acc[currentValue.peerId] = currentValue;
                            return acc;
                        }, {});
                    });
            };

            /**
             * Show member dialog
             * Hidden by ticket EM-2124
             * @param {Object} event - event object
             * @return {void}
             */
            vm.showPeerDialog = function (event) {
                $mdDialog.show({
                    template: '<md-dialog style="max-width: 500px;"><md-dialog-content><new-peer-dialog></new-peer-dialog></md-dialog-content></md-dialog>',
                    parent: angular.element(document.body),
                    targetEvent: event,
                    clickOutsideToClose: false,
                    preserveScope: true,
                    skipHide: true
                })
                    .then(function (peerName) {
                        if (!peerName) {
                            return;
                        }
                        vm.addPeer(peerName);
                    });
            };

            /**
             * Add new peer
             * Hidden by ticket EM-2124
             * @param {String} peerName - new peer name
             * @returns {void}
             */
            vm.addPeer = function (peerName) {
                var _payload = {
                    name: peerName,
                    projectId: vm.projectId,
                    publicKey: null,
                    subnetId: vm.currentSubnet.subnetId
                };
                Service.api.wgPeer(_payload).$promise
                    .then(function (peer) {
                        vm.downloadConfig(null, peer);
                        vm.refreshListAndStat();
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Add new peer failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error wgPeer:' + JSON.stringify(reason));
                    });
            };

            /**
             * Open device details view
             * @param {String} deviceId - device identificator
             * @return {void}
             */
            vm.openDeviceDetail = function (deviceId) {
                $state.go('deviceView', {
                    companyName: vm.companyName,
                    projectId: vm.projectId,
                    deviceId: deviceId,
                    selectedType: 'ALL'
                });
            };

            /**
             * Delete peer/device. 
             * If deviceId exist then remove device completely
             * If it a custom peer (not device), then remove peer
             * @param {Event} event - mouse click event
             * @param {Object} peer - peer object
             * @returns {void}
             */
            vm.delete = function (event, peer) {
                if (peer.deviceId) {
                    vm.deleteDevice(event, peer.deviceId);
                } else {
                    vm.deletePeer(event, peer);
                }
            };

            /**
             * Delete peer
             * @param {Event} event - mouse event
             * @param {Object} peer - peer object
             * @returns {void}
             */
            vm.deletePeer = function (event, peer) {
                var _deleteFn = function (peer) {
                    Service.api.wgPeerDelete({ actionExt: peer.peerId }).$promise
                        .then(function () {
                            vm.refreshListAndStat();
                        })
                        .catch(function (reason) {
                            var messageObject = Commons.createErrorObject(reason, 'Delete peer failed');
                            Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                            console.log('Error wgPeerDelete:' + JSON.stringify(reason));
                        });
                };
                Commons.showConfirmationWarn(
                    gettextCatalog.getString('Remove Peer'),
                    gettextCatalog.getString('Are you sure you want to remove peer ' + peer.name + '?'),
                    gettextCatalog.getString('Delete'),
                    function () {
                        _deleteFn(peer);
                    },
                    gettextCatalog.getString('Cancel'),
                    null,
                    event);
            };

            /**
             * Delete LoopEdge device
             * @param {Event} event - mouse event
             * @param {Object} deviceId - device object
             * @returns {void}
             */
            vm.deleteDevice = function (event, deviceId) {
                var _deleteFunc = function () {
                    Service.api.loopEdgeDeviceDelete({
                        projectId: vm.projectId,
                        deviceId: deviceId
                    }).$promise
                        .then(function () {
                            vm.refreshListAndStat();
                        })
                        .catch(function (reason) {
                            var messageObject = Commons.createErrorObject(reason, 'Delete device error');
                            Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                            console.log('Error loopEdgeDeviceDelete:' + JSON.stringify(reason));
                        });
                };
                Commons.showConfirmationWarn(
                    gettextCatalog.getString('Delete Edge Device'),
                    gettextCatalog.getString('Are you sure you want to delete edge device? <br>' +
                        'The deleted edge device can not be restored'),
                    gettextCatalog.getString('Delete'),
                    _deleteFunc,
                    gettextCatalog.getString('Cancel'),
                    null,
                    event);
            };

            /**
             * Download peer config
             * @param {Event} event - mouse event
             * @param {Object} peer - peer object
             * @returns {void}
             */
            vm.downloadConfig = function (event, peer) {
                Commons.downloadLink(peer.config, peer.name + '_wg.conf');
            };

            /**
            * Autorefresh checkbox toggler
            * @return {undefined}
            */
            vm.autoRefreshToggle = function () {
                if (vm.autorefresh) {
                    vm.refreshInterval = $interval(function () {
                        vm.refreshListAndStat();
                    }, vm.refreshPeriod);
                } else {
                    $interval.cancel(vm.refreshInterval);
                }
            };

            /**
             * Setup new interval then it changed
             * @return {undefined}
             */
            vm.updateInterval = function () {
                if (vm.refreshInterval) {
                    $interval.cancel(vm.refreshInterval);
                    vm.refreshInterval = $interval(function () {
                        vm.refreshListAndStat();
                    }, vm.refreshPeriod);
                }
            };
        }
    });
'use strict';
/**
 * @ngdoc component
 * @name loopUiApp.component:firmwareJobs
 * @description
 * # firmwareJobs
 */
angular.module('loopUiApp')
    .component('firmwareJobs', {
        templateUrl: '../scripts/components/firmware/firmwareJobs.html',
        controller: function ($q, $state, $stateParams, $mdDialog, $interval, $timeout, $filter, gettextCatalog, ServiceAsyncTask, Service, Commons) {
            var vm = this;
            // Show filter flag
            vm.isShowFilter = false;
            // Flag to show/hide multi selection
            vm.rowSelection = false;
            // Multiple selected jobs
            vm.selectedJobs = [];

            vm.$onInit = function () {
                vm.companyName = $stateParams.companyName;
                vm.projectId = $stateParams.projectId;
                // Filter value
                vm.searchText = '';

                // New job template
                vm.newJob = {
                    details: [],
                    entryID: 0,
                    projectId: vm.projectId,
                    versionName: null
                };

                vm.filterActions = [
                    {
                        label: 'Switch multi-select mode on',
                        icon: 'done_all',
                        buttonClick: vm.toggleMultiSelection,
                    },
                    {
                        label: 'Cancel all scheduled tasks',
                        icon: 'event_busy',
                        buttonClick: function (event) {
                            vm.cancelTasks(event, [], true);
                        },
                    },
                    {
                        label: 'Show/hide filter criteria',
                        icon: 'filter_list',
                        buttonClick: vm.toggleFilter
                    },
                    {
                        label: 'Refresh',
                        icon: 'refresh',
                        buttonClick: function () {
                            vm.refreshJobList(true);
                        }
                    }
                ];

                vm.listActions = [
                    {
                        icon: 'read_more',
                        name: 'View task log',
                        disable: function () { return false; },
                        function: vm.showTaskLog
                    },
                    {
                        icon: 'event_busy',
                        name: 'Cancel task',
                        disable: function (task) {
                            return !vm.isTaskCancelable(task);
                        },
                        function: function (event, task) {
                            vm.cancelTasks(event, [task]);
                        }
                    }
                ];

                vm.multipleActions = [
                    {
                        icon: 'event_busy',
                        name: 'Cancel task',
                        function: vm.cancelTasks
                    }
                ];

                vm.itemsPagination = {
                    limit: 10,
                    page: 1,
                    limitOptions: [10, 50, 100]
                };

                // Init filter object
                vm.initFilter();

                // Order by field
                vm.sortField = '-startTime';

                // Get job list
                vm.refreshJobList(true);

                // Start pulling job list
                vm.startListRefresh();
            };

            vm.$onDestroy = function () {
                $interval.cancel(vm.refreshInterval);
                ServiceAsyncTask.resetCurrentWatchedTask();
            };

            /**
             * Enable/disable multiple selection mode
             */
            vm.toggleMultiSelection = function () {
                vm.rowSelection = !vm.rowSelection;
                vm.filterActions[0].icon = vm.rowSelection ? 'list' : 'done_all';
                vm.filterActions[0].label = vm.rowSelection ? 'Switch multi-select mode on' : 'Switch multi-select mode off';
            };

            /**
             * Get firmware update task list
             * @param isFirstLoad {boolean} - flag of first load
             * @returns {void}
             */
            vm.refreshJobList = function (isFirstLoad) {
                vm.isLoading = true;

                var _dateFrom = vm.filterObject.createdOnFrom ? vm.filterObject.createdOnFrom.getTime() : null;
                var _dateTo = vm.filterObject.createdOnTo ? vm.filterObject.createdOnTo.getTime() + 24 * 60 * 60 * 1000 : null;
                var jobListPromise = Service.api.asyncSubtaskListAll({
                    companyName: vm.companyName,
                    projectId: vm.projectId,
                    taskType: ServiceAsyncTask.taskTypes.FIRMWARE_UPGRADE.code,
                    requestedPage: 0,
                    pageSize: 1000,
                    createdOnFrom: _dateFrom,
                    createdOnTo: _dateTo
                }).$promise;

                // On fist load show loader progress but, but skip it on auto-refresh
                if (isFirstLoad) {
                    vm.jobListPromise = jobListPromise;
                }

                jobListPromise
                    .then(function (data) {
                        vm.jobList = vm.groupByTask(data.elements);
                    })
                    .catch(function (reason) {
                        if (isFirstLoad) {
                            var messageObject = Commons.createErrorObject(reason, 'Get job list failed');
                            Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        }
                        console.log('Error firwareJobList:' + JSON.stringify(reason));
                    })
                    .finally(function () {
                        vm.isLoading = false;
                    });
            };

            /**
             * Group subtasks by taskId, select current subtask
             * @param {Array} items - list of subtasks with tasks 
             */
            vm.groupByTask = function (items) {
                // Find current working subtask
                var findCurrentSubtask = function (subtasks) {
                    // If only DOWNLOAD [num = 0] subtask exist, or DOWNLOAD is in progress, then return it
                    if (!subtasks[1] || subtasks[0].status !== 'SUCCESS') {
                        return subtasks[0];
                    }
                    return subtasks[1];
                };

                /**
                 * Get status text for current subtask
                 * @param {Object} subtask - current subtask object
                 * @returns 
                 */
                var getStatusText = function (subtask) {
                    if (subtask.status === 'ERROR' || subtask.status === 'CANCELING') {
                        return subtask.status;
                    }
                    if (subtask.status === 'CANCEL') {
                        return 'CANCELED';
                    }
                    if (subtask.type === 'FIRMWARE_UPGRADE_DOWNLOAD') {
                        return subtask.status === 'SUCCESS' ? 'SUCCESS' : 'Downloading...';
                    }
                    if (subtask.type === 'FIRMWARE_UPGRADE_EXECUTE' && subtask.status === 'WAITING') {
                        // File downloaded if task contains 2 subtask or if task contains 1 subtask but fwFileName is set
                        var _downloadStatus = subtask.num === 1 || subtask.params && subtask.params.fwFileName ? 'Downloaded.<br>' : '';
                        // Show planned exec time if it set
                        var _planTimeText = subtask.plannedExecTime ? ('Install at <strong>' + $filter('date')(subtask.plannedExecTime, 'yyyy-MM-dd HH:mm') + '</strong>') : '';
                        return _downloadStatus + _planTimeText;
                    }
                    if (subtask.type === 'FIRMWARE_UPGRADE_EXECUTE' && subtask.status !== 'WAITING') {
                        return subtask.status === 'SUCCESS' ? 'SUCCESS' : 'Installing...';
                    }
                };

                // Get file name from version name
                var getFileName = function (versionName) {
                    try {
                        var _parsed = versionName.split('/');
                        return _parsed[_parsed.length - 1];
                    }
                    catch (e) {
                        return versionName;
                    }
                };

                // Get version from version name
                var getVersion = function (versionName) {
                    try {
                        var _parsed = versionName.split('/');
                        return _parsed[2] || 'UNKNOWN';
                    }
                    catch (e) {
                        return 'UNKNOWN';
                    }
                };

                // Group subtasks by taskId
                var _groupedList = items.reduce(function (acc, item) {
                    if (!acc[item.task.id]) {
                        acc[item.task.id] = {
                            id: item.task.id,
                            progress: item.task.progress,
                            status: item.task.status,
                            devicePrettyName: item.subtask.devicePrettyName,
                            deviceId: item.subtask.deviceId,
                            fileName: getFileName(item.subtask.params.versionName),
                            versionName: item.subtask.params.versionName,
                            deviceVersion: item.subtask.params.deviceVersion,
                            newDeviceVersion: item.subtask.params.newDeviceVersion || getVersion(item.subtask.params.versionName),
                            plannedExecTime: item.subtask.plannedExecTime,
                            subtasks: {}
                        };
                    }
                    // Step nums: 0 - DOWNLOAD, 1 - EXECUTE
                    acc[item.task.id].subtasks[item.subtask.num] = item.subtask;
                    return acc;
                }, {});
                // Convert to array and enrich by current subtask
                return Object.keys(_groupedList).map(function (key) {
                    var _task = _groupedList[key];
                    _task.$currentSubtask = findCurrentSubtask(_task.subtasks);
                    _task.$statusText = getStatusText(_task.$currentSubtask);
                    return _task;
                });
            };

            /**
             * Start request list changes pulling
             * @returns {void}
             */
            vm.startListRefresh = function () {
                if (vm.refreshInterval) {
                    $interval.cancel(vm.refreshInterval);
                }

                vm.refreshInterval = $interval(function () {
                    vm.refreshJobList(false);
                }, 10000);
            };

            /**
             * Show job wizard
             * @param {Event} event - event object
             * @returns {void}
             */
            vm.viewJobWizard = function (event) {
                $mdDialog.show({
                    template: '<md-dialog style="width:1100px;"><update-job-dialog></update-job-dialog></md-dialog>',
                    parent: angular.element(document.body),
                    targetEvent: event,
                    clickOutsideToClose: false
                })
                    .then(function (jobDetails) {
                        /**
                         * Enrich subTask object by device version and plannedExecTime
                         * @param {Object} subTask - subtask object
                         * @param {string} type - subtask type
                         * @param {Object} device - device object
                         * @returns {Object} subtask enriched object 
                         */
                        return vm.createJob(jobDetails);
                    })
                    .then(function () {
                        Commons.toastShow('Task was created');
                        // Add pause before task created and task started
                        $timeout(function () {
                            ServiceAsyncTask.refreshTaskList(vm.companyName, vm.projectId);
                            vm.refreshJobList();
                        }, 1000);
                    })
                    .catch(function (reason) {
                        if (reason === false) {
                            return;
                        }
                        console.log('Create job failure:' + JSON.stringify(reason));
                        var messageObject = Commons.createErrorObject(reason, 'Create job failure');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                    });
            };

            /**
             * Create firmware upgrade job
             * @param {Object} jobDetails - job details object 
             * {
             *  selectedDevices: Object, 
             *  selectedFirmware: Object, 
             *  selectedScheduler: Object
             * }
             * @returns {Promise}
             */
            vm.createJob = function (jobDetails) {
                var _enrichSubTaskFn = function (subTask, type, device) {
                    var _subTask = angular.copy(subTask);
                    _subTask.params.deviceVersion = Commons.getObjectProperty(['properties', 'Firmware Version', 'value'], device);
                    if (type === 'FIRMWARE_UPGRADE_EXECUTE') {
                        _subTask.plannedExecTime = jobDetails.selectedScheduler.plannedExecTime || 0;
                    }
                    return _subTask;
                };

                var _promiseList = jobDetails.selectedDevices.map(function (device) {
                    var _isAsyncUpdateSupported = Commons.checkFeatureCapability(device.capabilities, 'DM_V2_API').available;
                    // If device doesn't support DM_V2_API, then don't create subtask FIRMWARE_UPGRADE_DOWNLOAD 
                    var _availableSubtaskTypes = _isAsyncUpdateSupported ? ServiceAsyncTask.taskTypes.FIRMWARE_UPGRADE.subtaskTypes : ['FIRMWARE_UPGRADE_EXECUTE'];
                    var _subtypes = jobDetails.selectedScheduler.type === 'DOWNLOAD' ? ['FIRMWARE_UPGRADE_DOWNLOAD'] : _availableSubtaskTypes;
                    // If device doesn't support DM_V2_API and if DOWNLOAD only is selected, then skip this device
                    if (jobDetails.selectedScheduler.type === 'DOWNLOAD' && !_isAsyncUpdateSupported) {
                        return false;
                    }

                    return ServiceAsyncTask.createTask(
                        ServiceAsyncTask.taskTypes.FIRMWARE_UPGRADE.code,
                        _subtypes,
                        '',
                        [device],
                        {
                            versionName: jobDetails.selectedFirmware.objectName,
                            newDeviceVersion: jobDetails.selectedFirmware.version,
                            allowDelayedUpgrade: jobDetails.selectedScheduler.allowDelayedUpgrade
                        },
                        true,
                        _enrichSubTaskFn,
                        1
                    );
                })
                    .filter(function (promise) { // Remove skipped promises
                        return promise !== false;
                    });

                return $q.all(_promiseList);
            };

            /**
             * Open menu
             * @param {Object} $mdOpenMenu - menu object
             * @param {Event} event - event object
             * @returns {void}
             */
            vm.openMenu = function ($mdOpenMenu, event) {
                $interval.cancel(vm.refreshInterval);
                $mdOpenMenu(event);
                // Start auto-refresh in 10 seconds
                $timeout(vm.startListRefresh, 10000);
            };

            /**
             * Filter jobs by active status
             * @param {Object} job - job object
             * @returns 
             */
            vm.isActiveStatus = function (job) {
                return ['NEW', 'RUNNING'].indexOf(job.status) >= 0;
            };

            /**
             * Filter providerList based on search criteria
             *
             * @param {string} searchText           - search string
             * @return {void}
             */
            vm.onFilter = function (searchText) {
                vm.searchText = searchText;
            };

            /**
             * Filter function for job list
             * @param {Object} job - job object 
             * @returns 
             */
            vm.filter = function (job) {
                if (!vm.searchText) {
                    return true;
                }
                return (job.devicePrettyName + job.fileName + job.deviceVersion + job.newDeviceVersion + job.deviceId).toLowerCase().indexOf(vm.searchText.toLowerCase()) >= 0;
            };

            /**
             * Show/hide filter
             * @returns {void}
             */
            vm.toggleFilter = function () {
                vm.isShowFilter = !vm.isShowFilter;
            };

            /**
             * Open device page
             * @param {String} deviceId - device object
             * @return {void}
             */
            vm.openDeviceDetails = function (deviceId) {
                $state.go('deviceView', {
                    companyName: vm.companyName,
                    projectId: vm.projectId,
                    deviceId: deviceId,
                });
            };

            /**
             * Show task log
             * @param {Object} event - Mouse click event object 
             * @param {Object} subtask - Subtask object
             */
            vm.showTaskLog = function (event, task) {
                ServiceAsyncTask.openTaskDetails(task.id);
            };

            /**
             * Show job status details
             * @param {String} message - error message
             */
            vm.showError = function (message) {
                Commons.showConfirmation(
                    'Details',
                    message,
                    null,
                    null,
                    'Close',
                    null,
                    null);
            };

            /**
             * Init filter object
             */
            vm.initFilter = function () {
                // Set max date form to filter
                vm.maxDate = new Date();
                // Set init date
                var dateFrom = new Date();
                dateFrom.setMonth(dateFrom.getMonth() - 1);


                vm.filterObject = {
                    createdOnFrom: dateFrom,
                    createdOnTo: null
                };
            };

            /**
             * Cancel scheduled tasks
             * @param {Event} event - Mouse click event object 
             * @param {Array} tasks - array of tasks
             * @param {boolean} isAllTasks - flag to cancel all tasks
             * @returns 
             */
            vm.cancelTasks = function (event, tasks, isAllTasks) {
                if ((!angular.isArray(tasks) || tasks.length === 0) && isAllTasks !== true) {
                    return;
                }

                var _cancelFn = function () {
                    var _payload = {
                        taskIds: tasks.map(function (task) {
                            return task.id;
                        }),
                        projectId: vm.projectId,
                        type: ServiceAsyncTask.taskTypes.FIRMWARE_UPGRADE.code
                    };

                    Service.api.asyncTaskCancel(null, _payload).$promise
                        .then(function (data) {
                            var _tasksWithErrors = data.filter(function (task) {
                                return task.cancelStatus === false;
                            });

                            if (_tasksWithErrors.length === 0) {
                                var _message = isAllTasks === true ? 'All scheduled tasks were canceled' : tasks.length > 1 ? 'Tasks were canceled' : 'Task was canceled';
                                Commons.toastShow(_message);
                            } else {
                                var _errorObject = {
                                    status: -1,
                                    message: 'Cancelling failed for ' + _tasksWithErrors.length + (_tasksWithErrors.length > 1 ? ' tasks' : ' task'),
                                    messageDetails: _tasksWithErrors.map(function (task, index) {
                                        return (index + 1) + '. Task ' + task.taskId.substring(0, 5) + ': ' + task.message;
                                    }).join('; ')
                                };
                                Commons.toastError(_errorObject.message, _errorObject.messageDetails, _errorObject.status);
                            }
                            vm.selectedJobs = [];
                            vm.refreshJobList();
                        })
                        .catch(function (reason) {
                            var messageObject = Commons.createErrorObject(reason, 'Cancel task failed');
                            Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        });
                };

                var _message = isAllTasks === true ? 'Are you sure you want to cancel <strong>all</strong> scheduled tasks?' : tasks.length > 1 ? 'Are you sure you want to cancel scheduled tasks?' : 'Are you sure you want to cancel scheduled task?';
                Commons.showConfirmationWarn(
                    gettextCatalog.getString('Confirmation'),
                    gettextCatalog.getString(_message),
                    gettextCatalog.getString('Yes, cancel'),
                    function () {
                        _cancelFn();
                    },
                    gettextCatalog.getString('No'),
                    undefined,
                    event);
            };

            /**
             * Check if it's allow to cancel
             * @param {Object} task - task object 
             * @returns 
             */
            vm.isTaskCancelable = function (task) {
                return ['WAITING', 'NEW'].indexOf(task.status) >= 0 ||
                    task.status === 'RUNNING' && task.$currentSubtask.type === ServiceAsyncTask.taskTypes.FIRMWARE_UPGRADE_DOWNLOAD.code;
            };
        }
    });
'use strict';
/**
 * @ngdoc component
 * @name loopUiApp.component:firmwareFiles
 * @description
 * # firmwareFiles
 */
angular.module('loopUiApp')
    .component('firmwareFiles', {
        templateUrl: '../scripts/components/firmware/firmwareFiles.html',
        bindings: {
            onSelect: '&',          // Select device callback
        },
        controller: function (Service, Commons) {
            var vm = this;
            vm.cm = Commons;
            // Selected firmware list
            vm.items = [];
            // List of available firmware updates
            vm.firmwareList = [];

            vm.$onInit = function () {
                // Generic table setup
                vm.listSetup = {
                    sortField: 'name',
                    rowSelection: true,
                    multipleSelection: false,
                    limit: 10,
                    limitOptions: [10, 50, 100],
                };

                vm.itemsPagination = {
                    limit: vm.listSetup.limit,
                    page: 1,
                    limitOptions: vm.listSetup.limitOptions
                };

                vm.refreshFirmwareList();
            };

            /**
             * Refresh available firmware list
             * @returns {void}
             */
            vm.refreshFirmwareList = function () {
                vm.isLoading = true;
                vm.firmwareListPromise = Service.api.firmwareList().$promise;
                vm.firmwareListPromise
                    .then(function (data) {
                        vm.firmwareList = data;
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Get firmware list failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('firmwareList:' + JSON.stringify(reason));
                    })
                    .finally(function () {
                        vm.isLoading = false;
                    });
            };

            /**
             * Emit event on row select/deselect
             *
             * @returns {void}
             */
            vm.notifySelectionChange = function () {
                vm.onSelect({ items: vm.items });
            };
        }
    });
'use strict';
/**
 * @ngdoc component
 * @name loopUiApp.component:updateScheduler
 * @description
 * # updateScheduler
 */
angular.module('loopUiApp')
    .component('updateScheduler', {
        templateUrl: '../scripts/components/firmware/updateScheduler.html',
        bindings: {
            devicesCapabilities: '<', // Devices capabilities
            onSelect: '&',            // Select scheduler callback
        },
        controller: function ($rootScope, $timeout) {
            var vm = this;

            vm.$onInit = function () {
                // Scheduler model
                vm.scheduler = {
                    type: 'IMMEDIATE',
                    plannedExecTime: null,
                    allowDelayedUpgrade: false,
                    isFormValid: true
                };

                // Scheduler types
                vm.schedulerTypes = [
                    {
                        code: 'IMMEDIATE',
                        name: 'Run now',
                        description: 'Download and install update immediately',
                        isDisabled: function () {
                            return false;
                        }
                    },
                    {
                        code: 'DOWNLOAD',
                        name: 'Download only',
                        description: 'Download the upgrade file to devices (for Edge Devices >= 3.5.0)',
                        isDisabled: vm.isDownloadOnlyDisabled
                    },
                    {
                        code: 'SCHEDULED',
                        name: 'Run on a schedule',
                        description: 'Download immediately (for Edge Devices >= 3.5.0) and install update at the specified time',
                        isDisabled: function () {
                            return false;
                        }
                    }
                ];

                // Minimum date for date picker
                vm.minDate = new Date();

                // Init time
                vm.initTime();

                // Subscribe to time picker change event
                $rootScope.$on('mdpTimePickerUpdated', vm.onTimeChange);

                $timeout(function () {
                    vm.notifySelectionChange();
                }, 0);
            };

            vm.$onChanges = function (changes) {
                if (changes.devicesCapabilities && vm.scheduler && vm.scheduler.type) {
                    // If download only is disabled and type was select as 'DOWNLOAD', then set type to 'immediate'
                    if (vm.scheduler.type === 'DOWNLOAD' && vm.isDownloadOnlyDisabled()) {
                        vm.scheduler.type = 'IMMEDIATE';
                    }
                }
            };

            /**
             * Check devicesCapabilities: if no device supports download only, disable the option
             * @returns {Boolean} - True if download only is disabled
             */
            vm.isDownloadOnlyDisabled = function () {
                return !vm.devicesCapabilities.fullSupport && !vm.devicesCapabilities.partialSupport;
            };

            /**
             * Emit event on row select/deselect
             *
             * @returns {void}
             */
            vm.notifySelectionChange = function () {
                var _plannedExecTime = vm.scheduler && vm.scheduler.plannedExecTime ? vm.scheduler.plannedExecTime.getTime() : null;

                // For SCHEDULED type, check if the form is valid, otherwise, set it to true
                var _scheduler = {
                    type: vm.scheduler.type,
                    plannedExecTime: vm.scheduler.type === 'SCHEDULED' ? _plannedExecTime : null,
                    allowDelayedUpgrade: vm.scheduler.type === 'SCHEDULED' ? vm.scheduler.allowDelayedUpgrade : null,
                    isFormValid: vm.scheduler.type === 'SCHEDULED' ? vm.schedulerForm.$valid : true
                };
                vm.onSelect({ scheduler: _scheduler });
            };

            /**
             * Set plannedExecTime as current time + 2 hours
             */
            vm.initTime = function () {
                var _now = new Date();

                _now.setHours(_now.getHours() + 2);
                _now.setMinutes(0);
                _now.setSeconds(0);
                _now.setMilliseconds(0);

                vm.scheduler.plannedExecTime = _now;
                vm.previousTime = new Date(vm.scheduler.plannedExecTime);
            };

            /**
             * Handle type change
             */
            vm.onTypeChange = function () {
                if (vm.scheduler.type === 'SCHEDULED') {
                    vm.initTime();
                }
                vm.notifySelectionChange();
            };

            /**
             * Handle date change
             * @returns {void}
             */
            vm.onDateChange = function () {
                if (vm.previousTime) {
                    vm.scheduler.plannedExecTime.setHours(vm.previousTime.getHours());
                    vm.scheduler.plannedExecTime.setMinutes(vm.previousTime.getMinutes());
                }
                vm.previousTime = new Date(vm.scheduler.plannedExecTime);

                vm.validateTime();
                vm.notifySelectionChange();
            };

            /**
             * Handle time change
             * @returns {void}
             */
            vm.onTimeChange = function () {
                vm.previousTime = new Date(vm.scheduler.plannedExecTime);

                vm.validateTime();
                vm.notifySelectionChange();
            };

            /**
             * Run validation - to make sure the time is in the future
             * @returns {void}
             */
            vm.validateTime = function () {
                vm.schedulerForm.plannedExecTimeField.$setValidity('mintime', vm.scheduler.plannedExecTime > new Date());
            };
        }
    });
'use strict';
/**
 * @ngdoc component
 * @name loopUiApp.component:updateSummary
 * @description
 * # updateSummary
 */
angular.module('loopUiApp')
    .component('updateSummary', {
        templateUrl: '../scripts/components/firmware/updateSummary.html',
        bindings: {
            selectedFirmware: '<',
            selectedDevices: '<',
            selectedScheduler: '<'
        },
        controller: function () { }
    });
'use strict';
/**
 * @ngdoc component
 * @name loopUiApp.component:updateJobDialog
 * @description
 * # updateJobDialog
 */
angular.module('loopUiApp')
    .component('updateJobDialog', {
        templateUrl: '../scripts/components/firmware/updateJobDialog.html',
        controller: function ($mdDialog, gettextCatalog, Commons) {
            var vm = this;
            // Selected device list
            vm.selectedDevices = [];
            // Selected firmware list
            vm.selectedFirmware = [];
            // Selected scheduler
            vm.selectedScheduler = {};
            // Devices capabilities
            vm.devicesCapabilities = {
                fullSupport: false,
                partialSupport: false,
            };
            // If Docker device exists
            vm.isDockerDeviceExists = false;

            vm.$onInit = function () {
                vm.currentStep = 0;

                //Wizard steps
                vm.wizardSetup = {
                    wizardName: null,
                    steps: [
                        {
                            name: 'Select update image',
                            description: gettextCatalog.getString('Select Software Image'),
                        },
                        {
                            name: 'Select Devices',
                            description: gettextCatalog.getString('Select Target Device(s)'),
                        },
                        {
                            name: 'Schedule',
                            description: gettextCatalog.getString('Setup the scheduler'),
                        },
                        {
                            name: 'Review',
                            description: gettextCatalog.getString('Review and Run'),
                            icon: 'flag'
                        }
                    ]
                };
            };

            /**
             * Check current step for validity.
             *
             * @param {number} step                 - Step number
             * @returns {boolean}                   - True if step data pass validation.
             */
            vm.stepInvalid = function (step) {
                switch (step) {
                    case 0:
                        return vm.selectedFirmware.length === 0;
                    case 1:
                        return vm.selectedDevices.length === 0;
                    case 2:
                        return vm.selectedScheduler.isFormValid === false;
                    default:
                        return false;
                    }
            };

            /**
             * Go to previous step
             *
             * @returns {void}
             */
            vm.previousStep = function () {
                if (vm.currentStep === 0) {
                    return;
                }
                vm.currentStep--;
            };

            /**
             * Go to the next step
             *
             * @returns {void}
             */
            vm.nextStep = function () {
                if (vm.currentStep === vm.wizardSetup.steps.length - 1) {
                    return;
                }
                vm.currentStep++;
            };

            /**
             * Check if is last step of wizard
             *
             * @returns {boolean}           - True if this is last step
             */
            vm.isLastStep = function () {
                return vm.currentStep === vm.wizardSetup.steps.length - 1;
            };

            /**
            * Close dialog window
            * @return {void}
            */
            vm.save = function () {
                var jobDetails = {
                    selectedFirmware: vm.selectedFirmware[0],
                    selectedDevices: vm.selectedDevices,
                    selectedScheduler: vm.selectedScheduler
                };
                $mdDialog.hide(jobDetails);
            };

            /**
             * Select devices callback
             * @param {Array} devices - list of devices 
             */
            vm.onDeviceSelect = function(devices) {
                vm.selectedDevices = devices;
                vm.devicesCapabilities = vm.checkDevicesCapabilities(devices);
            };

            /**
             * Check if devices support DM_V2_API.
             * @param {Array} devices - list of devices 
             * @returns {Object} - 
             * {
             *   fullSupport: boolean, -- all devices support DM_V2_API
             *   partialSupport: boolean -- at least one device support DM_V2_API
             * }
             */
            vm.checkDevicesCapabilities = function (devices) {
                var _supportedDeviceCnt = devices.filter(function(device) {
                    return Commons.checkFeatureCapability(device.capabilities, 'DM_V2_API').available;
                }).length;
                return {
                    fullSupport: _supportedDeviceCnt === devices.length && _supportedDeviceCnt > 0,
                    partialSupport: _supportedDeviceCnt > 0 && _supportedDeviceCnt < devices.length
                };
            };

            /**
             * Call back for device loaded event
             * Check if device list contains docker devices
             * @param {Array} devices - check if device list con 
             */
            vm.onDevicesLoaded = function (devices) {
                vm.isDockerDeviceExists = devices.some(function (device) {
                    return Commons.getDeviceVirtualizationType(device) === 'docker';
                });
            };

            /**
             * Cancel dialog button
             * @return {void}
             */
            vm.cancel = function () {
                $mdDialog.cancel(false);
            };
        }
    });
'use strict';
/**
 * @ngdoc component
 * @name loopUiApp.component:devicesList
 * @description
 * # devicesList
 */
angular.module('loopUiApp')
    .component('devicesList', {
        templateUrl: '../scripts/components/firmware/devicesList.html',
        bindings: {
            projectId: '<',         // Filter by projectId 
            companyName: '<',       // Filter by company name
            multipleSelection: '<', // Allow multi-selection
            deviceType: '<',        // Filter by device type
            hideFilter: '<',        // Hide side nav filter
            onlyOnline: '<',        // Select only only devices
            onlyNonDocker: '<',     // Select only non-docker devices
            onSelect: '&',          // Select device callback
            onLoad: '&'             // Load list callback
        },
        controller: function ($stateParams, Service, Commons) {
            var vm = this;
            //Current project
            vm.projectId = vm.projectId || $stateParams.projectId;
            //Current company
            vm.companyName = vm.companyName || $stateParams.companyName;
            //Device Status object
            vm.deviceStatusObject = {};
            //Selected device list
            vm.selectedDevices = [];
            //Tags list
            vm.tagList = [];
            //Selected tag list
            vm.selectedTags = [];
            //Map of disabled devices
            vm.devicesDisabled = {};
            //Pagination Options
            vm.paginationOptions = {
                totalSize: 0,
                pageNum: 1,
                pagesCount: 0,
                size: 0,
                limit: 25
            };

            // Order settings
            vm.order = '-createdAt';
            vm.orderMap = {
                'createdAt': 'CREATEDON_ASC',
                '-createdAt': 'CREATEDON_DESC',
                'hostname': 'HOSTNAME_ASC',
                '-hostname': 'HOSTNAME_DESC',
                'description': 'DESCRIPTION_ASC',
                '-description': 'DESCRIPTION_DESC',
                'statusTimestamp': 'STATUSTIMESTAMP_ASC',
                '-statusTimestamp': 'STATUSTIMESTAMP_DESC',
                'status': 'ONLINE_ASC',
                '-status': 'ONLINE_DESC',
                'version': 'VERSION_ASC',
                '-version': 'VERSION_DESC',
                'prettyName': 'PRETTY_NAME_ASC',
                '-prettyName': 'PRETTY_NAME_DESC',
            };

            vm.$onInit = function () {
                vm.refreshDeviceList();
                vm.multipleSelection = vm.multipleSelection || false;
            };

            /**
             * Refresh device list
             */
            vm.refreshDeviceList = function () {
                vm.devicesPromise = Service.api.deviceList({
                    projectId: vm.projectId,
                    companyName: vm.companyName,
                    tag: vm.selectedTags,
                    deviceType: vm.deviceType,
                    requestedPage: vm.paginationOptions.pageNum - 1,
                    limit: vm.paginationOptions.limit,
                    onlineOnly: vm.onlyOnline,
                    order: vm.orderMap[vm.order],
                }).$promise;

                vm.devicesPromise
                    .then(function (data) {
                        vm.devicesList = data.elements;
                        vm.devicesList.forEach(function (device) {
                            vm.deviceStatusObject[device.deviceId] = Commons.getDeviceStatusObject(device);
                            vm.devicesDisabled[device.deviceId] = vm.onlyNonDocker && Commons.getDeviceVirtualizationType(device) === 'docker';
                        });

                        vm.paginationOptions.totalSize = data.totalSize;
                        vm.paginationOptions.size = data.size;
                        vm.paginationOptions.pageNum = data.pageNum + 1;
                        vm.paginationOptions.pagesCount = data.pagesCount;

                        vm.onLoad({ devices: vm.devicesList });

                    })
                    .then(function () {
                        return Service.api.deviceTagList({
                            projectId: vm.projectId,
                            companyName: vm.companyName
                        }).$promise;
                    })
                    .then(function (tagList) {
                        vm.tagList = tagList;
                    })
                    .catch(function (reason) {
                        console.log('Error refreshDeviceList:' + JSON.stringify(reason));
                    });
            };

            /**
             * Tag select handler
             * @param  {String} current tag
             * @param  {Array} tag List
             *
             */
            vm.toggleTag = function (item, list) {
                var idx = list.indexOf(item);
                if (idx > -1) {
                    list.splice(idx, 1);
                } else {
                    list.push(item);
                }
                //Refresh devices list
                vm.selectedTags = list;
                vm.refreshDeviceList();
            };

            /**
             * Emit event on row select/deselect
             *
             * @returns {void}
             */
            vm.notifySelectionChange = function () {
                vm.onSelect({ devices: vm.selectedDevices });
            };
        }
    });
'use strict';
/**
 * @ngdoc component
 * @name loopUiApp.component:applicationsList
 * @description
 * # applicationsList
 */
angular.module('loopUiApp')
    .component('applicationsList', {
        templateUrl: '../scripts/components/applicationsList/applicationsList.html',
        controller: function ($stateParams, licenseCheck, appConfig, Auth, Service, Commons) {
            var vm = this;

            /**
             * Controller initialization
             *
             * @returns {void}
             *
             */
            vm.$onInit = function () {
                vm.currentProjectId = $stateParams.projectId;

                vm.marketplaceCatalogLink = appConfig.__env.marketplaceCatalogLink;
                vm.marketplaceCatalogLogo = appConfig.__env.marketplaceCatalogLogo || 'marketplace.svg';
                vm.grafanaLink = appConfig.__env.grafanaLink || '/grafana';
                vm.grafanaLogo = appConfig.__env.grafanaLogo || 'grafana.svg';
                vm.deploymentType = appConfig.__env.deploymentType;

                vm.applications = [
                    {
                        name: 'Marketplace',
                        svg: './images/' + vm.marketplaceCatalogLogo,
                        id: 'Marketplace-menu-logo',
                        appScope: 'project',
                        description: function () {
                            return '<b>Marketplace</b><br>Consists of catalogs that contain third-party and custom Docker container-based applications';
                        },
                        on: true,
                        url: vm.marketplaceCatalogLink,
                        status: '',
                        sync: '',
                        disabled: function() {
                            return !licenseCheck.isMarketplaceAvailable();
                        },
                        visible: function() {
                            return true;
                        },
                        commands: {
                            start: function() {
                                vm.goToLink(vm.marketplaceCatalogLink);
                            }
                        }
                    },
                    {
                        name: 'Grafana Dashboards',
                        svg: './images/' + vm.grafanaLogo,
                        id: 'Grafana-menu-logo',
                        appScope: 'project',
                        description: function () {
                            return '<b>Grafana Dashboards</b><br>Analytics and interactive visualization web application';
                        },
                        on: true,
                        url: vm.grafanaLink,
                        status: '',
                        sync: '',
                        disabled: function () {
                            return false;
                        },
                        visible: function() {
                            return vm.deploymentType !== 'kubernetes';
                        },
                        commands: {
                            start: vm.startGrafana
                        }
                    }
                ];

                // Check application status
                vm.applications.forEach(function (application) {
                    if (application.commands && application.commands.status) {
                        application.commands.status(application);
                    }
                });
            };

            /**
             * Open Grafana Dashboards
             * @param {Object} application - application object
             * @returns {void}
             */
            vm.startGrafana = function (application) {
                var _openProfile = function () {
                    var url = Auth.createAccountUrl();
                    window.open(url);
                };
                // Check is email exists. Do not allow open grafana without email
                Auth.loadUserProfile()
                .then(function (data) {
                    if (!data.email) {
                        Commons.showConfirmation(
                            'Email is empty ',
                            'The user <strong>' + data.username + '</strong> doesn\'t have email. ' +
                            'Email is required parameter to open <strong>' + application.name + '</strong>.<br>' +
                            'Please add email in the profile settings and try again.',
                            'Open profile',
                            _openProfile,
                            'Cancel',
                            null,
                            null);
                    } else {
                        var grafanaOrgId = Commons.companyData && Commons.companyData.project && Commons.companyData.project.grafanaOrgId ? 
                        Commons.companyData.project.grafanaOrgId : 0;
                        var grafanaOrgUri = grafanaOrgId >= 0 ? '/?orgId=' + Commons.companyData.project.grafanaOrgId : '';
                        
                        Commons.toastShow('Synchronizing with Grafana...');
                        // In case of grafanaOrgId = 0 start syncronization
                        if (grafanaOrgId === 0){
                            Service.api.projectGrafanaSync({ projectId: vm.currentProjectId }).$promise
                            .then(function(data) {
                                Commons.toastShow('Synchronization finished');
                                // Use orgId from sync response
                                if (data.orgId) {
                                    grafanaOrgUri = '/?orgId=' + data.orgId;
                                    Commons.companyData.project.grafanaOrgId = data.orgId;
                                }
                                vm.goToLink(application.url + grafanaOrgUri);
                            })
                            .catch(function (reason) {
                                console.log('Error projectGrafanaSync:' + JSON.stringify(reason));
                                var messageObject = Commons.createErrorObject(reason, 'Synchronization with Grafana failed');
                                Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                            });
                        } else { // Else start sync projects users with grafana
                            Service.api.projectGrafanaSyncCurrentUser({ 
                                orgId: grafanaOrgId, 
                                projectId: vm.currentProjectId, 
                            }).$promise
                            .then(function() {
                                Commons.toastShow('Synchronization finished');
                                vm.goToLink(application.url + grafanaOrgUri);
                            })
                            .catch(function (reason) {
                                console.log('Error projectGrafanaSyncCurrentUser:' + JSON.stringify(reason));
                                var messageObject = Commons.createErrorObject(reason, 'Sync project\'s users with Grafana failed');
                                Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                            });
                        }
                    }
                })
                    .catch(function (reason) {
                        console.log('Error loadUserProfile:' + JSON.stringify(reason));
                    });
            };

            /**
             * Toggle application status and handle API response
             * @param {Object} application - application object
             * @returns {void}
             */
            vm.toggleApplicationStatus = function (application) {
                switch (application.on) {
                case true:
                    application.commands.start(application);
                    break;
                case false:
                    application.commands.stop(application);
                    break;
                }
            };

            /**
             * Syncronize application and open application URL
             *
             * @param {Object} application - application object
             * @returns {void}
             */
            vm.goToApplication = function (application) {
                if (application.commands && application.commands.sync) {
                    application.commands.sync(application);
                }
                if (application.commands && application.commands.start &&
                    vm.isFunction(application.commands.start)) {
                    application.commands.start(application);
                }
            };

            /**
             * Check is value type of function
             * @param {*} value - value to check
             * @returns {boolean} - is it function
            */
            vm.isFunction = function (value) {
                return typeof value === 'function';
            };

            /**
             * open link in a new tab
             *
             * @param {String} url - app url
             * @return {undefined}
             */
            vm.goToLink = function (url) {
                if (url) {
                    window.open(url, '_blank');
                }
                else {
                    Commons.toastShow('Error with URL');
                }
            };
        }
    });

'use strict';
/**
 * @ngdoc component
 * @name loopUiApp.component:certificatesList
 * @description
 * # certificatesList
 */
angular.module('loopUiApp')
    .component('certificatesList', {
        templateUrl: '../scripts/components/certificates/certificatesList/certificatesList.html',
        controller: function ($scope, $stateParams, $state, $mdDialog, appConfig, Service, Commons) {
            var vm = this;
            vm.itemList = [];
            vm.selectedItems = [];
            vm.filterStr = '';
            vm.filterStatus = null;
            vm.filterIssuer = '';
            vm.filterIssuedOnDate = {
                from: null,
                to: null
            };
            vm.filterExpiresAfterDate = {
                from: null,
                to: null
            };

            vm.$onInit = function () {
                vm.projectId = $stateParams.projectId;

                // Init pagination object
                vm.itemsPagination = {
                    limitOptions: [10, 50, 100],
                    limit: 10,
                    page: 1,
                };

                // List of filter actions
                vm.additionalActions = [{
                    label: 'Refresh',
                    icon: 'refresh',
                    buttonClick: vm.refreshList
                }];

                // List row actions
                vm.listActions = [
                    {
                        name: 'Issue a new certificate',
                        icon: 'add',
                        function: vm.openNewCertDialog
                    },
                    {
                        name: 'Upload a new certificate',
                        icon: 'upload',
                        function: vm.openUploadCertDialog
                    },
                    {
                        name: 'Reset to Edge default',
                        icon: 'restart_alt',
                        function: vm.resetToDefault
                    }
                ];

                vm.sortField = 'expiresAfter';
                vm.sortMap = {
                    'deviceName': 'DEVICENAME_ASC',
                    '-deviceName': 'DEVICENAME_DESC',
                    'deviceFriendlyName': 'DEVICEFRIENDLYNAME_ASC',
                    '-deviceFriendlyName': 'DEVICEFRIENDLYNAME_DESC',
                    'authority': 'AUTHORITY_ASC',
                    '-authority': 'AUTHORITY_DESC',
                    'subject': 'SUBJECT_ASC',
                    '-subject': 'SUBJECT_DESC',
                    'issuer': 'ISSUER_ASC',
                    '-issuer': 'ISSUER_DESC',
                    'issuedOn': 'ISSUEDON_ASC',
                    '-issuedOn': 'ISSUEDON_DESC',
                    'expiresAfter': 'EXPIRESAFTER_ASC',
                    '-expiresAfter': 'EXPIRESAFTER_DESC',
                    'isOnline': 'DEVICEONLINESTATUS_ASC',
                    '-isOnline': 'DEVICEONLINESTATUS_DESC'
                };

                // Deployment source map
                vm.originMap = {
                    'MGR': {
                        name: appConfig.__env.productName,
                        code: 'Central',
                        cssClass: 'ml-model-badge__success'
                    },
                    'EDGE': {
                        name: appConfig.__env.supportDeviceName,
                        code: 'Local',
                        cssClass: 'ml-model-badge__warning'
                    },
                    'UNKNOWN': {
                        name: 'Unknown',
                        code: 'Unknown',
                        cssClass: ''
                    }
                };

                // Map of possible authorities
                vm.authorityMap = {
                    'LOCAL': appConfig.__env.productName,
                    'DIGICERT': 'DigiCert IoT Trust Manager',
                    'UNKNOWN': 'Unknown'
                };

                // Settings for table filters
                vm.filterObj = {
                    isOnline: {
                        type: 'select',
                        multiple: false,
                        name: 'Edge Device Status',
                        selectedValue: null,
                        defaultValue: null,
                        values: [{
                            code: true,
                            name: 'Online'
                        },
                        {
                            code: false,
                            name: 'Offline'
                        }],
                        visible: false,
                        action: function (value) {
                            vm.filterStatus = value;
                            vm.refreshList();
                        }
                    },
                    issuer: {
                        type: 'string',
                        multiple: false,
                        name: 'Issuer',
                        selectedValue: null,
                        defaultValue: null,
                        values: [],
                        visible: false,
                        action: function (value) {
                            vm.filterIssuer = value;
                            vm.refreshList();
                        }
                    },
                    issuedOn: {
                        type: 'date',
                        multiple: false,
                        name: 'Issue Date',
                        selectedValue: null,
                        defaultValue: {
                            from: null,
                            to: null
                        },
                        values: [],
                        visible: false,
                        action: function (value) {
                            vm.filterIssuedOnDate = value;
                            vm.refreshList();
                        }
                    },
                    expiresAfter: {
                        type: 'date',
                        multiple: false,
                        name: 'Expiry Date',
                        selectedValue: null,
                        defaultValue: {
                            from: null,
                            to: null
                        },
                        values: [],
                        visible: false,
                        action: function (value) {
                            vm.filterExpiresAfterDate = value;
                            vm.refreshList();
                        }
                    }
                };

                vm.refreshList();
            };

            /**
             * Get certificates list
             */
            vm.refreshList = function () {
                vm.selectedItems = [];

                vm.itemListPromise = Service.api.deviceCertificatesList({
                    projectId: vm.projectId,
                    limit: vm.itemsPagination.limit,
                    requestedPage: vm.itemsPagination.page - 1,
                    filter: vm.filterStr,
                    isOnline: vm.filterStatus,
                    issuer: vm.filterIssuer,
                    order: vm.sortMap[vm.sortField],
                    expiresAfterFrom: vm.filterExpiresAfterDate.from ? vm.filterExpiresAfterDate.from.setHours(0, 0, 0, 0) : null,
                    expiresAfterTo: vm.filterExpiresAfterDate.to ? vm.filterExpiresAfterDate.to.setHours(23, 59, 59, 59) : null,
                    issuedOnFrom: vm.filterIssuedOnDate.from ? vm.filterIssuedOnDate.from.setHours(0, 0, 0, 0) : null,
                    issuedOnTo: vm.filterIssuedOnDate.to ? vm.filterIssuedOnDate.to.setHours(23, 59, 59, 59) : null
                }).$promise;

                vm.itemListPromise
                    .then(function (data) {
                        vm.totalItems = data.totalSize;
                        vm.itemList = data.elements
                            .map(function (item) {
                                // Enrich item with additional properties
                                item.$validityPeriod = vm.getValidityPeriod(item.issuedOn, item.expiresAfter);
                                item.$certStatusClass = vm.certStatusClass(item);
                                return item;
                            });
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Get certificates failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error certificatesList:' + JSON.stringify(reason));
                    });
            };

            /**
             * Open new certificate dialog
             * @param {Event} event - mouse click event
             * @param {Object} item - device/certificate object
             */
            vm.openNewCertDialog = function (event, item) {
                var scope = angular.extend($scope.$new(true), {
                    certificate: item,
                });

                $mdDialog.show({
                    template: '<md-dialog aria-label="Issue New Certificate" style="width: 600px;">' +
                        '<certificate-new-dialog certificate="certificate"></certificate-new-dialog>' +
                        '</md-dialog>',
                    parent: angular.element(document.body),
                    targetEvent: event,
                    scope: scope,
                    clickOutsideToClose: false
                })
                    .then(function (data) {
                        if (data) {
                            vm.refreshList();
                        }
                    });
            };

            /**
             * Open upload certificate dialog
             * @param {Event} event - mouse click event
             * @param {Object} item - device/certificate object
             */
            vm.openUploadCertDialog = function (event, item) {
                var _uploadFn = function (data) {
                    return Service.api.deviceCertificateUserDefined({
                        projectId: item.projectId,
                        deviceId: item.deviceId
                    }, data).$promise;
                };

                var scope = angular.extend($scope.$new(true), {
                    uploadFn: _uploadFn
                });

                $mdDialog.show({
                    template: '<md-dialog aria-label="Upload Certificate" style="width: 600px;">' +
                        '<certificate-upload-dialog upload-fn="uploadFn"></certificate-upload-dialog>' +
                        '</md-dialog>',
                    parent: angular.element(document.body),
                    targetEvent: event,
                    scope: scope,
                    clickOutsideToClose: false
                })
                    .then(function () {
                        vm.refreshList();
                    });
            };

            /**
             * Reset certificate to the default Edge certificate
             * @param {Event} event - mouse click event
             * @param {Object} item - device/certificate object
             */
            vm.resetToDefault = function (event, item) {
                var _resetFunction = function () {
                    return Service.api.deviceCertificateReset({
                        projectId: vm.projectId,
                        deviceId: item.deviceId
                    }).$promise;
                };

                var scope = angular.extend($scope.$new(true), {
                    certificate: item,
                    resetFunction: _resetFunction
                });

                $mdDialog.show({
                    template: '<md-dialog aria-label="Reset Certificate" style="width: 600px;">' +
                        '<certificate-reset-dialog certificate="certificate" reset-fn="resetFunction"></certificate-reset-dialog>' +
                        '</md-dialog>',
                    parent: angular.element(document.body),
                    targetEvent: event,
                    scope: scope,
                    clickOutsideToClose: false
                })
                    .then(function () {
                        vm.refreshList();
                    });

            };

            /**
             * Bulk action on
             * @param {Event} event - mouse click event 
             */
            vm.viewCertificateDeployDialog = function (event) {
                var _selectedItems = angular.copy(vm.selectedItems) || [];
                // Create an isolated scope to pass to the component
                var scope = angular.extend($scope.$new(true), {
                    preselectedDevices: _selectedItems.map(function (device) {
                        return {
                            deviceId: device.deviceId,
                            deviceFriendlyName: device.deviceFriendlyName
                        };
                    }) || undefined,
                });

                $mdDialog.show({
                    template: '<md-dialog aria-label="Bulk Actions">' +
                        '<certificate-deploy-dialog preselected-devices="preselectedDevices"></certificate-deploy-dialog>' +
                        '</md-dialog>',
                    parent: angular.element(document.body),
                    targetEvent: event,
                    scope: scope,
                    clickOutsideToClose: false
                })
                    .then(function () {
                        vm.refreshList();
                    });
            };

            /**
             * Open device page
             * @return {void}
             */
            vm.openDeviceDetails = function (deviceId) {
                $state.go('deviceView', {
                    companyName: $stateParams.companyName,
                    projectId: $stateParams.projectId,
                    deviceId: deviceId
                });
            };

            /**
             * Handle filter open event
             * @param {Event} event - mouse click event 
             * @param {String} field - name of the field that's filtered
             */
            vm.onFilter = function (event, field) {
                // Position for filter menu
                var _leftPosition = event.clientX - 90 + 'px';
                var _topPosition = event.clientY + 10 + 'px';
                var scope = angular.extend($scope.$new(true), {
                    leftPosition: _leftPosition,
                    topPosition: _topPosition,
                    filterObject: vm.filterObj[field]
                });
                $mdDialog.show({
                    template: '<md-dialog class="md-table-filter" ng-style="{\'left\': leftPosition, \'top\': topPosition}" aria-label="Filter menu">' +
                        '<filter-menu filter-object="filterObject"></filter-menu>' +
                        '</md-dialog>',
                    clickOutsideToClose: true,
                    skipHide: true,
                    scope: scope,
                    hasBackdrop: false,
                })
                    .then(function (result) {
                        vm.itemsPagination.page = 1;
                        if (result.use === true) {
                            vm.filterApplyHandler(field, result.value);
                        } else {
                            vm.filterResetHandler(field);
                        }
                    });
            };

            /**
             * Handle filter apply
             * @param {string} field - field name
             * @param {any} value - value from the filter
             */
            vm.filterApplyHandler = function (field, value) {
                vm.filterObj[field].visible = true;
                vm.filterObj[field].selectedValue = value;
                vm.filterObj[field].action(value);
            };

            /**
             * On filter reset: set value to default and hide filter icon
             * @param {string} field - field name
             */
            vm.filterResetHandler = function (field) {
                vm.filterObj[field].visible = false;
                vm.filterObj[field].selectedValue = angular.copy(vm.filterObj[field].defaultValue);
                vm.filterObj[field].action(vm.filterObj[field].defaultValue);
            };

            /**
             * Handle filter search
             * @param {string} str - filter string
             */
            vm.filter = function (str) {
                vm.filterStr = str;
                vm.itemsPagination.page = 1;
                vm.refreshList();
            };

            /**
             * Reset all filters
             */
            vm.resetFilters = function () {
                vm.filterStr = '';
                vm.filterStatus = null;
                vm.filterIssuedOnDate = {
                    from: null,
                    to: null
                };
                vm.filterExpiresAfterDate = {
                    from: null,
                    to: null
                };
                Object.keys(vm.filterObj).forEach(function (key) {
                    vm.filterObj[key].selectedValue = angular.copy(vm.filterObj[key].defaultValue);
                    vm.filterObj[key].visible = false;
                });
                vm.itemsPagination.page = 1;
                vm.refreshList();
            };

            /**
             * Handle sorting change
             */
            vm.onSort = function () {
                vm.itemsPagination.page = 1;
                vm.refreshList();
            };

            /**
             * Get validity period between two timestamps in days
             * @param {number} ts1 - timestamp 1
             * @param {number} ts2 - timestamp 2
             * @returns 
             */
            vm.getValidityPeriod = function (ts1, ts2) {
                if (!ts1 || !ts2) {
                    return '';
                }
                return Math.floor((ts2 - ts1) / (24 * 60 * 60 * 1000));
            };

            /**
             * Return cert CSS class based on expired date
             * If less than 30 days then 'text-error' 'text-success'
             * @param {string}  - cert object
             * @returns 
             * 
             */
            vm.certStatusClass = function (item) {
                var _maxDate = Date.now() + 30 * 24 * 60 * 60 * 1000;
                return item.expiresAfter < _maxDate ? 'text-error' : 'text-success';
            };

            /**
             * Get human readable deployment source
             * @param {string} src - deployment source
             * @returns 
             */
            vm.getDeploymentSource = function (src) {
                return vm.originMap[src] || vm.originMap.UNKNOWN;
            };

            /**
             * Is data available after load
             * @return {boolean} - data exist flag
             */
            vm.showNoData = function () {
                return !vm.itemList || vm.itemList.length === 0 &&
                    !(vm.itemListPromise && vm.itemListPromise.$$state && vm.itemListPromise.$$state.status === 0);
            };

            /**
             * Check if filter is set
             * @return {boolean} - filter set flag
             */
            vm.isFilterSet = function () {
                return vm.filterStr || vm.filterStatus || vm.filterIssuer || vm.filterIssuedOnDate.from || vm.filterExpiresAfterDate.from;
            };
        }
    });
'use strict';
/**
 * @ngdoc component
 * @name loopUiApp.component:certificateNewDialog
 * @description
 * # certificateNewDialog
 */
angular.module('loopUiApp')
    .component('certificateNewDialog', {
        templateUrl: '../scripts/components/certificates/certificateNewDialog/certificateNewDialog.html',
        bindings: {
            certificate: '<'
        },
        controller: function ($mdDialog, appConfig, Service, Commons) {
            var vm = this;
            vm.isDigicertAvailable = false;
            vm.settings = {};
            vm.isLoading = false;
            vm.isSaving = false;
            vm.status = '';

            vm.$onInit = function () {
                // IPv4, IPv6, or Domain validation logic
                vm.ipv4Regex = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
                vm.ipv6Regex = /^([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}$|^([0-9a-fA-F]{1,4}:){1,7}:?$/;
                vm.domainRegex = /^(?!-)[A-Za-z0-9-]{1,63}(?<!-)(\.[A-Za-z0-9-]{1,63})*\.[A-Za-z]{2,6}$/;

                // Map of the possible authorities
                vm.authorityList = [{
                    code: 'LOCAL',
                    name: appConfig.__env.productName,
                    disabled: function () {
                        return false;
                    }
                },
                {
                    code: 'DIGICERT',
                    name: 'DigiCert IoT Trust Manager',
                    disabled: function () {
                        return !vm.isDigicertAvailable;
                    }
                }];

                // Load DigiCert settings
                vm.getDigicertSettings();
                // Load default settings
                vm.getDefaultSettings(vm.certificate);
            };

            /**
             * Load certificate default settings for particular device
             * @param {object} certificate - certificate/device object
             */
            vm.getDefaultSettings = function (certificate) {
                vm.isLoading = true;
                Service.api.deviceCertificateSettings({
                    projectId: certificate.projectId,
                    deviceId: certificate.deviceId
                }).$promise
                    .then(function (data) {
                        vm.settings = data;
                        vm.settings.authority = data.authority || vm.authorityList[0].code;
                        vm.settings.sansListStr = vm.settings.sansList.join(',');
                        vm.settings.dnsListStr = vm.settings.dnsList.join(',');
                        vm.settings.projectId = certificate.projectId;
                        vm.settings.deviceId = certificate.deviceId;
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Get certificate setting failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error deviceCertificateSettings:' + JSON.stringify(reason));
                    })
                    .finally(function () {
                        vm.isLoading = false;
                    });
            };

            /**
             * Load DigiCert settings
             */
            vm.getDigicertSettings = function () {
                Service.api.domainSslDigicert().$promise
                    .then(function (data) {
                        // Disable DigiCert option if DigiCert params are not defined
                        vm.isDigicertAvailable = !!data.profileId;
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Fail to get DigiCert settings');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error domainSslDigicert:' + JSON.stringify(reason));
                    });
            };

            /**
             * Emit save event
             */
            vm.save = function () {
                vm.isSaving = true;
                vm.status = 'Initializing. Please wait...';
                var _payload = angular.copy(vm.settings);
                _payload.sansList = vm.stringToArray(_payload.sansListStr);
                _payload.dnsList = vm.stringToArray(_payload.dnsListStr);
                delete _payload.sansListStr;
                delete _payload.dnsListStr;
                Service.api.deviceCertificateNew(null, _payload).$promise
                    .then(function () {
                        Commons.toastShow('Certificate issued successfully');
                        $mdDialog.hide(_payload);
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Issue certificate failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error deviceCertificateNew:' + JSON.stringify(reason));
                    })
                    .finally(function () {
                        vm.isSaving = false;
                        vm.status = '';
                    });

            };

            /**
             * Convert comma-separated string to array and remove spaces
             * @param {string} str - comma-separated string
             * @returns Array
             */
            vm.stringToArray = function (str) {
                if (!str || str.length === 0) {
                    return [];
                }
                return str.split(',').map(function (item) {
                    return item.trim();
                });
            };

            /**
             * Check if IP address is valid IPv4 or IPv6
             * @param {string} value - form value
             * @returns {boolean}
             */
            vm.ipValidator = function (value) {
                if (vm.ipv4Regex.test(value) || vm.ipv6Regex.test(value)) {
                    return true;
                }
                return false;
            };

            /**
             * Check if value is valid IP address or Domain
             * @param {string} value - form value
             * @returns {boolean}
             */
            vm.ipOrDomainValidator = function (value) {
                if (vm.ipv4Regex.test(value) || vm.ipv6Regex.test(value) || vm.domainRegex.test(value)) {
                    return true;
                }
                return false;
            };

            /**
             * Check if SAN list is valid
             */
            vm.validateSanList = function () {
                var _sanList = vm.stringToArray(vm.settings.sansListStr);
                var isInvalid = _sanList.some(function (san) {
                    return !vm.ipOrDomainValidator(san);
                });
                vm.form.sansListField.$setValidity('ipOrDomainValid', !isInvalid);
            };

            /**
             * Check if DNS list is valid
             */
            vm.validateDnsList = function () {
                var _dnsList = vm.stringToArray(vm.settings.dnsListStr);
                var isInvalid = _dnsList.some(function (dns) {
                    return !vm.ipValidator(dns);
                });
                vm.form.dnsListField.$setValidity('ipValid', !isInvalid);
            };

            /**
             * Cancel dialog button
             * @return {void}
             */
            vm.cancel = function () {
                $mdDialog.cancel(false);
            };
        }
    });
'use strict';
/**
 * @ngdoc component
 * @name loopUiApp.component:certificateResetDialog
 * @description
 * # certificateResetDialog
 */
angular.module('loopUiApp')
    .component('certificateResetDialog', {
        templateUrl: '../scripts/components/certificates/certificateResetDialog/certificateResetDialog.html',
        bindings: {
            certificate: '<',
            resetFn: '<'
        },
        controller: function ($mdDialog, $timeout, Commons) {
            var vm = this;
            vm.status = '';

            /**
             * Upload certificate
             */
            vm.reset = function () {
                vm.isLoading = true;
                vm.status = 'Resetting...';
                vm.resetFn()
                    .then(function () {
                        vm.status = 'Initializing. Please wait...';
                        return $timeout(function () {
                            Commons.toastShow('Certificate has been reset');
                            $mdDialog.hide();
                        }, 10000);
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Reset failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error deviceCertificateReset:' + JSON.stringify(reason));
                    })
                    .finally(function () {
                        vm.isLoading = false;
                        vm.status = '';
                    });
            };

            /**
             * Cancel dialog button
             * @return {void}
             */
            vm.cancel = function () {
                $mdDialog.cancel(false);
            };
        }
    });
'use strict';
/**
 * @ngdoc component
 * @name loopUiApp.component:certificateUploadDialog
 * @description
 * # certificateUploadDialog
 */
angular.module('loopUiApp')
    .component('certificateUploadDialog', {
        templateUrl: '../scripts/components/certificates/certificateUploadDialog/certificateUploadDialog.html',
        bindings: {
            uploadFn: '<'
        },
        controller: function ($mdDialog, $timeout, Commons) {
            var vm = this;
            vm.isLoading = false;
            vm.status = '';

            /**
             * Upload certificate
             */
            vm.save = function () {
                vm.isLoading = true;
                vm.status = 'Uploading...';
                var _certificate = vm.certificateFiles ? vm.certificateFiles[0] : null;
                var _privateKey = vm.privateKeyFiles ? vm.privateKeyFiles[0] : null;
                var _caCertificate = vm.caCertificateFiles ? vm.caCertificateFiles[0] : null;
                var formData = new FormData();
                formData.append('certificate', _certificate);
                formData.append('privateKey', _privateKey);
                formData.append('caCertificate', _caCertificate);
                vm.uploadFn(formData)
                    .then(function () {
                        vm.status = 'Initializing. Please wait...';
                        return $timeout(function() {
                            Commons.toastShow('Certificate uploaded');
                            $mdDialog.hide();
                        }, 10000);
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Upload certificate failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error deviceCertificateUserDefined:' + JSON.stringify(reason));
                    })
                    .finally(function () {
                        vm.isLoading = false;
                        vm.status = '';
                    });
            };

            /**
             * Cancel dialog button
             * @return {void}
             */
            vm.cancel = function () {
                $mdDialog.cancel(false);
            };
        }
    });
'use strict';
/**
 * @ngdoc component
 * @name loopUiApp.component:certificateDeployDialog
 * @description
 * # certificateDeployDialog
 */
angular.module('loopUiApp')
    .component('certificateDeployDialog', {
        bindings: {
            preselectedDevices: '<',
        },
        templateUrl: '../scripts/components/certificates/certificateDeployDialog/certificateDeployDialog.html',
        controller: function ($state, $stateParams, $mdDialog, gettextCatalog, appConfig, ServiceAsyncTask, Service, Commons) {
            var vm = this;
            vm.selectedDevices = [];
            vm.currentStep = 0;
            vm.currentStepCode = 'DEVICES';
            vm.isDigicertAvailable = false;

            vm.$onInit = function () {
                vm.companyName = $stateParams.companyName;
                vm.projectId = $stateParams.projectId;

                //Wizard steps
                vm.wizardSetup = {
                    wizardName: null,
                    steps: [
                        {
                            code: 'DEVICES',
                            name: 'Select Devices',
                            description: gettextCatalog.getString('Select Target Device(s)'),
                        },
                        {
                            code: 'ACTIONS',
                            name: 'Select Action',
                            description: gettextCatalog.getString('Select the actions to perform'),
                        },
                        {
                            code: 'REVIEW',
                            name: 'Review',
                            description: gettextCatalog.getString('Review and Run'),
                        },
                        {
                            code: 'RESULT',
                            name: 'Result',
                            description: gettextCatalog.getString('Result'),
                            icon: 'flag'
                        }
                    ]
                };

                if (vm.preselectedDevices && vm.preselectedDevices.length > 0) {
                    // Remove devices step if devices are preselected
                    vm.wizardSetup.steps = vm.wizardSetup.steps.filter(function (item) {
                        return item.code !== 'DEVICES';
                    });
                    vm.currentStepCode = 'ACTIONS';
                    vm.selectedDevices = angular.copy(vm.preselectedDevices);
                }

                // Selected action
                vm.actionType = 'RESET';

                // List of available actions
                vm.bulkActions = {
                    RESET: {
                        name: 'Reset to Edge default certificate',
                        description: 'Reset the certificate to the default certificate that comes with the Edge device',
                    },
                    ISSUE: {
                        name: 'Issue a new certificate',
                        description: 'Issue a new certificate for the Edge device'
                    }
                };

                // Map of the possible authorities
                vm.authorityList = [{
                    code: 'LOCAL',
                    name: appConfig.__env.productName,
                    disabled: function () {
                        return false;
                    }
                },
                {
                    code: 'DIGICERT',
                    name: 'DigiCert IoT Trust Manager',
                    disabled: function () {
                        return !vm.isDigicertAvailable;
                    }
                }];

                // Use these as default action parameters
                vm.defaultActionParams = {
                    authority: vm.authorityList[0],
                    ttlDays: 2555
                };

                // Setup result list
                vm.resultListSetup = {
                    sortField: 'name',
                    showIndex: false,
                    editable: false,
                    removable: false,
                    limit: 10,
                    limitOptions: [10, 50, 100],
                    fields: [
                        {
                            name: 'Edge Device Id',
                            column: 'deviceId',
                            link: true,
                            limit: 5,
                            style: '{"width": "50px"}',
                            fieldAction: function (item) {
                                $state.go('deviceView', {
                                    companyName: vm.companyName,
                                    projectId: vm.projectId,
                                    deviceId: item.deviceId,
                                    selectedTab: 'apps'
                                });
                            }
                        },
                        {
                            name: 'Friendly Name',
                            column: 'devicePrettyName'
                        },
                        {
                            name: 'Message',
                            column: 'msg'
                        },
                        {
                            name: 'Status',
                            label: function (item) {
                                return item.status;
                            },
                            iconButton: true,
                            style: '{"width": "50px"}',
                            iconName: function (item) {
                                switch (item.status) {
                                    case 'NEW':
                                        return 'schedule';
                                    case 'ERROR':
                                        return 'highlight_off';
                                    case 'SUCCESS':
                                        return 'check_circle_outline';
                                    default:
                                        return 'help_outline';
                                }
                            }
                        }
                    ]
                };

                // Init actionParams
                vm.onTypeChange();

                // Load DigiCert settings
                vm.getDigicertSettings();
            };

            /**
             * Load DigiCert settings
             */
            vm.getDigicertSettings = function () {
                Service.api.domainSslDigicert().$promise
                    .then(function (data) {
                        // Disable DigiCert option if DigiCert params are not defined
                        vm.isDigicertAvailable = !!data.profileId;
                    })
                    .catch(function (reason) {
                        console.log('Error domainSslDigicert:' + JSON.stringify(reason));
                    });
            };


            /**
             * Handle action type change
             */
            vm.onTypeChange = function () {
                vm.actionParams = vm.actionType === 'ISSUE' ? angular.copy(vm.defaultActionParams) : null;
            };

            /**
             * Check current step for validity.
             *
             * @param {number} step                 - Step number
             * @returns {boolean}                   - True if step data pass validation.
             */
            vm.stepInvalid = function (code) {
                switch (code) {
                    case 'DEVICES':
                        return vm.selectedDevices.length === 0;
                    case 'ACTIONS':
                        return vm.actionType === 'ISSUE' && vm.certForm.$invalid;
                    case 'REVIEW':
                    case 'RESULT':
                        return vm.isDeploying;
                    default:
                        return false;
                }
            };

            /**
             * Go to previous step
             *
             * @returns {void}
             */
            vm.previousStep = function () {
                if (vm.currentStep === 0) {
                    return;
                }
                vm.currentStep--;
                vm.currentStepCode = vm.wizardSetup.steps[vm.currentStep].code;
            };

            /**
             * Go to the next step
             *
             * @returns {void}
             */
            vm.nextStep = function () {
                if (vm.currentStep === vm.wizardSetup.steps.length - 1) {
                    return;
                }
                vm.currentStep++;
                vm.currentStepCode = vm.wizardSetup.steps[vm.currentStep].code;
            };

            /**
             * Check if is last step of wizard
             *
             * @returns {boolean}           - True if this is last step
             */
            vm.isLastStep = function () {
                return vm.currentStep === vm.wizardSetup.steps.length - 1;
            };

            /**
             * Select devices callback
             * @param {Array} devices - list of devices 
             */
            vm.onDeviceSelect = function (devices) {
                vm.selectedDevices = devices;
            };

            /**
             * Create a new async task to deploy certificates to selected devices
             */
            vm.deploy = function () {
                // Open result tab
                vm.nextStep();

                vm.isDeploying = true;

                vm.launchResult = vm.initLaunchResultList(vm.selectedDevices, 'Process has started. Please wait...', 'NEW');

                if (vm.actionType === 'RESET') {
                    vm.launchPromise = ServiceAsyncTask.createTaskAndWait(
                        ServiceAsyncTask.taskTypes.EDGE_CERTIFICATE_RESET.code, // Task type
                        ServiceAsyncTask.taskTypes.EDGE_CERTIFICATE_RESET.subtaskTypes, // Subtask types
                        '',  // Task description 
                        vm.selectedDevices,
                        {},   // Task params
                        false // Wait device for online
                    );
                }
                if (vm.actionType === 'ISSUE') {
                    vm.launchPromise = ServiceAsyncTask.createTaskAndWait(
                        ServiceAsyncTask.taskTypes.EDGE_CERTIFICATE_ISSUE.code, // Task type
                        ServiceAsyncTask.taskTypes.EDGE_CERTIFICATE_ISSUE.subtaskTypes, // Subtask types
                        '',  // Task description 
                        vm.selectedDevices,
                        {
                            authority: vm.actionParams.authority.code,
                            ttlDays: vm.actionParams.ttlDays
                        },   // Task params
                        false // Wait device for online
                    );
                }

                vm.launchPromise
                    .then(function (task) {
                        if (!task || !task.id) {
                            return;
                        }
                        // Get subtasks for current task
                        return Service.api.asyncSubtaskList({
                            action: task.id
                        }).$promise;
                    })
                    .then(function (data) {
                        // If no subtasks, then show error
                        if (!data || !data.length) {
                            vm.initLaunchResultList(vm.selectedDevices, '', 'ERROR');
                            return;
                        }
                        // Get launch results from subtasks
                        vm.launchResult = data.map(function (item) {
                            return {
                                deviceId: item.deviceId,
                                devicePrettyName: item.devicePrettyName,
                                msg: item.msg || 'Success',
                                status: item.status
                            };
                        });
                    })
                    .catch(function (reason) {
                        if (!reason) { // If not reason provided, then task was canceled
                            return;
                        }
                        console.log('Certificate deploy failure:' + JSON.stringify(reason));
                        var messageObject = Commons.createErrorObject(reason, 'Certificate deploy failure');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                    })
                    .finally(function () {
                        vm.isDeploying = false;
                    });
            };

            /**
             * Init launch result list
             * @param {Array} deviceList - selected device list for launch 
             * @param {String} msg - state message 
             * @param {String} status - application status
             * @returns {Array} empty launch list
             */
            vm.initLaunchResultList = function (deviceList, msg, status) {
                if (!deviceList || !angular.isArray(deviceList)) {
                    return [];
                }
                return deviceList.map(function (item) {
                    return {
                        deviceId: item.deviceId,
                        devicePrettyName: item.deviceFriendlyName || item.prettyName,
                        msg: msg,
                        status: status
                    };
                });
            };

            /**
             * Hide dialog
             * @return {void}
             */
            vm.hide = function () {
                $mdDialog.hide();
            };

            /**
             * Cancel dialog button
             * @return {void}
             */
            vm.cancel = function () {
                $mdDialog.cancel();
            };
        }
    }); 
'use strict';
/**
 * @ngdoc component
 * @name loopUiApp.component:certificateDeploySummary
 * @description
 * # certificateDeploySummary
 */
angular.module('loopUiApp')
    .component('certificateDeploySummary', {
        bindings: {
            selectedDevices: '<',
            actionObject: '<',
            actionParams: '<',
        },
        templateUrl: '../scripts/components/certificates/certificateDeploySummary/certificateDeploySummary.html',
        controller: function () {
        }
    }); 
'use strict';
/**
 * @ngdoc component
 * @name loopUiApp.component:mlEdgeDeviceModels
 * @description
 * # mlEdgeDeviceModels
 */
angular.module('loopUiApp')
    .component('mlEdgeDeviceModels', {
        templateUrl: '../scripts/components/mlModels/mlEdgeDeviceModels.html',
        controller: function ($scope, $state, $stateParams, $mdDialog, $q, $http, gettextCatalog, appConfig, Service, Commons) {
            var vm = this;
            vm.totalItems = 0;
            vm.itemList = [];
            vm.selectedItems = [];

            vm.filterStr = '';
            vm.filterStatus = null;
            vm.filterModel = null;

            vm.fullListFlag = {};
            vm.MODEL_LIST_LIMIT = 3;

            vm.$onInit = function () {
                vm.projectId = $stateParams.projectId;

                // Init pagination object
                vm.itemsPagination = {
                    limitOptions: [10, 50, 100],
                    limit: 10,
                    page: 1,
                };

                //HOSTNAME_ASC, HOSTNAME_DESC, PRETTY_NAME_ASC, PRETTY_NAME_DESC, TOTAL_SIZE_ASC, TOTAL_SIZE_DESC
                vm.sortMap = {
                    'hostname': 'HOSTNAME_ASC',
                    '-hostname': 'HOSTNAME_DESC',
                    'prettyName': 'PRETTY_NAME_ASC',
                    '-prettyName': 'PRETTY_NAME_DESC',
                    'totalSize': 'TOTAL_SIZE_ASC',
                    '-totalSize': 'TOTAL_SIZE_DESC',
                    'isOnline': 'DEVICEONLINESTATUS_ASC',
                    '-isOnline': 'DEVICEONLINESTATUS_DESC'
                };

                // List of filter actions
                vm.additionalActions = [{
                    label: 'Refresh',
                    icon: 'refresh',
                    buttonClick: vm.refresh
                }];

                // List of actions
                vm.filterActions = [{
                    icon: 'upload',
                    name: 'Bulk Deploy',
                    type: 'BUTTON',
                    buttonClick: function () {
                        vm.viewModelDeployWizard(null, vm.selectedItems);
                    }
                },
                {
                    icon: 'analytics',
                    name: 'AI/ML Models',
                    type: 'MENU',
                    disabled: function () {
                        return false;
                    },
                    subActions: [
                        {
                            icon: 'analytics',
                            name: 'Available AI/ML Models',
                            buttonClick: vm.viewModels
                        },
                        {
                            icon: 'file_upload',
                            name: 'Upload New AI/ML Model',
                            type: 'BUTTON',
                            buttonClick: vm.uploadModel
                        }]
                }];

                // Table rows actions
                vm.listActions = [{
                    name: 'Deploy AI/ML Model',
                    icon: 'upload',
                    function: function (event, item) {
                        vm.viewModelDeployWizard(event, [item]);
                    },
                    disabled: function (item) {
                        return !item.isOnline;
                    }
                },
                {
                    name: 'Delete Model',
                    icon: 'delete',
                    function: vm.deleteModel,
                    disabled: function (item) {
                        return !item.isOnline || !item.models || item.models.length === 0;
                    }
                }];

                // Settings for table filters
                vm.filterObj = {
                    isOnline: {
                        type: 'select',
                        multiple: false,
                        name: 'Edge Device Status',
                        selectedValue: null,
                        defaultValue: null,
                        values: [{
                            code: true,
                            name: 'Online'
                        },
                        {
                            code: false,
                            name: 'Offline'
                        }],
                        visible: false,
                        action: function (value) {
                            vm.filterStatus = value;
                            vm.refreshList();
                        }
                    },
                    model: {
                        type: 'select',
                        multiple: false,
                        name: 'Model',
                        selectedValue: null,
                        defaultValue: null,
                        values: [],
                        visible: false,
                        action: function (value) {
                            vm.filterModel = value;
                            vm.refreshList();
                        }
                    }
                };

                vm.refresh();
            };

            /**
             * Refresh all lists
             */
            vm.refresh = function () {
                // Get the list of Edge devices with models
                vm.refreshList();
                // Get full list of models on all Edge devices
                vm.refreshModelListAll();
            };

            /**
             * Refresh list of Edge devices with models
             * @returns {void}
             */
            vm.refreshList = function () {
                vm.selectedItems = [];

                // There could be different value of filter by model:
                // 1. filterModel === '' (empty string) - return all devices without models
                // 2. filterModel === null - return all devices with or without models
                // 3. filterModel === 'string' - return all devices with specific model
                var _filterModel = vm.filterModel === '' ?  '' : vm.filterModel;

                vm.itemListPromise = Service.api.mlEdgeDeviceModels({
                    action: vm.projectId,
                    isOnline: vm.filterStatus,
                    modelFilter: _filterModel,
                    filter: vm.filterStr || null,
                    order: vm.sortMap[vm.sortField],
                }).$promise;

                vm.itemListPromise
                    .then(function (data) {
                        vm.totalItems = data.totalSize;
                        vm.itemList = data.elements;
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Get models failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error mlEdgeDeviceModels:' + JSON.stringify(reason));
                    });
            };

            /**
             * Refresh list of all models on all Edge devices
             * This list is used for filtering by model
             */
            vm.refreshModelListAll = function () {
                Service.api.mlEdgeDeviceModelsAll({
                    action: vm.projectId
                }).$promise
                    .then(function (data) {
                        // Fill filter values
                        vm.filterObj.model.values = data.map(function (model) {
                            return {
                                name: model.name + ' (' + model.count + ')',
                                code: model.name
                            };
                        });

                        vm.filterObj.model.values.unshift({ name: 'No models', code: '' });

                    })
                    .catch(function (reason) {
                        console.log('Error mlEdgeDeviceModelsAll:' + JSON.stringify(reason));
                    });
            };

            /**
             * Open delete model dialog
             * @param {Event} event - mouse click event
             * @param {Object} item - device/models object
             */
            vm.deleteModel = function (event, item) {
                var deferred = $q.defer();

                var _deleteFn = function(payload) {
                    var _delete = function (data) {
                        var _deleteUrl = appConfig.apiUrl + 'api/v' + appConfig.apiVersion + '/analytics';
                        $http({
                            method: 'DELETE',
                            url: _deleteUrl,
                            data: data,
                            headers: { 'Content-Type': 'application/json' }
                        })
                        .then(function (data) {
                            deferred.resolve(data);
                        })
                        .catch(function (reason) {
                            deferred.reject(reason);
                        });
                    };

                    Commons.showConfirmationWarn(
                        gettextCatalog.getString('Remove Models'),
                        gettextCatalog.getString('Are you sure you want to remove selected models?'),
                        gettextCatalog.getString('Remove'),
                        function () {
                            _delete(payload);
                        },
                        gettextCatalog.getString('Cancel'),
                        null,
                        event);

                    return deferred.promise;
                };
                
                var scope = angular.extend($scope.$new(true), {
                    models: item.models || [],
                    deviceId: item.deviceId,
                    deleteFn: _deleteFn
                });

                $mdDialog.show({
                    template: '<md-dialog style="width:500px;"><ml-delete-model-dialog models="models" device-id="deviceId" delete-fn="deleteFn"></ml-delete-model-dialog></md-dialog>',
                    parent: angular.element(document.body),
                    targetEvent: event,
                    scope: scope,
                    clickOutsideToClose: false
                })
                    .then(function () {
                        vm.refresh(); 
                    });
            };

            /**
             * View models
             * @param {Event} event - mouse click event
             * @returns {void}
             */
            vm.viewModels = function (event) {
                $mdDialog.show({
                    template:
                        '<md-dialog aria-label="View model" style="width:600px;">' +
                        '<ml-models-dialog></ml-models-dialog>' +
                        '</md-dialog>',
                    parent: angular.element(document.body),
                    targetEvent: event,
                    clickOutsideToClose: false
                })
                    .then(function () {
                        vm.refresh();
                    });
            };

            /**
             * ML model upload dialog
             * @param {Event} event - Selection event from fileUpload component
             * @returns {void}
             */
            vm.uploadModel = function (event) {
                Commons.uploadMlModel(event, $scope, vm.projectId, vm.refresh);
            };

            /**
             * Open model deploy wizard
             * @param {Event} event - mouse click event
             * @param {Array} selectedItems - selected Edge devices
             * @returns {void}
             */
            vm.viewModelDeployWizard = function (event, selectedItems) {
                var scope = angular.extend($scope.$new(true), {
                    preselectedDevices: selectedItems
                });

                $mdDialog.show({
                    template:
                        '<md-dialog aria-label="Model Deploy Dialog">' +
                        '<ml-model-deploy-dialog preselected-devices="preselectedDevices"></ml-model-deploy-dialog>' +
                        '</md-dialog>',
                    parent: angular.element(document.body),
                    targetEvent: event,
                    scope: scope,
                    clickOutsideToClose: false
                })
                    .then(function () {
                        vm.refresh();
                    });
            };

            /**
             * Handle filter open event
             * @param {Event} event - mouse click event 
             * @param {String} field - name of the field that's filtered
             */
            vm.onFilter = function (event, field) {
                // Position for filter menu
                var _leftPosition = event.clientX - 90 + 'px';
                var _topPosition = event.clientY + 10 + 'px';
                var scope = angular.extend($scope.$new(true), {
                    leftPosition: _leftPosition,
                    topPosition: _topPosition,
                    filterObject: vm.filterObj[field]
                });
                $mdDialog.show({
                    template: '<md-dialog class="md-table-filter" ng-style="{\'left\': leftPosition, \'top\': topPosition}" aria-label="Filter menu">' +
                        '<filter-menu filter-object="filterObject"></filter-menu>' +
                        '</md-dialog>',
                    clickOutsideToClose: false,
                    skipHide: true,
                    scope: scope,
                    hasBackdrop: false,
                })
                    .then(function (result) {
                        vm.itemsPagination.page = 1;
                        if (result.use === true) {
                            vm.filterApplyHandler(field, result.value);
                        } else {
                            vm.filterResetHandler(field);
                        }
                    });
            };

            /**
             * Handle filter apply
             * @param {string} field - field name
             * @param {any} value - value from the filter
             */
            vm.filterApplyHandler = function (field, value) {
                vm.filterObj[field].visible = true;
                vm.filterObj[field].selectedValue = value;
                vm.filterObj[field].action(value);
            };

            /**
             * On filter reset: set value to default and hide filter icon
             * @param {string} field - field name
             */
            vm.filterResetHandler = function (field) {
                vm.filterObj[field].visible = false;
                vm.filterObj[field].selectedValue = angular.copy(vm.filterObj[field].defaultValue);
                vm.filterObj[field].action(vm.filterObj[field].defaultValue);
            };

            /**
             * On filter handler
             * @param {String} predicate - search string
             * @return {void}
             */
            vm.filterHandler = function (predicate) {
                vm.filterStr = predicate;
                vm.itemsPagination.page = 1; // Reset page to 1 on filtering
                vm.refreshList();
            };

            /**
             * Reset all filters
             */
            vm.resetFilters = function () {
                vm.filterStatus = null;
                vm.filterModel = null;
                vm.filterStr = '';
                Object.keys(vm.filterObj).forEach(function (key) {
                    vm.filterObj[key].selectedValue = angular.copy(vm.filterObj[key].defaultValue);
                    vm.filterObj[key].visible = false;
                });
                vm.itemsPagination.page = 1;
                vm.refreshList();
            };

            /**
             * Check if filter is set
             * @return {boolean} - filter set flag
             */
            vm.isFilterSet = function () {
                return vm.filterStr || vm.filterModel || vm.filterStatus;
            };

            /**
             * Sort handler
             */
            vm.onSort = function () {
                vm.itemsPagination.page = 1;
                vm.refreshList();
            };

            /**
             * Is data available after load
             * @return {boolean} - data exist flag
             */
            vm.showNoData = function () {
                return !vm.itemList || vm.itemList.length === 0 &&
                    !(vm.itemListPromise && vm.itemListPromise.$$state && vm.itemListPromise.$$state.status === 0);
            };

            /**
             * Open device page
             * @return {void}
             */
            vm.openDeviceDetails = function (deviceId) {
                $state.go('deviceView', {
                    companyName: $stateParams.companyName,
                    projectId: $stateParams.projectId,
                    deviceId: deviceId,
                    selectedTab: 'info'
                });
            };

            /**
             * Get human readable deployment source
             * @param {string} src - deployment source
             * @returns 
             */
            vm.getDeploymentSource = function (src) {
                return src === 'LEM' ? { name: appConfig.__env.productName, code: 'Central' } :
                    { name: appConfig.__env.supportDeviceName, code: 'Local' };
            };
        }
    }); 
'use strict';
/**
 * @ngdoc component
 * @name loopUiApp.component:mlDeleteModelDialog
 * @description
 * # mlDeleteModelDialog
 */
angular.module('loopUiApp')
    .component('mlDeleteModelDialog', {
        bindings: {
            models: '<',
            deviceId: '<',
            deleteFn: '<'
        },
        templateUrl: '../scripts/components/mlModels/mlDeleteModelDialog.html',
        controller: function ($stateParams, $mdDialog, appConfig, Commons) {
            var vm = this;
            vm.modelsObject = {};
            // Selected models
            vm.result = [];
            vm.isLoading = false;

            vm.$onInit = function () {
                vm.projectId = $stateParams.projectId;
            };

            vm.$onChanges = function (changesObj) {
                if (changesObj.models) {
                    vm.modelsObject = vm.models.reduce(function (acc, model) {
                        acc[model.name] = false;
                        return acc;
                    }, {});
                    vm.handleChange();
                }
            };

            /**
             * Handle selection
             */
            vm.handleChange = function () {
                vm.result = Object.keys(vm.modelsObject).filter(function (key) {
                    return vm.modelsObject[key] === true;
                });
            };

            /**
             * Get human readable deployment source
             * @param {string} src - deployment source
             * @returns 
             */
            vm.getDeploymentSource = function (src) {
                return src === 'LEM' ? appConfig.__env.productName : appConfig.__env.supportDeviceName;
            };

            /**
             * Close dialog and send list of selected models
             */
            vm.send = function () {
                var _payload = {
                    projectId: vm.projectId,
                    deviceId: vm.deviceId,
                    modelNames: vm.result
                };
                vm.isLoading = true;
                vm.deleteFn(_payload)
                    .then(function () {
                        var _message = _payload.modelNames.length > 1 ? 'Models deleted' : 'Model deleted';
                        Commons.toastShow(_message);
                        $mdDialog.hide();
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Delete model failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error delete model:' + JSON.stringify(reason));
                    })
                    .finally(function () {
                        vm.isLoading = false;
                    });
            };

            /**
             * Close dialog windows
             * @return {void}
             */
            vm.cancel = function () {
                $mdDialog.cancel();
            };
        }
    }); 
'use strict';
/**
 * @ngdoc component
 * @name loopUiApp.component:mlModelDeployDialog
 * @description
 * # mlModelDeployDialog
 */
angular.module('loopUiApp')
    .component('mlModelDeployDialog', {
        bindings: {
            preselectedDevices: '<',
        },
        templateUrl: '../scripts/components/mlModels/mlModelDeployDialog.html',
        controller: function ($stateParams, $state, $mdDialog, $filter, gettextCatalog, ServiceAsyncTask, Service, Commons) {
            var vm = this;
            vm.selectedDevices = [];
            vm.selectedModels = [];
            vm.modelList = [];
            vm.currentStep = 0;
            vm.currentStepCode = 'DEVICES';
            vm.isDeploying = false;

            vm.$onInit = function () {
                vm.companyName = $stateParams.companyName;
                vm.projectId = $stateParams.projectId;

                //Wizard steps
                vm.wizardSetup = {
                    wizardName: null,
                    steps: [
                        {
                            code: 'DEVICES',
                            name: 'Select Devices',
                            description: gettextCatalog.getString('Select Target Device(s)'),
                        },
                        {
                            code: 'MODELS',
                            name: 'Models',
                            description: gettextCatalog.getString('Select ML model to deploy'),
                        },
                        {
                            code: 'REVIEW',
                            name: 'Review',
                            description: gettextCatalog.getString('Review and Run'),
                        },
                        {
                            code: 'RESULT',
                            name: 'Result',
                            description: gettextCatalog.getString('Result'),
                            icon: 'flag'
                        }
                    ]
                };

                if (vm.preselectedDevices && vm.preselectedDevices.length) {
                    // Remove devices step if devices are preselected
                    vm.wizardSetup.steps = vm.wizardSetup.steps.filter(function (item) {
                        return item.code !== 'DEVICES';
                    });
                    vm.currentStepCode = 'MODELS';
                    vm.selectedDevices = angular.copy(vm.preselectedDevices);
                }

                // Setup license list
                vm.modelListSetup = {
                    sortField: 'name',
                    showIndex: false,
                    editable: false,
                    removable: false,
                    rowSelection: true,
                    multipleSelection: false,
                    limit: 10,
                    limitOptions: [10, 50, 100],
                    fields: [
                        {
                            name: 'Model name',
                            column: 'name',
                        },
                        {
                            name: 'Size',
                            column: 'size',
                            transformation: function (item) {
                                return $filter('bytes')(item.size);
                            }
                        }
                    ]
                };

                // Setup result list
                vm.resultListSetup = {
                    sortField: 'name',
                    showIndex: false,
                    editable: false,
                    removable: false,
                    limit: 10,
                    limitOptions: [10, 50, 100],
                    fields: [
                        {
                            name: 'Device Id',
                            column: 'deviceId',
                            link: true,
                            limit: 5,
                            style: '{"width": "50px"}',
                            fieldAction: function (item) {
                                $state.go('deviceView', {
                                    companyName: vm.companyName,
                                    projectId: vm.projectId,
                                    deviceId: item.deviceId,
                                    selectedTab: 'apps'
                                });
                            }
                        },
                        {
                            name: 'Host Name',
                            column: 'devicePrettyName'
                        },
                        {
                            name: 'Message',
                            column: 'msg'
                        },
                        {
                            name: 'Status',
                            label: function (item) {
                                return item.status;
                            },
                            iconButton: true,
                            style: '{"width": "50px"}',
                            iconName: function (item) {
                                switch (item.status) {
                                    case 'NEW':
                                        return 'schedule';
                                    case 'ERROR':
                                        return 'highlight_off';
                                    case 'SUCCESS':
                                        return 'check_circle_outline';
                                    default:
                                        return 'help_outline';
                                }
                            }
                        }
                    ]
                };

                vm.refreshModelList();
            };

            /**
             * Refresh the license list
             */
            vm.refreshModelList = function () {
                vm.modelListPromise = Service.api.mlModels({
                    action: vm.projectId
                }).$promise;

                vm.modelListPromise
                    .then(function (data) {
                        vm.modelList = data.elements;
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Get ML models failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error mlModels:' + JSON.stringify(reason));
                    });
            };

            /**
             * Check current step for validity.
             *
             * @param {number} step                 - Step number
             * @returns {boolean}                   - True if step data pass validation.
             */
            vm.stepInvalid = function (code) {
                switch (code) {
                    case 'DEVICES':
                        return vm.selectedDevices.length === 0;
                    case 'MODELS':
                        return vm.selectedModels.length === 0;
                    case 'RESULT':
                        return vm.isDeploying === true;
                    default:
                        return false;
                }
            };

            /**
             * Go to previous step
             *
             * @returns {void}
             */
            vm.previousStep = function () {
                if (vm.currentStep === 0) {
                    return;
                }
                vm.currentStep--;
                vm.currentStepCode = vm.wizardSetup.steps[vm.currentStep].code;
            };

            /**
             * Go to the next step
             *
             * @returns {void}
             */
            vm.nextStep = function () {
                if (vm.currentStep === vm.wizardSetup.steps.length - 1) {
                    return;
                }
                vm.currentStep++;
                vm.currentStepCode = vm.wizardSetup.steps[vm.currentStep].code;
            };

            /**
             * Check if is last step of wizard
             *
             * @returns {boolean}           - True if this is last step
             */
            vm.isLastStep = function () {
                return vm.currentStep === vm.wizardSetup.steps.length - 1;
            };

            /**
             * Select devices callback
             * @param {Array} devices - list of devices 
             */
            vm.onDeviceSelect = function (devices) {
                vm.selectedDevices = devices;
            };

            /**
             * Select models callback
             * @param {Array} models - list of selected models
             */
            vm.onModelSelect = function (models) {
                vm.selectedModels = models;
            };

            /**
             * Create a new async task to deploy licenses to selected devices
             */
            vm.deploy = function () {
                // Open result tab
                vm.nextStep();

                vm.isDeploying = true;

                vm.launchResult = vm.initLaunchResultList(vm.selectedDevices, 'Deploying models...', 'NEW');

                vm.launchPromise = ServiceAsyncTask.createTaskAndWait(
                    ServiceAsyncTask.taskTypes.ANALYTICS_ML_MODEL_UPLOAD.code, // Task type
                    ServiceAsyncTask.taskTypes.ANALYTICS_ML_MODEL_UPLOAD.subtaskTypes, // Subtask types
                    '',  // Task description 
                    vm.selectedDevices,
                    {
                        fileName: vm.selectedModels[0].name
                    },   // Task params
                    false // Wait device for online
                );

                vm.launchPromise
                    .then(function (task) {
                        if (!task || !task.id) {
                            return;
                        }
                        // Get subtasks for current task
                        return Service.api.asyncSubtaskList({
                            action: task.id
                        }).$promise;
                    })
                    .then(function (data) {
                        // If no subtasks, then show error
                        if (!data || !data.length) {
                            vm.initLaunchResultList(vm.selectedDevices, '', 'ERROR');
                            return;
                        }
                        // Get launch results from subtasks
                        vm.launchResult = data.map(function (item) {
                            return {
                                deviceId: item.deviceId,
                                devicePrettyName: item.devicePrettyName,
                                msg: item.msg,
                                status: item.status
                            };
                        });
                    })
                    .catch(function (reason) {
                        if (!reason) { // If not reason provided, then task was canceled
                            return;
                        }
                        console.log('Model deploy failure:' + JSON.stringify(reason));
                        var messageObject = Commons.createErrorObject(reason, 'License deploy failure');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                    })
                    .finally(function () {
                        vm.isDeploying = false;
                    });
            };

            /**
             * Init launch result list
             * @param {Array} deviceList - selected device list for launch 
             * @param {String} msg - state message 
             * @param {String} status - application status
             * @returns {Array} empty launch list
             */
            vm.initLaunchResultList = function (deviceList, msg, status) {
                if (!deviceList || !angular.isArray(deviceList)) {
                    return [];
                }
                return deviceList.map(function (item) {
                    return {
                        deviceId: item.deviceId,
                        devicePrettyName: item.prettyName,
                        msg: msg,
                        status: status
                    };
                });
            };

            /**
             * Cancel dialog button
             * @return {void}
             */
            vm.cancel = function () {
                $mdDialog.cancel();
            };

            /**
             * Hide dialog
             * @return {void}
             */
            vm.hide = function () {
                $mdDialog.hide();
            };
        }
    }); 

'use strict';
/**
 * @ngdoc component
 * @name loopUiApp.component:mlModelDeploySummary
 * @description
 * # mlModelDeploySummary
 */
angular.module('loopUiApp')
    .component('mlModelDeploySummary', {
        bindings: {
            selectedDevices: '<',
            selectedModels: '<'
        },
        templateUrl: '../scripts/components/mlModels/mlModelDeploySummary.html',
        controller: function () {
        }
    }); 
'use strict';
/**
 * @ngdoc component
 * @name loopUiApp.component:mlModelsDialog
 * @description
 * # mlModelsDialog
 */
angular.module('loopUiApp')
    .component('mlModelsDialog', {
        templateUrl: '../scripts/components/mlModels/mlModelsDialog.html',
        controller: function ($scope, $stateParams, $filter, $mdDialog, $window, gettextCatalog, Service, Commons) {
            var vm = this;
            vm.modelList = [];
            vm.selectedItems = [];
            vm.totalSize = 0;
            vm.filterStr = '';

            vm.$onInit = function () {
                vm.projectId = $stateParams.projectId;

                // Model license list
                vm.listSetup = {
                    sortField: 'name',
                    showIndex: false,
                    editable: false,
                    removable: false,
                    rowSelection: true,
                    multipleSelection: true,
                    serverPagination: true,
                    limit: 10,
                    limitOptions: [10, 50, 100],
                    fields: [
                        {
                            name: 'Model name',
                            column: 'name',
                        },
                        {
                            name: 'Description',
                            column: 'description',
                        },
                        {
                            name: 'Size',
                            column: 'size',
                            transformation: function (item) {
                                return $filter('bytes')(item.size);
                            }
                        }
                    ]
                };

                // Init pagination object
                vm.itemsPagination = {
                    limitOptions: vm.listSetup.limitOptions,
                    limit: vm.listSetup.limit,
                    page: 1
                };

                // Filter actions
                vm.filterActions = [
                    {
                        label: 'Refresh',
                        name: 'refresh',
                        icon: 'refresh',
                        buttonClick: vm.refreshList
                    },
                    {
                        label: 'Upload ML model',
                        name: 'upload',
                        icon: 'file_upload',
                        buttonClick: vm.upload
                    }
                ];

                // List item actions
                vm.listActions = [
                    {
                        name: 'Edit AI/ML Model description',
                        icon: 'edit',
                        function: vm.edit
                    },
                    {
                        name: 'Download AI/ML Model',
                        icon: 'download',
                        function: vm.download
                    },
                    {
                        name: 'Delete AI/ML Model',
                        icon: 'delete',
                        function: function (event, item) {
                            vm.delete(event, [item]);
                        }
                    },
                ];

                // Bulk actions
                vm.bulkActions = [
                    {
                        name: 'Delete selected models',
                        icon: 'delete',
                        function: vm.delete
                    }
                ];

                vm.refreshList();
            };

            /**
             * Refresh the license list
             */
            vm.refreshList = function () {
                vm.selectedItems = [];

                vm.modelListPromise = Service.api.mlModels({
                    action: vm.projectId,
                    requestedPage: vm.itemsPagination.page - 1,
                    limit: vm.itemsPagination.limit,
                    filter: vm.filterStr || null,
                }).$promise;

                vm.modelListPromise
                    .then(function (data) {
                        vm.totalSize = data.totalSize;
                        vm.modelList = data.elements;
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Get ML models failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error mlModels:' + JSON.stringify(reason));
                    });
            };

            /**
             * ML model upload dialog
             * @param {Event} event - Selection event from fileUpload component
             * @returns {void}
             */
            vm.upload = function(event) {
                Commons.uploadMlModel(event, $scope, vm.projectId, vm.refreshList);
            };

            /**
             * Open edit file dialog
             * @param {MouseEvent} event - event object
             * @param {Object} file - file object
             * @return {void}
             */
            vm.edit = function (event, file) {
                var _saveFn = function (item) {
                    return Service.api.mlModel({
                        action: vm.projectId,
                        fileName: item.name
                    }, {
                        description: item.description
                    }).$promise;
                };

                // Create an isolated scope to pass to the component 
                var scope = angular.extend($scope.$new(true), {
                    file: angular.copy(file),
                    saveFn: _saveFn
                });

                $mdDialog.show({
                    template: '<md-dialog style="width:500px;"><ml-model-edit-dialog file="file" save-fn="saveFn"></ml-model-edit-dialog></md-dialog>',
                    parent: angular.element(document.body),
                    targetEvent: event,
                    clickOutsideToClose: false,
                    preserveScope: true,
                    scope: scope,
                    skipHide: true,
                })
                    .then(function () {
                        vm.refreshList();
                    });
            };

            /**
             * Download ML model
             * @param {Object} event - event object
             * @param {object} item - backup list object
             * @returns {void}
             */
            vm.download = function (event, item) {
                Service.api.mlModelDownloadUrl({
                    projectId: vm.projectId,
                    fileName: item.name
                }).$promise
                    .then(function (data) {
                        $window.open(data.url, '_blank');
                    })
                    .catch(function (reason) {
                        console.log('mlModelDownloadUrl failure:' + JSON.stringify(reason));
                        var messageObject = Commons.createErrorObject(reason, 'Download action failure');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                    });
            };

            /**
             * Delete ML model
             * @param {Event} event - Event
             * @param {Array} items - Items to delete
             * @returns {void}
             **/
            vm.delete = function (event, items) {
                var deleteFn = function () {
                    var _payload = items.map(function (item) {
                        return {
                            fileType: 'mlModel',
                            fileName: item.name
                        };
                    });
                    vm.isLoading = true;
                    Service.api.mlModelDeleteMultiple({
                        action: vm.projectId
                    }, _payload).$promise
                        .then(function () {
                            var _resultMessage = items.length > 1 ? 'Files were removed' : 'File was removed';
                            Commons.toastShow(_resultMessage);
                            vm.refreshList();
                        })
                        .catch(function (reason) {
                            console.log('mlModelDeleteMultiple failure:' + JSON.stringify(reason));
                            var messageObject = Commons.createErrorObject(reason, 'Model delete action failure');
                            Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        })
                        .finally(function () {
                            vm.isLoading = false;
                        });
                };

                var _message = items.length > 1 ? 'Are you sure you want to remove selected files?' : 'Are you sure you want to remove file?';
                Commons.showConfirmationWarn(
                    gettextCatalog.getString('Remove confirmation'),
                    gettextCatalog.getString(_message + '<br>Removed files cannot be restored.'),
                    gettextCatalog.getString('Remove'),
                    function () {
                        deleteFn();
                    },
                    gettextCatalog.getString('Cancel'),
                    undefined,
                    event);
            };


            /**
             * Update pagination object and run list refresh
             * @param {Object} paginationObject - pagination object
             * @return {void}
             */
            vm.paginationHandler = function (paginationObject) {
                vm.itemsPagination = paginationObject;
                vm.refreshList();
            };

            /**
             * Filter on filter change
             * @param {string} filterStr - filter string
             */
            vm.filterHandler = function (filterStr) {
                vm.filterStr = filterStr;
                vm.itemsPagination.page = 1; // Reset page to 1 on filtering
                vm.refreshList();
            };

            /**
             * Handle model selection
             * @param {Array} selectedItems - selected items
             */
            vm.onModelSelect = function (selectedItems) {
                vm.selectedItems = selectedItems;
            };

            /**
             * Hides the dialog
             * @returns {void}
             */
            vm.hide = function () {
                $mdDialog.hide();
            };
        }
    }); 
'use strict';
/**
 * @ngdoc component
 * @name loopUiApp.component:mlModelEditDialog
 * @description
 * # mlModelEditDialog
 */
angular.module('loopUiApp')
    .component('mlModelEditDialog', {
        bindings: {
            file: '<',
            saveFn: '<'
        },
        templateUrl: '../scripts/components/mlModels/mlModelEditDialog.html',
        controller: function ($mdDialog, Commons) {
            var vm = this;
            vm.isLoading = false;

            /**
             * Save description
             */
            vm.save = function () {
                vm.isLoading = true;
                vm.saveFn(vm.file)
                    .then(function () {
                        $mdDialog.hide();
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Save model failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Save failure:' + JSON.stringify(reason));
                    })
                    .finally(function () {
                        vm.isLoading = false;
                    });
            };

            /**
             * Close dialog window
             * @return {void}
            */
            vm.hide = function () {
                $mdDialog.cancel();
            };
        }
    });
'use strict';
/**
 * @ngdoc component
 * @name loopUiApp.component:asyncTaskList
 * @description
 * # asyncTaskList
 */
angular.module('loopUiApp')
    .component('asyncTaskList', {
        templateUrl: '../scripts/components/asyncTask/asyncTaskList/asyncTaskList.html',
        controller: function ($stateParams, ServiceAsyncTask, Service, Commons) {
            var vm = this;
            vm.sat = ServiceAsyncTask;
            vm.taskList = [];

            vm.$onInit = function () {
                vm.projectId = $stateParams.projectId;
                vm.companyName = $stateParams.companyName;

                // Init pagination object
                vm.itemsPagination = {
                    limit: 10,
                    page: 1,
                    limitOptions: [10, 50, 100]
                };
                // Set max date form to filter
                vm.maxDate = new Date();

                // Task actions
                vm.taskActions = [
                    {
                        icon: 'remove_red_eye',
                        name: 'View task details',
                        function: function (event, task) {
                            ServiceAsyncTask.openTaskDetails(task.id);
                        }
                    }];

                vm.initFilter();
                vm.refreshTaskList();
            };

            /**
             * Refresh async task list
             * @returns {void}
             */
            vm.refreshTaskList = function () {
                var _dateFrom = vm.filterObject.createdOnFrom ? vm.filterObject.createdOnFrom.getTime() : null;
                var _dateTo = vm.filterObject.createdOnTo ? vm.filterObject.createdOnTo.getTime() + 24 * 60 * 60 * 1000 : null;

                vm.taskListPromise = Service.api.asyncTaskList({
                    companyName: vm.companyName,
                    projectId: vm.projectId,
                    taskType: vm.filterObject.type || null,
                    taskStatus: vm.filterObject.status || null,
                    createdOnFrom: _dateFrom,
                    createdOnTo: _dateTo,
                    pageSize: vm.itemsPagination.limit,
                    requestedPage: vm.itemsPagination.page - 1
                }).$promise;

                vm.taskListPromise.then(function (data) {
                    vm.taskList = data.elements;
                    vm.itemsPagination.total = data.totalSize;
                })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Get task list failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error asyncTaskList:' + JSON.stringify(reason));
                    });
            };

            /**
             * Is data available after load
             * @return {boolean} - data exist flag
             */
            vm.showNoData = function () {
                return !vm.taskList || vm.taskList.length === 0 &&
                    !(vm.taskListPromise && vm.taskListPromise.$$state && vm.taskListPromise.$$state.status === 0);
            };

            /**
             * Init filter object
             */
            vm.initFilter = function () {
                // Set init date
                var dateFrom = new Date();
                dateFrom.setHours(-24, 0, 0, 0);

                vm.filterObject = {
                    type: '',
                    status: '',
                    createdOnFrom: dateFrom,
                    createdOnTo: null
                };
            };
        }
    });
'use strict';
/**
 * @ngdoc component
 * @name loopUiApp.component:asyncTaskView
 * @description
 * # asyncTaskView
 */
angular.module('loopUiApp')
    .component('asyncTaskView', {
        templateUrl: '../scripts/components/asyncTask/asyncTaskView/asyncTaskView.html',
        controller: function ($stateParams, $window, $state, ServiceAsyncTask, Service, Commons) {
            var vm = this;
            vm.sat = ServiceAsyncTask;
            vm.subtaskList = [];

            vm.$onInit = function () {
                vm.companyName = $stateParams.companyName;
                vm.projectId = $stateParams.projectId;
                vm.taskId = $stateParams.taskId;

                // List of task actions
                vm.taskActions = [
                    {
                        icon: 'subject',
                        name: 'View log',
                        function: function (event, subtask) {
                            ServiceAsyncTask.openTaskLog(subtask);
                        }
                    }];

                vm.refreshSubtaskList();
            };

            /**
             * Refresh async subtask list
             * @returns {void}
             */
            vm.refreshSubtaskList = function () {
                vm.subtaskListPromise = Service.api.asyncSubtaskList({
                    action: vm.taskId
                }).$promise;

                vm.subtaskListPromise.then(function (data) {
                    vm.subtaskList = data;
                })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Get subtask list failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error asyncSubtaskList:' + JSON.stringify(reason));
                    });
            };

            /**
             * Open device page
             * @param {String} deviceId - device object
             * @return {void}
             */
            vm.openDeviceDetails = function (task) {
                $state.go('deviceView', {
                    companyName: task.companyName,
                    projectId: task.projectId,
                    deviceId: task.deviceId,
                });
            };

            /**
             * Is data available after load
             * @return {boolean} - data exist flag
             */
            vm.showNoData = function () {
                return !vm.subtaskList || vm.subtaskList.length === 0 &&
                    !(vm.subtaskListPromise && vm.subtaskListPromise.$$state && vm.subtaskListPromise.$$state.status === 0);
            };

            /**
             * Get back with history
             * @returns {void}
             */
            vm.historyBack = function () {
                $window.history.back();
            };
        }
    });
'use strict';

/**
 * @ngdoc component
 * @name loopUiApp.component:asyncSubtaskLog
 * @description
 * # asyncSubtaskLog
 *
 */
angular.module('loopUiApp')
    .component('asyncSubtaskLog', {
        templateUrl: '../scripts/components/asyncTask/asyncSubtaskLog/asyncSubtaskLog.html',
        controller: function ($stateParams, $filter, $window, ServiceAsyncTask, Service, Commons) {
            var vm = this;
            vm.sat = ServiceAsyncTask;
            vm.log = [];

            vm.$onInit = function () {
                vm.companyName = $stateParams.companyName;
                vm.projectId = $stateParams.projectId;
                // If taskId is not defined or 'none' then set it to null
                vm.taskId = !$stateParams.taskId || $stateParams.taskId === 'none' ? null : $stateParams.taskId;
                vm.subtaskId = $stateParams.subtaskId;

                vm.listSetup = {
                    sortField: '-eventTime',
                    showIndex: false,
                    editable: false,
                    removable: false,
                    serverPagination: true,
                    limit: 10,
                    limitOptions: [10, 50, 100],
                    fields: [
                        {
                            name: 'Event Time',
                            column: 'eventTime',
                            style: '{"width": "80px"}',
                            transformation: function (item) {
                                return $filter('date')(item.eventTime, 'yyyy-MM-dd HH:mm:ss');
                            }
                        },
                        {
                            name: 'Log Level',
                            column: 'level',
                            style: '{"width": "40px"}'
                        },
                        {
                            name: 'User',
                            column: 'username',
                            style: '{"width": "50px"}'
                        },
                        {
                            name: 'Message',
                            column: 'message'
                        }
                    ]
                };

                // Init pagination object
                vm.itemsPagination = {
                    limitOptions: vm.listSetup.limitOptions,
                    limit: vm.listSetup.limitOptions[0],
                    page: 1
                };

                // Action list
                vm.additionalActions = [
                    {
                        name: 'Refresh',
                        icon: 'refresh',
                        function: vm.refreshLog
                    },
                ];

                vm.refreshLog();
            };

            /**
             * Refresh async task log list
             * @returns {void}
             */
            vm.refreshLog = function () {
                vm.logPromise = Service.api.asyncSubtaskLogs({
                    subtaskId: vm.subtaskId,
                    requestedPage: vm.itemsPagination.page - 1,
                    pageSize: vm.itemsPagination.limit,
                }).$promise;

                vm.logPromise.then(function (data) {
                    vm.log = data.elements;
                    vm.totalItems = data.totalSize;
                })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Get subtask log failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error asyncSubtaskLogs:' + JSON.stringify(reason));
                    });
            };

            /**
             * Update pagination object and run list refresh
             * @param {Object} paginationObject - pagination object
             * @return {void}
             */
             vm.paginationHandler = function (paginationObject) {
                vm.itemsPagination = paginationObject;
                vm.refreshLog();
            };

            /**
             * Get back with history
             * @returns {void}
             */
            vm.historyBack = function () {
                $window.history.back();
            };
        }
    });
'use strict';

/**
 * @ngdoc component
 * @name loopUiApp.component:asyncTaskInformer
 * @description
 * # asyncTaskInformer
 *
 */
angular.module('loopUiApp')
    .component('asyncTaskInformer', {
        templateUrl: '../scripts/components/asyncTask/asyncTaskInformer/asyncTaskInformer.html',
        controller: function (ServiceAsyncTask) {
            var vm = this;
            vm.sat = ServiceAsyncTask;

            /**
             * Return status icon representation
             * @param {string} status - status name
             * @returns {string} - material icon name
             */
             vm.stepIcon = function (status) {
                switch (status) {
                case 'NEW':
                case 'WAITING':
                    return 'pause_circle_outline';
                case 'RUNNING':
                    return 'schedule';
                case 'ERROR':
                    return 'highlight_off';
                case 'SUCCESS':
                    return 'check_circle_outline';
                default:
                    return 'help_outline';
                }
            };

            /**
             * Set task CSS class
             * @param {string} status - status name
             * @returns {string} - class name
             */
            vm.stepClass = function(status) {
                var _class_name = 'async-task-informer__icon';
                switch (status) {
                case 'RUNNING':
                    _class_name += '-active';
                    break;
                case 'ERROR':
                    _class_name += '-error';
                    break;
                case 'SUCCESS':
                    _class_name += '-done';
                    break;
                default:
                    _class_name = '';
                    break;
                }
                return _class_name;
            };
        }
    });
'use strict';

/**
 * @ngdoc component
 * @name loopUiApp.component:eventsView
 * @description
 * # eventsView
 */
angular.module('loopUiApp')
    .component('eventsView', {
        templateUrl: '../scripts/components/event/eventsView.html',
        controller: function ($state, $stateParams, featuresCheck) {
            var vm = this;
            // Feature check service
            vm.fc = featuresCheck;
            vm.featureCode = 'EdgeEvents';

            vm.projectId = $stateParams.projectId;
            // Events type
            vm.eventType = ['SYSTEM_EVENTS', 'DEVICE_EVENTS'];
            
            vm.$onInit = function() {
                vm.selectedType = angular.copy($stateParams.selectedType) || vm.eventType[0];
            };

            /**
             * Updates the URL on tab change to persist currently selected tab
             * @param {string} type - type name
             * @returns {void}
             */
            vm.changeType = function (type) {
                vm.selectedType = type;
                $state.go('.', { selectedType: type }, { location: 'replace' });
            };

            /**
             * Get filter object value
             * @param {Objecy} data - filter object
             * @returns {void}
             */
            vm.applyFilter = function(data) {
                vm.filterObject = angular.copy(data);
            };

            /**
             * Add new value into filter
             * @param {Object} value - key-value filter object 
             * @return {void}
             */
            vm.addFilter = function(value) {
                vm.filterActive = true;
                vm.filterObject = angular.copy(Object.assign(vm.filterObject, value));
            };
        }
    });
'use strict';

/**
 * @ngdoc component
 * @name loopUiApp.component:deviceInfo
 * @description
 * # deviceInfo
 */
angular.module('loopUiApp')
    .component('events', {
        templateUrl: '../scripts/components/event/events.html',
        controller: function ($stateParams, Service, Commons) {
            var vm = this;
            vm.events = [];
            // List of context options 
            vm.contexts = [];
            vm.filter = '';

            vm.$onInit = function () {
                vm.projectId = $stateParams.projectId || null;
                vm.currentCommpanyName = $stateParams.companyName;
                vm.filterActive = true;

                // Query options
                vm.eventsQuery = {};
                vm.eventsQuery.startDate = new Date();
                vm.eventsQuery.endDate = new Date();
                vm.eventsQuery.type = $stateParams.context || null;

                vm.maxDate = new Date();

                /**
                 * Pagination settings
                 */
                vm.query = {
                    page: 1,
                    limit: 10,
                    limitOptions: [10, 50, 100]
                };

                // Load the list of contexts
                vm.getContexts();
                // Load events
                vm.getEvents();
            };

            /**
             * Load events
             * @returns {void}
             */
            vm.getEvents = function () {
                vm.eventsPromise = Service.api.log({
                    actionExt: vm.currentCommpanyName,
                    from: vm.eventsQuery.startDate.setHours(0, 0, 0, 0),
                    to: vm.eventsQuery.endDate.setHours(23, 59, 59, 59),
                    context: vm.eventsQuery.type,
                    projectId: vm.projectId,
                    filter: vm.filter,
                    requestedPage: (vm.query.page - 1),
                    limit: vm.query.limit
                }).$promise;
                vm.eventsPromise
                    .then(function (res) {
                        vm.totalSize = res.totalSize;
                        vm.events = res.elements;
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Get events failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error log:' + JSON.stringify(reason));
                    });
            };


            /**
             * Load full list of contexts
             * @returns {void}
             */
            vm.getContexts = function () {
                Service.api.logContexts().$promise
                    .then(function (data) {
                        data.push({
                            code: null,
                            description: 'All Events'
                        });
                        vm.contexts = data;
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Get contexts failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error log:' + JSON.stringify(reason));
                    });
            };

            /**
             * Show/hide filter elements
             * @returns {void}
             */
            vm.toggleFilter = function () {
                vm.filterActive = !vm.filterActive;
            };

            /**
             * Is data available after load
             * @return {boolean} - data exist flag
             */
            vm.showNoData = function () {
                return !vm.events || vm.events.length === 0 &&
                    !(vm.eventsPromise && vm.eventsPromise.$$state && vm.eventsPromise.$$state.status === 0);
            };
        }
    });
'use strict';
/**
 * @ngdoc component
 * @name loopUiApp.component:loopedgeEvents
 * @description
 * # loopedgeEvents
 */

angular.module('loopUiApp')
    .component('loopedgeEvents', {
        templateUrl: '../scripts/components/event/loopedgeEvents.html',
        bindings: {
            device: '<',
            deviceOnline: '<',
            filterObject: '<',
            onFilterSelect: '&'
        },
        controller: function ($stateParams, $state, Service, Commons) {
            var vm = this;
            
            //Pagination object
            vm.pagination = {
                limitOptions: [10, 50, 100],
                limit: 10,
                requestedPage: 1,
                total: 0
            };
            // Current company and project 
            vm.companyName = $stateParams.companyName;
            vm.projectId = $stateParams.projectId;

            vm.$onInit = function () {
                // View scope: device/project level
                vm.scope = vm.device ? 'DEVICE' : 'PROJECT';
                // Events list
                vm.eventList = [];

                // Severity Icon map
                vm.severityMap = {
                    info: { icon: 'info', class: '' },
                    warn: { icon: 'warning', class: 'severity__icon-warning' },
                    alert: { icon: 'notification_important', class: 'severity__icon-error' },
                    error: { icon: 'error', class: 'severity__icon-error' },
                    unknown: { icon: 'help_outline', class: '' },
                };

                // Event row actions
                vm.eventsActions = [
                    {
                        icon: 'devices',
                        name: 'Filter by Device',
                        function: function(event, item) {
                            vm.onFilterSelect({filterValue: {deviceId: item.deviceId}});
                        }
                    },
                    {
                        icon: 'widgets',
                        name: 'Filter by Component',
                        function: function(event, item) {
                            vm.onFilterSelect({filterValue: {component: item.component}});
                        }
                    },
                    /*{
                        icon: 'notification_important',
                        name: 'Create Alert',
                        function: function() {
                            console.log('Create Alert action');
                        },
                        disable: true
                    },*/
                ];
                // For device scope remove filter by device
                if (vm.scope === 'DEVICE') {
                    vm.eventsActions.shift();
                }

                vm.refreshEventRegistry();
            };

            /**
             * Track filter changes
             * @param {Object} changes - changes object
             * @returns {void}
             */
            vm.$onChanges = function (changes) {
                if (changes.filterObject) {
                    vm.refreshEventsList();
                }
            };

            /**
             * Refresh events list
             * @returns {void}
             */
            vm.refreshEventsList = function () {
                if (!vm.filterObject) {
                    return;
                }
                vm.isLoading = true;

                // Fix datetime remove hours
                var _from = vm.filterObject.from ? vm.filterObject.from.getTime() : null;
                var _to = vm.filterObject.to ? vm.filterObject.to.getTime() + 24 * 60 * 60 * 1000 : null;

                vm.eventsPromise = Service.api.eventList({
                    actionExt: vm.projectId,
                    severity: vm.filterObject.severity,
                    deviceId: vm.filterObject.deviceId,
                    component: vm.filterObject.component,
                    eventId: vm.filterObject.eventId,
                    from: _from,
                    to: _to,
                    requestedPage: vm.pagination.requestedPage - 1,
                    limit: vm.pagination.limit,
                }).$promise;

                vm.eventsPromise.then(function (data) {
                    vm.eventList = data.elements.map(function(element) {
                        return Object.assign({attrsParsed: vm.getAttrs(element.attrs)}, element);
                    });
                    vm.pagination.total = data.totalSize;
                })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Get events failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error eventList:' + JSON.stringify(reason));
                    })
                    .finally(function () {
                        vm.isLoading = false;
                    });
            };

            /**
             * Load component list
             * @returns {void}
             */
            vm.refreshEventRegistry = function () {
                Service.api.eventRegistry().$promise
                    .then(function (data) {
                        vm.eventsRegistry = data;
                    })
                    .catch(function (reason) {
                        console.log('Error eventRegistry:' + JSON.stringify(reason));
                    });
            };

            /**
             * Open device details view
             * @param {Object} deviceId - device id
             * @return {void}
             */
            vm.openDeviceDetail = function (deviceId) {
                $state.go('deviceView', {
                    companyName: vm.companyName,
                    projectId: vm.projectId,
                    deviceId: deviceId,
                    selectedTab: 'events'
                });
            };

            /**
             *
             * @param {*} $mdOpenMenu - Menu instance
             * @param {*} ev - Event
             * @returns {void}
             */
            vm.openMenu = function ($mdOpenMenu, ev) {
                ev.stopPropagation();
                $mdOpenMenu(ev);
            };

            /**
             * Get severity code
             * @param {string} severity - severity code
             * @return {string} icon name
             */
            vm.getSeverityIcon = function (severity) {
                try {
                    return vm.severityMap[severity].icon;
                } catch (e) {
                    return vm.severityMap.UNKNOWN.icon;
                }
            };

            /**
             * Get severity code
             * @param {string} severity - severity code
             * @return {string} icon name
             */
            vm.getSeverityClass = function (severity) {
                try {
                    return vm.severityMap[severity].class;
                } catch (e) {
                    return '';
                }
            };

            /**
             * Is data available after load
             * @return {boolean} - data exist flag
             */
            vm.showNoData = function () {
                return !vm.eventList || vm.eventList.length === 0 && !vm.listLoading;
            };

            /**
             * Convert string to object
             * @param {string} jsonString - object in string representation
             * @return {Object} - javascript object 
             */
            vm.getAttrs = function(jsonString) {
                try {
                    return JSON.parse(jsonString);
                } catch(e) {
                    return {};
                }
            };

            /**
             * Get components name from registry
             * @param {string} code - component code
             */
            vm.decodeComponentName = function(code) {
                if (!vm.eventsRegistry) {
                    return;
                }
                try {
                    return vm.eventsRegistry[code].name;
                } catch (e) {
                    return code;
                }
            };
        }
    });
'use strict';

/**
 * @ngdoc component
 * @name loopUiApp.component:filterEvents
 * @description
 * # filterEvents
 */
angular.module('loopUiApp')
    .component('filterEvents', {
        templateUrl: '../scripts/components/event/filterEvents.html',
        bindings: {
            projectId: '<',
            device: '<',
            forwardingState: '<',
            filterActive: '<',
            filterObject: '=',
            onApply: '&',
            onForwadingChange: '&'
        },
        controller: function (Service) {
            var vm = this;
            vm.deviceList = [];

            vm.$onInit = function () {
                vm.filterActive = false;

                // Scope view
                vm.scope = vm.device ? 'DEVICE' : 'PROJECT';
                
                vm.filterObject = {
                    severity: null,
                    deviceId: vm.scope === 'DEVICE' ? vm.device.deviceId : null,
                    component: null,
                    eventId: null,
                    from: null,
                    to: null
                };

                vm.initialFilterObject = angular.copy(vm.filterObject);

                // Send filter object
                vm.apply();

                // Set max date form to filter
                vm.maxDate = new Date();
                
                // Severity list
                vm.severityList = [
                    { code: null, name: 'All' },
                    { code: 'info', name: 'Info' },
                    { code: 'warn', name: 'Warning' },
                    { code: 'alert', name: 'Alert' },
                    { code: 'error', name: 'Error' }
                ];

                // Severity Icon map
                vm.severityIcon = {
                    info: 'info',
                    warn: 'warning',
                    alert: 'notification_important',
                    error: 'error',
                    unknown: 'help_outline',
                };

                // Component List
                vm.componentList = [
                    { code: null, name: 'All' },
                    { code: 'auth', name: 'Auth' },
                    { code: 'cc', name: 'Integrations' },
                    { code: 'dh', name: 'DeviceHub' },
                    { code: 'dm', name: 'Device Management' },
                    { code: 'mp', name: 'Marketplace' },
                ];

                if (vm.scope === 'PROJECT') {
                    vm.refreshDeviceList();
                }
            };

            /**
             * Load device list
             * @returns {void}
             */
            vm.refreshDeviceList = function() {
                Service.api.deviceList({
                    projectId: vm.projectId,
                    tag: null,
                    deviceType: 'LOOPEDGE',
                    requestedPage: 0,
                    limit: 100, // TODO: remove hardcoded limit
                    onlineOnly: false
                }).$promise
                .then(function(data) {
                    vm.deviceList = data.elements;
                    vm.deviceList.unshift({deviceId: null, prettyName: 'All'});
                });
            };

            /**
             * Show/hide filter elements
             * @returns {void}
             */
            vm.toggleFilter = function () {
                vm.filterActive = !vm.filterActive;
            };

            /**
             * Set filter into initial state
             * @return {void}
             */
            vm.reset = function() {
                vm.filterObject = angular.copy(vm.initialFilterObject);
            };

            /**
             * Submit filter form
             * @returns {void}
             */
            vm.apply = function () {
                vm.onApply({ filterObject: vm.filterObject });
            };

            /**
             * Get severity code
             * @param {string} severity - severity code
             * @return {string} icon name
             */
            vm.getSeverityIcon = function (severity) {
                try {
                    return vm.severityIcon[severity];
                } catch (e) {
                    return vm.severityIcon.unknown;
                }
            };

            /**
             * Change status
             * @return {void}
             */
            vm.changeForwardingStatus = function() {
                vm.onForwadingChange({enabled: vm.forwardingState});
            };
        }
    });
'use strict';

/**
 * @ngdoc component
 * @name loopUiApp.component:settings
 * @description
 * # settings
 */
angular.module('loopUiApp')
    .component('projectSettings', {
        templateUrl: '../scripts/components/projectSettings/projectSettings.html',
        controller: function ($stateParams, $state, Service, Commons) {
            var vm = this;

            // Used to convert selected tab number to state name and vice versa
            vm.tabs = [
                'settings',
                'members',
                //'billing',
                'credentials',
            ];

            //Init component
            vm.$onInit = function () {
                vm.currentProjectId = $stateParams.projectId;

                Service.api.projectGetById({ action: vm.currentProjectId }).$promise
                    .then(function (data) {
                        vm.project = data;
                        vm.topics = data.topics;
                    }, function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Get project error');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error projectGetById:' + JSON.stringify(reason));
                    });

                // Sets selected tab on load
                vm.selectedTab = $stateParams.selectedTab !== undefined ? vm.tabs.indexOf($stateParams.selectedTab) : 0;
            };

            /**
             * Updates the URL on tab change to persist currently selected tab
             * @return {void}
             */
            vm.changeTab = function () {
                $state.go('.', { selectedTab: vm.tabs[vm.selectedTab] }, { location: 'replace' });
            };

        }
    });

'use strict';

/**
 * @ngdoc component
 * @name loopUiApp.component:billing
 * @description
 * # billing
 */
angular.module('loopUiApp')
    .component('settings', {
        templateUrl: '../scripts/components/projectSettings/settings/settings.html',
        bindings: {
            project: '<'
        },
        controller: function ($stateParams, $state, gettextCatalog, Auth, Service, Commons) {
            var vm = this;
            //Available timezone names
            vm.timezoneList = [];
            //Selected timezone
            vm.timezone = null;
            //Is user owner flag
            vm.isUserOwner = false;

            //Init component
            vm.$onInit = function () {
                //to blink project description
                vm.item = { blink: false };
                vm.currentProjectId = $stateParams.projectId;
                vm.companyName = $stateParams.companyName;

                //Get company data
                Service.api.companyGet({ name: vm.companyName }).$promise
                    .then(function (data) {
                        vm.company = data;
                        vm.isUserOwner = vm.checkUserOwner(vm.company.teams, Auth.tokenParsed.preferred_username);
                    });

                //Get timezone list
                Service.api.projectTimezoneList({
                    projectId: vm.currentProjectId
                }).$promise
                    .then(function (data) {
                        vm.timezoneList = data;
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Failed load timezone list');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                    });

                //Get current timezone
                Service.api.projectTimezoneGet({
                    projectId: vm.currentProjectId
                }).$promise
                    .then(function (data) {
                        vm.timezone = data.timezone;
                        vm.searchTimeZone = data.timezone;
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Failed get current timezone');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                    });
            };

            /**
            * Update current project description
            * @param {object} project - project object
            * @returns {void}
            */
            vm.updateProject = function (project) {
                Service.api.project(project).$promise
                    .then(function () {
                        var _project = angular.copy(project);
                        Commons.toastShow('Project updated');
                        Commons.setCurrentProject(_project);
                        Commons.refreshProjectList();
                        vm.item.blink = true;
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Project save error');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error project POST:' + JSON.stringify(reason));
                    });
            };

            /**
             * On focus on description text area
             * @returns {void}
             */
            vm.onFocus = function () {
                vm.item.blink = false;
            };

            /**
             * Remove project
             * @param {Object} event - event object
             * @returns {void}
             */
            vm.deleteProject = function (event) {
                Commons.showConfirmationWarn(
                    gettextCatalog.getString('Remove Project'),
                    gettextCatalog.getString('Are you sure you want to remove?<br>The removed Project cannot be restored'),
                    gettextCatalog.getString('Remove'),
                    function () {
                        Service.api.projectDelete({
                            action: vm.currentProjectId
                        }).$promise
                            .then(function () {
                                Commons.toastShow('Project deleted');
                                Commons.refreshProjectList();
                                $state.go('projectList', { companyName: vm.companyName });
                            })
                            .catch(function (reason) {
                                if (reason && reason.type === 'cancel') {
                                    return;
                                }
                                var messageObject = Commons.createErrorObject(reason, 'Delete project failed');
                                Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                                console.log('Error projectDelete:' + JSON.stringify(reason));
                            });
                    }, gettextCatalog.getString('Cancel'), undefined, event);
            };

            /**
             * Save timezone
             * @returns {void}
             */
            vm.saveTimezone = function () {
                var timezone = { timezone: vm.timezone };
                Service.api.projectTimezone({
                    projectId: vm.currentProjectId
                }, timezone).$promise
                    .then(function () {
                        Commons.toastShow('Timezone saved');
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Timezone save failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error projectTimezone:' + JSON.stringify(reason));
                    });

            };

            /**
             * Filter timezone list
             * @param {string} query - search query string
             * @return {Array} - filtered mni list
             */
            vm.querySearchTimezone = function (query) {
                return query ? vm.timezoneList.filter(function (item) {
                    return angular.lowercase(item).indexOf(angular.lowercase(query)) >= 0;
                }) : vm.timezoneList;
            };

            /**
             * Check validity for timezone autocomplete timezone selector
             * @return {void}
             */
            vm.checkValidity = function () {
                var filteredList = [];
                if (vm.searchTimeZone) {
                    filteredList = vm.timezoneList.filter(function (item) {
                        return angular.lowercase(item) === angular.lowercase(vm.searchTimeZone);
                    });
                    if (filteredList.length === 1) {
                        vm.timezoneForm.timezone.$setValidity('notFromList', true);
                    } else {
                        vm.timezoneForm.timezone.$setValidity('notFromList', false);
                    }
                } else {
                    vm.timezoneForm.timezone.$setValidity('notFromList', false);
                }
            };

            /**
             * Check is current user is company OWNER
             * @param {Array} teamList - company user list
             * @param {String} login - current user login
             * @returns {Boolean} - current user OWNER flag
             */
            vm.checkUserOwner = function (teamList, login) {
                if (!angular.isArray(teamList)) {
                    return false;
                }
                for (var i = 0; i < teamList.length; i++){
                    if (teamList[i].name === 'OWNER' && angular.isArray(teamList[i].users)){
                        for (var j = 0; j < teamList[i].users.length; j++){
                            if (teamList[i].users[j].username === login) {
                                return true;
                            }
                        }
                    }
                }
                return false;
            };

        }
    });
'use strict';

/**
 * @ngdoc component
 * @name loopUiApp.component:members
 * @description
 * # members
 */
angular.module('loopUiApp')
    .component('members', {
        templateUrl: '../scripts/components/projectSettings/members/members.html',
        bindings: {
            project: '<'
        },
        controller: function ($scope, $stateParams, $mdDialog, $q, Service, Commons) {
            var vm = this;
            vm.cm = Commons;
            vm.userList = [];
            
            //Init component
            vm.$onInit = function () {
                vm.companyName = $stateParams.companyName;
                vm.currentProjectId = $stateParams.projectId;

                // Table name
                vm.entityName = 'User';

                // Generic table setup
                vm.listSetup = {
                    sortField: 'user',
                    showIndex: true,
                    editable: false,
                    removable: false,
                    limit: 10,
                    limitOptions: [10, 50, 100],
                    fields: [
                        {
                            name: 'Team',
                            column: 'teamName',
                            transformation: function (item) {
                                return vm.teams[item.teamName].name;
                            }
                        },
                        {
                            name: 'User',
                            column: 'user'
                        },
                        {
                            name: 'Status',
                            column: 'status'
                        }
                    ]
                };

                // Action list
                vm.actions = [
                    {
                        name: 'Remove',
                        icon: 'delete',
                        function: vm.removeUser
                    }
                ];

                vm.refreshCompany();

            };

            vm.$onChanges = function (changes) {
                if (changes.project && !changes.project.isFirstChange()) {
                    vm.currentTeams = Commons.transformArray(vm.project.teams);
                }
            };

            /**
             * Show invite dialog to sent user email
             * @param {Object} user - user form object
             * @param {Object} team - project level team object
             * @return {Promise} - dialog
             */
            vm.inviteUser = function (user, team) {
                // Create an isolated scope to pass to the component
                var scope = angular.extend($scope.$new(true), {
                    user: user,
                    teamName: team.code
                });

                return $mdDialog.show({
                    template: '<md-dialog aria-label="Invite Dialog"><company-invite-dialog user="user" team-name="teamName"></company-invite-dialog></md-dialog>',
                    parent: angular.element(document.body),
                    clickOutsideToClose: false,
                    preserveScope: true,
                    scope: scope,
                    skipHide: true
                });
            };

            /**
             * Seach user and add to the team
             * 1. Search user by email
             * 2. (OR) Search user by username
             * 3. (OR) Send invite
             * 4. Check if team exists
             * 5. If not exists create team
             * 6. Add to the team
             * @param {Object} user - user form object
             * @param {Object} team - team object
             * @return {void}
             */
            vm.addUser = function (user, team) {
                $q.when()
                    //1. Search user by email
                    .then(function () {
                        return Service.api.userByEmail({
                            email: user.username
                        }).$promise
                            .catch(function () {
                                return null;
                            });
                    })
                    .then(function (userByEmail) {
                        if (userByEmail) {
                            return userByEmail.username;
                        } else {
                            //2. Search user by username
                            return Service.api.userByUsername({
                                username: user.username
                            }).$promise
                                .catch(function () {
                                    return null;
                                });
                        }
                    })
                    .then(function (userByEmail) {
                        if (userByEmail) {
                            return userByEmail;
                        } else {
                            //3. Send invite
                            return vm.inviteUser(user, team)
                                .catch(function () {
                                    Commons.toastShow('Invite not sent');
                                });
                        }
                    })
                    .then(function (userByEmail) {
                        if (userByEmail) {
                            // Add to then team
                            return Service.api.companyTeamMemberAdd({
                                companyName: vm.companyName,
                                teamName: team.code,
                                username: user.username
                            }).$promise
                                .then(function () {
                                    Commons.toastShow('User ' + user.username + ' added to the team ' + vm.team.name);
                                })
                                .catch(function (reason) {
                                    var messageObject = Commons.createErrorObject(reason, 'Add user failed');
                                    Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                                });
                        }
                    })
                    .then(function () {
                        vm.refreshCompany();
                        vm.user.username = null;
                        vm.teamMemberForm.$setUntouched();
                        vm.teamMemberForm.$setPristine();
                    })
                    .catch(function (reason) {
                        if (reason) {
                            var messageObject = Commons.createErrorObject(reason, 'Add user failed');
                            Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                            console.log('Error addUser:' + JSON.stringify(reason));
                        }
                    });
            };

            /**
             * Add team to current Project
             * @param {string} team - team model
             * @returns {void}
             */
            vm.addTeamProject = function (team) {
                var index = vm.currentTeams.map(function (x) { return x.teamName; }).indexOf(team.teamName);
                if (index > -1) {
                    Commons.toastShow('Team already added');
                    vm.projectTeam = null;
                    return;
                }

                Service.api.projectGrant({
                    actionExt: vm.currentProjectId
                }, team).$promise
                    .then(function () {
                        vm.currentTeams.push(team);
                        vm.projectTeam = {};
                        vm.addTeamProjectForm.$setUntouched();
                        vm.addTeamProjectForm.$setPristine();
                        Commons.toastShow('Team added');
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Project grant error');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error projectGrant:' + JSON.stringify(reason));
                    });

            };

            /**
             * Add role [read, write] to a team
             * @param {string} team - team object
             * @returns {void}
             */
            vm.updateTeamRole = function (team) {
                Service.api.projectGrant({ actionExt: vm.currentProjectId }, team).$promise
                    .then(function () {
                        Commons.toastShow('Role added');
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Update team role error');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error updateTeamRole:' + JSON.stringify(reason));
                    });
            };

            /**
             * Remove team from projects
             * @param {any} team - team object
             */
            vm.removeTeamProject = function (team) {
                var _team = { teamName: team.teamName };
                Service.api.projectRevoke({
                    actionExt: vm.currentProjectId
                }, _team).$promise
                    .then(function () {
                        var index = vm.currentTeams.map(function (x) { return x.teamName; }).indexOf(team.teamName);
                        vm.currentTeams.splice(index, 1);
                        Commons.toastShow('Team removed');
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Project revoke error');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error projectRevoke:' + JSON.stringify(reason));
                    });
            };

            /**
             * Remove user from team
             * @param {Object} event - event object
             * @param {Object} user - user object
             * @result {void}
             */
            vm.removeUser = function (event, item) {
                Service.api.companyTeamMemberDelete({
                    companyName: vm.companyName,
                    teamName: item.teamName,
                    username: item.user
                }).$promise
                    .then(function () {
                        vm.refreshCompany();
                        Commons.toastShow('User successfully removed');
                    }, function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Remove user from team error');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error companyTeamMemberDelete:' + JSON.stringify(reason));
                    });
            };

            /**
             * Refresh company info
             * @returns {void}
             */
            vm.refreshCompany = function () {
                vm.isLoading = true;
                return Service.api.companyGet({
                    name: vm.companyName
                }).$promise
                    .then(function (data) {
                        Commons.companyData.profile = data;
                        vm.userList = vm.getUserList(Commons.companyData.profile.teams);
                    })
                    .catch(function (reason) {
                        console.log('Error companyGet:' + JSON.stringify(reason));
                    })
                    .finally(function () {
                        vm.isLoading = false;
                    });
            };

            /**
             * Get flat user list from team-user structure
             * @param {Array} teams - team user list
             * @return {Array} - flat user list by all teams
             */
            vm.getUserList = function (teams) {
                var userList = [];
                if (!teams || !angular.isArray(teams)) {
                    return userList;
                }
                // Filter only project level teams
                teams.filter(function (team) {
                    return team.name.indexOf(vm.currentProjectId) > 0;
                })
                    .forEach(function (team) {
                        team.users.forEach(function (user) {
                            userList.push({
                                teamName: team.name,
                                user: user.username,
                                status: user.attrs.status
                            });
                        });
                    });
                return userList;
            };
        }
    });

'use strict';

/**
 * @ngdoc component
 * @name loopUiApp.component:credentials
 * @description
 * # credentials
 */
angular.module('loopUiApp')
    .component('credentials', {
        templateUrl: '../scripts/components/projectSettings/credentials/credentials.html',
        controller: function (CredentialService) {
            var vm = this;

            vm.$onInit = function () {
                //Get MQTT credentials
                CredentialService.refreshMqttCredentials();

                //Load MQTT accounts
                CredentialService.refreshAccounts();

                //Load topic list
                CredentialService.refreshTopics();
            };
        }
    })
    /**
     * Credentials tab helper factory
     */
    .factory('CredentialService', ['$stateParams', 'Service', 'Commons', function ($stateParams, Service, Commons) {
        var factory = {};
        factory.mqttCredentials = [];
        factory.accounts = [];
        factory.accountsPromise = null;
        factory.accountIsLoading = false;
        factory.aclTopics = [];
        factory.topics = [];

        var currentProjectId = $stateParams.projectId;

        /**
         * Create ACL lisr
         * @param {Object} accounts - accounts object
         * @returns {Array} - ACL list
         */
        var refreshAclList = function (accounts) {
            var _aclTopics = [];
            angular.forEach(accounts, function (account) {
                for (var i = 0; i < account.topics.length; i++) {
                    var obj = {};
                    obj.accountName = account.accountName;
                    obj.topic = account.topics[i];
                    _aclTopics.push(obj);
                }
            });
            return _aclTopics;
        };

        /**
         * Create topic list helper 
         * @param {Array} topics - topic list
         * @returns {Array} - topic list
         */
        var refreshTopicList = function (topics) {
            return topics.map(function (topic) {
                var obj = {},
                    parts = topic.split('/');
                obj.topicName = topic;
                obj.name = parts[2];
                if (['data', 'req', 'resp'].indexOf(parts[1]) >= 0) {
                    obj.default = true;
                    switch (parts[1]) {
                    case 'data':
                        obj.description = 'To send the data';
                        break;
                    case 'req':
                        obj.description = 'To send request';
                        break;
                    case 'resp':
                        obj.description = 'To receive responses';
                        break;
                    default:
                        obj.description = '';
                        break;
                    }
                } else {
                    obj.default = false;
                    obj.description = 'Custom topic';
                }
                return obj;
            });
        };

        /**
         * Refresh MQTT credentials list
         * @returns {void}
         */
        factory.refreshMqttCredentials = function () {
            Service.api.projectMqttCredentials({ projectId: currentProjectId }).$promise
                .then(function (data) {
                    factory.mqttCredentials = data;
                })
                .catch(function (reason) {
                    var messageObject = Commons.createErrorObject(reason, 'Get project credentials list error');
                    Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                    console.log('Error projectMqttCredentials:' + JSON.stringify(reason));
                });
        };

        /**
         * Refresh MQTT account list
         * @returns {void}
         */
        factory.refreshAccounts = function () {
            factory.accountIsLoading = true;
            factory.accountsPromise = Service.api.projectMqttGetAccounts({
                projectId: currentProjectId
            }).$promise;

            factory.accountsPromise.then(function (data) {
                factory.accounts = data;
                factory.aclTopics = refreshAclList(data);
            })
                .catch(function (reason) {
                    var messageObject = Commons.createErrorObject(reason, 'Get project MQTT list error');
                    Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                    console.log('Error projectMqttGetAccounts:' + JSON.stringify(reason));
                })
                .finally(function() {
                    factory.accountIsLoading = false;
                });
        };

        /**
         * Refresh topic list
         */
        factory.refreshTopics = function () {
            factory.topicPromise = Service.api.projectTopicsCredentials({
                projectId: currentProjectId
            }).$promise;

            factory.topicPromise
                .then(function (data) {
                    factory.topics = data;
                    factory.topicList = refreshTopicList(data);
                })
                .catch(function (reason) {
                    factory.topics = [];
                    var messageObject = Commons.createErrorObject(reason, 'Get credentials topic list');
                    Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                    console.log('Error projectTopicsCredentials:' + JSON.stringify(reason));
                });
        };

        return factory;

    }]);
'use strict';

/**
 * @ngdoc component
 * @name loopUiApp.component:connection
 * @description
 * # connection
 */
angular.module('loopUiApp')
    .component('connection', {
        templateUrl: '../scripts/components/projectSettings/credentials/connection.html',
        controller: function ($mdDialog, CredentialService, Service, Commons) {
            var vm = this;
            vm.cs = CredentialService;
            vm.cm = Commons;
            vm.certName = 'ca.pem';
            vm.webCertificate = {};

            vm.$onInit = function() {
                vm.getWebServerCertificate();
            };

            /**
            * Show help windows
            */
            vm.openHelp = function (env) {
                $mdDialog.show({
                    contentElement: '#myDialog',
                    parent: angular.element(document.body),
                    targetEvent: env,
                    clickOutsideToClose: true
                });
            };

            /**
             * Get the web server certificate
             * 1. Get current certificate type
             * 2. Get certificate object
             */
            vm.getWebServerCertificate = function () {
                Service.api.domainSslList().$promise
                    .then(function (data) {
                        // Find current cert type
                        var type = Object.keys(data)
                            .filter(function (key) {
                                return data[key] && data[key].value === true;
                            })[0] || 'SELFSIGNED'; // Use self-signed as default type
                        return Service.api.domainSslDetails({
                            actionExt: type
                        }).$promise;
                    })
                    .then(function (data) {
                        vm.webCertificate = data;
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Get web server certificate failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error domainSslList:' + JSON.stringify(reason));
                    });
            };
        }
    });
'use strict';

/**
 * @ngdoc component
 * @name loopUiApp.component:credentials
 * @description
 * # credentials
 */
angular.module('loopUiApp')
    .component('mqttAccounts', {
        templateUrl: '../scripts/components/projectSettings/credentials/mqttAccounts.html',
        controller: function ($mdDialog, $stateParams, CredentialService, Service, Commons) {
            var vm = this;
            vm.cs = CredentialService;
            vm.cm = Commons;

            vm.currentProjectId = $stateParams.projectId;

            vm.showUserSearch = false;

            vm.$onInit = function () {
                //mqtt account table
                vm.userOptions = {
                    boundrayLinks: true,
                    pageSelect: true,
                };
                // settings  
                vm.userQuery = {
                    order: 'accountName',
                    limit: 5,
                    page: 1
                };
            };

            /**
              * Toggle search bar on top of table
              * @returns {void} 
              */
            vm.toggleUserSearch = function () {
                vm.showUserSearch = !vm.showUserSearch;
                delete vm.filterSearchUsername;
            };

            /**
             * Create new MQTT account
             * @param {Object} event - event object
             * @returns {void}
             */
            vm.createAccount = function (event) {
                Service.api.projectMqttCreateAccount({
                    projectId: vm.currentProjectId
                }).$promise
                    .then(function (data) {
                        CredentialService.refreshAccounts();
                        $mdDialog.show({
                            templateUrl: '../scripts/components/projectSettings/credentials/credentialsDialog.html',
                            targetEvent: event,
                            parent: angular.element(document.body),
                            clickOutsideToClose: false,
                            preserveScope: false,
                            controllerAs: 'vm',
                            locals: { account: data },
                            controller: ['account', '$mdDialog', 'Commons', function (account, $mdDialog, Commons) {
                                var vm = this;
                                vm.cm = Commons;
                                vm.account = account;
                                vm.accept = function () {
                                    $mdDialog.hide(vm.account);
                                };
                                vm.cancel = function () {
                                    $mdDialog.hide();
                                };
                            }],
                        });
                    });
            };

            /**
             * Remove account
             * @param {Object} account - account object
             * @returns {void}
             */
            vm.removeAccount = function (account) {
                Service.api.projectMqttDeleteAccount({ projectId: vm.currentProjectId, name: account.accountName }).$promise
                    .then(function () {
                        CredentialService.refreshAccounts();
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Delete MQTT account error');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error projectMqttDeleteAccount:' + JSON.stringify(reason));
                    });
            };
        }
    });
'use strict';

/**
 * @ngdoc component
 * @name loopUiApp.component:accessControlList
 * @description
 * # accessControlList
 */
angular.module('loopUiApp')
    .component('accessControlList', {
        templateUrl: '../scripts/components/projectSettings/credentials/accessControlList.html',
        controller: function ($mdDialog, $stateParams, CredentialService, Service, Commons) {
            var vm = this;
            this.$onInit = function () {
                vm.currentProjectId = $stateParams.projectId;
                vm.showSearch = false;
                vm.cs = CredentialService;
                
                //acl table query
                vm.aclTopicsQuery = {
                    order: 'accountName',
                    limit: 5,
                    page: 1
                };

                //acl talbe options
                vm.aclTopicsOption = {
                    boundrayLinks: true,
                    pageSelect: false
                };
            };

            /**
             * Togle search bar on top of table
             * @returns {void}
             */
            vm.toggleSearch = function () {
                vm.showSearch = !vm.showSearch;
                delete vm.topicSearchFilter;
            };

            /**
             * Add credentials dialog
             * @param {object} event - event object
             * @returns {void}
             */
            vm.addCredentials = function (event) {
                $mdDialog.show({
                    templateUrl: '../scripts/components/projectSettings/credentials/credentialsDialog.html',
                    targetEvent: event,
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                    preserveScope: false,
                    controllerAs: 'vm',
                    locals: { topics: vm.topics, accounts: vm.accounts },
                    controller: ['$mdDialog', 'CredentialService', function ($mdDialog, CredentialService) {
                        var vm = this;
                        vm.cs = CredentialService;
                        vm.credentials = {
                            topics: [],
                            subscribe: false,
                            publish: false
                        };

                        vm.cancel = function () {
                            $mdDialog.cancel();
                        };

                        vm.accept = function (output) {
                            $mdDialog.hide(output);
                        };
                    }]
                })
                    .then(function (credential) {
                        var topics = [];
                        angular.forEach(credential.topics, function (topic) {
                            if (credential.subscribe === true) {
                                //subscribe = 1
                                var subAcl = { topic: topic, access: 1 };
                                topics.push(subAcl);
                            }
                            if (credential.publish === true) {
                                //publish = 2
                                var pubAcl = { topic: topic, access: 2 };
                                topics.push(pubAcl);
                            }
                        });
                        Service.api.projectMqttGrantAccount({ 
                            projectId: vm.currentProjectId, 
                            account: credential.accountName 
                        }, topics).$promise
                            .then(function () {
                                CredentialService.refreshAccounts();
                            })
                            .catch(function (reason) {
                                var messageObject = Commons.createErrorObject(reason, 'Project MQTT grant error');
                                Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                                console.log('Error projectMqttGrantAccount:' + JSON.stringify(reason));
                            });
                    });
            };

            /**
             * Remove credential
             * @param {Object} topic
             */
            vm.removeCredential = function (topic) {
                var body = [];
                body.push(topic.topic);
                Service.api.projectMqttRevokeAccount({ 
                    projectId: vm.currentProjectId, 
                    account: topic.accountName 
                }, body).$promise
                    .then(function () {
                        CredentialService.refreshAccounts();
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Remove Error');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                    });
            };
        }
    });

'use strict';

/**
 * @ngdoc component
 * @name loopUiApp.component:topicsCredentials
 * @description
 * # topicsCredentials
 */
angular.module('loopUiApp')
    .component('topicsCredentials', {
        templateUrl: '../scripts/components/projectSettings/credentials/topicsCredentials.html',
        controller: function ($stateParams, $mdDialog, CredentialService, Commons, Service) {
            var vm = this;
            //Current project id
            vm.currentProjectId = $stateParams.projectId;
            vm.cm = Commons;
            vm.cs = CredentialService;
            //Search filter show flag
            vm.showSearch = false;

            vm.$onInit = function () {
                //acl table query
                vm.topicsQuery = {
                    order: 'topicName',
                    limit: 10,
                    page: 1
                };

                //acl table options
                vm.topicsOption = {
                    boundrayLinks: true,
                    pageSelect: false
                };
            };

            /**
             * Open topic dialog
             * @param {Object} event - event object
             * @returns {void}
             */
            vm.addTopicDialog = function (event) {
                $mdDialog.show({
                    templateUrl: '../scripts/components/projectSettings/credentials/credentialsDialog.html',
                    targetEvent: event,
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                    preserveScope: true,
                    controllerAs: 'vm',
                    controller: ['$mdDialog', function ($mdDialog) {
                        var vm = this;
                        vm.topicCredentials = {
                            name: '',
                            description: 'custom topic'
                        };
                        vm.accept = function (output) {
                            $mdDialog.hide(output);
                        };

                        /**
                         * Cancel dialog button
                         * @return {undefined}
                         */
                        vm.cancel = function () {
                            $mdDialog.cancel();
                        };
                    }]
                })
                    .then(function (topic) {
                        Service.api.projectMqttAddTopics({
                            name: topic.name,
                            projectId: vm.currentProjectId
                        }).$promise
                            .then(function () {
                                CredentialService.refreshTopics();
                            })
                            .catch(function (reason) {
                                var messageObject = Commons.createErrorObject(reason, 'Add topic error');
                                Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                                console.log('Error projectMqttAddTopics:' + JSON.stringify(reason));
                            });
                    });
            };

            /**
             * For search bar on top of table
             * @returns {void}
             */
            vm.toggleSearch = function () {
                vm.showSearch = !vm.showSearch;
                delete vm.filterSearch;
            };

            /**
             * Remove topic
             * @param {Object} topic - topic object
             * @return {void}
             */
            vm.removeTopic = function (topic) {
                vm.topicPromise = Service.api.projectMqttDeleteTopics({
                    name: topic.name,
                    projectId: vm.currentProjectId
                }).$promise
                    .then(function () {
                        CredentialService.refreshTopics();
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Delete topic error');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error projectMqttDeleteTopics:' + JSON.stringify(reason));

                    });
            };
        }
    });

'use strict';

/**
 * @ngdoc component
 * @name loopUiApp.component:billing
 * @description
 * # billing
 */
angular.module('loopUiApp')
    .component('billing', {
        templateUrl: '../scripts/components/projectSettings/billing/billing.html',
        controller: function ($scope, $stateParams, $mdDialog, billingMetrics, Service, Commons) {
            var vm = this;
            vm.cm = Commons;
            vm.bm = billingMetrics;

            //Pagination settings
            vm.paginationOptions = {
                limit: 10,
                page: 1,
                limitOptions: [10, 20, 50]
            };

            //Dummy events
            vm.eventList = [
                {
                    eventTime: 1520571508000,
                    level: 'level1',
                    message: 'Plan Basic selected'
                },
                {
                    eventTime: 1520571508000,
                    level: 'level1',
                    message: 'Message count change state to Warning'
                },
                {
                    eventTime: 1520571508000,
                    level: 'level1',
                    message: 'Database usage change state to Critical',
                },
                {
                    eventTime: 1520571508000,
                    level: 'level1',
                    message: 'Plan Medium selected',
                }];

            vm.$onInit = function () {
                //Current project
                vm.projectId = $stateParams.projectId;
            };

            /**
             * Show billing plan selector
             * @param {Event} event - event object
             * @return {void}
             */
            vm.changePlanDialogShow = function (event) {
                $mdDialog.show({
                    template: '<billing-plan-selector></billing-plan-selector>',
                    parent: angular.element(document.body),
                    targetEvent: event,
                    clickOutsideToClose: false,
                    preserveScope: true,
                    skipHide: true
                })
                    .then(function () {
                        vm.cm.refreshBillingPlan(vm.projectId);
                    })
                    .catch(function () {
                        //console.log('Cancel write');
                    });
            };
        }
    });

'use strict';

/**
 * @ngdoc component
 * @name loopUiApp.component:billingPlanSelector
 * @description
 * # billingPlanSelector
 */
angular.module('loopUiApp')
    .component('billingPlanSelector', {
        templateUrl: '../scripts/components/projectSettings/billing/billingPlanSelector.html',
        controller: function ($stateParams, $mdDialog, Service, Commons) {
            var vm = this;
            vm.cm = Commons;
            //Available plans objecs
            vm.billingPlanObject = {};
            //Code of plans (to order purpose)
            vm.billingPlanList = ['BASIC', 'MEDIUM', 'ADVANCED'];
            vm.isLoading = true;

            //Init component
            vm.$onInit = function () {
                //Current project
                vm.projectId = $stateParams.projectId;
                //Get billing plan list
                vm.refreshBillingPlans();
            };

            /**
             * Refresh billing plan list
             * @return {void}
             */
            vm.refreshBillingPlans = function () {
                vm.isLoading = true;
                Service.api.billingPlans().$promise
                    .then(function (response) {
                        vm.billingPlanObject = response;
                    })
                    .catch(function (reason) {
                        console.log('Error billingPlans:' + JSON.stringify(reason));
                        var messageObject = Commons.createErrorObject(reason, 'Get Billing Plans error');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                    })
                    .finally(function () {
                        vm.isLoading = false;
                    });
            };

            /**
             * Change billing plan
             * @param {String} planName selected plna name
             * @returns {void}
             */
            vm.saveBillingPlan = function (planName) {
                var plan = { billingPlan: planName };
                vm.isSaving = true;
                
                Service.api.billingPlan({
                    actionExt: vm.projectId
                }, plan).$promise
                .then(function() {
                    vm.cm.currentBillingPlan = vm.billingPlanObject[planName];
                    vm.refreshBillingPlans();
                    Commons.toastShow('Billing plan saved');
                })
                .catch(function (reason) {
                    console.log('Error billingPlan:' + JSON.stringify(reason));
                    var messageObject = Commons.createErrorObject(reason, 'Save Billing Plans error');
                    Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                })
                .finally(function() {
                    vm.isSaving = false;
                });
            };

            vm.isBillingPlanSelected = function (plan) {
                return plan.code && vm.cm.currentBillingPlan.code === plan.code;
            };

            /**
            * Hides the dialog
            * @returns {void} 
            */
            vm.hide = function () {
                $mdDialog.hide();
            };

        }
    });

'use strict';

/**
 * @ngdoc component
 * @name loopUiApp.component:edgeBackupPolicy
 * @description
 * # edgeBackupPolicy
 */
angular.module('loopUiApp')
    .component('edgeBackupPolicy', {
        templateUrl: '../scripts/components/projectSettings/edgeBackupPolicy/edgeBackupPolicy.html',
        controller: function ($stateParams, Service, Commons) {
            var vm = this;
            vm.isLoading = false;

            vm.$onInit = function () {
                vm.currentProjectId = $stateParams.projectId;

                vm.refreshProjectRetention();
            };

            /**
             * Get backup retention policy for current project
             * @returns {void}
             */
            vm.refreshProjectRetention = function () {
                vm.isLoading = true;
                Service.api.projectRetentionGet({
                    actionExt: vm.currentProjectId
                }).$promise
                    .then(function (data) {
                        vm.latestBackupsToKeep = data.latestBackupsToKeep || 0;
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Get backup retention failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error projectRetentionGet:' + JSON.stringify(reason));
                    })
                    .finally(function () {
                        vm.isLoading = false;
                    });
            };

            /**
             * Save backup retention policy for current project
             * @returns {void}
             */
            vm.save = function () {
                vm.isSaving = true;
                Service.api.projectRetention({
                    actionExt: vm.currentProjectId
                }, {
                    latestBackupsToKeep: vm.latestBackupsToKeep
                }).$promise
                    .then(function () {
                        Commons.toastShow('Backup retention policy updated');
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Save project backup policy failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error projectRetention:' + JSON.stringify(reason));
                    })
                    .finally(function () {
                        vm.isSaving = false;
                    });
            };
        }
    });
'use strict';

/**
 * @ngdoc component
 * @name loopUiApp.component:edgeStoragePolicy
 * @description
 * # edgeStoragePolicy
 */
angular.module('loopUiApp')
    .component('edgeStoragePolicy', {
        templateUrl: '../scripts/components/projectSettings/edgeStoragePolicy/edgeStoragePolicy.html',
        controller: function ($stateParams, Service, Commons) {
            var vm = this;
            vm.isLoading = false;
            vm.storagePolicy = {};

            vm.$onInit = function () {
                vm.currentProjectId = $stateParams.projectId;

                vm.storageSettings = [
                    { id: 'storeOmaData', name: 'OMA data', description: 'Store OMA data in Clickhouse' },
                    { id: 'storeRawData', name: 'RAW data', description: 'Store RAW data in Clickhouse' },
                ];

                vm.refreshProjectStoragePolicy();
            };

            /**
             * Get storage policy for current project
             * @returns {void}
             */
            vm.refreshProjectStoragePolicy = function () {
                vm.isLoading = true;
                Service.api.projectStoragePolicyGet({
                    actionExt: vm.currentProjectId
                }).$promise
                    .then(function (data) {
                        vm.storagePolicy = data;
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Get storage policy failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error projectStoragePolicyGet:' + JSON.stringify(reason));
                    })
                    .finally(function () {
                        vm.isLoading = false;
                    });
            };

            /**
             * Save storage policy for current project
             * @returns {void}
             */
            vm.save = function () {
                vm.isSaving = true;
                Service.api.projectStoragePolicy({
                    actionExt: vm.currentProjectId
                },
                    vm.storagePolicy
                ).$promise
                    .then(function () {
                        Commons.toastShow('Storage policy updated');
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Save storage policy failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error projectStoragePolicy:' + JSON.stringify(reason));
                    })
                    .finally(function () {
                        vm.isSaving = false;
                    });
            };
        }
    });
'use strict';

/**
 * @ngdoc component
 * @name loopUiApp.component:edgePollingSettings
 * @description
 * # edgePollingSettings
 */
angular.module('loopUiApp')
    .component('edgePollingSettings', {
        templateUrl: '../scripts/components/projectSettings/edgePollingSettings/edgePollingSettings.html',
        controller: function ($stateParams, gettextCatalog, Service, Commons, edgePollingCheck) {
            var vm = this;
            vm.isLoading = false;
            vm.isSaving = false;
            vm.settings = {};
            vm.instanceSettings = {};
            // Edge device management polling interval limits
            vm.POLLING_MIN_INTERVAL = 30;
            vm.POLLING_MAX_INTERVAL = 604800;
            vm.POLLING_INTERVAL_WARN_VALUE = 1000;

            vm.$onInit = function () {
                vm.projectId = $stateParams.projectId;
                vm.companyName = $stateParams.companyName;

                vm.adminUilink = Commons.getAdminUiLink() + '/settings/management';  

                vm.refreshInstanceSettings();
                vm.refreshSettings();
            };

            /**
             * Get polling settings for current project
             * @returns {void}
             */
            vm.refreshSettings = function () {
                vm.isLoading = true;
                vm.settings = {};
                Service.api.projectEdgePollingSettingsGet({
                    actionExt: vm.projectId
                }).$promise
                    .then(function (data) {
                        vm.settings = data;
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Get poll settings failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error projectEdgePollingSettingsGet:' + JSON.stringify(reason));
                    })
                    .finally(function () {
                        vm.isLoading = false;
                    });
            };

            /**
             * Save polling settings for current project
             * @returns {void}
             */
            vm.saveSettings = function () {
                var _saveFn = function () {
                    vm.isSaving = true;
                    Service.api.projectEdgePollingSettings({
                        actionExt: vm.projectId
                    }, vm.settings).$promise
                        .then(function () {
                            Commons.toastShow('Sync settings saved');
                            if (vm.settings.useInstanceSettings === true) {
                                vm.refreshSettings();
                            }
                            edgePollingCheck.getEdgePollingSettings(vm.projectId);
                        })
                        .catch(function (reason) {
                            var messageObject = Commons.createErrorObject(reason, 'Failed to save sync settings');
                            Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                            console.log('Error projectEdgePollingSettings:' + JSON.stringify(reason));
                        })
                        .finally(function () {
                            vm.isSaving = false;
                        });
                };

                Commons.showConfirmation(
                    gettextCatalog.getString('Edge Device Metrics Sync Settings'),
                    gettextCatalog.getString('Saving the Edge Device Metrics Sync Settings will <strong>override</strong> any settings ' +
                        'at Edge Device level. <strong>This action cannot be undone</strong>.<br>Click ‘Confirm’ to proceed with this action'),
                    gettextCatalog.getString('Confirm'),
                    _saveFn,
                    gettextCatalog.getString('Cancel'),
                    vm.refreshSettings,
                    null);
            };

            /**
             * Get polling settings for the instance
             * @returns {void}
             */
            vm.refreshInstanceSettings = function () {
                Service.api.instanceEdgePollingSettingsGet().$promise
                    .then(function (data) {
                        vm.instanceSettings = data;
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Get poll settings failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error projectEdgePollingSettingsGet:' + JSON.stringify(reason));
                    });
            };

            /**
             * Check if switcher is disabled: if polling on project is disabled or if instance settings are used
             * @returns {boolean}
             */
            vm.isSettingDisabled = function () {
                return vm.settings.useInstanceSettings === true;
            };

            /**
             * Check if interval is disabled: if polling on project or instance is disabled 
             * or if instance interval is used
             * @returns {boolean}
             */
            vm.isIntervalDisabled = function () {
                return vm.settings.enabled === false || vm.isSettingDisabled();
            };

            /**
             * Show warning if project level settings are disabled and instance settings are used
             * @returns {boolean}
             */
            vm.isInstanceWarningShown = function () {
                return vm.instanceSettings.enabled === false && vm.settings.useInstanceSettings === true;
            };

            /**
             * Check if project level settings require the warning:
             * 1. If polling interval is higher than the minimum allowed interval
             * 2. If polling is disabled
             * 3. And if instance settings are not used
             * @returns {boolean}
             */
            vm.isWarningShown = function () {
                return (vm.settings.intervalSec > vm.POLLING_INTERVAL_WARN_VALUE || vm.settings.enabled === false) &&
                    vm.settings.useInstanceSettings === false;
            };

            /**
             * Open warning details dialog
             * @returns {void}
             */
            vm.openWarningDetails = function () {
                edgePollingCheck.showInfo();
            };

            /**
             * Run polling manually
             * @returns {void}
             */
            vm.runPolling = function () {
                edgePollingCheck.runPolling();
            };

        }
    });
'use strict';

/**
 * @ngdoc component
 * @name loopUiApp.component:edgePollingInfoDialog
 * @description
 * # edgePollingInfoDialog
 */
angular.module('loopUiApp')
    .component('edgePollingInfoDialog', {
        templateUrl: '../scripts/components/projectSettings/edgePollingInfoDialog/edgePollingInfoDialog.html',
        controller: function ($state, $stateParams, $mdDialog, edgePollingCheck) {
            var vm = this;

            /**
             * Open settings page
             * @return {undefined}
             */
            vm.openSettings = function () {
                $state.go('settings', { companyName: $stateParams.companyName, projectId: $stateParams.projectId });
                $mdDialog.cancel();
            };

            /**
             * Run sync manually
             * @returns {void}
             */
            vm.runSyncing = function() {
                $mdDialog.cancel();
                edgePollingCheck.runPolling();
            };

            /**
             * Cancel dialog button
             * @return {undefined}
             */
            vm.cancel = function () {
                $mdDialog.cancel();
            };
        }
    });
'use strict';

/**
 * @ngdoc component
 * @name loopUiApp.component:edgePollingRunDialog
 * @description
 * # edgePollingRunDialog
 */
angular.module('loopUiApp')
    .component('edgePollingRunDialog', {
        templateUrl: '../scripts/components/projectSettings/edgePollingRunDialog/edgePollingRunDialog.html',
        controller: function ($stateParams, $interval, $mdDialog, Service, Commons) {
            var vm = this;
            vm.isRunning = false;
            vm.isFirstRun = true;
            vm.sessionId = null;
            vm.items = [];

            vm.$onInit = function () {
                // Run executors on open
                vm.runExecutors();
            };

            /**
             * Run all executors
             */
            vm.runExecutors = function () {
                vm.isRunning = true;
                Service.api.projectEdgePollingStart({
                    actionExt: $stateParams.projectId
                }, {}).$promise
                    .then(function (data) {
                        if (data && data.sessionId) {
                            vm.sessionId = data.sessionId;
                            vm.checkExecutorsStats();
                            vm.startPulling();
                        }
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Failed to run executors');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error projectEdgePollingStart:' + JSON.stringify(reason));
                        vm.stopPulling();
                    })
                    .finally(function () {
                        vm.isFirstRun = false;
                    });
            };

            /**
             * Check executors stats
             * @return {void}
             */
            vm.checkExecutorsStats = function () {
                Service.api.projectEdgePollingStatus({
                    sessionId: vm.sessionId
                }).$promise
                    .then(function (data) {
                        if (data && data.completed === true) {
                            vm.stopPulling();
                        }
                        vm.items = data.executors || [];
                    })
                    .catch(function (reason) {
                        console.log('Error projectEdgePollingStatus:' + JSON.stringify(reason));
                        vm.stopPulling();
                    });
            };

            /**
             * Start execution pulling
             * @return {undefined}
             */
            vm.startPulling = function () {
                if (!vm.pollingInterval) {
                    vm.pollingInterval = $interval(vm.checkExecutorsStats, 5000);
                }
            };

            /**
             * Stop execution pulling
             */
            vm.stopPulling = function () {
                vm.isRunning = false;
                if (vm.pollingInterval) {
                    $interval.cancel(vm.pollingInterval);
                    vm.pollingInterval = null;
                }
            };

            /**
             * Cancel dialog button
             * @return {undefined}
             */
            vm.cancel = function () {
                vm.stopPulling();
                $mdDialog.cancel();
            };
        }
    });
'use strict';
/**
 * @ngdoc component
 * @name loopUiApp.component:alertSettings
 * @description
 * # authDailog
 */
angular.module('loopUiApp')
    .component('alertSettings', {
        templateUrl: '../scripts/components/alert/alertSettings.html',
        controller: function ($state, $stateParams) {
            var vm = this;
            vm.tabs = [
                'incidents',
                'triggers',
                'notifications',
            ];

            vm.$onInit = function () {
                // Sets selected tab on load
                vm.selectedTab = $stateParams.selectedTab !== undefined ? vm.tabs.indexOf($stateParams.selectedTab) : 0;
            };

            /**
             * Updates the URL on tab change to persist currently selected tab
             * @return {void}
             */
            vm.changeTab = function () {
                $state.go('.', { selectedTab: vm.tabs[vm.selectedTab] }, { location: 'replace' });
            };
        }
    });
'use strict';
/**
 * @ngdoc 
 * @name loopUiApp.component:triggerList
 * @description
 * # triggerList
 */
angular.module('loopUiApp')
    .component('triggerList', {
        templateUrl: '../scripts/components/alert/trigger/triggerList.html',
        controller: function ($stateParams, $state, gettextCatalog, Service, Commons) {
            var vm = this;
            vm.triggerListLoading = false;
            vm.triggerList = [];
            vm.searchString = '';
            vm.scopeMap = {
                EDGE: gettextCatalog.getString('Edge Device'),
                EDGE_ALL: gettextCatalog.getString('All Edge Devices'),
                INSTANCE: gettextCatalog.getString('Instance Metrics')
            };

            vm.$onInit = function () {
                //Current company and project
                vm.companyName = $stateParams.companyName;
                vm.projectId = $stateParams.projectId;

                vm.triggerPagination = {
                    limitOptions: [10, 50, 100],
                    limit: 10,
                    page: 1
                };

                vm.filterActions = [
                    {
                        label: 'Add a new Trigger',
                        icon: 'add',
                        buttonClick: function () {
                            vm.showTriggerDialog();
                        }
                    }, {
                        label: 'Refresh',
                        icon: 'refresh',
                        buttonClick: vm.refreshTriggerList
                    }];

                vm.refreshTriggerList();
            };

            /**
             * Refresh trigger list
             */
            vm.refreshTriggerList = function () {
                vm.triggerListLoading = true;
                vm.triggerListPromise = Service.api.triggerList({
                    projectId: vm.projectId
                }).$promise;
                vm.triggerListPromise
                    .then(function (data) {
                        vm.triggerListOrig = (data || []).filter(function (item) {
                            return item.scopeType === 'USER';
                        });
                        vm.triggerList = angular.copy(vm.triggerListOrig);
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Get trigger list failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error triggerList:' + JSON.stringify(reason));
                    })
                    .finally(function () {
                        vm.triggerListLoading = false;
                    });
            };

            /**
             * Delete trigger
             * @param {String} triggerId trigger id 
             * @return {undefined}
             */
            vm.deleteTrigger = function (event, triggerId) {
                Commons.showConfirmationWarn(
                    gettextCatalog.getString('Remove Trigger'), 
                    gettextCatalog.getString('Are you sure you want to remove?<br> Removed trigger cannot be restored'), 
                    gettextCatalog.getString('Remove'), 
                    function () {
                    Service.api.triggerDelete({
                        projectId: vm.projectId,
                        triggerId: triggerId
                    }).$promise
                        .then(function () {
                            Commons.toastShow('Trigger deleted');
                            vm.refreshTriggerList();
                        })
                        .catch(function (reason) {
                            var messageObject = Commons.createErrorObject(reason, 'Delete trigger failed');
                            Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                            console.log('Error deleteTrigger:' + JSON.stringify(reason));
                        });
                }, gettextCatalog.getString('Cancel'), undefined, event);
            };

            /**
            * Show trigger edit dialog
            * @param {event} env object
            * @param {Object} trigger object
            * @return {undefined} 
            */
            vm.showTriggerDialog = function (trigger) {
                var _triggerId = trigger ? trigger.id : 'new';
                $state.go('triggerDetails', {
                    companyName: vm.companyName,
                    projectId: vm.projectId,
                    triggerId: _triggerId
                });
            };

            /**
             * Hides delete button for the default triggers
             * 
             * @param {Object} trigger - trigger object
             * @returns {boolean} - is it possible to delete trigger?
             */
            vm.canBeDeleted = function (trigger) {
                return trigger.scopeType && trigger.scopeType === 'USER';
            };

            /* 
             * Calculate trigger rules
             * @param {Object} trigger - trigger object 
             * @return {string} - result
             */
            vm.rulesCount = function (trigger) {
                if (!trigger) {
                    return '';
                }
                var _rulesName = trigger.sourceType === 'METRICS' ? 'metricRules' : 'eventRules';
                return trigger[_rulesName] ? trigger[_rulesName].length : '';
            };

            /**
             * Open device details view
             * @param {string} deviceId - device id
             * @returns {void}
             */
            vm.openDeviceDetail = function (deviceId) {
                $state.go('deviceView', {
                    companyName: vm.companyName,
                    projectId: vm.projectId,
                    deviceId: deviceId,
                });
            };

            /**
             * On filter handler
             * @param {String} predicate - search string
             * @return {void}
             */
            vm.filterHandler = function (predicate) {
                vm.searchString = predicate;
                vm.triggerList = vm.triggerListOrig.filter(vm.filterFn);
            };

            /**
             * Filter function for the trigger list
             * @param {Object} item - trigger object
             * @returns 
             */
            vm.filterFn = function (item) {
                if (vm.searchString === '') {
                    return true;
                }
                return (item.name + item.description).toUpperCase().indexOf(vm.searchString.toUpperCase()) >= 0;
            };

            /**
             * Is data available after load
             * @return {boolean} - data exists flag
             */
            vm.showNoData = function () {
                return !vm.triggerList || vm.triggerList.length === 0 &&
                    !(vm.triggerListPromise && vm.triggerListPromise.$$state && vm.triggerListPromise.$$state.status === 0);
            };
        }
    });
'use strict';
/**
 * @ngdoc 
 * @name loopUiApp.component:triggerDetails
 * @description
 * # triggerDetails
 */
angular.module('loopUiApp')
    .component('triggerDetails', {
        templateUrl: '../scripts/components/alert/trigger/triggerDetails.html',
        controller: function ($stateParams, $state, gettextCatalog, Service, Commons) {
            var vm = this;
            vm.cm = Commons;
            vm.triggerList = [];
            // Variables loading flag
            vm.isVariablesLoading = false;
            // Map of metrics rules
            vm.metricsRules = {};
            // Trigger scope list
            vm.scopeList = [
                { code: 'EDGE_ALL', name: gettextCatalog.getString('All Edge Devices') },
                { code: 'EDGE', name: gettextCatalog.getString('Edge Device') },
                { code: 'INSTANCE', name: gettextCatalog.getString('Instance Metrics') }
            ];

            /**
             * Init component
             * @return {undefined}
             */
            vm.$onInit = function () {
                //Current company and project
                vm.companyName = $stateParams.companyName;
                vm.projectId = $stateParams.projectId;

                //Default empty trigger
                vm.defaultTrigger = {
                    id: null,
                    active: false,
                    advancedRules: '',
                    deduplicate: false,
                    subject: '',
                    message: '',
                    messageResolved: '',
                    name: '',
                    severity: 0,
                    notifyGracePeriod: null,
                    notifyContinuously: false,
                    showOnDashboard: true,
                    simpleRules: [],
                    eventRules: [],
                    dataRules: [],
                    metricRules: [],
                    tags: [],
                    deviceId: null,
                    scope: vm.scopeList[0].code,
                    scopeType: 'USER',
                    sourceType: 'METRICS',
                    alertDelay: 60
                };

                if ($stateParams.triggerId !== 'new') {
                    vm.loadTriggerData($stateParams.triggerId);
                } else {
                    vm.trigger = vm.defaultTrigger;
                    vm.prepareVariables(vm.trigger.sourceType);
                }

                vm.refreshDeviceList();
                vm.refreshTriggerList();

                vm.variables = [];

                vm.refreshActionList();
            };

            /**
             * Load trigger data
             * @param {string} triggerId - trigger id
             * @return {void}
             */
            vm.loadTriggerData = function (triggerId) {
                Service.api.triggerList({
                    projectId: vm.projectId,
                    triggerId: triggerId
                }).$promise
                    .then(function (data) {
                        vm.trigger = data[0];
                        vm.isMessageResolvedVisible = !!vm.trigger.messageResolved;
                        vm.trigger.sourceType = vm.trigger.sourceType || 'METRICS';
                        vm.trigger.alertDelay = vm.trigger.alertDelay || 30;
                        vm.prepareVariables(vm.trigger.sourceType);
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Get Trigger failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                    });

            };

            /**
             * Refresh action list
             * 
             */
            vm.refreshActionList = function () {
                Service.api.projectActionList({
                    projectId: vm.projectId
                }).$promise
                    .then(function (data) {
                        vm.actionList = data;
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Get action list failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error actionList:' + JSON.stringify(reason));
                    });
            };

            /**
             * Load device list
             * @returns {void}
             */
            vm.refreshDeviceList = function () {
                Service.api.deviceList({
                    projectId: vm.projectId,
                    deviceType: 'LOOPEDGE',
                    requestedPage: 0,
                    limit: 1000, // TODO: remove hardcoded limit
                    onlineOnly: false
                }).$promise
                    .then(function (data) {
                        vm.deviceList = data.elements;
                    });
            };

            /**
             * Refresh trigger list
             */
            vm.refreshTriggerList = function () {
                Service.api.triggerList({
                    projectId: vm.projectId
                }).$promise
                    .then(function (data) {
                        vm.triggerList = data;
                    })
                    .catch(function (reason) {
                        console.log('Error triggerList:' + JSON.stringify(reason));
                    });
            };

            /**
             * Save trigger
             * @param {object} trigger
             * @return {undefined}
             */
            vm.save = function (trigger) {
                var _trigger = angular.copy(trigger);
                // Clean up special HTML chars from variable editor component
                _trigger.message = vm.cleanupHtmlEntries(_trigger.message);
                _trigger.messageResolved = vm.isMessageResolvedVisible ? vm.cleanupHtmlEntries(_trigger.messageResolved) : '';
                _trigger.subject = vm.cleanupHtmlEntries(_trigger.subject);
                _trigger.eventRules = vm.cleanupEmptyValues(_trigger.eventRules);
                // Check if there is no actions specified and `showOnDashboard` is false, then set showOnDashboard=true
                _trigger.showOnDashboard = !trigger.actions || trigger.actions && trigger.actions.length === 0 ? true : trigger.showOnDashboard;

                Service.api.trigger({
                    projectId: vm.projectId
                }, _trigger).$promise
                    .then(function (data) {
                        vm.trigger.id = data.id;
                        vm.trigger.showOnDashboard = data.showOnDashboard;
                        Commons.toastShow('Trigger saved');
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Save trigger failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error save trigger:' + JSON.stringify(reason));
                    });
            };

            /**
             * Get a variables list from an API convert and them to an Array
             * for pass to the editor.
             * @param {string} type - event source type:
             *
             * @returns {void}
             */
            vm.prepareVariables = function (type) {
                vm.variables = [];
                vm.isVariablesLoading = true;
                Service.api.triggerVariablesList({
                    sourceType: type
                }).$promise
                    .then(function (data) {
                        var _data = angular.fromJson(angular.toJson(data));
                        var _variables = Object.keys(_data).map(function (key) {
                            return {
                                name: key,
                                description: _data[key]
                            };
                        });
                        vm.variables = angular.copy(_variables);
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Get variables list failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error variablesList:' + JSON.stringify(reason));
                    })
                    .finally(function () {
                        vm.isVariablesLoading = false;
                    });
            };

            /**
             * Decode html codes into html representation
             * @param {string} str - input string
             * @returns {string} - result
             */
            vm.cleanupHtmlEntries = function (str) {
                return str
                    .replace(/&amp;/g, '&')
                    .replace(/&gt;/g, '>')
                    .replace(/&lt;/g, '<')
                    .replace(/&quot;/g, '"');
            };

            /**
             * Clean event rules:  'ALL' => null.
             * This action is opposite for triggerEventRules.js => replaceEmpty
             * @param {Array} rules - array of rules 
             * @returns {Array} - rules array
             */
            vm.cleanupEmptyValues = function (rules) {
                if (!angular.isArray(rules)) {
                    return [];
                }
                rules = rules.map(function (rule) {
                    rule.severity = rule.severity === 'ALL' ? null : rule.severity;
                    rule.component = rule.component === 'ALL' ? null : rule.component;
                    rule.eventId = rule.eventId === 'ALL' ? null : rule.eventId;
                    return rule;
                });
                return rules;
            };

            /**
             * Check if field allowed to change
             * @param {Object} trigger - trigger object 
             * @returns {boolean} - allow edit flag
             */
            vm.isEditable = function () {
                return vm.trigger && vm.trigger.scopeType === 'USER';
            };

            /**
             * Handle change scope type
             * @param {string} type - scope type
             * @returns {void}
             */
            vm.changeScope = function (type) {
                if (type === 'EDGE_ALL' || type === 'INSTANCE') {
                    vm.trigger.deviceId = null;
                }
            };

            /**
             * Change trigger source type
             * @param {Event} event - mouse click event
             * @param {string} type - new source type
             * @returns {void}
             */
            vm.changeSourceType = function (event, type) {
                // Do no ask if rules was not set yet
                if (vm.trigger.simpleRules.length === 0 &&
                    vm.trigger.eventRules.length === 0 &&
                    vm.trigger.metricRules.length === 0 &&
                    !vm.trigger.subject &&
                    !vm.trigger.message &&
                    !vm.trigger.messageResolved
                ) {
                    vm.prepareVariables(type);
                    return;
                }

                var changeTypeFunction = function () {
                    vm.prepareVariables(type);
                    vm.trigger.simpleRules = [];
                    vm.trigger.eventRules = [];
                    vm.trigger.metricRules = [];
                    vm.trigger.subject = '';
                    vm.trigger.message = '';
                    vm.trigger.messageResolved = '';
                };

                var rejectFunction = function () {
                    vm.trigger.sourceType = type === 'EVENTS' ? 'METRICS' : 'EVENTS';
                };

                Commons.showConfirmation(
                    gettextCatalog.getString('Change Source Type'),
                    gettextCatalog.getString('Are you sure you want change the source type?<br>' +
                        'Rules, subject, message and resolve message from the previous source will be deleted'),
                    gettextCatalog.getString('Change'),
                    changeTypeFunction,
                    gettextCatalog.getString('Cancel'),
                    rejectFunction,
                    event);
            };

            /**
             * Check if trigger name already in list
             * @param {Object} trigger - action name
             * @returns {void}
             */
            vm.validateTriggerName = function (trigger) {
                var isNameExist = vm.triggerList
                    .filter(function (item) {
                        return (!trigger.id && trigger.name === item.name) ||
                            (!!trigger.id && trigger.id !== item.id && trigger.name === item.name);
                    }).length > 0;

                vm.triggerForm.name.$setValidity('triggerExists', !isNameExist);
            };

            /**
             * Handle metrics rule change to change subject and message
             */
            vm.metricsRuleChanged = function (item) {
                if (!item) {
                    return;
                }

                var changeFunction = function () {
                    vm.trigger.subject = item.summary;
                    vm.trigger.message = item.description;
                    vm.trigger.messageResolved = vm.isMessageResolvedVisible ? item.descriptionResolved : '';
                };

                // If subject and message were empty do not ask confirmation
                if (!vm.trigger.subject && !vm.trigger.message && !vm.trigger.messageResolved || 
                    vm.trigger.subject === item.summary && vm.trigger.message === item.description && (!vm.isMessageResolvedVisible || vm.trigger.messageResolved === item.descriptionResolved)
                ) {
                    changeFunction();
                    return;
                }

                // Ask if user wants to change subject and message to the default value
                Commons.showConfirmation(
                    gettextCatalog.getString('Confirmation'),
                    gettextCatalog.getString('The alert template has been changed.<br>Do you want to change trigger\'s ' +
                        '<strong>Subject</strong>, <strong>Message</strong> and <strong>Resolution Message</strong> to the default values?'),
                    gettextCatalog.getString('Change'),
                    changeFunction,
                    gettextCatalog.getString('No'),
                    null,
                    event);
            };

            /**
             * Handle metrics rule change to change subject and message for Metric based triggers
             * @returns {void}
             */
            vm.toggleMessageResolved = function () {
                if (!vm.isMessageResolvedVisible) {
                    vm.trigger.messageResolved = '';
                    return;
                }
                if (vm.trigger.metricRules && vm.trigger.metricRules.length > 0) {
                    var ruleCode = vm.trigger.metricRules[0].templateCode;
                    vm.trigger.messageResolved = vm.metricsRules[ruleCode] ? vm.metricsRules[ruleCode].descriptionResolved : '';
                }
            };

            /**
             * Get a set of metrics rules. Key is a rule code, value is a rule object
             * @param {Object} rules - metrics rules set
             */
            vm.getMetricsRules = function (rules) {
                vm.metricsRules = rules || {};
            };

            /**
             * Close details page. Open config list page
             * @returns {void}
             */
            vm.close = function () {
                $state.go('alerts', {
                    companyName: vm.companyName,
                    projectId: vm.projectId,
                    selectedTab: 'triggers'
                });
            };
        }
    });
'use strict';
/**
 * @ngdoc 
 * @name loopUiApp.component:triggerMetricsRules
 * @description
 * # triggerMetricsRules
 */
angular.module('loopUiApp')
    .component('triggerMetricsRules', {
        bindings: {
            formInstance: '=',
            trigger: '<',
            triggerScope: '<',
            onChange: '&',
            onRulesLoaded: '&'
        },
        templateUrl: '../scripts/components/alert/trigger/triggerMetricsRules.html',
        controller: function ($timeout, Service, Commons) {
            var vm = this;

            vm.selectedRule = [];
            vm.ruleSearchText = [];
            vm.firstInit = true;

            vm.newDataRule = {
                templateCode: null,
                targetValue: null
            };

            // List of alert templates
            vm.ruleSet = [];
            vm.ruleSetEdge = [];
            vm.ruleSetInstance = [];
            // Map of alert templates
            vm.ruleObject = {};

            vm.$onInit = function () {
                // Load templates
                vm.getAlertTemplates();
            };

            vm.$onChanges = function (changes) {
                if (vm.isTriggerScopeChanged(changes.triggerScope)) {
                    vm.trigger.metricRules = [];
                    vm.metricRules = [];
                    vm.selectedRule = [];
                    vm.ruleSearchText = [];
                }
            };

            /**
             * Load alert templates for data triggers
             * @return {void}
             */
            vm.getAlertTemplates = function () {
                Service.api.alertTemplateList().$promise
                    .then(function (data) {
                        vm.ruleSet = data;

                        // Split templates by group
                        vm.ruleSetEdge = vm.ruleSet.filter(function (rule) {
                            return rule.group !== 'Instance';
                        });
                        vm.ruleSetInstance = vm.ruleSet.filter(function (rule) {
                            return rule.group === 'Instance';
                        });

                        // Prepare map of templates
                        vm.ruleObject = vm.ruleSet.reduce(function (obj, item) {
                            item.values = item.attributes.filter(function (attr) {
                                return attr.type === 'VALUE';
                            });
                            obj[item.code] = item;
                            return obj;
                        }, {});

                        vm.onRulesLoaded({ rules: vm.ruleObject });

                        if (vm.trigger.metricRules && vm.trigger.metricRules[0] && vm.ruleObject[vm.trigger.metricRules[0].templateCode]) {
                            vm.selectedRule[0] = vm.ruleObject[vm.trigger.metricRules[0].templateCode];
                        }

                        $timeout(function () {
                            vm.firstInit = false;
                        }, 500);
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Get alert templates failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error activationConfigList:' + JSON.stringify(reason));
                    });
            };

            /**
             * Add new condition in rule list
             * @return {void}
             */
            vm.addCondition = function () {
                var _newRule = angular.copy(vm.newDataRule);
                vm.trigger.metricRules.push(_newRule);
            };

            /**
             * Remove rule step
             * @param {int} ruleIndex index in rule array
             * @return {void}
             */
            vm.removeRule = function (ruleIndex) {
                vm.trigger.metricRules.splice(ruleIndex, 1);
                if (vm.selectedRule[ruleIndex]) {
                    vm.selectedRule.splice(ruleIndex, 1);
                    vm.ruleSearchText.splice(ruleIndex, 1);
                }
            };

            /**
             * Function for search in rule list
             * @param {String} query - search query 
             * @returns 
             */
            vm.querySearch = function (query) {
                var _ruleSet = vm.triggerScope === 'INSTANCE' ? vm.ruleSetInstance : vm.ruleSetEdge;
                return query ? _ruleSet.filter(vm.createFilterFor(query)) : _ruleSet;
            };

            /**
             * Create filter function for a query string
             */
            vm.createFilterFor = function (query) {
                return function filterFn(item) {
                    return (item.name.toLowerCase().indexOf(query.toLowerCase()) >= 0);
                };
            };

            /**
             * Handle function selection 
             * @param {Object} item - selected function
             * @returns {void}
             */
            vm.selectedItemChange = function (item, index) {
                vm.selectedRule[index] = item || null;
                vm.trigger.metricRules[index].templateCode = item ? item.code : null;
                if (!item) {
                    vm.trigger.metricRules[index].targetValue = null;
                }
                if (!vm.firstInit) {
                    vm.onChange({ item: item });
                }
            };

            /**
             * Check if rule item is filled
             * @param {Object} item - rule item 
             * @returns {boolean}
             */
            vm.isRuleReady = function (item) {
                return item.templateCode !== null;
            };

            /**
             * Show rules summary
             * @param {Array} rules - check if any of rules are filled 
             * @returns 
             */
            vm.isRuleSetReady = function (rules) {
                if (!rules) {
                    return false;
                }
                return rules.some(vm.isRuleReady);
            };

            /**
             * Check:
             * 1. if trigger scope has changed
             * 2. if previous and current value are not null and different
             * 3. if previous or current is 'INSTANCE'
             * In this case we need to reset selectedRule and ruleSearchText
             * @param {SimpleChange} changedObject - trigger scope change object
             * @returns 
             */
            vm.isTriggerScopeChanged = function (changedObject) {
                return !changedObject.isFirstChange() && changedObject && changedObject.currentValue && changedObject.previousValue &&
                    changedObject.currentValue !== changedObject.previousValue &&
                    (changedObject.currentValue === 'INSTANCE' || changedObject.previousValue === 'INSTANCE');
            };

            /**
             * Generate rule summary
             * @param {Object} item - rule object
             * @returns 
             */
            vm.getRuleSummary = function (item) {
                if (!vm.ruleObject[item.templateCode] || !vm.ruleObject[item.templateCode].summary) {
                    return '';
                }
                return vm.ruleObject[item.templateCode].summary
                    .replace('$targetValue', '<span class="rule-item">' + (item.targetValue || 'Target Value') + '</span>')
                    .replace('$alertDelay', '<span class="rule-item">' + (vm.trigger.alertDelay || 'Alert Delay') + '</span>');
            };
        }
    });
'use strict';
/**
 * @ngdoc 
 * @name loopUiApp.component:triggerEventRules
 * @description
 * # triggerEventRules
 */
angular.module('loopUiApp')
    .component('triggerEventRules', {
        bindings: {
            formInstance: '<',
            trigger: '<',
        },
        templateUrl: '../scripts/components/alert/trigger/triggerEventRules.html',
        controller: function (Service) {
            var vm = this;
            // Event components list
            vm.componentList = [];
            // Events registry
            vm.eventsRegistry = {};
            // Attr object
            vm.attrs = {};

            vm.$onInit = function () {
                vm.checkRuleValidity();
                // Attributes visible flag
                vm.attributesVisible = {};

                // Change empty values to 'ALL'
                vm.replaceEmpty(vm.trigger);

                // Severity list
                vm.severityList = [
                    { code: 'ALL', name: 'All' },
                    { code: 'INFO', name: 'Info' },
                    { code: 'WARN', name: 'Warning' },
                    { code: 'ALERT', name: 'Alert' }
                ];

                // Severity Icon map
                vm.severityIcon = {
                    INFO: 'error_outline',
                    WARN: 'warning',
                    ALERT: 'notification_important',
                    ERROR: 'notification_important',
                    UNKNOWN: 'help_outline',
                };

                // New event rule
                vm.newEventRule = {
                    attrs: {},
                    component: 'ALL',
                    eventId: 'ALL',
                    msg: null,
                    operator: 'OR',
                    severity: 'ALL'
                };

                vm.refreshEventRegistry();
            };

            vm.$onDestroy = function () {
                vm.checkRuleValidity();
            };

            /**
             * Add new condition in rule list
             * @return {undefined}
             */
            vm.addCondition = function () {
                var _newRule = angular.copy(vm.newEventRule);
                vm.trigger.eventRules.push(_newRule);
                vm.checkRuleValidity();
            };

            /**
             * Remove rule
             * @param {int} ruleIndex index in rule array
             * @return {undefined}
             */
            vm.removeRule = function (ruleIndex) {
                vm.trigger.eventRules.splice(ruleIndex, 1);
                vm.checkRuleValidity();
            };

            /**
             * Load component list
             * @returns {void}
             */
            vm.refreshEventRegistry = function () {
                Service.api.eventRegistry().$promise
                    .then(function (data) {
                        vm.eventsRegistry = data;
                    })
                    .catch(function (reason) {
                        console.log('Error eventRegistry:' + JSON.stringify(reason));
                    });
            };

            /**
             * Show/hide event attributes
             * @return {void}
             */
            vm.toggleAttributes = function (index) {
                vm.attributesVisible[index] = !vm.attributesVisible[index];
            };

            /**
             * Transform code first symbol to uppercase
             * @param {string} code - attribute code 
             * @returns {string} - new code
             */
            vm.getAttributeName = function (code) {
                if (!code) {
                    return '';
                }
                return code[0].toUpperCase() + code.substr(1).toLowerCase();
            };

            /**
             * Check Event rules validity. Do not allow empty evants rules
             * @return {void}
             */
            vm.checkRuleValidity = function () {
                if (!vm.formInstance.name) {
                    return;
                }
                if (vm.trigger.eventRules.some(function (rule) {
                    return (!rule.component || rule.component === 'ALL') &&
                        (!rule.severity || rule.severity === 'ALL') &&
                        !rule.msg;
                })) {
                    vm.formInstance.name.$setValidity('eventRuleEmpty', false);
                    return;
                }
                vm.formInstance.name.$setValidity('eventRuleEmpty', true);
            };


            /**
             * Replace events trigger rules empty values to 'ALL'
             * @param {Object} trigger - trigger object
             * @return {object} - enriched trigger 
             */
            vm.replaceEmpty = function (trigger) {
                trigger.eventRules = trigger.eventRules.map(function (rule) {
                    rule.severity = rule.severity || 'ALL';
                    rule.component = rule.component || 'ALL';
                    rule.eventId = rule.eventId || 'ALL';
                    return rule;
                });
                return trigger;
            };
        }
    });
'use strict';
/**
 * @ngdoc 
 * @name loopUiApp.component:actionList
 * @description
 * # actionList
 */
angular.module('loopUiApp')
    .component('actionList', {
        templateUrl: '../scripts/components/alert/notification/actionList.html',
        controller: function ($scope, $mdDialog, $stateParams, gettextCatalog, Service, Commons) {
            var vm = this;
            vm.actionList = [];
            vm.triggerList = [];
            vm.actionListLoading = false;
            vm.searchString = '';

            vm.$onInit = function () {
                //Current company and project
                vm.companyName = $stateParams.companyName;
                vm.projectId = $stateParams.projectId;

                vm.actionPagination = {
                    limitOptions: [10, 50, 100],
                    limit: 10,
                    page: 1
                };

                vm.filterActions = [
                    {
                        label: 'Add a new action',
                        icon: 'add',
                        buttonClick: vm.showActionDialog
                    }, {
                        label: 'Refresh',
                        icon: 'refresh',
                        buttonClick: vm.refreshActionList
                    }];

                vm.refreshTriggerList();
                vm.refreshActionList();
            };

            /**
             * Refresh trigger list
             */
            vm.refreshTriggerList = function () {
                vm.triggerListLoading = true;
                vm.triggerListPromise = Service.api.triggerList({
                    projectId: vm.projectId
                }).$promise;
                vm.triggerListPromise
                    .then(function (data) {
                        vm.triggerList = data;
                    })
                    .catch(function (reason) {
                        console.log('Error triggerList:' + JSON.stringify(reason));
                    })
                    .finally(function () {
                        vm.triggerListLoading = false;
                    });
            };

            /**
             * Refresh action list
             * 
             */
            vm.refreshActionList = function () {
                vm.actionListLoading = true;
                vm.actionListPromise = Service.api.projectActionList({
                    projectId: vm.projectId
                }).$promise;
                vm.actionListPromise
                    .then(function (data) {
                        vm.actionListOrig = data;
                        vm.actionList = angular.copy(vm.actionListOrig);
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Get action list failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error actionList:' + JSON.stringify(reason));
                    })
                    .finally(function () {
                        vm.actionListLoading = false;
                    });
            };

            /**
             * Remove an action
             * 
             * @param {Object} action 
             */
            vm.deleteAction = function (event, action) {
                if (vm.checkActionInUse(action.id)) {
                    Commons.toastShow(gettextCatalog.getString('Action "' + action.name + '" is used in the trigger'));
                    return;
                }
                Commons.showConfirmationWarn(
                    gettextCatalog.getString('Remove Action'),
                    gettextCatalog.getString('Are you sure you want to remove?<br>Removed action cannot be restored'),
                    gettextCatalog.getString('Remove'),
                    function () {
                        Service.api.projectRemoveAction({
                            projectId: vm.projectId,
                            templateId: action.id
                        }).$promise
                            .then(function () {
                                Commons.toastShow(gettextCatalog.getString('Action "' + action.name + '" removed'));
                                vm.refreshActionList();
                            })
                            .catch(function (reason) {
                                var messageObject = Commons.createErrorObject(reason, 'Fail to remove action');
                                Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                                console.log('Error actionList:' + JSON.stringify(reason));
                            });
                    },
                    gettextCatalog.getString('Cancel'), undefined, event);
            };

            /**
             * Check action is in use before delete
             * @param {String} actionId - action id
             * @returns {Boolean} - is action used in any trigger
             */
            vm.checkActionInUse = function (actionId) {
                return vm.triggerList.some(function (trigger) {
                    return angular.isArray(trigger.actions) && trigger.actions.indexOf(actionId) >= 0;
                });
            };

            /**
             * Display action dialog
             * 
             * @param {Event} env 
             * @param {Object} action 
             */
            vm.showActionDialog = function (env, action) {
                // Create an isolated scope to pass to the component 
                var scope = angular.extend($scope.$new(true), {
                    action: angular.copy(action),
                    actionList: vm.actionList
                });

                $mdDialog.show({
                    template:
                        '<md-dialog flex="60" flex-xs="100" flex-sm="100">' +
                        '<action-dialog layout="column" passed-action="action" action-list="actionList" aria-label="Action Settings"></action-dialog>' +
                        '</md-dialog>',
                    parent: angular.element(document.body),
                    targetEvent: env,
                    clickOutsideToClose: false,
                    preserveScope: true,
                    scope: scope,
                    skipHide: true,
                })
                    .then(function () {
                        vm.refreshActionList();
                    });
            };

            /**
             * On filter handler
             * @param {String} predicate - search string
             * @return {void}
             */
            vm.filterHandler = function (predicate) {
                vm.searchString = predicate;
                vm.actionList = vm.actionListOrig.filter(vm.filterFn);
            };

            /**
             * Filter function for the trigger list
             * @param {Object} item - trigger object
             * @returns 
             */
            vm.filterFn = function (item) {
                if (vm.searchString === '') {
                    return true;
                }
                return (item.name + item.type).toUpperCase().indexOf(vm.searchString.toUpperCase()) >= 0;
            };

            /**
             * Is data available after load
             * @return {boolean} - data exists flag
             */
            vm.showNoData = function () {
                return !vm.actionList || vm.actionList.length === 0 &&
                    !(vm.actionListPromise && vm.actionListPromise.$$state && vm.actionListPromise.$$state.status === 0);
            };
        }
    });

'use strict';

/**
 * @ngdoc component
 * @name loopUiApp.component:actionDialog
 * @description
 * # actionDialog
 */

angular
    .module('loopUiApp')
    .component('actionDialog', {
        templateUrl: '../scripts/components/alert/notification/actionDialog.html',
        bindings: {
            passedAction: '<',
            actionList: '<'
        },
        controller: ['$mdDialog', '$mdToast', '$stateParams', 'Service', 'Commons', 'gettextCatalog', function ($mdDialog, $mdToast, $stateParams, Service, Commons, gettextCatalog) {
            var ctrl = this;
            ctrl.projectId = $stateParams.projectId;
            ctrl.isNew = true;

            // Action templates types
            ctrl.actionTemplateTypes = [
                'EMAIL',
                'SLACK',
                'WEBHOOK',
                'PAGERDUTY'
            ];

            ctrl.$onInit = function () {
                ctrl.isNew = ctrl.passedAction === undefined;
                ctrl.action = ctrl.passedAction || { type: 'EMAIL', limit: { maxActionsPerInterval: null, updateIntervalSeconds: null } };
            };

            /**
             * Perform an API call to add action
             * 
             */
            ctrl.addAction = function () {
                var _action = angular.copy(ctrl.action);
                _action.limit = _action.limit && _action.limit.maxActionsPerInterval ? _action.limit : null;
                Service.api.projectAddAction({
                    projectId: ctrl.projectId
                }, _action)
                    .$promise
                    .then(function () {
                        Commons.toastShow('Action saved');
                        ctrl.hide();
                    })
                    .catch(function (reason) {
                        console.log('Add action failure:' + JSON.stringify(reason));
                        var _actionName = ctrl.action.id ? 'Update' : 'Add';
                        var messageObject = Commons.createErrorObject(reason, _actionName + ' action failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                    });
            };

            /**
             * Check if action name already in list
             * @param {Object} action - action object
             * @returns {void}
             */
            ctrl.validateActionName = function (action) {
                var isNameExist = ctrl.actionList
                    .filter(function (item) {
                        return (!action.id && action.name === item.name) ||
                            (!!action.id && action.name === item.name && action.id !== item.id);
                    }).length > 0;

                ctrl.actionForm.nameField.$setValidity('actionExists', !isNameExist);
            };

            /**
             * Clean the model if type was changed
             * 
             */
            ctrl.cleanModel = function () {
                ctrl.action = {
                    type: ctrl.action.type
                };
            };

            /**
             * Execute test action. 
             * Implemented for Webhooks for now
             * @param {Object} action - action object 
             */
            ctrl.testAction = function (action) {
                Service.api.projectTestAction({}, action).$promise
                    .then(function (data) {
                        ctrl.testActionDetails(data);
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Webhook test failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error actionList:' + JSON.stringify(reason));
                    });
            };

            /**
             * Show test details
             * @param {Object} response - test action response
             */
            ctrl.testActionDetails = function (response) {
                return $mdToast.show({
                    hideDelay: 5000,
                    position: 'bottom right',
                    bindToController: true,
                    templateUrl: '../scripts/components/common/detailsToast/detailsToast.html',
                    locals: {
                        message: 'Webhook test completed successfully',
                        code: 'S'
                    },
                    controllerAs: '$ctrl',
                    controller: ['$mdToast', function ($mdToast) {
                        var vm = this;
                        vm.MESSAGE_LIMIT = 150;

                        vm.closeToast = function () {
                            $mdToast.hide();
                        };

                        // Show details for Webhook test
                        vm.openDetails = function () {
                            $mdToast.hide();

                            var _request = '';
                            try {
                                _request = JSON.stringify(response.request, null, '\t');  
                            } catch (e) {
                                _request = response.request;
                            }

                            Commons.showConfirmation(
                                gettextCatalog.getString('Test Details'),
                                gettextCatalog.getString(
                                    '<div class="overflow-hidden">' +
                                    '<strong>Request Body:</strong><br><pre class="md-caption">' + _request + '</pre>' +
                                    '<strong>Response Body:</strong><br><pre class="md-caption">' + Commons.stripHtmlTags(response.response) + '</pre>' +
                                    '</div>'
                                ),
                                gettextCatalog.getString('Close'),
                                null,
                                null,
                                null,
                                null);
                        };
                    }]
                });
            };

            /**
             * Hides the dialog
             * 
             */
            ctrl.hide = function () {
                $mdDialog.hide();
            };

            /**
             * Cancel dialog button
             * @return {undefined}
             */
            ctrl.cancel = function () {
                $mdDialog.cancel();
            };
        }]
    });

'use strict';

/**
 * @ngdoc component
 * @name loopUiApp.component:emailActionTemplate
 * @description
 * # emailActionTemplate
 */

angular
    .module('loopUiApp')
    .component('emailActionTemplate', {
        templateUrl: '../scripts/components/alert/notification/emailActionTemplate.html',
        bindings: {
            action: '<',
            actionForm: '<'
        },
        controller: [function () {
            var ctrl = this;
            ctrl.readonly = false;
            
            /**
             * Component initialization
             * 
             */
            ctrl.$onInit = function () {
                ctrl.action.recipients = ctrl.action.recipients || [];
                ctrl.performArrayValidation();
            };
            
            /**
             * Validates an email address
             * 
             * @param {string} email 
             * @returns 
             */
            ctrl.validateEmail = function (email) {
                var isEmailValid = false;
                // Src https://emailregex.com/
                var reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                if (reg.test(email)) {
                    isEmailValid = true;
                } else {
                    isEmailValid = false;
                }
                return isEmailValid;
            };
          
            /**
             * Performs overall validation for action
             * @returns {void}
             */
            ctrl.performArrayValidation = function () {
                var hasInvalidEmail = false;
                ctrl.action.recipients.forEach(function (recipient) {
                    hasInvalidEmail = hasInvalidEmail || !ctrl.validateEmail(recipient);
                });
                if (ctrl.actionForm.emailField) {
                    ctrl.actionForm.emailField.$setValidity('emailInvalid', !hasInvalidEmail);
                    ctrl.actionForm.emailField.$setValidity('emailEmpty', ctrl.action.recipients.length !== 0);
                }

            };

        }]
    });

'use strict';

/**
 * @ngdoc component
 * @name loopUiApp.component:slackActionTemplate
 * @description
 * # slackActionTemplate
 */

angular
    .module('loopUiApp')
    .component('slackActionTemplate', {
        templateUrl: '../scripts/components/alert/notification/slackActionTemplate.html',
        bindings: {
            action: '=',
            actionForm: '<',
        },
        controller: function () {
        }
    });

'use strict';

/**
 * @ngdoc component
 * @name loopUiApp.component:webhookActionTemplate
 * @description
 * # webhookActionTemplate
 */

angular
    .module('loopUiApp')
    .component('webhookActionTemplate', {
        templateUrl: '../scripts/components/alert/notification/webhookActionTemplate.html',
        bindings: {
            action: '=',
            actionForm: '<',
        },
        controller: function () {
            var vm = this;

            /**
             * Component initialization
             */
            vm.$onInit = function () {
                vm.httpMethods = ['GET', 'POST', 'PUT'];

                vm.action.verifySsl = vm.action.verifySsl === undefined ? true : vm.action.verifySsl;
                vm.action.method = vm.action.method || vm.httpMethods[1];
                vm.action.headers = vm.action.headers || [{ key: 'Content-Type', value: 'application/json' }];
            };

            /**
             * Remove header from the headers array
             * @param {number} index - index of the header to remove
             */
            vm.removeHeader = function (index) {
                vm.action.headers.splice(index, 1);
            };

            /**
             * Add new empty header to the headers array
             */
            vm.addHeader = function () {
                vm.action.headers.push({ key: '', value: '' });
            };

            /**
             * Check if header is editable: do not allow to edit Content-Type header with application/json value
             * @param {object} header - header object
             * @returns {boolean} - true if header is editable
             */
            vm.isHeaderEditable = function (header) {
                return header.key.toLowerCase() !== 'content-type' && header.value.toLowerCase() !== 'application/json';
            };
        }
    });

'use strict';

/**
 * @ngdoc component
 * @name loopUiApp.component:pagerActionTemplate
 * @description
 * # pagerActionTemplate
 */

angular
    .module('loopUiApp')
    .component('pagerActionTemplate', {
        templateUrl: '../scripts/components/alert/notification/pagerActionTemplate.html',
        bindings: {
            action: '=',
            actionForm: '<',
        },
        controller: function () { }
    });

'use strict';
/**
 * @ngdoc component
 * @name loopUiApp.component:actionLimiter
 * @description
 * # authDailog
 */
angular.module('loopUiApp')
    .component('actionLimiter', {
        templateUrl: '../scripts/components/alert/notification/actionLimiter.html',
        bindings: {
            action: '<',
            actionForm: '<'
        },
        controller: function () {
            var vm = this;

            vm.$onInit = function () {
                // Intervals with seconds
                vm.intervalMap = {
                    60: 'minute',
                    3600: 'hour', // 60 * 60
                    86400: 'day', // 24 * 60 * 60
                    604800: 'week', // 7 * 24 * 60 * 60
                    2592000: 'month', // 30 * 24 * 60 * 6
                };

                vm.action.limit = vm.action.limit || { maxActionsPerInterval: null, updateIntervalSeconds: null };
                vm.action.limit.updateIntervalSeconds = vm.action.limit.updateIntervalSeconds || 3600;

            };
        }
    });
'use strict';

/**
 * @ngdoc component
 * @name loopUiApp.component:incidentList
 * @description
 * # incidentList
 */

angular
    .module('loopUiApp')
    .component('incidentList', {
        templateUrl: '../scripts/components/alert/incidents/incidentList.html',
        controller: function ($state, $stateParams, gettextCatalog, Service, Commons) {
            var vm = this;
            vm.query = {};

            /**
             * Component initialization
             *
             */
            vm.$onInit = function () {
                vm.cm = Commons;
                vm.companyName = $stateParams.companyName;
                vm.projectId = $stateParams.projectId;

                vm.incidentList = [];
                vm.triggerMap = {};
                vm.filterActive = true;
                vm.deviceTaglist = [];
                vm.incidentPagination = {
                    limitOptions: [10, 50, 100],
                    totalSize: 0,
                    pageNum: 1,
                    pagesCount: 0,
                    boundaryLinks: true,
                    size: 0,
                    limit: 10
                };
                vm.maxDate = new Date();
                vm.states = [
                    'OPEN',
                    'CLOSE'
                ];
                vm.initFilter();
                // Trigger message limit length
                vm.triggerMessageLimit = 256;
                // Selected index to show all message
                vm.selectedAllIndex = [];
                vm.refreshTriggerList();
                vm.refreshIncidentList();
                vm.getDeviceTagList();

            };

            /**
             * Refresh all data
             */
            vm.refresh = function() {
                vm.refreshTriggerList();
                vm.refreshIncidentList();
            };

            /**
             * Fetch data from API
             *
             */
            vm.refreshIncidentList = function () {
                vm.refreshPromise = Service.api.incidentList({
                    projectId: vm.projectId,
                    limit: vm.incidentPagination.limit,
                    requestedPage: vm.incidentPagination.pageNum - 1,
                    tag: vm.query.tag,
                    state: vm.query.state,
                    openedBefore: vm.convertDate(vm.query.openedBefore),
                    openedAfter: vm.convertDate(vm.query.openedAfter),
                    closedBefore: vm.convertDate(vm.query.closedBefore),
                    closedAfter: vm.convertDate(vm.query.closedAfter)
                }).$promise;
                vm.refreshPromise
                    .then(function (data) {
                        vm.incidentPagination.totalSize = data.totalSize;
                        vm.incidentPagination.size = data.size;
                        vm.incidentPagination.pagesCount = data.pagesCount;
                        vm.incidentList = data.elements;
                        vm.selectedAllIndex = [];
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Get incident list failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error incidentList:' + JSON.stringify(reason));
                    });
            };

            /**
             * Resolve incident
             * @param {Object} incident incident object
             * @return {undefined}
             */
            vm.incidentResolve = function (incident) {
                var incidentObject = {
                    incidentId: incident.id,
                    startedAt: incident.startedAt,
                    triggerId: incident.triggerId
                };
                Service.api.incidentResolve({
                    projectId: vm.projectId
                }, incidentObject).$promise
                    .then(function () {
                        Commons.toastShow(gettextCatalog.getString('Incident resolved'));
                        vm.refreshIncidentList();
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Incident Resolve failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error incidentResolve:' + JSON.stringify(reason));
                    });
            };

            /**
             * Convert date into timestamp
             *
             * @param {date} date
             * @returns {number}
             */
            vm.convertDate = function (date) {
                if (date) {
                    date = date.getTime();
                }
                return date;
            };

            /**
             * Refresh trigger list
             */
            vm.refreshTriggerList = function () {
                Service.api.triggerList({
                    projectId: vm.projectId
                }).$promise
                    .then(function (data) {
                        vm.triggerMap = data.reduce(function (acc, item) {
                            acc[item.id] = item;
                            return acc;
                        }, {});
                    })
                    .catch(function (reason) {
                        console.log('Error triggerList:' + JSON.stringify(reason));
                    });
            };

            /**
             * Get device tag list
             * @return {undefined}
             */
            vm.getDeviceTagList = function () {
                Service.api.deviceTagList({
                    projectId: vm.projectId
                }).$promise
                    .then(function (data) {
                        vm.deviceTaglist = data;
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Get device list failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error deviceTagList:' + JSON.stringify(reason));
                    });
            };

            /**
             * Open device details view
             * @param {String} detailId device identificator
             */
            vm.openDeviceDetail = function (deviceId) {
                $state.go('deviceView', {
                    companyName: vm.companyName,
                    projectId: vm.projectId,
                    deviceId: deviceId,
                    selectedType: 'ALL'
                });
            };

            /**
            * Show trigger edit dialog
            * @param {event} env object
            * @param {Object} trigger object
            * @return {undefined} 
            */
            vm.showTriggerDialog = function (env, triggerId) {
                $state.go('triggerDetails', {
                    companyName: vm.companyName,
                    projectId: vm.projectId,
                    triggerId: triggerId
                });
            };

            /**
             * Show all message toggler
             * @param {int} index row index
             */
            vm.toggleMessageView = function (index) {
                this.selectedAllIndex[index] = !this.selectedAllIndex[index];
            };

            /**
             * Show/hide filter elements
             * @returns {void}
             */
            vm.toggleFilter = function () {
                vm.filterActive = !vm.filterActive;
            };

            /**
             * Is data available after load
             * @return {boolean} - data exists flag
             */
            vm.showNoData = function () {
                return vm.incidentList.length === 0 &&
                    !(vm.refreshPromise && vm.refreshPromise.$$state && vm.refreshPromise.$$state.status === 0);
            };

            /**
             * Check if any of filters active
             * @returns Boolean
             */
            vm.isFilterActive = function () {
                return !!vm.query.state || !!vm.query.openedBefore || !!vm.query.openedAfter ||
                    !!vm.query.closedBefore || !!vm.query.closedAfter || !!vm.query.tag;
            };

            /**
             * Reset filter
             */
            vm.initFilter = function () {
                vm.query = {};
                // Select OPEN incident by default (#256)
                vm.query.state = vm.states[0];
            };
        }
    });

'use strict';
/**
 * @ngdoc component
 * @name loopUiApp.component:variableEditor
 * @description
 * # variableEditor
 */
angular.module('loopUiApp')
    .component('variableEditor', {
        require: {
            ngModelCtrl: 'ngModel'
        },
        bindings: {
            ngModel: '<',
            editorTitle: '<',
            isLoading: '<',
            variables: '<'
        },
        templateUrl: '../scripts/components/alert/variableEditor/variableEditor.html',
        controller: function ($window, $compile, $scope, $element) {
            var vm = this;

            /**
             * Initialization lifecycle hook.
             * Initialize editor element, perform model rendering and
             * bind remove action to the rendered variables.
             *
             * @returns {void}
             */
            vm.$onInit = function () {
                // Find editor inside current element
                vm.elm = angular.element($element[0].querySelector('#editor'));

                vm.ngModelCtrl.$render = function () {
                    if (!vm.ngModelCtrl.$viewValue) {
                        vm.elm[0].innerHTML = '';
                        return;
                    }
                    vm.ngModelCtrl.$viewValue = vm.ngModelCtrl.$viewValue
                        .replace(/>/g, '&gt;')
                        .replace(/</g, '&lt;');
                    vm.elm[0].innerHTML = '';
                    vm.elm.append(vm.scanForVariables(vm.ngModelCtrl.$viewValue));
                    vm.elm.find('span').find('span').on('click', vm.removeVariable);
                    vm.onFocus();
                };
            };

            vm.$onChanges = function (changes) {
                if (changes.variables && changes.variables.currentValue && changes.variables.currentValue.length > 0) {
                    vm.ngModelCtrl.$render();
                }
            };

            /**
             * Clean up ngModel and pass it from this component to a parent.
             *
             * @returns {void}
             */
            vm.ngModelChange = function () {
                vm.ngModelCtrl.$setViewValue(
                    vm.elm.html()
                        .replace(/<span class="variable-close" ng-click="\$ctrl\.removeVariable\(\$event\)" title="Remove variable"[ role="button"]*[ tabindex="0"]*>x<\/span>/gi, '')
                        .replace(/&nbsp;/gi, ' ')
                        .replace(/(<.+?>)/gi, ' ')
                        .replace(/\s{2}/gi, ' ')
                );
            };

            /**
             * Wrap variable name with HTML span tag.
             *
             * @param {string} variable             Variable name
             * @returns {string}                    Wrapped variable name
             */
            vm.wrapVariable = function (variable) {
                return '<span spellcheck="false" class="inline-variable" contenteditable="false">' + variable + ' <span class="variable-close" ng-click="$ctrl.removeVariable($event)" title="Remove variable">x</span></span>';
            };

            /**
             * Add variable into the editor.
             * Compile HTML template and append it to a content
             *
             * @param {string} variableName         Variable name to add into editor
             * @returns {void}
             */
            vm.addVariable = function (variableName) {
                vm.elm.focus();
                // Get the current selection (cursor position)
                var selection = $window.getSelection();
                // Check if the selection is within the editable div
                if (selection.rangeCount <= 0) {
                    return;
                }
                var range = selection.getRangeAt(0);
                range.deleteContents();

                // Ensure the insertion is not within restricted elements (e.g., spans)
                var containerElement = range.commonAncestorContainer;

                // Check if the container is a restricted element. Restricting the insertion to the variable element
                if (!vm.elm[0].contains(containerElement) || containerElement.parentNode && containerElement.parentNode.nodeName === 'SPAN') {
                    return;
                }
                // Compile the variable span with the remove button
                var compiledSpan = $compile(vm.wrapVariable(variableName))($scope);

                // Insert the text node at the current cursor position
                range.insertNode(compiledSpan[0]);

                // Move the cursor after the inserted text
                range.setStartAfter(compiledSpan[0]);
                range.setEndAfter(compiledSpan[0]);

                // Remove the current selection and apply the new one
                selection.removeAllRanges();
                selection.addRange(range);

                vm.ngModelChange();
            };

            /**
             * Scan text for variables and represent them as HTML
             *
             * TODO: Check if we really should grab spaces, maybe convert double spaces to one.
             *
             * @param {string} text                 Text to parse
             * @returns {string}                    Parsed text with wrapped variables
             */
            vm.scanForVariables = function (text) {
                if (!text) {
                    return '';
                }
                if (!vm.variables || vm.variables.length === 0) {
                    return text;
                }
                vm.variables.forEach(function (variable) {
                    text = text.replaceAll(variable.name, vm.wrapVariable(variable.name));
                });
                return text;
            };

            /**
             * Remove variable definition from DOM and replace it with space.
             * Get event target, traverse to the parent element and replace it
             *
             * @param {Event} event             Mouse click event
             * @returns {void}
             */
            vm.removeVariable = function (event) {
                angular.element(event.target).parent().replaceWith('');
                vm.ngModelChange();
            };

            /**
             * Add focus class to the parent element
             */
            vm.onFocus = function () {
                vm.elm[0].parentElement.classList.add('md-input-focused');
            };

            /**
             * Remove focus class from the parent element in case the editor is empty
             */
            vm.onBlur = function () {
                if (!vm.ngModelCtrl.$viewValue) {
                    vm.elm[0].parentElement.classList.remove('md-input-focused');
                }
            };
        }
    });


'use strict';
/**
 * @ngdoc component
 * @name loopUiApp.component:confirmDialog
 * @description
 * # confirmDialog
 */
angular.module('loopUiApp')
    .component('confirmDialog', {
        bindings: {
            title: '<',
            body: '<',
            confirmButton: '<'
        },
        templateUrl: '../scripts/components/common/confirmDialog/confirmDialog.html',
        controller: function ($mdDialog) {
            var ctrl = this;
            ctrl.hide = function () {
                $mdDialog.hide();
            };
        
            ctrl.cancel = function () {
                $mdDialog.cancel();
            };

        }
    });


'use strict';

/**
 * @name loopUiApp.component:featureUnavailable
 * @description
 * # featureUnavailable
 *
 */
angular.module('loopUiApp')
    .component('featureUnavailable', {
        templateUrl: '../scripts/components/common/featureUnavailable/featureUnavailable.html',
        bindings: {
            featureName: '<'
        },
        controller: function (appConfig, featuresCheck, Commons) {
            var vm = this;
            vm.fc = featuresCheck;

            vm.$onInit = function() {
                vm.adminUiName = appConfig.__env.adminUiName || 'Admin Console';
                vm.adminUilink = Commons.getAdminUiLink() + '/settings';                
            };
        }
    });
'use strict';

/**
 * @name loopUiApp.component:licenseUnavailable
 * @description
 * # licenseUnavailable
 *
 */
angular.module('loopUiApp')
    .component('licenseUnavailable', {
        templateUrl: '../scripts/components/common/licenseUnavailable/licenseUnavailable.html',
        bindings: {
            featureName: '<'
        },
        controller: function (appConfig, licenseCheck, Commons) {
            var vm = this;
            vm.lc = licenseCheck;

            vm.$onInit = function() {
                vm.adminUiName = appConfig.__env.adminUiName || 'Admin Console';
                vm.adminUilink = Commons.getAdminUiLink() + '/license';
            };
        }
    });
'use strict';
/**
 * @ngdoc component
 * @name loopUiApp.component:cookieNotice
 * @description
 * # authDailog
 */
angular.module('loopUiApp')
    .component('cookieNotice', {
        templateUrl: '../scripts/components/common/cookieNotice/cookieNotice.html',
        controller: function ($cookies, $location, appConfig) {
            var vm = this;
            //Num days to cookie expired
            vm.expiredDays = 365;
            //Initially cookies not allowed
            vm.isAllowedCookies = false;

            vm.$onInit = function () {
                vm.isAllowedCookies = $cookies.get('loopUi.cookieAllow') === '1';
                // If config skipCookiesNotification true - do not show cookies notification
                vm.isAllowedCookies = appConfig.__env.skipCookiesNotification || vm.isAllowedCookies;
                // URL in notifications
                vm.cookieNotificationUrl = appConfig.__env.cookieNotificationUrl;
            };

            /**
             * Get domain name for cookie. 
             * Cookie will be available only for this domain and its sub-domains.
             * @return {String} - domain name
             */
            vm.getMainDomainName = function () {
                var domainArray = $location.host().split('.');
                if (domainArray.length === 3 || domainArray.length === 2) {
                    return '.' + domainArray.slice(domainArray.length - 2, domainArray.length).join('.');
                }
                else {
                    return $location.host();
                }
            };

            /**
             * Set cookies allow flag
             * @returns {void}
             */
            vm.allowCookie = function () {
                vm.isAllowedCookies = true;
                $cookies.put('loopUi.cookieAllow', '1', {
                    domain: vm.getMainDomainName(),
                    expires: new Date(new Date().getTime() + 24 * 60 * 60 * 1000 * vm.expiredDays)
                });
            };
        }
    });
'use strict';

/**
 * @ngdoc component
 * @name loopUiApp.component:switcherComponent
 * @description
 * # switcherComponent
 *
 * Component accepts following as input:
 *
 * - `titleText`      - Title text, that will be showed on the left side
 * - `state`      - Currently selected state
 * - `states`     - Acceptable states array with following items format
 *    {
 *      icon: 'state_icon',
 *      value: 0,
 *      description: 'State's description'
 *    }
 *
 * and emits following as output:
 *
 * - `onSwitch`     - Emits currently clicked item
 *
 * The component doesn't store it state,
 * but counts on state that passed from parent component
 */
angular.module('loopUiApp')
    .component('switcherComponent', {
        templateUrl: '../scripts/components/common/switcherComponent/switcherComponent.html',
        bindings: {
            state: '<',
            onSwitch: '&',
            states: '<',
            additionalActions: '<',
            titleText: '<'
        },
        controller: function () {}
    });

'use strict';

/**
 * @ngdoc component
 * @name loopUiApp.component:switcherSubheaderComponent
 * @description
 * # switcherSubheaderComponent
 *
 * Component accepts following as input:
 *
 * - `titleText`      - Title text, that will be showed on the left side
 * - `subtitleText`   - Subtitle text, that will be showed on the left side
 * - `state`          - Currently selected state
 * - `states`         - Acceptable states array with following items format
 *    {
 *      icon: 'state_icon',
 *      value: 0,
 *      description: 'State's description'
 *    }
 *
 * and emits following as output:
 *
 * - `onSwitch`     - Emits currently clicked item
 *
 * The component doesn't store it state,
 * but counts on state that passed from parent component
 */
angular.module('loopUiApp')
    .component('switcherSubheaderComponent', {
        templateUrl: '../scripts/components/common/switcherSubheaderComponent/switcherSubheaderComponent.html',
        bindings: {
            titleText: '<',
            subtitleText: '<',
            state: '<',
            states: '<',
            additionalActions: '<',
            onSwitch: '&',
        },
        controller: function () {}
    });

'use strict';

/**
 * @ngdoc component
 * @name loopUiApp.component:filterGroup
 * @description
 * # filter group
 * 
 * Component represents generic filter group.
 *
 * Takes following as an input:
 *
 * - `entitySetting`                            - Configuration JSON object. Type: EntitySetting
 * - `itemList`                                 - List item for select. Type: Array<Item>
 * - `isDisabled`                               - Allow to disable all items. Type: Boolean
 * 
 *  and uses the following as an output:
 * - `selectedList`                             - Array of selected elements
 *
 * EntitySetting description:
 *
 * {
 *    name: String,                             - Filter name    
 *    filter: Boolean,                          - Flag show filter or not
 *    entityIcon: String                        - Material Icon name
 *    listLimit: Integer                        - Max quantity of list item to show. Default: 4
 * }
 * 
 * Item description
 * {
 *    name: String,                             - Filter element name
 *    count: Integer                            - Count on element to filter
 *    preSelected: Boolean                      - Allow to preselect filter
 *    ids: Array                                - List of item ids. May be used when same name contain many id's
 * }
 */

angular.module('loopUiApp')
    .component('filterGroup', {
        templateUrl: '../scripts/components/common/filterGroup/filterGroup.html',
        bindings: {
            entitySetting: '<',
            itemList: '<',
            selectedList: '=',
            isDisabled: '<',
            onSelect: '&'
        },
        controller: function () {
            var vm = this;
            vm.FILTER_LIST_LIMIT = 4;
            vm.FILTER_ICON = 'search';

            vm.$onInit = function () {
                vm.selectedList = vm.selectedList || [];
                vm.entitySetting = vm.entitySetting || {};
                vm.entitySetting.listLimit = vm.entitySetting.listLimit || vm.FILTER_LIST_LIMIT;
                vm.entitySetting.entityIcon = vm.entitySetting.entityIcon || vm.FILTER_ICON;
                vm.entitySetting.multipleSelection = vm.entitySetting.multipleSelection === undefined ? true : vm.entitySetting.multipleSelection;
            };

            vm.$onChanges = function (changes) {
                if (changes.itemList && changes.itemList.currentValue && vm.selectedList && vm.selectedList.length > 0) {
                    // Restore preselected items
                    vm.itemList = vm.itemList.map(function (item) {
                        item.checked = vm.selectedList.indexOf(item.name) !== -1;
                        return item;
                    });
                }
            };

            /**
             * Filter select handler
             * @param  {Number} index - element index
             * @param  {Array} list - element list
             * @return {Array} - selected element array
             */
            vm.toggleElement = function (index, list) {
                vm.selectedList =
                    angular.forEach(list, function (item, idx) {
                        if (index !== idx && !vm.entitySetting.multipleSelection) {
                            item.checked = false;
                        }
                    })
                        .filter(function (item) {
                            return item.checked === true;
                        })
                        .map(function (item) {
                            return item.id || item.name;
                        });
                if (typeof vm.onSelect === 'function') {
                    vm.onSelect({ selectedList: vm.selectedList });
                }
            };

            /**
             * Check is current limit value default
             * @return {Boolean} - is current limit value default
             */
            vm.isDefaultListLimit = function () {
                return vm.entitySetting.listLimit === vm.FILTER_LIST_LIMIT;
            };

            /**
             * Toggle showAll functions for filter items
             * @returns {void}
             */
            vm.toggleShowAll = function () {
                vm.entitySetting.listLimit =
                    vm.isDefaultListLimit() ?
                        vm.itemList.length : vm.FILTER_LIST_LIMIT;
            };
        }
    });
'use strict';

/**
 * @ngdoc component
 * @name loopUiApp.component:filterMenu
 * @description
 * 
 * Filter Object description:
 *
 * {
 *   type: 'string' | 'date'                    - Type of filter. Type: string
 *   multiple: false,                           - If the filter can have multiple values. Type: boolean
 *   name: 'Filter name',                       - Header of filter selector. Type: string
 *   selectedValue: null,                       - Selected value of the filter. Type: any
 *   defaultValue: 'Default value',             - Default value of the filter. Type: any
 *   values: [{ code: 'string', name: 'name' }  - Possible values of the filter. Type: Array
 *   visible: false,                            - Visibility of the filter. Type: boolean
 *   action: function(value) {                  - Action to perform when the filter is applied. Type: function
 * }
 */
angular.module('loopUiApp')
    .component('filterMenu', {
        templateUrl: '../scripts/components/common/filterMenu/filterMenu.html',
        bindings: {
            filterObject: '<',
        },
        controller: function ($mdDialog, $timeout) {
            var vm = this;

            vm.$onInit = function () {
                $timeout(function () {
                    vm.value = vm.filterObject.selectedValue || angular.copy(vm.filterObject.defaultValue);
                }, 0);
            };

            /**
             * Handle the change event of the filter
             * If multiple === false, allow a single item selection only
             */
            vm.changeHandle = function () {
                if (vm.filterObject.multiple === false && vm.value && vm.value.length > 1) {
                    vm.value.shift();
                }
            };

            /**
             * Handle the apply button click
             * @param {any} value - value of the filter to apply
             */
            vm.apply = function (value) {
                $mdDialog.hide({
                    use: true,
                    value: value
                });
            };

            /**
             * Handle the reset button click
             */
            vm.reset = function () {
                $mdDialog.hide({
                    use: false
                });
            };
        }
    });
'use strict';

/**
 * @ngdoc component
 * @name loopUiApp.component:genericTable
 * @description
 * # genericTable
 *
 * Component that represents generic table.
 *
 * Takes following as an input:
 *
 * - `listSetup`          - List configuration JSON object. Type: any
 * - `listPromise`        - Promise that used to determine current loading state. Type: Promise
 * - `listLoading`        - [Deprecated] Boolean to determine current loading state. Type: boolean
 * - `items`              - Items to display. Type: Array<any>
 * - `filterFunction`     - Function to filter list. Type: function
 * - `selectionDisabledFunction` - Function to calculate if row selection is disabled. Type: function
 * - `totalItems`         - Total items count. Used for server-side pagination
 * - `entityName`         - Item entity name. Type: string
 * - `randomActions`      - Additional actions for displayed item. Type: any
 * - `preselectedItems`   - Array of entities of items type which should be in selectedItems list. Type: Array<any>
 * - `emptyListMessage`     - Message will show if there are no items in table
 *
 * and uses the following as an output:
 *
 * - `onEdit`             - Event that emits when edit menu item is clicked, contained clicked item and MouseEvent
 * - `onDelete`           - Event that emits when delete menu item is clicked, contain clicked item and MouseEvent
 * - `onPaginate          - Event that emits on pagination action
 *
 * ListSetup description:
 *
 * {
 *    sortField: 'name',                        - Name of the field to sort. Type: string
 *    showIndex: true,                          - Show or not index column. Type: boolean
 *    editable: false,                          - Show or not Edit menu item in actions menu. Type: boolean
 *    removable: false,                         - Show or not Delete menu item in actions menu. Type: boolean
 *    hidePagination: false,                    - Hide or not pagination. Type: boolean
 *    limit: 10,                                - Preselected limit for paginator. Type: number
 *    limitOptions: [10, 50, 100],              - Available paginator limit options. Type Array<number>
 *    serverPagination: false,                  - Flag use or not server side pagination. Type: boolean
 *    rowSelection: true,                       - Enable row selection. Type: boolean
 *    multipleSelection: true,                  - Enable multiple row selection. Type: boolean
 *    keyName: 'entryID',                       - Name of key field. Type: string
 *    rowMouseEnter: function (item) {}         - Notify host about row mouse enter. Useful if need to highlight something based on row.
 *    rowMouseLeave: function (item) {}         - Notify host about row mouse leave. Useful if need to highlight something based on row.
 *    rowMouseClick: function (event, item) {}  - Notify host about that row was clicked. If passed - the row will have a pointer as a cursor when hovered.
 *    fields: [                                 - Fields array
 *      {
 *        name: 'Objects',                      - Field header. Type: string
 *        column: 'objects',                    - Field column name from data array. Type: string
 *        limit: 'number',                      - Maximum number of symbols in the current cell. Type: number
 *        array: true,                          - Is field array. Type: boolean
 *        image: false,                         - Is field contain image link. Type: boolean
 *        link: false,                          - Is field represents http link. Type: boolean
 *        input: 'text'                         - Input field type text | select | number
 *        iconButton: false,                    - Is field represent icon button link. Type: boolean
 *        editable: false,                      - Allow to edit field value
 *        component: '',                        - Component name which allowed for generic table 
 *        style: ''                             - Additional field component style. Format ng-style. Example: {"name": "value"}
 *        transformation: function (item) {     - Function, that receive item to perform data transformation. Type: function
 *          return item.objects.map(
 *            function (object) {
 *              return object.name;
 *            });
 *          }
 *        }
 *    ]
 * }
 *
 * Random actions description:
 *
 * {
 *    name: 'View/Edit',                        - Additional action name. Type: string
 *    icon: 'edit',                             - Additional action icon. Type: string
 *    function: function(item) {  },            - Additional action function. Type: function
 *    disabled: false                           - Should or not item displayed as disabled. Type: boolean
 *    hidden: false                             - Should the item be hid from the actions list. Type: boolean
 * }
 *
 */
angular.module('loopUiApp')
    .component('genericTable', {
        templateUrl: '../scripts/components/common/genericTable/genericTable.html',
        bindings: {
            listSetup: '<',
            listPromise: '<',
            listLoading: '<', // Deprecated and not use
            items: '<',
            filterFunction: '<',
            totalItems: '<',
            entityName: '<',
            onEdit: '&',
            onDelete: '&',
            onPaginate: '&',
            selectionChange: '&',
            randomActions: '<',
            preselectedItems: '<',
            emptyListMessage: '<'
        },
        controller: function () {
            var vm = this;

            /**
             * Component initialization
             *
             * @returns {void}
             */
            vm.$onInit = function () {
                vm.listSetup.showIndex = vm.listSetup.showIndex !== undefined ? vm.listSetup.showIndex : true;
                vm.itemsPagination = {
                    limit: vm.listSetup.limit || 5,
                    page: vm.listSetup.pageIndex || 1,
                    limitOptions: vm.listSetup.limitOptions || [5, 10, 20]
                };
                vm.selectedItems = [];
                vm.listSetup.multipleSelection = vm.listSetup.multipleSelection || false;
                vm.allowRowClick = vm.listSetup.rowMouseClick instanceof Function;
                vm.listSetup.keyName = vm.listSetup.keyName || 'entryID';
                // Calc number of columns
                vm.colNum = vm.listSetup.fields.length + (vm.listSetup.showIndex ? 1 : 0) +
                    (vm.listSetup.editable || vm.randomActions && vm.randomActions.length ? 1 : 0);
                vm.emptyListMessage = vm.emptyListMessage || 'No available ' + vm.entityName + '. ';
            };

            vm.$onChanges = function (changes) {
                if (changes.items && vm.preselectedItems && vm.selectedItems) {
                    vm.selectedItems = vm.selectedItems.concat(vm.items.filter(function (item) {
                        return vm.preselectedItems.some(function (preselectedItem) {
                            return angular.equals(item, preselectedItem);
                        });
                    }));
                    vm.invalidateSelection();
                }
                if (changes.items && vm.selectedItems && vm.selectedItems.length > 0 && !vm.preselectedItems) {
                    vm.selectedItems = [];
                }
            };

            /**
             * Used for save and restore selected values when filter is used,
             * as we use external filtering then items list will be new on each search,
             * so for selectors to work we need to restore the same objects into selectedItems array.
             *
             * @returns {void}
             */
            vm.invalidateSelection = function () {
                if (!vm.listSetup.rowSelection || !vm.selectedItems || !vm.items) {
                    return;
                }

                // TODO: Think about improvements, the list are edited twice
                vm.selectedItems = vm.selectedItems.reduce(function (accumulator, currentValue) {
                    if (!accumulator.some(function (element) { return element[vm.listSetup.keyName] === currentValue[vm.listSetup.keyName]; })) {
                        accumulator.push(currentValue);
                    }
                    return accumulator;
                }, []);

                var selectedCopy = angular.copy(vm.selectedItems);
                vm.selectedItems = [];

                selectedCopy.forEach(function (selectedItem) {
                    var itemAdded = false;
                    vm.items.forEach(function (listItem) {
                        if (listItem[vm.listSetup.keyName] === selectedItem[vm.listSetup.keyName]) {
                            vm.selectedItems.push(listItem);
                            itemAdded = true;
                        }
                    });
                    if (!itemAdded) {
                        vm.selectedItems.push(selectedItem);
                    }
                });

                vm.preselectedItems = vm.selectedItems;
            };

            /**
             *
             * @param {*} $mdOpenMenu - Menu instance
             * @param {*} ev - Event
             * @returns {void}
             */
            vm.openMenu = function ($mdOpenMenu, ev) {
                ev.stopPropagation();
                $mdOpenMenu(ev);
            };

            /**
             * Call for edit item
             *
             * @param {*} event - MouseEvent
             * @param {*} item - Item for update
             * @returns {void}
             */
            vm.edit = function (event, item) {
                vm.onEdit({ event: event, item: item });
            };

            /**
             * Call for delete item
             *
             * @param {*} event - MouseEvent
             * @param {*} item - Item for delete
             * @returns {void}
             */
            vm.delete = function (event, item) {
                vm.onDelete({ event: event, item: item });
            };

            /**
             * Is data available after load
             * @return {boolean} - data exist flag
             */
            vm.showNoData = function () {
                return !vm.items || vm.items.length === 0 &&
                    !(vm.listPromise && vm.listPromise.$$state && vm.listPromise.$$state.status === 0);
            };

            /**
             * Emit event on row select/deselect
             *
             * @returns {void}
             */
            vm.notifySelectionChange = function () {
                vm.selectionChange({ items: vm.selectedItems });
            };

            /**
             * Check is value type of function
             * @param {*} value - value to check
             * @returns {boolean} - is it function
             */
            vm.isFunction = function (value) {
                return typeof value === 'function';
            };

            /**
             * Notify subscribers about row mouse enter.
             *
             * @param {any} item                - Row item
             * @returns {void}
             */
            vm.notifyMouseEnter = function (item) {
                if (!(vm.listSetup.rowMouseEnter instanceof Function)) {
                    return;
                }
                vm.listSetup.rowMouseEnter(item);
            };

            /**
             * Notify subscribers about row mouse leave.
             *
             * @param {any} item                - Row item
             * @returns {void}
             */
            vm.notifyMouseLeave = function (item) {
                if (!(vm.listSetup.rowMouseLeave instanceof Function)) {
                    return;
                }
                vm.listSetup.rowMouseLeave(item);
            };

            vm.notifyMouseClick = function (event, item) {
                if (!(vm.listSetup.rowMouseClick instanceof Function)) {
                    return;
                }
                vm.listSetup.rowMouseClick(event, item);
            };

            /**
             * Filter out hidden items from the random actions.
             * @param {*} item                  - Action item
             * @returns {boolean}               - Should be item filtered or not
             */
            vm.filterHiddenActions = function (item) {
                return !item.hidden;
            };

            /**
             * Pagination handler
             */
            vm.paginationHandler = function () {
                vm.onPaginate({ itemsPagination: vm.itemsPagination });
            };

            /**
             * Optional function to filter list
             * @param {Object} item - list item 
             * @returns {Boolean} - filter result
             */
            vm.filter = function (item) {
                if (vm.filterFunction) {
                    return vm.filterFunction(item);
                }
                return true;
            };

            /**
             * Optional function to check if row selection is disabled
             * @param {Object} item - list item 
             * @returns {Boolean} - is row selection disabled
             */
            vm.isRowSelectionDisabled = function(item) {
                if (vm.listSetup.selectionDisabledFunction && typeof vm.listSetup.selectionDisabledFunction === 'function'){
                    return vm.listSetup.selectionDisabledFunction(item);
                }
                return false;
            };
        }
    })
    .component('masterDetailField', {
        template: '<div layout="column" layout-align="start stretch"><span class="md-body-1">{{$ctrl.header}}</span><span class="md-caption">{{$ctrl.subheader}}</span></div>',
        bindings: {
            header: '@',
            subheader: '@'
        }
    });

'use strict';

/**
 * @ngdoc component
 * @name loopUiApp.component:genericGrid
 * @description
 * # genericGrid
 *
 * Component to represent data as grid of cards.
 * Accepts the following parameters as input:
 *
 * - `gridSetup`            - Grid configuration data
 * - `gridPromise`          - Promise to determine is data loading or not
 * - `gridLoading`          - [Deprecated] Boolean flag to determine is data loading or not
 * - `items`                - Items to display on cards
 * - `filterFunction`       - Function to filter list. Type: function 
 * - `entityName`           - Entity of items
 * - `newEntityTooltip`     - Tooltip for new entity button
 * - `randomActions`        - Random actions to add on cards menu
 *
 * and the following as output:
 *
 * `onEdit`                 - Event that emits when edit menu item is clicked
 * `onDelete`               - Event that emits when delete menu item is clicked
 * `onNew`                  - Event that emits when new button is clicked
 *
 * GridSetup description:
 *
 * {
 *    sortField: 'name',                        - Name of the field to sort. Type: string. For future use.
 *    showIndex: true,                          - Show or not index column. Type: boolean. For future use.
 *    editable: false,                          - Show or not Edit menu item in actions menu. Type: boolean
 *    removable: false,                         - Show or not Delete menu item in actions menu. Type: boolean
 *    cardType: '',                             - Card type. ['logoGridCard, 'companyCard', 'default']. Type: string
 *    itemClickable: true,                      - Is item clickable. Type: boolean
 *    limit: 10,                                - Preselected limit for paginator. Type: number. For future use.
 *    limitOptions: [10, 50, 100],              - Available paginator limit options. Type Array<number>. For future use.
 *    rowHeight: 200,                           - Grid row height (rowHeight - 16 = card height). Default: 200. Type: number
 *    dataMapping: {                            - Card data mapping
 *      avatar: {
 *        column: 'columnName',                 - Avatar field name. Type: string
 *        transformation: function (item) {     - Avatar field transformation function. Type: function
 *          return item.value;
 *        }
 *      },
 *      title: {
 *        column: 'columnName',                  - Title field name. Type: string
 *        transformation: function (item) {      - Title field transformation function. Type: function
 *          return item.value;
 *        }
 *      },
 *      subtitle: {
 *        column: 'columnName',                  - Subtitle field name. Type: string
 *        transformation: function (item) {      - Subtitle field transformation function. Type: function
 *          return item.value;
 *        }
 *      },
 *      content: {
 *        column: 'columnName',                  - Content field name. Type: string
 *        transformation: function (item) {      - Content field transformation function. Type: function
 *          return item.value;
 *        }
 *      }
 *    },
 *    footerItems: [
 *      {
 *        itemIcon: 'devices_other',             - Footer item icon name. Type: string
 *        itemTooltip: 'Devices count',          - Item tooltip. Type: string
 *        itemCounter: function (item) {         - Transformation function if item should contain counter.
 *          return item.deviceCount;
 *        }
 *      }
 *    ]
 * }
 *
 * Random actions description:
 *
 * {
 *    name: 'View/Edit',                        - Additional action name. Type: string
 *    icon: 'edit',                             - Additional action icon. Type: string
 *    function: function(item) {  },            - Additional action function. Type: function
 *    disabled: false                           - Should or not item displayed as disabled. Type: boolean
 * }
 *
 */
angular.module('loopUiApp')
    .component('genericGrid', {
        templateUrl: '../scripts/components/common/genericGrid/genericGrid.html',
        bindings: {
            gridSetup: '<',
            gridPromise: '<',
            gridLoading: '<', // Deprecated and not use
            items: '<',
            filterFunction: '<',
            entityName: '<',
            newEntityTooltip: '<',
            onEdit: '&',
            onDelete: '&',
            onNew: '&',
            onItemClick: '&',
            footerActions: '<',
            randomActions: '<'
        },
        controller: function () {
            var vm = this;

            /**
             * Component initialization
             *
             * @returns {void}
             */
            vm.$onInit = function () {
                vm.gridSetup.showIndex = vm.gridSetup.showIndex !== undefined ? vm.gridSetup.showIndex : true;
                vm.itemsPagination = {
                    limit: vm.gridSetup.limit || 11,
                    page: 1,
                    limitOptions: vm.gridSetup.limitOptions || [5, 10, 20]
                };

                vm.rowHeight = vm.gridSetup.rowHeight || 200;

            };

            /**
             * Call for edit item
             *
             * @param {*} event     - MouseEvent
             * @param {*} item      - Item for update
             * @returns {void}
             */
            vm.edit = function (event, item) {
                vm.onEdit({ event: event, item: item });
            };

            /**
             * Call for delete item
             *
             * @param {*} event     - MouseEvent
             * @param {*} item      - Item for delete
             * @returns {void}
             */
            vm.delete = function (event, item) {
                vm.onDelete({ event: event, item: item });
            };

            /**
             * Is data available after load
             * @return {boolean}    - data exist flag
             */
            vm.showNoData = function () {
                return vm.items.length === 0 &&
                    !(vm.gridPromise && vm.gridPromise.$$state && vm.gridPromise.$$state.status === 0);
            };

            /**
             * Transform data for column
             *
             * @param {*} item                  - Entity item
             * @param {string} column           - Column name
             * @returns {string}                - Original or transformed data
             */
            vm.getColumn = function (item, column) {
                if (!vm.gridSetup.dataMapping[column]) {
                    return;
                }
                return vm.gridSetup.dataMapping[column].transformation ?
                    vm.gridSetup.dataMapping[column].transformation(item) :
                    item[vm.gridSetup.dataMapping[column].column];
            };

            /**
              * Calculate number of pages for pagination
              * @returns {int} - number of pages
              */
            vm.numberPages = function () {
                var _listLength = vm.items.length;
                if (vm.filterFunction) {
                    _listLength = vm.items.filter(vm.filterFunction).length;
                }
                return Math.ceil(_listLength / vm.itemsPagination.limit);
            };

            /**
             * Optional function to filter list
             * @param {Object} item - list item 
             * @returns {Boolean} - filter result
             */
             vm.filter = function (item) {
                if (vm.filterFunction) {
                    return vm.filterFunction(item);
                }
                return true;
            };
        }
    });

'use strict';

/**
 * @ngdoc component
 * @name loopUiApp.component:gridCard
 * @description
 * # gridCard
 *
 * Component accepts following parameters as input:
 *
 * - `cardTitle`            - Card title, main label on card. Type: string
 * - `cardSubtitle`         - Card subtitle. Type: string
 * - `cardAvatar`           - Small image that will be placed before title and subtitle. Type: string
 * - `cardContent`          - Main card content, description. Type: string
 * - `randomActions`        - List of actions that will be displayed in card menu. Type Array
 * - `gridSetup`            - Host grid configuration.
 * - `cardItem`             - Data item that stands behind the card. Type: any
 * - `footerItems`          - Array of items appeared in the card footer. Type: Array<any>
 *
 * Footer item description:
 *
 * {
 *    itemIcon: 'icon_name',                  - Icon name from material icon registry. Type: string
 *    itemTooltip: 'Tooltip text'.            - Text for item tool. Type: string
 *    itemCounter: function (item) {          - Item column name that contain counter. Type: function
 *      return item.field.length
 *    }
 * }
 *
 */
angular.module('loopUiApp')
    .component('gridCard', {
        templateUrl: '../scripts/components/common/genericGrid/gridCard/gridCard.html',
        bindings: {
            cardTitle: '<',
            cardSubtitle: '<',
            cardAvatar: '<',
            cardContent: '<',
            randomActions: '<',
            gridSetup: '<',
            cardItem: '<',
            footerItems: '<'
        },
        controller: function () {
            var vm = this;

            vm.$onInit = function () {
                vm.gridSetup.cardType = vm.gridSetup.cardType || 'small';
            };

            /**
             *
             * @param {*} $mdOpenMenu - Menu instance
             * @param {*} ev - Event
             * @returns {void}
             */
            vm.openMenu = function ($mdOpenMenu, ev) {
                $mdOpenMenu(ev);
            };
        }
    });

'use strict';

/**
 * @ngdoc component
 * @name loopUiApp.component:infoCard
 * @description
 * # infoCard
 *
 * Component accepts following parameters as input:
 */
angular.module('loopUiApp')
    .component('infoCard', {
        templateUrl: '../scripts/components/common/genericGrid/infoCard/infoCard.html',
        bindings: {
            cardTitle: '<',
            cardSubtitle: '<',
            cardAvatar: '<',
            cardActions: '<'
        },
        transclude: true
    });
'use strict';

/**
 * @ngdoc component
 * @name loopUiApp.component:logoGridCard
 * @description
 * # logoGridCard
 *
 * Component accepts following parameters as input:
 *
 * - `cardTitle`            - Card title, main label on card. Type: string
 * - `cardSubtitle`         - Card subtitle. Type: string
 * - `cardTag`              - Card tag, value shows in the left-top corner. Type: string
 * - `cardAvatar`           - Small image that will be placed before title and subtitle. Type: string
 * - `cardContent`          - Main card content, description. Type: string
 * - `randomActions`        - List of actions that will be displayed in card menu. Type Array
 * - `gridSetup`            - Host grid configuration.
 * - `cardItem`             - Data item that stands behind the card. Type: any
 * - `footerItems`          - Array of items appeared in the card footer. Type: Array<any>
 *
 * Footer item description:
 *
 * {
 *    itemIcon: 'icon_name',                  - Icon name from material icon registry. Type: string
 *    itemTooltip: 'Tooltip text'.            - Text for item tool. Type: string
 *    itemCounter: function (item) {          - Item column name that contain counter. Type: function
 *      return item.field.length
 *    }
 * }
 *
 */
angular.module('loopUiApp')
    .component('logoGridCard', {
        templateUrl: '../scripts/components/common/genericGrid/logoGridCard/logoGridCard.html',
        bindings: {
            cardTitle: '<',
            cardSubtitle: '<',
            cardTag: '<',
            cardAvatar: '<',
            cardContent: '<',
            randomActions: '<',
            gridSetup: '<',
            cardItem: '<',
            footerItems: '<',
            backgroundHeight: '<',
            cardClass: '<'
        },
        controller: function () {
            var vm = this;

            vm.$onInit = function () {
                vm.gridSetup.cardType = vm.gridSetup.cardType || 'small';
            };

            /**
             *
             * @param {*} $mdOpenMenu - Menu instance
             * @param {*} ev - Event
             * @returns {void}
             */
            vm.openMenu = function ($mdOpenMenu, ev) {
                $mdOpenMenu(ev);
            };
        }
    });

'use strict';

/**
 * @ngdoc component
 * @name loopUiApp.component:companyCard
 * @description
 * # companyCard
 *
 * Component accepts following parameters as input:
 *
 * - `cardTitle`            - Card title, main label on card. Type: string
 * - `cardSubtitle`         - Card subtitle. Type: string
 * - `cardAvatar`           - Small image that will be placed before title and subtitle. Type: string
 * - `cardContent`          - Main card content, description. Type: string
 * - `randomActions`        - List of actions that will be displayed in card menu. Type Array
 * - `footerActions`        - List of actions that will be displayed on the bottom of the card. Type Array
 * - `gridSetup`            - Host grid configuration.
 * - `cardItem`             - Data item that stands behind the card. Type: any
 *
 */
angular.module('loopUiApp')
    .component('companyCard', {
        templateUrl: '../scripts/components/common/genericGrid/companyCard/companyCard.html',
        bindings: {
            cardTitle: '<',
            cardSubtitle: '<',
            cardContent: '<',
            footerActions: '<',
            randomActions: '<',
            gridSetup: '<',
            cardItem: '<',
            backgroundHeight: '<'
        },
        controller: function () {
            var vm = this;

            vm.$onInit = function () {
                vm.gridSetup.cardType = vm.gridSetup.cardType || 'small';
                vm.randomActions = vm.randomActions || vm.footerActions || [];
            };

            /**
             *
             * @param {*} $mdOpenMenu - Menu instance
             * @param {*} ev - Event
             * @returns {void}
             */
            vm.openMenu = function ($mdOpenMenu, ev) {
                $mdOpenMenu(ev);
            };
        }
    });

'use strict';

/**
 * @ngdoc component
 * @name loopUiApp.component:buttonCard
 * @description
 * # buttonCard
 *
 * Component accepts following parameter as input:
 *
 * - `imageName`        - Name of the image from Material Icons registry. Type: string
 * - `buttonText`       - Text, appeared on the button right after image. Type: string
 * - `buttonText`       - Tooltip shows on button hover. Type: string
 * - `showProgress`     - To show or not loading bar at the button's top. Type: boolean
 *
 * and the following as output:
 *
 * - `onClick`          - Emits click event w/o parameters. Type: MouseEvent.
 *
 */
angular.module('loopUiApp')
    .component('buttonCard', {
        templateUrl: '../scripts/components/common/genericGrid/buttonCard/buttonCard.html',
        bindings: {
            imageName: '<',
            buttonText: '<',
            buttonTooltip: '<',
            onClick: '&',
            showProgress: '<'
        },
        controller: function () {
            var vm = this;

            vm.buttonClick = function (event) {
                if (vm.showProgress) {
                    return;
                }
                vm.onClick({ event: event });
            };
        }
    });

'use strict';

/**
 * @ngdoc component
 * @name loopUiApp.component:listFilter
 * @description
 * # listFilter
 *
 * Component exposes following API's as output:
 *
 * - `onFilter`                       - Emits filter event and pass `predicate` to parent component. Usage <list-filter on-filter="$ctrl.filter(predicate)"
 * - `onNewClick`                     - Emits click Add event and pass MouseEvent to parent component. Usage <list-filter on-new-click="$ctrl.createNew(event)". May be deprecated later in favour of `additionalActions`.
 * - `onClose`                        - Emits close event. Usage <list-filter on-close="$ctrl.close(event)"`.
 * - `entityName`                     - Entity name of items
 * - `newEntityTooltip`               - Tooltip for new entity button
 * - `additionalActions`              - Additional actions that appeared as icon buttons after the add button.
 * - `hideButtons`                    - Hide all additional actions except filter.
 * - `hideFilter`                     - Hide filter button.
 * - `filter`                         - Show/Hide search field.
 *
 * Additional action:
 *
 * {
 *    label: 'Remove',                - Text that appeared in tooltip. Type: string
 *    icon: 'delete',                 - Material icon name. Type: string
 *    toggled: false,                 - Should button be toggled. Behavior can be controlled in buttonClick. Type: boolean
 *    buttonClick: function(event) {  - Action function. Type: function
 *      // Do something
 *    }
 * }
 *
 */
angular.module('loopUiApp')
    .component('listFilter', {
        templateUrl: '../scripts/components/common/listFilter/listFilter.html',
        bindings: {
            onFilter: '&',
            onNewClick: '&',
            onClose: '&',
            additionalActions: '<',
            hideButtons: '<',
            hideFilter: '<',
            entityName: '<',
            newEntityTooltip: '<',
            filterTitle: '<',
            filter: '<',
            searchString: '<'
        },
        controller: function () {
            var vm = this;

            vm.$onInit = function () {
                vm.filter = vm.filter || false;
                vm.entityName = vm.entityName || 'item';
            };

            vm.close = function() {
                vm.filter = false; 
                vm.searchString = ''; 
                vm.onFilter({predicate: ''});
                vm.onClose();
            };
        }
    });

'use strict';

/**
 * @ngdoc component
 * @name loopUiApp.component:listFilterSearch
 * @description
 * # listFilterSearch
 *
 * Component exposes following API's as output:
 *
 * - `onFilter`                       - Emits filter event and pass `predicate` to parent component. Usage <list-filter on-filter="$ctrl.filter(predicate)"
 * - `entityName`                     - Entity name of items 
 * - `additionalActions`              - Additional actions that appeared as icon buttons after the add button.
 * - `itemsCount`                     - Number of items in the list. Type: number
 *
 * Additional action:
 *
 * {
 *    label: 'Remove',                - Text that appeared in tooltip. Type: string
 *    icon: 'delete',                 - Material icon name. Type: string
 *    buttonClick: function(event) {  - Action function. Type: function
 *      // Do something
 *    }
 * }
 *
 */
angular.module('loopUiApp')
    .component('listFilterSearch', {
        templateUrl: '../scripts/components/common/listFilterSearch/listFilterSearch.html',
        bindings: {
            entityName: '<',
            additionalActions: '<',
            itemsCount: '<',
            onFilter: '&'
        },
        controller: function () {}
    });
'use strict';

/**
 * @ngdoc Digital Model List
 * @name loopUiApp.component:dtModelList
 * @description
 * # dtModelList
 *
 * Component represents Digital Twins Model Tags Hierarchy
 */
angular.module('loopUiApp')
    .component('dtModelList', {
        templateUrl: '../scripts/components/common/digitalTwins/dtModelList/dtModelList.html',
        controller: function ($scope, $state, $stateParams, $mdDialog, gettextCatalog, featuresCheck, Service, Commons) {
            var vm = this;
            vm.featureCode = 'DigitalTwin';
            vm.featureName = 'Digital Twins';
            // Feature check service
            vm.fc = featuresCheck;

            vm.modelList = [];
            vm.origModelList = [];

            vm.$onInit = function () {
                vm.entityName = 'Digital Twins Models';
                vm.entityHelpText = 'Models are the data structures for virtual instances. They allow you to create metadata ' +
                    'objects, transform data in a suitable format, and view the data in specific hierarchies. Multiple instances can be deployed from a single model.';
                vm.newEntityTooltip = 'Create a model';
                vm.companyName = $stateParams.companyName;

                // Unique value to get fresh device image
                vm.imageHash = Date.now();

                // Generic table setup
                vm.listSetup = {
                    sortField: 'name',
                    showIndex: false,
                    editable: false,
                    removable: false,
                    limit: 10,
                    limitOptions: [10, 50, 100],
                    fields: [
                        {
                            name: 'Image',
                            column: 'ImageUrl',
                            image: true,
                            style: '{"width": "50px"}',
                            transformation: function (item) {
                                return vm.getModelImagePath(item.ImagePreviewUrl);
                            }
                        },
                        {
                            name: 'Model',
                            column: 'Name',
                            transformation: function (item) {
                                return item.Name + (typeof item.Version === 'number' ? ' (v.' + item.Version + ')' : '');
                            }
                        },
                        {
                            name: 'Description',
                            column: 'Description'
                        },
                    ]
                };

                vm.gridSetup = {
                    sortField: 'name',
                    showIndex: true,
                    editable: false,
                    removable: false,
                    limit: 11,
                    limitOptions: [10, 50, 100],
                    cardType: 'logoGridCard',
                    itemClickable: true,
                    dataMapping: {
                        avatar: {
                            column: 'ImageUrl',
                            transformation: function (item) {
                                return vm.getModelImagePath(item.ImageUrl);
                            }
                        },
                        title: {
                            column: 'Name'
                        },
                        subtitle: {
                            column: 'Description'
                        },
                        tag: {
                            column: 'Version',
                            transformation: function (item) {
                                return typeof item.Version === 'number' ? ('v.' + item.Version) : '';
                            }
                        },
                        actions: vm.additionalActions
                    },
                };

                vm.additionalActions = [
                    {
                        name: 'Export Model',
                        icon: 'import_export',
                        function: vm.exportModel
                    },
                    {
                        name: 'Clone',
                        icon: 'file_copy',
                        function: vm.cloneModel
                    },
                    {
                        name: 'Edit Model',
                        icon: 'edit',
                        function: vm.editModelDialog
                    },
                    {
                        name: 'Upgrade Model on Edge Device',
                        icon: 'upgrade',
                        function: function (event, item) {
                            vm.upgradeModels(item);
                        }
                    },
                    {
                        name: 'Deploy Model to Edge Device',
                        icon: 'file_upload',
                        function: function (event, item) {
                            vm.deploy(item);
                        }
                    },
                    {
                        name: 'Delete',
                        icon: 'delete',
                        function: vm.deleteModel
                    }
                ];

                // Actions in filter
                vm.filterActions = [
                    {
                        label: 'Refresh',
                        icon: 'refresh',
                        buttonClick: vm.refreshModelList
                    },
                ];

                // Actions in button right after filter
                vm.buttonActions = [
                    {
                        name: 'Bulk Deploy',
                        label: 'Deploy models to Edge Device',
                        icon: 'upload',
                        buttonClick: function () {
                            vm.deploy();
                        }
                    },
                    {
                        name: 'Upgrade Models',
                        label: 'Upgrade Models deployed on Edge Devices',
                        icon: 'upgrade',
                        buttonClick: function () {
                            vm.upgradeModels();
                        }
                    },
                    {
                        name: 'Import Model',
                        label: 'Import Model from file (.json)',
                        icon: 'swap_vert',
                        buttonClick: function () {
                            vm.fileUploadApi.selectFile();
                        }
                    }
                ];

                vm.states = [
                    {
                        icon: 'view_list',
                        value: 0,
                        description: 'Table view'
                    },
                    {
                        icon: 'view_module',
                        value: 1,
                        description: 'Module view'
                    }
                ];
                vm.selectedState = vm.states[1];

                // New model object
                vm.newModel = {
                    Assets: null,
                    Description: '',
                    ID: null,
                    Name: ''
                };

                vm.refreshModelList();
            };

            /**
             * Load model list
             * @returns {void}
             */
            vm.refreshModelList = function () {
                vm.modelListPromise = Service.api.dtModelList({
                    actionExt: vm.companyName
                }).$promise;

                vm.modelListPromise.then(function (data) {
                    vm.modelList = data;
                    vm.origModelList = data;
                })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Get models failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error dtModelList:' + JSON.stringify(reason));
                    });
            };

            /**
             * Switch view state list/tree
             *
             * @param {*} state             - Newly selected state
             * @returns {void}
             */
            vm.selectState = function (state) {
                vm.selectedState = state;
            };


            /**
             * Save model
             * @param {Object} model - model object
             * @return {void}
             */
            vm.saveModel = function (model) {
                Service.api.dtModel({
                    actionExt: vm.companyName
                }, model).$promise
                    .then(function () {
                        vm.refreshModelList();
                        Commons.toastShow('Model saved');
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Save model failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error dtModel:' + JSON.stringify(reason));
                    });
            };

            /**
             * Create new node
             * @param {Object} model - model object
             * @return {Promise} - save node promise
             */
            vm.createNode = function (model) {
                var _payload = {
                    type: 'MODEL',
                    companyName: vm.companyName,
                    object: model,
                    name: model.name,
                    id: null,
                    childNodes: []
                };
                return Service.api.dtNode(_payload).$promise;
            };

            /**
             * Update node
             * @param {Object} model - model object
             * @param {Object} rootNode - model root node object
             * @return {Promise} - update node promise
             */
            vm.updateNode = function (model, rootNode) {
                rootNode.name = model.name;
                rootNode.object = model;
                return Service.api.dtNode(rootNode).$promise;
            };


            /**
             * Get full image URL
             * @param {Object} model - model object
             * @returns {string} - full image url
             */
            vm.getModelImagePath = function (imageUrl) {
                return imageUrl ? imageUrl + '?' + vm.imageHash : '/images/photo.svg';
            };

            /**
             * Delete model
             * @param {Object} event - Mouse event
             * @param {Object} dtModel - model object
             * @returns {void}
             */
            vm.deleteModel = function (event, dtModel) {
                var _deleteFn = function (model) {
                    Service.api.dtModelDelete({
                        actionExt: model.ID
                    }).$promise
                        .then(function () {
                            Commons.toastShow('Model was deleted');
                            vm.refreshModelList();
                        })
                        .catch(function (reason) {
                            var messageObject = Commons.createErrorObject(reason, 'Delete model failed');
                            Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                            console.log('Error dtModelDelete:' + JSON.stringify(reason));
                        });
                };

                Commons.showConfirmationWarn(
                    gettextCatalog.getString('Remove Model'),
                    gettextCatalog.getString('Are you sure you want to remove model <strong>' + dtModel.Name + '</strong>?'),
                    gettextCatalog.getString('Yes, Remove'),
                    function () {
                        _deleteFn(dtModel);
                    },
                    gettextCatalog.getString('Cancel'),
                    null,
                    event);
            };

            /**
             * Edit/Add model
             * @param {Event} event - mouse click event
             * @param {Object} item - activation config object
             * @returns {void} 
             */
            vm.editModel = function (event, item) {
                $state.go('dtModelView', {
                    companyName: vm.companyName,
                    modelId: item ? item.ID : '',
                    selectedTab: ''
                });
            };

            /**
             * Edit name/description or create a new model
             * @param {Object} event - mouse click event
             * @param {*} item - model item
             */
            vm.editModelDialog = function (event, item) {
                var scope = angular.extend($scope.$new(true), {
                    dtModel: angular.copy(item || vm.newModel),
                    dtModels: vm.modelList,
                });

                $mdDialog.show({
                    template: '<md-dialog style="width:600px;"><dt-model-dialog dt-model="dtModel" dt-models="dtModels"></dt-model-dialog></md-dialog>',
                    parent: angular.element(document.body),
                    targetEvent: event,
                    clickOutsideToClose: false,
                    preserveScope: true,
                    scope: scope,
                    skipHide: true
                })
                    .then(function (data) {
                        if (data) {
                            vm.saveModel(data);
                        }
                    });
            };

            /**
             * Clone model
             * @param {Object} event - Mouse click event
             * @param {*} item - model object
             */
            vm.cloneModel = function (event, item) {
                var _newModel = angular.copy(item);
                _newModel.Name = _newModel.Name + '_COPY';
                _newModel.$isClone = true;

                var scope = angular.extend($scope.$new(true), {
                    dtModel: _newModel,
                    dtModels: vm.modelList,
                });

                $mdDialog.show({
                    template: '<md-dialog style="width:600px;"><dt-model-dialog dt-model="dtModel" dt-models="dtModels"></dt-model-dialog></md-dialog>',
                    parent: angular.element(document.body),
                    targetEvent: event,
                    clickOutsideToClose: false,
                    preserveScope: true,
                    scope: scope,
                    skipHide: true
                })
                    .then(function (data) {
                        if (data) {
                            Service.api.dtModelClone({ modelId: data.ID }, {
                                Name: data.Name,
                                Description: data.Description,
                            }).$promise
                                .then(function () {
                                    Commons.toastShow('Model was cloned');
                                    vm.refreshModelList();
                                })
                                .catch(function (reason) {
                                    var messageObject = Commons.createErrorObject(reason, 'Clone model failed');
                                    Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                                    console.log('Error dtModelClone:' + JSON.stringify(reason));
                                });
                        }
                    });
            };

            /**
             * Deploy model from LEM to LE
             * @param {Object} item - selected model object
             * @returns {void}
             */
            vm.deploy = function (item) {
                var scope = angular.extend($scope.$new(true), {
                    model: item,
                });
                $mdDialog.show({
                    template: '<md-dialog aria-label="Select to deploy">' +
                        '<dt-deploy-model-dialog model="model">' +
                        '</dt-deploy-model-dialog></md-dialog>',
                    parent: angular.element(document.body),
                    clickOutsideToClose: false,
                    preserveScope: true,
                    scope: scope,
                    skipHide: true
                });
            };

            /**
             * 1. Show list of models deployed on edge devices
             * 2. Run upgrade process
             * @param {Object} model - selected model object
             * @return {void}
             */
            vm.upgradeModels = function (model) {
                // Create an isolated scope to pass to the component 
                var scope = angular.extend($scope.$new(true), {
                    type: 'MODEL',
                    modelId: model ? model.ID : null,
                });

                $mdDialog.show({
                    template: '<md-dialog aria-label="Select to upgrade">' +
                        '<dt-upgrade-models-dialog type="type" model-id="modelId">' +
                        '</dt-upgrade-models-dialog></md-dialog>',
                    parent: angular.element(document.body),
                    clickOutsideToClose: false,
                    preserveScope: true,
                    scope: scope,
                    skipHide: true
                });
            };

            /**
             * Export model
             * @param {Object} event - Mouse click event
             * @param {*} item - model object
             * @returns {void}
             */
            vm.exportModel = function (event, item) {
                var _payload = {
                    modelIds: [item.ID]
                };
                Service.api.dtModelExport(_payload).$promise
                    .then(function (data) {
                        Commons.downloadLink(JSON.stringify(data), 'model_' + item.Name + '_export.json');
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Export model failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error dtModelExport:' + JSON.stringify(reason));
                    });
            };

            /**
             * Prepare FormData for upload model
             * @param {Event} event - Selection event from fileUpload component
             * @returns {void}
             */
            vm.uploadModel = function (event) {
                if (event.target.files && event.target.files.length > 0) {
                    vm.formData = new FormData();
                    angular.forEach(event.target.files, function (data) {
                        vm.formData.append('file', data);
                    });
                    vm.saveImport(vm.formData, false);
                }
            };

            /**
             * Save imported file
             * 1. In case of error check error message
             * 2. If model already exists, ask user to overwrite it
             * @param {Object} data - FormData object of template
             * @param {Boolean} force 
             */
            vm.saveImport = function (data, force) {
                vm.fileUploadApi.cleanSelection();
                Service.api.dtModelImport({
                    actionExt: vm.companyName,
                    force: force
                }, data).$promise
                    .then(function () {
                        Commons.toastShow('Model imported');
                        vm.refreshModelList();
                    })
                    .catch(function (reason) {
                        // In case of error and model exist, ask confirmation to overwrite it
                        if (reason.data && reason.data.message === 'Models already exist') {
                            Commons.showConfirmation(
                                gettextCatalog.getString('Warning'),
                                gettextCatalog.getString(reason.data.messageDetails + '.<br>Are you sure you want to overwrite model?'),
                                gettextCatalog.getString('Overwrite'),
                                function () {
                                    vm.saveImport(data, true);
                                },
                                gettextCatalog.getString('Cancel'),
                                null,
                                null);
                        } else {
                            var messageObject = Commons.createErrorObject(reason, 'Import model failed');
                            Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                            console.log('Error dtModelImport:' + JSON.stringify(reason));
                        }
                    });
            };

            /**
             * Filter model list based on search criteria
             * @param {String} searchText - search string
             * @return {void}
             */
            vm.filter = function (searchText) {
                if (!searchText) {
                    vm.modelList = angular.copy(vm.origModelList);
                    return;
                }
                vm.modelList = vm.origModelList.filter(function (row) {
                    return (row.Description + row.Name).toLowerCase().indexOf(searchText.toLowerCase()) >= 0;
                });
            };
        }
    });
'use strict';

/**
 * @ngdoc Digital Twins Instances
 * @name loopUiApp.component:dtInstanceList
 * @description
 * # dtInstanceList
 */
angular.module('loopUiApp')
    .component('dtInstanceList', {
        templateUrl: '../scripts/components/common/digitalTwins/dtInstanceList/dtInstanceList.html',
        controller: function ($scope, $stateParams, $state, gettextCatalog, $mdDialog, featuresCheck, appConfig, Service, Commons) {
            var vm = this;
            vm.featureCode = 'DigitalTwin';
            vm.featureName = 'Digital Twins';
            // Feature check service
            vm.fc = featuresCheck;
            // Group instances by selected key
            vm.instanceGroup = {};
            // Map of models with a key as model ID 
            vm.isInstancesExists = undefined;

            vm.$onInit = function () {
                vm.entityName = 'Digital Twins Instances';
                vm.entityHelpText = 'Instances are inherited from a model. They are the actual data objects that contain static and dynamic ' +
                    'data from different sources. You must create a model, push it to an Edge device, create an instance on the Edge device. After that the instance will appear here automatically.';
                vm.companyName = $stateParams.companyName;
                vm.productName = appConfig.__env.productName;

                // Unique value to get fresh device image
                vm.imageHash = Date.now();

                vm.additionalActions = [
                    {
                        name: function (item) {
                            return item.State ? 'Disable Instance' : 'Enable';
                        },
                        icon: function (item) {
                            return item.State ? 'stop' : 'play_arrow';
                        },
                        function: vm.toggleStatus,
                        disabled: function (item) {
                            return !item.Online;
                        }
                    },
                    {
                        name: 'Upgrade',
                        icon: 'upgrade',
                        function: function (event, item) {
                            vm.upgradeModels(event, item.ModelID, item.DeviceID);
                        },
                        disabled: function (item) {
                            return !item.Online || !vm.isModelOutdated(item) || item.modifiable !== true;
                        }
                    }
                ];

                vm.listActions = [
                    {
                        label: 'Refresh',
                        icon: 'refresh',
                        buttonClass: 'md-icon-button',
                        buttonClick: vm.refreshInstanceList,
                        disabled: function () {
                            return false;
                        }
                    },
                    {
                        label: 'Upgrade Instances',
                        icon: 'upgrade',
                        buttonClass: 'md-raised',
                        buttonClick: vm.upgradeModels,
                        disabled: function () {
                            return !vm.isInstancesExists;
                        }
                    }
                ];

                // List for group selector
                vm.groups = [{
                    codeId: 'ProjectID',
                    codeName: 'ProjectName',
                    name: 'Project'
                },
                {
                    codeId: 'ModelID',
                    codeName: 'ModelName',
                    name: 'Model'
                },
                {
                    codeId: 'DevicePrettyName',
                    codeName: 'DevicePrettyName',
                    name: 'Edge Device'
                }];

                vm.groupKey = vm.groups[0];

                vm.sortField = 'Name';

                // TODO: Remove
                vm.instanceStatus = {};

                vm.refreshInstanceList();
            };

            /**
             * Load instance list
             * @returns {void}
             */
            vm.refreshInstanceList = function () {
                vm.isLoading = true;
                vm.instanceGroup = {};

                Service.api.dtInstanceList({
                    companyName: vm.companyName
                }).$promise
                    .then(function (data) {
                        vm.isInstancesExists = data.length > 0;
                        vm.instanceGroup = vm.groupInstanceByKey(vm.groupKey, data);
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Get instances failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error dtInstanceList:' + JSON.stringify(reason));
                    })
                    .finally(function () {
                        vm.isLoading = false;
                    });
            };

            /**
             * Group instances by selected key
             * @param {Object} groupKey - group object
             * @param {Array} list - list of instances 
             * @returns grouped list
             */
            vm.groupInstanceByKey = function (groupKey, list) {
                return list.reduce(function (acc, cur) {
                    acc[cur[groupKey.codeId]] = acc[cur[groupKey.codeId]] || {
                        groupKey: cur[groupKey.codeId],
                        groupName: cur[groupKey.codeName],
                        items: []
                    };
                    acc[cur[groupKey.codeId]].items.push(cur);
                    return acc;
                }, {});
            };

            /**
             * 1. Show list of models deployed on edge devices
             * 2. Run upgrade process
             * @return {void}
             */
            vm.upgradeModels = function (event, modelId, deviceId) {
                // Create an isolated scope to pass to the component 
                var scope = angular.extend($scope.$new(true), {
                    type: 'INSTANCE',
                    modelId: modelId || null,
                    deviceId: deviceId || null,
                });

                $mdDialog.show({
                    template: '<md-dialog aria-label="Select to upgrade">' +
                        '<dt-upgrade-models-dialog type="type" model-id="modelId" device-id="deviceId">' +
                        '</dt-upgrade-models-dialog></md-dialog>',
                    parent: angular.element(document.body),
                    clickOutsideToClose: false,
                    preserveScope: true,
                    scope: scope,
                    skipHide: true
                });
            };

            /**
             * Edit/Add instance
             * @param {Event} event - mouse click event
             * @param {Object} item - activation config object
             * @returns {void} 
             */
            vm.editInstance = function (event, item) {
                $state.go('dtInstanceView', {
                    companyName: vm.companyName,
                    instanceId: item ? item.id : '',
                    selectedTab: ''
                });
            };

            /**
             * Switch view state list/tree
             *
             * @param {*} state             - Newly selected state
             * @returns {void}
             */
            vm.selectState = function (state) {
                vm.selectedState = state;
            };

            /**
             * Get full image URL
             * @param {Object} model - model object
             * @returns {string} - full image url
             */
            vm.getModelImagePath = function (imageUrl) {
                return imageUrl ? imageUrl + '?' + vm.imageHash : '/images/photo.svg';
            };

            /**
             * Toggle instance state
             * @param {Object} event - mouse click event
             * @param {Object} instance - instance object
             */
            vm.toggleStatus = function (event, instance) {
                var _payload = {
                    ID: instance.ID,
                    State: !instance.State
                };
                Service.api.dtInstanceState(null, _payload).$promise
                    .then(function () {
                        Commons.toastShow('Instance has been ' + (_payload.State ? 'enabled' : 'disabled'));
                        vm.refreshInstanceList();
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Set instance status failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error dtInstanceState:' + JSON.stringify(reason));
                    });
            };

            /**
             * Open instance view
             * @param {Event} event - mouse click event
             * @param {Object} instance - instance object
             * @returns 
             */
            vm.openInstanceView = function (event, instance) {
                // Open view for online devices only
                if (instance.Online !== true || instance.modifiable !== true) {
                    var _message = instance.Online !== true ?
                        gettextCatalog.getString('The instance view is accessible for online edge devices') :
                        gettextCatalog.getString('You can view instances of models that were initially created on the ' + vm.productName);
                    Commons.showConfirmation(
                        gettextCatalog.getString('Instance view is not available'),
                        _message,
                        gettextCatalog.getString('Ok'),
                        null,
                        null,
                        null,
                        event);
                    return;
                }

                $state.go('dtInstanceView', {
                    companyName: vm.companyName,
                    instanceId: instance.ID,
                    selectedTab: ''
                });
            };

            /**
             * Edit name/description or create a new instance
             * @param {Object} event - mouse click event
             * @param {*} item - model item
             */
            vm.editInstanceDialog = function (event, item) {
                var scope = angular.extend($scope.$new(true), {
                    dtInstance: angular.copy(item || vm.newInstance)
                });

                $mdDialog.show({
                    template: '<md-dialog style="width:600px;"><dt-instance-dialog dt-instance="dtInstance"></dt-instance-dialog></md-dialog>',
                    parent: angular.element(document.body),
                    targetEvent: event,
                    clickOutsideToClose: false,
                    preserveScope: true,
                    scope: scope,
                    skipHide: true
                })
                    .then(function (data) {
                        if (data) {
                            vm.save(data);
                        }
                    });
            };

            /**
             * Save instance
             * @param {Object} dtInstance - instance object
             */
            vm.save = function (dtInstance) {
                Service.api.dtInstance(null, dtInstance).$promise
                    .then(function () {
                        Commons.toastShow('Instance saved');
                        vm.refreshInstanceList();
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Save instance failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error dtInstance:' + JSON.stringify(reason));
                    });
            };

            /**
             * Check if model on the instance is outdated
             * @param {Object} instance - instance object 
             * @returns 
             */
            vm.isModelOutdated = function (instance) {
                return instance && instance.ModelVersion && instance.ModelVersion > instance.Version;
            };

            /**
             * Open menu
             * @param {*} $mdOpenMenu - Menu instance
             * @param {*} ev - Event
             * @returns {void}
             */
            vm.openMenu = function ($mdOpenMenu, ev) {
                ev.stopPropagation();
                $mdOpenMenu(ev);
            };

            /**
             * Check is value type of function
             * @param {*} value - value to check
             * @returns {boolean} - is it function
             */
            vm.isFunction = function (value) {
                return typeof value === 'function';
            };
        }
    });
'use strict';

/**
 * @ngdoc Digital Model Dialog
 * @name loopUiApp.component:dtModelDialog
 * @description
 * # dtModelDialog
 *
 * Component represents Digital Twins Model Tags Hierarchy
 */
angular.module('loopUiApp')
    .component('dtModelDialog', {
        templateUrl: '../scripts/components/common/digitalTwins/dtModelDialog/dtModelDialog.html',
        bindings: {
            dtModel: '<',
            dtModels: '<'
        },
        controller: function ($timeout, $mdDialog) {
            var vm = this;

            vm.$onInit = function () {
                vm.assetType = ['ASSET'];

                vm.dtModel.Assets = vm.dtModel.Assets || vm.assetType[0];

                // In case of cloning model validate model name on load
                if (vm.dtModel && vm.dtModel.$isClone) {
                    $timeout(function () {
                        vm.dtModelForm.nameField.$setTouched();
                        vm.validateName(vm.dtModel);
                    }, 0);
                }
            };

            /**
             * Check if model name already exists
             * @param {Object} dtModel - model object
             * @returns {void}
             */
            vm.validateName = function (dtModel) {
                if (!dtModel.Name || !angular.isArray(vm.dtModels)) {
                    return;
                }
                var isNameExist = vm.dtModels.some(function (item) {
                    return item.Name.toUpperCase() === dtModel.Name.toUpperCase() &&
                        (item.ID !== dtModel.ID || dtModel.$isClone);
                });

                vm.dtModelForm.nameField.$setValidity('exists', !isNameExist);
            };

            /**
             * Hides the dialog
             * @returns {void}
             */
            vm.hide = function () {
                $mdDialog.hide(vm.dtModel);
            };

            /**
             * Cancel dialog button
             * @return {undefined}
             */
            vm.cancel = function () {
                $mdDialog.cancel();
            };
        }
    });
'use strict';

/**
 * @ngdoc Digital Twins Instance Dialog
 * @name loopUiApp.component:dtInstanceDialog
 * @description
 * # dtInstanceDialog
 */
angular.module('loopUiApp')
    .component('dtInstanceDialog', {
        templateUrl: '../scripts/components/common/digitalTwins/dtInstanceDialog/dtInstanceDialog.html',
        bindings: {
            dtInstance: '<',
        },
        controller: function ($mdDialog, $stateParams, Service, Commons) {
            var vm = this;
            vm.modelList = [];

            vm.$onInit = function () {
                vm.companyName = $stateParams.companyName;

                vm.refreshModelList();
            };

            /**
             * Load model list
             * @returns {void}
             */
            vm.refreshModelList = function () {
                Service.api.dtModelList({
                    actionExt: vm.companyName
                }).$promise
                    .then(function (data) {
                        vm.modelList = data;
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Get models failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error dtModelList:' + JSON.stringify(reason));
                    });
            };

            /**
             * Hides the dialog
             * @returns {void}
             */
            vm.hide = function () {
                $mdDialog.hide(vm.dtInstance);
            };

            /**
             * Cancel dialog button
             * @return {undefined}
             */
            vm.cancel = function () {
                $mdDialog.cancel();
            };
        }
    });
'use strict';

/**
 * @ngdoc Insights Dashboard view
 * @name loopUiApp.component:dtModelViewTree
 * @description
 * # dtModelViewTree
 *
 * Component represents Digital Twins Model Tags Hierarchy
 */
angular.module('loopUiApp')
    .component('dtModelViewTree', {
        templateUrl: '../scripts/components/common/digitalTwins/dtModelViewTree/dtModelViewTree.html',
        bindings: {
            model: '<',
            modelId: '<',
            staticAttributes: '<',
            dynamicAttributes: '<',
            nodes: '<',
            onSave: '&',
            onCalculateUsage: '&',
            onExport: '&',
            onImport: '&'
        },
        controller: function ($scope, $mdDialog, $stateParams, treeConfig, gettextCatalog, $timeout, Commons) {
            var vm = this;
            vm.companyName = $stateParams.companyName;
            vm.staticAttributesNodes = [];
            vm.dynamicAttributesNodes = [];

            vm.$onInit = function () {
                vm.data = [];

                // Change default angular-ui-tree classes 
                treeConfig.nodesClass = 'angular-ui-tree-nodes';
                treeConfig.treeClass = 'angular-ui-tree';
                treeConfig.handleClass = 'angular-ui-tree-handle';
                // Tree settings
                vm.treeOptions = {
                    dropped: function () {
                        vm.save();
                    },
                    removed: function () {
                        vm.save();
                    },
                    beforeDrag: function (sourceNodeScope) {
                        // This hack fixes md-virtual-repeat issue with node model
                        if (sourceNodeScope.$modelValue && sourceNodeScope.$modelValue.ID !== sourceNodeScope.node.ID) {
                            sourceNodeScope.$modelValue = angular.copy(sourceNodeScope.node);
                        }
                        return true;
                    },
                    beforeDrop: function (e) {
                        if (e.source && e.source.cloneModel && !e.source.cloneModel.ID) {
                            e.source.cloneModel.$ID = Commons.generateRandomString(16);
                        }
                        if (e.dest.nodesScope.node &&
                            ['FOLDER', 'ARRAY', 'MODEL'].indexOf(e.dest.nodesScope.node.NodeType) >= 0) {
                            return true;
                        } else {
                            Commons.toastShow('This node can\'t contain other nodes');
                            return false;
                        }
                    }
                };

                // List of schema actions
                vm.schemaActions = [
                    {
                        label: 'Collapse all',
                        icon: 'unfold_less',
                        buttonClick: vm.collapseAll
                    },
                    {
                        label: 'Expand all',
                        icon: 'unfold_more',
                        buttonClick: vm.expandAll
                    },
                    {
                        label: 'Export Schema',
                        icon: 'file_download',
                        buttonClick: vm.onExport
                    },
                    {
                        label: 'Import Schema',
                        icon: 'file_upload',
                        buttonClick: vm.onImport
                    }
                ];
            };

            vm.$onChanges = function (changes) {
                if (changes.nodes && changes.nodes.currentValue) {
                    vm.data = [changes.nodes.currentValue];
                    $timeout(function () {
                        vm.onCalculateUsage({
                            usage: vm.flattenObject(changes.nodes.currentValue)
                        });
                    }, 0);
                }
                if (changes.staticAttributes && changes.staticAttributes.currentValue) {
                    vm.staticAttributesNodes = changes.staticAttributes.currentValue
                        .map(function (attribute) {
                            return {
                                ID: attribute.ID,
                                Name: attribute.Key,
                                NodeType: 'STATIC_ATTRIBUTE',
                                Object: attribute,
                                CompanyName: vm.companyName
                            };
                        });
                }

                if (changes.dynamicAttributes && changes.dynamicAttributes.currentValue) {
                    vm.dynamicAttributesNodes = changes.dynamicAttributes.currentValue
                        .map(function (attribute) {
                            return {
                                ID: attribute.ID,
                                Name: attribute.Name,
                                NodeType: 'DYNAMIC_ATTRIBUTE',
                                Object: attribute,
                                CompanyName: vm.companyName
                            };
                        });
                }
            };

            /**
             * Save nodes
             * @returns {void}
             */
            vm.save = function () {
                vm.onSave({ nodes: vm.nodes });
                $timeout(function () {
                    vm.onCalculateUsage({
                        usage: vm.flattenObject(vm.nodes)
                    });
                }, 0);
            };

            /**
             * Show node details
             * @param {Object} node - node object
             * @return {void}
             */
            vm.nodeDetails = function (node) {
                vm.selectedNode = node;
            };

            /**
             * Is selected node folder?
             * @return {Boolean} - is folder flag
             */
            vm.isFolder = function () {
                return !!vm.selectedNode && (vm.selectedNode.NodeType === 'FOLDER' || vm.selectedNode.NodeType === 'ARRAY');
            };

            /**
             * Attribute list filter function
             * @param {Object} attribute - attribute object 
             * @returns {Boolean} - does search string exist in the list
             */
            vm.attrFilter = function (attribute) {
                if (vm.searchString && attribute && (attribute.Name || attribute.Key)) {
                    return (attribute.Name + attribute.Key).toUpperCase().indexOf(vm.searchString.toUpperCase()) >= 0;
                } else {
                    return true;
                }
            };

            /**
             * Create or edit folder
             * @param {Object} node - node object
             * @param {String} nodeType - node type (FOLDER or ARRAY)
             * @param {Boolean} isNew - is new node flag
             */
            vm.editFolder = function (node, nodeType, isNew) {
                var scope = angular.extend($scope.$new(true), {
                    nodeName: isNew ? 'New_Folder' : node.Name,
                    isNew: isNew,
                });
                $mdDialog.show({
                    template: '<md-dialog style="width:400px;" aria-label="Edit folder"><dt-edit-folder-dialog node-name="nodeName" is-new="isNew"></dt-edit-folder-dialog></md-dialog>',
                    parent: angular.element(document.body),
                    clickOutsideToClose: false,
                    preserveScope: true,
                    scope: scope,
                    skipHide: true,
                })
                    .then(function (name) {
                        // In case of new folder add it to the tree
                        if (name && isNew) {
                            node.ChildNodes.push({
                                $ID: Commons.generateRandomString(16),
                                NodeType: nodeType,
                                Name: name,
                                companyName: vm.companyName,
                                ChildNodes: [],
                            });
                            vm.save();
                            return;
                        }
                        // In case of edit folder update its name
                        if (name && !isNew) {
                            node.Name = name;
                            vm.save();
                            return;
                        }
                    });
            };

            /**
             * Add attribute to the node
             * @param {Object} node - node object 
             */
            vm.addAttribute = function (node) {
                var scope = angular.extend($scope.$new(true), {
                    staticAttributes: vm.staticAttributes,
                    dynamicAttributes: vm.dynamicAttributes,
                });
                $mdDialog.show({
                    template: '<md-dialog style="width:290px;" aria-label="Add attribute"><dt-select-attributes-dialog static-attributes="staticAttributes" dynamic-attributes="dynamicAttributes">' +
                        '</dt-select-attributes-dialog></md-dialog>',
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                    preserveScope: true,
                    scope: scope,
                    skipHide: true,
                    hasBackdrop: false
                })
                    .then(function (attribute) {
                        // If attribute and node is not empty add it to the tree
                        if (node && attribute) {
                            var _type = attribute.Key ? 'STATIC_ATTRIBUTE' : 'DYNAMIC_ATTRIBUTE';
                            node.ChildNodes.push({
                                Name: attribute.Name || attribute.Key,
                                NodeType: _type,
                                Object: attribute,
                                CompanyName: vm.companyName
                            });
                            vm.save();
                            return;
                        }
                    });
            };

            /**
             * Remove node/folder from the tree
             * @param {Object} node - node object
             * @param {Function} removeFn - remove function
             * @returns {void}
             */
            vm.removeNode = function (node, removeFn) {
                if (!node || !removeFn) {
                    return;
                }
                var isFolder = node.NodeType === 'FOLDER' || node.NodeType === 'ARRAY';
                var isFolderNotEmpty = isFolder && node.ChildNodes && node.ChildNodes.length > 0;

                Commons.showConfirmationWarn(
                    gettextCatalog.getString('Remove Confirmation'),
                    gettextCatalog.getString('Remove node?' + (isFolderNotEmpty ? ' Folder is not empty.' : '')),
                    gettextCatalog.getString('Yes, remove it'),
                    removeFn,
                    gettextCatalog.getString('Cancel'),
                    null,
                    null);
            };

            vm.flattenObject = function (curr, result) {
                var _result = result || {};

                if (['DYNAMIC_ATTRIBUTE', 'STATIC_ATTRIBUTE'].indexOf(curr.NodeType) >= 0) {
                    // Add the current Object's ID to the result
                    _result[curr.Object.ID] = true;
                }

                if (curr.ChildNodes && curr.ChildNodes.length > 0) {
                    // Recursively process each child node
                    curr.ChildNodes.forEach(function (child) {
                        return vm.flattenObject(child, _result);
                    });
                }

                return _result;
            };

            /**
             * Collapse all nodes
             */
            vm.collapseAll = function () {
                $scope.$broadcast('angular-ui-tree:collapse-all');
            };

            /**
             * Expand all nodes
             */
            vm.expandAll = function () {
                $scope.$broadcast('angular-ui-tree:expand-all');
            };
        }

    });
'use strict';

/**
 * @ngdoc Insights Dashboard view
 * @name loopUiApp.component:dtModelView
 * @description
 * # dtModelView
 *
 * Component represents Tag list
 */
angular.module('loopUiApp')
    .component('dtModelView', {
        templateUrl: '../scripts/components/common/digitalTwins/dtModelView/dtModelView.html',
        controller: function ($scope, $mdDialog, $transitions, $state, $http, $q, $stateParams, gettextCatalog,
            $timeout, FileSaver, featuresCheck, appConfig, Service, Commons) {
            var vm = this;
            vm.featureCode = 'DigitalTwin';
            vm.featureName = 'Digital Twins';
            // Feature check service
            vm.fc = featuresCheck;
            vm.cm = Commons;
            // Payload to save model
            vm.modelPayload = {};
            // Model or Instance
            vm.entity = {};
            // Static attributes
            vm.staticAttributes = [];
            // Dynamic attributes
            vm.dynamicAttributes = [];
            // Translations
            vm.transformations = [];
            // Image data
            vm.imageObject = {
                imageData: null,
                deleteImage: false
            };
            // Map of attribute used on hierarchy
            vm.attributeUsage = {};
            // Loading flag
            vm.isLoading = false;
            // Saving flag
            vm.isSaving = false;
            // Maximum number of attributes
            vm.MAX_ATTRIBUTES = 2000;

            vm.$onInit = function () {
                vm.companyName = $stateParams.companyName;
                vm.modelId = $stateParams.modelId;
                vm.instanceId = $stateParams.instanceId;

                // Select view mode: Model or Instance
                vm.viewType = vm.modelId ? 'MODEL_VIEW' : vm.instanceId ? 'INSTANCE_VIEW' : null;

                if (vm.viewType === null) {
                    console.log('Model or Instance ID is not provided');
                    return;
                }

                // Tab list
                if (vm.viewType === 'MODEL_VIEW') {
                    vm.tabs = ['static', 'transformation', 'dynamic', 'schema'];
                }
                if (vm.viewType === 'INSTANCE_VIEW') {
                    vm.tabs = ['static', 'dynamic'];
                }

                if (vm.modelId) {
                    vm.getModel(vm.modelId);
                } else if (vm.instanceId) {
                    vm.getInstance(vm.instanceId);
                }

                // Sets selected tab on load
                $timeout(function () {
                    vm.selectedTab = $stateParams.selectedTab !== undefined ? vm.tabs.indexOf($stateParams.selectedTab) : 0;
                    // body
                }, 0);

                // New static attribute object
                vm.newStaticAttribute = {
                    ID: null,
                    ModelID: vm.modelId,
                    InstanceID: null,
                    Key: null,
                    Value: null
                };

                // New dynamic attribute object
                vm.newDynamicAttribute = {
                    ID: null,
                    ModelID: vm.modelId,
                    InstanceID: null,
                    Topic: null,
                    Name: null,
                    Unit: null,
                    DataType: null,
                    SchemaID: null
                };

                // Track model changes and use it for save
                vm.newModelPayload = {
                    modelId: vm.modelId,
                    createStaticAttributes: [],
                    updateStaticAttributes: [],
                    delStaticAttributes: [],
                    createDynamicAttributes: [],
                    updateDynamicAttributes: [],
                    delDynamicAttributes: [],
                    createTransformations: [],
                    updateTransformations: [],
                    deleteTransformations: [],
                    saveHierarchy: null
                };

                // Create initial model payload from newModelPayload
                vm.initModelPayload();

                /** 
                 * Handle modelView page change. 
                 * Check if there are changes and ask confirmation
                 */
                vm.deRegisterHook = $transitions.onBefore({}, function (transition) {
                    var nextState = transition.to();  // This is the next state
                    var currentState = transition.from();  // This is the current state

                    // If the next state is different from the current state and the form is dirty
                    if (nextState !== currentState && !vm.isSaving && (vm.isFormDirty() || vm.isImageChanged())) {
                        return vm.confirmUnsaved()
                            .then(function (result) {
                                if (result) {
                                    return true;
                                }
                                return false;
                            });
                    }
                });
            };

            vm.$onDestroy = function () {
                // Deregister $transitions hook, so it won't work on other pages
                vm.deRegisterHook();
            };

            /**
             * Init model payload
             */
            vm.initModelPayload = function () {
                vm.modelPayload = angular.copy(vm.newModelPayload);
            };

            /**
             * Load model object
             * @param {String} modelId - model id
             * @return {void}
             */
            vm.getModel = function (modelId) {
                vm.isLoading = true;
                Service.api.dtModelGet({
                    actionExt: modelId
                }).$promise
                    .then(function (data) {
                        vm.refreshModelDetails(data);
                        vm.entity = data;

                        // Init image object
                        vm.imageObject = {
                            imageData: null,
                            deleteImage: false
                        };
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Get model node failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error dtModelGet:' + JSON.stringify(reason));
                    })
                    .finally(function () {
                        vm.isLoading = false;
                    });
            };

            /**
             * Load instance object
             * @param {String} instanceId - model id
             * @return {void}
             */
            vm.getInstance = function (instanceId) {
                vm.isLoading = true;
                Service.api.dtInstanceGet({
                    actionExt: instanceId
                }).$promise
                    .then(function (data) {
                        vm.refreshInstanceDetails();
                        vm.entity = data;
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Get instance node failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error dtInstanceGet:' + JSON.stringify(reason));
                    })
                    .finally(function () {
                        vm.isLoading = false;
                    });
            };

            /**
             * Load model details
             * @return {void}
             */
            vm.refreshModelDetails = function (model) {
                vm.refreshStaticAttributeList();
                vm.refreshDynamicAttributeList();
                vm.refreshTransformationsList();
                vm.refreshNodes(model);
            };

            /**
             * Load instance details
             * @return {void}
             */
            vm.refreshInstanceDetails = function () {
                vm.refreshStaticAttributeList();
                vm.refreshDynamicAttributeList();
                vm.refreshTransformationsList();
            };

            /**
             * Load static attributes list
             * @param {String} entityId - model or instance id
             * @returns {void}
             */
            vm.refreshStaticAttributeList = function () {
                var _entityId = vm.viewType === 'MODEL_VIEW' ? vm.modelId : vm.instanceId;
                var _operationName = vm.viewType === 'MODEL_VIEW' ? 'dtStaticAttributeList' : 'dtInstanceStaticAttributeList';

                vm.staticAttributes = [];
                vm.staticAttributesPromise = Service.api[_operationName]({
                    actionExt: _entityId
                }).$promise;

                vm.staticAttributesPromise.then(function (data) {
                    vm.staticAttributes = data;

                    vm.modelPayload.createStaticAttributes = [];
                    vm.modelPayload.updateStaticAttributes = [];
                    vm.modelPayload.delStaticAttributes = [];
                })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Get static attributes failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error dtStaticAttributeList:' + JSON.stringify(reason));
                    });
            };

            /** 
             * Add static attribute
             * @returns {void}
             */
            vm.onAddStaticAttribute = function () {
                if (!vm.validateAttributesLimit(vm.staticAttributes)) {
                    return;
                }
                var _newAttr = angular.copy(vm.newStaticAttribute);
                _newAttr = vm.addServiceFields(_newAttr);
                vm.staticAttributes.push(_newAttr);
                return _newAttr;
            };

            /**
             * Delete static attributes from list
             * @param {Array} items - attributes list 
             */
            vm.deleteStaticAttribute = function (items) {
                // Map of all items to delete in the list (local and in the database)
                var _itemToDeleteMap = {};

                items.forEach(function (item) {
                    if (!item.$isNew) {
                        vm.modelPayload.delStaticAttributes.push(item.ID);
                    }
                    vm.modelPayload.updateStaticAttributes = vm.modelPayload.updateStaticAttributes
                        .filter(function (attr) {
                            return attr.ID !== item.ID;
                        });
                    vm.modelPayload.createStaticAttributes = vm.modelPayload.createStaticAttributes
                        .filter(function (attr) {
                            return attr.ID !== item.ID;
                        });
                    _itemToDeleteMap[item.ID] = true;
                });

                // Delete attributes locally
                vm.staticAttributes = vm.staticAttributes.filter(function (row) {
                    return !_itemToDeleteMap[row.ID];
                });
            };

            /**
             * Save static attributes
             * @param {Object} item - attribute object to save
             * @param {boolean} trackChanges - track changes flag 
             */
            vm.saveStaticAttributes = function (item, trackChanges) {
                if (!item) {
                    return;
                }
                var _attr = angular.copy(item);
                if (trackChanges) {
                    if (_attr.$isNew) {
                        var _idxCreate = vm.modelPayload.createStaticAttributes
                            .findIndex(function (attr) {
                                return attr.ID === _attr.ID;
                            });
                        if (_idxCreate > -1) {
                            vm.modelPayload.createStaticAttributes[_idxCreate] = _attr;
                        } else {
                            vm.modelPayload.createStaticAttributes.push(_attr);
                        }
                    }

                    if (!_attr.$isNew) {
                        var idxUpd = vm.modelPayload.updateStaticAttributes
                            .findIndex(function (attr) {
                                return attr.ID === _attr.ID;
                            });
                        if (idxUpd > -1) {
                            vm.modelPayload.updateStaticAttributes[idxUpd] = _attr;
                        } else {
                            vm.modelPayload.updateStaticAttributes.push(_attr);
                        }
                    }
                }

                // Update the list for the change detection
                vm.staticAttributes = vm.staticAttributes.map(function (attr) {
                    return _attr.ID === attr.ID ? _attr : attr;
                });
            };

            /**
             * Load dynamic attributes list
             * @returns {void}
             */
            vm.refreshDynamicAttributeList = function () {
                var entityId = vm.viewType === 'MODEL_VIEW' ? vm.modelId : vm.instanceId;
                var _operationName = vm.viewType === 'MODEL_VIEW' ? 'dtDynamicAttributeList' : 'dtInstanceDynamicAttributeList';

                vm.dynamicAttributes = [];
                vm.dynamicAttributesPromise = Service.api[_operationName]({
                    actionExt: entityId
                }).$promise;

                vm.dynamicAttributesPromise.then(function (data) {
                    vm.dynamicAttributes = data;

                    vm.modelPayload.createDynamicAttributes = [];
                    vm.modelPayload.updateDynamicAttributes = [];
                    vm.modelPayload.delDynamicAttributes = [];
                })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Get dynamic attributes failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error dtDynamicAttributeList:' + JSON.stringify(reason));
                    });
            };

            /** 
             * Add dynamic attribute
             * @returns {void}
             */
            vm.onAddDynamicAttribute = function () {
                if (!vm.validateAttributesLimit(vm.dynamicAttributes)) {
                    return;
                }
                var _newAttr = angular.copy(vm.newDynamicAttribute);
                _newAttr = vm.addServiceFields(_newAttr);
                vm.dynamicAttributes.push(_newAttr);
                return _newAttr;
            };

            /**
             * Delete dynamic attribute from list
             * @param {Array} items - attributes list 
             */
            vm.deleteDynamicAttribute = function (items) {
                // Map of all items to delete in the list (local and in the database)
                var _itemToDeleteMap = {};

                items.forEach(function (item) {
                    if (!item.$isNew) {
                        vm.modelPayload.delDynamicAttributes.push(item.ID);
                    }

                    vm.modelPayload.updateDynamicAttributes = vm.modelPayload.updateDynamicAttributes
                        .filter(function (attr) {
                            return attr.ID !== item.ID;
                        });

                    vm.modelPayload.createDynamicAttributes = vm.modelPayload.createDynamicAttributes
                        .filter(function (attr) {
                            return attr.ID !== item.ID;
                        });
                    _itemToDeleteMap[item.ID] = true;
                });

                // Delete attributes locally
                vm.dynamicAttributes = vm.dynamicAttributes.filter(function (row) {
                    return !_itemToDeleteMap[row.ID];
                });
            };

            /**
             * Save dynamic attributes
             * @param {Object} item - dynamic attribute object
             * @param {boolean} trackChanges - track changes flag
             */
            vm.saveDynamicAttributes = function (item, trackChanges) {
                if (!item) {
                    return;
                }
                var _attr = angular.copy(item);
                if (trackChanges) {
                    if (_attr.$isNew) {
                        var _idxCreate = vm.modelPayload.createDynamicAttributes.findIndex(function (attr) {
                            return attr.ID === _attr.ID;
                        });
                        if (_idxCreate > -1) {
                            vm.modelPayload.createDynamicAttributes[_idxCreate] = _attr;
                        } else {
                            vm.modelPayload.createDynamicAttributes.push(_attr);
                        }
                    }

                    if (!_attr.$isNew) {
                        var idxUpd = vm.modelPayload.updateDynamicAttributes.findIndex(function (attr) {
                            return attr.ID === _attr.ID;
                        });
                        if (idxUpd > -1) {
                            vm.modelPayload.updateDynamicAttributes[idxUpd] = _attr;
                        } else {
                            vm.modelPayload.updateDynamicAttributes.push(_attr);
                        }
                    }
                }

                vm.dynamicAttributes = vm.dynamicAttributes.map(function (attr) {
                    return _attr.ID === attr.ID ? _attr : attr;
                });
            };

            /**
             * Load transformation list
             * @returns {void}
             */
            vm.refreshTransformationsList = function () {
                var _entityId = vm.viewType === 'MODEL_VIEW' ? vm.modelId : vm.instanceId;
                var _operationName = vm.viewType === 'MODEL_VIEW' ? 'dtTransformations' : 'dtInstanceTransformations';

                vm.transformationsPromise = Service.api[_operationName]({
                    actionExt: _entityId
                }).$promise;

                vm.transformationsPromise.then(function (data) {
                    vm.transformations = data;

                    vm.modelPayload.createTransformations = [];
                    vm.modelPayload.updateTransformations = [];
                    vm.modelPayload.deleteTransformations = [];
                })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Get transformations failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error dtTransformations:' + JSON.stringify(reason));
                    });
            };

            /**
             * Save transformation
             * @param {Object} transformation - transformation object
             * @param {Array} transformations - transformations list
             * @return {void}
             */
            vm.saveTransformation = function (transformation, transformations) {
                if (!transformation) {
                    return;
                }
                var _transformation = angular.copy(transformation);
                if (_transformation.$isNew) {
                    var _idxCreate = vm.modelPayload.createTransformations.findIndex(function (attr) {
                        return attr.ID === _transformation.ID;
                    });
                    if (_idxCreate > -1) {
                        vm.modelPayload.createTransformations[_idxCreate] = _transformation;
                    } else {
                        vm.modelPayload.createTransformations.push(_transformation);
                    }
                }

                if (!_transformation.$isNew) {
                    var idxUpd = vm.modelPayload.updateTransformations.findIndex(function (attr) {
                        return attr.ID === _transformation.ID;
                    });
                    if (idxUpd > -1) {
                        vm.modelPayload.updateTransformations[idxUpd] = _transformation;
                    } else {
                        vm.modelPayload.updateTransformations.push(_transformation);
                    }
                }
                vm.transformations = angular.copy(transformations);
            };

            /**
             * Delete transformation
             * @param {Object} event - mouse click event
             * @param {Object} transformation - transformation object
             * @param {Array} transformations - transformations list
             */
            vm.deleteTransformation = function (event, transformation, transformations) {
                if (!transformation.$isNew) {
                    vm.modelPayload.deleteTransformations.push(transformation.ID);
                }
                vm.modelPayload.createTransformations = vm.modelPayload.createTransformations
                    .filter(function (item) {
                        return item.ID !== transformation.ID;
                    });

                vm.modelPayload.updateTransformations = vm.modelPayload.updateTransformations
                    .filter(function (item) {
                        return item.ID !== transformation.ID;
                    });

                vm.transformations = angular.copy(transformations);
            };

            /**
             * Save nodes hierarchy
             * @param {Object} nodes - nodes tree
             * @return {void}
             */
            vm.saveNodes = function (nodes) {
                vm.modelPayload.saveHierarchy = nodes;
            };

            /**
             * Get nodes hierarchy by model
             * @param {Object} model - model object
             * @return {void}
             */
            vm.refreshNodes = function (model) {
                Service.api.dtNodes({
                    actionExt2: model.RootNodeID
                }).$promise
                    .then(function (data) {
                        vm.nodes = data;

                        vm.modelPayload.saveHierarchy = null;
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Get nodes failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error dtNodes:' + JSON.stringify(reason));
                    });
            };

            /**
             * Reload with confirmation
             * @param {MouseEvent} event - Mouse click event
             */
            vm.reload = function (event) {
                if (vm.isFormDirty() || vm.isImageChanged()) {
                    Commons.showConfirmation(
                        gettextCatalog.getString('Unsaved changes'),
                        gettextCatalog.getString('There are unsaved changes in the model. Are you sure you want to reload the model?'),
                        gettextCatalog.getString('Yes, reload'),
                        function () {
                            vm.getModel(vm.modelId);
                        },
                        gettextCatalog.getString('Cancel'),
                        null,
                        event);
                }
                else {
                    vm.getModel(vm.modelId);
                }
            };

            /**
             * Ask for confirmation before leaving the page
             * @returns {Promise} - Confirmation dialog promise
             */
            vm.confirmUnsaved = function () {
                var deferred = $q.defer();
                Commons.showConfirmation(
                    gettextCatalog.getString('Unsaved changes'),
                    gettextCatalog.getString('There are unsaved changes in the model. Leaving the page will result in the loss of these changes'),
                    gettextCatalog.getString('Leave page'),
                    function () {
                        deferred.resolve(true);
                    },
                    gettextCatalog.getString('Cancel'),
                    function () {
                        deferred.resolve(false);
                    });
                return deferred.promise;
            };

            /**
             * Save transactional model
             * @returns {void}
             */
            vm.save = function () {
                vm.isSaving = true;
                $q.when()
                    .then(function () {
                        // If no image changes move to the next step
                        if (!vm.isImageChanged()) {
                            return;
                        }
                        // If image was deleted, then call delete image
                        if (vm.imageObject.deleteImage) {
                            return Service.api.dtModelImageDelete({
                                actionExt: vm.modelId
                            }).$promise;
                        }
                        // If image was changed, then call save image
                        if (vm.imageObject.imageData) {
                            return Service.api.dtModelImage({
                                actionExt: vm.modelId
                            }, vm.imageObject.imageData).$promise;
                        }
                    })
                    .then(function () {
                        // Init image object as it's saved already
                        vm.imageObject = {
                            imageData: null,
                            deleteImage: false
                        };

                        // If no changes in the form, then move to the next step
                        if (!vm.isFormDirty()) {
                            return;
                        }
                        return Service.api.dtModelComplete({
                            companyName: vm.companyName
                        }, vm.modelPayload).$promise;
                    })
                    .then(function () {
                        vm.initModelPayload();
                        // Refresh model data
                        vm.getModel(vm.modelId);
                        Commons.toastShow('Model saved');
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Save model failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error dtModelComplete:' + JSON.stringify(reason));
                    })
                    .finally(function () {
                        vm.isSaving = false;
                    });

            };

            /**
             * Export attributes to CSV
             * @param {String} type - type of attributes to export (STATIC, DYNAMIC)
             * @returns {void}
             **/
            vm.exportAttributes = function (type) {
                var _operationName = type === 'STATIC' ? 'static-attributes' : type === 'DYNAMIC' ? 'dynamic-attributes' : null;

                if (!_operationName) {
                    return;
                }

                var req = {
                    url: appConfig.apiUrl + 'api/v' + appConfig.apiVersion +
                        '/dt2/' + _operationName + '/export-csv/' + vm.modelId,
                    method: 'GET',
                    responseType: 'arraybuffer'
                };
                Commons.toastShow('Exporting...');
                $http(req)
                    .then(function (resp) {
                        var serverData = new Blob([resp.data], { type: 'text/csv' });
                        FileSaver.saveAs(serverData, _operationName + '.csv');
                        Commons.toastShow('Export finished');
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Export to CSV failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log(_operationName + ':' + JSON.stringify(reason));
                    });
            };

            /**
             * Upload list of static attributes from CSV file
             * @returns {void}
             */
            vm.importStaticAttributes = function () {
                // Create an isolated scope to pass to the component
                var scope = angular.extend($scope.$new(true), {
                    title: 'Upload static attributes',
                    exampleLink: '/scripts/components/common/digitalTwins/dtModelView/static-attributes-sample.csv',
                });

                $mdDialog.show({
                    template: '<md-dialog style="max-width:350px;" aria-label="Upload Attributes"><md-dialog-content>' +
                        '<upload-file-dialog title="title" example-link="exampleLink">' +
                        '</upload-file-dialog></md-dialog-content></md-dialog>',
                    parent: angular.element(document.body),
                    clickOutsideToClose: false,
                    scope: scope,
                    preserveScope: true,
                    skipHide: true,
                })
                    .then(function (data) {
                        if (data && data.fileData) {
                            return Service.api.dtStaticAttributesParseCsv({
                                modelId: vm.modelId
                            }, data.fileData).$promise;
                        }
                    })
                    .then(function (data) {
                        if (data && data.length > 0) {
                            return vm.appendAttributes(vm.staticAttributes, data, 'Key');
                        }
                    })
                    .then(function (data) {
                        if (data && data.length > 0) {
                            vm.staticAttributes = angular.copy(data);

                            data.filter(function (attr) {
                                // Save only new attributes or existed in uploaded file 
                                return attr.$isNew !== undefined;
                            })
                                .forEach(function (attr) {
                                    vm.saveStaticAttributes(attr, true);
                                });
                        }
                    })
                    .catch(function (reason) {
                        if (!reason) {
                            return;
                        }
                        var messageObject = Commons.createErrorObject(reason, 'Uploading attributes failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error dtStaticAttributesParseCsv:' + JSON.stringify(reason));
                    });
            };

            /**
             * Upload list of dynamic attributes from CSV file
             * @returns {void}
             */
            vm.importDynamicAttributes = function () {
                // Create an isolated scope to pass to the component
                var scope = angular.extend($scope.$new(true), {
                    title: 'Upload dynamic attributes',
                    exampleLink: '/scripts/components/common/digitalTwins/dtModelView/dynamic-attributes-sample.csv',
                });

                $mdDialog.show({
                    template: '<md-dialog style="max-width:350px;" aria-label="Upload Attributes"><md-dialog-content>' +
                        '<upload-file-dialog title="title" example-link="exampleLink">' +
                        '</upload-file-dialog></md-dialog-content></md-dialog>',
                    parent: angular.element(document.body),
                    clickOutsideToClose: false,
                    scope: scope,
                    preserveScope: true,
                    skipHide: true,
                })
                    .then(function (data) {
                        if (data && data.fileData) {
                            return Service.api.dtDynamicAttributesParseCsv({
                                modelId: vm.modelId
                            }, data.fileData).$promise;
                        }
                    })
                    .then(function (data) {
                        if (data && data.length > 0) {
                            // Check transformation links
                            return vm.validateAttributeTransfomation(data);
                        }
                    })
                    .then(function (data) {
                        if (data && data.length > 0) {
                            return vm.appendAttributes(vm.dynamicAttributes, data, 'Name');
                        }
                    })
                    .then(function (data) {
                        if (data && data.length > 0) {
                            vm.dynamicAttributes = angular.copy(data);

                            data.filter(function (attr) {
                                // Save only new attributes or existed in uploaded file 
                                return attr.$isNew !== undefined;
                            })
                                .forEach(function (attr) {
                                    vm.saveDynamicAttributes(attr, true);
                                });
                        }
                    })
                    .catch(function (reason) {
                        if (!reason) {
                            return;
                        }
                        var messageObject = Commons.createErrorObject(reason, 'Uploading attributes failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error dtDynamicAttributesParseCsv:' + JSON.stringify(reason));
                    });
            };

            /**
             * Check if attribute exists in the list
             * 1. Ask for confirmation to overwrite
             * 2. Append new/changed attributes to the list
             * @param {Array} list - list of attributes
             * @param {Array} data - list of attributes to append
             * @param {string} keyName - name the unique key in the attribute object
             * @returns {Array} - updated list of attributes
             */
            vm.appendAttributes = function (list, data, keyName) {
                var deferred = $q.defer();
                // Create map of existing attributes
                var _attributesMap = list.reduce(function (acc, cur) {
                    acc[cur[keyName]] = cur;
                    return acc;
                }, {});
                // Find if any attribute exists
                var isAttributeExists = data.some(function (attr) {
                    return _attributesMap[attr[keyName]];
                });

                var _resolve = function () {
                    data.forEach(function (attr) {
                        // For new attributes add service flag $isNew
                        attr.$isNew = !_attributesMap[attr[keyName]];
                        _attributesMap[attr[keyName]] = attr;
                    });
                    var result = Object.keys(_attributesMap)
                        .map(function (key) {
                            return _attributesMap[key];
                        });
                    var _attributesMapById = result.reduce(function (acc, cur) {
                        acc[cur.ID] = cur;
                        return acc;
                    }, {});

                    var isDublicatesById = Object.keys(_attributesMapById).length < Object.keys(_attributesMap).length;

                    if (isDublicatesById) {
                        deferred.reject({
                            data: {
                                message: 'Attributes with the same ID and different names already exist. Please check the file and try again.'
                            }
                        });
                        return;
                    }
                    deferred.resolve(result);
                };

                // Ask confirmation about overwriting attributes
                if (isAttributeExists) {
                    Commons.showConfirmation(
                        gettextCatalog.getString('Confirmation'),
                        gettextCatalog.getString('Attributes with the same name already exist. Do you want to overwrite them?'),
                        gettextCatalog.getString('Yes, overwrite'),
                        _resolve,
                        gettextCatalog.getString('Cancel'),
                        function () {
                            deferred.reject();
                        },
                        null);
                } else {
                    _resolve();
                }
                return deferred.promise;
            };

            /**
             * Check if link to transformations if they exists in the list of transformations
             * @param {Array} attributes - list of attributes to upload 
             * @returns {Promise}
             */
            vm.validateAttributeTransfomation = function (attributes) {
                var deferred = $q.defer();
                var _transformationMap = vm.transformations.reduce(function (acc, cur) {
                    acc[cur.ID] = cur;
                    return acc;
                }, {});

                var isTransformationMissing = attributes.some(function (attr) {
                    return !!attr.SchemaID && !_transformationMap[attr.SchemaID];
                });

                if (isTransformationMissing) {
                    deferred.reject({
                        data: {
                            message: 'The attributes contain links to non-existent transformations',
                            messageDetails: 'Some attributes contain links to transformations that do not exist. Please check the file and try again.'
                        }
                    });
                } else {
                    deferred.resolve(attributes);
                }
                return deferred.promise;
            };

            /**
             * Export attributes to CSV
             * @param {String} type - type of attributes to export (STATIC, DYNAMIC)
             * @returns {void}
             **/
            vm.exportSchema = function () {
                var req = {
                    url: appConfig.apiUrl + 'api/v' + appConfig.apiVersion +
                        '/dt2/model/node/export-csv/' + vm.modelId,
                    method: 'GET',
                    responseType: 'arraybuffer'
                };
                Commons.toastShow('Exporting...');
                $http(req)
                    .then(function (resp) {
                        var serverData = new Blob([resp.data], { type: 'text/csv' });
                        FileSaver.saveAs(serverData, 'schema' + '-' + vm.modelId + '.csv');
                        Commons.toastShow('Export finished');
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Export to CSV failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('export-csv:' + JSON.stringify(reason));
                    });
            };


            /**
             * Upload schema from CSV file
             */
            vm.importSchema = function () {
                var _import = function () {
                    // Create an isolated scope to pass to the component
                    var scope = angular.extend($scope.$new(true), {
                        title: 'Upload schema',
                        exampleLink: '/scripts/components/common/digitalTwins/dtModelView/schema-sample.csv',
                    });

                    $mdDialog.show({
                        template: '<md-dialog style="max-width:350px;" aria-label="Upload Schema"><md-dialog-content>' +
                            '<upload-file-dialog title="title" example-link="exampleLink">' +
                            '</upload-file-dialog></md-dialog-content></md-dialog>',
                        parent: angular.element(document.body),
                        clickOutsideToClose: false,
                        scope: scope,
                        preserveScope: true,
                        skipHide: true,
                    })
                        .then(function (data) {
                            if (data && data.fileData) {
                                return Service.api.dtNodeParseCsv({
                                    modelId: vm.modelId
                                }, data.fileData).$promise;
                            }
                        })
                        .then(function (data) {
                            if (!data) {
                                return;
                            }

                            var validationObject = vm.validateSchemaNodes(data);

                            if (!validationObject.isValid) {
                                throw ({
                                    data: {
                                        message: 'Schema is not valid',
                                        messageDetails: 'The schema contains attributes (e.g. ' + validationObject.object.Name + ') that are not defined in the model. Please check the file and try again.'
                                    }
                                });
                            }

                            vm.nodes = angular.copy(data);
                            // Track nodes changes
                            vm.saveNodes(data);
                        })
                        .catch(function (reason) {
                            if (!reason) {
                                return;
                            }
                            var messageObject = Commons.createErrorObject(reason, 'Uploading schema failed');
                            Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                            console.log('Error dtSchemaParseCsv:' + JSON.stringify(reason));
                        });
                };

                Commons.showConfirmation(
                    gettextCatalog.getString('Confirmation'),
                    gettextCatalog.getString('Schema will be overwritten. Are you sure you want to continue?'),
                    gettextCatalog.getString('Yes, import'),
                    _import,
                    gettextCatalog.getString('Cancel'),
                    null,
                    null);
            };

            /**
             * Check if schema nodes exist. 
             * Recursively go through all nodes (attributes) and check if they exist
             * @returns {Boolean} - is schema valid
             */
            vm.validateSchemaNodes = function (nodes) {
                // Prepare map of all attributes
                var _attrMap = vm.staticAttributes.concat(vm.dynamicAttributes)
                    .reduce(function (acc, cur) {
                        acc[cur.ID] = true;
                        return acc;
                    }, {});

                /**
                 * Recursively check if the node exists in the list of attributes
                 * @param {Object} data - node object
                 * @returns 
                 */
                var checkObjects = function (data) {
                    var _object = data.Object && data.Object.ID ? data.Object : null;
                    // Check if the Object property exists in the objectList
                    if (_object && !_attrMap[_object.ID] && (data.NodeType === 'DYNAMIC_ATTRIBUTE' || data.NodeType === 'STATIC_ATTRIBUTE')) {
                        return {
                            isValid: false,
                            object: _object
                        };
                    }

                    // Recursively check child nodes
                    var valid = true;
                    if (data.ChildNodes) {
                        for (var i = 0; i < data.ChildNodes.length; i++) {
                            var childNode = data.ChildNodes[i];
                            var _result = checkObjects(childNode);
                            if (!_result.isValid) {
                                valid = false;
                                break; // Stop checking if any child node fails
                            }
                        }
                    }
                    return {
                        isValid: valid,
                        object: _object
                    };
                };

                return checkObjects(nodes);
            };

            /**
             * Save image
             * @param {FormData} imageData - image data
             * @return {void}
             */
            vm.saveImage = function (imageData) {
                vm.imageObject.imageData = imageData;
                vm.imageObject.deleteImage = false;
            };

            /**
             * Delete image
             * @returns {void}
             */
            vm.deleteImage = function () {
                vm.imageObject.imageData = null;
                vm.imageObject.deleteImage = true;
            };

            /**
             * 1. Show list of models deployed on edge devices
             * 2. Run upgrade process
             * @return {void}
             */
            vm.upgradeInstances = function () {
                // Create an isolated scope to pass to the component 
                var scope = angular.extend($scope.$new(true), {
                    type: 'INSTANCE',
                    modelId: vm.modelId,
                });

                $mdDialog.show({
                    template: '<md-dialog aria-label="Select to upgrade">' +
                        '<dt-upgrade-models-dialog type="type" model-id="modelId">' +
                        '</dt-upgrade-models-dialog></md-dialog>',
                    parent: angular.element(document.body),
                    clickOutsideToClose: false,
                    preserveScope: true,
                    scope: scope,
                    skipHide: true
                });
            };

            /**
             * Restart instance
             * @returns {void}
             */
            vm.restartInstance = function () {
                var _payload = {
                    ID: vm.instanceId,
                    State: true
                };
                Service.api.dtInstanceState(null, _payload).$promise
                    .then(function () {
                        _payload.State = false;
                        return Service.api.dtInstanceState(null, _payload).$promise;
                    })
                    .then(function () {
                        Commons.toastShow('Instance restarted');
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Restart instance failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error dtInstanceState:' + JSON.stringify(reason));
                    });
            };


            /**
             * Add service fields to help "track by" function in the list 
             * They should be clean before save (vm.cleanServiceFields)
             * @param {Object} item - attr object 
             * @returns 
             */
            vm.addServiceFields = function (item) {
                var _result = angular.copy(item);
                _result.ID = _result.ID || crypto.randomUUID();
                _result.$isNew = true;
                return _result;
            };

            /**
             * Check if the limit of attributes is exceeded
             * @param {Array} list - list of attributes
             * @returns {Boolean}
             */
            vm.validateAttributesLimit = function (list) {
                if (list.length >= vm.MAX_ATTRIBUTES) {
                    Commons.toastError(
                        'Attribute limit exceeded',
                        'You have reached the limit of ' + vm.MAX_ATTRIBUTES + ' attributes. Please remove some attributes to add new ones.',
                        -1
                    );
                    return false;
                }
                return true;
            };

            /**
             * Remove service fields from attributes
             * @param {Array} items - list of attributes to save 
             * @returns 
             */
            vm.cleanServiceFields = function (items) {
                return items.map(vm.removeServiceField);
            };

            /**
             * Remove service fields from attributes
             * @param {Object} item - attribute to save 
             * @returns 
             */
            vm.removeServiceField = function (item) {
                var _item = angular.copy(item);
                if (_item.$isNew) {
                    delete _item.$isNew;
                }
                return _item;
            };

            /**
             * Updates the URL on tab change to persist currently selected tab
             * @return {void}
             */
            vm.changeTab = function () {
                $state.go('.', { selectedTab: vm.tabs[vm.selectedTab] }, { location: 'replace' });
            };

            /**
             * Check if any changes were made
             * @returns {boolean} - is form pristine
             */
            vm.isFormDirty = function () {
                return vm.modelPayload.createStaticAttributes.length > 0 ||
                    vm.modelPayload.updateStaticAttributes.length > 0 ||
                    vm.modelPayload.delStaticAttributes.length > 0 ||
                    vm.modelPayload.createDynamicAttributes.length > 0 ||
                    vm.modelPayload.updateDynamicAttributes.length > 0 ||
                    vm.modelPayload.delDynamicAttributes.length > 0 ||
                    vm.modelPayload.createTransformations.length > 0 ||
                    vm.modelPayload.updateTransformations.length > 0 ||
                    vm.modelPayload.deleteTransformations.length > 0 ||
                    !!vm.modelPayload.saveHierarchy;

            };

            /**
             * Check if any image changes were made
             * @returns {boolean} - is image changed
             */
            vm.isImageChanged = function () {
                return !!vm.imageObject.imageData || vm.imageObject.deleteImage === true;
            };

            /**
             * Update attribute usage map key - attribute ID, value - true
             * @param {Object} usage - attribute usage map
             */
            vm.refreshAttributeUsage = function (usage) {
                vm.attributeUsage = usage;
            };
        }
    });
'use strict';

/**
 * @ngdoc Insights Dashboard view
 * @name loopUiApp.component:dtTagDialog
 * @description
 * # dtTagDialog
 *
 * Component represents Digital Twins Model Tags Hierarchy
 */
angular.module('loopUiApp')
    .component('dtTagDialog', {
        templateUrl: '../scripts/components/common/digitalTwins/dtTagDialog/dtTagDialog.html',
        bindings: {
            tag: '<'
        },
        controller: function ($mdDialog, $timeout, Service, Commons) {
            var vm = this;

            vm.$onInit = function () {
                vm.cm = Commons;
                vm.dataTypes = ['INT', 'LONG', 'DOUBLE', 'STRING', 'BOOLEAN'];
                vm.types = ['REALTIME_RAW', 'REALTIME_ANALYZED', 'HISTORICAL_ANALYZED', 'STATIC', 'CONTROL', 'ALERT'];

                vm.searchObjectText = null;
                vm.selectedObject = null;
                vm.searchResourceText = null;
                vm.selectedResource = null;

                vm.getOmnaList();
            };

            /**
             * Get OMNA registry list
             * @return {undefined}
             */
            vm.getOmnaList = function () {
                Service.api.omnaList().$promise
                    .then(function (data) {
                        vm.omnaObject = data.objects;
                        vm.omnaList = vm.cm.transformOmnaObject(data.objects);
                        vm.selectedObject = vm.restoreSelectedObject(vm.tag);
                    })
                    .then(function () {
                        //TODO: Find more correct way for md-selected-item-change event on object which clear resource selection on load
                        return $timeout(function () {
                            vm.selectedResource = vm.restoreSelectedResource(vm.tag);
                        }, 400);
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Get OMA list failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error omnaList:' + JSON.stringify(reason));
                    });
            };

            /**
             * Filter object list
             * @param {String} query search query string
             * @return {Array} filtered mni list
             */
            vm.querySearchObject = function (query) {
                return query ? vm.omnaList.filter(vm.createFilterFor(query)) : vm.omnaList;
            };

            /**
             * Filter resource list
             * @param {String} query search query string
             * @return {Array}
             */
            vm.querySearchResource = function (query) {
                if (!vm.selectedObject) {
                    return [];
                }
                var selectedObjectId = vm.selectedObject.objectID;
                return query ? vm.omnaObject[selectedObjectId].resources.item.filter(vm.createFilterFor(query))
                    : vm.omnaObject[selectedObjectId].resources.item;
            };

            /**
             * Create filter function for a query string
             * @param {String} query search query string
             * @return {function} comparator function
             */
            vm.createFilterFor = function (query) {
                var lowercaseQuery = angular.lowercase(query);

                return function filterFn(item) {
                    return (angular.lowercase(item.name).indexOf(lowercaseQuery) >= 0);
                };
            };

            /**
             * Reaction on object select change
             * @param {Object} tag tag object
             * @param {Object} object OMNA object definition
             * @return {undefined}
             */
            vm.objectChanged = function (tag, object) {
                vm.searchResourceText = '';
                vm.selectedResource = null;
                tag.omaObject = object ? object.objectID : null;
            };

            /**
             * Reaction on object select change
             * @param {Object} tag tag object
             * @param {Object} resource OMNA resource definition
             * @return {undefined}
             */
            vm.resourceChanged = function (tag, resource) {
                tag.omaResource = resource ? resource.id : null;
            };

            /**
             * Get "Object" object on load from tag objectId
             * @param {Object} tag - tag object
             * @return {Array} selected obejct array list
             */
            vm.restoreSelectedObject = function (tag) {
                return tag && tag.omaObject ? vm.omnaObject[tag.omaObject] : null;
            };

            /**
             * Get "Resource" object on load from tag resourceId
             * @param {Object} tag tag object
             * @return {Array} selected object array list
             */
            vm.restoreSelectedResource = function (tag) {
                if (!tag || !tag.omaResource || !tag.omaObject) {
                    return [];
                }
                var resourceList = vm.omnaObject[tag.omaObject].resources.item;
                for (var i = 0; i < resourceList.length; i++) {
                    if (resourceList[i].id === tag.omaResource) {
                        return resourceList[i];
                    }
                }
                return null;
            };

            /**
             * Hides the dialog
             * @returns {void}
             */
            vm.hide = function () {
                $mdDialog.hide(vm.tag);
            };

            /**
             * Cancel dialog button
             * @returns {void}
             */
            vm.cancel = function () {
                $mdDialog.cancel();
            };
        }
    });
'use strict';

/**
 * @ngdoc Attributes view
 * @name loopUiApp.component:dtAttributes
 * @description
 * # dtAttributes
 *
 * Component that represents a generic attributes table.
 *
 * Takes the following as input:
 *
 * - `modelId`            - Id of the model attributes belong to. Type: String 
 * - `formInstance`       - Form instance to validate attributes. Type: Object
 * - `rowModel`           - Current model of the row which is in edit mode. Type: Object
 * - `listSetup`          - List configuration JSON object. Type: Object
 * - `listPromise`        - Promise used to determine the current loading state. Type: Promise
 * - `items`              - Items to display. Type: Array<Object>
 * - `filterFunction`     - Function to filter the list. Type: Function
 * - `onNewClick`         - Callback for adding a new item. Type: Function
 * - `selectionChange`    - Handle item selection event. Type: Function
 * - `onFormRestore`      - Callback to restore the form when it becomes visible after scrolling. Type: Function
 * 
 * ListSetup description:
 *
 * {
 *    sortField: 'name',                        - Name of the field to sort by. Type: String
 *    sortFunction: function (item)             - Custom sort function. Type: Function
 *    showIndex: true,                          - Whether to show the index column. Type: Boolean
 *    idFieldName: 'Unique ID Field Name'       - Field name that represents the unique ID. Type: String,
 *    limit: 10,                                - Preselected limit for the paginator. Type: Number
 *    limitOptions: [10, 50, 100],              - Available paginator limit options. Type: Array<Number>
 *    fields: [                                 - Array of field configurations. Type: Array<Object>
 *      {
 *        name: 'Field Header',                 - Field header. Type: String
 *        column: 'Field Column Name',          - Field column name from the data array. Type: String
 *        type: 'Field Editor Type',            - Type of field editor ['static', 'autocomplete', 'input', 'select']. Type: String
 *        limit: 'Maximum Symbols',             - Maximum number of symbols in the current cell. Type: Number
 *        input: 'Input Field Type',            - Input field type ['text', 'select', 'number']. Type: String
 *        iconButton: false,                    - Whether the field represents an icon button link. Type: Boolean
 *        iconName: 'Icon Name',                - Icon name for the button. Type: String
 *        iconStyle: 'Icon CSS Style',          - Icon CSS style. Type: String
 *        style: 'Additional Field Style',      - Additional field component style. Type: Object
 *        validator: 'Validator Map',           - Map of available validators. Type: Object
 *        transformation: function              - Function to perform data transformation for edit mode like select element. Type: Function
 *        readTransformation: function          - Function to perform data transformation for read mode. Type: Function
 *      }
 *    ],
 *    actions: [                                - Array of action configurations. Type: Array<Object>
 *      {
 *        iconName: 'Action Icon Name',         - Icon name for the action. Type: String
 *        iconStyle: 'Action Icon Style',       - Icon CSS style. Type: String
 *        visible: function                     - Function to determine visibility of the action. Type: Function
 *        disabled: function                    - Function to determine if the action is disabled. Type: Function
 *        fieldAction: function                 - Action callback function. Type: Function
 *      }
 *    ],
 *    rowDblClickAction: function               - Callback function for row double click. Type: Function
 * }
 */
angular.module('loopUiApp')
    .component('dtAttributes', {
        templateUrl: '../scripts/components/common/digitalTwins/dtAttributes/dtAttributes.html',
        bindings: {
            modelId: '<',
            formInstance: '<',
            rowModel: '<',
            listSetup: '<',
            listPromise: '<',
            items: '<',
            isReadOnly: '<',
            filterFunction: '<',
            onNewClick: '&',
            onFormRestore: '&',
            selectionChange: '&',
        },
        controller: function () {
            var vm = this;
            // Map of selected items
            vm.selectedMap = {};
            // Flag to check if all items are selected
            vm.isAllChecked = false;
            // Map of all selected items to simplify track changes
            vm.itemsMap = {};
            // Map of validation message per field
            vm.customValidationMessage = {};

            vm.$onChanges = function (changes) {
                if (changes.items) {
                    //console.log('Items changed', changes.items.currentValue);
                    vm.itemsMap = changes.items.currentValue.reduce(function (acc, cur) {
                        acc[cur.ID] = true;
                        return acc;
                    }, {});
                    // It help to remove items from selectedItems list which are gone already
                    vm.selectedMap = Object.keys(vm.selectedMap).reduce(function (acc, key) {
                        if (vm.itemsMap[key]) {
                            acc[key] = vm.selectedMap[key];
                        }
                        return acc;
                    }, {});

                    vm.isAllChecked = false;

                    vm.notifySelectionChange();
                }
            };

            /**
             * Return the current loading state
             * @returns {boolean} - is promise in progress
             */
            vm.isLoading = function () {
                return vm.listPromise && vm.listPromise.$$state && vm.listPromise.$$state.status === 0;
            };

            /**
             * Is data available after load
             * @return {boolean} - data exist flag
             */
            vm.showNoData = function () {
                return !vm.items || vm.items.length === 0 && !vm.isLoading();
            };

            /**
             * Check is value type of function
             * @param {*} value - value to check
             * @returns {boolean} - is it function
             */
            vm.isFunction = function (value) {
                return typeof value === 'function';
            };

            /**
             * Optional function to filter list
             * @param {Object} item - list item 
             * @returns {Boolean} - filter result
             */
            vm.filter = function (item) {
                if (vm.filterFunction) {
                    return vm.filterFunction(item);
                }
                return true;
            };

            /**
             * Run customValidator function
             * @param {Object} field - field object
             */
            vm.validate = function (field) {
                if (vm.formInstance[field.column] && field.validator &&
                    vm.isFunction(field.validator.customValidator)) {
                    var _result = field.validator.customValidator(vm.rowModel);
                    vm.customValidationMessage[field.column] = _result.message;
                    vm.formInstance[field.column].$setValidity('customValidation', _result.status === 'S');
                }
            };

            /**
             * Add new attribute callback
             * @returns {void}
             **/
            vm.add = function () {
                vm.onNewClick();
            };

            /**
             * Check if row editable
             * @param {Object} item - row object
             * @returns {Boolean}
             */
            vm.isRowEditable = function (item) {
                return !!vm.rowModel && vm.rowModel[vm.listSetup.idFieldName] === item[vm.listSetup.idFieldName];
            };

            /**
             * Convert selectedMap to the array of selected IDs
             * Emit event on row select/deselect
             * @returns {void}
             */
            vm.notifySelectionChange = function () {
                var selectedItems = Object.keys(vm.selectedMap)
                    .filter(function (key) {
                        // Return only selected items
                        return vm.selectedMap[key] === true;
                    })
                    .map(function (key) {
                        // Convert to the array of IDs
                        return {
                            ID: key
                        };
                    });
                vm.selectionChange({ items: selectedItems });
            };

            /**
             * Check current visible row and restore form instance if needed
             * If row is visible (it might be deleted from DOM and restored later on md-virtual-repeat)
             * and form instance is empty, restore it from row model and validate
             * @param {String} id - row id
             * @returns {void}
             **/
            vm.reInitForm = function (id) {
                // Ignore row if it's not in edit mode
                if (!vm.rowModel || vm.rowModel && vm.rowModel[vm.listSetup.idFieldName] !== id) {
                    return;
                }
                var _keyField = vm.listSetup.fields[0].column;
                // Check if form instance is not empty
                if (!vm.formInstance[_keyField]) {
                    vm.onFormRestore({ item: vm.rowModel });
                    // Init change detection, to restore form instance
                    vm.rowModel = null;
                }
            };

            vm.toggleSelectAll = function () {
                if (vm.isAllChecked === true) {
                    vm.selectedMap = vm.items
                        .filter(vm.filter)
                        .reduce(function (acc, item) {
                            acc[item.ID] = true;
                            return acc;
                        }, {});
                }
                else {
                    vm.selectedMap = {};
                }
                vm.notifySelectionChange();
            };
        }
    })
    /**
     * Handle row visibility event. As row deleted from the DOM, 
     * it's form instance should be restored when it appears again.
     */
    .directive('validateRow', function () {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                attrs.$observe('rowId', function (newVal) {
                    // Call the callback function when row is visible
                    scope.$eval(attrs.onRowVisible, { id: newVal });
                });
            }
        };
    });
'use strict';

/**
 * @ngdoc Static attributes view
 * @name loopUiApp.component:dtStaticAttributes
 * @description
 * # dtStaticAttributes
 *
 */
angular.module('loopUiApp')
    .component('dtStaticAttributes', {
        templateUrl: '../scripts/components/common/digitalTwins/dtStaticAttributes/dtStaticAttributes.html',
        bindings: {
            model: '<',
            modelId: '<',
            staticAttributes: '<',
            staticAttributesPromise: '<',
            attributeUsage: '<',
            isReadOnly: '<',
            onImageSave: '&',
            onImageDelete: '&',
            onAdd: '&',
            onSave: '&',
            onDelete: '&',
            onRefresh: '&',
            onExport: '&',
            onImport: '&'
        },
        controller: function ($scope, $timeout, gettextCatalog, Commons) {
            var vm = this;

            vm.$onInit = function () {
                // Selected attributes
                vm.selectedItems = [];
                // Form model
                vm.rowModel = null;
                vm.origRowModel = null;

                // Generic table setup
                vm.listSetup = {
                    sortFunction: function (item) {
                        return item.$isNew ? 0 : 1;
                    },
                    limit: 10,
                    limitOptions: [10, 50, 100],
                    idFieldName: 'ID',
                    fields: [
                        {
                            name: 'Attribute Name',
                            column: 'Key',
                            editable: true,
                            type: 'autocomplete',
                            validator: {
                                required: true,
                                maxlength: 256,
                                customValidator: vm.keyValidation
                            },
                            transformation: function () {
                                return [
                                    'Device Description',
                                    'Device Type',
                                    'Manufacturer',
                                    'Device ID',
                                    'Model',
                                    'Serial',
                                ];
                            }
                        },
                        {
                            name: 'Attribute Value',
                            column: 'Value',
                            type: 'autocomplete',
                            editable: true,
                            validator: {
                                required: true,
                                maxlength: 256,
                            },
                            transformation: function () {
                                return [
                                    '$EDGE_DT_MODEL_NAME',
                                    '$EDGE_DT_MODEL_VERSION',
                                    '$EDGE_DT_SYSTEM_TIME'
                                ];
                            }
                        }
                    ],
                    actions: [
                        {
                            iconName: 'edit',
                            iconStyle: '{"color": "var(--primary-color)"}',
                            visible: function (item) {
                                return !vm.isEditable(item);
                            },
                            disabled: function () {
                                return false;
                            },
                            fieldAction: vm.editRow
                        },
                        {
                            iconName: 'check',
                            visible: function (item) {
                                return vm.isEditable(item);
                            },
                            disabled: function () {
                                return vm.isSaveDisabled();
                            },
                            fieldAction: function () {
                                vm.onSave({
                                    item: vm.rowModel,
                                    trackChanges: true
                                });
                                vm.rowModel = null;
                                vm.origRowModel = null;
                                vm.staticFormInstance.$setPristine();
                            }
                        },
                        {
                            iconName: 'delete',
                            iconStyle: '{"color": "var(--warn-color)"}',
                            visible: function () {
                                return true;
                            },
                            fieldAction: function (item) {
                                vm.removeSelected([item]);
                            }
                        }
                    ],
                    rowDblClickAction: vm.editRow
                };

                vm.filterActions = [{
                    label: 'Add new static attribute',
                    icon: 'add',
                    buttonClick: vm.onNew,
                    disable: function () {
                        return vm.staticFormInstance.$dirty;
                    }
                },
                {
                    label: 'Remove selected',
                    icon: 'delete',
                    iconClass: 'button__error',
                    disable: function () {
                        return vm.selectedItems.length === 0;
                    },
                    buttonClick: function () {
                        vm.removeSelected(vm.selectedItems);
                    }
                },
                {
                    label: 'Refresh',
                    icon: 'refresh',
                    buttonClick: vm.refresh
                },
                {
                    label: 'Export attributes',
                    icon: 'file_download',
                    buttonClick: vm.onExport
                },
                {
                    label: 'Import attributes',
                    icon: 'file_upload',
                    buttonClick: vm.onImport
                }];

                if (vm.isReadOnly) {
                    vm.listSetup.fields = vm.listSetup.fields
                        .filter(function (field) {
                            return !field.iconButton;
                        });

                    vm.filterActions = [{
                        label: 'Refresh',
                        icon: 'refresh',
                        buttonClick: vm.refresh
                    }];
                }

                // Unique value to get fresh model image
                vm.imageHash = Date.now();
            };

            vm.$onChanges = function (changes) {
                if (changes.staticAttributes && changes.staticAttributes.currentValue &&
                    vm.staticFormInstance && Commons.checkAllPristine(vm.staticFormInstance)) {
                    // Set form pristine on refresh
                    $timeout(function () {
                        vm.staticFormInstance.$setPristine();
                    }, 0);
                }
            };

            /**
             * Validate key input field
             * @param {Object} item - key value 
             * @returns {Object} - result of validation
             * { status: 'E|S', message: 'Some validation message' }
             */
            vm.keyValidation = function (value) {
                var _successResult = {
                    status: 'S',
                    message: ''
                };
                if (!value) {
                    return _successResult;
                }
                var _filteredTag = vm.staticAttributes.filter(function (item) {
                    return item.ID !== value.ID && value.Key && item.Key.toUpperCase() === value.Key.toUpperCase();
                });
                if (_filteredTag.length > 0) {
                    return {
                        status: 'E',
                        message: 'Key \'' + value.Key + '\' already exists'
                    };
                }
                return _successResult;
            };

            vm.refresh = function () {
                vm.rowModel = null;
                vm.origRowModel = null;
                vm.onRefresh();
            };

            /**
             * Check is field disabled
             * @param {String} id - field id
             * @returns 
             */
            vm.isSaveDisabled = function () {
                return vm.staticFormInstance && (vm.staticFormInstance.$invalid || !vm.staticFormInstance.$dirty);
            };

            /**
             * Check is the row on the edit mode
             * @param {Object} item - row object
             * @returns 
             */
            vm.isEditable = function (item) {
                return !!vm.rowModel && vm.rowModel[vm.listSetup.idFieldName] === item[vm.listSetup.idFieldName];
            };

            /**
             * Add new row callback
             * @returns {void}
             */
            vm.onNew = function () {
                vm.rowModel = vm.onAdd();
                vm.origRowModel = null;
                $timeout(function () {
                    Commons.formValidate(vm.staticFormInstance);
                }, 100);
            };

            /**
             * Edit row callback
             * 1. Check if row is already in edit mode (check previous row model)
             * 2. If row is already in edit mode and form instance is deleted from DOM, restore it
             * 3. If row is already in edit mode, and form is dirty, then save it
             * 4. If row is already in edit mode, and form is invalid, then delete it
             */
            vm.editRow = function (item) {
                var _keyField = vm.listSetup.fields[0].column;
                // If row is already in edit mode and form instance is deleted from DOM, restore it
                if (!!vm.rowModel && !vm.staticFormInstance[_keyField]) {
                    vm.onSave({
                        item: angular.copy(vm.origRowModel),
                        trackChanges: false
                    });
                    // Save current row model as a new model
                    vm.rowModel = angular.copy(item);
                    vm.origRowModel = angular.copy(item);
                    return;
                }

                // If row is already in edit mode
                if (!!vm.rowModel && vm.staticFormInstance.$dirty) {
                    // If form is valid, then save it
                    if (vm.staticFormInstance.$valid) {
                        vm.onSave({
                            item: angular.copy(vm.rowModel),
                            trackChanges: true
                        });
                    } else {
                        // If form is invalid, but new row then delete it
                        if (vm.rowModel.$isNew) {
                            vm.onDelete({
                                items: [vm.rowModel]
                            });
                            // If form is invalid, but not new row then restore it
                        } else {
                            vm.onSave({
                                item: angular.copy(vm.origRowModel),
                                trackChanges: false
                            });
                        }
                    }
                }
                vm.rowModel = angular.copy(item);
                vm.origRowModel = angular.copy(item);
                vm.staticFormInstance.$setPristine();
            };

            /**
             * Restore form after virtual repeat reappear
             * @param {Object} item - form model object 
             * @returns 
             */
            vm.restoreForm = function (item) {
                var _keyField = vm.listSetup.fields[0].column;
                if (!!vm.rowModel && item[vm.listSetup.idFieldName] === vm.rowModel[vm.listSetup.idFieldName] &&
                    vm.staticFormInstance && !vm.staticFormInstance[_keyField]) {
                    vm.rowModel = angular.copy(item);
                    // Run validation if only model has changed
                    if (!angular.equals(vm.rowModel, vm.origRowModel)) {
                        $timeout(function () {
                            Commons.formValidate(vm.staticFormInstance);
                        }, 100);
                    }
                }
            };

            /**
             * List filter callback
             *
             * @param {string} searchText    - Search string
             * @return {void}
             */
            vm.filter = function (searchText) {
                vm.searchText = searchText;
            };

            /**
             * Function for filtering list 
             * @param {Object} row - list item 
             * @returns {Boolean} - is item satisfies filter
             */
            vm.filterList = function (row) {
                if (!vm.searchText || row.$isNew === true) {
                    return true;
                }
                return (row.Key + row.Value).toLowerCase().indexOf(vm.searchText.toLowerCase()) >= 0;
            };

            /**
            * Prepare image upload data and call preview.
            *
            * @param {Event} event             - Selection event from fileUpload component
            * @returns {void}
            */
            vm.uploadImage = function (event) {
                if (event.target.files && event.target.files.length > 0) {
                    vm.imageData = new FormData();
                    angular.forEach(event.target.files, function (data) {
                        vm.imageData.append('file', data);
                    });
                    vm.previewImage(event.target);
                    vm.onImageSave({
                        imageData: vm.imageData
                    });
                }
            };

            /**
             * Enable image previewer.
             *
             * @param {HTMLElement} input - Input element
             * @returns {void}
             */
            vm.previewImage = function (input) {
                if (input.files && input.files[0]) {
                    var reader = new FileReader();
                    reader.onload = function (e) {
                        angular.element(document.querySelector('img.dt-model-dialog__image')).attr('src', e.target.result);
                        vm.imagePreview = true;
                        // Run $digest cycle manually after image upload
                        $scope.$apply();
                    };
                    reader.readAsDataURL(input.files[0]);
                }
            };

            /**
             * Check if model image available
             * @returns {boolean} - is image available
             */
            vm.haveImage = function () {
                return !!(vm.model && vm.model.ImageUrl) || vm.imagePreview;
            };

            /**
             * Get full image URL
             * @param {Object} model - model object
             * @returns {string} - full image url
             */
            vm.getModelImagePath = function () {
                return vm.model && vm.model.ImageUrl ? (vm.model.ImageUrl + '?' + vm.imageHash) : '/images/dt-upload.svg';
            };

            /**
             * Remove model image
             * @returns {void}
             */
            vm.removeImage = function () {
                var deleteFunction = function () {
                    vm.fileUploadApi.cleanSelection();
                    vm.model.ImageUrl = null;
                    vm.imagePreview = false;
                    vm.imageData = undefined;

                    vm.onImageDelete();
                };

                Commons.showConfirmationWarn(
                    gettextCatalog.getString('Remove Image'),
                    gettextCatalog.getString('Are you sure you want to remove image?'),
                    gettextCatalog.getString('Yes, remove'),
                    deleteFunction,
                    gettextCatalog.getString('Cancel'),
                    undefined,
                    null);
            };

            /**
             * Remove selected attributes
             * @param {Array} items - selected items
             * @returns {void}
             */
            vm.removeSelected = function (items) {
                if (vm.isAttributesUsed(items)) {
                    var _message = items.length === 1 ? 'This attribute cannot be removed because it is used in the schema.' :
                        'The selected attributes cannot be removed because at least one is used in the schema.';
                    Commons.showConfirmation(
                        gettextCatalog.getString('Operation is not allowed'),
                        gettextCatalog.getString(_message),
                        gettextCatalog.getString('Close'),
                        null,
                        null,
                        null,
                        null);
                    return;
                }

                Commons.showConfirmationWarn(
                    gettextCatalog.getString('Remove Confirmation'),
                    gettextCatalog.getString('Are you sure you want to remove <strong>' + items.length + '</strong> attribute(s)?'),
                    gettextCatalog.getString('Yes, remove them'),
                    function () {
                        vm.onDelete({
                            items: items
                        });
                        vm.selectedItems = [];
                        // Check form on the next digest cycle
                        $timeout(function () {
                            if (Commons.checkAllPristine(vm.staticFormInstance) && vm.staticFormInstance.$valid) {
                                vm.staticFormInstance.$setPristine();
                            }
                        }, 0);
                    },
                    gettextCatalog.getString('No'),
                    null,
                    null);
            };

            /**
             * Track changes in attributes
             * @param {Array} items - list of selected static attributes 
             */
            vm.selectionChange = function (items) {
                vm.selectedItems = items;
            };

            /**
             * Check if attributes are used on hierarchy
             * @param {Array} items - list of selected static attributes
             * @returns 
             */
            vm.isAttributesUsed = function (items) {
                return items.some(function (item) {
                    return vm.attributeUsage[item.ID] === true;
                });
            };
        }
    });
'use strict';

/**
 * @ngdoc Dynamic attributes view
 * @name loopUiApp.component:dtDynamicAttributes
 * @description
 * # dtDynamicAttributes
 *
 * Component represents Tag list
 */
angular.module('loopUiApp')
    .component('dtDynamicAttributes', {
        templateUrl: '../scripts/components/common/digitalTwins/dtDynamicAttributes/dtDynamicAttributes.html',
        bindings: {
            modelId: '<',
            transformations: '<',
            attributeUsage: '<',
            dynamicAttributes: '<',
            dynamicAttributesPromise: '<',
            isReadOnly: '<',
            onAdd: '&',
            onSave: '&',
            onDelete: '&',
            onRefresh: '&',
            onExport: '&',
            onImport: '&'
        },
        controller: function (gettextCatalog, $timeout, Commons) {
            var vm = this;

            vm.$onInit = function () {
                // Selected attributes
                vm.selectedItems = [];
                // Form model
                vm.rowModel = null;
                vm.origRowModel = null;

                vm.transformationMap = {};

                // Generic table setup
                vm.listSetup = {
                    sortFunction: function (item) {
                        return item.$isNew ? 0 : 1;
                    },
                    limit: 10,
                    limitOptions: [10, 50, 100],
                    idFieldName: 'ID',
                    fields: [
                        {
                            name: 'Name',
                            column: 'Name',
                            editable: true,
                            type: 'input',
                            validator: {
                                required: true,
                                maxlength: 256,
                                customValidator: vm.nameValidation
                            }
                        },
                        {
                            name: 'Unit (Optional)',
                            column: 'Unit',
                            editable: true,
                            type: 'input',
                            validator: {
                                maxlength: 256,
                            }
                        },
                        {
                            name: 'DataType (Optional)',
                            column: 'DataType',
                            editable: true,
                            type: 'autocomplete',
                            validator: {
                                maxlength: 256,
                            },
                            transformation: function () {
                                return [
                                    'JSON',
                                    'String',
                                    'Number',
                                    'Boolean',
                                    'Array',
                                ];
                            }
                        },
                        {
                            name: 'Skip Key',
                            column: 'SkipParentKey',
                            editable: true,
                            type: 'checkbox',
                            disabled: function () {
                                return vm.rowModel.DataType !== 'JSON';
                            },
                        },
                        {
                            name: 'Schema ID (Optional)',
                            column: 'SchemaID',
                            editable: true,
                            keyColumn: 'ID',
                            nameColumn: 'Name',
                            type: 'select',
                            transformation: function () {
                                return vm.transformations;
                            },
                            readTransformation: function (item) {
                                return vm.transformationMap[item.SchemaID] || item.SchemaID;
                            }
                        }
                    ],
                    actions: [
                        {
                            iconName: 'edit',
                            iconStyle: '{"color": "var(--primary-color)"}',
                            visible: function (item) {
                                return !vm.isEditable(item);
                            },
                            disabled: function () {
                                return false;
                            },
                            fieldAction: vm.editRow
                        },
                        {
                            iconName: 'check',
                            visible: function (item) {
                                return vm.isEditable(item);
                            },
                            disabled: function () {
                                return vm.isSaveDisabled();
                            },
                            fieldAction: function () {
                                vm.onSave({
                                    item: vm.rowModel,
                                    trackChanges: true
                                });
                                vm.rowModel = null;
                                vm.origRowModel = null;
                                vm.dynamicFormInstance.$setPristine();
                            }
                        },
                        {
                            iconName: 'delete',
                            iconStyle: '{"color": "var(--warn-color)"}',
                            visible: function () {
                                return true;
                            },
                            fieldAction: function (item) {
                                vm.removeSelected([item]);
                            }
                        }
                    ],
                    rowDblClickAction: vm.editRow
                };

                vm.filterActions = [{
                    label: 'Add new dynamic attribute',
                    icon: 'add',
                    buttonClick: vm.onNew,
                    disable: function () {
                        return vm.dynamicFormInstance.$dirty;
                    }
                },
                {
                    label: 'Remove selected',
                    icon: 'delete',
                    iconClass: 'button__error',
                    disable: function () {
                        return vm.selectedItems.length === 0;
                    },
                    buttonClick: function () {
                        vm.removeSelected(vm.selectedItems);
                    }
                },
                {
                    label: 'Refresh',
                    icon: 'refresh',
                    buttonClick: vm.refresh
                },
                {
                    label: 'Export attributes',
                    icon: 'file_download',
                    buttonClick: vm.onExport
                },
                {
                    label: 'Import attributes',
                    icon: 'file_upload',
                    buttonClick: vm.onImport
                }];

                if (vm.isReadOnly) {
                    vm.listSetup.fields = vm.listSetup.fields
                        .filter(function (field) {
                            return !field.iconButton;
                        });

                    vm.filterActions = [{
                        label: 'Refresh',
                        icon: 'refresh',
                        buttonClick: vm.refresh
                    }];
                }
            };

            vm.$onChanges = function (changes) {
                if (changes.dynamicAttributes && changes.dynamicAttributes.currentValue &&
                    vm.dynamicFormInstance && Commons.checkAllPristine(vm.dynamicFormInstance)) {
                    // Set form pristine on refresh
                    $timeout(function () {
                        vm.dynamicFormInstance.$setPristine();
                    }, 0);
                }

                if (changes.transformations && changes.transformations.currentValue) {
                    vm.transformationMap = changes.transformations.currentValue.reduce(function (acc, cur) {
                        acc[cur.ID] = cur.Name;
                        return acc;
                    }, {});
                }
            };

            /**
             * Validate name input field
             * @param {Object} value - key value 
             * @returns {Object} - result of validation
             * { status: 'E|S', message: 'Some validation message' }
             */
            vm.nameValidation = function (value) {
                var _successResult = {
                    status: 'S',
                    message: ''
                };
                if (!value) {
                    return _successResult;
                }
                var _filteredAtts = vm.dynamicAttributes.filter(function (item) {
                    return item.ID !== value.ID && value.Name && item.Name.toUpperCase() === value.Name.toUpperCase();
                });
                if (_filteredAtts.length > 0) {
                    return {
                        status: 'E',
                        message: 'Attribute  \'' + value.Name + '\' already exists'
                    };
                }
                return _successResult;
            };

            /**
             * Clean model on refresh
             */
            vm.refresh = function () {
                vm.rowModel = null;
                vm.origRowModel = null;
                vm.onRefresh();
            };

            /**
             * Check is field disabled
             * @param {String} id - field id
             * @returns 
             */
            vm.isSaveDisabled = function () {
                return vm.dynamicFormInstance && (vm.dynamicFormInstance.$invalid || !vm.dynamicFormInstance.$dirty);
            };

            /**
             * Check is the row on the edit mode
             * @param {Object} item - row object
             * @returns 
             */
            vm.isEditable = function (item) {
                return !!vm.rowModel && vm.rowModel[vm.listSetup.idFieldName] === item[vm.listSetup.idFieldName];
            };

            /**
             * Add new row callback
             * @returns {void}
             */
            vm.onNew = function () {
                vm.rowModel = vm.onAdd();
                vm.origRowModel = null;
                $timeout(function () {
                    Commons.formValidate(vm.dynamicFormInstance);
                }, 100);
            };

            /**
             * Edit row callback
             * 1. Check if row is already in edit mode (check previous row model)
             * 2. If row is already in edit mode and form instance is deleted from DOM, restore it
             * 3. If row is already in edit mode, and form is dirty, then save it
             * 4. If row is already in edit mode, and form is invalid, then delete it
             */
            vm.editRow = function (item) {
                var _keyField = vm.listSetup.fields[0].column;
                // If row is already in edit mode and form instance is deleted from DOM, restore it
                if (!!vm.rowModel && !vm.dynamicFormInstance[_keyField]) {
                    vm.onSave({
                        item: angular.copy(vm.origRowModel),
                        trackChanges: false
                    });
                    // Save current row model as a new model
                    vm.rowModel = angular.copy(item);
                    vm.origRowModel = angular.copy(item);
                    return;
                }

                // If row is already in edit mode
                if (!!vm.rowModel && vm.dynamicFormInstance.$dirty) {
                    // If form is valid, then save it
                    if (vm.dynamicFormInstance.$valid) {
                        vm.onSave({
                            item: angular.copy(vm.rowModel),
                            trackChanges: true
                        });
                    } else {
                        // If form is invalid, but new row then delete it
                        if (vm.rowModel.$isNew) {
                            vm.onDelete({
                                items: [vm.rowModel]
                            });
                            // If form is invalid, but not new row then restore it
                        } else {
                            vm.onSave({
                                item: angular.copy(vm.origRowModel),
                                trackChanges: false
                            });
                        }
                    }
                }
                vm.rowModel = angular.copy(item);
                vm.origRowModel = angular.copy(item);
                vm.dynamicFormInstance.$setPristine();
            };

            /**
             * Restore form after virtual repeat reappear
             * @param {Object} item - form model object 
             * @returns 
             */
            vm.restoreForm = function (item) {
                var _keyField = vm.listSetup.fields[0].column;
                if (!!vm.rowModel && item[vm.listSetup.idFieldName] === vm.rowModel[vm.listSetup.idFieldName] &&
                    vm.dynamicFormInstance && !vm.dynamicFormInstance[_keyField]) {
                    vm.rowModel = angular.copy(item);
                    // Run validation if only model has changed
                    if (!angular.equals(vm.rowModel, vm.origRowModel)) {
                        $timeout(function () {
                            Commons.formValidate(vm.dynamicFormInstance);
                        }, 100);
                    }
                }
            };

            /**
             * List filter callback
             *
             * @param {string} searchText    - Search string
             * @return {void}
             */
            vm.filter = function (searchText) {
                vm.searchText = searchText;
            };

            /**
             * Function for filtering list 
             * @param {Object} row - list item 
             * @returns {Boolean} - is item satisfies filter
             */
            vm.filterList = function (row) {
                if (!vm.searchText || row.$isNew === true) {
                    return true;
                }
                return (row.Name + row.Unit + row.Topic).toLowerCase().indexOf(vm.searchText.toLowerCase()) >= 0;
            };

            /**
             * Remove selected attributes
             * @param {Array} items - selected items
             * @returns {void}
             */
            vm.removeSelected = function (items) {
                if (vm.isAttributesUsed(items)) {
                    var _message = items.length === 1 ? 'This attribute cannot be removed because it is used in the schema.' :
                        'The selected attributes cannot be removed because at least one is used in the schema.';
                    Commons.showConfirmation(
                        gettextCatalog.getString('Operation is not allowed'),
                        gettextCatalog.getString(_message),
                        gettextCatalog.getString('Close'),
                        null,
                        null,
                        null,
                        null);
                    return;
                }

                Commons.showConfirmationWarn(
                    gettextCatalog.getString('Remove Confirmation'),
                    gettextCatalog.getString('Are you sure you want to remove <strong>' + items.length + '</strong> attribute(s)?'),
                    gettextCatalog.getString('Yes, remove them'),
                    function () {
                        vm.onDelete({
                            items: items
                        });
                        vm.selectedItems = [];
                        // Check form on the next digest cycle
                        $timeout(function () {
                            if (Commons.checkAllPristine(vm.dynamicFormInstance) && vm.dynamicFormInstance.$valid) {
                                vm.dynamicFormInstance.$setPristine();
                            }
                        }, 0);
                    },
                    gettextCatalog.getString('No'),
                    null,
                    null);
            };

            /**
             * Track changes in attributes
             * @param {Array} items - list of selected attributes 
             */
            vm.selectionChange = function (items) {
                vm.selectedItems = items;
            };

            /**
             * Check if attributes are used on hierarchy
             * @param {Array} items - list of selected attributes
             * @returns 
             */
            vm.isAttributesUsed = function (items) {
                return items.some(function (item) {
                    return vm.attributeUsage[item.ID] === true;
                });
            };
        }
    });
'use strict';

/**
 * @ngdoc Transformation view
 * @name loopUiApp.component:dtTransformation
 * @description
 * # dtTransformation
 */
angular.module('loopUiApp')
    .component('dtTransformation', {
        templateUrl: '../scripts/components/common/digitalTwins/dtTransformation/dtTransformation.html',
        bindings: {
            modelId: '<',
            transformations: '<',
            transformationsPromise: '<',
            onSave: '&',
            onDelete: '&',
            onRefresh: '&'
        },
        controller: function ($scope, $mdDialog, gettextCatalog, Commons) {
            var vm = this;

            vm.$onInit = function () {
                // Generic table setup
                vm.listSetup = {
                    sortField: 'Name',
                    showIndex: false,
                    editable: false,
                    removable: false,
                    limit: 10,
                    limitOptions: [10, 50, 100],
                    fields: [
                        {
                            name: 'Name',
                            column: 'Name',
                            link: true,
                            style: {'max-width': '400px', 'word-break': 'break-all'},
                            fieldAction: function (item) {
                                vm.editTransformation(null, item, false);
                            }
                        },
                        {
                            name: 'Schema',
                            column: 'Schema',
                            style: {'max-width': '400px', 'word-break': 'break-all'},
                            limit: 1024
                        },
                        {
                            name: 'Schema Type',
                            column: 'SchemaType',
                            style: {'width': '100px'},
                            transformation: function (item) {
                                return vm.schemaTypeMap[item.SchemaType] || item.SchemaType;
                            }
                        }
                    ]
                };

                vm.additionalActions = [
                    {
                        name: 'View/Edit',
                        icon: 'edit',
                        function: function (event, item) {
                            vm.editTransformation(event, item, false);
                        }
                    },
                    {
                        name: 'Delete',
                        icon: 'delete',
                        function: function (event, item) {
                            var _deleteFn = function () {
                                vm.transformations = vm.transformations.filter(function (transformation) {
                                    return transformation.ID !== item.ID;
                                });
                                vm.onDelete({
                                    event: event,
                                    transformation: item,
                                    transformations: vm.transformations
                                });
                            };

                            Commons.showConfirmationWarn(
                                gettextCatalog.getString('Remove Transformation'),
                                gettextCatalog.getString('Are you sure you want to remove transformation ' + item.Name + '?'),
                                gettextCatalog.getString('Remove'),
                                function () {
                                    _deleteFn(item);
                                },
                                gettextCatalog.getString('Cancel'),
                                null,
                                event);
                        }
                    }
                ];

                vm.filterActions = [{
                    label: 'Refresh',
                    icon: 'refresh',
                    buttonClick: vm.onRefresh
                }];

                // New transformation object
                vm.newTransformation = {
                    ID: null,
                    Name: null,
                    Schema: null,
                    ModelID: vm.modelId,
                    SchemaType: 'json',
                };
                
                // Decode schema type
                vm.schemaTypeMap = {
                    json: 'JSON',
                    jsonata: 'JSONata'
                };
            };

            /**
             * Open transformation editor
             * @param {Object} event - Mouse click event 
             * @param {Object} item - transformation object
             * @param {Boolean} isNew - is new transformation
             * @returns {void}
             */
            vm.editTransformation = function (event, item, isNew) {
                // Create an isolated scope to pass to the component
                var scope = angular.extend($scope.$new(true), {
                    transformation: item ? angular.copy(item) : vm.addServiceFields(vm.newTransformation),
                    transformations: vm.transformations,
                    isNew: isNew
                });
                $mdDialog.show({
                    template: '<md-dialog style="width:900px;">' +
                        '<dt-transformation-dialog transformation="transformation" transformations="transformations" is-new="isNew">' +
                        '</dt-transformation-dialog></md-dialog>',
                    parent: angular.element(document.body),
                    clickOutsideToClose: false,
                    preserveScope: true,
                    scope: scope,
                    skipHide: true
                })
                    .then(function (data) {
                        if (data) {
                            // Update transformation
                            var index = vm.transformations.findIndex(function (transformation) {
                                return transformation.ID === data.ID;
                            });
                            if (index >= 0) {
                                vm.transformations[index] = data;
                            } else {
                                vm.transformations.push(data);
                            }

                            vm.onSave({
                                transformation: data,
                                transformations: vm.transformations
                            });
                        }
                    });
            };

            /**
             * List filter callback
             *
             * @param {string} searchText    - Search string
             * @return {void}
             */
            vm.filter = function (searchText) {
                vm.searchText = searchText;
            };

            /**
             * Function for filtering list 
             * @param {Object} row - list item 
             * @returns {Boolean} - is item satisfies filter
             */
            vm.filterList = function (row) {
                if (!vm.searchText) {
                    return true;
                }
                return row.Name.toLowerCase().indexOf(vm.searchText.toLowerCase()) >= 0;
            };

            /**
             * Add service $isNew field to track new/existing items
             * @param {Object} item - transformation object
             * @returns 
             */
            vm.addServiceFields = function (item) {
                var _result = angular.copy(item);
                _result.ID = crypto.randomUUID();
                _result.$isNew = true;
                return _result;
            };
        }
    });
'use strict';

/**
 * @ngdoc Data access view
 * @name loopUiApp.component:dtDataAccess
 * @description
 * # dtDataAccess
 */
angular.module('loopUiApp')
    .component('dtDataAccess', {
        templateUrl: '../scripts/components/common/digitalTwins/dtDataAccess/dtDataAccess.html',
        bindings: {
            instance: '<',
        },
        controller: function () {
            var vm = this;

            /* // TODO: Remove dummy object for test
            vm.data = {
                Topic: 'Robot_for_conveyer',
                Interval: 5,
                Schema: ''
            }; */

            /**
             * ACE editor init function
             * @param {Object} editor - ACE editor object
             * @return {void}
             */
             vm.aceLoaded = function (editor) {
                editor.$blockScrolling = Infinity;
                editor.setTheme('ace/theme/material');
                editor.getSession().setMode('ace/mode/json');

                editor.setOptions({
                    useWorker: false,
                    wrap: true,
                    showGutter: true,
                    printMargin: false,
                    readOnly: true,
                });
            };
        }
    });
'use strict';

/**
 * @ngdoc Transformation dialog view
 * @name loopUiApp.component:dtTransformationDialog
 * @description
 * # dtTransformationDialog
 */
angular.module('loopUiApp')
    .component('dtTransformationDialog', {
        templateUrl: '../scripts/components/common/digitalTwins/dtTransformationDialog/dtTransformationDialog.html',
        bindings: {
            transformation: '<',
            transformations: '<',
            isNew: '<'
        },
        controller: function ($mdDialog, $timeout) {
            var vm = this;

            vm.$onInit = function () {
                // List of schema types
                vm.typeList = [{
                    code: 'json',
                    name: 'JSON'
                }, {
                    code: 'jsonata',
                    name: 'JSONata'
                }];

                // Set default schema type
                vm.transformation.SchemaType = vm.transformation.SchemaType || vm.typeList[0].code;
            };

            /**
             * ACE editor init function
             * @param {Object} editor - ACE editor object
             * @return {void}
             */
            vm.aceLoaded = function (editor) {
                editor.$blockScrolling = Infinity;
                editor.setTheme('ace/theme/material');
                editor.getSession().setMode('ace/mode/json');

                editor.setOptions({
                    useWorker: false,
                    wrap: true,
                    showGutter: true,
                    printMargin: false
                });
            };

            /**
             * Validate form on SchemaType change
             */
            vm.validate = function () {
                $timeout(function () {
                    vm.transformationForm.schemaField.$validate();
                }, 0);
            };

            /**
             * Prettify JSON schema
             */
            vm.prettifyJson = function () {
                try {
                    vm.transformation.Schema = JSON.stringify(JSON.parse(vm.transformation.Schema), null, '\t');
                } catch (e) {
                    return;
                }
            };

            /**
             * Check if transformation already exists
             * @param {Object} transformation - transformation name
             * @returns {void}
             */
            vm.validateTransformationName = function (transformation) {
                if (!angular.isArray(vm.transformations)) {
                    return;
                }
                var isTransformationExist = vm.transformations.some(function (item) {
                    return item.Name.toUpperCase() === transformation.Name.toUpperCase() &&
                        item.ID !== transformation.ID;
                });

                vm.transformationForm.nameField.$setValidity('exists', !isTransformationExist);
            };

            /**
             * Save value
             * @returns {void}
             */
            vm.save = function () {
                if (vm.transformation.SchemaType === 'json') {
                    // remove extra spaces from transformation schema
                    vm.transformation.Schema = JSON.stringify(JSON.parse(vm.transformation.Schema));
                }
                $mdDialog.hide(vm.transformation);
            };

            /**
             * Cancel dialog button
             * @returns {void}
             */
            vm.cancel = function () {
                $mdDialog.cancel();
            };
        }
    });
'use strict';

/**
 * @ngdoc Upload/download model to/from Edge devices
 * @name loopUiApp.component:dtDeployModelDialog
 * @description
 * # dtDeployModelDialog
 *
 * Component represents Tag list
 */
angular.module('loopUiApp')
    .component('dtDeployModelDialog', {
        templateUrl: '../scripts/components/common/digitalTwins/dtDeployModelDialog/dtDeployModelDialog.html',
        bindings: {
            model: '<'
        },
        controller: function ($q, $stateParams, $mdDialog, gettextCatalog, ServiceAsyncTask, Service, Commons) {
            var vm = this;

            vm.$onInit = function () {
                vm.companyName = $stateParams.companyName;

                // Flag that model is deploying
                vm.isDeploying = false;

                // List of available models
                vm.modelList = [];
                // List of Edge devices enriched with deployed models
                vm.deviceModelList = [];
                // Map of devices that are not allowed to deploy models
                vm.disabledDevices = {};
                // Map of model deployed on device
                vm.deviceModelMap = {};

                // Selected target devices
                vm.selectedDevices = [];
                // Selected models
                vm.selectedModels = vm.model ? [vm.model] : [];
                // Intersection of selected models and models deployed on devices
                vm.modelsIntersection = [];

                // Wizard steps
                vm.wizardSetup = {
                    wizardName: null,
                    steps: [
                        {
                            code: 'MODELS',
                            name: 'Models',
                            description: gettextCatalog.getString('Select Models'),
                            componentId: 'model_list_id.html'
                        },
                        {
                            code: 'DEVICES',
                            name: 'Edge Devices',
                            description: gettextCatalog.getString('Select Edge devices'),
                            componentId: 'device_list_id.html'
                        },
                        {
                            code: 'PREVIEW',
                            name: 'Preview',
                            description: gettextCatalog.getString('Preview'),
                            componentId: 'preview_id.html'
                        },
                        {
                            code: 'RESULT',
                            name: 'Result',
                            description: gettextCatalog.getString('Result'),
                            componentId: 'result_id.html'
                        }]
                };

                // Wizard current step
                vm.currentStep = 0;
                vm.currentStepCode = vm.wizardSetup.steps[0].code;

                // Model generic table setup
                vm.modelListSetup = {
                    sortField: 'name',
                    rowSelection: true,
                    multipleSelection: true,
                    showIndex: false,
                    editable: false,
                    removable: false,
                    limit: 10,
                    keyName: 'ID',
                    limitOptions: [10, 50, 100],
                    fields: [
                        {
                            name: 'Model',
                            column: 'Name',
                            transformation: function (item) {
                                return item.Name + (typeof item.Version === 'number' ? ' (v.' + item.Version + ')' : '');
                            }
                        },
                        {
                            name: 'Description',
                            column: 'Description'
                        }
                    ]
                };

                // Device generic table setup
                vm.deviceModelListSetup = {
                    sortField: 'deviceId',
                    rowSelection: true,
                    multipleSelection: true,
                    showIndex: false,
                    editable: false,
                    removable: false,
                    limit: 10,
                    keyName: 'deviceId',
                    selectionDisabledFunction: function (item) {
                        // Allow selection only for devices with DT capability
                        return vm.disabledDevices[item.deviceId];
                    },
                    limitOptions: [10, 50, 100],
                    fields: [
                        {
                            name: 'Edge Device',
                            column: 'prettyName',
                            style: '{"width": "25%"}',
                        },
                        {
                            name: 'Models on Edge Device',
                            column: 'model',
                            transformation: function (item) {
                                return vm.deviceModelMap[item.deviceId] ?
                                    Object.keys(vm.deviceModelMap[item.deviceId])
                                        .map(function (id) {
                                            return vm.deviceModelMap[item.deviceId][id].name + ' (v.' + vm.deviceModelMap[item.deviceId][id].version + ')';
                                        }).join(', ') : '';
                            }
                        },
                        {
                            name: 'Info',
                            column: 'deviceId',
                            style: '{"width": "25%"}',
                            transformation: function (item) {
                                return vm.disabledDevices[item.deviceId] || '';
                            }
                        }
                    ]
                };

                // Result generic table setup
                vm.resultListSetup = {
                    sortField: 'name',
                    showIndex: false,
                    editable: false,
                    removable: false,
                    limit: 10,
                    limitOptions: [10, 50, 100],
                    fields: [
                        {
                            name: 'Edge Device Id',
                            column: 'deviceId',
                            limit: 5,
                            style: '{"width": "50px"}',
                            transformation: function (item) {
                                return item.deviceId ?
                                    item.deviceId.substring(0, 5) : '-';
                            }
                        },
                        {
                            name: 'Friendly Name',
                            column: 'devicePrettyName',
                            transformation: function (item) {
                                return item.devicePrettyName || '';
                            }
                        },
                        {
                            name: 'Message',
                            transformation: function (item) {
                                return item.msg || 'No message';
                            }
                        },
                        {
                            name: 'Status',
                            label: function (item) {
                                return item.status;
                            },
                            iconButton: true,
                            style: '{"width": "50px"}',
                            iconName: function (item) {
                                switch (item.status) {
                                    case 'NEW':
                                        return 'schedule';
                                    case 'ERROR':
                                        return 'highlight_off';
                                    case 'SUCCESS':
                                        return 'check_circle_outline';
                                    default:
                                        return 'help_outline';
                                }
                            }
                        }
                    ]
                };

                // Summary pagination setup
                vm.summaryPagination = {
                    limit: 10,
                    page: 1,
                    limitOptions: [10, 50, 100]
                };

                // Model list actions
                vm.modelListFilterActions = [{
                    label: 'Refresh',
                    icon: 'refresh',
                    buttonClick: vm.refreshModelList
                }];

                // Device list actions
                vm.deviceListFilterActions = [{
                    label: 'Refresh',
                    icon: 'refresh',
                    buttonClick: vm.refreshDeviceModelList
                }];

                // Refresh model list
                vm.refreshModelList();

                // Refresh device list with the list of installed models
                vm.refreshDeviceModelList();
            };

            /**
             * Load model list
             * @returns {void}
             */
            vm.refreshModelList = function () {
                vm.modelListPromise = Service.api.dtModelList({
                    actionExt: vm.companyName
                }).$promise;
                vm.modelListPromise
                    .then(function (data) {
                        vm.modelList = data;
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Get models failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error dtModelList:' + JSON.stringify(reason));
                    });
            };

            /**
             * 1. Load Edge device list for the current company
             * 2. Load deployed models for the current company
             * 3. Combine both lists
             */
            vm.refreshDeviceModelList = function () {
                // Load device list promise
                var _deviceListPromise = Service.api.deviceList({
                    companyName: vm.companyName,
                    deviceType: 'LOOPEDGE',
                    requestedPage: 0,
                    limit: 1000, // TODO: remove hardcoded limit
                    onlineOnly: true,
                }).$promise;

                // Load deployed models promise
                var _deployedModelsPromise = Service.api.dtDeployedModels({
                    companyName: vm.companyName
                }).$promise;

                vm.deviceModelListPromise = $q.all([_deviceListPromise, _deployedModelsPromise]);

                // Get device list (data[0]) and deployed models (data[1])
                vm.deviceModelListPromise
                    .then(function (data) {
                        // Current list of devices
                        vm.deviceModelList = data[0].elements;
                        // Find disabled devices (no license for DT)
                        vm.disabledDevices = vm.deviceModelList.reduce(function (acc, device) {
                            // Check if device is disabled
                            var _capability = Commons.checkFeatureCapability(device.capabilities, 'DIGITAL_TWINS');
                            if (_capability && !_capability.available) {
                                acc[device.deviceId] = _capability.unavailabilityReason;
                            }
                            return acc;
                        }, {});
                        // List of models per Edge Device
                        vm.deviceModelMap = data[1].reduce(function (acc, item) {
                            if (!acc[item.deviceId]) {
                                acc[item.deviceId] = {};
                            }
                            acc[item.deviceId][item.id] = item;
                            return acc;
                        }, {});
                    });
            };

            /**
             * Deploy models to Edge devices
             */
            vm.deployModels = function () {
                vm.isDeploying = true;
                // Open result tab
                vm.next();

                // Selected model IDs
                var modelIds = vm.selectedModels.map(function (item) {
                    return item.ID;
                });

                vm.launchResult = vm.initLaunchResultList(vm.selectedDevices, 'Deploying models...', 'NEW');

                ServiceAsyncTask.createTaskAndWait(
                    ServiceAsyncTask.taskTypes.DIGITAL_TWINS_MODEL_DEPLOY.code, // Task type
                    ServiceAsyncTask.taskTypes.DIGITAL_TWINS_MODEL_DEPLOY.subtaskTypes, // Subtask types
                    '', // Task description 
                    vm.selectedDevices,
                    { modelIds: modelIds }, // Task params
                    false // Wait device for online
                )
                    .then(function (task) {
                        if (!task || !task.id) {
                            return;
                        }
                        // Get subtasks for current task
                        return Service.api.asyncSubtaskList({
                            action: task.id
                        }).$promise;
                    })
                    .then(function (data) {
                        // If no subtasks, then show error
                        if (!data || !data.length) {
                            vm.initLaunchResultList(vm.selectedDevices, '', 'ERROR');
                            return;
                        }
                        // Get launch results from subtasks
                        vm.launchResult = data.map(function (item) {
                            return {
                                deviceId: item.deviceId,
                                devicePrettyName: item.devicePrettyName,
                                msg: item.msg || 'Model deployed successfully',
                                status: item.status
                            };
                        });
                    })
                    .catch(function (reason) {
                        if (!reason) { // If not reason provided, then task was canceled
                            return;
                        }
                        console.log('Failed to deploy DT model:' + JSON.stringify(reason));
                        var messageObject = Commons.createErrorObject(reason, 'Failed to deploy DT model');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                    })
                    .finally(function () {
                        vm.isDeploying = false;
                    });
            };

            /**
             * Transform response array to message string
             * @param {Object} response - Push API response object 
             * @returns 
             */
            vm.getResponseMessage = function (response) {
                if (!response || !angular.isArray(response.responseItems)) {
                    return;
                }
                return response.responseItems.map(function (item) {
                    return (item.message || 'Model deployed successfully') + ' (modelId=' + item.modelId + ')';
                }).join('. ');
            };

            /**
             * Check if response has errors
             * @param {Object} response - Push API response object
             * @returns 
             */
            vm.checkResponseForErrors = function (response) {
                if (!response || !angular.isArray(response.responseItems)) {
                    return false;
                }
                return response.responseItems.some(function (item) {
                    return !item.success;
                });
            };

            /**
             * Init launch result list
             * @param {Array} deviceList - selected device list for launch 
             * @param {String} msg - state message 
             * @param {String} status - application status
             * @returns {Array} empty launch list
             */
            vm.initLaunchResultList = function (deviceList, msg, status) {
                if (!deviceList || !angular.isArray(deviceList)) {
                    return [];
                }
                return deviceList.map(function (item) {
                    return {
                        deviceId: item.deviceId,
                        devicePrettyName: item.devicePrettyName || item.prettyName,
                        msg: msg,
                        status: status
                    };
                });
            };

            /**
             * Go to previous step
             *
             * @returns {void}
             */
            vm.previous = function () {
                if (vm.currentStep === 0) {
                    return;
                }
                vm.currentStep--;
                vm.currentStepCode = vm.wizardSetup.steps[vm.currentStep].code;
            };

            /**
             * Go to the next step
             *
             * @returns {void}
             */
            vm.next = function () {
                if (vm.currentStep === vm.wizardSetup.steps.length - 1) {
                    return;
                }
                vm.currentStep++;
                vm.currentStepCode = vm.wizardSetup.steps[vm.currentStep].code;
            };


            /**
             * Check if is first step of wizard
             * @returns {boolean} - True if this is first step
             */
            vm.isFirstStep = function () {
                return vm.currentStep === 0;
            };

            /**
             * Check if is last step of wizard
             *
             * @returns {boolean}           - True if this is last step
             */
            vm.isLastStep = function () {
                return vm.currentStep === vm.wizardSetup.steps.length - 1;
            };

            /**
             * Show/hide deploy button
             * @returns {boolean} - True if this is preview step
             */
            vm.isPreviewStep = function () {
                return vm.currentStepCode === 'PREVIEW';
            };

            /**
             * Check if next master step is disabled
             * @return {Boolean} - if next step disabled
             */
            vm.isNextDisabled = function () {
                return (vm.currentStep === 0 && vm.selectedModels.length === 0) ||
                    (vm.currentStep === 1 && vm.selectedDevices.length === 0);
            };

            /**
             * Handle models select
             * @param {Array} items - selected catalog items
             */
            vm.onModelSelect = function (items) {
                vm.selectedModels = items;
                vm.modelsIntersection = vm.calcSelectedModelIntersection();
            };

            /**
             * Handle devices select
             * @param {Array} items - selected device items
             */
            vm.onEdgeDeviceSelect = function (items) {
                vm.selectedDevices = items;
                vm.modelsIntersection = vm.calcSelectedModelIntersection();
            };

            /**
             * Calculate intersection of selected models and models deployed devices
             * @returns {Array} - list of selected devices with deployed models
             */
            vm.calcSelectedModelIntersection = function () {
                if (vm.selectedModels.length === 0 ||
                    vm.selectedDevices.length === 0) {
                    return [];
                }
                var _result = [];

                // Create a combined list of selected devices with selected models
                vm.selectedDevices.forEach(function (device) {
                    vm.selectedModels.forEach(function (model) {
                        // Find if there is deployed model on device among selected models
                        var _currentModel = vm.deviceModelMap[device.deviceId] && vm.deviceModelMap[device.deviceId][model.ID] ?
                            vm.deviceModelMap[device.deviceId][model.ID] : null;
                        _result.push({
                            prettyName: device.prettyName,
                            newModel: model,
                            currentModel: _currentModel
                        });
                    });
                });

                return _result;
            };

            /**
             * Hides the dialog
             * @returns {void}
             */
            vm.hide = function () {
                $mdDialog.hide();
            };

            /**
             * Cancel dialog button
             * @returns {void}
             */
            vm.cancel = function () {
                $mdDialog.cancel();
            };
        }
    });
'use strict';

/**
 * @ngdoc Upgrade Models dialog
 * @name loopUiApp.component:dtUpgradeModelsDialog
 * @description
 * # dtUpgradeModelsDialog
 *
 * Component represents Digital Twins Model Tags Hierarchy
 */
angular.module('loopUiApp')
    .component('dtUpgradeModelsDialog', {
        templateUrl: '../scripts/components/common/digitalTwins/dtUpgradeModelsDialog/dtUpgradeModelsDialog.html',
        bindings: {
            deviceId: '<', // Device ID
            modelId: '<', // Model ID
            type: '<' // Type of the dialog: MODEL or INSTANCE
        },
        controller: function ($scope, $q, $stateParams, $mdDialog, appConfig, ServiceAsyncTask, Service, Commons) {
            var vm = this;
            // Map of devices that are not allowed to deploy models
            vm.disabledDevices = {};
            // Intersection of selected models and models deployed on devices
            vm.modelsIntersection = [];
            // Original list of models intersection before filtering
            vm.modelsIntersectionOrig = [];
            // List of selected pares of model and device
            vm.selectedModels = [];
            // Default sort field
            vm.sortField = 'prettyName';
            // Filters status
            vm.filterStatus = [true];
            vm.filterModelName = vm.modelId ? [vm.modelId] : null;
            vm.filterPrettyName = vm.deviceId ? [vm.deviceId] : null;

            vm.$onInit = function () {
                vm.companyName = $stateParams.companyName;
                vm.productName = appConfig.__env.productName;

                // Settings for table filters
                vm.filterObj = {
                    online: {
                        type: 'select',
                        multiple: false,
                        name: 'Edge Device Status',
                        selectedValue: [true],
                        defaultValue: null,
                        values: [{
                            code: true,
                            name: 'Online'
                        },
                        {
                            code: false,
                            name: 'Offline'
                        }],
                        visible: true,
                        action: function (value) {
                            vm.filterStatus = value;
                            vm.modelsIntersection = vm.filterByCriterias();
                        }
                    },
                    currentModelName: {
                        type: 'select',
                        multiple: true,
                        name: 'Model Name',
                        selectedValue: vm.modelId ? [vm.modelId] : null,
                        defaultValue: null,
                        values: [],
                        visible: vm.modelId ? true : false,
                        action: function (value) {
                            vm.filterModelName = value;
                            vm.modelsIntersection = vm.filterByCriterias();
                        }
                    },
                    prettyName: {
                        type: 'select',
                        multiple: true,
                        name: 'Edge Device',
                        selectedValue: vm.deviceId ? [vm.deviceId] : null,
                        defaultValue: null,
                        values: [],
                        visible: vm.deviceId ? true : false,
                        action: function (value) {
                            vm.filterPrettyName = value;
                            vm.modelsIntersection = vm.filterByCriterias();
                        }
                    },
                };

                vm.itemsPagination = {
                    limit: 10,
                    page: 1,
                    limitOptions: [10, 50, 100]
                };

                // Load models intersection from models or instance
                if (vm.type === 'MODEL') {
                    vm.getModelsIntersection(vm.type);
                } else if (vm.type === 'INSTANCE') {
                    vm.getInstanceIntersection();
                } else {
                    console.log('Unknown type of the dialog: ' + vm.type);
                }
            };

            /**
             * Calculate intersection of models and models deployed devices
             * @returns {void}
             */
            vm.getModelsIntersection = function () {
                // Reset intersection list
                vm.modelsIntersection = [];
                vm.modelsIntersectionOrig = [];

                // Load deployed models promise
                var _deployedModelsPromise = Service.api.dtDeployedModels({
                    companyName: vm.companyName
                }).$promise;

                var _modelListPromise = Service.api.dtModelList({
                    actionExt: vm.companyName
                }).$promise;

                vm.deviceModelListPromise = $q.all([_deployedModelsPromise, _modelListPromise]);

                // Get device list (data[0]) and deployed models (data[1])
                vm.deviceModelListPromise
                    .then(function (data) {
                        // List of deployed models
                        var _deployedModelList = data[0];
                        // List of all models
                        var _modelList = data[1] ? data[1] : [];
                        // Map of all models
                        var _modelMap = _modelList.reduce(function (acc, item) {
                            acc[item.ID] = item;
                            return acc;
                        }, {});

                        // Return if no models or devices
                        if (_deployedModelList.length === 0 ||
                            _modelList.length === 0) {
                            return;
                        }

                        var _result = [];
                        _deployedModelList.forEach(function (deployedModel) {
                            var _newModel = _modelMap[deployedModel.id];
                            if (!_newModel || _newModel && _newModel.Version > deployedModel.version) {
                                _result.push({
                                    deviceId: deployedModel.deviceId,
                                    prettyName: deployedModel.devicePrettyName,
                                    modelId: deployedModel.id,
                                    newModelName: _newModel ? _newModel.Name : null,
                                    newModelVersion: _newModel ? _newModel.Version : null,
                                    currentModelName: deployedModel.name,
                                    currentModelVersion: deployedModel.version,
                                    instanceId: null,
                                    instanceName: null,
                                    online: deployedModel.online,
                                    modifiable: deployedModel.modifiable
                                });
                            }
                        });
                        vm.modelsIntersectionOrig = _result;
                        // Fill filter options
                        vm.fillFilterOptions(_result);

                        vm.modelsIntersection = vm.filterByCriterias();
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Failed to get the list of models deployed on Edge devices');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error deployed models or models:' + JSON.stringify(reason));
                    });
            };

            /**
             * Calculate intersection of models and instances
             * @returns {void}
             */
            vm.getInstanceIntersection = function () {
                // Reset intersection list
                vm.modelsIntersection = [];
                vm.modelsIntersectionOrig = [];

                vm.deviceModelListPromise = Service.api.dtInstanceList({
                    companyName: vm.companyName
                }).$promise;

                // Get device list (data[0]) and deployed models (data[1])
                vm.deviceModelListPromise
                    .then(function (data) {
                        // Return if no models or devices
                        if (data.length === 0) {
                            return;
                        }

                        vm.modelsIntersectionOrig = data
                            // Return only instances that have old model
                            .filter(function (item) {
                                return item.ModelVersion > item.Version;
                            })
                            .map(function (instance) {
                                return {
                                    deviceId: instance.DeviceID,
                                    prettyName: instance.DevicePrettyName,
                                    modelId: instance.ModelID,
                                    newModelName: instance.ModelName,
                                    newModelVersion: instance.ModelVersion,
                                    currentModelName: instance.ModelName,
                                    currentModelVersion: instance.Version,
                                    instanceId: instance.ID,
                                    instanceName: instance.Name,
                                    online: instance.Online,
                                    modifiable: instance.modifiable
                                };
                            });

                        // Fill filter options
                        vm.fillFilterOptions(vm.modelsIntersectionOrig);

                        vm.modelsIntersection = vm.filterByCriterias();
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Failed to get the list of instance');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error instance list or model list:' + JSON.stringify(reason));
                    });
            };

            /**
             * Filter models by criterias
             * @returns {Array} - filtered list
             */
            vm.filterByCriterias = function () {
                return vm.modelsIntersectionOrig.filter(vm.filterFn);
            };

            /**
             * Run upgrade process
             * @param {string} type - type of the dialog (MODEL or INSTANCE) 
             */
            vm.upgrade = function () {
                if (vm.type === 'MODEL') {
                    vm.upgradeModels();
                } else if (vm.type === 'INSTANCE') {
                    vm.upgradeInstances();
                }
                else {
                    console.log('Unknown type of the dialog: ' + vm.type);
                }
            };

            /**
             * Upgrade models to Edge devices
             */
            vm.upgradeModels = function () {
                if (vm.selectedModels.length === 0) {
                    return;
                }
                vm.isUpgrading = true;

                // List of models for each device
                var _devices = vm.selectedModels.reduce(function (acc, item) {
                    if (acc[item.deviceId]) {
                        acc[item.deviceId].push(item.modelId);
                    } else {
                        acc[item.deviceId] = [item.modelId];
                    }
                    return acc;
                }, {});

                var _promiseList = Object.keys(_devices).map(function (deviceId) {
                    return ServiceAsyncTask.createTaskAndWait(
                        ServiceAsyncTask.taskTypes.DIGITAL_TWINS_MODEL_DEPLOY.code, // Task type
                        ServiceAsyncTask.taskTypes.DIGITAL_TWINS_MODEL_DEPLOY.subtaskTypes, // Subtask types
                        '', // Task description 
                        [{ deviceId: deviceId }], // Devices
                        { modelIds: _devices[deviceId] }, // Task params
                        false // Wait device for online
                    );
                });

                $q.all(_promiseList)
                    .then(function () {
                        vm.hide();
                    })
                    .catch(function (reason) {
                        console.log('Failed to deploy models:' + JSON.stringify(reason));
                        var messageObject = Commons.createErrorObject(reason, 'Failed to deploy DT model');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                    })
                    .finally(function () {
                        vm.isUpgrading = false;
                    });
            };

            /**
             * Upgrade models of the instances
             */
            vm.upgradeInstances = function () {
                if (vm.selectedModels.length === 0) {
                    return;
                }
                vm.isUpgrading = true;

                // List of models for each device
                var _devices = vm.selectedModels.reduce(function (acc, item) {
                    if (acc[item.deviceId]) {
                        acc[item.deviceId].push(item.instanceId);
                    } else {
                        acc[item.deviceId] = [item.instanceId];
                    }
                    return acc;
                }, {});

                var _promiseList = Object.keys(_devices).map(function (deviceId) {
                    return ServiceAsyncTask.createTaskAndWait(
                        ServiceAsyncTask.taskTypes.DIGITAL_TWINS_INSTANCES_UPGRADE.code, // Task type
                        ServiceAsyncTask.taskTypes.DIGITAL_TWINS_INSTANCES_UPGRADE.subtaskTypes, // Subtask types
                        '', // Task description 
                        [{ deviceId: deviceId }], // Devices
                        { instanceIds: _devices[deviceId] }, // Task params
                        false // Wait device for online
                    );
                });

                $q.all(_promiseList)
                    .then(function () {
                        vm.hide();
                    })
                    .catch(function (reason) {
                        console.log('Failed to deploy models:' + JSON.stringify(reason));
                        var messageObject = Commons.createErrorObject(reason, 'Failed to deploy DT model');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                    })
                    .finally(function () {
                        vm.isUpgrading = false;
                    });
            };

            /**
             * Filter function for the list of models
             * @param {Object} item - list item
             * @returns 
             */
            vm.filterFn = function (item) {
                if (vm.filterStatus === null && vm.filterModelName === null && vm.filterPrettyName === null) {
                    return true;
                }
                return (vm.filterModelName === null || vm.filterModelName && vm.filterModelName.length > 0 && vm.filterModelName.indexOf(item.modelId) > -1) &&
                    (vm.filterPrettyName === null || vm.filterPrettyName && vm.filterPrettyName.length > 0 && vm.filterPrettyName.indexOf(item.deviceId) > -1) &&
                    (vm.filterStatus === null || vm.filterStatus && vm.filterStatus.length > 0 && vm.filterStatus[0] === item.online);
            };

            /**
             * Handle filter open event
             * @param {Event} event - mouse click event 
             * @param {String} field - name of the field that's filtered
             */
            vm.onFilter = function (event, field) {
                // Position for filter menu
                var _leftPosition = event.clientX - 90 + 'px';
                var _topPosition = event.clientY + 10 + 'px';
                var scope = angular.extend($scope.$new(true), {
                    leftPosition: _leftPosition,
                    topPosition: _topPosition,
                    filterObject: vm.filterObj[field]
                });
                $mdDialog.show({
                    template: '<md-dialog class="md-table-filter" ng-style="{\'left\': leftPosition, \'top\': topPosition}" aria-label="Filter menu">' +
                        '<filter-menu filter-object="filterObject"></filter-menu>' +
                        '</md-dialog>',
                    clickOutsideToClose: true,
                    skipHide: true,
                    scope: scope,
                    hasBackdrop: false,
                })
                    .then(function (result) {
                        vm.itemsPagination.page = 1;
                        if (result.use === true) {
                            vm.filterApplyHandler(field, result.value);
                        } else {
                            vm.filterResetHandler(field);
                        }
                        vm.modelsIntersection = vm.filterByCriterias();
                    });
            };

            /**
             * Handle filter apply
             * @param {string} field - field name
             * @param {any} value - value from the filter
             */
            vm.filterApplyHandler = function (field, value) {
                vm.filterObj[field].visible = true;
                vm.filterObj[field].selectedValue = value;
                vm.filterObj[field].action(value);
            };

            /**
             * On filter reset: set value to default and hide filter icon
             * @param {string} field - field name
             */
            vm.filterResetHandler = function (field) {
                vm.filterObj[field].visible = false;
                vm.filterObj[field].selectedValue = angular.copy(vm.filterObj[field].defaultValue);
                vm.filterObj[field].action(vm.filterObj[field].defaultValue);
            };


            /**
             * Get options for filters
             * @param {Array} list - list of models 
             */
            vm.fillFilterOptions = function (list) {
                if (!list || list.length === 0) {
                    return;
                }

                // Create unique array of objects by key
                var _getUniqueArray = function (array, key) {
                    // Create an empty object to track unique keys
                    var uniqueTracker = {};
                    // Use filter to return a new array of unique objects
                    return array.filter(function (item) {
                        // Get the value of the key to track
                        var value = item[key];
                        // Check if the value is already in the uniqueTracker
                        if (uniqueTracker.hasOwnProperty(value)) {
                            return false; // Exclude duplicate
                        } else {
                            uniqueTracker[value] = true; // Mark as seen
                            return true; // Include in the result
                        }
                    }).sort();
                };
                // Fill filters options
                vm.filterObj.currentModelName.values = _getUniqueArray(list, 'modelId')
                    .map(function (item) {
                        return {
                            code: item.modelId,
                            name: item.currentModelName
                        };
                    });

                vm.filterObj.prettyName.values = _getUniqueArray(list, 'deviceId')
                    .map(function (item) {
                        return {
                            code: item.deviceId,
                            name: item.prettyName
                        };
                    });
            };

            /**
             * Reset all filters
             */
            vm.resetFilters = function () {
                vm.filterStatus = null;
                vm.filterModelName = null;
                vm.filterPrettyName = null;
                Object.keys(vm.filterObj).forEach(function (key) {
                    vm.filterObj[key].selectedValue = angular.copy(vm.filterObj[key].defaultValue);
                    vm.filterObj[key].visible = false;
                });
                vm.itemsPagination.page = 1;
                vm.modelsIntersection = vm.filterByCriterias();
            };

            /**
             * Is data available after load
             * @return {boolean} - data exists flag
             */
            vm.showNoData = function () {
                return !vm.modelsIntersection || vm.modelsIntersection.length === 0 &&
                    !(vm.deviceModelListPromise && vm.deviceModelListPromise.$$state && vm.deviceModelListPromise.$$state.status === 0);
            };

            /**
             * Check if filter is set
             * @return {boolean} - filter set flag
             */
            vm.isFilterSet = function () {
                return vm.filterStatus !== null || vm.filterModelName !== null || vm.filterPrettyName !== null;
            };

            /**
             * Check if upgrade button is disabled
             * @param {Object} item - item instance/model intersection object
             */
            vm.isUpgradeDisabled = function (item) {
                return !item.online || !item.modifiable;
            };

            /**
             * Hides the dialog
             * @returns {void}
             */
            vm.hide = function () {
                $mdDialog.hide();
            };

            /**
             * Cancel dialog button
             * @return {undefined}
             */
            vm.cancel = function () {
                $mdDialog.cancel();
            };
        }
    });
'use strict';

/**
 * @ngdoc Digital Twins Tree view. Dialog for editing node (folder)
 * @name loopUiApp.component:dtEditFolderDialog
 * @description
 * # dtEditFolderDialog
 */
angular.module('loopUiApp')
    .component('dtEditFolderDialog', {
        templateUrl: '../scripts/components/common/digitalTwins/dtEditFolderDialog/dtEditFolderDialog.html',
        bindings: {
            nodeName: '<',
            isNew: '<'
        },
        controller: function ($timeout, $mdDialog) {
            var vm = this;

            vm.$onInit = function () {
                // TODO: Can't find the way to set focus on input field
                $timeout(function () {
                    vm.isFocus = true; 
                }, 500);
            };

            /**
             * Hides the dialog
             * @returns {void}
             */
             vm.hide = function () {
                $mdDialog.hide(vm.nodeName);
            };

            /**
             * Cancel dialog button
             * @return {undefined}
             */
            vm.cancel = function () {
                $mdDialog.cancel();
            };
        }
    });
'use strict';

/**
 * @ngdoc Digital Twins Tree view. Select attributes to add to the node
 * @name loopUiApp.component:dtSelectAttributesDialog
 * @description
 * # dtSelectAttributesDialog
 */
angular.module('loopUiApp')
    .component('dtSelectAttributesDialog', {
        templateUrl: '../scripts/components/common/digitalTwins/dtSelectAttributesDialog/dtSelectAttributesDialog.html',
        bindings: {
            staticAttributes: '<',
            dynamicAttributes: '<',
        },
        controller: function ($timeout, $mdDialog) {
            var vm = this;
            // Filter value
            vm.searchString = null;

            vm.$onInit = function () {
                vm.allAttributes = vm.dynamicAttributes.concat(vm.staticAttributes);

                $timeout(function () {
                    vm.isFocus = true; 
                }, 500);
            };

            /**
             * Select attribute from list and close dialog
             * @param {Object} attribute - attribute to add to the node
             */
            vm.selectAttribute = function (attribute) {
                $mdDialog.hide(attribute);
            };

            /**
             * Filter function for attributes list
             * @param {Object} attr - attribute object to check 
             * @returns 
             */
            vm.filterFn = function (attr) {
                return vm.searchString ? (attr.Name || attr.Key).toLowerCase().indexOf(vm.searchString.toLowerCase()) >= 0 : true;
            };
        }
    });
'use strict';

/**
 * @ngdoc component
 * @name loopUiApp.component:stepper
 * @description
 * # stepper
 *
 */
angular.module('loopUiApp')
    .component('stepper', {
        templateUrl: '../scripts/components/common/stepper/stepper.html',
        bindings: {
            wizardSetup: '<',
            currentStep: '<',
            onStepSelect: '&'
        },
        controller: function () {
            var vm = this;

            vm.$onInit = function () {
            };

            /**
             * Get step name by step number.
             *
             * @param {number} step             - Step number
             * @returns {string}                - Step name
             */
            vm.stepName = function (step) {
                return vm.wizardSetup.steps[step].name;
            };

            /**
             * Determine if the step number active.
             *
             * @param {number} step             - Step number
             * @returns {boolean}               - Return true if step is current step
             */
            vm.stepActive = function (step) {
                return vm.currentStep === step;
            };

            /**
             * Determine if the step is a last step.
             *
             * @param {number} step             - Step number
             * @returns {boolean}               - Return true if the step is a last
             */
            vm.stepLast = function (step) {
                return step === vm.wizardSetup.steps.length - 1;
            };

            /**
             * Select step
             *
             * @param {number} step             - Step number
             * @returns {void}
             */
            vm.selectActiveStep = function (step) {
                vm.onStepSelect({ step: step});
            };
        }
    });

'use strict';

/**
 * @ngdoc component
 * @name loopUiApp.component:jobStepper
 * @description
 * # jobStepper
 *
 */
angular.module('loopUiApp')
    .component('jobStepper', {
        templateUrl: '../scripts/components/common/jobStepper/jobStepper.html',
        bindings: {
            stages: '<',
            onMenuOpen: '&'
        },
        controller: function (gettextCatalog, Commons) {
            var vm = this;

            /**
             * Return status icon representation
             * @param {string} status - status name
             * @returns {string} - material icon name
             */
            vm.stepIcon = function (status) {
                switch (status) {
                case 'RECEIVED':
                    return 'arrow_circle_right';
                case 'NEW':
                    return 'pause_circle_outline';
                case 'IN_PROGRESS':
                    return 'schedule';
                case 'ERROR':
                    return 'highlight_off';
                case 'DONE':
                    return 'check_circle_outline';
                case 'REJECTED':
                    return 'block';
                case 'SKIPPED':
                    return 'redo';
                case 'ABORTED':
                    return 'power_settings_new';
                case 'DEACTIVATED':
                    return 'power_settings_new';
                default:
                    return 'help_outline';
                }
            };

            /**
             * Set stepper CSS class
             * @param {string} status - status name
             * @returns {string} - class name
             */
            vm.stepClass = function (status) {
                var _class_name = 'job-stepper__icon';
                switch (status) {
                case 'RECEIVED':
                    _class_name += '-waiting';
                    break;
                case 'IN_PROGRESS':
                    _class_name += '-active';
                    break;
                case 'ERROR':
                    _class_name += '-error';
                    break;
                case 'DONE':
                    _class_name += '-done';
                    break;
                case 'REJECTED':
                    _class_name += '-rejected';
                    break;
                case 'DEACTIVATED':
                    _class_name += '-deactivated';
                    break;
                case 'ABORTED':
                    _class_name += '-error';
                    break;
                default:
                    _class_name = '';
                    break;
                }
                return _class_name;
            };

            /**
             *
             * @param {*} $mdOpenMenu - Menu instance
             * @param {*} ev - Event
             * @returns {void}
             */
            vm.openMenu = function ($mdOpenMenu, ev) {
                $mdOpenMenu(ev);
                vm.onMenuOpen();
            };

            /**
             * Show error details
             * @param {Object} step - step object
             * @return {void}
             */
            vm.openDetails = function (step) {
                var _statusClass = step.stepStatus === 'ERROR' ? 'job-stepper__icon-error' : '';
                Commons.showConfirmation(
                    gettextCatalog.getString('Activation Stage Details'),
                    '<strong>Stage: </strong>' + step.stageName + '<br>' +
                    '<strong>Step: </strong>' + step.stepName + '<br>' +
                    '<strong>Status: </strong><span class="' + _statusClass + '">' + step.stepStatus + '</span><br>' +
                    '<strong>Message: </strong>' + Commons.stripHtmlTags(step.message) + '<br>',
                    gettextCatalog.getString('OK'),
                    null,
                    null,
                    null,
                    event
                );
            };
        }
    });
'use strict';
/**
 * @ngdoc component
 * @name loopUiApp.component:statusDisplay
 * @description
 * # statusDisplay
 */
angular.module('loopUiApp')
    .component('statusDisplay', {
        bindings: {
            positive: '@',
            statusText: '@'
        },
        templateUrl: '../scripts/components/common/statusDisplay/statusDisplay.html',
        controller: function () {
            var vm = this;

            vm.$onChanges = function () {
                if (!vm.statusText) {
                    vm.message = vm.positive ? 'Enabled' : 'Disabled';
                }
                vm.message = vm.statusText;
            };
        }
    });
'use strict';

/**
 * @ngdoc component
 * @name loopUiApp.component:emailChipsInput
 * @description
 * # emailChipsInput
 *
 */
angular.module('loopUiApp')
    .component('emailChipsInput', {
        templateUrl: '../scripts/components/common/emailChipsInput/emailChipsInput.html',
        bindings: {
            notification: '<',
            title: '@'
        },
        controller: function () {
            var vm = this;

            vm.$onInit = function () {
                vm.readonly = false;
                vm.notification.recipients = vm.notification.recipients || [];
                vm.performArrayValidation();
            };

            /**
             * Validate single email using regular expression
             *
             * @param {string} email            - Email
             * @returns {boolean}               - True if email is valid
             */
            vm.validateEmail = function (email) {
                // Src https://emailregex.com/
                var reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return !!reg.test(email);
            };

            /**
             * Validate whole array of notification recipients
             *
             * @returns {boolean}               - True if all emails are correct email addresses and list is not empty
             */
            vm.performArrayValidation = function () {
                var hasInvalidEmail = false;
                vm.notification.recipients.forEach(function (recipient) {
                    hasInvalidEmail = hasInvalidEmail || !vm.validateEmail(recipient);
                });
                vm.notification.isValid = !hasInvalidEmail &&
                    vm.notification.recipients.length !== 0 ||
                    vm.notification.recipients.length === 0;
            };
        }
    });

'use strict';
/**
 * @ngdoc company level modele: Sensor model dialog window
 * @name loopUiApp.component:fileUpload
 * @description
 * # fileUpload
 *
 * Component for implement file upload.
 *
 * Exposes an API through following output:
 *
 * - `exposeApi`            - Takes a function and pass vm.api as a parameter, so parent component can call internal API.
 * - `onSelection`          - Emits file selection event that contains all needed information. Useful when component is in hidden mode. Type: function.
 * - `selectionFilter`      - Set input control accept property. Type: string.
 *
 * API:
 *
 * - `startUpload`          - Function called from host component and accepts callback, which in ture receives form data and file name.
 * - `selectFile`           - Trigger file selector if component is hidden.
 */
angular.module('loopUiApp')
    .component('fileUpload', {
        bindings: {
            exposeApi: '&',
            onSelection: '&',
            selectionFilter: '@'
        },
        templateUrl: '../scripts/components/common/fileUpload/fileUpload.html',
        controller: function (Commons, $element) {
            var vm = this;
            vm.files = [];

            vm.$onInit = function () {
                vm.uploadTriggerElement = $element.children().find('input');
                if (vm.uploadTriggerElement) {
                    vm.uploadTriggerElement.on('change', function (event) {
                        vm.onSelection({ event: event });
                    });
                }

                // Exposed API
                vm.api = {
                    startUpload: vm.startUpload,
                    selectFile: vm.selectFile,
                    cleanSelection: vm.cleanSelection
                };

                vm.exposeApi({ $API: vm.api });
            };

            /**
             * Triggered file selection from parent component, this should be done
             * asynchronously to avoid `$apply already in progress` error.
             *
             * @returns {void}
             */
            vm.selectFile = function () {
                setTimeout(function () {
                    vm.uploadTriggerElement[0].click();
                }, 0);
            };

            /**
             * Component API function to start uploading from host component.
             *
             * @param {function} callback           - Callback that defined in host component. callback(formData, filename)
             * @returns {void}
             */
            vm.startUpload = function (callback) {
                var fileName = vm.files[0].name;

                Commons.toastShow('Uploading start...');

                var formData = new FormData();
                angular.forEach(vm.files, function (data) {
                    formData.append('file', data);
                });

                callback(formData, fileName);
            };

            /**
             * Clean input file selection
             * @returns {void}
             */
            vm.cleanSelection = function () {
                if (vm.uploadTriggerElement[0]) {
                    vm.uploadTriggerElement[0].value = null;
                }
            };
        }
    });

'use strict';
/**
 * @ngdoc component
 * @name loopUiApp.component:uploadFileDialog
 * @description
 * # uploadFileDialog
 */
angular.module('loopUiApp')
    .component('uploadFileDialog', {
        bindings: {
            title: '<',
            exampleLink: '<',
            isDescriptionRequired: '<',
            acceptType: '<',
            uploadFn: '<'
        },
        templateUrl: '../scripts/components/common/uploadFileDialog/uploadFileDialog.html',
        controller: function ($mdDialog, Commons) {
            var vm = this;
            //Selected files array
            vm.files = [];
            vm.isLoading = false;

            vm.$onInit = function () {
                vm.isDescriptionRequired = vm.isDescriptionRequired || false;
                vm.acceptType = vm.acceptType || '.csv';
            };

            /**
            * Close dialog windows
            * @return {undefined}
            */
            vm.hide = function () {
                $mdDialog.hide();
            };

            /**
             * Return formData element to upload or call upload function
             * @return {void}
             */
            vm.upload = function () {
                var fileData = new FormData();
                angular.forEach(vm.files, function (data) {
                    fileData.append('file', data);
                });
                var _result = {
                    files: vm.files,
                    fileData: fileData,
                    fileName: vm.filename || vm.files[0].name,
                    fileDescription: vm.fileDescription
                };
                // If no upload function is provided, close the dialog and return the result
                if (!vm.uploadFn) {
                    $mdDialog.hide(_result);
                    return;
                }

                // If upload function is provided, then call it and wait until it finishes
                if (vm.uploadFn) {
                    vm.isLoading = true;
                    vm.uploadFn(_result)
                        .then(function () {
                            $mdDialog.hide();
                        })
                        .catch(function (reason) {
                            var messageObject = Commons.createErrorObject(reason, 'Upload failed');
                            Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                            console.log('Upload failure:' + JSON.stringify(reason));
                        })
                        .finally(function () {
                            vm.isLoading = false;
                        });
                }
            };
        }
    });
'use strict';
/**
 * @ngdoc component
 * @name loopUiApp.component:processLog
 * @description
 * # processLog
 */
angular.module('loopUiApp')
    .component('processLog', {
        bindings: {
            title: '<',
            messages: '<',
            filterName: '<',
            filterList: '<',
            onFilter: '&'
        },
        templateUrl: '../scripts/components/common/processLog/processLog.html',
        controller: function ($mdDialog) {
            var vm = this;

            vm.$onInit = function() {
                vm.filterName = vm.filterName || 'Filter';
            };

            /**
             * Hide dialog
             * @returns {void}
             */
            vm.hide = function () {
                $mdDialog.hide();
            };

            /**
             * Callback function on filter
             * @param {Object} item - filter element 
             */
            vm.filter = function(item) {
                vm.onFilter({item: item});
            };
        }
    });
'use strict';
/**
 * @ngdoc component
 * @name loopUiApp.component:progressBar
 * @description
 * # progressBar
 */
angular.module('loopUiApp')
    .component('progressBar', {
        bindings: {
            status: '<',
            progressPct: '<'
        },
        templateUrl: '../scripts/components/common/progressBar/progressBar.html',
        controller: function () {
            var vm = this;

            // Progress status color map
            vm.statusColor = {
                NEW: '#e8904c',
                PENDING: '#e8904c',
                WAITING: '#e8904c',
                RUNNING: '#009EE1',
                COMPLETED: '#3fa46f',
                SUCCESS: '#3fa46f',
                ERROR: '#f70b49',
                CANCEL: '#0000004d',
                UNKNOWN: '#727272'
            };

            /**
             * Get progress line color
             * @param {String} status - status name
             * @returns {String} - color code
             */
            vm.progressStatusColor = function (status) {
                try {
                    return vm.statusColor[status];
                } catch (e) {
                    return vm.statusColor.UNKNOWN;
                }
            };
        }
    });
'use strict';

/**
 * @ngdoc component
 * @name loopUiApp.component:externalPage
 * @description
 * # externalPage
 *
 */
angular.module('loopUiApp')
    .component('externalPage', {
        templateUrl: '../scripts/components/common/externalPage/externalPage.html',
        bindings: {
            url: '<',
            title: '<'
        },
        controller: function ($mdDialog, $sce) {
            var vm = this;

            vm.$onInit = function() {
                vm.toolbarOpen = false;
                vm.trustedUrl = $sce.trustAsResourceUrl(vm.url);
            };

            /**
             * Show/hide toolbar
             * @returns {void}
             */
            vm.toggleToolbar = function() {
                vm.toolbarOpen = !vm.toolbarOpen;
            };

            /**
             * Open URL in a new tab
             * @returns {void}
             */
            vm.move = function() {
                window.open(vm.url, '_blank');
                $mdDialog.cancel();
            };

            /**
             * Close external page 
             * @returns {void}
             */
            vm.close = function() {
                $mdDialog.cancel();
            };
        }
    });
'use strict';

/**
 * @ngdoc Personal user settings page 
 * @name loopUiApp.component:userSettings
 * @description
 * # userSettings
 */
angular.module('loopUiApp')
    .component('userSettings', {
        templateUrl: '../scripts/components/common/userSettings/userSettings.html',
        controller: function ($mdToast, appConfig, Auth, Service, Commons) {
            var vm = this;
            // Feature attribute name
            var featureName = appConfig.__env.gtmFeatureName;
            // Feature status time attribute name
            var featureStatusTimeName =  appConfig.__env.gtmFeatureStatusTimeName;
            vm.featureStatus = false;

            vm.$onInit = function () {
                vm.getStatus();
            };

            /**
             * Get feature current status
             */
            vm.getStatus = function () {
                Service.api.userAttributesGet({
                    action: Auth.tokenParsed.preferred_username
                }).$promise
                    .then(function (data) {
                        vm.featureStatus = data[featureName] || false;
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Get user attributes failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error userAttributes:' + JSON.stringify(reason));
                    });
            };

            /**
             * Enable/disable feature
             */
            vm.toggle = function () {
                Service.api.userAttributesGet({
                    action: Auth.tokenParsed.preferred_username
                }).$promise
                    .then(function (data) {
                        var _payload = data.toJSON() || {};
                        _payload[featureName] = vm.featureStatus;
                        _payload[featureStatusTimeName] = Date.now();
            
                        return Service.api.userAttributesSet({
                            action: Auth.tokenParsed.preferred_username
                        }, _payload).$promise;
                    })
                    .then(function () {
                        // Ask user to reload
                        var toast = $mdToast.simple()
                            .textContent('Status changed. Please, reload the page to apply changes.')
                            .action('Reload')
                            .highlightAction(true)
                            .position('bottom right')
                            .hideDelay(0);
                        $mdToast.show(toast)
                            .then(function () {
                                window.location.reload();
                            });
                    })
                    .catch(function (reason) {
                        var messageObject = Commons.createErrorObject(reason, 'Get user attributes failed');
                        Commons.toastError(messageObject.message, messageObject.messageDetails, messageObject.status);
                        console.log('Error userAttributes:' + JSON.stringify(reason));
                    });
            };
        }
    });
'use strict';
/**
 * @ngdoc
 * @name loopUiApp.component:systemTime
 * @description
 * # systemTime
 *  */
angular.module('loopUiApp')
    .component('systemTime', {
        templateUrl: '../scripts/components/common/systemTime/systemTime.html',
        bindings: {
            currentTime: '<',
            uptimeMs: '<',
            timeSource: '@'
        },
        controller: function () {
            var vm = this;
            // Uptime object {days: 0, hours: 0, minutes: 0}
            vm.uptime = {};

            vm.$onInit = function () {
                // Source can be 'VM' or 'Device'
                vm.timeSource = vm.timeSource || 'VM';
            };

            vm.$onChanges = function(changes) {
                if(changes.uptimeMs) {
                    vm.uptime = vm.convertMiliseconds(vm.uptimeMs);
                }
            };

            /**
             * Uptime in human readable format
             * @param {number} - time in milliseconds
             * @returns UptimeHuman
             */
            vm.convertMiliseconds = function(miliseconds) {
                if (!miliseconds) { return null; }

                var totalSeconds = Math.floor(miliseconds / 1000);
                var totalMinutes = Math.floor(totalSeconds / 60);
                var totalHours = Math.floor(totalMinutes / 60);

                var days = Math.floor(totalHours / 24);
                var minutes = totalMinutes % 60;
                var hours = totalHours % 24;

                return { days: days, hours: hours, minutes: minutes };
            };
        }
    });
'use strict';

/**
 * @ngdoc component
 * @name loopUiApp.component:supportChatIcon
 * @description
 * # supportChatIcon
 *
 */
angular.module('loopUiApp')
    .component('supportChatIcon', {
        templateUrl: '../scripts/components/common/supportChatIcon/supportChatIcon.html',
        controller: function (localStorageService, ServiceZenDesk) {
            var vm = this;
            var _storageKey = 'supportIconCollapsed';
            vm.szd = ServiceZenDesk;

            vm.$onInit = function() {
                vm.collapsed = localStorageService.get(_storageKey, 'localStorage');
            };

            /**
             * Show full/collapsed chat icon
             */
            vm.toggleCollapse = function () {
                vm.collapsed = !vm.collapsed;
                localStorageService.set(_storageKey, vm.collapsed, 'localStorage');
            };
        }
    });
'use strict';

/**
 * @ngdoc component
 * @name loopUiApp.component:simpleHorizontalBarChart
 * @description
 * # simpleHorizontalBarChart
 *
 */
angular.module('loopUiApp')
    .component('simpleHorizontalBarChart', {
        templateUrl: '../scripts/components/common/simpleHorizontalBarChart/simpleHorizontalBarChart.html',
        bindings: {
            usedValue: '<',
            availableValue: '<',
            totalValue: '<',
            usedPercent: '<'
        },
        controller: function () {
            var vm = this;
            vm.barClass = 'bar-success';

            vm.$onChanges = function(changes) {
                if (changes.usedPercent !== undefined){
                    vm.barClass = vm.usedPercent < 90 ? 'bar-success' : 'bar-error';
                }
            };
        }
    });
'use strict';
/**
 * @ngdoc directive
 * @name LoopUI directive:companyValidator
 * @description Validate company name input field directive
 */
angular.module('loopUiApp')
    .directive('companyValidator', function ($q, $http, appConfig, Commons) {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, element, attr, ngModel) {
                ngModel.$asyncValidators.companyName = function (companyName) {
                    var deferred = $q.defer(),
                        apiUrl = appConfig.apiUrl + 'api/v' + appConfig.apiVersion + '/company/name-validation',
                        _companyName = Commons.cleanUrlText(companyName);
                    var skipValidation = scope.$eval(attr.skipValidation);
                    if (skipValidation) {
                        deferred.resolve();
                    } else {
                        $http({
                            url: apiUrl,
                            method: 'GET',
                            params: { name: _companyName }
                        }).then(function (response) {
                            if (response && response.data && response.data.code === 'E'){
                                scope.serverValidations = response.data.message;
                                // API returns error
                                deferred.reject(response.data.message);
                            } else {
                                // Validation check success
                                deferred.resolve();
                            }
                        }, function () {
                            // On API error allow validation
                            deferred.resolve();
                        });
                    }

                    return deferred.promise;
                };
            }
        };
    });

'use strict';
/**
 * @ngdoc directive
 * @name LoopUI directive:apiTokenValidator
 * @description Validate company name input field directive
 */
angular.module('loopUiApp')
    .directive('apiTokenValidator', function ($q, $http, appConfig, $stateParams) {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, element, attr, ngModel) {
                ngModel.$asyncValidators.apiToken = function (apiToken) {
                    var deferred = $q.defer(),
                        projectId = $stateParams.projectId,
                        deviceId = $stateParams.deviceId,
                        apiUrl = appConfig.apiUrl + 'api/v' + appConfig.apiVersion +
                            '/device/api-key/' + projectId + '/' + deviceId + '/verify';

                    $http.post(apiUrl, {
                        value: apiToken
                    }).then(function (response) {
                        if (response && response.data && response.data.code === 'E') {
                            scope.serverValidations = response.data.message;
                            // API returns error
                            deferred.reject(response.data.message);
                        } else {
                            // Validation check success
                            deferred.resolve();
                        }
                    }, function (reason) {
                        var message = reason.data && reason.data.message ? reason.data.message : 'Validation failed';
                        scope.serverValidations = reason.data.message;
                        deferred.reject(message);
                    });

                    return deferred.promise;
                };
            }
        };
    });
'use strict';

/**
 * @ngdoc directive
 * @name LoopUI directive:jsonValidator
 * @description Check if model value is valid JSON
 
 */
angular.module('loopUiApp')
.directive('jsonValidator', function() {
    return {
        require: 'ngModel',
        link: function(scope, elem, attrs, ctrl) {
            ctrl.$validators.validJson = function(modelValue) {
                if (ctrl.$isEmpty(modelValue) || scope.$eval(attrs.jsonValidator) === false) {
                  return true;
                }
                try {
                    JSON.parse(modelValue);
                    // If JSON.parse didn't throw error, then model is valid JSON
                    return true;
                } catch (e) {
                    return false;
                }
              };
        }
    };
});

'use strict';
/**
 * @ngdoc directive
 * @name LoopUI directive:jsonAtaValidator
 * @description Validate JSONata expression
 */
angular.module('loopUiApp')
    .directive('jsonAtaValidator', function ($q, $http, appConfig) {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, element, attr, ngModel) {
                ngModel.$asyncValidators.jsonAtaInvalid = function (value) {
                    var deferred = $q.defer();
                    var apiUrl = appConfig.apiUrl + 'api/v' + appConfig.apiVersion + '/dt2/jsonata-validate';
                    if (scope.$eval(attr.jsonAtaValidator) === false) {
                        deferred.resolve();
                        return deferred.promise;
                    }
                    $http({
                        url: apiUrl,
                        method: 'POST',
                        data: value
                    }).then(function () {
                        // Validation check success
                        deferred.resolve();
                    }, function (response) {
                        if (response && response.data && response.data.code === 'E') {
                            if (response.data.messageDetails) {
                                scope.validationMessage = 'Invalid expression: ' + response.data.messageDetails.substring(0, 256);
                            } else {
                                scope.validationMessage = response.data.message;
                            }
                            // API returns error
                            deferred.reject(response.data.message);
                        } else {
                            // On API error allow validation
                            deferred.resolve();
                        }
                    });
                    return deferred.promise;
                };
            }
        };
    });

'use strict';

/**
 * _.debounce analog
 */
angular.module('loopUiApp')
    .directive('ngDebounce', function ($timeout) {
        return {
            restrict: 'A',
            require: 'ngModel',
            priority: 99,
            link: function (scope, elm, attr, ngModelCtrl) {
                if (attr.type === 'radio' || attr.type === 'checkbox') {
                    return;
                }

                var delay = parseInt(attr.ngDebounce, 10);
                if (isNaN(delay)) {
                    delay = 1000;
                }

                elm.unbind('input');

                var debounce;
                elm.bind('input', function () {
                    $timeout.cancel(debounce);
                    debounce = $timeout(function () {
                        scope.$apply(function () {
                            ngModelCtrl.$setViewValue(elm.val());
                        });
                    }, delay);
                });
                elm.bind('blur', function () {
                    scope.$apply(function () {
                        ngModelCtrl.$setViewValue(elm.val());
                    });
                });
            }
        };
});
'use strict';

/**
 * @ngdoc directive
 * @name LoopUI directive:match
 * @description Used for email or password confirmation 
 
 */
angular.module('loopUiApp')
.directive('match', function($parse) {
    return {
        require: 'ngModel',
        link: function(scope, elem, attrs, ctrl) {
            scope.$watch(function() {        
                return $parse(attrs.match)(scope) === ctrl.$modelValue;
            }, function(currentValue) {
                ctrl.$setValidity('mismatch', currentValue);
            });
        }
    };
});
'use strict';

/**
 * @ngdoc customPagination
 * @description Custom pagination for company list and projects 
 */

angular.module('loopUiApp')
    .directive('customPagination', function () {
        return {
            restrict: 'EA',
            scope: {
                clPages: '=',
                clPageChanged: '&',
                clSteps: '<',
                clCurrentPage: '=',
            },

            templateUrl: '../scripts/components/pagination.html',
            controllerAs: 'vm',
            controller:
                function ($scope) {
                    var vm = this;
                    vm.index = 0;
                    //number of buttons 
                    vm.clSteps = $scope.clSteps;

                    /**
                     * to go to a specific page 
                     * 
                     * @param {number} index
                     */
                    vm.goto = function (index) {
                        $scope.clCurrentPage = vm.page[index];
                    };

                    vm.gotoPrev = function () {
                        $scope.clCurrentPage = vm.index;
                        vm.index -= vm.clSteps - 1;
                    };

                    vm.gotoNext = function () {
                        vm.index += vm.clSteps;
                        $scope.clCurrentPage = vm.index;
                    };

                    vm.gotoFirst = function () {
                        vm.index = 0;
                        $scope.clCurrentPage = 0;
                    };

                    vm.gotoLast = function () {
                        vm.index = parseInt($scope.clPages / vm.clSteps) * vm.clSteps;
                        if (vm.index === $scope.clPages) {
                            vm.index = vm.index - vm.clSteps;
                        }
                        $scope.clCurrentPage = $scope.clPages - 1;
                    };

                    $scope.$watch('clCurrentPage', function (value) {
                        vm.index = parseInt((value) / vm.clSteps) * vm.clSteps;
                        //call function if scope exist .... for cl-page-changed attr 
                        if ($scope.clPageChanged) {
                            $scope.clPageChanged();
                        }
                    });
                    //if number of pages changes init 
                    $scope.$watch('clPages', function () {
                        vm.init();
                    });
                    
                    /**
                     * create page array and steps array 
                     */
                    vm.init = function () {
                        $scope.clCurrentPage = 0;
                        vm.stepInfo = (function () {
                            var result = [];
                            for (var i = 0; i < vm.clSteps; i++) {
                                result.push(i);
                            }
                            return result;
                        })();

                        vm.page = (function () {
                            var result = [];
                            for (var i = 0; i < $scope.clPages; i++) {
                                result.push(i);
                            }
                            return result;
                        })();

                    };
                }
        };
    });


'use strict';

/**
 * @ngdoc directive
 * @name dataEnrichmentApp.directive:chipsextend
 * @description Extend the original mdChips directive for onBlur add chips reason
 * https://github.com/angular/material/issues/3364
 * # chipsextend
 */
angular.module('loopUiApp')
    .directive('mdChips', function () {
        return {
            restrict: 'E',
            require: 'mdChips', // Extends the original mdChips directive
            link: function (scope, element, attributes, mdChipsCtrl) {
                mdChipsCtrl.onInputBlur = function () {
                    this.inputHasFocus = false;

                    var chipBuffer = this.getChipBuffer();
                    setTimeout(function () {
                        // Only append the chip and reset the chip buffer if the chips and input ngModel is valid.
                        if (!document.activeElement.hasAttribute('md-virtual-repeat') && chipBuffer) {
                            this.appendChip(chipBuffer);
                            this.resetChipBuffer();
                        }
                        this.fromAutoComplete = false;
                    }.bind(this));
                };

                mdChipsCtrl.removeChipAndFocusInput = function (index) {
                    this.removeChip(index);

                    if (this.autocompleteCtrl) {
                        // Always hide the autocomplete dropdown before focusing the autocomplete input.
                        // Wait for the input to move horizontally, because the chip was removed.
                        // This can lead to an incorrect dropdown position.
                        this.autocompleteCtrl.hidden = true;
                        // $mdUtil.nextTick(this.onFocus.bind(this));
                    } else {
                        this.onFocus();
                    }
                };
            }
        };
    });
"use strict";


/**
 * @ngdoc directive
 * @name LoopUI directive:dialogProfile
 * @description Used for dialog template 
 
 */

angular.module('loopUiApp')
.directive('dialogProfile', function ($compile) {

    var nameTemplate =                    
        '    <md-toolbar>'+
        '		<div class="md-toolbar-tools">'+
        '			<h2>Name</h2>'+
        '			<span flex></span>'+
        '			<md-button class="md-icon-button" ng-click="vm.hide()">'+
        '				<md-icon>close</md-icon>'+
        '			</md-button>'+
        '		</div>'+
        '	</md-toolbar>'+
        '    <md-dialog-content>'+
        '        <form name="nameForm" layout="column" layout-align="start " layout-padding>'+       
        '            <md-input-container>'+
        '                <label>First name</label>'+
        '                <input ng-model="vm.user.firstName" name="firstName"  >'+
        '            <div ng-messages="nameForm.firstName.$error">'+
        '                <div ng-message="required">Name is Required</div>'+
        '                <div ng-message="pattern">Incorrect Format</div>'+
        '            </div>'+                            
        '            </md-input-container>'+
        '            <md-input-container>'+
        '                <label>Last name</label>'+
        '                <input ng-model="vm.user.lastName"  name="lastName"   >'+
        '            <div ng-messages="nameForm.lastName.$error">'+
        '                <div ng-message="required">Name is Required</div>'+
        '                <div ng-message="pattern">Incorrect Format</div>'+
        '            </div>'+
        '            </md-input-container>'+
        '            <md-dialog-actions layout="row">'+
        '                <md-button type="submit" class="clear-button" ng-click="vm.accept(vm.user)" ng-disabled="nameForm.$invalid">{{\'Save\'|translate}}</md-button>'+
        '                <md-button ng-click="vm.hide()" >{{\'Close\'|translate}}</md-button>'+
        '            </md-dialog-actions>'+
        '        </form>'+
        '    </md-dialog-content>';
                            
    var emailTemplate = 
        '    <md-toolbar>'+
        '		<div class="md-toolbar-tools">'+
        '			<h2>Email</h2>'+
        '			<span flex></span>'+
        '			<md-button class="md-icon-button" ng-click="vm.hide()" ng-hide="vm.success">'+
        '				<md-icon>close</md-icon>'+
        '			</md-button>'+
        '		</div>'+
        '	</md-toolbar>'+
        '    <md-dialog-content>'+
        '        <form name="emailForm" layout="column" layout-align="start " ng-if="!vm.success" layout-padding>'+       
        '            <p class="md-caption">When you update your email address, we will send a confirmation email to your new email address.</p>'+
        '            <md-input-container>'+
        '                <label>Email</label>'+
        '                <input type="email" ng-model="vm.user.email" name="email" minlenght="10" maxlength="100" ng-pattern="/^.+@.+\..+$/" required>'+
        '               <div ng-messages="emailForm.email.$error" >'+
        '                  <div ng-message="required">Email is required</div>'+
        '                  <div ng-message="pattern">Incorrect format</div>'+
        '                </div>'+
        '            </md-input-container>'+
        '            <md-dialog-actions layout="row">'+
        '                <md-button type="submit" class="clear-button" ng-click="vm.accept(vm.user)" ng-disabled="emailForm.$invalid || vm.user.email === vm.copy.email">{{\'Save\'|translate}}</md-button>'+
        '                <md-button ng-click="vm.hide()" >{{\'Close\'|translate}}</md-button>'+
        '            </md-dialog-actions>'+
        '        </form>'+
        '    <div ng-if="vm.success" layout-padding>'+
        '       <p> We just sent you the confirmation link to the new email address. </p>'+
        '   </div>'+
        '    </md-dialog-content>';
    var password = 
            '    <md-toolbar>'+
        '		<div class="md-toolbar-tools">'+
        '			<h2>Change Password</h2>'+
        '			<span flex></span>'+
        '			<md-button class="md-icon-button" ng-click="vm.hide()" ng-hide="vm.success">'+
        '				<md-icon>close</md-icon>'+
        '			</md-button>'+
        '		</div>'+
        '	</md-toolbar>'+
        '       <md-dialog-content layout-padding>'+
        '            <form name="confirmPasswordForm" layout="column" ng-if="!vm.success">'+
        '               <md-input-container>'+
        '                   <label>New password</label>'+
        '                   <input name="password" type="password" ng-model="vm.user.password" aria-label="password" required/>'+
        '               </md-input-container>'+
        '               <md-input-container>'+
        '                   <label>Confirm password</label>'+
        '                   <input type="password" name="passwordConfirm" ng-model="vm.user.passwordConfirm" match="vm.user.password" required/>'+
        '                   <div ng-messages="confirmPasswordForm.passwordConfirm.$error">'+
        '                       <div ng-message="mismatch">Password does not match the confirm password</div>'+
        '                   </div>'+
        '               </md-input-container>'+
        '       </md-dialog-content>'+
        '       <md-dialog-actions layout="row" ng-if="!vm.success">'+
        '           <md-button  class="clear-button" ng-click="vm.accept(vm.user)" ng-disabled="confirmPasswordForm.$invalid"> {{\'Update\'|translate}}</md-button>'+
        '            <md-button ng-click="vm.hide()" >{{\'Cancel\'|translate}}</md-button>'+
        '        </md-dialog-actions>'+
        '         </form>'+
        '         <p ng-if="vm.success"> You have successfully updated your password. </p>';
    var caCertificate = 
       '     <md-toolbar>'+
       '         <div class="md-toolbar-tools">'+
       '             <h2>Certificate</h2>'+
       '             <span flex></span>'+
       '             <md-button class="md-icon-button" ng-click="vm.hide()">'+
       '                 <md-icon>close</md-icon>'+
       '             </md-button>'+
       '         </div>'+
       '     </md-toolbar>'+
       '     <md-dialog-content layout-padding>'+
       '         <md-input-container >'+
       '             <textarea aria-label="caCertificate" ng-model="vm.caCertificate" rows="19"cols="80"  ng-readonly="true"></textarea>'+
       '         </md-input-container>'+
       '         <md-dialog-actions layout="row">'+
       '         <md-button ngclipboard data-clipboard-text="{{vm.caCertificate}}" ngclipboard-success="vm.copySuccess()" class="md-raised md-warn"> {{\'Copy\'|translate}} </md-button>'+
       "         <md-button ng-click='$ctrl.downloadLink($ctrl.mqttCredentials.caCertificate, 'ca-litmus.pem')'>"+
       "             <md-icon>file_download</md-icon>"+
       '             <md-tooltip md-direction="bottom">{{\'Download file\'|translate}} </md-tooltip>'+
       '         </md-button>'+                     
       '         <md-button ng-click="vm.hide()">{{\'Close\'|translate}}</md-button>'+         
       '         </md-dialog-actions>'+
       '     </md-dialog-content>';

    var getTemplate = function(contentType){
        var template = '';
        switch(contentType){
        case 'name':
            template = nameTemplate;
            break;
        case 'email':
            template = emailTemplate;
            break;
        case 'caCertificate':
            template = caCertificate;
            break;
        case 'changePassword':
            template = password;
            break;
        }

        return template;
    }; 

    var linker = function(scope, element, attrs){
        element.html(getTemplate(attrs.content));
        $compile(element.contents())(scope);
          
    };

    return {
        restrict: 'E',
        replace: true,
        link: linker
    };
});
'use strict';
/**
 * @ngdoc directive
 * @name LoopUI directive:copyToClipboard
 * @description Used to copy to clipboard function. 
 
 */

angular.module('loopUiApp')
    .directive('copyToClipboard', function ($window) {
        var body = angular.element($window.document.body);
        var textarea = angular.element('<textarea/>');
        textarea.css({
            position: 'fixed',
            opacity: '0'
        });

        /**
         * 
         * create an invisble textarea add value then copy to clipboard
         * @param {string} toCopy
         * @param {function} callback
         */
        function copy(toCopy, callback) {
            var successful = false;
            textarea.val(toCopy);
            body.append(textarea);
            textarea[0].select();
            successful = document.execCommand('copy');
            textarea.remove();
            callback(successful);
        }

        return {
            restrict: 'E',
            template: '<md-button class="md-icon-button" ng-class=\'{"copy-to-clipboard--small": size === "small" }\'>' +
                '<md-icon>content_copy</md-icon>' +
                '<md-tooltip md-direction="bottom">{{ title || \'Copy to clipboard\'}}</md-tooltip>' +
                '</md-button>',
            link: function (scope, element) {
                element.bind('click', function () {
                    copy(scope.copy, function (thing) {
                        if (thing === true) {
                            scope.success();
                        }
                    });
                });
            },
            scope: {
                success: '&',
                copy: '@',
                size: '@',
                title: '@'
            }
        };
    });

'use strict';

/**
 * @ngdoc directive
 * @name myClickOutSide
 * @description closes application menu if its clicked outside
 * 
 */
angular.module('loopUiApp')
.directive('twClickOutside', function ($window, $parse) {
    return {
        restrict:'A',
        link: function(scope, el, attr) {
            if (!attr.twClickOutside) {
                return;
            }
            //if you dont want it to fire undersome circumstances
            var ignore;
            if (attr.ignoreIf) {
                ignore = $parse(attr.ignoreIf);
            }

            var nakedEl = el[0];
            var fn = $parse(attr.twClickOutside);

            var handler = function(e) {
                if (nakedEl === e.target || nakedEl.contains(e.target) || (ignore && ignore(scope))) {
                    return;
                }

                scope.$apply(fn);
            };

            $window.addEventListener('click', handler, true);

            scope.$on('$destroy', function() {
                $window.removeEventListener('click', handler);
            });
        }
    };
}



);

(function(){
    'use strict';

    angular.module('loopUiApp')
    .directive('menuLink', function () {
        return {       
            scope: {
                section: '<'
            },                
            template: 
                        '<md-button class="menu-link-button" ng-click="vm.focusSection(section)">' +
                            '<md-icon ng-if="section.svg" md-svg-icon="{{section.svg}}"></md-icon>' +         
                            '<md-icon ng-if="section.icon">{{section.icon}}</md-icon>' +         
                            '<span ng-show="vm.cm.isFullMenu">{{section.name}}</span>' +         
                        '</md-button>',            
            controllerAs:'vm',
            controller:
              function(Commons){
                  var vm = this;
                  vm.cm = Commons;
                  /**
                   * when click this will cause a view change 
                   * 
                   * @param {string} link
                   * 
                   */
                  vm.focusSection = function(section){
                      Commons.stateChange(section.link);               
                  };
              }
            
        };
    });
})();




'use strict';
/**
 * @ngdoc directive
 * @name LoopUI directive:menuToggle
 * @description derective for toggle component of the drop down menu. 
 
 */

angular.module('loopUiApp')
  .directive('menuToggle', ['$timeout', function ( ) {
      return {
          restrict: 'E',
          scope: {
              section: '<'
          },
          template:   
            '<md-button class="md-button-toggle" ng-click="toggle()" aria-controls="docs-menu-{{section.name | nospace}}"  >'+
            '<md-icon ng-if="section.svg" md-svg-icon="{{section.svg}}"></md-icon>'+         
            '<md-icon ng-if="section.icon">{{section.icon}}</md-icon>'+
            '<span ng-show="vm.cm.isFullMenu">{{section.name}}</span>' +
            '<md-icon ng-show="vm.cm.isFullMenu" class="md-toggle-icon white-icon" ng-class="{toggled : isOpen()}">keyboard_arrow_right</md-icon>'+
            '</md-button>'+
            ' <ul ng-show="!isOpen()" id="docs-menu-{{section.name | nospace}}" class="menu-toggle-list">'+
            '  <li ng-repeat="page in section.pages | filter:vm.filterMenu" ng-if="!page.hidden" ng-class="{activated: page.link === vm.menu.returnLink()}">'+
            '  <menu-link ng-click="vm.activate()" section="page"></menu-link>'+
            '  </li>'+
            '</ul>',
          require:'^sideNavLeft',
          link: function (scope, element, attr, controller) {
            
              /**
               * calls parent controller to see if dorpdown menu is open or not 
               * 
               * @returns boolean 
               */
              scope.isOpen = function () {
                  return controller.isOpen(scope.section);
              };


              scope.toggle = function () {
                  controller.toggleOpen(scope.section);
                  // if section has link then change view
                  if(scope.section.link){
                      controller.stateChange(scope.section.link);
                  }
              };

              var parentNode = element[0].parentNode.parentNode.parentNode;
              if (parentNode.classList.contains('parent-list-item')) {
                  var heading = parentNode.querySelector('h2');
                  element[0].firstChild.setAttribute('aria-describedby', heading.id);
              }
          },
          controllerAs:'vm',
          controller: function (menu, Commons, appConfig) {
              var vm = this;
              vm.cm = Commons;
              //used  for css. If current state is === to button link   then highlight the text 
              vm.menu = menu;

              /**
                 *  Filter disabled first level menu items from config file
                 * @param {Object} menuItem - menu item object
                 */
              vm.filterMenu = function (menuItem) {
                  var disabledMenuItems = appConfig.disabledMenuItems || [];
                  if (disabledMenuItems.length === 0) {
                      return true;
                  }
                  return disabledMenuItems.indexOf(menuItem.link) < 0;
              };
          }
      };
  }]);
'use strict';

/**
 * @ngdoc directive
 * @name LoopUI directive:stringToNumber
 * @description Try to convert string input to number
 
 */
angular.module('loopUiApp')
    .directive('stringToNumber', function () {
        return {
            require: 'ngModel',
            link: function (scope, element, attrs, ngModel) {
                ngModel.$parsers.push(function (value) {
                    return '' + value;
                });
                ngModel.$formatters.push(function (value) {
                    return parseFloat(value);
                });
            }
        };
    });
'use strict';

/**
 * @ngdoc directive
 * @name dataEnrichmentApp.directive:upload
 * @description
 * https://egghead.io/lessons/angularjs-file-uploads
 * # upload
 */
angular.module('loopUiApp')
    .directive('upload', ['$parse', function ($parse) {
        return {
            restrict: 'A',
            scope: false,
            link: function (scope, element, attrs) {
                var fn = $parse(attrs.upload);

                element.on('change', function (onChangeEvent) {
                    var reader = new FileReader();

                    reader.onload = function (onLoadEvent) {
                        scope.$apply(function () {
                            fn(scope, { $fileContent: onLoadEvent.target.result });
                        });
                    };

                    reader.readAsText((onChangeEvent.srcElement || onChangeEvent.target).files[0]);
                });
            }
        };
    }])
    .directive('uploadFiles', ['$parse', function ($parse) {
        return {
            restrict: 'A',
            link: function postLink(scope, element, attrs) {
                element.bind('change', function(){
                    $parse(attrs.uploadFiles).assign(scope, element[0].files);
                    scope.$apply();
                });
            }
        };
    }]);

'use strict';

/**
 * Element focus directive
 */
angular.module('loopUiApp')
    .directive('focusOn', function ($timeout) {
        return {
            restrict: 'A',
            link: function ($scope, $element, $attr) {
                $scope.$watch($attr.focusOn, function (_focusVal) {
                    $timeout(function () {
                        if (_focusVal) {
                            $element[0].focus();
                        } else {
                            $element[0].blur();
                        }
                    });
                });
            }
        };
    });
/**************************************************************************
 * JSON-tree, v0.1.5; MIT License
 * http://krispo.github.io/json-tree
 **************************************************************************/
(function () {
    'use strict';

    angular.module('json-tree', [])
        .constant('jsonTreeConfig', {
            templateUrl: null
        })

        .directive('jsonTree', ['$compile', '$q', '$http', '$templateCache', 'jsonTreeConfig', function ($compile, $q, $http, $templateCache, jsonTreeConfig) {

            var template =
                '<span ng-bind="utils.wrap.start(node)"></span>' +
                '<span ng-bind="node.isCollapsed ? utils.wrap.middle(node) : \'&nbsp;&nbsp;&nbsp;\'" ng-click="utils.clickNode(node)"></span>' +
                '<ul ng-if="!node.isCollapsed">' +
                '<li ng-repeat="key in utils.keys(json) track by key">' +
                '<div draggable>' +
                '<span  class="key" ng-click="utils.clickNode(childs[key])" >{{ key }}: </span>' +
                '<span ng-hide="childs[key].isObject()">' +
                '<input ng-if="childs[key].type() === \'boolean\'" type="checkbox" ng-model="json[key]"/>' +
                '<input ng-if="childs[key].type() === \'number\'" type="number" ng-model="json[key]"/>' +
                '<textarea ng-if="childs[key].type() === \'function\'" ng-model="jsonFn[key]" ng-init="utils.textarea.init(key)" ng-change="utils.textarea.onChange(key)" ng-focus="utils.textarea.onFocus($event, key)" ng-blur="utils.textarea.onBlur(key)"></textarea>' +
                '<input ng-if="childs[key].type() !== \'number\' && childs[key].type() !== \'function\'" type="text" ng-model="json[key]" ng-change="utils.validateNode(key)" placeholder="null"/>' +
                '</span>' +
                '<json-tree json="json[key]" edit-level="{{editLevel}}" collapsed-level="{{+collapsedLevel - 1}}" node="childs[key]" timeout="{{timeout}}" ng-show="childs[key].isObject()"></json-tree>' +
                '<span class="reset" ng-dblclick="utils.resetNode(key)" ng-show="node.isHighEditLevel"> ~ </span>' +
                '<span class="remove" ng-dblclick="utils.removeNode(key)" ng-show="node.isHighEditLevel">-</span>' +
                '<span class="comma" ng-hide="utils.wrap.isLastIndex(node, $index + 1)">,</span>' +
                '</div>' +
                '</li>' +
                '</ul>' +
                '<span ng-bind="utils.wrap.end(node)"></span>' +
                '<span class="add" ng-show="node.isHighEditLevel && node.isObject()" ng-click="addTpl = !addTpl; inputKey = null; inputValue = null"> + </span>' +
                '<span class="add-item-block" ng-show="(addTpl && node.isHighEditLevel) || false">' +
                '<span class="add-item-label" ng-show="node.type() === \'object\'">' +
                '<input class="add-item-input-key" type="text" ng-model="inputKey" placeholder="key"/>: ' +
                '<input class="add-item-input-value" type="text" ng-model="inputValue" placeholder="value"/>' +
                '</span>' +
                '<span class="add-item-preview" ng-show="node.type() === \'array\'">' +
                '<input class="add-value-preview-input" type="text" ng-model="inputValue" placeholder="value"/>' +
                '</span>' +
                '<button class="add-item-btn-add" ng-click="utils.addNode(inputKey, inputValue); addTpl = false">+</button>' +
                '<button class="add-item-btn-cancel" ng-click="addTpl = false">c</button>' +
                '</span>';

            /** */
            function getTemplatePromise() {
                if (jsonTreeConfig.templateUrl) {
                    return $http.get(jsonTreeConfig.templateUrl, {
                        cache: $templateCache
                    }).then(function (result) {
                        return result.data;
                    });
                }

                return $q.when(template);
            }

            return {
                restrict: 'EA',
                scope: {
                    json: '=',
                    node: '=?',
                    childs: '=?',
                    nodeOptions: '=',
                    editLevel: '@',
                    collapsedLevel: '@',
                    timeout: '@',
                    timeoutInit: '@',
                    onChange: '&'
                },
                controller: ['$scope', function ($scope) {

                    /* initialize container for child nodes */
                    $scope.childs = {};

                    /* initialize container for nodes with functions */
                    $scope.jsonFn = {};

                    /* define auxiliary functions */
                    $scope.utils = {

                        /* prettify json view */
                        wrap: {
                            start: function (node) {
                                if (node === undefined || node === null) { return ''; }
                                switch (node.type()) {
                                case 'array': return '[';
                                case 'object': return '{';
                                default: return '';
                                }
                            },
                            middle: function (node) {
                                if (node === undefined || node === null) { return ''; }
                                switch (node.type()) {
                                case 'array': return '...';
                                case 'object': return '...';
                                default: return '';
                                }
                            },
                            end: function (node) {
                                if (node === undefined || node === null) { return ''; }
                                switch (node.type()) {
                                case 'array': return ']';
                                case 'object': return '}';
                                default: return '';
                                }
                            },
                            isLastIndex: function (node, index) {
                                if (node === undefined || node === null) { return true; }
                                else { return index >= node.length(); }
                            },
                            variable: function (name, node, key) {
                                if (!node[key]) { return; }
                                return ('' + node[key]).indexOf('${') === 0 ? '${' + name + ':' + $scope.utils.wrap.defaultValue(node, key) + '}'
                                    : '${' + name + ':' + node[key] + '}';
                            },
                            defaultValue: function(node, key) {
                                var paramLength = node[key].length;
                                var firstPosition = node[key].indexOf(':');
                                return node[key].substring(firstPosition + 1, paramLength - 1);
                            }
                        },

                        toggleEditable: function(node, key){
                            node.isEditable[key] = undefined ? false : node.isEditable[key];
                            node.isEditable[key] = !node.isEditable[key];
                            $scope.onChange();
                        },

                        undoVariable: function(node, key) {
                            node[key] = $scope.utils.wrap.defaultValue(node, key);
                            $scope.onChange();
                        },

                        isVariable: function(node, key) {
                            return ('' + node[key]).indexOf('${') === 0;
                        },

                        /* collapse/expand node by clicking */
                        clickNode: function (node) {
                            node.isCollapsed = !node.isCollapsed;
                        },

                        /* add new node to the collection */
                        addNode: function (key, value) {
                            var json = null;
                            try {
                                json = JSON.parse(value);
                            } catch (e) { } //try get json
                            if (json === null) { json = $scope.utils.tryGetFunction(value) || json; } //try get function

                            /* add element to the object */
                            if ($scope.node.type() === 'object') {
                                if (json !== null) {
                                    $scope.json[key] = json;
                                } else {
                                    $scope.json[key] = value;
                                }

                            }
                            /* add element(s) to the array */
                            else if ($scope.node.type() === 'array') {
                                if (json !== null) {
                                    if (json.constructor === Array) {
                                        /* push new array elements to the array */
                                        $scope.json.push.apply($scope.json, json);
                                    } else {
                                        /* push single element to the array */
                                        $scope.json.push(json);
                                    }
                                } else {
                                    $scope.json.push(value);
                                }
                            }
                            $scope.refresh();
                        },

                        /* reset node value by key to default == null */
                        resetNode: function (key) {
                            $scope.json[key] = null;
                            $scope.refresh();
                        },

                        /* remove node by key from json */
                        removeNode: function (key) {
                            if ($scope.node.type() === 'object') {
                                delete $scope.json[key];
                            }
                            else if ($scope.node.type() === 'array') {
                                $scope.json.splice(key, 1);
                            }
                            $scope.refresh();
                        },

                        /* validate text if input to the form */
                        validateNode: function (key) {
                            /* check if null */
                            if ($scope.json[key] === null) { }

                            /* check if undefined or "" */
                            else if ($scope.json[key] === undefined || $scope.json[key] === '') { $scope.json[key] = null; }

                            /* try to convert string to number */
                            else if (!isNaN(+$scope.json[key]) && isFinite($scope.json[key])) {
                                $scope.json[key] = +$scope.json[key];
                            }

                            /* try parse to function */
                            else if ($scope.utils.tryGetFunction($scope.json[key])) {
                                $scope.json[key] = $scope.utils.tryGetFunction($scope.json[key]);
                                $scope.utils.textarea.init(key);
                            }

                            /* try to parse string to json */
                            else {
                                if ($scope.node.isHighEditLevel) { /* if high editable level */
                                    try {
                                        var json = JSON.parse($scope.json[key]);
                                        $scope.json[key] = json;
                                        $scope.refresh();
                                    } catch (e) { }
                                } else { /* if low editable level */
                                    /* check if boolean input -> then refresh */
                                    if ($scope.json[key] === 'true' || $scope.json[key] === 'false') {
                                        $scope.json[key] = JSON.parse($scope.json[key]);
                                        $scope.refresh();
                                    }
                                }
                            }
                        },

                        /* move node from position with index 'i' to position with index 'j' */
                        moveNode: function (i, j) {
                            /* moving for object */
                            if ($scope.node.type() === 'object') {
                                var json = {},
                                    keys = Object.keys($scope.json),
                                    key1 = keys[i],
                                    key2 = keys[j];

                                angular.forEach($scope.json, function (value, key) {
                                    if (key === key2) {
                                        if (j > i) {
                                            json[key2] = $scope.json[key2];
                                            json[key1] = $scope.json[key1];
                                        } else {
                                            json[key1] = $scope.json[key1];
                                            json[key2] = $scope.json[key2];
                                        }
                                    }
                                    else if (key !== key1) { json[key] = value; }
                                });
                                $scope.json = json;
                            }

                            /* moving for array */
                            else if ($scope.node.type() === 'array') {
                                var temp = $scope.json[i];
                                $scope.json.splice(i, 1);
                                $scope.json.splice(j, 0, temp);
                                $scope.$apply($scope.refresh());
                            }
                        },

                        /* handle textarea fith functions */
                        textarea: {
                            /* define function value for textarea */
                            init: function (key) {
                                if ($scope.json[key] !== null) { $scope.jsonFn[key] = $scope.json[key].toString().trim(); }
                            },

                            /* validate if element value is function */
                            validate: function (key) {
                                var func = $scope.utils.tryGetFunction($scope.jsonFn[key]);
                                if (func) {
                                    angular.element($scope.utils.textarea.element).removeClass('invalid').addClass('valid');
                                } else {
                                    angular.element($scope.utils.textarea.element).removeClass('valid').addClass('invalid');
                                }
                            },

                            /* onFocus event handler */
                            onFocus: function (e, key) {
                                $scope.utils.textarea.valueBeforeEditing = angular.copy($scope.jsonFn[key]); //keep value before editing
                                $scope.utils.textarea.element = e.currentTarget;
                                $scope.utils.textarea.validate(key);
                            },

                            /* onChange event handler */
                            onChange: function (key) {
                                $scope.utils.textarea.validate(key);
                            },

                            /* onBlur event handler */
                            onBlur: function (key) {
                                //handle only if the field has been changed
                                if ($scope.utils.textarea.valueBeforeEditing !== $scope.jsonFn[key]) {
                                    $scope.$emit('onFunctionChanged'); //emit onFunctionChange event if the function definition was changed.

                                    var func = $scope.utils.tryGetFunction($scope.jsonFn[key]);
                                    if (func) { $scope.json[key] = func; }
                                    else { //if value is not a valid function
                                        $scope.json[key] = $scope.jsonFn[key];
                                        delete $scope.jsonFn[key];
                                        $scope.utils.validateNode(key); //full validation for node
                                    }
                                }
                            }
                        },

                        /* try to convert string to function */
                        /* it is important that function element MUST start with 'function' keyword */
                        tryGetFunction: function (str) {
                            if (str.trim().substring(0, 8) === 'function') {
                                try {
                                    /*jslint evil: true */
                                    var func = eval('(' + str.trim() + ')');
                                    /*jslint evil: false */
                                    return func;
                                } catch (e) { }
                            }
                        },

                        /* to skip ordering in ng-repeat */
                        keys: function (obj) {
                            return (obj instanceof Object) ? Object.keys(obj) : [];
                        },

                        /* get type for variable val */
                        getType: function (val) {
                            if (val === null) { return 'null'; }
                            else if (val === undefined) { return 'undefined'; }
                            else if (val.constructor === Array) { return 'array'; }
                            else if (val.constructor === Object) { return 'object'; }
                            else if (val.constructor === String) { return 'string'; }
                            else if (val.constructor === Number) { return 'number'; }
                            else if (val.constructor === Boolean) { return 'boolean'; }
                            else if (val.constructor === Function) { return 'function'; }
                            else { return 'object'; }
                        },

                        isAllowParams: function(val) {
                            return ['string', 'number'].indexOf(typeof val) >= 0; 
                        }
                    };

                    /* define properties of the current node */
                    $scope.node = {

                        /* check node is collapsed */
                        isCollapsed: ($scope.collapsedLevel && +$scope.collapsedLevel) ? (+$scope.collapsedLevel <= 0) : true, /* set up isCollapsed properties, by default - true */

                        /* check if node value editable */
                        isEditable: {},

                        /* check editing level is high */
                        isHighEditLevel: $scope.editLevel !== 'low',

                        /* if childs[key] is dragging now, dragChildKey matches to key  */
                        dragChildKey: null,

                        /* used to get info such as coordinates (top, left, height, width, meanY) of draggable elements by key */
                        dragElements: {},

                        /* check current node is object or array */
                        isObject: function () {
                            return angular.isObject($scope.json);
                        },

                        /* get type for current node */
                        type: function () {
                            return $scope.utils.getType($scope.json);
                        },

                        /* calculate collection length for object or array */
                        length: function () {
                            return ($scope.json instanceof Object) ? (Object.keys($scope.json).length) : 1;
                        },

                        /* refresh template view */
                        refresh: function () {
                            $scope.refresh();
                        }
                    };
                }],
                link: function (scope, element) {

                    /* define child scope and template */
                    var childScope = scope.$new(),
                        templatePromise = getTemplatePromise();

                    /* define build template function */
                    scope.build = function (_scope) {
                        if (scope.node.isObject()) {
                            templatePromise.then(function (tpl) {
                                element.html('').append($compile(tpl)(_scope));
                            });
                        }
                    };

                    /* define refresh function */
                    scope.refresh = function () {
                        childScope.$destroy();
                        childScope = scope.$new();
                        scope.build(childScope);
                    };

                    // build template view
                    if (scope.timeoutInit) {
                        setTimeout(function () {
                            scope.build(childScope);
                        }, scope.timeoutInit);
                    } else if (scope.timeout && +scope.timeout >= 0) {
                        setTimeout(function () {
                            scope.build(childScope);
                        }, scope.timeout);
                    } else {
                        scope.build(childScope);
                    }
                }
            };
        }]);
})();

'use strict';
/**
 * @ngdoc directive
 * @name LoopUI directive:mdTableFilter
 * @description Add filter icon to the table header 
 */
angular.module('loopUiApp')
    .directive('mdTableFilter', function ($compile) {
        return {
            restrict: 'A',
            require: ['^^mdHead', '^^mdTable'],
            replace: false,
            link: function (scope, element, attr) {
                // Create a new icon element
                var iconElement = angular.element('<md-icon class="filter-icon">filter_alt</md-icon>');
                
                // Append the icon element to the directive element
                element.append($compile(iconElement)(scope));

                // Add click event listener to the icon
                iconElement.on('click', function (event) {
                    event.stopPropagation();
                    // Call the callback function provided by the user
                    scope.$apply(function () {
                        scope.$eval(attr.mdOnFilter, { event: event });
                    });
                });

                scope.$watch(attr.mdFilterVisible, function (newValue) {
                    if (newValue === true) {
                        iconElement.addClass('filter-icon__visible');
                    } else {
                        iconElement.removeClass('filter-icon__visible');
                    }
                });
            }
        };
    });
  'use strict';

/**
 * @ngdoc overview
 * @name filter
 * @description
 *  file for filters
 *
 * Main route file for the application.
 */
  angular
    .module('loopUiApp')
    //take all whitespace out of string
    .filter('nospace', function () {
        return function (value) {
            return (!value) ? '' : value.replace(/ /g, '');
        };
    })
    //replace uppercase to regular case
    .filter('humanizeDoc', function () {
        return function (doc) {
            if (!doc){
                return;
            }
            if (doc.type === 'directive') {
                return doc.name.replace(/([A-Z])/g, function ($1) {
                    return '-' + $1.toLowerCase();
                });
            }

            return doc.label || doc.name;
        };
    })
    .filter('pagination', function(){
        return function(input, start){
            start = +start;
            if(input){
                return input.slice(start);
            }
        };
    })
    .filter('range', function() {
        return function(val, range) {
            range = parseInt(range);
            for (var i=0; i<range; i++){
                val.push(i);
            }
            return val;
        };
    })
    .filter('underscoreless', function () {
        return function (input) {
            return input.replace(/_/g, ' ');
        };
    })
    .filter('prettify', function () {
        return function (json) {
            if(!json){
                return;
            }
            json = json.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
            return json.replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g, function (match) {
                var cls = 'hl-number';
                if (/^"/.test(match)) {
                    if (/:$/.test(match)) {
                        cls = 'hl-key';
                    } else {
                        cls = 'hl-string';
                    }
                } else if (/true|false/.test(match)) {
                    cls = 'hl-boolean';
                } else if (/null/.test(match)) {
                    cls = 'hl-null';
                }
                return '<span class="' + cls + '">' + match + '</span>';
            });
        };
    })
    .filter('bytes', function() {
        return function(bytes, precision, compact, divider, postfix) {
            if (isNaN(parseFloat(bytes)) || !isFinite(bytes)) {
                return '-';
            }
            if (!bytes) {
                return 0;
            }
            if (typeof precision === 'undefined') {
                precision = 1;
            }
            if (typeof divider === 'undefined') {
                divider = 1024;
            }
            var units = ['B', 'kB', 'MB', 'GB', 'TB', 'PB'];
            var compactUnits = ['B', 'K', 'M', 'G', 'T', 'P'];
            var number = Math.floor(Math.log(bytes) / Math.log(divider));
            if (Math.abs(bytes) < divider) {
                return bytes.toFixed(precision) + ' ' + (compact ? compactUnits[0] : units[0]);
            }
            return (bytes / Math.pow(divider, Math.floor(number))).toFixed(precision) + ' ' +
                (compact ? (compactUnits[number] || '') : ' ' + (units[number] ? units[number] : '')) + (postfix || '') ;
        };
    })
    .filter('counters', function() {
        return function(counter, precision, divider) {
            if (isNaN(parseFloat(counter)) || !isFinite(counter)) {
                return '-';
            }
            if (!counter) {
                return 0;
            }
            if (Math.abs(counter) < 1) {
                return counter;
            }
            if (typeof precision === 'undefined') {
                precision = 1;
            }
            if (typeof divider === 'undefined') {
                divider = 1000;
            }
            var units = ['', 'K', 'M', 'B', 'T'],
                number = Math.floor(Math.log(counter) / Math.log(divider));
            return (counter / Math.pow(divider, Math.floor(number))).toFixed(precision) + (units[number] !== undefined ? units[number] : ('E^' + (number * 3 - 3)));
        };
    })
    .filter('humanInterval', function() {
        return function (time) {
            var interval = ((Date.now() - time) / 1000).toFixed(0);
            var result = '';
            var brakepoint = {
                second: 60,
                minute: 60,
                hour: 24,
                day: 7,
                week: 4.35,
                month: 12,
                year: 10000
            };

            for (var unit in brakepoint) {
                result = interval % brakepoint[unit];
                /*jslint bitwise: true */
                if (!(interval = 0 | interval / brakepoint[unit])) {
                    return result + ' ' + (result - 1 ? unit + 's' : unit);
                }
                /*jslint bitwise: false */
            }
        };
    });

'use strict';

angular.module('loopUiApp').run(['gettextCatalog', function (gettextCatalog) {
/* jshint -W100 */
    gettextCatalog.setStrings('ja', {"1. Forms; Access to the Service":"1.フォーム;サービスへのアクセス","10. Indemnification":"10.免責","11. Disclaimer":"11.免責事項","12. Limitation of Liability":"12.賠償責任の制限","13. Miscellaneous":"13.その他","2. Implementation":"2.実装","3. Support; Service Levels":"3.サポート;サービスレベル","5. Ownership; Feedback":"5.所有権;フォードバック","6. Fees; Payment":"6.料金;支払い","7. Restrictions":"7.制限事項","8. Confidentiality; Customer Data; Publicity":"8.守秘義務;顧客データ;広報","9. Term; Termination":"9.期間;解約","A topic is required":"A トピックを指定","ACL":"ACL","ALL":"ALL","Account Name":"アカウント名","Action":"アクション","Action on selected devices":"選択したデバイスに対するアクション","Actions":"アクション","Actions Log":"アクションログ","Activate":"アクティベイト","Add":"追加","Add User":"ユーザの追加","Add a ACL":"ACLの追加","Add a Credential":"アカウント情報の追加","Add a topic":"トピックの追加","Add demo device":"デモデバイスの追加","Add teams to this project":"プロジェクトへのチームの追加","Add users by their username.":"これらのユーザ名でユーザを追加","Alerts":"警告","Are you sure you want to permanently delete this {{$ctrl.type}}? Please enter  <span class=\"delete-text\" md-colors=\"{color:'warn'}\">{{$ctrl.toDeleteItem}}</span>   below to delete it.":"本当に、 {{$ctrl.type}}　を削除しますか? 　 <span class=\"delete-text\" md-colors=\"{color:'warn'}\">{{$ctrl.toDeleteItem}}</span>  を入力して削除してください","Auto Refresh":"自動更新","Binding":"バインド","Binding: {{ action.binding }}":"バインド {{ action.binding }}","Block":"ブロック","Body":"ボディ","CA certificate":"CAサーティフィケイト","Cancel":"キャンセル","Change Description":"詳細を変更","Change Device Tag":"デバイスタグを変更","Change Firmware":"ファームウエアを更新","Change Manufacturer":"製造メーカを変更","Change Model":"モデルを変更","Change Status":"ステータスを変更","Checkbox Parameter":"パラメータ選択","Clear":"クリア","Click new to create a project.":"新しいプロジェクトをクリックして作成","Click on a project to add teams/roles.":"プロジェクトにチーム/役割をクリックして追加","Click on a team to add members.":"チームにメンバをクリックして追加","Close":"閉じる","Comment":"コメント","Companies":"会社","Company Description":"会社の詳細","Concurrency":"同時実行","Config":"設定","Confirmation":"確認","Connection":"接続","Context":"コンテキスト","Continue":"続ける","Create":"作成","Create Company":"会社の作成","Create New Device model":"新しいデバイスモデルの作成","Create New Project":"新しいプロジェクトの作成","Create an MQTT  account.":"MQTTのアカウント作成","Create an access control list":"アクセスコントロールリストの作成","Create new company":"新しい会社の作成","Created":"作成されました","Credentials":"アカウント情報","Date is too early!":"日付が新しすぎます","Date is too late!":"日付が古すぎます","Default Value":"デフォルト値","Delete":"削除","Delete Company":"会社の削除","Delete Model":"モデルの削除","Demo Device":"デモデバイス","Deployment:":"配備","Description":"詳細","Details":"詳細","Device":"デバイス","Device Description":"デバイスの詳細","Device Group Action":"デバイスグループのアクション","Device Model Select":"デバイスモデルの選択","Device Model {{$ctrl.isModalView($ctrl.model.mode) ? 'Preview': 'Editor'}}: {{$ctrl.model.name}}":"デバイスモデル  {{$ctrl.isModalView($ctrl.model.mode) ? 'Preview': 'Editor'}}: {{$ctrl.model.name}}","Device Object value":"デバイスオブジェクト値","Device count":"デバイスカウント","Device description":"デバイスの詳細","Devices":"デバイス","Disabled for Edit":"編集を隠す","Disconnect":"接続解除","Domain Name":"ドメイン名","Download":"ダウンロード","Download file":"ダウンロードファイル","Download link for device config file":"デバイスの設定ファイルのリンクをダウンロード","Edit device config":"デバイス設定を編集","Edit selected devices":"選択されたデバイスの編集","Encrypted Value Checkbox":"暗号値チェックボックス","Encrypted value":"暗号化された値","End date":"終了日付","Error. This email verification link has expired":"エラー　このメールのリンクは有効期限を過ぎています","Event":"イベント","Event Time":"イベント時間","Event type":"イベントタイプ","Events":"イベント","Explore":"探索する","Filter":"フィルタ","Filter ACL":"ACLをフィルタ","Filter Credentials":"アカウント情報をフィルタ","Filter Models":"モデルをフィルタ","Filter Topics":"トピックをフィルタ","Fingerprint":"認証情報","Firmware":"ファームウエア","Firmware Version":"ファームウエアのバージョン","Get Model from WSDL":"WSDLからモデルを取得","Get WSDL from file":"ファイルからWSDLを取得","Get aviilable operations list from WSDL":"WSDLから利用可能な操作リストを取得","HTTP URL":"HTTP URL","HTTP url":"HTTP url","HTTPS URL":"HTTPS URL","Header Name":"ヘッダ名","Headers":"ヘッダ","Hour(s)":"時","ID: {{$ctrl.object.id}} Instance: {{$ctrl.object.instance}} Resource: {{$ctrl.object.resource}}":"ID: {{$ctrl.object.id}} Instance: {{$ctrl.object.instance}} Resource: {{$ctrl.object.resource}}","Id":"Id","Info":"情報","Instance":"インスタンス","Interval":"インターバル","Invite Users to team {{$ctrl.team.name}}":"チームにユーザを招待する {{$ctrl.team.name}}","JSON":"JSON","Key-Value Storage":"Key-Value ストア","LWM2M  Last Update":"LWM2Mの最終更新","LWM2M Client Address":"LWM2M クライアントアドレス","LWM2M Registration Date":"LWM2M 登録日","Last Exec":"最終実行日","Last Poll Time":"最終記録時間","Last Value":"最終値","Litmus Automation Terms and Conditions":"Litmus Automation Terms and Conditions","Load":"ロード","Load from WSDL":"WSDL からロード","Location":"位置情報","Log":"ログ","Logout":"ログアウト","MQTT  Last Update":"MQTT  最終更新","MQTT Account":"MQTT  アカウント","MQTT Client Address":"MQTT  クライアントアドレス","MQTT Registration Date":"MQTT  登録日","MQTT URL":"MQTT  URL","MQTT WS":"MQTT  WS","MQTT WSS URL":"MQTT WSS URL","MQTTS URL":"MQTTS URL","Maintenance":"メンテナンス","Make sure you save the password - you won't be able to access it again.":"パスワードの保存を確認してください -　再度アクセスすることはできません","Manufacturer":"製造メーカ","Matched resource not found":"一致するリソースがありません","Matched resources":"一致したリソース","Message":"メッセージ","Messages":"メッセージ","Method":"メソッド","Minute(s)":"分","Model":"モデル","Model Name":"モデル名","Model Number":"モデル番号","Model from WSDL":"WSDL のモデル","Model name":"モデル名","Multi-select mode off":"複数選択モードのオフ","Name":"名前","New":"New","New Model":"新しいモデル","New header name":"新しいヘッダ名","New project":"新しいプロジェクト","New value":"新しい値","Next Exec":"次を実行","Next Poll Time":"次に記録する時間","No Records Available":"レコードがありません","No {{type !== 'ALL' ? type : ''}} device available":" {{type !== 'ALL' ? type : ''}} のデバイスはありません","None":"None","OBSERVE":"OBSERVE","OMNA Lightweight M2M (LWM2M) Object & Resource Registry":"OMNA Lightweight M2M (LWM2M) オブジェクトとリソースの登録","Object":"オブジェクト","Open company project list":"会社のプロジェクトリストを開く","Open filter":"フィルタを開く","Parameters of the HTTP API:":"HTTP APのパラメータ:","Password":"パスワード","Path":"パス","Payload":"データ本体","Please contact Litmus Automation team to enable it.":"有効にするためにリトマスオートメーションのチームに連絡してください","Poll Data Detail":"日付の詳細を記録","Poll Scheduler":"スケジュールを記録","Poll interval":"インターバルを記録","PortType: {{action.portType}}":"PortType: {{action.portType}}","Predefined Sets":"定義済みセット","Profile":"プロファイル","Project Description":"プロジェクト詳細","Project Icon":"プロジェクトアイコン","Projects":"プロジェクト","Properties":"プロパティ","Publish":"公開","QoS(0, 1, 2)":"QoS(0, 1, 2)","RAW":"RAW","Raw data":"生データ","Read":"読む","Refresh":"更新","Remove":"削除","Removing a company will delete all related resources and cannot be restored.":"会社を削除すると、それに関連する全ての情報も削除され元に戻せません","Request":"リクエスト","Request Body":"リクエストボディ","Request Header":"リクエストヘッダ","Request Time":"リクエストタイム","Request URL":"リクエスト URL","Resource":"リソース","Resource Response":"リソースレスポンス","Response":"レスポンス","Response Body":"レスポンスボディ","Response Code":"レスポンスコード","Response Headers":"レスポンスヘッダ","Response Time":"レスポンスタイム","Retain(0,1)":"Retain(0,1)","Role":"役割","Roles":"役割","SSL Certificate":"SSL サーティフィケイト","STATUS":"ステータス","Save":"保存","Save config":"設定を保存","Schedule":"スケジュール","Second(s)":"秒","Select Operation":"選択されたオペレーション","Select file...":"ファイルを選択...","Send POST request to HTTP(S) endpoint to publish messages to a topic.":"メッセージをトピックに公開するために、POST要求をHTTP（S）エンドポイントに送信します","Serial":"シリアル","Serial Number":"シリアル番号","Serial number":"シリアル番号","Service Updates":"サービス更新","Service {{key}} status is {{$ctrl.serviceStatusDesc(value).desc}}":"サービス {{key}} のステータスは {{$ctrl.serviceStatusDesc(value).desc}}　です","Services status":"サービスステータス","Signing algorithm":"署名のアルゴリズム","Single":"シングル","Single deployment configuration file link":"単一配備の設定ファイルリンク","Start Date":"開始日","Start date":"開始日","Status":"ステータス","Status Time":"ステータスタイム","Subscribe":"サブスクライブ","Success! Your email has been successfully activated. Click <a href=\"#/login\">here</a> to login.":"あなたのメールを有効化しました。 <a href=\"#/login\">ここをクリック</a> してログインしてください","Switch in Map view mode":"マップ表示モードへ切替","Switch in list view mode":"リスト表示モードへ切替","Switch map/list view":"マップ/リスト表示の切替","Switch to multi-select mode":"マルチ選択モードへの切替","Synchronize":"同期","Tags":"タグ","Team":"チーム","Team List":"チームリスト","Team Members":"チームメンバ","Team Name":"チーム名","Teams":"チーム","Teams count":"チーム数","Thank you, your email has been activated.":"あなたのメールは有効です","Thank you. Your email has been activated. Click <a href=\"#/login\">here</a> to login.":"あなたのメールは有効です。 <a href=\"#/login\">ここをクリック</a> してログインしてください","The API uses HTTP Basic Authentication.":"APIはHTTPベーシック認証を利用します","The device's data published to the data topic. The JSON schema of the message provided below. See <a target=\"_blank\" href=\"http://technical.openmobilealliance.org/Technical/technical-information/omna/lightweight-m2m-lwm2m-object-registry\" translate=\"\">OMNA Lightweight M2M (LWM2M) Object & Resource Registry</a> for more details. Timestamp attribute is not mandatory. If it omitted or equals to 0 it will be replaced by server's timestamp (UTC).":"データのトピックとして公開されたデバイスのデータ。 以下に示すメッセージのJSONスキーマ。 <a target=\"_blank\" href=\"http://technical.openmobilealliance.org/Technical/technical-information/omna/lightweight-m2m-lwm2m-object-registry\" translate=\"\"> OMNA Lightweight M2M（LWM2M）を参照してください。 オブジェクトとリソースレジストリ</a>を参照してください。 タイムスタンプ属性は必須ではありません。 省略または0に等しい場合、サーバーのタイムスタンプ（UTC）に置き換えられます。","The entered value is not a date!":"入力された値は日付ではありません","This email verification link has expired.":"メール認証の有効期限が過ぎています","This feature is not enabled in your version.":"ご利用のバージョンでは、この機能を有効にすることは出来ません","This is required.":"これは必須です","Time":"時間","Topic":"トピック","Topic name":"トピック名","Type":"タイプ","Update":"アップデート","Updated At":"アップデート","Url":"Url","Usage Limits":"使用制限","User":"ユーザ","User Parameters":"ユーザパラメータ","User session expired":"ユーザセッションが無効です","UserName":"ユーザ名","Username":"ユーザ名","Valid before":"より有効","Value":"値","Web browsers could connect to the MQTT broker directly by MQTT Over WebSocket. Sec-WebSocket-Protocol: 'mqttv3.1' or 'mqttv3.1.1'":"Webブラウザーは、MQTT Over WebSocketによって直接MQTTブローカーに接続することができます。 Sec-WebSocket-Protocol： 'mqttv3.1'または 'mqttv3.1.1'","Write":"書込み","Write value":"値の書込み","You haven't added any users to your team  yet":"まだチームにユーザーを追加していません","Your session has expired. Please <a href=\"\" ng-click=\"$ctrl.auth.logout()\">log in</a> .":"セッションが無効です。 <a href=\"\" ng-click=\"$ctrl.auth.logout()\">ログイン</a>　してください","add ACL":"ACL追加","add credentials":"アカウント情報の追加","client":"クライアント","clientid":"クライアントID","credential dialog":"アカウント情報ダイアログ","credentials":"アカウント情報","message":"メッセージ","model filter":"モデルのフィルタ","must be between 10 to 100 characters long":"文字数の長さは10から100の間でなければなりません","qos":"qos","retain":"保持","status: {{alert.status}}, severity: {{alert.severity}}":"ステータス: {{alert.status}}, 重大度: {{alert.severity}}","teams":"チーム","topic":"トピック","{{$ctrl.action}} Project":"{{$ctrl.action}} プロジェクト","{{$ctrl.selectedItem.length}} {{$ctrl.selectedItem.length > 1 ? 'items' : 'item'}} selected":"{{$ctrl.selectedItem.length}} {{$ctrl.selectedItem.length > 1 ? 'items' : 'item'}} selected","{{$ctrl.tableSelect.length}} {{$ctrl.tableSelect.length > 1 ? 'items' : 'item'}} selected":"{{$ctrl.tableSelect.length}} {{$ctrl.tableSelect.length > 1 ? 'items' : 'item'}} selected","{{action}} Team":"{{action}} チーム"});
/* jshint +W100 */
}]);
'use strict';
/**
 * @ngdoc component
 * @name loopUiApp.component:applicationsList
 * @description
 * # applicationsList
 */
angular.module('loopUiApp')
    .config(function ($mdThemingProvider) {
        var litmusPrimary = {
            '50': 'e0e6e6',
            '100': 'b3c1bf',
            '200': '809795',
            '300': '4d6d6b',
            '400': '264e4b',
            '500': '002f2b',
            '600': '002a26',
            '700': '002320',
            '800': '001d1a',
            '900': '001210',
            'A100': '53ffea',
            'A200': '20ffe3',
            'A400': '00eccf',
            'A700': '00d3b8',
            'contrastDefaultColor': 'light',
            'contrastDarkColors': [
                '50',
                '100',
                '200',
                'A100',
                'A200',
                'A400',
                'A700'
            ],
            'contrastLightColors': [
                '300',
                '400',
                '500',
                '600',
                '700',
                '800',
                '900'
            ]
        };
        $mdThemingProvider
            .definePalette('litmusPrimary', litmusPrimary);

        var litmusAccent = {
            '50': 'e7fbf2',
            '100': 'c4f4de',
            '200': '9dedc8',
            '300': '75e6b1',
            '400': '58e0a1',
            '500': '3adb90',
            '600': '34d788',
            '700': '2cd27d',
            '800': '25cd73',
            '900': '18c461',
            'A100': 'f7fffa',
            'A200': '3adb90',
            'A400': '91ffbc',
            'A700': '78ffac',
            'contrastDefaultColor': 'light',
            'contrastDarkColors': [
                '50',
                '100',
                '200',
                '300',
                '400',
                '500',
                '600',
                '700',
                '800',
                '900',
                'A100',
                'A200',
                'A400',
                'A700'
            ],
            'contrastLightColors': []
        };
        $mdThemingProvider
            .definePalette('litmusAccent', litmusAccent);

        var litmusWarn = {
            '50': 'fee2e9',
            '100': 'fdb6c8',
            '200': 'fb85a4',
            '300': 'f95480',
            '400': 'f83064',
            '500': 'f70b49',
            '600': 'f60a42',
            '700': 'f50839',
            '800': 'f30631',
            '900': 'f10321',
            'A100': 'ffffff',
            'A200': 'ffe5e7',
            'A400': 'ffb2b8',
            'A700': 'ff98a1',
            'contrastDefaultColor': 'light',
            'contrastDarkColors': [
                '50',
                '100',
                '200',
                '300',
                'A100',
                'A200',
                'A400',
                'A700'
            ],
            'contrastLightColors': [
                '400',
                '500',
                '600',
                '700',
                '800',
                '900'
            ]
        };
        $mdThemingProvider
            .definePalette('litmusWarn', litmusWarn);


        var litmusBackground = $mdThemingProvider.extendPalette('grey', {
            '900': '#002f2b',
        });
        $mdThemingProvider
            .definePalette('litmusBackground', litmusBackground);

        // Ugly hack to change text color, as there is no way to change foreground settings in the theme
        $mdThemingProvider.theme('default')
            .backgroundPalette('litmusBackground')
            .foregroundPalette['1'] = '#002f2b';
        $mdThemingProvider.theme('default')
            .foregroundPalette['2'] = '#002f2b';
    });
/* jshint ignore:start */
ace.define("ace/theme/material", ["require", "exports", "module", "ace/lib/dom"], function (e, t, n) {
    t.isDark = !0,
        t.cssClass = "ace-material",
        t.cssText = ".ace-material .ace_gutter {\
        background: #263238;\
        color: #546E7A;\
      }\
      .ace-material .ace_print-margin {\
        width: 1px;\
        background: #555651;\
      }\
      .ace-material {\
        background-color: #263238;\
        color: #EEFFFF;\
        font-family: monospace !important;\
        font-size: 13px !important;\
      }\
      .ace-material .ace_cursor {\
        color: #FFCC00;\
      }\
      .ace-material .ace_marker-layer .ace_selection {\
        background: rgba(128, 203, 196, 0.2);\
      }\
      .ace-material.ace_multiselect .ace_selection.ace_start {\
        box-shadow: 0 0 3px 0px #272822;\
      }\
      .ace-material .ace_marker-layer .ace_step {\
        background: rgb(102, 82, 0);\
      }\
      .ace-material .ace_marker-layer .ace_bracket {\
        margin: -1px 0 0 -1px;\
        border: 1px solid #49483e;\
      }\
      .ace-material .ace_marker-layer .ace_active-line {\
        background: #263238;\
      }\
      .ace-material .ace_gutter-active-line {\
        background-color: #263238;\
      }\
      .ace-material .ace_marker-layer .ace_selected-word {\
        border: 1px solid #49483e;\
      }\
      .ace-material .ace_invisible {\
        color: #52524d;\
      }\
      .ace-material .ace_entity.ace_name.ace_tag,\
      .ace-material .ace_keyword,\
      .ace-material .ace_meta.ace_tag,\
      .ace-material .ace_storage {\
        color: #C792EA;\
      }\
      .ace-material .ace_punctuation,\
      .ace-material .ace_punctuation.ace_tag {\
        color: #fff;\
      }\
      .ace-material .ace_constant.ace_character,\
      .ace-material .ace_constant.ace_language,\
      .ace-material .ace_constant.ace_numeric,\
      .ace-material .ace_constant.ace_other {\
        color: #F78C6C;\
      }\
      .ace-material .ace_invalid {\
        color: #f8f8f0;\
        background-color: #f92672;\
      }\
      .ace-material .ace_invalid.ace_deprecated {\
        color: #f8f8f0;\
        background-color: #ae81ff;\
      }\
      .ace-material .ace_support.ace_constant,\
      .ace-material .ace_support.ace_function {\
        color: #66d9ef;\
      }\
      .ace-material .ace_fold {\
        background-color: #a6e22e;\
        border-color: #f8f8f2;\
      }\
      .ace-material .ace_storage.ace_type,\
      .ace-material .ace_support.ace_class,\
      .ace-material .ace_support.ace_type {\
        font-style: italic;\
        color: #f07178;\
      }\
      .ace-material .ace_entity.ace_name.ace_function,\
      .ace-material .ace_entity.ace_other,\
      .ace-material .ace_entity.ace_other.ace_attribute-name,\
      .ace-material .ace_variable {\
        color: #C792EA;\
      }\
      .ace-material .ace_variable.ace_parameter {\
        font-style: italic;\
        color: #fd971f;\
      }\
      .ace-material .ace_string {\
        color: #C3E88D;\
      }\
      .ace-material .ace_comment {\
        color: #546E7A;\
      }\
      .ace-material .ace_indent-guide {\
        background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAACCAYAAACZgbYnAAAAEklEQVQImWPQ0FD0ZXBzd/wPAAjVAoxeSgNeAAAAAElFTkSuQmCC)\
          right repeat-y;\
      }";
    var r = e("../lib/dom"); r.importCssString(t.cssText, t.cssClass, !1)
}); (function () {
    ace.require(["ace/theme/material"], function (m) {
        if (typeof module == "object" && typeof exports == "object" && module) {
            module.exports = m;
        }
    });
})();
/* jshint ignore:end */
